(function ($t, Qe) {
  typeof exports == "object" && typeof module == "object" ? module.exports = Qe() : typeof define == "function" && define.amd ? define([], Qe) : typeof exports == "object" ? exports.videojs = Qe() : $t.videojs = Qe();
})(this, function () {
  return (() => {
    var pi = {
      477: ve => {
        function ae(K) {
          if (K === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return K;
        }

        ve.exports = ae, ve.exports.default = ve.exports, ve.exports.__esModule = !0;
      },
      811: (ve, ae, K) => {
        var R = K(470),
            j = K(751);

        function x(k, H, w) {
          return j() ? (ve.exports = x = Reflect.construct, ve.exports.default = ve.exports, ve.exports.__esModule = !0) : (ve.exports = x = function (D, E, L) {
            var P = [null];
            P.push.apply(P, E);
            var d = Function.bind.apply(D, P),
                f = new d();
            return L && R(f, L.prototype), f;
          }, ve.exports.default = ve.exports, ve.exports.__esModule = !0), x.apply(null, arguments);
        }

        ve.exports = x, ve.exports.default = ve.exports, ve.exports.__esModule = !0;
      },
      723: ve => {
        function ae() {
          return ve.exports = ae = Object.assign || function (K) {
            for (var R = 1; R < arguments.length; R++) {
              var j = arguments[R];

              for (var x in j) Object.prototype.hasOwnProperty.call(j, x) && (K[x] = j[x]);
            }

            return K;
          }, ve.exports.default = ve.exports, ve.exports.__esModule = !0, ae.apply(this, arguments);
        }

        ve.exports = ae, ve.exports.default = ve.exports, ve.exports.__esModule = !0;
      },
      324: (ve, ae, K) => {
        var R = K(470);

        function j(x, k) {
          if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function");
          x.prototype = Object.create(k && k.prototype, {
            constructor: {
              value: x,
              writable: !0,
              configurable: !0
            }
          }), k && R(x, k);
        }

        ve.exports = j, ve.exports.default = ve.exports, ve.exports.__esModule = !0;
      },
      743: (ve, ae, K) => {
        var R = K(470);

        function j(x, k) {
          x.prototype = Object.create(k.prototype), x.prototype.constructor = x, R(x, k);
        }

        ve.exports = j, ve.exports.default = ve.exports, ve.exports.__esModule = !0;
      },
      751: ve => {
        function ae() {
          if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
          if (typeof Proxy == "function") return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (K) {
            return !1;
          }
        }

        ve.exports = ae, ve.exports.default = ve.exports, ve.exports.__esModule = !0;
      },
      470: ve => {
        function ae(K, R) {
          return ve.exports = ae = Object.setPrototypeOf || function (x, k) {
            return x.__proto__ = k, x;
          }, ve.exports.default = ve.exports, ve.exports.__esModule = !0, ae(K, R);
        }

        ve.exports = ae, ve.exports.default = ve.exports, ve.exports.__esModule = !0;
      },
      480: (ve, ae, K) => {
        "use strict";

        var R = K(697),
            j = function (H, w) {
          return w === void 0 && (w = !1), function (O, D, E) {
            if (O) {
              H(O);
              return;
            }

            if (D.statusCode >= 400 && D.statusCode <= 599) {
              var L = E;
              if (w) if (R.TextDecoder) {
                var P = x(D.headers && D.headers["content-type"]);

                try {
                  L = new TextDecoder(P).decode(E);
                } catch (d) {}
              } else L = String.fromCharCode.apply(null, new Uint8Array(E));
              H({
                cause: L
              });
              return;
            }

            H(null, E);
          };
        };

        function x(k) {
          return k === void 0 && (k = ""), k.toLowerCase().split(";").reduce(function (H, w) {
            var O = w.split("="),
                D = O[0],
                E = O[1];
            return D.trim() === "charset" ? E.trim() : H;
          }, "utf-8");
        }

        ve.exports = j;
      },
      424: (ve, ae, K) => {
        "use strict";

        var R = K(697),
            j = K(723),
            x = K(988);
        D.httpHandler = K(480);
        /**
        * @license
        * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
        * Copyright (c) 2014 David Björklund
        * Available under the MIT license
        * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
        */

        var k = function (f) {
          var y = {};
          return f && f.trim().split("\n").forEach(function (u) {
            var i = u.indexOf(":"),
                n = u.slice(0, i).trim().toLowerCase(),
                a = u.slice(i + 1).trim();
            typeof y[n] == "undefined" ? y[n] = a : Array.isArray(y[n]) ? y[n].push(a) : y[n] = [y[n], a];
          }), y;
        };

        ve.exports = D, ve.exports.default = D, D.XMLHttpRequest = R.XMLHttpRequest || P, D.XDomainRequest = "withCredentials" in new D.XMLHttpRequest() ? D.XMLHttpRequest : R.XDomainRequest, H(["get", "put", "post", "patch", "head", "delete"], function (d) {
          D[d === "delete" ? "del" : d] = function (f, y, u) {
            return y = O(f, y, u), y.method = d.toUpperCase(), E(y);
          };
        });

        function H(d, f) {
          for (var y = 0; y < d.length; y++) f(d[y]);
        }

        function w(d) {
          for (var f in d) if (d.hasOwnProperty(f)) return !1;

          return !0;
        }

        function O(d, f, y) {
          var u = d;
          return x(f) ? (y = f, typeof d == "string" && (u = {
            uri: d
          })) : u = j({}, f, {
            uri: d
          }), u.callback = y, u;
        }

        function D(d, f, y) {
          return f = O(d, f, y), E(f);
        }

        function E(d) {
          if (typeof d.callback == "undefined") throw new Error("callback argument missing");

          var f = !1,
              y = function (M, F, B) {
            f || (f = !0, d.callback(M, F, B));
          };

          function u() {
            v.readyState === 4 && setTimeout(a, 0);
          }

          function i() {
            var I = void 0;
            if (v.response ? I = v.response : I = v.responseText || L(v), o) try {
              I = JSON.parse(I);
            } catch (M) {}
            return I;
          }

          function n(I) {
            return clearTimeout(b), I instanceof Error || (I = new Error("" + (I || "Unknown XMLHttpRequest Error"))), I.statusCode = 0, y(I, A);
          }

          function a() {
            if (!c) {
              var I;
              clearTimeout(b), d.useXDR && v.status === void 0 ? I = 200 : I = v.status === 1223 ? 204 : v.status;
              var M = A,
                  F = null;
              return I !== 0 ? (M = {
                body: i(),
                statusCode: I,
                method: C,
                headers: {},
                url: p,
                rawRequest: v
              }, v.getAllResponseHeaders && (M.headers = k(v.getAllResponseHeaders()))) : F = new Error("Internal XMLHttpRequest Error"), y(F, M, M.body);
            }
          }

          var v = d.xhr || null;
          v || (d.cors || d.useXDR ? v = new D.XDomainRequest() : v = new D.XMLHttpRequest());

          var h,
              c,
              p = v.url = d.uri || d.url,
              C = v.method = d.method || "GET",
              _ = d.body || d.data,
              g = v.headers = d.headers || {},
              s = !!d.sync,
              o = !1,
              b,
              A = {
            body: void 0,
            headers: {},
            statusCode: 0,
            method: C,
            url: p,
            rawRequest: v
          };

          if ("json" in d && d.json !== !1 && (o = !0, g.accept || g.Accept || (g.Accept = "application/json"), C !== "GET" && C !== "HEAD" && (g["content-type"] || g["Content-Type"] || (g["Content-Type"] = "application/json"), _ = JSON.stringify(d.json === !0 ? _ : d.json))), v.onreadystatechange = u, v.onload = a, v.onerror = n, v.onprogress = function () {}, v.onabort = function () {
            c = !0;
          }, v.ontimeout = n, v.open(C, p, !s, d.username, d.password), s || (v.withCredentials = !!d.withCredentials), !s && d.timeout > 0 && (b = setTimeout(function () {
            if (!c) {
              c = !0, v.abort("timeout");
              var I = new Error("XMLHttpRequest timeout");
              I.code = "ETIMEDOUT", n(I);
            }
          }, d.timeout)), v.setRequestHeader) for (h in g) g.hasOwnProperty(h) && v.setRequestHeader(h, g[h]);else if (d.headers && !w(d.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");
          return "responseType" in d && (v.responseType = d.responseType), "beforeSend" in d && typeof d.beforeSend == "function" && d.beforeSend(v), v.send(_ || null), v;
        }

        function L(d) {
          try {
            if (d.responseType === "document") return d.responseXML;
            var f = d.responseXML && d.responseXML.documentElement.nodeName === "parsererror";
            if (d.responseType === "" && !f) return d.responseXML;
          } catch (y) {}

          return null;
        }

        function P() {}
      },
      675: (ve, ae, K) => {
        var R = typeof K.g != "undefined" ? K.g : typeof window != "undefined" ? window : {},
            j = K(893),
            x;
        typeof document != "undefined" ? x = document : (x = R["__GLOBAL_DOCUMENT_CACHE@4"], x || (x = R["__GLOBAL_DOCUMENT_CACHE@4"] = j)), ve.exports = x;
      },
      697: (ve, ae, K) => {
        var R;
        typeof window != "undefined" ? R = window : typeof K.g != "undefined" ? R = K.g : typeof self != "undefined" ? R = self : R = {}, ve.exports = R;
      },
      199: function (ve) {
        typeof window != "undefined" && function (K, R) {
          ve.exports = R();
        }(this, function () {
          return function (ae) {
            var K = {};

            function R(j) {
              if (K[j]) return K[j].exports;
              var x = K[j] = {
                i: j,
                l: !1,
                exports: {}
              };
              return ae[j].call(x.exports, x, x.exports, R), x.l = !0, x.exports;
            }

            return R.m = ae, R.c = K, R.d = function (j, x, k) {
              R.o(j, x) || Object.defineProperty(j, x, {
                enumerable: !0,
                get: k
              });
            }, R.r = function (j) {
              typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(j, Symbol.toStringTag, {
                value: "Module"
              }), Object.defineProperty(j, "__esModule", {
                value: !0
              });
            }, R.t = function (j, x) {
              if (x & 1 && (j = R(j)), x & 8 || x & 4 && typeof j == "object" && j && j.__esModule) return j;
              var k = Object.create(null);
              if (R.r(k), Object.defineProperty(k, "default", {
                enumerable: !0,
                value: j
              }), x & 2 && typeof j != "string") for (var H in j) R.d(k, H, function (w) {
                return j[w];
              }.bind(null, H));
              return k;
            }, R.n = function (j) {
              var x = j && j.__esModule ? function () {
                return j.default;
              } : function () {
                return j;
              };
              return R.d(x, "a", x), x;
            }, R.o = function (j, x) {
              return Object.prototype.hasOwnProperty.call(j, x);
            }, R.p = "/dist/", R(R.s = "./src/hls.ts");
          }({
            "./node_modules/eventemitter3/index.js": function (ae, K, R) {
              "use strict";

              var j = Object.prototype.hasOwnProperty,
                  x = "~";

              function k() {}

              Object.create && (k.prototype = Object.create(null), new k().__proto__ || (x = !1));

              function H(E, L, P) {
                this.fn = E, this.context = L, this.once = P || !1;
              }

              function w(E, L, P, d, f) {
                if (typeof P != "function") throw new TypeError("The listener must be a function");
                var y = new H(P, d || E, f),
                    u = x ? x + L : L;
                return E._events[u] ? E._events[u].fn ? E._events[u] = [E._events[u], y] : E._events[u].push(y) : (E._events[u] = y, E._eventsCount++), E;
              }

              function O(E, L) {
                --E._eventsCount == 0 ? E._events = new k() : delete E._events[L];
              }

              function D() {
                this._events = new k(), this._eventsCount = 0;
              }

              D.prototype.eventNames = function () {
                var L = [],
                    P,
                    d;
                if (this._eventsCount === 0) return L;

                for (d in P = this._events) j.call(P, d) && L.push(x ? d.slice(1) : d);

                return Object.getOwnPropertySymbols ? L.concat(Object.getOwnPropertySymbols(P)) : L;
              }, D.prototype.listeners = function (L) {
                var P = x ? x + L : L,
                    d = this._events[P];
                if (!d) return [];
                if (d.fn) return [d.fn];

                for (var f = 0, y = d.length, u = new Array(y); f < y; f++) u[f] = d[f].fn;

                return u;
              }, D.prototype.listenerCount = function (L) {
                var P = x ? x + L : L,
                    d = this._events[P];
                return d ? d.fn ? 1 : d.length : 0;
              }, D.prototype.emit = function (L, P, d, f, y, u) {
                var i = x ? x + L : L;
                if (!this._events[i]) return !1;
                var n = this._events[i],
                    a = arguments.length,
                    v,
                    h;

                if (n.fn) {
                  switch (n.once && this.removeListener(L, n.fn, void 0, !0), a) {
                    case 1:
                      return n.fn.call(n.context), !0;

                    case 2:
                      return n.fn.call(n.context, P), !0;

                    case 3:
                      return n.fn.call(n.context, P, d), !0;

                    case 4:
                      return n.fn.call(n.context, P, d, f), !0;

                    case 5:
                      return n.fn.call(n.context, P, d, f, y), !0;

                    case 6:
                      return n.fn.call(n.context, P, d, f, y, u), !0;
                  }

                  for (h = 1, v = new Array(a - 1); h < a; h++) v[h - 1] = arguments[h];

                  n.fn.apply(n.context, v);
                } else {
                  var c = n.length,
                      p;

                  for (h = 0; h < c; h++) switch (n[h].once && this.removeListener(L, n[h].fn, void 0, !0), a) {
                    case 1:
                      n[h].fn.call(n[h].context);
                      break;

                    case 2:
                      n[h].fn.call(n[h].context, P);
                      break;

                    case 3:
                      n[h].fn.call(n[h].context, P, d);
                      break;

                    case 4:
                      n[h].fn.call(n[h].context, P, d, f);
                      break;

                    default:
                      if (!v) for (p = 1, v = new Array(a - 1); p < a; p++) v[p - 1] = arguments[p];
                      n[h].fn.apply(n[h].context, v);
                  }
                }

                return !0;
              }, D.prototype.on = function (L, P, d) {
                return w(this, L, P, d, !1);
              }, D.prototype.once = function (L, P, d) {
                return w(this, L, P, d, !0);
              }, D.prototype.removeListener = function (L, P, d, f) {
                var y = x ? x + L : L;
                if (!this._events[y]) return this;
                if (!P) return O(this, y), this;
                var u = this._events[y];
                if (u.fn) u.fn === P && (!f || u.once) && (!d || u.context === d) && O(this, y);else {
                  for (var i = 0, n = [], a = u.length; i < a; i++) (u[i].fn !== P || f && !u[i].once || d && u[i].context !== d) && n.push(u[i]);

                  n.length ? this._events[y] = n.length === 1 ? n[0] : n : O(this, y);
                }
                return this;
              }, D.prototype.removeAllListeners = function (L) {
                var P;
                return L ? (P = x ? x + L : L, this._events[P] && O(this, P)) : (this._events = new k(), this._eventsCount = 0), this;
              }, D.prototype.off = D.prototype.removeListener, D.prototype.addListener = D.prototype.on, D.prefixed = x, D.EventEmitter = D, ae.exports = D;
            },
            "./node_modules/url-toolkit/src/url-toolkit.js": function (ae, K, R) {
              (function (j) {
                var x = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/?#]*\/)*[^;?#]*)?(;[^?#]*)?(\?[^#]*)?(#[^]*)?$/,
                    k = /^([^\/?#]*)([^]*)$/,
                    H = /(?:\/|^)\.(?=\/)/g,
                    w = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g,
                    O = {
                  buildAbsoluteURL: function (D, E, L) {
                    if (L = L || {}, D = D.trim(), E = E.trim(), !E) {
                      if (!L.alwaysNormalize) return D;
                      var P = O.parseURL(D);
                      if (!P) throw new Error("Error trying to parse base URL.");
                      return P.path = O.normalizePath(P.path), O.buildURLFromParts(P);
                    }

                    var d = O.parseURL(E);
                    if (!d) throw new Error("Error trying to parse relative URL.");
                    if (d.scheme) return L.alwaysNormalize ? (d.path = O.normalizePath(d.path), O.buildURLFromParts(d)) : E;
                    var f = O.parseURL(D);
                    if (!f) throw new Error("Error trying to parse base URL.");

                    if (!f.netLoc && f.path && f.path[0] !== "/") {
                      var y = k.exec(f.path);
                      f.netLoc = y[1], f.path = y[2];
                    }

                    f.netLoc && !f.path && (f.path = "/");
                    var u = {
                      scheme: f.scheme,
                      netLoc: d.netLoc,
                      path: null,
                      params: d.params,
                      query: d.query,
                      fragment: d.fragment
                    };
                    if (!d.netLoc && (u.netLoc = f.netLoc, d.path[0] !== "/")) if (!d.path) u.path = f.path, d.params || (u.params = f.params, d.query || (u.query = f.query));else {
                      var i = f.path,
                          n = i.substring(0, i.lastIndexOf("/") + 1) + d.path;
                      u.path = O.normalizePath(n);
                    }
                    return u.path === null && (u.path = L.alwaysNormalize ? O.normalizePath(d.path) : d.path), O.buildURLFromParts(u);
                  },
                  parseURL: function (D) {
                    var E = x.exec(D);
                    return E ? {
                      scheme: E[1] || "",
                      netLoc: E[2] || "",
                      path: E[3] || "",
                      params: E[4] || "",
                      query: E[5] || "",
                      fragment: E[6] || ""
                    } : null;
                  },
                  normalizePath: function (D) {
                    for (D = D.split("").reverse().join("").replace(H, ""); D.length !== (D = D.replace(w, "")).length;);

                    return D.split("").reverse().join("");
                  },
                  buildURLFromParts: function (D) {
                    return D.scheme + D.netLoc + D.path + D.params + D.query + D.fragment;
                  }
                };
                ae.exports = O;
              })(this);
            },
            "./node_modules/webworkify-webpack/index.js": function (ae, K, R) {
              function j(L) {
                var P = {};

                function d(y) {
                  if (P[y]) return P[y].exports;
                  var u = P[y] = {
                    i: y,
                    l: !1,
                    exports: {}
                  };
                  return L[y].call(u.exports, u, u.exports, d), u.l = !0, u.exports;
                }

                d.m = L, d.c = P, d.i = function (y) {
                  return y;
                }, d.d = function (y, u, i) {
                  d.o(y, u) || Object.defineProperty(y, u, {
                    configurable: !1,
                    enumerable: !0,
                    get: i
                  });
                }, d.r = function (y) {
                  Object.defineProperty(y, "__esModule", {
                    value: !0
                  });
                }, d.n = function (y) {
                  var u = y && y.__esModule ? function () {
                    return y.default;
                  } : function () {
                    return y;
                  };
                  return d.d(u, "a", u), u;
                }, d.o = function (y, u) {
                  return Object.prototype.hasOwnProperty.call(y, u);
                }, d.p = "/", d.oe = function (y) {
                  throw console.error(y), y;
                };
                var f = d(d.s = ENTRY_MODULE);
                return f.default || f;
              }

              var x = "[\\.|\\-|\\+|\\w|/|@]+",
                  k = "\\(\\s*(/\\*.*?\\*/)?\\s*.*?(" + x + ").*?\\)";

              function H(L) {
                return (L + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
              }

              function w(L) {
                return !isNaN(1 * L);
              }

              function O(L, P, d) {
                var f = {};
                f[d] = [];
                var y = P.toString(),
                    u = y.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!u) return f;

                for (var i = u[1], n = new RegExp("(\\\\n|\\W)" + H(i) + k, "g"), a; a = n.exec(y);) a[3] !== "dll-reference" && f[d].push(a[3]);

                for (n = new RegExp("\\(" + H(i) + '\\("(dll-reference\\s(' + x + '))"\\)\\)' + k, "g"); a = n.exec(y);) L[a[2]] || (f[d].push(a[1]), L[a[2]] = R(a[1]).m), f[a[2]] = f[a[2]] || [], f[a[2]].push(a[4]);

                for (var v = Object.keys(f), h = 0; h < v.length; h++) for (var c = 0; c < f[v[h]].length; c++) w(f[v[h]][c]) && (f[v[h]][c] = 1 * f[v[h]][c]);

                return f;
              }

              function D(L) {
                var P = Object.keys(L);
                return P.reduce(function (d, f) {
                  return d || L[f].length > 0;
                }, !1);
              }

              function E(L, P) {
                for (var d = {
                  main: [P]
                }, f = {
                  main: []
                }, y = {
                  main: {}
                }; D(d);) for (var u = Object.keys(d), i = 0; i < u.length; i++) {
                  var n = u[i],
                      a = d[n],
                      v = a.pop();

                  if (y[n] = y[n] || {}, !(y[n][v] || !L[n][v])) {
                    y[n][v] = !0, f[n] = f[n] || [], f[n].push(v);

                    for (var h = O(L, L[n][v], n), c = Object.keys(h), p = 0; p < c.length; p++) d[c[p]] = d[c[p]] || [], d[c[p]] = d[c[p]].concat(h[c[p]]);
                  }
                }

                return f;
              }

              ae.exports = function (L, P) {
                P = P || {};
                var d = {
                  main: R.m
                },
                    f = P.all ? {
                  main: Object.keys(d.main)
                } : E(d, L),
                    y = "";
                Object.keys(f).filter(function (v) {
                  return v !== "main";
                }).forEach(function (v) {
                  for (var h = 0; f[v][h];) h++;

                  f[v].push(h), d[v][h] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", y = y + "var " + v + " = (" + j.toString().replace("ENTRY_MODULE", JSON.stringify(h)) + ")({" + f[v].map(function (c) {
                    return "" + JSON.stringify(c) + ": " + d[v][c].toString();
                  }).join(",") + "});\n";
                }), y = y + "new ((" + j.toString().replace("ENTRY_MODULE", JSON.stringify(L)) + ")({" + f.main.map(function (v) {
                  return "" + JSON.stringify(v) + ": " + d.main[v].toString();
                }).join(",") + "}))(self);";
                var u = new window.Blob([y], {
                  type: "text/javascript"
                });
                if (P.bare) return u;
                var i = window.URL || window.webkitURL || window.mozURL || window.msURL,
                    n = i.createObjectURL(u),
                    a = new window.Worker(n);
                return a.objectURL = n, a;
              };
            },
            "./src/config.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "hlsDefaultConfig", function () {
                return p;
              }), R.d(K, "mergeConfig", function () {
                return _;
              }), R.d(K, "enableStreamingMode", function () {
                return g;
              });
              var j = R("./src/controller/abr-controller.ts"),
                  x = R("./src/controller/audio-stream-controller.ts"),
                  k = R("./src/controller/audio-track-controller.ts"),
                  H = R("./src/controller/subtitle-stream-controller.ts"),
                  w = R("./src/controller/subtitle-track-controller.ts"),
                  O = R("./src/controller/buffer-controller.ts"),
                  D = R("./src/controller/timeline-controller.ts"),
                  E = R("./src/controller/cap-level-controller.ts"),
                  L = R("./src/controller/fps-controller.ts"),
                  P = R("./src/controller/eme-controller.ts"),
                  d = R("./src/controller/cmcd-controller.ts"),
                  f = R("./src/utils/xhr-loader.ts"),
                  y = R("./src/utils/fetch-loader.ts"),
                  u = R("./src/utils/cues.ts"),
                  i = R("./src/utils/mediakeys-helper.ts"),
                  n = R("./src/utils/logger.ts");

              function a() {
                return a = Object.assign || function (s) {
                  for (var o = 1; o < arguments.length; o++) {
                    var b = arguments[o];

                    for (var A in b) Object.prototype.hasOwnProperty.call(b, A) && (s[A] = b[A]);
                  }

                  return s;
                }, a.apply(this, arguments);
              }

              function v(s, o) {
                var b = Object.keys(s);

                if (Object.getOwnPropertySymbols) {
                  var A = Object.getOwnPropertySymbols(s);
                  o && (A = A.filter(function (I) {
                    return Object.getOwnPropertyDescriptor(s, I).enumerable;
                  })), b.push.apply(b, A);
                }

                return b;
              }

              function h(s) {
                for (var o = 1; o < arguments.length; o++) {
                  var b = arguments[o] != null ? arguments[o] : {};
                  o % 2 ? v(Object(b), !0).forEach(function (A) {
                    c(s, A, b[A]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(b)) : v(Object(b)).forEach(function (A) {
                    Object.defineProperty(s, A, Object.getOwnPropertyDescriptor(b, A));
                  });
                }

                return s;
              }

              function c(s, o, b) {
                return o in s ? Object.defineProperty(s, o, {
                  value: b,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }) : s[o] = b, s;
              }

              var p = h(h({
                autoStartLoad: !0,
                startPosition: -1,
                defaultAudioCodec: void 0,
                debug: !1,
                capLevelOnFPSDrop: !1,
                capLevelToPlayerSize: !1,
                initialLiveManifestSize: 1,
                maxBufferLength: 30,
                backBufferLength: 1 / 0,
                maxBufferSize: 60 * 1e3 * 1e3,
                maxBufferHole: .1,
                highBufferWatchdogPeriod: 2,
                nudgeOffset: .1,
                nudgeMaxRetry: 3,
                maxFragLookUpTolerance: .25,
                liveSyncDurationCount: 3,
                liveMaxLatencyDurationCount: 1 / 0,
                liveSyncDuration: void 0,
                liveMaxLatencyDuration: void 0,
                maxLiveSyncPlaybackRate: 1,
                liveDurationInfinity: !1,
                liveBackBufferLength: null,
                maxMaxBufferLength: 600,
                enableWorker: !0,
                enableSoftwareAES: !0,
                manifestLoadingTimeOut: 1e4,
                manifestLoadingMaxRetry: 1,
                manifestLoadingRetryDelay: 1e3,
                manifestLoadingMaxRetryTimeout: 64e3,
                startLevel: void 0,
                levelLoadingTimeOut: 1e4,
                levelLoadingMaxRetry: 4,
                levelLoadingRetryDelay: 1e3,
                levelLoadingMaxRetryTimeout: 64e3,
                fragLoadingTimeOut: 2e4,
                fragLoadingMaxRetry: 6,
                fragLoadingRetryDelay: 1e3,
                fragLoadingMaxRetryTimeout: 64e3,
                startFragPrefetch: !1,
                fpsDroppedMonitoringPeriod: 5e3,
                fpsDroppedMonitoringThreshold: .2,
                appendErrorMaxRetry: 3,
                loader: f.default,
                fLoader: void 0,
                pLoader: void 0,
                xhrSetup: void 0,
                licenseXhrSetup: void 0,
                licenseResponseCallback: void 0,
                abrController: j.default,
                bufferController: O.default,
                capLevelController: E.default,
                fpsController: L.default,
                stretchShortVideoTrack: !1,
                maxAudioFramesDrift: 1,
                forceKeyFrameOnDiscontinuity: !0,
                abrEwmaFastLive: 3,
                abrEwmaSlowLive: 9,
                abrEwmaFastVoD: 3,
                abrEwmaSlowVoD: 9,
                abrEwmaDefaultEstimate: 5e5,
                abrBandWidthFactor: .95,
                abrBandWidthUpFactor: .7,
                abrMaxWithRealBitrate: !1,
                maxStarvationDelay: 4,
                maxLoadingDelay: 4,
                minAutoBitrate: 0,
                emeEnabled: !1,
                widevineLicenseUrl: void 0,
                drmSystemOptions: {},
                requestMediaKeySystemAccessFunc: i.requestMediaKeySystemAccess,
                testBandwidth: !0,
                progressive: !1,
                lowLatencyMode: !0,
                cmcd: void 0
              }, C()), {}, {
                subtitleStreamController: H.SubtitleStreamController,
                subtitleTrackController: w.default,
                timelineController: D.TimelineController,
                audioStreamController: x.default,
                audioTrackController: k.default,
                emeController: P.default,
                cmcdController: d.default
              });

              function C() {
                return {
                  cueHandler: u.default,
                  enableCEA708Captions: !0,
                  enableWebVTT: !0,
                  enableIMSC1: !0,
                  captionsTextTrack1Label: "English",
                  captionsTextTrack1LanguageCode: "en",
                  captionsTextTrack2Label: "Spanish",
                  captionsTextTrack2LanguageCode: "es",
                  captionsTextTrack3Label: "Unknown CC",
                  captionsTextTrack3LanguageCode: "",
                  captionsTextTrack4Label: "Unknown CC",
                  captionsTextTrack4LanguageCode: "",
                  renderTextTracksNatively: !0
                };
              }

              function _(s, o) {
                if ((o.liveSyncDurationCount || o.liveMaxLatencyDurationCount) && (o.liveSyncDuration || o.liveMaxLatencyDuration)) throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
                if (o.liveMaxLatencyDurationCount !== void 0 && (o.liveSyncDurationCount === void 0 || o.liveMaxLatencyDurationCount <= o.liveSyncDurationCount)) throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
                if (o.liveMaxLatencyDuration !== void 0 && (o.liveSyncDuration === void 0 || o.liveMaxLatencyDuration <= o.liveSyncDuration)) throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
                return a({}, s, o);
              }

              function g(s) {
                var o = s.loader;
                if (o !== y.default && o !== f.default) n.logger.log("[config]: Custom loader detected, cannot enable progressive streaming"), s.progressive = !1;else {
                  var b = Object(y.fetchSupported)();
                  b && (s.loader = y.default, s.progressive = !0, s.enableSoftwareAES = !0, n.logger.log("[config]: Progressive streaming enabled, using FetchLoader"));
                }
              }
            },
            "./src/controller/abr-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/utils/ewma-bandwidth-estimator.ts"),
                  k = R("./src/events.ts"),
                  H = R("./src/utils/buffer-helper.ts"),
                  w = R("./src/errors.ts"),
                  O = R("./src/types/loader.ts"),
                  D = R("./src/utils/logger.ts");

              function E(d, f) {
                for (var y = 0; y < f.length; y++) {
                  var u = f[y];
                  u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(d, u.key, u);
                }
              }

              function L(d, f, y) {
                return f && E(d.prototype, f), y && E(d, y), d;
              }

              var P = function () {
                function d(y) {
                  this.hls = void 0, this.lastLoadedFragLevel = 0, this._nextAutoLevel = -1, this.timer = void 0, this.onCheck = this._abandonRulesCheck.bind(this), this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.bwEstimator = void 0, this.hls = y;
                  var u = y.config;
                  this.bwEstimator = new x.default(u.abrEwmaSlowVoD, u.abrEwmaFastVoD, u.abrEwmaDefaultEstimate), this.registerListeners();
                }

                var f = d.prototype;
                return f.registerListeners = function () {
                  var u = this.hls;
                  u.on(k.Events.FRAG_LOADING, this.onFragLoading, this), u.on(k.Events.FRAG_LOADED, this.onFragLoaded, this), u.on(k.Events.FRAG_BUFFERED, this.onFragBuffered, this), u.on(k.Events.LEVEL_LOADED, this.onLevelLoaded, this), u.on(k.Events.ERROR, this.onError, this);
                }, f.unregisterListeners = function () {
                  var u = this.hls;
                  u.off(k.Events.FRAG_LOADING, this.onFragLoading, this), u.off(k.Events.FRAG_LOADED, this.onFragLoaded, this), u.off(k.Events.FRAG_BUFFERED, this.onFragBuffered, this), u.off(k.Events.LEVEL_LOADED, this.onLevelLoaded, this), u.off(k.Events.ERROR, this.onError, this);
                }, f.destroy = function () {
                  this.unregisterListeners(), this.clearTimer(), this.hls = this.onCheck = null, this.fragCurrent = this.partCurrent = null;
                }, f.onFragLoading = function (u, i) {
                  var n = i.frag;

                  if (n.type === O.PlaylistLevelType.MAIN && !this.timer) {
                    var a;
                    this.fragCurrent = n, this.partCurrent = (a = i.part) != null ? a : null, this.timer = self.setInterval(this.onCheck, 100);
                  }
                }, f.onLevelLoaded = function (u, i) {
                  var n = this.hls.config;
                  i.details.live ? this.bwEstimator.update(n.abrEwmaSlowLive, n.abrEwmaFastLive) : this.bwEstimator.update(n.abrEwmaSlowVoD, n.abrEwmaFastVoD);
                }, f._abandonRulesCheck = function () {
                  var u = this.fragCurrent,
                      i = this.partCurrent,
                      n = this.hls,
                      a = n.autoLevelEnabled,
                      v = n.config,
                      h = n.media;

                  if (!(!u || !h)) {
                    var c = i ? i.stats : u.stats,
                        p = i ? i.duration : u.duration;

                    if (c.aborted) {
                      D.logger.warn("frag loader destroy or aborted, disarm abandonRules"), this.clearTimer(), this._nextAutoLevel = -1;
                      return;
                    }

                    if (!(!a || h.paused || !h.playbackRate || !h.readyState)) {
                      var C = performance.now() - c.loading.start,
                          _ = Math.abs(h.playbackRate);

                      if (!(C <= 500 * p / _)) {
                        var g = n.levels,
                            s = n.minAutoLevel,
                            o = g[u.level],
                            b = c.total || Math.max(c.loaded, Math.round(p * o.maxBitrate / 8)),
                            A = Math.max(1, c.bwEstimate ? c.bwEstimate / 8 : c.loaded * 1e3 / C),
                            I = (b - c.loaded) / A,
                            M = h.currentTime,
                            F = (H.BufferHelper.bufferInfo(h, M, v.maxBufferHole).end - M) / _;

                        if (!(F >= 2 * p / _ || I <= F)) {
                          var B = Number.POSITIVE_INFINITY,
                              U;

                          for (U = u.level - 1; U > s; U--) {
                            var W = g[U].maxBitrate;
                            if (B = p * W / (8 * .8 * A), B < F) break;
                          }

                          if (!(B >= I)) {
                            var G = this.bwEstimator.getEstimate();
                            D.logger.warn("Fragment " + u.sn + (i ? " part " + i.index : "") + " of level " + u.level + " is loading too slowly and will cause an underbuffer; aborting and switching to level " + U + "\n      Current BW estimate: " + (Object(j.isFiniteNumber)(G) ? (G / 1024).toFixed(3) : "Unknown") + " Kb/s\n      Estimated load time for current fragment: " + I.toFixed(3) + " s\n      Estimated load time for the next fragment: " + B.toFixed(3) + " s\n      Time to underbuffer: " + F.toFixed(3) + " s"), n.nextLoadLevel = U, this.bwEstimator.sample(C, c.loaded), this.clearTimer(), u.loader && (this.fragCurrent = this.partCurrent = null, u.loader.abort()), n.trigger(k.Events.FRAG_LOAD_EMERGENCY_ABORTED, {
                              frag: u,
                              part: i,
                              stats: c
                            });
                          }
                        }
                      }
                    }
                  }
                }, f.onFragLoaded = function (u, i) {
                  var n = i.frag,
                      a = i.part;

                  if (n.type === O.PlaylistLevelType.MAIN && Object(j.isFiniteNumber)(n.sn)) {
                    var v = a ? a.stats : n.stats,
                        h = a ? a.duration : n.duration;

                    if (this.clearTimer(), this.lastLoadedFragLevel = n.level, this._nextAutoLevel = -1, this.hls.config.abrMaxWithRealBitrate) {
                      var c = this.hls.levels[n.level],
                          p = (c.loaded ? c.loaded.bytes : 0) + v.loaded,
                          C = (c.loaded ? c.loaded.duration : 0) + h;
                      c.loaded = {
                        bytes: p,
                        duration: C
                      }, c.realBitrate = Math.round(8 * p / C);
                    }

                    if (n.bitrateTest) {
                      var _ = {
                        stats: v,
                        frag: n,
                        part: a,
                        id: n.type
                      };
                      this.onFragBuffered(k.Events.FRAG_BUFFERED, _), n.bitrateTest = !1;
                    }
                  }
                }, f.onFragBuffered = function (u, i) {
                  var n = i.frag,
                      a = i.part,
                      v = a ? a.stats : n.stats;

                  if (!v.aborted && !(n.type !== O.PlaylistLevelType.MAIN || n.sn === "initSegment")) {
                    var h = v.parsing.end - v.loading.start;
                    this.bwEstimator.sample(h, v.loaded), v.bwEstimate = this.bwEstimator.getEstimate(), n.bitrateTest ? this.bitrateTestDelay = h / 1e3 : this.bitrateTestDelay = 0;
                  }
                }, f.onError = function (u, i) {
                  switch (i.details) {
                    case w.ErrorDetails.FRAG_LOAD_ERROR:
                    case w.ErrorDetails.FRAG_LOAD_TIMEOUT:
                      this.clearTimer();
                      break;

                    default:
                      break;
                  }
                }, f.clearTimer = function () {
                  self.clearInterval(this.timer), this.timer = void 0;
                }, f.getNextABRAutoLevel = function () {
                  var u = this.fragCurrent,
                      i = this.partCurrent,
                      n = this.hls,
                      a = n.maxAutoLevel,
                      v = n.config,
                      h = n.minAutoLevel,
                      c = n.media,
                      p = i ? i.duration : u ? u.duration : 0,
                      C = c ? c.currentTime : 0,
                      _ = c && c.playbackRate !== 0 ? Math.abs(c.playbackRate) : 1,
                      g = this.bwEstimator ? this.bwEstimator.getEstimate() : v.abrEwmaDefaultEstimate,
                      s = (H.BufferHelper.bufferInfo(c, C, v.maxBufferHole).end - C) / _,
                      o = this.findBestLevel(g, h, a, s, v.abrBandWidthFactor, v.abrBandWidthUpFactor);

                  if (o >= 0) return o;
                  D.logger.trace((s ? "rebuffering expected" : "buffer is empty") + ", finding optimal quality level");
                  var b = p ? Math.min(p, v.maxStarvationDelay) : v.maxStarvationDelay,
                      A = v.abrBandWidthFactor,
                      I = v.abrBandWidthUpFactor;

                  if (!s) {
                    var M = this.bitrateTestDelay;

                    if (M) {
                      var F = p ? Math.min(p, v.maxLoadingDelay) : v.maxLoadingDelay;
                      b = F - M, D.logger.trace("bitrate test took " + Math.round(1e3 * M) + "ms, set first fragment max fetchDuration to " + Math.round(1e3 * b) + " ms"), A = I = 1;
                    }
                  }

                  return o = this.findBestLevel(g, h, a, s + b, A, I), Math.max(o, 0);
                }, f.findBestLevel = function (u, i, n, a, v, h) {
                  for (var c, p = this.fragCurrent, C = this.partCurrent, _ = this.lastLoadedFragLevel, g = this.hls.levels, s = g[_], o = !!(s != null && (c = s.details) !== null && c !== void 0 && c.live), b = s == null ? void 0 : s.codecSet, A = C ? C.duration : p ? p.duration : 0, I = n; I >= i; I--) {
                    var M = g[I];

                    if (!(!M || b && M.codecSet !== b)) {
                      var F = M.details,
                          B = (C ? F == null ? void 0 : F.partTarget : F == null ? void 0 : F.averagetargetduration) || A,
                          U = void 0;
                      I <= _ ? U = v * u : U = h * u;
                      var W = g[I].maxBitrate,
                          G = W * B / U;
                      if (D.logger.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + I + "/" + Math.round(U) + "/" + W + "/" + B + "/" + a + "/" + G), U > W && (!G || o && !this.bitrateTestDelay || G < a)) return I;
                    }
                  }

                  return -1;
                }, L(d, [{
                  key: "nextAutoLevel",
                  get: function () {
                    var u = this._nextAutoLevel,
                        i = this.bwEstimator;
                    if (u !== -1 && (!i || !i.canEstimate())) return u;
                    var n = this.getNextABRAutoLevel();
                    return u !== -1 && (n = Math.min(u, n)), n;
                  },
                  set: function (u) {
                    this._nextAutoLevel = u;
                  }
                }]), d;
              }();

              K.default = P;
            },
            "./src/controller/audio-stream-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/controller/base-stream-controller.ts"),
                  k = R("./src/events.ts"),
                  H = R("./src/utils/buffer-helper.ts"),
                  w = R("./src/controller/fragment-tracker.ts"),
                  O = R("./src/types/level.ts"),
                  D = R("./src/types/loader.ts"),
                  E = R("./src/loader/fragment.ts"),
                  L = R("./src/demux/chunk-cache.ts"),
                  P = R("./src/demux/transmuxer-interface.ts"),
                  d = R("./src/types/transmuxer.ts"),
                  f = R("./src/controller/fragment-finders.ts"),
                  y = R("./src/utils/discontinuities.ts"),
                  u = R("./src/errors.ts"),
                  i = R("./src/utils/logger.ts");

              function n() {
                return n = Object.assign || function (p) {
                  for (var C = 1; C < arguments.length; C++) {
                    var _ = arguments[C];

                    for (var g in _) Object.prototype.hasOwnProperty.call(_, g) && (p[g] = _[g]);
                  }

                  return p;
                }, n.apply(this, arguments);
              }

              function a(p, C) {
                p.prototype = Object.create(C.prototype), p.prototype.constructor = p, v(p, C);
              }

              function v(p, C) {
                return v = Object.setPrototypeOf || function (g, s) {
                  return g.__proto__ = s, g;
                }, v(p, C);
              }

              var h = 100,
                  c = function (p) {
                a(C, p);

                function C(g, s) {
                  var o;
                  return o = p.call(this, g, s, "[audio-stream-controller]") || this, o.videoBuffer = null, o.videoTrackCC = -1, o.waitingVideoCC = -1, o.audioSwitch = !1, o.trackId = -1, o.waitingData = null, o.mainDetails = null, o.bufferFlushed = !1, o._registerListeners(), o;
                }

                var _ = C.prototype;
                return _.onHandlerDestroying = function () {
                  this._unregisterListeners(), this.mainDetails = null;
                }, _._registerListeners = function () {
                  var s = this.hls;
                  s.on(k.Events.MEDIA_ATTACHED, this.onMediaAttached, this), s.on(k.Events.MEDIA_DETACHING, this.onMediaDetaching, this), s.on(k.Events.MANIFEST_LOADING, this.onManifestLoading, this), s.on(k.Events.LEVEL_LOADED, this.onLevelLoaded, this), s.on(k.Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), s.on(k.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), s.on(k.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), s.on(k.Events.ERROR, this.onError, this), s.on(k.Events.BUFFER_RESET, this.onBufferReset, this), s.on(k.Events.BUFFER_CREATED, this.onBufferCreated, this), s.on(k.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), s.on(k.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), s.on(k.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                }, _._unregisterListeners = function () {
                  var s = this.hls;
                  s.off(k.Events.MEDIA_ATTACHED, this.onMediaAttached, this), s.off(k.Events.MEDIA_DETACHING, this.onMediaDetaching, this), s.off(k.Events.MANIFEST_LOADING, this.onManifestLoading, this), s.off(k.Events.LEVEL_LOADED, this.onLevelLoaded, this), s.off(k.Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), s.off(k.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), s.off(k.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), s.off(k.Events.ERROR, this.onError, this), s.off(k.Events.BUFFER_RESET, this.onBufferReset, this), s.off(k.Events.BUFFER_CREATED, this.onBufferCreated, this), s.off(k.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), s.off(k.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), s.off(k.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                }, _.onInitPtsFound = function (s, o) {
                  var b = o.frag,
                      A = o.id,
                      I = o.initPTS;

                  if (A === "main") {
                    var M = b.cc;
                    this.initPTS[b.cc] = I, this.log("InitPTS for cc: " + M + " found from main: " + I), this.videoTrackCC = M, this.state === x.State.WAITING_INIT_PTS && this.tick();
                  }
                }, _.startLoad = function (s) {
                  if (!this.levels) {
                    this.startPosition = s, this.state = x.State.STOPPED;
                    return;
                  }

                  var o = this.lastCurrentTime;
                  this.stopLoad(), this.setInterval(h), this.fragLoadError = 0, o > 0 && s === -1 ? (this.log("Override startPosition with lastCurrentTime @" + o.toFixed(3)), this.state = x.State.IDLE) : (this.loadedmetadata = !1, this.state = x.State.WAITING_TRACK), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = s, this.tick();
                }, _.doTick = function () {
                  switch (this.state) {
                    case x.State.IDLE:
                      this.doTickIdle();
                      break;

                    case x.State.WAITING_TRACK:
                      {
                        var s,
                            o = this.levels,
                            b = this.trackId,
                            A = o == null || (s = o[b]) === null || s === void 0 ? void 0 : s.details;

                        if (A) {
                          if (this.waitForCdnTuneIn(A)) break;
                          this.state = x.State.WAITING_INIT_PTS;
                        }

                        break;
                      }

                    case x.State.FRAG_LOADING_WAITING_RETRY:
                      {
                        var I,
                            M = performance.now(),
                            F = this.retryDate;
                        (!F || M >= F || (I = this.media) !== null && I !== void 0 && I.seeking) && (this.log("RetryDate reached, switch back to IDLE state"), this.state = x.State.IDLE);
                        break;
                      }

                    case x.State.WAITING_INIT_PTS:
                      {
                        var B = this.waitingData;

                        if (B) {
                          var U = B.frag,
                              W = B.part,
                              G = B.cache,
                              V = B.complete;

                          if (this.initPTS[U.cc] !== void 0) {
                            this.waitingData = null, this.waitingVideoCC = -1, this.state = x.State.FRAG_LOADING;
                            var Y = G.flush(),
                                $ = {
                              frag: U,
                              part: W,
                              payload: Y,
                              networkDetails: null
                            };
                            this._handleFragmentLoadProgress($), V && p.prototype._handleFragmentLoadComplete.call(this, $);
                          } else if (this.videoTrackCC !== this.waitingVideoCC) i.logger.log("Waiting fragment cc (" + U.cc + ") cancelled because video is at cc " + this.videoTrackCC), this.clearWaitingFragment();else {
                            var q = this.getLoadPosition(),
                                Z = H.BufferHelper.bufferInfo(this.mediaBuffer, q, this.config.maxBufferHole),
                                te = Object(f.fragmentWithinToleranceTest)(Z.end, this.config.maxFragLookUpTolerance, U);
                            te < 0 && (i.logger.log("Waiting fragment cc (" + U.cc + ") @ " + U.start + " cancelled because another fragment at " + Z.end + " is needed"), this.clearWaitingFragment());
                          }
                        } else this.state = x.State.IDLE;
                      }
                  }

                  this.onTickEnd();
                }, _.clearWaitingFragment = function () {
                  var s = this.waitingData;
                  s && (this.fragmentTracker.removeFragment(s.frag), this.waitingData = null, this.waitingVideoCC = -1, this.state = x.State.IDLE);
                }, _.onTickEnd = function () {
                  var s = this.media;

                  if (!(!s || !s.readyState)) {
                    var o = this.mediaBuffer ? this.mediaBuffer : s,
                        b = o.buffered;
                    !this.loadedmetadata && b.length && (this.loadedmetadata = !0), this.lastCurrentTime = s.currentTime;
                  }
                }, _.doTickIdle = function () {
                  var s,
                      o,
                      b = this.hls,
                      A = this.levels,
                      I = this.media,
                      M = this.trackId,
                      F = b.config;

                  if (!(!A || !A[M]) && !(!I && (this.startFragRequested || !F.startFragPrefetch))) {
                    var B = A[M],
                        U = B.details;

                    if (!U || U.live && this.levelLastLoaded !== M || this.waitForCdnTuneIn(U)) {
                      this.state = x.State.WAITING_TRACK;
                      return;
                    }

                    this.bufferFlushed && (this.bufferFlushed = !1, this.afterBufferFlushed(this.mediaBuffer ? this.mediaBuffer : this.media, E.ElementaryStreamTypes.AUDIO, D.PlaylistLevelType.AUDIO));
                    var W = this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, D.PlaylistLevelType.AUDIO);

                    if (W !== null) {
                      var G = W.len,
                          V = this.getMaxBufferLength(),
                          Y = this.audioSwitch;

                      if (!(G >= V && !Y)) {
                        if (!Y && this._streamEnded(W, U)) {
                          b.trigger(k.Events.BUFFER_EOS, {
                            type: "audio"
                          }), this.state = x.State.ENDED;
                          return;
                        }

                        var $ = U.fragments,
                            q = $[0].start,
                            Z = W.end;

                        if (Y) {
                          var te = this.getLoadPosition();
                          Z = te, U.PTSKnown && te < q && (W.end > q || W.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), I.currentTime = q + .05);
                        }

                        var se = this.getNextFragment(Z, U);

                        if (!se) {
                          this.bufferFlushed = !0;
                          return;
                        }

                        ((s = se.decryptdata) === null || s === void 0 ? void 0 : s.keyFormat) === "identity" && !((o = se.decryptdata) !== null && o !== void 0 && o.key) ? this.loadKey(se, U) : this.loadFragment(se, U, Z);
                      }
                    }
                  }
                }, _.getMaxBufferLength = function () {
                  var s = p.prototype.getMaxBufferLength.call(this),
                      o = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, D.PlaylistLevelType.MAIN);
                  return o === null ? s : Math.max(s, o.len);
                }, _.onMediaDetaching = function () {
                  this.videoBuffer = null, p.prototype.onMediaDetaching.call(this);
                }, _.onAudioTracksUpdated = function (s, o) {
                  var b = o.audioTracks;
                  this.resetTransmuxer(), this.levels = b.map(function (A) {
                    return new O.Level(A);
                  });
                }, _.onAudioTrackSwitching = function (s, o) {
                  var b = !!o.url;
                  this.trackId = o.id;
                  var A = this.fragCurrent;
                  A != null && A.loader && A.loader.abort(), this.fragCurrent = null, this.clearWaitingFragment(), b ? this.setInterval(h) : this.resetTransmuxer(), b ? (this.audioSwitch = !0, this.state = x.State.IDLE) : this.state = x.State.STOPPED, this.tick();
                }, _.onManifestLoading = function () {
                  this.mainDetails = null, this.fragmentTracker.removeAllFragments(), this.startPosition = this.lastCurrentTime = 0, this.bufferFlushed = !1;
                }, _.onLevelLoaded = function (s, o) {
                  this.mainDetails = o.details;
                }, _.onAudioTrackLoaded = function (s, o) {
                  var b,
                      A = this.levels,
                      I = o.details,
                      M = o.id;

                  if (!A) {
                    this.warn("Audio tracks were reset while loading level " + M);
                    return;
                  }

                  this.log("Track " + M + " loaded [" + I.startSN + "," + I.endSN + "],duration:" + I.totalduration);
                  var F = A[M],
                      B = 0;

                  if (I.live || (b = F.details) !== null && b !== void 0 && b.live) {
                    var U = this.mainDetails;
                    if (I.fragments[0] || (I.deltaUpdateFailed = !0), I.deltaUpdateFailed || !U) return;
                    !F.details && I.hasProgramDateTime && U.hasProgramDateTime ? (Object(y.alignMediaPlaylistByPDT)(I, U), B = I.fragments[0].start) : B = this.alignPlaylists(I, F.details);
                  }

                  F.details = I, this.levelLastLoaded = M, !this.startFragRequested && (this.mainDetails || !I.live) && this.setStartPosition(F.details, B), this.state === x.State.WAITING_TRACK && !this.waitForCdnTuneIn(I) && (this.state = x.State.IDLE), this.tick();
                }, _._handleFragmentLoadProgress = function (s) {
                  var o,
                      b = s.frag,
                      A = s.part,
                      I = s.payload,
                      M = this.config,
                      F = this.trackId,
                      B = this.levels;

                  if (!B) {
                    this.warn("Audio tracks were reset while fragment load was in progress. Fragment " + b.sn + " of level " + b.level + " will not be buffered");
                    return;
                  }

                  var U = B[F];
                  console.assert(U, "Audio track is defined on fragment load progress");
                  var W = U.details;
                  console.assert(W, "Audio track details are defined on fragment load progress");
                  var G = M.defaultAudioCodec || U.audioCodec || "mp4a.40.2",
                      V = this.transmuxer;
                  V || (V = this.transmuxer = new P.default(this.hls, D.PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
                  var Y = this.initPTS[b.cc],
                      $ = (o = b.initSegment) === null || o === void 0 ? void 0 : o.data;

                  if (Y !== void 0) {
                    var q = !1,
                        Z = A ? A.index : -1,
                        te = Z !== -1,
                        se = new d.ChunkMetadata(b.level, b.sn, b.stats.chunkCount, I.byteLength, Z, te);
                    V.push(I, $, G, "", b, A, W.totalduration, q, se, Y);
                  } else {
                    i.logger.log("Unknown video PTS for cc " + b.cc + ", waiting for video PTS before demuxing audio frag " + b.sn + " of [" + W.startSN + " ," + W.endSN + "],track " + F);
                    var ge = this.waitingData = this.waitingData || {
                      frag: b,
                      part: A,
                      cache: new L.default(),
                      complete: !1
                    },
                        he = ge.cache;
                    he.push(new Uint8Array(I)), this.waitingVideoCC = this.videoTrackCC, this.state = x.State.WAITING_INIT_PTS;
                  }
                }, _._handleFragmentLoadComplete = function (s) {
                  if (this.waitingData) {
                    this.waitingData.complete = !0;
                    return;
                  }

                  p.prototype._handleFragmentLoadComplete.call(this, s);
                }, _.onBufferReset = function () {
                  this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
                }, _.onBufferCreated = function (s, o) {
                  var b = o.tracks.audio;
                  b && (this.mediaBuffer = b.buffer), o.tracks.video && (this.videoBuffer = o.tracks.video.buffer);
                }, _.onFragBuffered = function (s, o) {
                  var b = o.frag,
                      A = o.part;

                  if (b.type === D.PlaylistLevelType.AUDIO) {
                    if (this.fragContextChanged(b)) {
                      this.warn("Fragment " + b.sn + (A ? " p: " + A.index : "") + " of level " + b.level + " finished buffering, but was aborted. state: " + this.state + ", audioSwitch: " + this.audioSwitch);
                      return;
                    }

                    b.sn !== "initSegment" && (this.fragPrevious = b, this.audioSwitch && (this.audioSwitch = !1, this.hls.trigger(k.Events.AUDIO_TRACK_SWITCHED, {
                      id: this.trackId
                    }))), this.fragBufferedComplete(b, A);
                  }
                }, _.onError = function (s, o) {
                  switch (o.details) {
                    case u.ErrorDetails.FRAG_LOAD_ERROR:
                    case u.ErrorDetails.FRAG_LOAD_TIMEOUT:
                    case u.ErrorDetails.KEY_LOAD_ERROR:
                    case u.ErrorDetails.KEY_LOAD_TIMEOUT:
                      this.onFragmentOrKeyLoadError(D.PlaylistLevelType.AUDIO, o);
                      break;

                    case u.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                    case u.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                      this.state !== x.State.ERROR && this.state !== x.State.STOPPED && (this.state = o.fatal ? x.State.ERROR : x.State.IDLE, this.warn(o.details + " while loading frag, switching to " + this.state + " state"));
                      break;

                    case u.ErrorDetails.BUFFER_FULL_ERROR:
                      if (o.parent === "audio" && (this.state === x.State.PARSING || this.state === x.State.PARSED)) {
                        var b = !0,
                            A = this.getFwdBufferInfo(this.mediaBuffer, D.PlaylistLevelType.AUDIO);
                        A && A.len > .5 && (b = !this.reduceMaxBufferLength(A.len)), b && (this.warn("Buffer full error also media.currentTime is not buffered, flush audio buffer"), this.fragCurrent = null, p.prototype.flushMainBuffer.call(this, 0, Number.POSITIVE_INFINITY, "audio")), this.resetLoadingState();
                      }

                      break;

                    default:
                      break;
                  }
                }, _.onBufferFlushed = function (s, o) {
                  var b = o.type;
                  b === E.ElementaryStreamTypes.AUDIO && (this.bufferFlushed = !0);
                }, _._handleTransmuxComplete = function (s) {
                  var o,
                      b = "audio",
                      A = this.hls,
                      I = s.remuxResult,
                      M = s.chunkMeta,
                      F = this.getCurrentContext(M);

                  if (!F) {
                    this.warn("The loading context changed while buffering fragment " + M.sn + " of level " + M.level + ". This chunk will not be buffered."), this.resetLiveStartWhenNotLoaded(M.level);
                    return;
                  }

                  var B = F.frag,
                      U = F.part,
                      W = I.audio,
                      G = I.text,
                      V = I.id3,
                      Y = I.initSegment;

                  if (!this.fragContextChanged(B)) {
                    if (this.state = x.State.PARSING, this.audioSwitch && W && this.completeAudioSwitch(), Y != null && Y.tracks && (this._bufferInitSegment(Y.tracks, B, M), A.trigger(k.Events.FRAG_PARSING_INIT_SEGMENT, {
                      frag: B,
                      id: b,
                      tracks: Y.tracks
                    })), W) {
                      var $ = W.startPTS,
                          q = W.endPTS,
                          Z = W.startDTS,
                          te = W.endDTS;
                      U && (U.elementaryStreams[E.ElementaryStreamTypes.AUDIO] = {
                        startPTS: $,
                        endPTS: q,
                        startDTS: Z,
                        endDTS: te
                      }), B.setElementaryStreamInfo(E.ElementaryStreamTypes.AUDIO, $, q, Z, te), this.bufferFragmentData(W, B, U, M);
                    }

                    if (V != null && (o = V.samples) !== null && o !== void 0 && o.length) {
                      var se = n({
                        frag: B,
                        id: b
                      }, V);
                      A.trigger(k.Events.FRAG_PARSING_METADATA, se);
                    }

                    if (G) {
                      var ge = n({
                        frag: B,
                        id: b
                      }, G);
                      A.trigger(k.Events.FRAG_PARSING_USERDATA, ge);
                    }
                  }
                }, _._bufferInitSegment = function (s, o, b) {
                  if (this.state === x.State.PARSING) {
                    s.video && delete s.video;
                    var A = s.audio;

                    if (!!A) {
                      A.levelCodec = A.codec, A.id = "audio", this.log("Init audio buffer, container:" + A.container + ", codecs[parsed]=[" + A.codec + "]"), this.hls.trigger(k.Events.BUFFER_CODECS, s);
                      var I = A.initSegment;

                      if (I != null && I.byteLength) {
                        var M = {
                          type: "audio",
                          frag: o,
                          part: null,
                          chunkMeta: b,
                          parent: o.type,
                          data: I
                        };
                        this.hls.trigger(k.Events.BUFFER_APPENDING, M);
                      }

                      this.tick();
                    }
                  }
                }, _.loadFragment = function (s, o, b) {
                  var A = this.fragmentTracker.getState(s);
                  this.fragCurrent = s, (this.audioSwitch || A === w.FragmentState.NOT_LOADED || A === w.FragmentState.PARTIAL) && (s.sn === "initSegment" ? this._loadInitSegment(s) : o.live && !Object(j.isFiniteNumber)(this.initPTS[s.cc]) ? (this.log("Waiting for video PTS in continuity counter " + s.cc + " of live stream before loading audio fragment " + s.sn + " of level " + this.trackId), this.state = x.State.WAITING_INIT_PTS) : (this.startFragRequested = !0, p.prototype.loadFragment.call(this, s, o, b)));
                }, _.completeAudioSwitch = function () {
                  var s = this.hls,
                      o = this.media,
                      b = this.trackId;
                  o && (this.log("Switching audio track : flushing all audio"), p.prototype.flushMainBuffer.call(this, 0, Number.POSITIVE_INFINITY, "audio")), this.audioSwitch = !1, s.trigger(k.Events.AUDIO_TRACK_SWITCHED, {
                    id: b
                  });
                }, C;
              }(x.default);

              K.default = c;
            },
            "./src/controller/audio-track-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = R("./src/events.ts"),
                  x = R("./src/errors.ts"),
                  k = R("./src/controller/base-playlist-controller.ts"),
                  H = R("./src/types/loader.ts");

              function w(P, d) {
                for (var f = 0; f < d.length; f++) {
                  var y = d[f];
                  y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(P, y.key, y);
                }
              }

              function O(P, d, f) {
                return d && w(P.prototype, d), f && w(P, f), P;
              }

              function D(P, d) {
                P.prototype = Object.create(d.prototype), P.prototype.constructor = P, E(P, d);
              }

              function E(P, d) {
                return E = Object.setPrototypeOf || function (y, u) {
                  return y.__proto__ = u, y;
                }, E(P, d);
              }

              var L = function (P) {
                D(d, P);

                function d(y) {
                  var u;
                  return u = P.call(this, y, "[audio-track-controller]") || this, u.tracks = [], u.groupId = null, u.tracksInGroup = [], u.trackId = -1, u.trackName = "", u.selectDefaultTrack = !0, u.registerListeners(), u;
                }

                var f = d.prototype;
                return f.registerListeners = function () {
                  var u = this.hls;
                  u.on(j.Events.MANIFEST_LOADING, this.onManifestLoading, this), u.on(j.Events.MANIFEST_PARSED, this.onManifestParsed, this), u.on(j.Events.LEVEL_LOADING, this.onLevelLoading, this), u.on(j.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), u.on(j.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), u.on(j.Events.ERROR, this.onError, this);
                }, f.unregisterListeners = function () {
                  var u = this.hls;
                  u.off(j.Events.MANIFEST_LOADING, this.onManifestLoading, this), u.off(j.Events.MANIFEST_PARSED, this.onManifestParsed, this), u.off(j.Events.LEVEL_LOADING, this.onLevelLoading, this), u.off(j.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), u.off(j.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), u.off(j.Events.ERROR, this.onError, this);
                }, f.destroy = function () {
                  this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, P.prototype.destroy.call(this);
                }, f.onManifestLoading = function () {
                  this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.trackName = "", this.selectDefaultTrack = !0;
                }, f.onManifestParsed = function (u, i) {
                  this.tracks = i.audioTracks || [];
                }, f.onAudioTrackLoaded = function (u, i) {
                  var n = i.id,
                      a = i.details,
                      v = this.tracksInGroup[n];

                  if (!v) {
                    this.warn("Invalid audio track id " + n);
                    return;
                  }

                  var h = v.details;
                  v.details = i.details, this.log("audioTrack " + n + " loaded [" + a.startSN + "-" + a.endSN + "]"), n === this.trackId && (this.retryCount = 0, this.playlistLoaded(n, i, h));
                }, f.onLevelLoading = function (u, i) {
                  this.switchLevel(i.level);
                }, f.onLevelSwitching = function (u, i) {
                  this.switchLevel(i.level);
                }, f.switchLevel = function (u) {
                  var i = this.hls.levels[u];

                  if (!!(i != null && i.audioGroupIds)) {
                    var n = i.audioGroupIds[i.urlId];

                    if (this.groupId !== n) {
                      this.groupId = n;
                      var a = this.tracks.filter(function (h) {
                        return !n || h.groupId === n;
                      });
                      this.selectDefaultTrack && !a.some(function (h) {
                        return h.default;
                      }) && (this.selectDefaultTrack = !1), this.tracksInGroup = a;
                      var v = {
                        audioTracks: a
                      };
                      this.log("Updating audio tracks, " + a.length + ' track(s) found in "' + n + '" group-id'), this.hls.trigger(j.Events.AUDIO_TRACKS_UPDATED, v), this.selectInitialTrack();
                    }
                  }
                }, f.onError = function (u, i) {
                  P.prototype.onError.call(this, u, i), !(i.fatal || !i.context) && i.context.type === H.PlaylistContextType.AUDIO_TRACK && i.context.id === this.trackId && i.context.groupId === this.groupId && this.retryLoadingOrFail(i);
                }, f.setAudioTrack = function (u) {
                  var i = this.tracksInGroup;

                  if (u < 0 || u >= i.length) {
                    this.warn("Invalid id passed to audio-track controller");
                    return;
                  }

                  this.clearTimer();
                  var n = i[this.trackId];
                  this.log("Now switching to audio-track index " + u);
                  var a = i[u],
                      v = a.id,
                      h = a.groupId,
                      c = h === void 0 ? "" : h,
                      p = a.name,
                      C = a.type,
                      _ = a.url;

                  if (this.trackId = u, this.trackName = p, this.selectDefaultTrack = !1, this.hls.trigger(j.Events.AUDIO_TRACK_SWITCHING, {
                    id: v,
                    groupId: c,
                    name: p,
                    type: C,
                    url: _
                  }), !(a.details && !a.details.live)) {
                    var g = this.switchParams(a.url, n == null ? void 0 : n.details);
                    this.loadPlaylist(g);
                  }
                }, f.selectInitialTrack = function () {
                  var u = this.tracksInGroup;
                  console.assert(u.length, "Initial audio track should be selected when tracks are known");
                  var i = this.trackName,
                      n = this.findTrackId(i) || this.findTrackId();
                  n !== -1 ? this.setAudioTrack(n) : (this.warn("No track found for running audio group-ID: " + this.groupId), this.hls.trigger(j.Events.ERROR, {
                    type: x.ErrorTypes.MEDIA_ERROR,
                    details: x.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                    fatal: !0
                  }));
                }, f.findTrackId = function (u) {
                  for (var i = this.tracksInGroup, n = 0; n < i.length; n++) {
                    var a = i[n];
                    if ((!this.selectDefaultTrack || a.default) && (!u || u === a.name)) return a.id;
                  }

                  return -1;
                }, f.loadPlaylist = function (u) {
                  var i = this.tracksInGroup[this.trackId];

                  if (this.shouldLoadTrack(i)) {
                    var n = i.id,
                        a = i.groupId,
                        v = i.url;
                    if (u) try {
                      v = u.addDirectives(v);
                    } catch (h) {
                      this.warn("Could not construct new URL with HLS Delivery Directives: " + h);
                    }
                    this.log("loading audio-track playlist for id: " + n), this.clearTimer(), this.hls.trigger(j.Events.AUDIO_TRACK_LOADING, {
                      url: v,
                      id: n,
                      groupId: a,
                      deliveryDirectives: u || null
                    });
                  }
                }, O(d, [{
                  key: "audioTracks",
                  get: function () {
                    return this.tracksInGroup;
                  }
                }, {
                  key: "audioTrack",
                  get: function () {
                    return this.trackId;
                  },
                  set: function (u) {
                    this.selectDefaultTrack = !1, this.setAudioTrack(u);
                  }
                }]), d;
              }(k.default);

              K.default = L;
            },
            "./src/controller/base-playlist-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return O;
              });

              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/types/level.ts"),
                  k = R("./src/controller/level-helper.ts"),
                  H = R("./src/utils/logger.ts"),
                  w = R("./src/errors.ts"),
                  O = function () {
                function D(L, P) {
                  this.hls = void 0, this.timer = -1, this.canLoad = !1, this.retryCount = 0, this.log = void 0, this.warn = void 0, this.log = H.logger.log.bind(H.logger, P + ":"), this.warn = H.logger.warn.bind(H.logger, P + ":"), this.hls = L;
                }

                var E = D.prototype;
                return E.destroy = function () {
                  this.clearTimer(), this.hls = this.log = this.warn = null;
                }, E.onError = function (P, d) {
                  d.fatal && d.type === w.ErrorTypes.NETWORK_ERROR && this.clearTimer();
                }, E.clearTimer = function () {
                  clearTimeout(this.timer), this.timer = -1;
                }, E.startLoad = function () {
                  this.canLoad = !0, this.retryCount = 0, this.loadPlaylist();
                }, E.stopLoad = function () {
                  this.canLoad = !1, this.clearTimer();
                }, E.switchParams = function (P, d) {
                  var f = d == null ? void 0 : d.renditionReports;
                  if (f) for (var y = 0; y < f.length; y++) {
                    var u = f[y],
                        i = "" + u.URI;

                    if (i === P.substr(-i.length)) {
                      var n = parseInt(u["LAST-MSN"]),
                          a = parseInt(u["LAST-PART"]);

                      if (d && this.hls.config.lowLatencyMode) {
                        var v = Math.min(d.age - d.partTarget, d.targetduration);
                        a !== void 0 && v > d.partTarget && (a += 1);
                      }

                      if (Object(j.isFiniteNumber)(n)) return new x.HlsUrlParameters(n, Object(j.isFiniteNumber)(a) ? a : void 0, x.HlsSkip.No);
                    }
                  }
                }, E.loadPlaylist = function (P) {}, E.shouldLoadTrack = function (P) {
                  return this.canLoad && P && !!P.url && (!P.details || P.details.live);
                }, E.playlistLoaded = function (P, d, f) {
                  var y = this,
                      u = d.details,
                      i = d.stats,
                      n = i.loading.end ? Math.max(0, self.performance.now() - i.loading.end) : 0;

                  if (u.advancedDateTime = Date.now() - n, u.live || f != null && f.live) {
                    if (u.reloaded(f), f && this.log("live playlist " + P + " " + (u.advanced ? "REFRESHED " + u.lastPartSn + "-" + u.lastPartIndex : "MISSED")), f && u.fragments.length > 0 && Object(k.mergeDetails)(f, u), !this.canLoad || !u.live) return;
                    var a,
                        v = void 0,
                        h = void 0;

                    if (u.canBlockReload && u.endSN && u.advanced) {
                      var c = this.hls.config.lowLatencyMode,
                          p = u.lastPartSn,
                          C = u.endSN,
                          _ = u.lastPartIndex,
                          g = _ !== -1,
                          s = p === C,
                          o = c ? 0 : _;
                      g ? (v = s ? C + 1 : p, h = s ? o : _ + 1) : v = C + 1;
                      var b = u.age,
                          A = b + u.ageHeader,
                          I = Math.min(A - u.partTarget, u.targetduration * 1.5);

                      if (I > 0) {
                        if (f && I > f.tuneInGoal) this.warn("CDN Tune-in goal increased from: " + f.tuneInGoal + " to: " + I + " with playlist age: " + u.age), I = 0;else {
                          var M = Math.floor(I / u.targetduration);

                          if (v += M, h !== void 0) {
                            var F = Math.round(I % u.targetduration / u.partTarget);
                            h += F;
                          }

                          this.log("CDN Tune-in age: " + u.ageHeader + "s last advanced " + b.toFixed(2) + "s goal: " + I + " skip sn " + M + " to part " + h);
                        }
                        u.tuneInGoal = I;
                      }

                      if (a = this.getDeliveryDirectives(u, d.deliveryDirectives, v, h), c || !s) {
                        this.loadPlaylist(a);
                        return;
                      }
                    } else a = this.getDeliveryDirectives(u, d.deliveryDirectives, v, h);

                    var B = Object(k.computeReloadInterval)(u, i);
                    v !== void 0 && u.canBlockReload && (B -= u.partTarget || 1), this.log("reload live playlist " + P + " in " + Math.round(B) + " ms"), this.timer = self.setTimeout(function () {
                      return y.loadPlaylist(a);
                    }, B);
                  } else this.clearTimer();
                }, E.getDeliveryDirectives = function (P, d, f, y) {
                  var u = Object(x.getSkipValue)(P, f);
                  return d != null && d.skip && P.deltaUpdateFailed && (f = d.msn, y = d.part, u = x.HlsSkip.No), new x.HlsUrlParameters(f, y, u);
                }, E.retryLoadingOrFail = function (P) {
                  var d = this,
                      f = this.hls.config,
                      y = this.retryCount < f.levelLoadingMaxRetry;

                  if (y) {
                    var u;
                    if (this.retryCount++, P.details.indexOf("LoadTimeOut") > -1 && (u = P.context) !== null && u !== void 0 && u.deliveryDirectives) this.warn("retry playlist loading #" + this.retryCount + ' after "' + P.details + '"'), this.loadPlaylist();else {
                      var i = Math.min(Math.pow(2, this.retryCount) * f.levelLoadingRetryDelay, f.levelLoadingMaxRetryTimeout);
                      this.timer = self.setTimeout(function () {
                        return d.loadPlaylist();
                      }, i), this.warn("retry playlist loading #" + this.retryCount + " in " + i + ' ms after "' + P.details + '"');
                    }
                  } else this.warn('cannot recover from error "' + P.details + '"'), this.clearTimer(), P.fatal = !0;

                  return y;
                }, D;
              }();
            },
            "./src/controller/base-stream-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "State", function () {
                return C;
              }), R.d(K, "default", function () {
                return _;
              });
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/task-loop.ts"),
                  k = R("./src/controller/fragment-tracker.ts"),
                  H = R("./src/utils/buffer-helper.ts"),
                  w = R("./src/utils/logger.ts"),
                  O = R("./src/events.ts"),
                  D = R("./src/errors.ts"),
                  E = R("./src/types/transmuxer.ts"),
                  L = R("./src/utils/mp4-tools.ts"),
                  P = R("./src/utils/discontinuities.ts"),
                  d = R("./src/controller/fragment-finders.ts"),
                  f = R("./src/controller/level-helper.ts"),
                  y = R("./src/loader/fragment-loader.ts"),
                  u = R("./src/crypt/decrypter.ts"),
                  i = R("./src/utils/time-ranges.ts"),
                  n = R("./src/types/loader.ts");

              function a(g, s) {
                for (var o = 0; o < s.length; o++) {
                  var b = s[o];
                  b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(g, b.key, b);
                }
              }

              function v(g, s, o) {
                return s && a(g.prototype, s), o && a(g, o), g;
              }

              function h(g) {
                if (g === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return g;
              }

              function c(g, s) {
                g.prototype = Object.create(s.prototype), g.prototype.constructor = g, p(g, s);
              }

              function p(g, s) {
                return p = Object.setPrototypeOf || function (b, A) {
                  return b.__proto__ = A, b;
                }, p(g, s);
              }

              var C = {
                STOPPED: "STOPPED",
                IDLE: "IDLE",
                KEY_LOADING: "KEY_LOADING",
                FRAG_LOADING: "FRAG_LOADING",
                FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
                WAITING_TRACK: "WAITING_TRACK",
                PARSING: "PARSING",
                PARSED: "PARSED",
                BACKTRACKING: "BACKTRACKING",
                ENDED: "ENDED",
                ERROR: "ERROR",
                WAITING_INIT_PTS: "WAITING_INIT_PTS",
                WAITING_LEVEL: "WAITING_LEVEL"
              },
                  _ = function (g) {
                c(s, g);

                function s(b, A, I) {
                  var M;
                  return M = g.call(this) || this, M.hls = void 0, M.fragPrevious = null, M.fragCurrent = null, M.fragmentTracker = void 0, M.transmuxer = null, M._state = C.STOPPED, M.media = void 0, M.mediaBuffer = void 0, M.config = void 0, M.bitrateTest = !1, M.lastCurrentTime = 0, M.nextLoadPosition = 0, M.startPosition = 0, M.loadedmetadata = !1, M.fragLoadError = 0, M.retryDate = 0, M.levels = null, M.fragmentLoader = void 0, M.levelLastLoaded = null, M.startFragRequested = !1, M.decrypter = void 0, M.initPTS = [], M.onvseeking = null, M.onvended = null, M.logPrefix = "", M.log = void 0, M.warn = void 0, M.logPrefix = I, M.log = w.logger.log.bind(w.logger, I + ":"), M.warn = w.logger.warn.bind(w.logger, I + ":"), M.hls = b, M.fragmentLoader = new y.default(b.config), M.fragmentTracker = A, M.config = b.config, M.decrypter = new u.default(b, b.config), b.on(O.Events.KEY_LOADED, M.onKeyLoaded, h(M)), M;
                }

                var o = s.prototype;
                return o.doTick = function () {
                  this.onTickEnd();
                }, o.onTickEnd = function () {}, o.startLoad = function (A) {}, o.stopLoad = function () {
                  this.fragmentLoader.abort();
                  var A = this.fragCurrent;
                  A && this.fragmentTracker.removeFragment(A), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = C.STOPPED;
                }, o._streamEnded = function (A, I) {
                  var M = this.fragCurrent,
                      F = this.fragmentTracker;

                  if (!I.live && M && M.sn >= I.endSN && !A.nextStart) {
                    var B = I.partList;

                    if (B != null && B.length) {
                      var U = B[B.length - 1],
                          W = H.BufferHelper.isBuffered(this.media, U.start + U.duration / 2);
                      return W;
                    }

                    var G = F.getState(M);
                    return G === k.FragmentState.PARTIAL || G === k.FragmentState.OK;
                  }

                  return !1;
                }, o.onMediaAttached = function (A, I) {
                  var M = this.media = this.mediaBuffer = I.media;
                  this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), M.addEventListener("seeking", this.onvseeking), M.addEventListener("ended", this.onvended);
                  var F = this.config;
                  this.levels && F.autoStartLoad && this.state === C.STOPPED && this.startLoad(F.startPosition);
                }, o.onMediaDetaching = function () {
                  var A = this.media;
                  A != null && A.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), A && (A.removeEventListener("seeking", this.onvseeking), A.removeEventListener("ended", this.onvended), this.onvseeking = this.onvended = null), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
                }, o.onMediaSeeking = function () {
                  var A = this.config,
                      I = this.fragCurrent,
                      M = this.media,
                      F = this.mediaBuffer,
                      B = this.state,
                      U = M ? M.currentTime : 0,
                      W = H.BufferHelper.bufferInfo(F || M, U, A.maxBufferHole);
                  if (this.log("media seeking to " + (Object(j.isFiniteNumber)(U) ? U.toFixed(3) : U) + ", state: " + B), B === C.ENDED) this.resetLoadingState();else if (I && !W.len) {
                    var G = A.maxFragLookUpTolerance,
                        V = I.start - G,
                        Y = I.start + I.duration + G,
                        $ = U > Y;
                    (U < V || $) && ($ && I.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), I.loader.abort()), this.resetLoadingState());
                  }
                  M && (this.lastCurrentTime = U), !this.loadedmetadata && !W.len && (this.nextLoadPosition = this.startPosition = U), this.tickImmediate();
                }, o.onMediaEnded = function () {
                  this.startPosition = this.lastCurrentTime = 0;
                }, o.onKeyLoaded = function (A, I) {
                  if (!(this.state !== C.KEY_LOADING || I.frag !== this.fragCurrent || !this.levels)) {
                    this.state = C.IDLE;
                    var M = this.levels[I.frag.level].details;
                    M && this.loadFragment(I.frag, M, I.frag.start);
                  }
                }, o.onHandlerDestroying = function () {
                  this.stopLoad(), g.prototype.onHandlerDestroying.call(this);
                }, o.onHandlerDestroyed = function () {
                  this.state = C.STOPPED, this.hls.off(O.Events.KEY_LOADED, this.onKeyLoaded, this), this.fragmentLoader && this.fragmentLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.fragmentLoader = this.fragmentTracker = null, g.prototype.onHandlerDestroyed.call(this);
                }, o.loadKey = function (A, I) {
                  this.log("Loading key for " + A.sn + " of [" + I.startSN + "-" + I.endSN + "], " + (this.logPrefix === "[stream-controller]" ? "level" : "track") + " " + A.level), this.state = C.KEY_LOADING, this.fragCurrent = A, this.hls.trigger(O.Events.KEY_LOADING, {
                    frag: A
                  });
                }, o.loadFragment = function (A, I, M) {
                  this._loadFragForPlayback(A, I, M);
                }, o._loadFragForPlayback = function (A, I, M) {
                  var F = this,
                      B = function (W) {
                    if (F.fragContextChanged(A)) {
                      F.warn("Fragment " + A.sn + (W.part ? " p: " + W.part.index : "") + " of level " + A.level + " was dropped during download."), F.fragmentTracker.removeFragment(A);
                      return;
                    }

                    A.stats.chunkCount++, F._handleFragmentLoadProgress(W);
                  };

                  this._doFragLoad(A, I, M, B).then(function (U) {
                    if (!!U) {
                      F.fragLoadError = 0;
                      var W = F.state;

                      if (F.fragContextChanged(A)) {
                        (W === C.FRAG_LOADING || W === C.BACKTRACKING || !F.fragCurrent && W === C.PARSING) && (F.fragmentTracker.removeFragment(A), F.state = C.IDLE);
                        return;
                      }

                      if ("payload" in U && (F.log("Loaded fragment " + A.sn + " of level " + A.level), F.hls.trigger(O.Events.FRAG_LOADED, U), F.state === C.BACKTRACKING)) {
                        F.fragmentTracker.backtrack(A, U), F.resetFragmentLoading(A);
                        return;
                      }

                      F._handleFragmentLoadComplete(U);
                    }
                  }).catch(function (U) {
                    F.warn(U), F.resetFragmentLoading(A);
                  });
                }, o.flushMainBuffer = function (A, I, M) {
                  if (M === void 0 && (M = null), !!(A - I)) {
                    var F = {
                      startOffset: A,
                      endOffset: I,
                      type: M
                    };
                    this.fragLoadError = 0, this.hls.trigger(O.Events.BUFFER_FLUSHING, F);
                  }
                }, o._loadInitSegment = function (A) {
                  var I = this;

                  this._doFragLoad(A).then(function (M) {
                    if (!M || I.fragContextChanged(A) || !I.levels) throw new Error("init load aborted");
                    return M;
                  }).then(function (M) {
                    var F = I.hls,
                        B = M.payload,
                        U = A.decryptdata;

                    if (B && B.byteLength > 0 && U && U.key && U.iv && U.method === "AES-128") {
                      var W = self.performance.now();
                      return I.decrypter.webCryptoDecrypt(new Uint8Array(B), U.key.buffer, U.iv.buffer).then(function (G) {
                        var V = self.performance.now();
                        return F.trigger(O.Events.FRAG_DECRYPTED, {
                          frag: A,
                          payload: G,
                          stats: {
                            tstart: W,
                            tdecrypt: V
                          }
                        }), M.payload = G, M;
                      });
                    }

                    return M;
                  }).then(function (M) {
                    var F = I.fragCurrent,
                        B = I.hls,
                        U = I.levels;
                    if (!U) throw new Error("init load aborted, missing levels");
                    var W = U[A.level].details;
                    console.assert(W, "Level details are defined when init segment is loaded");
                    var G = A.stats;
                    I.state = C.IDLE, I.fragLoadError = 0, A.data = new Uint8Array(M.payload), G.parsing.start = G.buffering.start = self.performance.now(), G.parsing.end = G.buffering.end = self.performance.now(), M.frag === F && B.trigger(O.Events.FRAG_BUFFERED, {
                      stats: G,
                      frag: F,
                      part: null,
                      id: A.type
                    }), I.tick();
                  }).catch(function (M) {
                    I.warn(M), I.resetFragmentLoading(A);
                  });
                }, o.fragContextChanged = function (A) {
                  var I = this.fragCurrent;
                  return !A || !I || A.level !== I.level || A.sn !== I.sn || A.urlId !== I.urlId;
                }, o.fragBufferedComplete = function (A, I) {
                  var M = this.mediaBuffer ? this.mediaBuffer : this.media;
                  this.log("Buffered " + A.type + " sn: " + A.sn + (I ? " part: " + I.index : "") + " of " + (this.logPrefix === "[stream-controller]" ? "level" : "track") + " " + A.level + " " + i.default.toString(H.BufferHelper.getBuffered(M))), this.state = C.IDLE, this.tick();
                }, o._handleFragmentLoadComplete = function (A) {
                  var I = this.transmuxer;

                  if (!!I) {
                    var M = A.frag,
                        F = A.part,
                        B = A.partsLoaded,
                        U = !B || B.length === 0 || B.some(function (G) {
                      return !G;
                    }),
                        W = new E.ChunkMetadata(M.level, M.sn, M.stats.chunkCount + 1, 0, F ? F.index : -1, !U);
                    I.flush(W);
                  }
                }, o._handleFragmentLoadProgress = function (A) {}, o._doFragLoad = function (A, I, M, F) {
                  var B = this;
                  if (M === void 0 && (M = null), !this.levels) throw new Error("frag load aborted, missing levels");

                  if (M = Math.max(A.start, M || 0), this.config.lowLatencyMode && I) {
                    var U = I.partList;

                    if (U && F) {
                      M > A.end && I.fragmentHint && (A = I.fragmentHint);
                      var W = this.getNextPart(U, A, M);

                      if (W > -1) {
                        var G = U[W];
                        return this.log("Loading part sn: " + A.sn + " p: " + G.index + " cc: " + A.cc + " of playlist [" + I.startSN + "-" + I.endSN + "] parts [0-" + W + "-" + (U.length - 1) + "] " + (this.logPrefix === "[stream-controller]" ? "level" : "track") + ": " + A.level + ", target: " + parseFloat(M.toFixed(3))), this.nextLoadPosition = G.start + G.duration, this.state = C.FRAG_LOADING, this.hls.trigger(O.Events.FRAG_LOADING, {
                          frag: A,
                          part: U[W],
                          targetBufferTime: M
                        }), this.doFragPartsLoad(A, U, W, F).catch(function (V) {
                          return B.handleFragLoadError(V);
                        });
                      } else if (!A.url || this.loadedEndOfParts(U, M)) return Promise.resolve(null);
                    }
                  }

                  return this.log("Loading fragment " + A.sn + " cc: " + A.cc + " " + (I ? "of [" + I.startSN + "-" + I.endSN + "] " : "") + (this.logPrefix === "[stream-controller]" ? "level" : "track") + ": " + A.level + ", target: " + parseFloat(M.toFixed(3))), Object(j.isFiniteNumber)(A.sn) && !this.bitrateTest && (this.nextLoadPosition = A.start + A.duration), this.state = C.FRAG_LOADING, this.hls.trigger(O.Events.FRAG_LOADING, {
                    frag: A,
                    targetBufferTime: M
                  }), this.fragmentLoader.load(A, F).catch(function (V) {
                    return B.handleFragLoadError(V);
                  });
                }, o.doFragPartsLoad = function (A, I, M, F) {
                  var B = this;
                  return new Promise(function (U, W) {
                    var G = [],
                        V = function Y($) {
                      var q = I[$];
                      B.fragmentLoader.loadPart(A, q, F).then(function (Z) {
                        G[q.index] = Z;
                        var te = Z.part;
                        B.hls.trigger(O.Events.FRAG_LOADED, Z);
                        var se = I[$ + 1];
                        if (se && se.fragment === A) Y($ + 1);else return U({
                          frag: A,
                          part: te,
                          partsLoaded: G
                        });
                      }).catch(W);
                    };

                    V(M);
                  });
                }, o.handleFragLoadError = function (A) {
                  var I = A.data;
                  return I && I.details === D.ErrorDetails.INTERNAL_ABORTED ? this.handleFragLoadAborted(I.frag, I.part) : this.hls.trigger(O.Events.ERROR, I), null;
                }, o._handleTransmuxerFlush = function (A) {
                  var I = this.getCurrentContext(A);

                  if (!I || this.state !== C.PARSING) {
                    this.fragCurrent || (this.state = C.IDLE);
                    return;
                  }

                  var M = I.frag,
                      F = I.part,
                      B = I.level,
                      U = self.performance.now();
                  M.stats.parsing.end = U, F && (F.stats.parsing.end = U), this.updateLevelTiming(M, F, B, A.partial);
                }, o.getCurrentContext = function (A) {
                  var I = this.levels,
                      M = A.level,
                      F = A.sn,
                      B = A.part;
                  if (!I || !I[M]) return this.warn("Levels object was unset while buffering fragment " + F + " of level " + M + ". The current chunk will not be buffered."), null;
                  var U = I[M],
                      W = B > -1 ? Object(f.getPartWith)(U, F, B) : null,
                      G = W ? W.fragment : Object(f.getFragmentWithSN)(U, F, this.fragCurrent);
                  return G ? {
                    frag: G,
                    part: W,
                    level: U
                  } : null;
                }, o.bufferFragmentData = function (A, I, M, F) {
                  if (!(!A || this.state !== C.PARSING)) {
                    var B = A.data1,
                        U = A.data2,
                        W = B;

                    if (B && U && (W = Object(L.appendUint8Array)(B, U)), !(!W || !W.length)) {
                      var G = {
                        type: A.type,
                        frag: I,
                        part: M,
                        chunkMeta: F,
                        parent: I.type,
                        data: W
                      };
                      this.hls.trigger(O.Events.BUFFER_APPENDING, G), A.dropped && A.independent && !M && this.flushBufferGap(I);
                    }
                  }
                }, o.flushBufferGap = function (A) {
                  var I = this.media;

                  if (!!I) {
                    if (!H.BufferHelper.isBuffered(I, I.currentTime)) {
                      this.flushMainBuffer(0, A.start);
                      return;
                    }

                    var M = I.currentTime,
                        F = H.BufferHelper.bufferInfo(I, M, 0),
                        B = A.duration,
                        U = Math.min(this.config.maxFragLookUpTolerance * 2, B * .25),
                        W = Math.max(Math.min(A.start - U, F.end - U), M + U);
                    A.start - W > U && this.flushMainBuffer(W, A.start);
                  }
                }, o.getFwdBufferInfo = function (A, I) {
                  var M = this.config,
                      F = this.getLoadPosition();
                  if (!Object(j.isFiniteNumber)(F)) return null;
                  var B = H.BufferHelper.bufferInfo(A, F, M.maxBufferHole);

                  if (B.len === 0 && B.nextStart !== void 0) {
                    var U = this.fragmentTracker.getBufferedFrag(F, I);
                    if (U && B.nextStart < U.end) return H.BufferHelper.bufferInfo(A, F, Math.max(B.nextStart, M.maxBufferHole));
                  }

                  return B;
                }, o.getMaxBufferLength = function (A) {
                  var I = this.config,
                      M;
                  return A ? M = Math.max(8 * I.maxBufferSize / A, I.maxBufferLength) : M = I.maxBufferLength, Math.min(M, I.maxMaxBufferLength);
                }, o.reduceMaxBufferLength = function (A) {
                  var I = this.config,
                      M = A || I.maxBufferLength;
                  return I.maxMaxBufferLength >= M ? (I.maxMaxBufferLength /= 2, this.warn("Reduce max buffer length to " + I.maxMaxBufferLength + "s"), !0) : !1;
                }, o.getNextFragment = function (A, I) {
                  var M,
                      F,
                      B = I.fragments,
                      U = B.length;
                  if (!U) return null;
                  var W = this.config,
                      G = B[0].start,
                      V;

                  if (I.live) {
                    var Y = W.initialLiveManifestSize;
                    if (U < Y) return this.warn("Not enough fragments to start playback (have: " + U + ", need: " + Y + ")"), null;
                    !I.PTSKnown && !this.startFragRequested && this.startPosition === -1 && (V = this.getInitialLiveFragment(I, B), this.startPosition = V ? this.hls.liveSyncPosition || V.start : A);
                  } else A <= G && (V = B[0]);

                  if (!V) {
                    var $ = W.lowLatencyMode ? I.partEnd : I.fragmentEnd;
                    V = this.getFragmentAtPosition(A, $, I);
                  }

                  return (M = V) !== null && M !== void 0 && M.initSegment && !((F = V) !== null && F !== void 0 && F.initSegment.data) && !this.bitrateTest && (V = V.initSegment), V;
                }, o.getNextPart = function (A, I, M) {
                  for (var F = -1, B = !1, U = !0, W = 0, G = A.length; W < G; W++) {
                    var V = A[W];
                    if (U = U && !V.independent, F > -1 && M < V.start) break;
                    var Y = V.loaded;
                    !Y && (B || V.independent || U) && V.fragment === I && (F = W), B = Y;
                  }

                  return F;
                }, o.loadedEndOfParts = function (A, I) {
                  var M = A[A.length - 1];
                  return M && I > M.start && M.loaded;
                }, o.getInitialLiveFragment = function (A, I) {
                  var M = this.fragPrevious,
                      F = null;

                  if (M) {
                    if (A.hasProgramDateTime && (this.log("Live playlist, switching playlist, load frag with same PDT: " + M.programDateTime), F = Object(d.findFragmentByPDT)(I, M.endProgramDateTime, this.config.maxFragLookUpTolerance)), !F) {
                      var B = M.sn + 1;

                      if (B >= A.startSN && B <= A.endSN) {
                        var U = I[B - A.startSN];
                        M.cc === U.cc && (F = U, this.log("Live playlist, switching playlist, load frag with next SN: " + F.sn));
                      }

                      F || (F = Object(d.findFragWithCC)(I, M.cc), F && this.log("Live playlist, switching playlist, load frag with same CC: " + F.sn));
                    }
                  } else {
                    var W = this.hls.liveSyncPosition;
                    W !== null && (F = this.getFragmentAtPosition(W, this.bitrateTest ? A.fragmentEnd : A.edge, A));
                  }

                  return F;
                }, o.getFragmentAtPosition = function (A, I, M) {
                  var F = this.config,
                      B = this.fragPrevious,
                      U = M.fragments,
                      W = M.endSN,
                      G = M.fragmentHint,
                      V = F.maxFragLookUpTolerance,
                      Y = !!(F.lowLatencyMode && M.partList && G);
                  Y && G && !this.bitrateTest && (U = U.concat(G), W = G.sn);
                  var $;

                  if (A < I) {
                    var q = A > I - V ? 0 : V;
                    $ = Object(d.findFragmentByPTS)(B, U, A, q);
                  } else $ = U[U.length - 1];

                  if ($) {
                    var Z = $.sn - M.startSN,
                        te = B && $.level === B.level,
                        se = U[Z + 1],
                        ge = this.fragmentTracker.getState($);

                    if (ge === k.FragmentState.BACKTRACKED) {
                      $ = null;

                      for (var he = Z; U[he] && this.fragmentTracker.getState(U[he]) === k.FragmentState.BACKTRACKED;) B ? $ = U[he--] : $ = U[--he];

                      $ || ($ = se);
                    } else B && $.sn === B.sn && !Y && te && ($.sn < W && this.fragmentTracker.getState(se) !== k.FragmentState.OK ? (this.log("SN " + $.sn + " just loaded, load next one: " + se.sn), $ = se) : $ = null);
                  }

                  return $;
                }, o.synchronizeToLiveEdge = function (A) {
                  var I = this.config,
                      M = this.media;

                  if (!!M) {
                    var F = this.hls.liveSyncPosition,
                        B = M.currentTime,
                        U = A.fragments[0].start,
                        W = A.edge,
                        G = B >= U - I.maxFragLookUpTolerance && B <= W;

                    if (F !== null && M.duration > F && (B < F || !G)) {
                      var V = I.liveMaxLatencyDuration !== void 0 ? I.liveMaxLatencyDuration : I.liveMaxLatencyDurationCount * A.targetduration;
                      (!G && M.readyState < 4 || B < W - V) && (this.loadedmetadata || (this.nextLoadPosition = F), M.readyState && (this.warn("Playback: " + B.toFixed(3) + " is located too far from the end of live sliding playlist: " + W + ", reset currentTime to : " + F.toFixed(3)), M.currentTime = F));
                    }
                  }
                }, o.alignPlaylists = function (A, I) {
                  var M = this.levels,
                      F = this.levelLastLoaded,
                      B = this.fragPrevious,
                      U = F !== null ? M[F] : null,
                      W = A.fragments.length;
                  if (!W) return this.warn("No fragments in live playlist"), 0;
                  var G = A.fragments[0].start,
                      V = !I,
                      Y = A.alignedSliding && Object(j.isFiniteNumber)(G);

                  if (V || !Y && !G) {
                    Object(P.alignStream)(B, U, A);
                    var $ = A.fragments[0].start;
                    return this.log("Live playlist sliding: " + $.toFixed(2) + " start-sn: " + (I ? I.startSN : "na") + "->" + A.startSN + " prev-sn: " + (B ? B.sn : "na") + " fragments: " + W), $;
                  }

                  return G;
                }, o.waitForCdnTuneIn = function (A) {
                  var I = 3;
                  return A.live && A.canBlockReload && A.tuneInGoal > Math.max(A.partHoldBack, A.partTarget * I);
                }, o.setStartPosition = function (A, I) {
                  var M = this.startPosition;

                  if (M < I && (M = -1), M === -1 || this.lastCurrentTime === -1) {
                    var F = A.startTimeOffset;
                    Object(j.isFiniteNumber)(F) ? (M = I + F, F < 0 && (M += A.totalduration), M = Math.min(Math.max(I, M), I + A.totalduration), this.log("Start time offset " + F + " found in playlist, adjust startPosition to " + M), this.startPosition = M) : A.live ? M = this.hls.liveSyncPosition || I : this.startPosition = M = 0, this.lastCurrentTime = M;
                  }

                  this.nextLoadPosition = M;
                }, o.getLoadPosition = function () {
                  var A = this.media,
                      I = 0;
                  return this.loadedmetadata && A ? I = A.currentTime : this.nextLoadPosition && (I = this.nextLoadPosition), I;
                }, o.handleFragLoadAborted = function (A, I) {
                  this.transmuxer && A.sn !== "initSegment" && A.stats.aborted && (this.warn("Fragment " + A.sn + (I ? " part" + I.index : "") + " of level " + A.level + " was aborted"), this.resetFragmentLoading(A));
                }, o.resetFragmentLoading = function (A) {
                  (!this.fragCurrent || !this.fragContextChanged(A)) && (this.state = C.IDLE);
                }, o.onFragmentOrKeyLoadError = function (A, I) {
                  if (!I.fatal) {
                    var M = I.frag;

                    if (!(!M || M.type !== A)) {
                      var F = this.fragCurrent;
                      console.assert(F && M.sn === F.sn && M.level === F.level && M.urlId === F.urlId, "Frag load error must match current frag to retry");
                      var B = this.config;

                      if (this.fragLoadError + 1 <= B.fragLoadingMaxRetry) {
                        if (this.resetLiveStartWhenNotLoaded(M.level)) return;
                        var U = Math.min(Math.pow(2, this.fragLoadError) * B.fragLoadingRetryDelay, B.fragLoadingMaxRetryTimeout);
                        this.warn("Fragment " + M.sn + " of " + A + " " + M.level + " failed to load, retrying in " + U + "ms"), this.retryDate = self.performance.now() + U, this.fragLoadError++, this.state = C.FRAG_LOADING_WAITING_RETRY;
                      } else I.levelRetry ? (A === n.PlaylistLevelType.AUDIO && (this.fragCurrent = null), this.fragLoadError = 0, this.state = C.IDLE) : (w.logger.error(I.details + " reaches max retry, redispatch as fatal ..."), I.fatal = !0, this.hls.stopLoad(), this.state = C.ERROR);
                    }
                  }
                }, o.afterBufferFlushed = function (A, I, M) {
                  if (!!A) {
                    var F = H.BufferHelper.getBuffered(A);
                    this.fragmentTracker.detectEvictedFragments(I, F, M), this.state === C.ENDED && this.resetLoadingState();
                  }
                }, o.resetLoadingState = function () {
                  this.fragCurrent = null, this.fragPrevious = null, this.state = C.IDLE;
                }, o.resetLiveStartWhenNotLoaded = function (A) {
                  if (!this.loadedmetadata) {
                    this.startFragRequested = !1;
                    var I = this.levels ? this.levels[A].details : null;
                    if (I != null && I.live) return this.startPosition = -1, this.setStartPosition(I, 0), this.resetLoadingState(), !0;
                    this.nextLoadPosition = this.startPosition;
                  }

                  return !1;
                }, o.updateLevelTiming = function (A, I, M, F) {
                  var B = this,
                      U = M.details;
                  console.assert(!!U, "level.details must be defined");
                  var W = Object.keys(A.elementaryStreams).reduce(function (G, V) {
                    var Y = A.elementaryStreams[V];

                    if (Y) {
                      var $ = Y.endPTS - Y.startPTS;
                      if ($ <= 0) return B.warn("Could not parse fragment " + A.sn + " " + V + " duration reliably (" + $ + ") resetting transmuxer to fallback to playlist timing"), B.resetTransmuxer(), G || !1;
                      var q = F ? 0 : Object(f.updateFragPTSDTS)(U, A, Y.startPTS, Y.endPTS, Y.startDTS, Y.endDTS);
                      return B.hls.trigger(O.Events.LEVEL_PTS_UPDATED, {
                        details: U,
                        level: M,
                        drift: q,
                        type: V,
                        frag: A,
                        start: Y.startPTS,
                        end: Y.endPTS
                      }), !0;
                    }

                    return G;
                  }, !1);
                  W ? (this.state = C.PARSED, this.hls.trigger(O.Events.FRAG_PARSED, {
                    frag: A,
                    part: I
                  })) : this.resetLoadingState();
                }, o.resetTransmuxer = function () {
                  this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null);
                }, v(s, [{
                  key: "state",
                  get: function () {
                    return this._state;
                  },
                  set: function (A) {
                    var I = this._state;
                    I !== A && (this._state = A, this.log(I + "->" + A));
                  }
                }]), s;
              }(x.default);
            },
            "./src/controller/buffer-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return d;
              });

              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/events.ts"),
                  k = R("./src/utils/logger.ts"),
                  H = R("./src/errors.ts"),
                  w = R("./src/utils/buffer-helper.ts"),
                  O = R("./src/utils/mediasource-helper.ts"),
                  D = R("./src/loader/fragment.ts"),
                  E = R("./src/controller/buffer-operation-queue.ts"),
                  L = Object(O.getMediaSource)(),
                  P = /([ha]vc.)(?:\.[^.,]+)+/,
                  d = function () {
                function f(u) {
                  var i = this;
                  this.details = null, this._objectUrl = null, this.operationQueue = void 0, this.listeners = void 0, this.hls = void 0, this.bufferCodecEventsExpected = 0, this._bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.appendError = 0, this.tracks = {}, this.pendingTracks = {}, this.sourceBuffer = void 0, this._onMediaSourceOpen = function () {
                    var n = i.hls,
                        a = i.media,
                        v = i.mediaSource;
                    k.logger.log("[buffer-controller]: Media source opened"), a && (i.updateMediaElementDuration(), n.trigger(x.Events.MEDIA_ATTACHED, {
                      media: a
                    })), v && v.removeEventListener("sourceopen", i._onMediaSourceOpen), i.checkPendingTracks();
                  }, this._onMediaSourceClose = function () {
                    k.logger.log("[buffer-controller]: Media source closed");
                  }, this._onMediaSourceEnded = function () {
                    k.logger.log("[buffer-controller]: Media source ended");
                  }, this.hls = u, this._initSourceBuffer(), this.registerListeners();
                }

                var y = f.prototype;
                return y.hasSourceTypes = function () {
                  return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
                }, y.destroy = function () {
                  this.unregisterListeners(), this.details = null;
                }, y.registerListeners = function () {
                  var i = this.hls;
                  i.on(x.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), i.on(x.Events.MEDIA_DETACHING, this.onMediaDetaching, this), i.on(x.Events.MANIFEST_PARSED, this.onManifestParsed, this), i.on(x.Events.BUFFER_RESET, this.onBufferReset, this), i.on(x.Events.BUFFER_APPENDING, this.onBufferAppending, this), i.on(x.Events.BUFFER_CODECS, this.onBufferCodecs, this), i.on(x.Events.BUFFER_EOS, this.onBufferEos, this), i.on(x.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), i.on(x.Events.LEVEL_UPDATED, this.onLevelUpdated, this), i.on(x.Events.FRAG_PARSED, this.onFragParsed, this), i.on(x.Events.FRAG_CHANGED, this.onFragChanged, this);
                }, y.unregisterListeners = function () {
                  var i = this.hls;
                  i.off(x.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), i.off(x.Events.MEDIA_DETACHING, this.onMediaDetaching, this), i.off(x.Events.MANIFEST_PARSED, this.onManifestParsed, this), i.off(x.Events.BUFFER_RESET, this.onBufferReset, this), i.off(x.Events.BUFFER_APPENDING, this.onBufferAppending, this), i.off(x.Events.BUFFER_CODECS, this.onBufferCodecs, this), i.off(x.Events.BUFFER_EOS, this.onBufferEos, this), i.off(x.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), i.off(x.Events.LEVEL_UPDATED, this.onLevelUpdated, this), i.off(x.Events.FRAG_PARSED, this.onFragParsed, this), i.off(x.Events.FRAG_CHANGED, this.onFragChanged, this);
                }, y._initSourceBuffer = function () {
                  this.sourceBuffer = {}, this.operationQueue = new E.default(this.sourceBuffer), this.listeners = {
                    audio: [],
                    video: [],
                    audiovideo: []
                  };
                }, y.onManifestParsed = function (i, n) {
                  var a = 2;
                  (n.audio && !n.video || !n.altAudio) && (a = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = a, this.details = null, k.logger.log(this.bufferCodecEventsExpected + " bufferCodec event(s) expected");
                }, y.onMediaAttaching = function (i, n) {
                  var a = this.media = n.media;

                  if (a && L) {
                    var v = this.mediaSource = new L();
                    v.addEventListener("sourceopen", this._onMediaSourceOpen), v.addEventListener("sourceended", this._onMediaSourceEnded), v.addEventListener("sourceclose", this._onMediaSourceClose), a.src = self.URL.createObjectURL(v), this._objectUrl = a.src;
                  }
                }, y.onMediaDetaching = function () {
                  var i = this.media,
                      n = this.mediaSource,
                      a = this._objectUrl;

                  if (n) {
                    if (k.logger.log("[buffer-controller]: media source detaching"), n.readyState === "open") try {
                      n.endOfStream();
                    } catch (v) {
                      k.logger.warn("[buffer-controller]: onMediaDetaching: " + v.message + " while calling endOfStream");
                    }
                    this.onBufferReset(), n.removeEventListener("sourceopen", this._onMediaSourceOpen), n.removeEventListener("sourceended", this._onMediaSourceEnded), n.removeEventListener("sourceclose", this._onMediaSourceClose), i && (a && self.URL.revokeObjectURL(a), i.src === a ? (i.removeAttribute("src"), i.load()) : k.logger.warn("[buffer-controller]: media.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {};
                  }

                  this.hls.trigger(x.Events.MEDIA_DETACHED, void 0);
                }, y.onBufferReset = function () {
                  var i = this;
                  this.getSourceBufferTypes().forEach(function (n) {
                    var a = i.sourceBuffer[n];

                    try {
                      a && (i.removeBufferListeners(n), i.mediaSource && i.mediaSource.removeSourceBuffer(a), i.sourceBuffer[n] = void 0);
                    } catch (v) {
                      k.logger.warn("[buffer-controller]: Failed to reset the " + n + " buffer", v);
                    }
                  }), this._initSourceBuffer();
                }, y.onBufferCodecs = function (i, n) {
                  var a = this,
                      v = this.getSourceBufferTypes().length;
                  Object.keys(n).forEach(function (h) {
                    if (v) {
                      var c = a.tracks[h];

                      if (c && typeof c.buffer.changeType == "function") {
                        var p = n[h],
                            C = p.codec,
                            _ = p.levelCodec,
                            g = p.container,
                            s = (c.levelCodec || c.codec).replace(P, "$1"),
                            o = (_ || C).replace(P, "$1");

                        if (s !== o) {
                          var b = g + ";codecs=" + (_ || C);
                          a.appendChangeType(h, b);
                        }
                      }
                    } else a.pendingTracks[h] = n[h];
                  }), !v && (this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0), this.mediaSource && this.mediaSource.readyState === "open" && this.checkPendingTracks());
                }, y.appendChangeType = function (i, n) {
                  var a = this,
                      v = this.operationQueue,
                      h = {
                    execute: function () {
                      var p = a.sourceBuffer[i];
                      p && (k.logger.log("[buffer-controller]: changing " + i + " sourceBuffer type to " + n), p.changeType(n)), v.shiftAndExecuteNext(i);
                    },
                    onStart: function () {},
                    onComplete: function () {},
                    onError: function (p) {
                      k.logger.warn("[buffer-controller]: Failed to change " + i + " SourceBuffer type", p);
                    }
                  };
                  v.append(h, i);
                }, y.onBufferAppending = function (i, n) {
                  var a = this,
                      v = this.hls,
                      h = this.operationQueue,
                      c = this.tracks,
                      p = n.data,
                      C = n.type,
                      _ = n.frag,
                      g = n.part,
                      s = n.chunkMeta,
                      o = s.buffering[C],
                      b = self.performance.now();
                  o.start = b;
                  var A = _.stats.buffering,
                      I = g ? g.stats.buffering : null;
                  A.start === 0 && (A.start = b), I && I.start === 0 && (I.start = b);
                  var M = c.audio,
                      F = C === "audio" && s.id === 1 && (M == null ? void 0 : M.container) === "audio/mpeg",
                      B = {
                    execute: function () {
                      if (o.executeStart = self.performance.now(), F) {
                        var W = a.sourceBuffer[C];

                        if (W) {
                          var G = _.start - W.timestampOffset;
                          Math.abs(G) >= .1 && (k.logger.log("[buffer-controller]: Updating audio SourceBuffer timestampOffset to " + _.start + " (delta: " + G + ") sn: " + _.sn + ")"), W.timestampOffset = _.start);
                        }
                      }

                      a.appendExecutor(p, C);
                    },
                    onStart: function () {},
                    onComplete: function () {
                      var W = self.performance.now();
                      o.executeEnd = o.end = W, A.first === 0 && (A.first = W), I && I.first === 0 && (I.first = W);
                      var G = a.sourceBuffer,
                          V = {};

                      for (var Y in G) V[Y] = w.BufferHelper.getBuffered(G[Y]);

                      a.appendError = 0, a.hls.trigger(x.Events.BUFFER_APPENDED, {
                        type: C,
                        frag: _,
                        part: g,
                        chunkMeta: s,
                        parent: _.type,
                        timeRanges: V
                      });
                    },
                    onError: function (W) {
                      k.logger.error("[buffer-controller]: Error encountered while trying to append to the " + C + " SourceBuffer", W);
                      var G = {
                        type: H.ErrorTypes.MEDIA_ERROR,
                        parent: _.type,
                        details: H.ErrorDetails.BUFFER_APPEND_ERROR,
                        err: W,
                        fatal: !1
                      };
                      W.code === DOMException.QUOTA_EXCEEDED_ERR ? G.details = H.ErrorDetails.BUFFER_FULL_ERROR : (a.appendError++, G.details = H.ErrorDetails.BUFFER_APPEND_ERROR, a.appendError > v.config.appendErrorMaxRetry && (k.logger.error("[buffer-controller]: Failed " + v.config.appendErrorMaxRetry + " times to append segment in sourceBuffer"), G.fatal = !0)), v.trigger(x.Events.ERROR, G);
                    }
                  };
                  h.append(B, C);
                }, y.onBufferFlushing = function (i, n) {
                  var a = this,
                      v = this.operationQueue,
                      h = function (p) {
                    return {
                      execute: a.removeExecutor.bind(a, p, n.startOffset, n.endOffset),
                      onStart: function () {},
                      onComplete: function () {
                        a.hls.trigger(x.Events.BUFFER_FLUSHED, {
                          type: p
                        });
                      },
                      onError: function (_) {
                        k.logger.warn("[buffer-controller]: Failed to remove from " + p + " SourceBuffer", _);
                      }
                    };
                  };

                  n.type ? v.append(h(n.type), n.type) : this.getSourceBufferTypes().forEach(function (c) {
                    v.append(h(c), c);
                  });
                }, y.onFragParsed = function (i, n) {
                  var a = this,
                      v = n.frag,
                      h = n.part,
                      c = [],
                      p = h ? h.elementaryStreams : v.elementaryStreams;
                  p[D.ElementaryStreamTypes.AUDIOVIDEO] ? c.push("audiovideo") : (p[D.ElementaryStreamTypes.AUDIO] && c.push("audio"), p[D.ElementaryStreamTypes.VIDEO] && c.push("video"));

                  var C = function () {
                    var g = self.performance.now();
                    v.stats.buffering.end = g, h && (h.stats.buffering.end = g);
                    var s = h ? h.stats : v.stats;
                    a.hls.trigger(x.Events.FRAG_BUFFERED, {
                      frag: v,
                      part: h,
                      stats: s,
                      id: v.type
                    });
                  };

                  c.length === 0 && k.logger.warn("Fragments must have at least one ElementaryStreamType set. type: " + v.type + " level: " + v.level + " sn: " + v.sn), this.blockBuffers(C, c);
                }, y.onFragChanged = function (i, n) {
                  this.flushBackBuffer();
                }, y.onBufferEos = function (i, n) {
                  var a = this,
                      v = this.getSourceBufferTypes().reduce(function (h, c) {
                    var p = a.sourceBuffer[c];
                    return (!n.type || n.type === c) && p && !p.ended && (p.ended = !0, k.logger.log("[buffer-controller]: " + c + " sourceBuffer now EOS")), h && !!(!p || p.ended);
                  }, !0);
                  v && this.blockBuffers(function () {
                    var h = a.mediaSource;
                    !h || h.readyState !== "open" || h.endOfStream();
                  });
                }, y.onLevelUpdated = function (i, n) {
                  var a = n.details;
                  !a.fragments.length || (this.details = a, this.getSourceBufferTypes().length ? this.blockBuffers(this.updateMediaElementDuration.bind(this)) : this.updateMediaElementDuration());
                }, y.flushBackBuffer = function () {
                  var i = this.hls,
                      n = this.details,
                      a = this.media,
                      v = this.sourceBuffer;

                  if (!(!a || n === null)) {
                    var h = this.getSourceBufferTypes();

                    if (!!h.length) {
                      var c = n.live && i.config.liveBackBufferLength !== null ? i.config.liveBackBufferLength : i.config.backBufferLength;

                      if (!(!Object(j.isFiniteNumber)(c) || c < 0)) {
                        var p = a.currentTime,
                            C = n.levelTargetDuration,
                            _ = Math.max(c, C),
                            g = Math.floor(p / C) * C - _;

                        h.forEach(function (s) {
                          var o = v[s];

                          if (o) {
                            var b = w.BufferHelper.getBuffered(o);
                            b.length > 0 && g > b.start(0) && (i.trigger(x.Events.BACK_BUFFER_REACHED, {
                              bufferEnd: g
                            }), n.live && i.trigger(x.Events.LIVE_BACK_BUFFER_REACHED, {
                              bufferEnd: g
                            }), i.trigger(x.Events.BUFFER_FLUSHING, {
                              startOffset: 0,
                              endOffset: g,
                              type: s
                            }));
                          }
                        });
                      }
                    }
                  }
                }, y.updateMediaElementDuration = function () {
                  if (!(!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== "open")) {
                    var i = this.details,
                        n = this.hls,
                        a = this.media,
                        v = this.mediaSource,
                        h = i.fragments[0].start + i.totalduration,
                        c = a.duration,
                        p = Object(j.isFiniteNumber)(v.duration) ? v.duration : 0;
                    i.live && n.config.liveDurationInfinity ? (k.logger.log("[buffer-controller]: Media Source duration is set to Infinity"), v.duration = 1 / 0, this.updateSeekableRange(i)) : (h > p && h > c || !Object(j.isFiniteNumber)(c)) && (k.logger.log("[buffer-controller]: Updating Media Source duration to " + h.toFixed(3)), v.duration = h);
                  }
                }, y.updateSeekableRange = function (i) {
                  var n = this.mediaSource,
                      a = i.fragments,
                      v = a.length;

                  if (v && i.live && n !== null && n !== void 0 && n.setLiveSeekableRange) {
                    var h = Math.max(0, a[0].start),
                        c = Math.max(h, h + i.totalduration);
                    n.setLiveSeekableRange(h, c);
                  }
                }, y.checkPendingTracks = function () {
                  var i = this.bufferCodecEventsExpected,
                      n = this.operationQueue,
                      a = this.pendingTracks,
                      v = Object.keys(a).length;

                  if (v && !i || v === 2) {
                    this.createSourceBuffers(a), this.pendingTracks = {};
                    var h = this.getSourceBufferTypes();

                    if (h.length === 0) {
                      this.hls.trigger(x.Events.ERROR, {
                        type: H.ErrorTypes.MEDIA_ERROR,
                        details: H.ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                        fatal: !0,
                        reason: "could not create source buffer for media codec(s)"
                      });
                      return;
                    }

                    h.forEach(function (c) {
                      n.executeNext(c);
                    });
                  }
                }, y.createSourceBuffers = function (i) {
                  var n = this.sourceBuffer,
                      a = this.mediaSource;
                  if (!a) throw Error("createSourceBuffers called when mediaSource was null");
                  var v = 0;

                  for (var h in i) if (!n[h]) {
                    var c = i[h];
                    if (!c) throw Error("source buffer exists for track " + h + ", however track does not");
                    var p = c.levelCodec || c.codec,
                        C = c.container + ";codecs=" + p;
                    k.logger.log("[buffer-controller]: creating sourceBuffer(" + C + ")");

                    try {
                      var _ = n[h] = a.addSourceBuffer(C),
                          g = h;

                      this.addBufferListener(g, "updatestart", this._onSBUpdateStart), this.addBufferListener(g, "updateend", this._onSBUpdateEnd), this.addBufferListener(g, "error", this._onSBUpdateError), this.tracks[h] = {
                        buffer: _,
                        codec: p,
                        container: c.container,
                        levelCodec: c.levelCodec,
                        id: c.id
                      }, v++;
                    } catch (s) {
                      k.logger.error("[buffer-controller]: error while trying to add sourceBuffer: " + s.message), this.hls.trigger(x.Events.ERROR, {
                        type: H.ErrorTypes.MEDIA_ERROR,
                        details: H.ErrorDetails.BUFFER_ADD_CODEC_ERROR,
                        fatal: !1,
                        error: s,
                        mimeType: C
                      });
                    }
                  }

                  v && this.hls.trigger(x.Events.BUFFER_CREATED, {
                    tracks: this.tracks
                  });
                }, y._onSBUpdateStart = function (i) {
                  var n = this.operationQueue,
                      a = n.current(i);
                  a.onStart();
                }, y._onSBUpdateEnd = function (i) {
                  var n = this.operationQueue,
                      a = n.current(i);
                  a.onComplete(), n.shiftAndExecuteNext(i);
                }, y._onSBUpdateError = function (i, n) {
                  k.logger.error("[buffer-controller]: " + i + " SourceBuffer error", n), this.hls.trigger(x.Events.ERROR, {
                    type: H.ErrorTypes.MEDIA_ERROR,
                    details: H.ErrorDetails.BUFFER_APPENDING_ERROR,
                    fatal: !1
                  });
                  var a = this.operationQueue.current(i);
                  a && a.onError(n);
                }, y.removeExecutor = function (i, n, a) {
                  var v = this.media,
                      h = this.mediaSource,
                      c = this.operationQueue,
                      p = this.sourceBuffer,
                      C = p[i];

                  if (!v || !h || !C) {
                    k.logger.warn("[buffer-controller]: Attempting to remove from the " + i + " SourceBuffer, but it does not exist"), c.shiftAndExecuteNext(i);
                    return;
                  }

                  var _ = Object(j.isFiniteNumber)(v.duration) ? v.duration : 1 / 0,
                      g = Object(j.isFiniteNumber)(h.duration) ? h.duration : 1 / 0,
                      s = Math.max(0, n),
                      o = Math.min(a, _, g);

                  o > s ? (k.logger.log("[buffer-controller]: Removing [" + s + "," + o + "] from the " + i + " SourceBuffer"), console.assert(!C.updating, i + " sourceBuffer must not be updating"), C.remove(s, o)) : c.shiftAndExecuteNext(i);
                }, y.appendExecutor = function (i, n) {
                  var a = this.operationQueue,
                      v = this.sourceBuffer,
                      h = v[n];

                  if (!h) {
                    k.logger.warn("[buffer-controller]: Attempting to append to the " + n + " SourceBuffer, but it does not exist"), a.shiftAndExecuteNext(n);
                    return;
                  }

                  h.ended = !1, console.assert(!h.updating, n + " sourceBuffer must not be updating"), h.appendBuffer(i);
                }, y.blockBuffers = function (i, n) {
                  var a = this;

                  if (n === void 0 && (n = this.getSourceBufferTypes()), !n.length) {
                    k.logger.log("[buffer-controller]: Blocking operation requested, but no SourceBuffers exist"), Promise.resolve(i);
                    return;
                  }

                  var v = this.operationQueue,
                      h = n.map(function (c) {
                    return v.appendBlocker(c);
                  });
                  Promise.all(h).then(function () {
                    i(), n.forEach(function (c) {
                      var p = a.sourceBuffer[c];
                      (!p || !p.updating) && v.shiftAndExecuteNext(c);
                    });
                  });
                }, y.getSourceBufferTypes = function () {
                  return Object.keys(this.sourceBuffer);
                }, y.addBufferListener = function (i, n, a) {
                  var v = this.sourceBuffer[i];

                  if (!!v) {
                    var h = a.bind(this, i);
                    this.listeners[i].push({
                      event: n,
                      listener: h
                    }), v.addEventListener(n, h);
                  }
                }, y.removeBufferListeners = function (i) {
                  var n = this.sourceBuffer[i];
                  !n || this.listeners[i].forEach(function (a) {
                    n.removeEventListener(a.event, a.listener);
                  });
                }, f;
              }();
            },
            "./src/controller/buffer-operation-queue.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return x;
              });

              var j = R("./src/utils/logger.ts"),
                  x = function () {
                function k(w) {
                  this.buffers = void 0, this.queues = {
                    video: [],
                    audio: [],
                    audiovideo: []
                  }, this.buffers = w;
                }

                var H = k.prototype;
                return H.append = function (O, D) {
                  var E = this.queues[D];
                  E.push(O), E.length === 1 && this.buffers[D] && this.executeNext(D);
                }, H.insertAbort = function (O, D) {
                  var E = this.queues[D];
                  E.unshift(O), this.executeNext(D);
                }, H.appendBlocker = function (O) {
                  var D,
                      E = new Promise(function (P) {
                    D = P;
                  }),
                      L = {
                    execute: D,
                    onStart: function () {},
                    onComplete: function () {},
                    onError: function () {}
                  };
                  return this.append(L, O), E;
                }, H.executeNext = function (O) {
                  var D = this.buffers,
                      E = this.queues,
                      L = D[O],
                      P = E[O];

                  if (P.length) {
                    var d = P[0];

                    try {
                      d.execute();
                    } catch (f) {
                      j.logger.warn("[buffer-operation-queue]: Unhandled exception executing the current operation"), d.onError(f), (!L || !L.updating) && (P.shift(), this.executeNext(O));
                    }
                  }
                }, H.shiftAndExecuteNext = function (O) {
                  this.queues[O].shift(), this.executeNext(O);
                }, H.current = function (O) {
                  return this.queues[O][0];
                }, k;
              }();
            },
            "./src/controller/cap-level-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = R("./src/events.ts");

              function x(w, O) {
                for (var D = 0; D < O.length; D++) {
                  var E = O[D];
                  E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(w, E.key, E);
                }
              }

              function k(w, O, D) {
                return O && x(w.prototype, O), D && x(w, D), w;
              }

              var H = function () {
                function w(D) {
                  this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.hls = void 0, this.streamController = void 0, this.clientRect = void 0, this.hls = D, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
                }

                var O = w.prototype;
                return O.setStreamController = function (E) {
                  this.streamController = E;
                }, O.destroy = function () {
                  this.unregisterListener(), this.hls.config.capLevelToPlayerSize && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
                }, O.registerListeners = function () {
                  var E = this.hls;
                  E.on(j.Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), E.on(j.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), E.on(j.Events.MANIFEST_PARSED, this.onManifestParsed, this), E.on(j.Events.BUFFER_CODECS, this.onBufferCodecs, this), E.on(j.Events.MEDIA_DETACHING, this.onMediaDetaching, this);
                }, O.unregisterListener = function () {
                  var E = this.hls;
                  E.off(j.Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), E.off(j.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), E.off(j.Events.MANIFEST_PARSED, this.onManifestParsed, this), E.off(j.Events.BUFFER_CODECS, this.onBufferCodecs, this), E.off(j.Events.MEDIA_DETACHING, this.onMediaDetaching, this);
                }, O.onFpsDropLevelCapping = function (E, L) {
                  w.isLevelAllowed(L.droppedLevel, this.restrictedLevels) && this.restrictedLevels.push(L.droppedLevel);
                }, O.onMediaAttaching = function (E, L) {
                  this.media = L.media instanceof HTMLVideoElement ? L.media : null;
                }, O.onManifestParsed = function (E, L) {
                  var P = this.hls;
                  this.restrictedLevels = [], this.firstLevel = L.firstLevel, P.config.capLevelToPlayerSize && L.video && this.startCapping();
                }, O.onBufferCodecs = function (E, L) {
                  var P = this.hls;
                  P.config.capLevelToPlayerSize && L.video && this.startCapping();
                }, O.onMediaDetaching = function () {
                  this.stopCapping();
                }, O.detectPlayerSize = function () {
                  if (this.media && this.mediaHeight > 0 && this.mediaWidth > 0) {
                    var E = this.hls.levels;

                    if (E.length) {
                      var L = this.hls;
                      L.autoLevelCapping = this.getMaxLevel(E.length - 1), L.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = L.autoLevelCapping;
                    }
                  }
                }, O.getMaxLevel = function (E) {
                  var L = this,
                      P = this.hls.levels;
                  if (!P.length) return -1;
                  var d = P.filter(function (f, y) {
                    return w.isLevelAllowed(y, L.restrictedLevels) && y <= E;
                  });
                  return this.clientRect = null, w.getMaxLevelByMediaSize(d, this.mediaWidth, this.mediaHeight);
                }, O.startCapping = function () {
                  this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, this.hls.firstLevel = this.getMaxLevel(this.firstLevel), self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
                }, O.stopCapping = function () {
                  this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
                }, O.getDimensions = function () {
                  if (this.clientRect) return this.clientRect;
                  var E = this.media,
                      L = {
                    width: 0,
                    height: 0
                  };

                  if (E) {
                    var P = E.getBoundingClientRect();
                    L.width = P.width, L.height = P.height, !L.width && !L.height && (L.width = P.right - P.left || E.width || 0, L.height = P.bottom - P.top || E.height || 0);
                  }

                  return this.clientRect = L, L;
                }, w.isLevelAllowed = function (E, L) {
                  return L === void 0 && (L = []), L.indexOf(E) === -1;
                }, w.getMaxLevelByMediaSize = function (E, L, P) {
                  if (!E || !E.length) return -1;

                  for (var d = function (n, a) {
                    return a ? n.width !== a.width || n.height !== a.height : !0;
                  }, f = E.length - 1, y = 0; y < E.length; y += 1) {
                    var u = E[y];

                    if ((u.width >= L || u.height >= P) && d(u, E[y + 1])) {
                      f = y;
                      break;
                    }
                  }

                  return f;
                }, k(w, [{
                  key: "mediaWidth",
                  get: function () {
                    return this.getDimensions().width * w.contentScaleFactor;
                  }
                }, {
                  key: "mediaHeight",
                  get: function () {
                    return this.getDimensions().height * w.contentScaleFactor;
                  }
                }], [{
                  key: "contentScaleFactor",
                  get: function () {
                    var E = 1;

                    try {
                      E = self.devicePixelRatio;
                    } catch (L) {}

                    return E;
                  }
                }]), w;
              }();

              K.default = H;
            },
            "./src/controller/cmcd-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return d;
              });
              var j = R("./src/events.ts"),
                  x = R("./src/types/cmcd.ts"),
                  k = R("./src/utils/buffer-helper.ts"),
                  H = R("./src/utils/logger.ts");

              function w(f, y) {
                for (var u = 0; u < y.length; u++) {
                  var i = y[u];
                  i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(f, i.key, i);
                }
              }

              function O(f, y, u) {
                return y && w(f.prototype, y), u && w(f, u), f;
              }

              function D(f, y) {
                var u = typeof Symbol != "undefined" && f[Symbol.iterator] || f["@@iterator"];
                if (u) return (u = u.call(f)).next.bind(u);

                if (Array.isArray(f) || (u = E(f)) || y && f && typeof f.length == "number") {
                  u && (f = u);
                  var i = 0;
                  return function () {
                    return i >= f.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: f[i++]
                    };
                  };
                }

                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }

              function E(f, y) {
                if (!!f) {
                  if (typeof f == "string") return L(f, y);
                  var u = Object.prototype.toString.call(f).slice(8, -1);
                  if (u === "Object" && f.constructor && (u = f.constructor.name), u === "Map" || u === "Set") return Array.from(f);
                  if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u)) return L(f, y);
                }
              }

              function L(f, y) {
                (y == null || y > f.length) && (y = f.length);

                for (var u = 0, i = new Array(y); u < y; u++) i[u] = f[u];

                return i;
              }

              function P() {
                return P = Object.assign || function (f) {
                  for (var y = 1; y < arguments.length; y++) {
                    var u = arguments[y];

                    for (var i in u) Object.prototype.hasOwnProperty.call(u, i) && (f[i] = u[i]);
                  }

                  return f;
                }, P.apply(this, arguments);
              }

              var d = function () {
                function f(u) {
                  var i = this;
                  this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = function () {
                    i.initialized && (i.starved = !0), i.buffering = !0;
                  }, this.onPlaying = function () {
                    i.initialized || (i.initialized = !0), i.buffering = !1;
                  }, this.applyPlaylistData = function (v) {
                    try {
                      i.apply(v, {
                        ot: x.CMCDObjectType.MANIFEST,
                        su: !i.initialized
                      });
                    } catch (h) {
                      H.logger.warn("Could not generate manifest CMCD data.", h);
                    }
                  }, this.applyFragmentData = function (v) {
                    try {
                      var h = v.frag,
                          c = i.hls.levels[h.level],
                          p = i.getObjectType(h),
                          C = {
                        d: h.duration * 1e3,
                        ot: p
                      };
                      (p === x.CMCDObjectType.VIDEO || p === x.CMCDObjectType.AUDIO || p == x.CMCDObjectType.MUXED) && (C.br = c.bitrate / 1e3, C.tb = i.getTopBandwidth(p) / 1e3, C.bl = i.getBufferLength(p)), i.apply(v, C);
                    } catch (_) {
                      H.logger.warn("Could not generate segment CMCD data.", _);
                    }
                  }, this.hls = u;
                  var n = this.config = u.config,
                      a = n.cmcd;
                  a != null && (n.pLoader = this.createPlaylistLoader(), n.fLoader = this.createFragmentLoader(), this.sid = a.sessionId || f.uuid(), this.cid = a.contentId, this.useHeaders = a.useHeaders === !0, this.registerListeners());
                }

                var y = f.prototype;
                return y.registerListeners = function () {
                  var i = this.hls;
                  i.on(j.Events.MEDIA_ATTACHED, this.onMediaAttached, this), i.on(j.Events.MEDIA_DETACHED, this.onMediaDetached, this), i.on(j.Events.BUFFER_CREATED, this.onBufferCreated, this);
                }, y.unregisterListeners = function () {
                  var i = this.hls;
                  i.off(j.Events.MEDIA_ATTACHED, this.onMediaAttached, this), i.off(j.Events.MEDIA_DETACHED, this.onMediaDetached, this), i.off(j.Events.BUFFER_CREATED, this.onBufferCreated, this), this.onMediaDetached();
                }, y.destroy = function () {
                  this.unregisterListeners(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
                }, y.onMediaAttached = function (i, n) {
                  this.media = n.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
                }, y.onMediaDetached = function () {
                  !this.media || (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
                }, y.onBufferCreated = function (i, n) {
                  var a, v;
                  this.audioBuffer = (a = n.tracks.audio) === null || a === void 0 ? void 0 : a.buffer, this.videoBuffer = (v = n.tracks.video) === null || v === void 0 ? void 0 : v.buffer;
                }, y.createData = function () {
                  var i;
                  return {
                    v: x.CMCDVersion,
                    sf: x.CMCDStreamingFormat.HLS,
                    sid: this.sid,
                    cid: this.cid,
                    pr: (i = this.media) === null || i === void 0 ? void 0 : i.playbackRate,
                    mtp: this.hls.bandwidthEstimate / 1e3
                  };
                }, y.apply = function (i, n) {
                  n === void 0 && (n = {}), P(n, this.createData());
                  var a = n.ot === x.CMCDObjectType.INIT || n.ot === x.CMCDObjectType.VIDEO || n.ot === x.CMCDObjectType.MUXED;

                  if (this.starved && a && (n.bs = !0, n.su = !0, this.starved = !1), n.su == null && (n.su = this.buffering), this.useHeaders) {
                    var v = f.toHeaders(n);
                    if (!Object.keys(v).length) return;
                    i.headers || (i.headers = {}), P(i.headers, v);
                  } else {
                    var h = f.toQuery(n);
                    if (!h) return;
                    i.url = f.appendQueryToUri(i.url, h);
                  }
                }, y.getObjectType = function (i) {
                  var n = i.type;
                  if (n === "subtitle") return x.CMCDObjectType.TIMED_TEXT;
                  if (i.sn === "initSegment") return x.CMCDObjectType.INIT;
                  if (n === "audio") return x.CMCDObjectType.AUDIO;
                  if (n === "main") return this.hls.audioTracks.length ? x.CMCDObjectType.VIDEO : x.CMCDObjectType.MUXED;
                }, y.getTopBandwidth = function (i) {
                  var n = 0,
                      a,
                      v = this.hls;
                  if (i === x.CMCDObjectType.AUDIO) a = v.audioTracks;else {
                    var h = v.maxAutoLevel,
                        c = h > -1 ? h + 1 : v.levels.length;
                    a = v.levels.slice(0, c);
                  }

                  for (var p = D(a), C; !(C = p()).done;) {
                    var _ = C.value;
                    _.bitrate > n && (n = _.bitrate);
                  }

                  return n > 0 ? n : NaN;
                }, y.getBufferLength = function (i) {
                  var n = this.hls.media,
                      a = i === x.CMCDObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
                  if (!a || !n) return NaN;
                  var v = k.BufferHelper.bufferInfo(a, n.currentTime, this.config.maxBufferHole);
                  return v.len * 1e3;
                }, y.createPlaylistLoader = function () {
                  var i = this.config.pLoader,
                      n = this.applyPlaylistData,
                      a = i || this.config.loader;
                  return function () {
                    function v(c) {
                      this.loader = void 0, this.loader = new a(c);
                    }

                    var h = v.prototype;
                    return h.destroy = function () {
                      this.loader.destroy();
                    }, h.abort = function () {
                      this.loader.abort();
                    }, h.load = function (p, C, _) {
                      n(p), this.loader.load(p, C, _);
                    }, O(v, [{
                      key: "stats",
                      get: function () {
                        return this.loader.stats;
                      }
                    }, {
                      key: "context",
                      get: function () {
                        return this.loader.context;
                      }
                    }]), v;
                  }();
                }, y.createFragmentLoader = function () {
                  var i = this.config.fLoader,
                      n = this.applyFragmentData,
                      a = i || this.config.loader;
                  return function () {
                    function v(c) {
                      this.loader = void 0, this.loader = new a(c);
                    }

                    var h = v.prototype;
                    return h.destroy = function () {
                      this.loader.destroy();
                    }, h.abort = function () {
                      this.loader.abort();
                    }, h.load = function (p, C, _) {
                      n(p), this.loader.load(p, C, _);
                    }, O(v, [{
                      key: "stats",
                      get: function () {
                        return this.loader.stats;
                      }
                    }, {
                      key: "context",
                      get: function () {
                        return this.loader.context;
                      }
                    }]), v;
                  }();
                }, f.uuid = function () {
                  var i = URL.createObjectURL(new Blob()),
                      n = i.toString();
                  return URL.revokeObjectURL(i), n.substr(n.lastIndexOf("/") + 1);
                }, f.serialize = function (i) {
                  for (var n = [], a = function (F) {
                    return !Number.isNaN(F) && F != null && F !== "" && F !== !1;
                  }, v = function (F) {
                    return Math.round(F);
                  }, h = function (F) {
                    return v(F / 100) * 100;
                  }, c = function (F) {
                    return encodeURIComponent(F);
                  }, p = {
                    br: v,
                    d: v,
                    bl: h,
                    dl: h,
                    mtp: h,
                    nor: c,
                    rtp: h,
                    tb: v
                  }, C = Object.keys(i || {}).sort(), _ = D(C), g; !(g = _()).done;) {
                    var s = g.value,
                        o = i[s];

                    if (!!a(o) && !(s === "v" && o === 1) && !(s == "pr" && o === 1)) {
                      var b = p[s];
                      b && (o = b(o));
                      var A = typeof o,
                          I = void 0;
                      s === "ot" || s === "sf" || s === "st" ? I = s + "=" + o : A === "boolean" ? I = s : A === "number" ? I = s + "=" + o : I = s + "=" + JSON.stringify(o), n.push(I);
                    }
                  }

                  return n.join(",");
                }, f.toHeaders = function (i) {
                  for (var n = Object.keys(i), a = {}, v = ["Object", "Request", "Session", "Status"], h = [{}, {}, {}, {}], c = {
                    br: 0,
                    d: 0,
                    ot: 0,
                    tb: 0,
                    bl: 1,
                    dl: 1,
                    mtp: 1,
                    nor: 1,
                    nrr: 1,
                    su: 1,
                    cid: 2,
                    pr: 2,
                    sf: 2,
                    sid: 2,
                    st: 2,
                    v: 2,
                    bs: 3,
                    rtp: 3
                  }, p = 0, C = n; p < C.length; p++) {
                    var _ = C[p],
                        g = c[_] != null ? c[_] : 1;
                    h[g][_] = i[_];
                  }

                  for (var s = 0; s < h.length; s++) {
                    var o = f.serialize(h[s]);
                    o && (a["CMCD-" + v[s]] = o);
                  }

                  return a;
                }, f.toQuery = function (i) {
                  return "CMCD=" + encodeURIComponent(f.serialize(i));
                }, f.appendQueryToUri = function (i, n) {
                  if (!n) return i;
                  var a = i.includes("?") ? "&" : "?";
                  return "" + i + a + n;
                }, f;
              }();
            },
            "./src/controller/eme-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = R("./src/events.ts"),
                  x = R("./src/errors.ts"),
                  k = R("./src/utils/logger.ts"),
                  H = R("./src/utils/mediakeys-helper.ts");

              function w(d, f) {
                for (var y = 0; y < f.length; y++) {
                  var u = f[y];
                  u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(d, u.key, u);
                }
              }

              function O(d, f, y) {
                return f && w(d.prototype, f), y && w(d, y), d;
              }

              var D = 3,
                  E = function (f, y, u) {
                var i = {
                  audioCapabilities: [],
                  videoCapabilities: []
                };
                return f.forEach(function (n) {
                  i.audioCapabilities.push({
                    contentType: 'audio/mp4; codecs="' + n + '"',
                    robustness: u.audioRobustness || ""
                  });
                }), y.forEach(function (n) {
                  i.videoCapabilities.push({
                    contentType: 'video/mp4; codecs="' + n + '"',
                    robustness: u.videoRobustness || ""
                  });
                }), [i];
              },
                  L = function (f, y, u, i) {
                switch (f) {
                  case H.KeySystems.WIDEVINE:
                    return E(y, u, i);

                  default:
                    throw new Error("Unknown key-system: " + f);
                }
              },
                  P = function () {
                function d(y) {
                  this.hls = void 0, this._widevineLicenseUrl = void 0, this._licenseXhrSetup = void 0, this._licenseResponseCallback = void 0, this._emeEnabled = void 0, this._requestMediaKeySystemAccess = void 0, this._drmSystemOptions = void 0, this._config = void 0, this._mediaKeysList = [], this._media = null, this._hasSetMediaKeys = !1, this._requestLicenseFailureCount = 0, this.mediaKeysPromise = null, this._onMediaEncrypted = this.onMediaEncrypted.bind(this), this.hls = y, this._config = y.config, this._widevineLicenseUrl = this._config.widevineLicenseUrl, this._licenseXhrSetup = this._config.licenseXhrSetup, this._licenseResponseCallback = this._config.licenseResponseCallback, this._emeEnabled = this._config.emeEnabled, this._requestMediaKeySystemAccess = this._config.requestMediaKeySystemAccessFunc, this._drmSystemOptions = this._config.drmSystemOptions, this._registerListeners();
                }

                var f = d.prototype;
                return f.destroy = function () {
                  this._unregisterListeners(), this.hls = this._onMediaEncrypted = null, this._requestMediaKeySystemAccess = null;
                }, f._registerListeners = function () {
                  this.hls.on(j.Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(j.Events.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(j.Events.MANIFEST_PARSED, this.onManifestParsed, this);
                }, f._unregisterListeners = function () {
                  this.hls.off(j.Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(j.Events.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(j.Events.MANIFEST_PARSED, this.onManifestParsed, this);
                }, f.getLicenseServerUrl = function (u) {
                  switch (u) {
                    case H.KeySystems.WIDEVINE:
                      if (!this._widevineLicenseUrl) break;
                      return this._widevineLicenseUrl;
                  }

                  throw new Error('no license server URL configured for key-system "' + u + '"');
                }, f._attemptKeySystemAccess = function (u, i, n) {
                  var a = this,
                      v = L(u, i, n, this._drmSystemOptions);
                  k.logger.log("Requesting encrypted media key-system access");
                  var h = this.requestMediaKeySystemAccess(u, v);
                  this.mediaKeysPromise = h.then(function (c) {
                    return a._onMediaKeySystemAccessObtained(u, c);
                  }), h.catch(function (c) {
                    k.logger.error('Failed to obtain key-system "' + u + '" access:', c);
                  });
                }, f._onMediaKeySystemAccessObtained = function (u, i) {
                  var n = this;
                  k.logger.log('Access for key-system "' + u + '" obtained');
                  var a = {
                    mediaKeysSessionInitialized: !1,
                    mediaKeySystemAccess: i,
                    mediaKeySystemDomain: u
                  };

                  this._mediaKeysList.push(a);

                  var v = Promise.resolve().then(function () {
                    return i.createMediaKeys();
                  }).then(function (h) {
                    return a.mediaKeys = h, k.logger.log('Media-keys created for key-system "' + u + '"'), n._onMediaKeysCreated(), h;
                  });
                  return v.catch(function (h) {
                    k.logger.error("Failed to create media-keys:", h);
                  }), v;
                }, f._onMediaKeysCreated = function () {
                  var u = this;

                  this._mediaKeysList.forEach(function (i) {
                    i.mediaKeysSession || (i.mediaKeysSession = i.mediaKeys.createSession(), u._onNewMediaKeySession(i.mediaKeysSession));
                  });
                }, f._onNewMediaKeySession = function (u) {
                  var i = this;
                  k.logger.log("New key-system session " + u.sessionId), u.addEventListener("message", function (n) {
                    i._onKeySessionMessage(u, n.message);
                  }, !1);
                }, f._onKeySessionMessage = function (u, i) {
                  k.logger.log("Got EME message event, creating license request"), this._requestLicense(i, function (n) {
                    k.logger.log("Received license data (length: " + (n && n.byteLength) + "), updating key-session"), u.update(n);
                  });
                }, f.onMediaEncrypted = function (u) {
                  var i = this;

                  if (k.logger.log('Media is encrypted using "' + u.initDataType + '" init data type'), !this.mediaKeysPromise) {
                    k.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been requested"), this.hls.trigger(j.Events.ERROR, {
                      type: x.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: x.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                      fatal: !0
                    });
                    return;
                  }

                  var n = function (v) {
                    !i._media || (i._attemptSetMediaKeys(v), i._generateRequestWithPreferredKeySession(u.initDataType, u.initData));
                  };

                  this.mediaKeysPromise.then(n).catch(n);
                }, f._attemptSetMediaKeys = function (u) {
                  if (!this._media) throw new Error("Attempted to set mediaKeys without first attaching a media element");

                  if (!this._hasSetMediaKeys) {
                    var i = this._mediaKeysList[0];

                    if (!i || !i.mediaKeys) {
                      k.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been obtained yet"), this.hls.trigger(j.Events.ERROR, {
                        type: x.ErrorTypes.KEY_SYSTEM_ERROR,
                        details: x.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                        fatal: !0
                      });
                      return;
                    }

                    k.logger.log("Setting keys for encrypted media"), this._media.setMediaKeys(i.mediaKeys), this._hasSetMediaKeys = !0;
                  }
                }, f._generateRequestWithPreferredKeySession = function (u, i) {
                  var n = this,
                      a = this._mediaKeysList[0];

                  if (!a) {
                    k.logger.error("Fatal: Media is encrypted but not any key-system access has been obtained yet"), this.hls.trigger(j.Events.ERROR, {
                      type: x.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: x.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                      fatal: !0
                    });
                    return;
                  }

                  if (a.mediaKeysSessionInitialized) {
                    k.logger.warn("Key-Session already initialized but requested again");
                    return;
                  }

                  var v = a.mediaKeysSession;

                  if (!v) {
                    k.logger.error("Fatal: Media is encrypted but no key-session existing"), this.hls.trigger(j.Events.ERROR, {
                      type: x.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: x.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                      fatal: !0
                    });
                    return;
                  }

                  if (!i) {
                    k.logger.warn("Fatal: initData required for generating a key session is null"), this.hls.trigger(j.Events.ERROR, {
                      type: x.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: x.ErrorDetails.KEY_SYSTEM_NO_INIT_DATA,
                      fatal: !0
                    });
                    return;
                  }

                  k.logger.log('Generating key-session request for "' + u + '" init data type'), a.mediaKeysSessionInitialized = !0, v.generateRequest(u, i).then(function () {
                    k.logger.debug("Key-session generation succeeded");
                  }).catch(function (h) {
                    k.logger.error("Error generating key-session request:", h), n.hls.trigger(j.Events.ERROR, {
                      type: x.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: x.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                      fatal: !1
                    });
                  });
                }, f._createLicenseXhr = function (u, i, n) {
                  var a = new XMLHttpRequest();
                  a.responseType = "arraybuffer", a.onreadystatechange = this._onLicenseRequestReadyStageChange.bind(this, a, u, i, n);
                  var v = this._licenseXhrSetup;
                  if (v) try {
                    v.call(this.hls, a, u), v = void 0;
                  } catch (h) {
                    k.logger.error(h);
                  }

                  try {
                    a.readyState || a.open("POST", u, !0), v && v.call(this.hls, a, u);
                  } catch (h) {
                    throw new Error("issue setting up KeySystem license XHR " + h);
                  }

                  return a;
                }, f._onLicenseRequestReadyStageChange = function (u, i, n, a) {
                  switch (u.readyState) {
                    case 4:
                      if (u.status === 200) {
                        this._requestLicenseFailureCount = 0, k.logger.log("License request succeeded");
                        var v = u.response,
                            h = this._licenseResponseCallback;
                        if (h) try {
                          v = h.call(this.hls, u, i);
                        } catch (p) {
                          k.logger.error(p);
                        }
                        a(v);
                      } else {
                        if (k.logger.error("License Request XHR failed (" + i + "). Status: " + u.status + " (" + u.statusText + ")"), this._requestLicenseFailureCount++, this._requestLicenseFailureCount > D) {
                          this.hls.trigger(j.Events.ERROR, {
                            type: x.ErrorTypes.KEY_SYSTEM_ERROR,
                            details: x.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                            fatal: !0
                          });
                          return;
                        }

                        var c = D - this._requestLicenseFailureCount + 1;
                        k.logger.warn("Retrying license request, " + c + " attempts left"), this._requestLicense(n, a);
                      }

                      break;
                  }
                }, f._generateLicenseRequestChallenge = function (u, i) {
                  switch (u.mediaKeySystemDomain) {
                    case H.KeySystems.WIDEVINE:
                      return i;
                  }

                  throw new Error("unsupported key-system: " + u.mediaKeySystemDomain);
                }, f._requestLicense = function (u, i) {
                  k.logger.log("Requesting content license for key-system");
                  var n = this._mediaKeysList[0];

                  if (!n) {
                    k.logger.error("Fatal error: Media is encrypted but no key-system access has been obtained yet"), this.hls.trigger(j.Events.ERROR, {
                      type: x.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: x.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                      fatal: !0
                    });
                    return;
                  }

                  try {
                    var a = this.getLicenseServerUrl(n.mediaKeySystemDomain),
                        v = this._createLicenseXhr(a, u, i);

                    k.logger.log("Sending license request to URL: " + a);

                    var h = this._generateLicenseRequestChallenge(n, u);

                    v.send(h);
                  } catch (c) {
                    k.logger.error("Failure requesting DRM license: " + c), this.hls.trigger(j.Events.ERROR, {
                      type: x.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: x.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                      fatal: !0
                    });
                  }
                }, f.onMediaAttached = function (u, i) {
                  if (!!this._emeEnabled) {
                    var n = i.media;
                    this._media = n, n.addEventListener("encrypted", this._onMediaEncrypted);
                  }
                }, f.onMediaDetached = function () {
                  var u = this._media,
                      i = this._mediaKeysList;
                  !u || (u.removeEventListener("encrypted", this._onMediaEncrypted), this._media = null, this._mediaKeysList = [], Promise.all(i.map(function (n) {
                    if (n.mediaKeysSession) return n.mediaKeysSession.close().catch(function () {});
                  })).then(function () {
                    return u.setMediaKeys(null);
                  }).catch(function () {}));
                }, f.onManifestParsed = function (u, i) {
                  if (!!this._emeEnabled) {
                    var n = i.levels.map(function (v) {
                      return v.audioCodec;
                    }).filter(function (v) {
                      return !!v;
                    }),
                        a = i.levels.map(function (v) {
                      return v.videoCodec;
                    }).filter(function (v) {
                      return !!v;
                    });

                    this._attemptKeySystemAccess(H.KeySystems.WIDEVINE, n, a);
                  }
                }, O(d, [{
                  key: "requestMediaKeySystemAccess",
                  get: function () {
                    if (!this._requestMediaKeySystemAccess) throw new Error("No requestMediaKeySystemAccess function configured");
                    return this._requestMediaKeySystemAccess;
                  }
                }]), d;
              }();

              K.default = P;
            },
            "./src/controller/fps-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = R("./src/events.ts"),
                  x = R("./src/utils/logger.ts"),
                  k = function () {
                function H(O) {
                  this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = O, this.registerListeners();
                }

                var w = H.prototype;
                return w.setStreamController = function (D) {
                  this.streamController = D;
                }, w.registerListeners = function () {
                  this.hls.on(j.Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
                }, w.unregisterListeners = function () {
                  this.hls.off(j.Events.MEDIA_ATTACHING, this.onMediaAttaching);
                }, w.destroy = function () {
                  this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
                }, w.onMediaAttaching = function (D, E) {
                  var L = this.hls.config;

                  if (L.capLevelOnFPSDrop) {
                    var P = E.media instanceof self.HTMLVideoElement ? E.media : null;
                    this.media = P, P && typeof P.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), L.fpsDroppedMonitoringPeriod);
                  }
                }, w.checkFPS = function (D, E, L) {
                  var P = performance.now();

                  if (E) {
                    if (this.lastTime) {
                      var d = P - this.lastTime,
                          f = L - this.lastDroppedFrames,
                          y = E - this.lastDecodedFrames,
                          u = 1e3 * f / d,
                          i = this.hls;

                      if (i.trigger(j.Events.FPS_DROP, {
                        currentDropped: f,
                        currentDecoded: y,
                        totalDroppedFrames: L
                      }), u > 0 && f > i.config.fpsDroppedMonitoringThreshold * y) {
                        var n = i.currentLevel;
                        x.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + n), n > 0 && (i.autoLevelCapping === -1 || i.autoLevelCapping >= n) && (n = n - 1, i.trigger(j.Events.FPS_DROP_LEVEL_CAPPING, {
                          level: n,
                          droppedLevel: i.currentLevel
                        }), i.autoLevelCapping = n, this.streamController.nextLevelSwitch());
                      }
                    }

                    this.lastTime = P, this.lastDroppedFrames = L, this.lastDecodedFrames = E;
                  }
                }, w.checkFPSInterval = function () {
                  var D = this.media;
                  if (D) if (this.isVideoPlaybackQualityAvailable) {
                    var E = D.getVideoPlaybackQuality();
                    this.checkFPS(D, E.totalVideoFrames, E.droppedVideoFrames);
                  } else this.checkFPS(D, D.webkitDecodedFrameCount, D.webkitDroppedFrameCount);
                }, H;
              }();

              K.default = k;
            },
            "./src/controller/fragment-finders.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "findFragmentByPDT", function () {
                return k;
              }), R.d(K, "findFragmentByPTS", function () {
                return H;
              }), R.d(K, "fragmentWithinToleranceTest", function () {
                return w;
              }), R.d(K, "pdtWithinToleranceTest", function () {
                return O;
              }), R.d(K, "findFragWithCC", function () {
                return D;
              });
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/utils/binary-search.ts");

              function k(E, L, P) {
                if (L === null || !Array.isArray(E) || !E.length || !Object(j.isFiniteNumber)(L)) return null;
                var d = E[0].programDateTime;
                if (L < (d || 0)) return null;
                var f = E[E.length - 1].endProgramDateTime;
                if (L >= (f || 0)) return null;
                P = P || 0;

                for (var y = 0; y < E.length; ++y) {
                  var u = E[y];
                  if (O(L, P, u)) return u;
                }

                return null;
              }

              function H(E, L, P, d) {
                P === void 0 && (P = 0), d === void 0 && (d = 0);
                var f = null;
                if (E ? f = L[E.sn - L[0].sn + 1] || null : P === 0 && L[0].start === 0 && (f = L[0]), f && w(P, d, f) === 0) return f;
                var y = x.default.search(L, w.bind(null, P, d));
                return y || f;
              }

              function w(E, L, P) {
                E === void 0 && (E = 0), L === void 0 && (L = 0);
                var d = Math.min(L, P.duration + (P.deltaPTS ? P.deltaPTS : 0));
                return P.start + P.duration - d <= E ? 1 : P.start - d > E && P.start ? -1 : 0;
              }

              function O(E, L, P) {
                var d = Math.min(L, P.duration + (P.deltaPTS ? P.deltaPTS : 0)) * 1e3,
                    f = P.endProgramDateTime || 0;
                return f - d > E;
              }

              function D(E, L) {
                return x.default.search(E, function (P) {
                  return P.cc < L ? 1 : P.cc > L ? -1 : 0;
                });
              }
            },
            "./src/controller/fragment-tracker.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "FragmentState", function () {
                return k;
              }), R.d(K, "FragmentTracker", function () {
                return H;
              });
              var j = R("./src/events.ts"),
                  x = R("./src/types/loader.ts"),
                  k;

              (function (D) {
                D.NOT_LOADED = "NOT_LOADED", D.BACKTRACKED = "BACKTRACKED", D.APPENDING = "APPENDING", D.PARTIAL = "PARTIAL", D.OK = "OK";
              })(k || (k = {}));

              var H = function () {
                function D(L) {
                  this.activeFragment = null, this.activeParts = null, this.fragments = Object.create(null), this.timeRanges = Object.create(null), this.bufferPadding = .2, this.hls = void 0, this.hls = L, this._registerListeners();
                }

                var E = D.prototype;
                return E._registerListeners = function () {
                  var P = this.hls;
                  P.on(j.Events.BUFFER_APPENDED, this.onBufferAppended, this), P.on(j.Events.FRAG_BUFFERED, this.onFragBuffered, this), P.on(j.Events.FRAG_LOADED, this.onFragLoaded, this);
                }, E._unregisterListeners = function () {
                  var P = this.hls;
                  P.off(j.Events.BUFFER_APPENDED, this.onBufferAppended, this), P.off(j.Events.FRAG_BUFFERED, this.onFragBuffered, this), P.off(j.Events.FRAG_LOADED, this.onFragLoaded, this);
                }, E.destroy = function () {
                  this._unregisterListeners(), this.fragments = this.timeRanges = null;
                }, E.getAppendedFrag = function (P, d) {
                  if (d === x.PlaylistLevelType.MAIN) {
                    var f = this.activeFragment,
                        y = this.activeParts;
                    if (!f) return null;
                    if (y) for (var u = y.length; u--;) {
                      var i = y[u],
                          n = i ? i.end : f.appendedPTS;
                      if (i.start <= P && n !== void 0 && P <= n) return u > 9 && (this.activeParts = y.slice(u - 9)), i;
                    } else if (f.start <= P && f.appendedPTS !== void 0 && P <= f.appendedPTS) return f;
                  }

                  return this.getBufferedFrag(P, d);
                }, E.getBufferedFrag = function (P, d) {
                  for (var f = this.fragments, y = Object.keys(f), u = y.length; u--;) {
                    var i = f[y[u]];

                    if ((i == null ? void 0 : i.body.type) === d && i.buffered) {
                      var n = i.body;
                      if (n.start <= P && P <= n.end) return n;
                    }
                  }

                  return null;
                }, E.detectEvictedFragments = function (P, d, f) {
                  var y = this;
                  Object.keys(this.fragments).forEach(function (u) {
                    var i = y.fragments[u];

                    if (!!i) {
                      if (!i.buffered) {
                        i.body.type === f && y.removeFragment(i.body);
                        return;
                      }

                      var n = i.range[P];
                      !n || n.time.some(function (a) {
                        var v = !y.isTimeBuffered(a.startPTS, a.endPTS, d);
                        return v && y.removeFragment(i.body), v;
                      });
                    }
                  });
                }, E.detectPartialFragments = function (P) {
                  var d = this,
                      f = this.timeRanges,
                      y = P.frag,
                      u = P.part;

                  if (!(!f || y.sn === "initSegment")) {
                    var i = O(y),
                        n = this.fragments[i];
                    !n || (Object.keys(f).forEach(function (a) {
                      var v = y.elementaryStreams[a];

                      if (!!v) {
                        var h = f[a],
                            c = u !== null || v.partial === !0;
                        n.range[a] = d.getBufferedTimes(y, u, c, h);
                      }
                    }), n.backtrack = n.loaded = null, Object.keys(n.range).length ? n.buffered = !0 : this.removeFragment(n.body));
                  }
                }, E.fragBuffered = function (P) {
                  var d = O(P),
                      f = this.fragments[d];
                  f && (f.backtrack = f.loaded = null, f.buffered = !0);
                }, E.getBufferedTimes = function (P, d, f, y) {
                  for (var u = {
                    time: [],
                    partial: f
                  }, i = d ? d.start : P.start, n = d ? d.end : P.end, a = P.minEndPTS || n, v = P.maxStartPTS || i, h = 0; h < y.length; h++) {
                    var c = y.start(h) - this.bufferPadding,
                        p = y.end(h) + this.bufferPadding;

                    if (v >= c && a <= p) {
                      u.time.push({
                        startPTS: Math.max(i, y.start(h)),
                        endPTS: Math.min(n, y.end(h))
                      });
                      break;
                    } else if (i < p && n > c) u.partial = !0, u.time.push({
                      startPTS: Math.max(i, y.start(h)),
                      endPTS: Math.min(n, y.end(h))
                    });else if (n <= c) break;
                  }

                  return u;
                }, E.getPartialFragment = function (P) {
                  var d = null,
                      f,
                      y,
                      u,
                      i = 0,
                      n = this.bufferPadding,
                      a = this.fragments;
                  return Object.keys(a).forEach(function (v) {
                    var h = a[v];
                    !h || w(h) && (y = h.body.start - n, u = h.body.end + n, P >= y && P <= u && (f = Math.min(P - y, u - P), i <= f && (d = h.body, i = f)));
                  }), d;
                }, E.getState = function (P) {
                  var d = O(P),
                      f = this.fragments[d];
                  return f ? f.buffered ? w(f) ? k.PARTIAL : k.OK : f.backtrack ? k.BACKTRACKED : k.APPENDING : k.NOT_LOADED;
                }, E.backtrack = function (P, d) {
                  var f = O(P),
                      y = this.fragments[f];
                  if (!y || y.backtrack) return null;
                  var u = y.backtrack = d || y.loaded;
                  return y.loaded = null, u;
                }, E.getBacktrackData = function (P) {
                  var d = O(P),
                      f = this.fragments[d];

                  if (f) {
                    var y,
                        u = f.backtrack;
                    if (u != null && (y = u.payload) !== null && y !== void 0 && y.byteLength) return u;
                    this.removeFragment(P);
                  }

                  return null;
                }, E.isTimeBuffered = function (P, d, f) {
                  for (var y, u, i = 0; i < f.length; i++) {
                    if (y = f.start(i) - this.bufferPadding, u = f.end(i) + this.bufferPadding, P >= y && d <= u) return !0;
                    if (d <= y) return !1;
                  }

                  return !1;
                }, E.onFragLoaded = function (P, d) {
                  var f = d.frag,
                      y = d.part;

                  if (!(f.sn === "initSegment" || f.bitrateTest || y)) {
                    var u = O(f);
                    this.fragments[u] = {
                      body: f,
                      loaded: d,
                      backtrack: null,
                      buffered: !1,
                      range: Object.create(null)
                    };
                  }
                }, E.onBufferAppended = function (P, d) {
                  var f = this,
                      y = d.frag,
                      u = d.part,
                      i = d.timeRanges;
                  if (y.type === x.PlaylistLevelType.MAIN) if (this.activeFragment = y, u) {
                    var n = this.activeParts;
                    n || (this.activeParts = n = []), n.push(u);
                  } else this.activeParts = null;
                  this.timeRanges = i, Object.keys(i).forEach(function (a) {
                    var v = i[a];
                    if (f.detectEvictedFragments(a, v), !u) for (var h = 0; h < v.length; h++) y.appendedPTS = Math.max(v.end(h), y.appendedPTS || 0);
                  });
                }, E.onFragBuffered = function (P, d) {
                  this.detectPartialFragments(d);
                }, E.hasFragment = function (P) {
                  var d = O(P);
                  return !!this.fragments[d];
                }, E.removeFragmentsInRange = function (P, d, f) {
                  var y = this;
                  Object.keys(this.fragments).forEach(function (u) {
                    var i = y.fragments[u];

                    if (!!i && i.buffered) {
                      var n = i.body;
                      n.type === f && n.start < d && n.end > P && y.removeFragment(n);
                    }
                  });
                }, E.removeFragment = function (P) {
                  var d = O(P);
                  P.stats.loaded = 0, P.clearElementaryStreamInfo(), delete this.fragments[d];
                }, E.removeAllFragments = function () {
                  this.fragments = Object.create(null), this.activeFragment = null, this.activeParts = null;
                }, D;
              }();

              function w(D) {
                var E, L;
                return D.buffered && (((E = D.range.video) === null || E === void 0 ? void 0 : E.partial) || ((L = D.range.audio) === null || L === void 0 ? void 0 : L.partial));
              }

              function O(D) {
                return D.type + "_" + D.level + "_" + D.urlId + "_" + D.sn;
              }
            },
            "./src/controller/gap-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "STALL_MINIMUM_DURATION_MS", function () {
                return w;
              }), R.d(K, "MAX_START_GAP_JUMP", function () {
                return O;
              }), R.d(K, "SKIP_BUFFER_HOLE_STEP_SECONDS", function () {
                return D;
              }), R.d(K, "SKIP_BUFFER_RANGE_START", function () {
                return E;
              }), R.d(K, "default", function () {
                return L;
              });

              var j = R("./src/utils/buffer-helper.ts"),
                  x = R("./src/errors.ts"),
                  k = R("./src/events.ts"),
                  H = R("./src/utils/logger.ts"),
                  w = 250,
                  O = 2,
                  D = .1,
                  E = .05,
                  L = function () {
                function P(f, y, u, i) {
                  this.config = void 0, this.media = void 0, this.fragmentTracker = void 0, this.hls = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.config = f, this.media = y, this.fragmentTracker = u, this.hls = i;
                }

                var d = P.prototype;
                return d.destroy = function () {
                  this.hls = this.fragmentTracker = this.media = null;
                }, d.poll = function (y) {
                  var u = this.config,
                      i = this.media,
                      n = this.stalled,
                      a = i.currentTime,
                      v = i.seeking,
                      h = this.seeking && !v,
                      c = !this.seeking && v;

                  if (this.seeking = v, a !== y) {
                    if (this.moved = !0, n !== null) {
                      if (this.stallReported) {
                        var p = self.performance.now() - n;
                        H.logger.warn("playback not stuck anymore @" + a + ", after " + Math.round(p) + "ms"), this.stallReported = !1;
                      }

                      this.stalled = null, this.nudgeRetry = 0;
                    }

                    return;
                  }

                  if ((c || h) && (this.stalled = null), !(i.paused || i.ended || i.playbackRate === 0 || !j.BufferHelper.getBuffered(i).length)) {
                    var C = j.BufferHelper.bufferInfo(i, a, 0),
                        _ = C.len > 0,
                        g = C.nextStart || 0;

                    if (!(!_ && !g)) {
                      if (v) {
                        var s = C.len > O,
                            o = !g || g - a > O && !this.fragmentTracker.getPartialFragment(a);
                        if (s || o) return;
                        this.moved = !1;
                      }

                      if (!this.moved && this.stalled !== null) {
                        var b,
                            A = Math.max(g, C.start || 0) - a,
                            I = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null,
                            M = I == null || (b = I.details) === null || b === void 0 ? void 0 : b.live,
                            F = M ? I.details.targetduration * 2 : O;

                        if (A > 0 && A <= F) {
                          this._trySkipBufferHole(null);

                          return;
                        }
                      }

                      var B = self.performance.now();

                      if (n === null) {
                        this.stalled = B;
                        return;
                      }

                      var U = B - n;
                      !v && U >= w && this._reportStall(C.len);
                      var W = j.BufferHelper.bufferInfo(i, a, u.maxBufferHole);

                      this._tryFixBufferStall(W, U);
                    }
                  }
                }, d._tryFixBufferStall = function (y, u) {
                  var i = this.config,
                      n = this.fragmentTracker,
                      a = this.media,
                      v = a.currentTime,
                      h = n.getPartialFragment(v);

                  if (h) {
                    var c = this._trySkipBufferHole(h);

                    if (c) return;
                  }

                  y.len > i.maxBufferHole && u > i.highBufferWatchdogPeriod * 1e3 && (H.logger.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
                }, d._reportStall = function (y) {
                  var u = this.hls,
                      i = this.media,
                      n = this.stallReported;
                  n || (this.stallReported = !0, H.logger.warn("Playback stalling at @" + i.currentTime + " due to low buffer (buffer=" + y + ")"), u.trigger(k.Events.ERROR, {
                    type: x.ErrorTypes.MEDIA_ERROR,
                    details: x.ErrorDetails.BUFFER_STALLED_ERROR,
                    fatal: !1,
                    buffer: y
                  }));
                }, d._trySkipBufferHole = function (y) {
                  for (var u = this.config, i = this.hls, n = this.media, a = n.currentTime, v = 0, h = j.BufferHelper.getBuffered(n), c = 0; c < h.length; c++) {
                    var p = h.start(c);

                    if (a + u.maxBufferHole >= v && a < p) {
                      var C = Math.max(p + E, n.currentTime + D);
                      return H.logger.warn("skipping hole, adjusting currentTime from " + a + " to " + C), this.moved = !0, this.stalled = null, n.currentTime = C, y && i.trigger(k.Events.ERROR, {
                        type: x.ErrorTypes.MEDIA_ERROR,
                        details: x.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                        fatal: !1,
                        reason: "fragment loaded with buffer holes, seeking from " + a + " to " + C,
                        frag: y
                      }), C;
                    }

                    v = h.end(c);
                  }

                  return 0;
                }, d._tryNudgeBuffer = function () {
                  var y = this.config,
                      u = this.hls,
                      i = this.media,
                      n = i.currentTime,
                      a = (this.nudgeRetry || 0) + 1;

                  if (this.nudgeRetry = a, a < y.nudgeMaxRetry) {
                    var v = n + a * y.nudgeOffset;
                    H.logger.warn("Nudging 'currentTime' from " + n + " to " + v), i.currentTime = v, u.trigger(k.Events.ERROR, {
                      type: x.ErrorTypes.MEDIA_ERROR,
                      details: x.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                      fatal: !1
                    });
                  } else H.logger.error("Playhead still not moving while enough data buffered @" + n + " after " + y.nudgeMaxRetry + " nudges"), u.trigger(k.Events.ERROR, {
                    type: x.ErrorTypes.MEDIA_ERROR,
                    details: x.ErrorDetails.BUFFER_STALLED_ERROR,
                    fatal: !0
                  });
                }, P;
              }();
            },
            "./src/controller/id3-track-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = R("./src/events.ts"),
                  x = R("./src/utils/texttrack-utils.ts"),
                  k = R("./src/demux/id3.ts"),
                  H = .25,
                  w = function () {
                function O(E) {
                  this.hls = void 0, this.id3Track = null, this.media = null, this.hls = E, this._registerListeners();
                }

                var D = O.prototype;
                return D.destroy = function () {
                  this._unregisterListeners();
                }, D._registerListeners = function () {
                  var L = this.hls;
                  L.on(j.Events.MEDIA_ATTACHED, this.onMediaAttached, this), L.on(j.Events.MEDIA_DETACHING, this.onMediaDetaching, this), L.on(j.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), L.on(j.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                }, D._unregisterListeners = function () {
                  var L = this.hls;
                  L.off(j.Events.MEDIA_ATTACHED, this.onMediaAttached, this), L.off(j.Events.MEDIA_DETACHING, this.onMediaDetaching, this), L.off(j.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), L.off(j.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                }, D.onMediaAttached = function (L, P) {
                  this.media = P.media;
                }, D.onMediaDetaching = function () {
                  !this.id3Track || (Object(x.clearCurrentCues)(this.id3Track), this.id3Track = null, this.media = null);
                }, D.getID3Track = function (L) {
                  if (!!this.media) {
                    for (var P = 0; P < L.length; P++) {
                      var d = L[P];
                      if (d.kind === "metadata" && d.label === "id3") return Object(x.sendAddTrackEvent)(d, this.media), d;
                    }

                    return this.media.addTextTrack("metadata", "id3");
                  }
                }, D.onFragParsingMetadata = function (L, P) {
                  if (!!this.media) {
                    var d = P.frag,
                        f = P.samples;
                    this.id3Track || (this.id3Track = this.getID3Track(this.media.textTracks), this.id3Track.mode = "hidden");

                    for (var y = self.WebKitDataCue || self.VTTCue || self.TextTrackCue, u = 0; u < f.length; u++) {
                      var i = k.getID3Frames(f[u].data);

                      if (i) {
                        var n = f[u].pts,
                            a = u < f.length - 1 ? f[u + 1].pts : d.end,
                            v = a - n;
                        v <= 0 && (a = n + H);

                        for (var h = 0; h < i.length; h++) {
                          var c = i[h];

                          if (!k.isTimeStampFrame(c)) {
                            var p = new y(n, a, "");
                            p.value = c, this.id3Track.addCue(p);
                          }
                        }
                      }
                    }
                  }
                }, D.onBufferFlushing = function (L, P) {
                  var d = P.startOffset,
                      f = P.endOffset,
                      y = P.type;

                  if (!y || y === "audio") {
                    var u = this.id3Track;
                    u && Object(x.removeCuesInRange)(u, d, f);
                  }
                }, O;
              }();

              K.default = w;
            },
            "./src/controller/latency-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return O;
              });
              var j = R("./src/errors.ts"),
                  x = R("./src/events.ts"),
                  k = R("./src/utils/logger.ts");

              function H(D, E) {
                for (var L = 0; L < E.length; L++) {
                  var P = E[L];
                  P.enumerable = P.enumerable || !1, P.configurable = !0, "value" in P && (P.writable = !0), Object.defineProperty(D, P.key, P);
                }
              }

              function w(D, E, L) {
                return E && H(D.prototype, E), L && H(D, L), D;
              }

              var O = function () {
                function D(L) {
                  var P = this;
                  this.hls = void 0, this.config = void 0, this.media = null, this.levelDetails = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this.timeupdateHandler = function () {
                    return P.timeupdate();
                  }, this.hls = L, this.config = L.config, this.registerListeners();
                }

                var E = D.prototype;
                return E.destroy = function () {
                  this.unregisterListeners(), this.onMediaDetaching(), this.levelDetails = null, this.hls = this.timeupdateHandler = null;
                }, E.registerListeners = function () {
                  this.hls.on(x.Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(x.Events.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.on(x.Events.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(x.Events.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.on(x.Events.ERROR, this.onError, this);
                }, E.unregisterListeners = function () {
                  this.hls.off(x.Events.MEDIA_ATTACHED, this.onMediaAttached), this.hls.off(x.Events.MEDIA_DETACHING, this.onMediaDetaching), this.hls.off(x.Events.MANIFEST_LOADING, this.onManifestLoading), this.hls.off(x.Events.LEVEL_UPDATED, this.onLevelUpdated), this.hls.off(x.Events.ERROR, this.onError);
                }, E.onMediaAttached = function (P, d) {
                  this.media = d.media, this.media.addEventListener("timeupdate", this.timeupdateHandler);
                }, E.onMediaDetaching = function () {
                  this.media && (this.media.removeEventListener("timeupdate", this.timeupdateHandler), this.media = null);
                }, E.onManifestLoading = function () {
                  this.levelDetails = null, this._latency = null, this.stallCount = 0;
                }, E.onLevelUpdated = function (P, d) {
                  var f = d.details;
                  this.levelDetails = f, f.advanced && this.timeupdate(), !f.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
                }, E.onError = function (P, d) {
                  d.details === j.ErrorDetails.BUFFER_STALLED_ERROR && (this.stallCount++, k.logger.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
                }, E.timeupdate = function () {
                  var P = this.media,
                      d = this.levelDetails;

                  if (!(!P || !d)) {
                    this.currentTime = P.currentTime;
                    var f = this.computeLatency();

                    if (f !== null) {
                      this._latency = f;
                      var y = this.config,
                          u = y.lowLatencyMode,
                          i = y.maxLiveSyncPlaybackRate;

                      if (!(!u || i === 1)) {
                        var n = this.targetLatency;

                        if (n !== null) {
                          var a = f - n,
                              v = Math.min(this.maxLatency, n + d.targetduration),
                              h = a < v;

                          if (d.live && h && a > .05 && this.forwardBufferLength > 1) {
                            var c = Math.min(2, Math.max(1, i)),
                                p = Math.round(2 / (1 + Math.exp(-.75 * a - this.edgeStalled)) * 20) / 20;
                            P.playbackRate = Math.min(c, Math.max(1, p));
                          } else P.playbackRate !== 1 && P.playbackRate !== 0 && (P.playbackRate = 1);
                        }
                      }
                    }
                  }
                }, E.estimateLiveEdge = function () {
                  var P = this.levelDetails;
                  return P === null ? null : P.edge + P.age;
                }, E.computeLatency = function () {
                  var P = this.estimateLiveEdge();
                  return P === null ? null : P - this.currentTime;
                }, w(D, [{
                  key: "latency",
                  get: function () {
                    return this._latency || 0;
                  }
                }, {
                  key: "maxLatency",
                  get: function () {
                    var P = this.config,
                        d = this.levelDetails;
                    return P.liveMaxLatencyDuration !== void 0 ? P.liveMaxLatencyDuration : d ? P.liveMaxLatencyDurationCount * d.targetduration : 0;
                  }
                }, {
                  key: "targetLatency",
                  get: function () {
                    var P = this.levelDetails;
                    if (P === null) return null;
                    var d = P.holdBack,
                        f = P.partHoldBack,
                        y = P.targetduration,
                        u = this.config,
                        i = u.liveSyncDuration,
                        n = u.liveSyncDurationCount,
                        a = u.lowLatencyMode,
                        v = this.hls.userConfig,
                        h = a && f || d;
                    (v.liveSyncDuration || v.liveSyncDurationCount || h === 0) && (h = i !== void 0 ? i : n * y);
                    var c = y,
                        p = 1;
                    return h + Math.min(this.stallCount * p, c);
                  }
                }, {
                  key: "liveSyncPosition",
                  get: function () {
                    var P = this.estimateLiveEdge(),
                        d = this.targetLatency,
                        f = this.levelDetails;
                    if (P === null || d === null || f === null) return null;
                    var y = f.edge,
                        u = P - d - this.edgeStalled,
                        i = y - f.totalduration,
                        n = y - (this.config.lowLatencyMode && f.partTarget || f.targetduration);
                    return Math.min(Math.max(i, u), n);
                  }
                }, {
                  key: "drift",
                  get: function () {
                    var P = this.levelDetails;
                    return P === null ? 1 : P.drift;
                  }
                }, {
                  key: "edgeStalled",
                  get: function () {
                    var P = this.levelDetails;
                    if (P === null) return 0;
                    var d = (this.config.lowLatencyMode && P.partTarget || P.targetduration) * 3;
                    return Math.max(P.age - d, 0);
                  }
                }, {
                  key: "forwardBufferLength",
                  get: function () {
                    var P = this.media,
                        d = this.levelDetails;
                    if (!P || !d) return 0;
                    var f = P.buffered.length;
                    return f ? P.buffered.end(f - 1) : d.edge - this.currentTime;
                  }
                }]), D;
              }();
            },
            "./src/controller/level-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return u;
              });
              var j = R("./src/types/level.ts"),
                  x = R("./src/events.ts"),
                  k = R("./src/errors.ts"),
                  H = R("./src/utils/codecs.ts"),
                  w = R("./src/controller/level-helper.ts"),
                  O = R("./src/controller/base-playlist-controller.ts"),
                  D = R("./src/types/loader.ts");

              function E() {
                return E = Object.assign || function (i) {
                  for (var n = 1; n < arguments.length; n++) {
                    var a = arguments[n];

                    for (var v in a) Object.prototype.hasOwnProperty.call(a, v) && (i[v] = a[v]);
                  }

                  return i;
                }, E.apply(this, arguments);
              }

              function L(i, n) {
                for (var a = 0; a < n.length; a++) {
                  var v = n[a];
                  v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(i, v.key, v);
                }
              }

              function P(i, n, a) {
                return n && L(i.prototype, n), a && L(i, a), i;
              }

              function d(i, n) {
                i.prototype = Object.create(n.prototype), i.prototype.constructor = i, f(i, n);
              }

              function f(i, n) {
                return f = Object.setPrototypeOf || function (v, h) {
                  return v.__proto__ = h, v;
                }, f(i, n);
              }

              var y = /chrome|firefox/.test(navigator.userAgent.toLowerCase()),
                  u = function (i) {
                d(n, i);

                function n(v) {
                  var h;
                  return h = i.call(this, v, "[level-controller]") || this, h._levels = [], h._firstLevel = -1, h._startLevel = void 0, h.currentLevelIndex = -1, h.manualLevelIndex = -1, h.onParsedComplete = void 0, h._registerListeners(), h;
                }

                var a = n.prototype;
                return a._registerListeners = function () {
                  var h = this.hls;
                  h.on(x.Events.MANIFEST_LOADED, this.onManifestLoaded, this), h.on(x.Events.LEVEL_LOADED, this.onLevelLoaded, this), h.on(x.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), h.on(x.Events.FRAG_LOADED, this.onFragLoaded, this), h.on(x.Events.ERROR, this.onError, this);
                }, a._unregisterListeners = function () {
                  var h = this.hls;
                  h.off(x.Events.MANIFEST_LOADED, this.onManifestLoaded, this), h.off(x.Events.LEVEL_LOADED, this.onLevelLoaded, this), h.off(x.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), h.off(x.Events.FRAG_LOADED, this.onFragLoaded, this), h.off(x.Events.ERROR, this.onError, this);
                }, a.destroy = function () {
                  this._unregisterListeners(), this.manualLevelIndex = -1, this._levels.length = 0, i.prototype.destroy.call(this);
                }, a.startLoad = function () {
                  var h = this._levels;
                  h.forEach(function (c) {
                    c.loadError = 0;
                  }), i.prototype.startLoad.call(this);
                }, a.onManifestLoaded = function (h, c) {
                  var p = [],
                      C = [],
                      _ = [],
                      g,
                      s = {},
                      o,
                      b = !1,
                      A = !1,
                      I = !1;

                  if (c.levels.forEach(function (U) {
                    var W = U.attrs;
                    b = b || !!(U.width && U.height), A = A || !!U.videoCodec, I = I || !!U.audioCodec, y && U.audioCodec && U.audioCodec.indexOf("mp4a.40.34") !== -1 && (U.audioCodec = void 0);
                    var G = U.bitrate + "-" + U.attrs.RESOLUTION + "-" + U.attrs.CODECS;
                    o = s[G], o ? o.url.push(U.url) : (o = new j.Level(U), s[G] = o, p.push(o)), W && (W.AUDIO && Object(w.addGroupId)(o, "audio", W.AUDIO), W.SUBTITLES && Object(w.addGroupId)(o, "text", W.SUBTITLES));
                  }), (b || A) && I && (p = p.filter(function (U) {
                    var W = U.videoCodec,
                        G = U.width,
                        V = U.height;
                    return !!W || !!(G && V);
                  })), p = p.filter(function (U) {
                    var W = U.audioCodec,
                        G = U.videoCodec;
                    return (!W || Object(H.isCodecSupportedInMp4)(W, "audio")) && (!G || Object(H.isCodecSupportedInMp4)(G, "video"));
                  }), c.audioTracks && (C = c.audioTracks.filter(function (U) {
                    return !U.audioCodec || Object(H.isCodecSupportedInMp4)(U.audioCodec, "audio");
                  }), Object(w.assignTrackIdsByGroup)(C)), c.subtitles && (_ = c.subtitles, Object(w.assignTrackIdsByGroup)(_)), p.length > 0) {
                    g = p[0].bitrate, p.sort(function (U, W) {
                      return U.bitrate - W.bitrate;
                    }), this._levels = p;

                    for (var M = 0; M < p.length; M++) if (p[M].bitrate === g) {
                      this._firstLevel = M, this.log("manifest loaded, " + p.length + " level(s) found, first bitrate: " + g);
                      break;
                    }

                    var F = I && !A,
                        B = {
                      levels: p,
                      audioTracks: C,
                      subtitleTracks: _,
                      firstLevel: this._firstLevel,
                      stats: c.stats,
                      audio: I,
                      video: A,
                      altAudio: !F && C.some(function (U) {
                        return !!U.url;
                      })
                    };
                    this.hls.trigger(x.Events.MANIFEST_PARSED, B), (this.hls.config.autoStartLoad || this.hls.forceStartLoad) && this.hls.startLoad(this.hls.config.startPosition);
                  } else this.hls.trigger(x.Events.ERROR, {
                    type: k.ErrorTypes.MEDIA_ERROR,
                    details: k.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                    fatal: !0,
                    url: c.url,
                    reason: "no level with compatible codecs found in manifest"
                  });
                }, a.onError = function (h, c) {
                  if (i.prototype.onError.call(this, h, c), !c.fatal) {
                    var p = c.context,
                        C = this._levels[this.currentLevelIndex];

                    if (p && (p.type === D.PlaylistContextType.AUDIO_TRACK && C.audioGroupIds && p.groupId === C.audioGroupIds[C.urlId] || p.type === D.PlaylistContextType.SUBTITLE_TRACK && C.textGroupIds && p.groupId === C.textGroupIds[C.urlId])) {
                      this.redundantFailover(this.currentLevelIndex);
                      return;
                    }

                    var _ = !1,
                        g = !0,
                        s;

                    switch (c.details) {
                      case k.ErrorDetails.FRAG_LOAD_ERROR:
                      case k.ErrorDetails.FRAG_LOAD_TIMEOUT:
                      case k.ErrorDetails.KEY_LOAD_ERROR:
                      case k.ErrorDetails.KEY_LOAD_TIMEOUT:
                        if (c.frag) {
                          var o = this._levels[c.frag.level];
                          o ? (o.fragmentError++, o.fragmentError > this.hls.config.fragLoadingMaxRetry && (s = c.frag.level)) : s = c.frag.level;
                        }

                        break;

                      case k.ErrorDetails.LEVEL_LOAD_ERROR:
                      case k.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                        p && (p.deliveryDirectives && (g = !1), s = p.level), _ = !0;
                        break;

                      case k.ErrorDetails.REMUX_ALLOC_ERROR:
                        s = c.level, _ = !0;
                        break;
                    }

                    s !== void 0 && this.recoverLevel(c, s, _, g);
                  }
                }, a.recoverLevel = function (h, c, p, C) {
                  var _ = h.details,
                      g = this._levels[c];

                  if (g.loadError++, p) {
                    var s = this.retryLoadingOrFail(h);
                    if (s) h.levelRetry = !0;else {
                      this.currentLevelIndex = -1;
                      return;
                    }
                  }

                  if (C) {
                    var o = g.url.length;
                    if (o > 1 && g.loadError < o) h.levelRetry = !0, this.redundantFailover(c);else if (this.manualLevelIndex === -1) {
                      var b = c === 0 ? this._levels.length - 1 : c - 1;
                      this.currentLevelIndex !== b && this._levels[b].loadError === 0 && (this.warn(_ + ": switch to " + b), h.levelRetry = !0, this.hls.nextAutoLevel = b);
                    }
                  }
                }, a.redundantFailover = function (h) {
                  var c = this._levels[h],
                      p = c.url.length;

                  if (p > 1) {
                    var C = (c.urlId + 1) % p;
                    this.warn("Switching to redundant URL-id " + C), this._levels.forEach(function (_) {
                      _.urlId = C;
                    }), this.level = h;
                  }
                }, a.onFragLoaded = function (h, c) {
                  var p = c.frag;

                  if (p !== void 0 && p.type === D.PlaylistLevelType.MAIN) {
                    var C = this._levels[p.level];
                    C !== void 0 && (C.fragmentError = 0, C.loadError = 0);
                  }
                }, a.onLevelLoaded = function (h, c) {
                  var p,
                      C = c.level,
                      _ = c.details,
                      g = this._levels[C];

                  if (!g) {
                    var s;
                    this.warn("Invalid level index " + C), (s = c.deliveryDirectives) !== null && s !== void 0 && s.skip && (_.deltaUpdateFailed = !0);
                    return;
                  }

                  C === this.currentLevelIndex ? (g.fragmentError === 0 && (g.loadError = 0, this.retryCount = 0), this.playlistLoaded(C, c, g.details)) : (p = c.deliveryDirectives) !== null && p !== void 0 && p.skip && (_.deltaUpdateFailed = !0);
                }, a.onAudioTrackSwitched = function (h, c) {
                  var p = this.hls.levels[this.currentLevelIndex];

                  if (!!p && p.audioGroupIds) {
                    for (var C = -1, _ = this.hls.audioTracks[c.id].groupId, g = 0; g < p.audioGroupIds.length; g++) if (p.audioGroupIds[g] === _) {
                      C = g;
                      break;
                    }

                    C !== p.urlId && (p.urlId = C, this.startLoad());
                  }
                }, a.loadPlaylist = function (h) {
                  var c = this.currentLevelIndex,
                      p = this._levels[c];

                  if (this.canLoad && p && p.url.length > 0) {
                    var C = p.urlId,
                        _ = p.url[C];
                    if (h) try {
                      _ = h.addDirectives(_);
                    } catch (g) {
                      this.warn("Could not construct new URL with HLS Delivery Directives: " + g);
                    }
                    this.log("Attempt loading level index " + c + (h ? " at sn " + h.msn + " part " + h.part : "") + " with URL-id " + C + " " + _), this.clearTimer(), this.hls.trigger(x.Events.LEVEL_LOADING, {
                      url: _,
                      level: c,
                      id: C,
                      deliveryDirectives: h || null
                    });
                  }
                }, a.removeLevel = function (h, c) {
                  var p = function (g, s) {
                    return s !== c;
                  },
                      C = this._levels.filter(function (_, g) {
                    return g !== h ? !0 : _.url.length > 1 && c !== void 0 ? (_.url = _.url.filter(p), _.audioGroupIds && (_.audioGroupIds = _.audioGroupIds.filter(p)), _.textGroupIds && (_.textGroupIds = _.textGroupIds.filter(p)), _.urlId = 0, !0) : !1;
                  }).map(function (_, g) {
                    var s = _.details;
                    return s != null && s.fragments && s.fragments.forEach(function (o) {
                      o.level = g;
                    }), _;
                  });

                  this._levels = C, this.hls.trigger(x.Events.LEVELS_UPDATED, {
                    levels: C
                  });
                }, P(n, [{
                  key: "levels",
                  get: function () {
                    return this._levels.length === 0 ? null : this._levels;
                  }
                }, {
                  key: "level",
                  get: function () {
                    return this.currentLevelIndex;
                  },
                  set: function (h) {
                    var c,
                        p = this._levels;

                    if (p.length !== 0 && !(this.currentLevelIndex === h && (c = p[h]) !== null && c !== void 0 && c.details)) {
                      if (h < 0 || h >= p.length) {
                        var C = h < 0;
                        if (this.hls.trigger(x.Events.ERROR, {
                          type: k.ErrorTypes.OTHER_ERROR,
                          details: k.ErrorDetails.LEVEL_SWITCH_ERROR,
                          level: h,
                          fatal: C,
                          reason: "invalid level idx"
                        }), C) return;
                        h = Math.min(h, p.length - 1);
                      }

                      this.clearTimer();
                      var _ = this.currentLevelIndex,
                          g = p[_],
                          s = p[h];
                      this.log("switching to level " + h + " from " + _), this.currentLevelIndex = h;
                      var o = E({}, s, {
                        level: h,
                        maxBitrate: s.maxBitrate,
                        uri: s.uri,
                        urlId: s.urlId
                      });
                      delete o._urlId, this.hls.trigger(x.Events.LEVEL_SWITCHING, o);
                      var b = s.details;

                      if (!b || b.live) {
                        var A = this.switchParams(s.uri, g == null ? void 0 : g.details);
                        this.loadPlaylist(A);
                      }
                    }
                  }
                }, {
                  key: "manualLevel",
                  get: function () {
                    return this.manualLevelIndex;
                  },
                  set: function (h) {
                    this.manualLevelIndex = h, this._startLevel === void 0 && (this._startLevel = h), h !== -1 && (this.level = h);
                  }
                }, {
                  key: "firstLevel",
                  get: function () {
                    return this._firstLevel;
                  },
                  set: function (h) {
                    this._firstLevel = h;
                  }
                }, {
                  key: "startLevel",
                  get: function () {
                    if (this._startLevel === void 0) {
                      var h = this.hls.config.startLevel;
                      return h !== void 0 ? h : this._firstLevel;
                    } else return this._startLevel;
                  },
                  set: function (h) {
                    this._startLevel = h;
                  }
                }, {
                  key: "nextLoadLevel",
                  get: function () {
                    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
                  },
                  set: function (h) {
                    this.level = h, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = h);
                  }
                }]), n;
              }(O.default);
            },
            "./src/controller/level-helper.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "addGroupId", function () {
                return k;
              }), R.d(K, "assignTrackIdsByGroup", function () {
                return H;
              }), R.d(K, "updatePTS", function () {
                return w;
              }), R.d(K, "updateFragPTSDTS", function () {
                return D;
              }), R.d(K, "mergeDetails", function () {
                return E;
              }), R.d(K, "mapPartIntersection", function () {
                return L;
              }), R.d(K, "mapFragmentIntersection", function () {
                return P;
              }), R.d(K, "adjustSliding", function () {
                return d;
              }), R.d(K, "addSliding", function () {
                return f;
              }), R.d(K, "computeReloadInterval", function () {
                return y;
              }), R.d(K, "getFragmentWithSN", function () {
                return u;
              }), R.d(K, "getPartWith", function () {
                return i;
              });
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/utils/logger.ts");

              function k(n, a, v) {
                switch (a) {
                  case "audio":
                    n.audioGroupIds || (n.audioGroupIds = []), n.audioGroupIds.push(v);
                    break;

                  case "text":
                    n.textGroupIds || (n.textGroupIds = []), n.textGroupIds.push(v);
                    break;
                }
              }

              function H(n) {
                var a = {};
                n.forEach(function (v) {
                  var h = v.groupId || "";
                  v.id = a[h] = a[h] || 0, a[h]++;
                });
              }

              function w(n, a, v) {
                var h = n[a],
                    c = n[v];
                O(h, c);
              }

              function O(n, a) {
                var v = a.startPTS;

                if (Object(j.isFiniteNumber)(v)) {
                  var h = 0,
                      c;
                  a.sn > n.sn ? (h = v - n.start, c = n) : (h = n.start - v, c = a), c.duration !== h && (c.duration = h);
                } else if (a.sn > n.sn) {
                  var p = n.cc === a.cc;
                  p && n.minEndPTS ? a.start = n.start + (n.minEndPTS - n.start) : a.start = n.start + n.duration;
                } else a.start = Math.max(n.start - a.duration, 0);
              }

              function D(n, a, v, h, c, p) {
                var C = h - v;
                C <= 0 && (x.logger.warn("Fragment should have a positive duration", a), h = v + a.duration, p = c + a.duration);
                var _ = v,
                    g = h,
                    s = a.startPTS,
                    o = a.endPTS;

                if (Object(j.isFiniteNumber)(s)) {
                  var b = Math.abs(s - v);
                  Object(j.isFiniteNumber)(a.deltaPTS) ? a.deltaPTS = Math.max(b, a.deltaPTS) : a.deltaPTS = b, _ = Math.max(v, s), v = Math.min(v, s), c = Math.min(c, a.startDTS), g = Math.min(h, o), h = Math.max(h, o), p = Math.max(p, a.endDTS);
                }

                a.duration = h - v;
                var A = v - a.start;
                a.appendedPTS = h, a.start = a.startPTS = v, a.maxStartPTS = _, a.startDTS = c, a.endPTS = h, a.minEndPTS = g, a.endDTS = p;
                var I = a.sn;
                if (!n || I < n.startSN || I > n.endSN) return 0;
                var M,
                    F = I - n.startSN,
                    B = n.fragments;

                for (B[F] = a, M = F; M > 0; M--) O(B[M], B[M - 1]);

                for (M = F; M < B.length - 1; M++) O(B[M], B[M + 1]);

                return n.fragmentHint && O(B[B.length - 1], n.fragmentHint), n.PTSKnown = n.alignedSliding = !0, A;
              }

              function E(n, a) {
                for (var v = null, h = n.fragments, c = h.length - 1; c >= 0; c--) {
                  var p = h[c].initSegment;

                  if (p) {
                    v = p;
                    break;
                  }
                }

                n.fragmentHint && delete n.fragmentHint.endPTS;

                var C = 0,
                    _;

                if (P(n, a, function (M, F) {
                  M.relurl && (C = M.cc - F.cc), Object(j.isFiniteNumber)(M.startPTS) && Object(j.isFiniteNumber)(M.endPTS) && (F.start = F.startPTS = M.startPTS, F.startDTS = M.startDTS, F.appendedPTS = M.appendedPTS, F.maxStartPTS = M.maxStartPTS, F.endPTS = M.endPTS, F.endDTS = M.endDTS, F.minEndPTS = M.minEndPTS, F.duration = M.endPTS - M.startPTS, F.duration && (_ = F), a.PTSKnown = a.alignedSliding = !0), F.elementaryStreams = M.elementaryStreams, F.loader = M.loader, F.stats = M.stats, F.urlId = M.urlId, M.initSegment && (F.initSegment = M.initSegment, v = M.initSegment);
                }), v) {
                  var g = a.fragmentHint ? a.fragments.concat(a.fragmentHint) : a.fragments;
                  g.forEach(function (M) {
                    var F;
                    (!M.initSegment || M.initSegment.relurl === ((F = v) === null || F === void 0 ? void 0 : F.relurl)) && (M.initSegment = v);
                  });
                }

                if (a.skippedSegments && (a.deltaUpdateFailed = a.fragments.some(function (M) {
                  return !M;
                }), a.deltaUpdateFailed)) {
                  x.logger.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");

                  for (var s = a.skippedSegments; s--;) a.fragments.shift();

                  a.startSN = a.fragments[0].sn, a.startCC = a.fragments[0].cc;
                }

                var o = a.fragments;

                if (C) {
                  x.logger.warn("discontinuity sliding from playlist, take drift into account");

                  for (var b = 0; b < o.length; b++) o[b].cc += C;
                }

                a.skippedSegments && (a.startCC = a.fragments[0].cc), L(n.partList, a.partList, function (M, F) {
                  F.elementaryStreams = M.elementaryStreams, F.stats = M.stats;
                }), _ ? D(a, _, _.startPTS, _.endPTS, _.startDTS, _.endDTS) : d(n, a), o.length && (a.totalduration = a.edge - o[0].start), a.driftStartTime = n.driftStartTime, a.driftStart = n.driftStart;
                var A = a.advancedDateTime;

                if (a.advanced && A) {
                  var I = a.edge;
                  a.driftStart || (a.driftStartTime = A, a.driftStart = I), a.driftEndTime = A, a.driftEnd = I;
                } else a.driftEndTime = n.driftEndTime, a.driftEnd = n.driftEnd, a.advancedDateTime = n.advancedDateTime;
              }

              function L(n, a, v) {
                if (n && a) for (var h = 0, c = 0, p = n.length; c <= p; c++) {
                  var C = n[c],
                      _ = a[c + h];
                  C && _ && C.index === _.index && C.fragment.sn === _.fragment.sn ? v(C, _) : h--;
                }
              }

              function P(n, a, v) {
                for (var h = a.skippedSegments, c = Math.max(n.startSN, a.startSN) - a.startSN, p = (n.fragmentHint ? 1 : 0) + (h ? a.endSN : Math.min(n.endSN, a.endSN)) - a.startSN, C = a.startSN - n.startSN, _ = a.fragmentHint ? a.fragments.concat(a.fragmentHint) : a.fragments, g = n.fragmentHint ? n.fragments.concat(n.fragmentHint) : n.fragments, s = c; s <= p; s++) {
                  var o = g[C + s],
                      b = _[s];
                  h && !b && s < h && (b = a.fragments[s] = o), o && b && v(o, b);
                }
              }

              function d(n, a) {
                var v = a.startSN + a.skippedSegments - n.startSN,
                    h = n.fragments;
                v < 0 || v >= h.length || f(a, h[v].start);
              }

              function f(n, a) {
                if (a) {
                  for (var v = n.fragments, h = n.skippedSegments; h < v.length; h++) v[h].start += a;

                  n.fragmentHint && (n.fragmentHint.start += a);
                }
              }

              function y(n, a) {
                var v = 1e3 * n.levelTargetDuration,
                    h = v / 2,
                    c = n.age,
                    p = c > 0 && c < v * 3,
                    C = a.loading.end - a.loading.start,
                    _,
                    g = n.availabilityDelay;

                if (n.updated === !1) {
                  if (p) {
                    var s = 333 * n.misses;
                    _ = Math.max(Math.min(h, C * 2), s), n.availabilityDelay = (n.availabilityDelay || 0) + _;
                  } else _ = h;
                } else p ? (g = Math.min(g || v / 2, c), n.availabilityDelay = g, _ = g + v - c) : _ = v - C;
                return Math.round(_);
              }

              function u(n, a, v) {
                if (!n || !n.details) return null;
                var h = n.details,
                    c = h.fragments[a - h.startSN];
                return c || (c = h.fragmentHint, c && c.sn === a) ? c : a < h.startSN && v && v.sn === a ? v : null;
              }

              function i(n, a, v) {
                if (!n || !n.details) return null;
                var h = n.details.partList;
                if (h) for (var c = h.length; c--;) {
                  var p = h[c];
                  if (p.index === v && p.fragment.sn === a) return p;
                }
                return null;
              }
            },
            "./src/controller/stream-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return h;
              });
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/controller/base-stream-controller.ts"),
                  k = R("./src/is-supported.ts"),
                  H = R("./src/events.ts"),
                  w = R("./src/utils/buffer-helper.ts"),
                  O = R("./src/controller/fragment-tracker.ts"),
                  D = R("./src/types/loader.ts"),
                  E = R("./src/loader/fragment.ts"),
                  L = R("./src/demux/transmuxer-interface.ts"),
                  P = R("./src/types/transmuxer.ts"),
                  d = R("./src/controller/gap-controller.ts"),
                  f = R("./src/errors.ts"),
                  y = R("./src/utils/logger.ts");

              function u(c, p) {
                for (var C = 0; C < p.length; C++) {
                  var _ = p[C];
                  _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(c, _.key, _);
                }
              }

              function i(c, p, C) {
                return p && u(c.prototype, p), C && u(c, C), c;
              }

              function n(c, p) {
                c.prototype = Object.create(p.prototype), c.prototype.constructor = c, a(c, p);
              }

              function a(c, p) {
                return a = Object.setPrototypeOf || function (_, g) {
                  return _.__proto__ = g, _;
                }, a(c, p);
              }

              var v = 100,
                  h = function (c) {
                n(p, c);

                function p(_, g) {
                  var s;
                  return s = c.call(this, _, g, "[stream-controller]") || this, s.audioCodecSwap = !1, s.gapController = null, s.level = -1, s._forceStartLoad = !1, s.altAudio = !1, s.audioOnly = !1, s.fragPlaying = null, s.onvplaying = null, s.onvseeked = null, s.fragLastKbps = 0, s.stalled = !1, s.couldBacktrack = !1, s.audioCodecSwitch = !1, s.videoBuffer = null, s._registerListeners(), s;
                }

                var C = p.prototype;
                return C._registerListeners = function () {
                  var g = this.hls;
                  g.on(H.Events.MEDIA_ATTACHED, this.onMediaAttached, this), g.on(H.Events.MEDIA_DETACHING, this.onMediaDetaching, this), g.on(H.Events.MANIFEST_LOADING, this.onManifestLoading, this), g.on(H.Events.MANIFEST_PARSED, this.onManifestParsed, this), g.on(H.Events.LEVEL_LOADING, this.onLevelLoading, this), g.on(H.Events.LEVEL_LOADED, this.onLevelLoaded, this), g.on(H.Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), g.on(H.Events.ERROR, this.onError, this), g.on(H.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), g.on(H.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), g.on(H.Events.BUFFER_CREATED, this.onBufferCreated, this), g.on(H.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), g.on(H.Events.LEVELS_UPDATED, this.onLevelsUpdated, this), g.on(H.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                }, C._unregisterListeners = function () {
                  var g = this.hls;
                  g.off(H.Events.MEDIA_ATTACHED, this.onMediaAttached, this), g.off(H.Events.MEDIA_DETACHING, this.onMediaDetaching, this), g.off(H.Events.MANIFEST_LOADING, this.onManifestLoading, this), g.off(H.Events.MANIFEST_PARSED, this.onManifestParsed, this), g.off(H.Events.LEVEL_LOADED, this.onLevelLoaded, this), g.off(H.Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), g.off(H.Events.ERROR, this.onError, this), g.off(H.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), g.off(H.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), g.off(H.Events.BUFFER_CREATED, this.onBufferCreated, this), g.off(H.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), g.off(H.Events.LEVELS_UPDATED, this.onLevelsUpdated, this), g.off(H.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                }, C.onHandlerDestroying = function () {
                  this._unregisterListeners(), this.onMediaDetaching();
                }, C.startLoad = function (g) {
                  if (this.levels) {
                    var s = this.lastCurrentTime,
                        o = this.hls;

                    if (this.stopLoad(), this.setInterval(v), this.level = -1, this.fragLoadError = 0, !this.startFragRequested) {
                      var b = o.startLevel;
                      b === -1 && (o.config.testBandwidth ? (b = 0, this.bitrateTest = !0) : b = o.nextAutoLevel), this.level = o.nextLoadLevel = b, this.loadedmetadata = !1;
                    }

                    s > 0 && g === -1 && (this.log("Override startPosition with lastCurrentTime @" + s.toFixed(3)), g = s), this.state = x.State.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = g, this.tick();
                  } else this._forceStartLoad = !0, this.state = x.State.STOPPED;
                }, C.stopLoad = function () {
                  this._forceStartLoad = !1, c.prototype.stopLoad.call(this);
                }, C.doTick = function () {
                  switch (this.state) {
                    case x.State.IDLE:
                      this.doTickIdle();
                      break;

                    case x.State.WAITING_LEVEL:
                      {
                        var g,
                            s = this.levels,
                            o = this.level,
                            b = s == null || (g = s[o]) === null || g === void 0 ? void 0 : g.details;

                        if (b && (!b.live || this.levelLastLoaded === this.level)) {
                          if (this.waitForCdnTuneIn(b)) break;
                          this.state = x.State.IDLE;
                          break;
                        }

                        break;
                      }

                    case x.State.FRAG_LOADING_WAITING_RETRY:
                      {
                        var A,
                            I = self.performance.now(),
                            M = this.retryDate;
                        (!M || I >= M || (A = this.media) !== null && A !== void 0 && A.seeking) && (this.log("retryDate reached, switch back to IDLE state"), this.state = x.State.IDLE);
                      }
                      break;

                    default:
                      break;
                  }

                  this.onTickEnd();
                }, C.onTickEnd = function () {
                  c.prototype.onTickEnd.call(this), this.checkBuffer(), this.checkFragmentChanged();
                }, C.doTickIdle = function () {
                  var g,
                      s,
                      o = this.hls,
                      b = this.levelLastLoaded,
                      A = this.levels,
                      I = this.media,
                      M = o.config,
                      F = o.nextLoadLevel;

                  if (!(b === null || !I && (this.startFragRequested || !M.startFragPrefetch)) && !(this.altAudio && this.audioOnly) && !(!A || !A[F])) {
                    var B = A[F];
                    this.level = o.nextLoadLevel = F;
                    var U = B.details;

                    if (!U || this.state === x.State.WAITING_LEVEL || U.live && this.levelLastLoaded !== F) {
                      this.state = x.State.WAITING_LEVEL;
                      return;
                    }

                    var W = this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : I, D.PlaylistLevelType.MAIN);

                    if (W !== null) {
                      var G = W.len,
                          V = this.getMaxBufferLength(B.maxBitrate);

                      if (!(G >= V)) {
                        if (this._streamEnded(W, U)) {
                          var Y = {};
                          this.altAudio && (Y.type = "video"), this.hls.trigger(H.Events.BUFFER_EOS, Y), this.state = x.State.ENDED;
                          return;
                        }

                        var $ = W.end,
                            q = this.getNextFragment($, U);

                        if (this.couldBacktrack && !this.fragPrevious && q && q.sn !== "initSegment") {
                          var Z = q.sn - U.startSN;
                          Z > 1 && (q = U.fragments[Z - 1], this.fragmentTracker.removeFragment(q));
                        }

                        if (q && this.fragmentTracker.getState(q) === O.FragmentState.OK && this.nextLoadPosition > $) {
                          var te = this.audioOnly && !this.altAudio ? E.ElementaryStreamTypes.AUDIO : E.ElementaryStreamTypes.VIDEO;
                          this.afterBufferFlushed(I, te, D.PlaylistLevelType.MAIN), q = this.getNextFragment(this.nextLoadPosition, U);
                        }

                        !q || (q.initSegment && !q.initSegment.data && !this.bitrateTest && (q = q.initSegment), ((g = q.decryptdata) === null || g === void 0 ? void 0 : g.keyFormat) === "identity" && !((s = q.decryptdata) !== null && s !== void 0 && s.key) ? this.loadKey(q, U) : this.loadFragment(q, U, $));
                      }
                    }
                  }
                }, C.loadFragment = function (g, s, o) {
                  var b,
                      A = this.fragmentTracker.getState(g);

                  if (this.fragCurrent = g, A === O.FragmentState.BACKTRACKED) {
                    var I = this.fragmentTracker.getBacktrackData(g);

                    if (I) {
                      this._handleFragmentLoadProgress(I), this._handleFragmentLoadComplete(I);
                      return;
                    } else A = O.FragmentState.NOT_LOADED;
                  }

                  A === O.FragmentState.NOT_LOADED || A === O.FragmentState.PARTIAL ? g.sn === "initSegment" ? this._loadInitSegment(g) : this.bitrateTest ? (g.bitrateTest = !0, this.log("Fragment " + g.sn + " of level " + g.level + " is being downloaded to test bitrate and will not be buffered"), this._loadBitrateTestFrag(g)) : (this.startFragRequested = !0, c.prototype.loadFragment.call(this, g, s, o)) : A === O.FragmentState.APPENDING ? this.reduceMaxBufferLength(g.duration) && this.fragmentTracker.removeFragment(g) : ((b = this.media) === null || b === void 0 ? void 0 : b.buffered.length) === 0 && this.fragmentTracker.removeAllFragments();
                }, C.getAppendedFrag = function (g) {
                  var s = this.fragmentTracker.getAppendedFrag(g, D.PlaylistLevelType.MAIN);
                  return s && "fragment" in s ? s.fragment : s;
                }, C.getBufferedFrag = function (g) {
                  return this.fragmentTracker.getBufferedFrag(g, D.PlaylistLevelType.MAIN);
                }, C.followingBufferedFrag = function (g) {
                  return g ? this.getBufferedFrag(g.end + .5) : null;
                }, C.immediateLevelSwitch = function () {
                  this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                }, C.nextLevelSwitch = function () {
                  var g = this.levels,
                      s = this.media;

                  if (s != null && s.readyState) {
                    var o,
                        b = this.getAppendedFrag(s.currentTime);

                    if (b && b.start > 1 && this.flushMainBuffer(0, b.start - 1), !s.paused && g) {
                      var A = this.hls.nextLoadLevel,
                          I = g[A],
                          M = this.fragLastKbps;
                      M && this.fragCurrent ? o = this.fragCurrent.duration * I.maxBitrate / (1e3 * M) + 1 : o = 0;
                    } else o = 0;

                    var F = this.getBufferedFrag(s.currentTime + o);

                    if (F) {
                      var B = this.followingBufferedFrag(F);

                      if (B) {
                        this.abortCurrentFrag();
                        var U = B.maxStartPTS ? B.maxStartPTS : B.start,
                            W = B.duration,
                            G = Math.max(F.end, U + Math.min(Math.max(W - this.config.maxFragLookUpTolerance, W * .5), W * .75));
                        this.flushMainBuffer(G, Number.POSITIVE_INFINITY);
                      }
                    }
                  }
                }, C.abortCurrentFrag = function () {
                  var g = this.fragCurrent;
                  this.fragCurrent = null, g != null && g.loader && g.loader.abort(), this.state === x.State.KEY_LOADING && (this.state = x.State.IDLE), this.nextLoadPosition = this.getLoadPosition();
                }, C.flushMainBuffer = function (g, s) {
                  c.prototype.flushMainBuffer.call(this, g, s, this.altAudio ? "video" : null);
                }, C.onMediaAttached = function (g, s) {
                  c.prototype.onMediaAttached.call(this, g, s);
                  var o = s.media;
                  this.onvplaying = this.onMediaPlaying.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), o.addEventListener("playing", this.onvplaying), o.addEventListener("seeked", this.onvseeked), this.gapController = new d.default(this.config, o, this.fragmentTracker, this.hls);
                }, C.onMediaDetaching = function () {
                  var g = this.media;
                  g && (g.removeEventListener("playing", this.onvplaying), g.removeEventListener("seeked", this.onvseeked), this.onvplaying = this.onvseeked = null, this.videoBuffer = null), this.fragPlaying = null, this.gapController && (this.gapController.destroy(), this.gapController = null), c.prototype.onMediaDetaching.call(this);
                }, C.onMediaPlaying = function () {
                  this.tick();
                }, C.onMediaSeeked = function () {
                  var g = this.media,
                      s = g ? g.currentTime : null;
                  Object(j.isFiniteNumber)(s) && this.log("Media seeked to " + s.toFixed(3)), this.tick();
                }, C.onManifestLoading = function () {
                  this.log("Trigger BUFFER_RESET"), this.hls.trigger(H.Events.BUFFER_RESET, void 0), this.fragmentTracker.removeAllFragments(), this.couldBacktrack = this.stalled = !1, this.startPosition = this.lastCurrentTime = 0, this.fragPlaying = null;
                }, C.onManifestParsed = function (g, s) {
                  var o = !1,
                      b = !1,
                      A;
                  s.levels.forEach(function (I) {
                    A = I.audioCodec, A && (A.indexOf("mp4a.40.2") !== -1 && (o = !0), A.indexOf("mp4a.40.5") !== -1 && (b = !0));
                  }), this.audioCodecSwitch = o && b && !Object(k.changeTypeSupported)(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = s.levels, this.startFragRequested = !1;
                }, C.onLevelLoading = function (g, s) {
                  var o = this.levels;

                  if (!(!o || this.state !== x.State.IDLE)) {
                    var b = o[s.level];
                    (!b.details || b.details.live && this.levelLastLoaded !== s.level || this.waitForCdnTuneIn(b.details)) && (this.state = x.State.WAITING_LEVEL);
                  }
                }, C.onLevelLoaded = function (g, s) {
                  var o,
                      b = this.levels,
                      A = s.level,
                      I = s.details,
                      M = I.totalduration;

                  if (!b) {
                    this.warn("Levels were reset while loading level " + A);
                    return;
                  }

                  this.log("Level " + A + " loaded [" + I.startSN + "," + I.endSN + "], cc [" + I.startCC + ", " + I.endCC + "] duration:" + M);
                  var F = this.fragCurrent;
                  F && (this.state === x.State.FRAG_LOADING || this.state === x.State.FRAG_LOADING_WAITING_RETRY) && F.level !== s.level && F.loader && (this.state = x.State.IDLE, F.loader.abort());
                  var B = b[A],
                      U = 0;

                  if (I.live || (o = B.details) !== null && o !== void 0 && o.live) {
                    if (I.fragments[0] || (I.deltaUpdateFailed = !0), I.deltaUpdateFailed) return;
                    U = this.alignPlaylists(I, B.details);
                  }

                  if (B.details = I, this.levelLastLoaded = A, this.hls.trigger(H.Events.LEVEL_UPDATED, {
                    details: I,
                    level: A
                  }), this.state === x.State.WAITING_LEVEL) {
                    if (this.waitForCdnTuneIn(I)) return;
                    this.state = x.State.IDLE;
                  }

                  this.startFragRequested ? I.live && this.synchronizeToLiveEdge(I) : this.setStartPosition(I, U), this.tick();
                }, C._handleFragmentLoadProgress = function (g) {
                  var s,
                      o = g.frag,
                      b = g.part,
                      A = g.payload,
                      I = this.levels;

                  if (!I) {
                    this.warn("Levels were reset while fragment load was in progress. Fragment " + o.sn + " of level " + o.level + " will not be buffered");
                    return;
                  }

                  var M = I[o.level],
                      F = M.details;

                  if (!F) {
                    this.warn("Dropping fragment " + o.sn + " of level " + o.level + " after level details were reset");
                    return;
                  }

                  var B = M.videoCodec,
                      U = F.PTSKnown || !F.live,
                      W = (s = o.initSegment) === null || s === void 0 ? void 0 : s.data,
                      G = this._getAudioCodec(M),
                      V = this.transmuxer = this.transmuxer || new L.default(this.hls, D.PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)),
                      Y = b ? b.index : -1,
                      $ = Y !== -1,
                      q = new P.ChunkMetadata(o.level, o.sn, o.stats.chunkCount, A.byteLength, Y, $),
                      Z = this.initPTS[o.cc];

                  V.push(A, W, G, B, o, b, F.totalduration, U, q, Z);
                }, C.onAudioTrackSwitching = function (g, s) {
                  var o = this.altAudio,
                      b = !!s.url,
                      A = s.id;

                  if (!b) {
                    if (this.mediaBuffer !== this.media) {
                      this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
                      var I = this.fragCurrent;
                      I != null && I.loader && (this.log("Switching to main audio track, cancel main fragment load"), I.loader.abort()), this.resetTransmuxer(), this.resetLoadingState();
                    } else this.audioOnly && this.resetTransmuxer();

                    var M = this.hls;
                    o && M.trigger(H.Events.BUFFER_FLUSHING, {
                      startOffset: 0,
                      endOffset: Number.POSITIVE_INFINITY,
                      type: "audio"
                    }), M.trigger(H.Events.AUDIO_TRACK_SWITCHED, {
                      id: A
                    });
                  }
                }, C.onAudioTrackSwitched = function (g, s) {
                  var o = s.id,
                      b = !!this.hls.audioTracks[o].url;

                  if (b) {
                    var A = this.videoBuffer;
                    A && this.mediaBuffer !== A && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = A);
                  }

                  this.altAudio = b, this.tick();
                }, C.onBufferCreated = function (g, s) {
                  var o = s.tracks,
                      b,
                      A,
                      I = !1;

                  for (var M in o) {
                    var F = o[M];

                    if (F.id === "main") {
                      if (A = M, b = F, M === "video") {
                        var B = o[M];
                        B && (this.videoBuffer = B.buffer);
                      }
                    } else I = !0;
                  }

                  I && b ? (this.log("Alternate track found, use " + A + ".buffered to schedule main fragment loading"), this.mediaBuffer = b.buffer) : this.mediaBuffer = this.media;
                }, C.onFragBuffered = function (g, s) {
                  var o = s.frag,
                      b = s.part;

                  if (!(o && o.type !== D.PlaylistLevelType.MAIN)) {
                    if (this.fragContextChanged(o)) {
                      this.warn("Fragment " + o.sn + (b ? " p: " + b.index : "") + " of level " + o.level + " finished buffering, but was aborted. state: " + this.state), this.state === x.State.PARSED && (this.state = x.State.IDLE);
                      return;
                    }

                    var A = b ? b.stats : o.stats;
                    this.fragLastKbps = Math.round(8 * A.total / (A.buffering.end - A.loading.first)), o.sn !== "initSegment" && (this.fragPrevious = o), this.fragBufferedComplete(o, b);
                  }
                }, C.onError = function (g, s) {
                  switch (s.details) {
                    case f.ErrorDetails.FRAG_LOAD_ERROR:
                    case f.ErrorDetails.FRAG_LOAD_TIMEOUT:
                    case f.ErrorDetails.KEY_LOAD_ERROR:
                    case f.ErrorDetails.KEY_LOAD_TIMEOUT:
                      this.onFragmentOrKeyLoadError(D.PlaylistLevelType.MAIN, s);
                      break;

                    case f.ErrorDetails.LEVEL_LOAD_ERROR:
                    case f.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                      this.state !== x.State.ERROR && (s.fatal ? (this.warn("" + s.details), this.state = x.State.ERROR) : !s.levelRetry && this.state === x.State.WAITING_LEVEL && (this.state = x.State.IDLE));
                      break;

                    case f.ErrorDetails.BUFFER_FULL_ERROR:
                      if (s.parent === "main" && (this.state === x.State.PARSING || this.state === x.State.PARSED)) {
                        var o = !0,
                            b = this.getFwdBufferInfo(this.media, D.PlaylistLevelType.MAIN);
                        b && b.len > .5 && (o = !this.reduceMaxBufferLength(b.len)), o && (this.warn("buffer full error also media.currentTime is not buffered, flush main"), this.immediateLevelSwitch()), this.resetLoadingState();
                      }

                      break;

                    default:
                      break;
                  }
                }, C.checkBuffer = function () {
                  var g = this.media,
                      s = this.gapController;

                  if (!(!g || !s || !g.readyState)) {
                    var o = w.BufferHelper.getBuffered(g);
                    !this.loadedmetadata && o.length ? (this.loadedmetadata = !0, this.seekToStartPos()) : s.poll(this.lastCurrentTime), this.lastCurrentTime = g.currentTime;
                  }
                }, C.onFragLoadEmergencyAborted = function () {
                  this.state = x.State.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tickImmediate();
                }, C.onBufferFlushed = function (g, s) {
                  var o = s.type;

                  if (o !== E.ElementaryStreamTypes.AUDIO || this.audioOnly && !this.altAudio) {
                    var b = (o === E.ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
                    this.afterBufferFlushed(b, o, D.PlaylistLevelType.MAIN);
                  }
                }, C.onLevelsUpdated = function (g, s) {
                  this.levels = s.levels;
                }, C.swapAudioCodec = function () {
                  this.audioCodecSwap = !this.audioCodecSwap;
                }, C.seekToStartPos = function () {
                  var g = this.media,
                      s = g.currentTime,
                      o = this.startPosition;

                  if (o >= 0 && s < o) {
                    if (g.seeking) {
                      y.logger.log("could not seek to " + o + ", already seeking at " + s);
                      return;
                    }

                    var b = w.BufferHelper.getBuffered(g),
                        A = b.length ? b.start(0) : 0,
                        I = A - o;
                    I > 0 && (I < this.config.maxBufferHole || I < this.config.maxFragLookUpTolerance) && (y.logger.log("adjusting start position by " + I + " to match buffer start"), o += I, this.startPosition = o), this.log("seek to target start position " + o + " from current time " + s), g.currentTime = o;
                  }
                }, C._getAudioCodec = function (g) {
                  var s = this.config.defaultAudioCodec || g.audioCodec;
                  return this.audioCodecSwap && s && (this.log("Swapping audio codec"), s.indexOf("mp4a.40.5") !== -1 ? s = "mp4a.40.2" : s = "mp4a.40.5"), s;
                }, C._loadBitrateTestFrag = function (g) {
                  var s = this;

                  this._doFragLoad(g).then(function (o) {
                    var b = s.hls;

                    if (!(!o || b.nextLoadLevel || s.fragContextChanged(g))) {
                      s.fragLoadError = 0, s.state = x.State.IDLE, s.startFragRequested = !1, s.bitrateTest = !1;
                      var A = g.stats;
                      A.parsing.start = A.parsing.end = A.buffering.start = A.buffering.end = self.performance.now(), b.trigger(H.Events.FRAG_LOADED, o);
                    }
                  });
                }, C._handleTransmuxComplete = function (g) {
                  var s,
                      o = "main",
                      b = this.hls,
                      A = g.remuxResult,
                      I = g.chunkMeta,
                      M = this.getCurrentContext(I);

                  if (!M) {
                    this.warn("The loading context changed while buffering fragment " + I.sn + " of level " + I.level + ". This chunk will not be buffered."), this.resetLiveStartWhenNotLoaded(I.level);
                    return;
                  }

                  var F = M.frag,
                      B = M.part,
                      U = M.level,
                      W = A.video,
                      G = A.text,
                      V = A.id3,
                      Y = A.initSegment,
                      $ = this.altAudio ? void 0 : A.audio;

                  if (!this.fragContextChanged(F)) {
                    if (this.state = x.State.PARSING, Y) {
                      Y.tracks && (this._bufferInitSegment(U, Y.tracks, F, I), b.trigger(H.Events.FRAG_PARSING_INIT_SEGMENT, {
                        frag: F,
                        id: o,
                        tracks: Y.tracks
                      }));
                      var q = Y.initPTS,
                          Z = Y.timescale;
                      Object(j.isFiniteNumber)(q) && (this.initPTS[F.cc] = q, b.trigger(H.Events.INIT_PTS_FOUND, {
                        frag: F,
                        id: o,
                        initPTS: q,
                        timescale: Z
                      }));
                    }

                    if (W && A.independent !== !1) {
                      if (U.details) {
                        var te = W.startPTS,
                            se = W.endPTS,
                            ge = W.startDTS,
                            he = W.endDTS;
                        if (B) B.elementaryStreams[W.type] = {
                          startPTS: te,
                          endPTS: se,
                          startDTS: ge,
                          endDTS: he
                        };else if (W.firstKeyFrame && W.independent && (this.couldBacktrack = !0), W.dropped && W.independent) {
                          var ye = this.getLoadPosition() + this.config.maxBufferHole;

                          if (ye < te) {
                            this.backtrack(F);
                            return;
                          }

                          F.setElementaryStreamInfo(W.type, F.start, se, F.start, he, !0);
                        }
                        F.setElementaryStreamInfo(W.type, te, se, ge, he), this.bufferFragmentData(W, F, B, I);
                      }
                    } else if (A.independent === !1) {
                      this.backtrack(F);
                      return;
                    }

                    if ($) {
                      var pe = $.startPTS,
                          _e = $.endPTS,
                          be = $.startDTS,
                          Le = $.endDTS;
                      B && (B.elementaryStreams[E.ElementaryStreamTypes.AUDIO] = {
                        startPTS: pe,
                        endPTS: _e,
                        startDTS: be,
                        endDTS: Le
                      }), F.setElementaryStreamInfo(E.ElementaryStreamTypes.AUDIO, pe, _e, be, Le), this.bufferFragmentData($, F, B, I);
                    }

                    if (V != null && (s = V.samples) !== null && s !== void 0 && s.length) {
                      var we = {
                        frag: F,
                        id: o,
                        samples: V.samples
                      };
                      b.trigger(H.Events.FRAG_PARSING_METADATA, we);
                    }

                    if (G) {
                      var xe = {
                        frag: F,
                        id: o,
                        samples: G.samples
                      };
                      b.trigger(H.Events.FRAG_PARSING_USERDATA, xe);
                    }
                  }
                }, C._bufferInitSegment = function (g, s, o, b) {
                  var A = this;

                  if (this.state === x.State.PARSING) {
                    this.audioOnly = !!s.audio && !s.video, this.altAudio && !this.audioOnly && delete s.audio;
                    var I = s.audio,
                        M = s.video,
                        F = s.audiovideo;

                    if (I) {
                      var B = g.audioCodec,
                          U = navigator.userAgent.toLowerCase();
                      this.audioCodecSwitch && (B && (B.indexOf("mp4a.40.5") !== -1 ? B = "mp4a.40.2" : B = "mp4a.40.5"), I.metadata.channelCount !== 1 && U.indexOf("firefox") === -1 && (B = "mp4a.40.5")), U.indexOf("android") !== -1 && I.container !== "audio/mpeg" && (B = "mp4a.40.2", this.log("Android: force audio codec to " + B)), g.audioCodec && g.audioCodec !== B && this.log('Swapping manifest audio codec "' + g.audioCodec + '" for "' + B + '"'), I.levelCodec = B, I.id = "main", this.log("Init audio buffer, container:" + I.container + ", codecs[selected/level/parsed]=[" + (B || "") + "/" + (g.audioCodec || "") + "/" + I.codec + "]");
                    }

                    M && (M.levelCodec = g.videoCodec, M.id = "main", this.log("Init video buffer, container:" + M.container + ", codecs[level/parsed]=[" + (g.videoCodec || "") + "/" + M.codec + "]")), F && this.log("Init audiovideo buffer, container:" + F.container + ", codecs[level/parsed]=[" + (g.attrs.CODECS || "") + "/" + F.codec + "]"), this.hls.trigger(H.Events.BUFFER_CODECS, s), Object.keys(s).forEach(function (W) {
                      var G = s[W],
                          V = G.initSegment;
                      V != null && V.byteLength && A.hls.trigger(H.Events.BUFFER_APPENDING, {
                        type: W,
                        data: V,
                        frag: o,
                        part: null,
                        chunkMeta: b,
                        parent: o.type
                      });
                    }), this.tick();
                  }
                }, C.backtrack = function (g) {
                  this.couldBacktrack = !0, this.resetTransmuxer(), this.flushBufferGap(g);
                  var s = this.fragmentTracker.backtrack(g);
                  this.fragPrevious = null, this.nextLoadPosition = g.start, s ? this.resetFragmentLoading(g) : this.state = x.State.BACKTRACKING;
                }, C.checkFragmentChanged = function () {
                  var g = this.media,
                      s = null;

                  if (g && g.readyState > 1 && g.seeking === !1) {
                    var o = g.currentTime;

                    if (w.BufferHelper.isBuffered(g, o) ? s = this.getAppendedFrag(o) : w.BufferHelper.isBuffered(g, o + .1) && (s = this.getAppendedFrag(o + .1)), s) {
                      var b = this.fragPlaying,
                          A = s.level;
                      (!b || s.sn !== b.sn || b.level !== A || s.urlId !== b.urlId) && (this.hls.trigger(H.Events.FRAG_CHANGED, {
                        frag: s
                      }), (!b || b.level !== A) && this.hls.trigger(H.Events.LEVEL_SWITCHED, {
                        level: A
                      }), this.fragPlaying = s);
                    }
                  }
                }, i(p, [{
                  key: "nextLevel",
                  get: function () {
                    var g = this.nextBufferedFrag;
                    return g ? g.level : -1;
                  }
                }, {
                  key: "currentLevel",
                  get: function () {
                    var g = this.media;

                    if (g) {
                      var s = this.getAppendedFrag(g.currentTime);
                      if (s) return s.level;
                    }

                    return -1;
                  }
                }, {
                  key: "nextBufferedFrag",
                  get: function () {
                    var g = this.media;

                    if (g) {
                      var s = this.getAppendedFrag(g.currentTime);
                      return this.followingBufferedFrag(s);
                    } else return null;
                  }
                }, {
                  key: "forceStartLoad",
                  get: function () {
                    return this._forceStartLoad;
                  }
                }]), p;
              }(x.default);
            },
            "./src/controller/subtitle-stream-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "SubtitleStreamController", function () {
                return i;
              });
              var j = R("./src/events.ts"),
                  x = R("./src/utils/buffer-helper.ts"),
                  k = R("./src/controller/fragment-finders.ts"),
                  H = R("./src/utils/discontinuities.ts"),
                  w = R("./src/controller/level-helper.ts"),
                  O = R("./src/controller/fragment-tracker.ts"),
                  D = R("./src/controller/base-stream-controller.ts"),
                  E = R("./src/types/loader.ts"),
                  L = R("./src/types/level.ts");

              function P(n, a) {
                for (var v = 0; v < a.length; v++) {
                  var h = a[v];
                  h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(n, h.key, h);
                }
              }

              function d(n, a, v) {
                return a && P(n.prototype, a), v && P(n, v), n;
              }

              function f(n, a) {
                n.prototype = Object.create(a.prototype), n.prototype.constructor = n, y(n, a);
              }

              function y(n, a) {
                return y = Object.setPrototypeOf || function (h, c) {
                  return h.__proto__ = c, h;
                }, y(n, a);
              }

              var u = 500,
                  i = function (n) {
                f(a, n);

                function a(h, c) {
                  var p;
                  return p = n.call(this, h, c, "[subtitle-stream-controller]") || this, p.levels = [], p.currentTrackId = -1, p.tracksBuffered = [], p.mainDetails = null, p._registerListeners(), p;
                }

                var v = a.prototype;
                return v.onHandlerDestroying = function () {
                  this._unregisterListeners(), this.mainDetails = null;
                }, v._registerListeners = function () {
                  var c = this.hls;
                  c.on(j.Events.MEDIA_ATTACHED, this.onMediaAttached, this), c.on(j.Events.MEDIA_DETACHING, this.onMediaDetaching, this), c.on(j.Events.MANIFEST_LOADING, this.onManifestLoading, this), c.on(j.Events.LEVEL_LOADED, this.onLevelLoaded, this), c.on(j.Events.ERROR, this.onError, this), c.on(j.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), c.on(j.Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), c.on(j.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), c.on(j.Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), c.on(j.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                }, v._unregisterListeners = function () {
                  var c = this.hls;
                  c.off(j.Events.MEDIA_ATTACHED, this.onMediaAttached, this), c.off(j.Events.MEDIA_DETACHING, this.onMediaDetaching, this), c.off(j.Events.MANIFEST_LOADING, this.onManifestLoading, this), c.off(j.Events.LEVEL_LOADED, this.onLevelLoaded, this), c.off(j.Events.ERROR, this.onError, this), c.off(j.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), c.off(j.Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), c.off(j.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), c.off(j.Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), c.off(j.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                }, v.startLoad = function () {
                  this.stopLoad(), this.state = D.State.IDLE, this.setInterval(u), this.tick();
                }, v.onManifestLoading = function () {
                  this.mainDetails = null, this.fragmentTracker.removeAllFragments();
                }, v.onLevelLoaded = function (c, p) {
                  this.mainDetails = p.details;
                }, v.onSubtitleFragProcessed = function (c, p) {
                  var C = p.frag,
                      _ = p.success;

                  if (this.fragPrevious = C, this.state = D.State.IDLE, !!_) {
                    var g = this.tracksBuffered[this.currentTrackId];

                    if (!!g) {
                      for (var s, o = C.start, b = 0; b < g.length; b++) if (o >= g[b].start && o <= g[b].end) {
                        s = g[b];
                        break;
                      }

                      var A = C.start + C.duration;
                      s ? s.end = A : (s = {
                        start: o,
                        end: A
                      }, g.push(s)), this.fragmentTracker.fragBuffered(C);
                    }
                  }
                }, v.onBufferFlushing = function (c, p) {
                  var C = p.startOffset,
                      _ = p.endOffset;

                  if (C === 0 && _ !== Number.POSITIVE_INFINITY) {
                    var g = this.currentTrackId,
                        s = this.levels;
                    if (!s.length || !s[g] || !s[g].details) return;
                    var o = s[g].details,
                        b = o.targetduration,
                        A = _ - b;
                    if (A <= 0) return;
                    p.endOffsetSubtitles = Math.max(0, A), this.tracksBuffered.forEach(function (I) {
                      for (var M = 0; M < I.length;) {
                        if (I[M].end <= A) {
                          I.shift();
                          continue;
                        } else if (I[M].start < A) I[M].start = A;else break;

                        M++;
                      }
                    }), this.fragmentTracker.removeFragmentsInRange(C, A, E.PlaylistLevelType.SUBTITLE);
                  }
                }, v.onError = function (c, p) {
                  var C,
                      _ = p.frag;
                  !_ || _.type !== E.PlaylistLevelType.SUBTITLE || ((C = this.fragCurrent) !== null && C !== void 0 && C.loader && this.fragCurrent.loader.abort(), this.state = D.State.IDLE);
                }, v.onSubtitleTracksUpdated = function (c, p) {
                  var C = this,
                      _ = p.subtitleTracks;
                  this.tracksBuffered = [], this.levels = _.map(function (g) {
                    return new L.Level(g);
                  }), this.fragmentTracker.removeAllFragments(), this.fragPrevious = null, this.levels.forEach(function (g) {
                    C.tracksBuffered[g.id] = [];
                  }), this.mediaBuffer = null;
                }, v.onSubtitleTrackSwitch = function (c, p) {
                  if (this.currentTrackId = p.id, !this.levels.length || this.currentTrackId === -1) {
                    this.clearInterval();
                    return;
                  }

                  var C = this.levels[this.currentTrackId];
                  C != null && C.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, C && this.setInterval(u);
                }, v.onSubtitleTrackLoaded = function (c, p) {
                  var C,
                      _ = p.details,
                      g = p.id,
                      s = this.currentTrackId,
                      o = this.levels;

                  if (!!o.length) {
                    var b = o[s];

                    if (!(g >= o.length || g !== s || !b)) {
                      if (this.mediaBuffer = this.mediaBufferTimeRanges, _.live || (C = b.details) !== null && C !== void 0 && C.live) {
                        var A = this.mainDetails;
                        if (_.deltaUpdateFailed || !A) return;
                        var I = A.fragments[0];
                        if (!b.details) _.hasProgramDateTime && A.hasProgramDateTime ? Object(H.alignMediaPlaylistByPDT)(_, A) : I && Object(w.addSliding)(_, I.start);else {
                          var M = this.alignPlaylists(_, b.details);
                          M === 0 && I && Object(w.addSliding)(_, I.start);
                        }
                      }

                      if (b.details = _, this.levelLastLoaded = g, this.tick(), _.live && !this.fragCurrent && this.media && this.state === D.State.IDLE) {
                        var F = Object(k.findFragmentByPTS)(null, _.fragments, this.media.currentTime, 0);
                        F || (this.warn("Subtitle playlist not aligned with playback"), b.details = void 0);
                      }
                    }
                  }
                }, v._handleFragmentLoadComplete = function (c) {
                  var p = c.frag,
                      C = c.payload,
                      _ = p.decryptdata,
                      g = this.hls;

                  if (!this.fragContextChanged(p) && C && C.byteLength > 0 && _ && _.key && _.iv && _.method === "AES-128") {
                    var s = performance.now();
                    this.decrypter.webCryptoDecrypt(new Uint8Array(C), _.key.buffer, _.iv.buffer).then(function (o) {
                      var b = performance.now();
                      g.trigger(j.Events.FRAG_DECRYPTED, {
                        frag: p,
                        payload: o,
                        stats: {
                          tstart: s,
                          tdecrypt: b
                        }
                      });
                    });
                  }
                }, v.doTick = function () {
                  if (!this.media) {
                    this.state = D.State.IDLE;
                    return;
                  }

                  if (this.state === D.State.IDLE) {
                    var c,
                        p = this.currentTrackId,
                        C = this.levels;
                    if (!C.length || !C[p] || !C[p].details) return;
                    var _ = C[p].details,
                        g = _.targetduration,
                        s = this.config,
                        o = this.media,
                        b = x.BufferHelper.bufferedInfo(this.mediaBufferTimeRanges, o.currentTime - g, s.maxBufferHole),
                        A = b.end,
                        I = b.len,
                        M = this.getMaxBufferLength() + g;
                    if (I > M) return;
                    console.assert(_, "Subtitle track details are defined on idle subtitle stream controller tick");
                    var F = _.fragments,
                        B = F.length,
                        U = _.edge,
                        W,
                        G = this.fragPrevious;

                    if (A < U) {
                      var V = s.maxFragLookUpTolerance;
                      W = Object(k.findFragmentByPTS)(G, F, A, V), !W && G && G.start < F[0].start && (W = F[0]);
                    } else W = F[B - 1];

                    (c = W) !== null && c !== void 0 && c.encrypted ? this.loadKey(W, _) : W && this.fragmentTracker.getState(W) === O.FragmentState.NOT_LOADED && this.loadFragment(W, _, A);
                  }
                }, v.loadFragment = function (c, p, C) {
                  this.fragCurrent = c, n.prototype.loadFragment.call(this, c, p, C);
                }, d(a, [{
                  key: "mediaBufferTimeRanges",
                  get: function () {
                    return this.tracksBuffered[this.currentTrackId] || [];
                  }
                }]), a;
              }(D.default);
            },
            "./src/controller/subtitle-track-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = R("./src/events.ts"),
                  x = R("./src/utils/texttrack-utils.ts"),
                  k = R("./src/controller/base-playlist-controller.ts"),
                  H = R("./src/types/loader.ts");

              function w(d, f) {
                for (var y = 0; y < f.length; y++) {
                  var u = f[y];
                  u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(d, u.key, u);
                }
              }

              function O(d, f, y) {
                return f && w(d.prototype, f), y && w(d, y), d;
              }

              function D(d, f) {
                d.prototype = Object.create(f.prototype), d.prototype.constructor = d, E(d, f);
              }

              function E(d, f) {
                return E = Object.setPrototypeOf || function (u, i) {
                  return u.__proto__ = i, u;
                }, E(d, f);
              }

              var L = function (d) {
                D(f, d);

                function f(u) {
                  var i;
                  return i = d.call(this, u, "[subtitle-track-controller]") || this, i.media = null, i.tracks = [], i.groupId = null, i.tracksInGroup = [], i.trackId = -1, i.selectDefaultTrack = !0, i.queuedDefaultTrack = -1, i.trackChangeListener = function () {
                    return i.onTextTracksChanged();
                  }, i.asyncPollTrackChange = function () {
                    return i.pollTrackChange(0);
                  }, i.useTextTrackPolling = !1, i.subtitlePollingInterval = -1, i.subtitleDisplay = !0, i.registerListeners(), i;
                }

                var y = f.prototype;
                return y.destroy = function () {
                  this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.trackChangeListener = this.asyncPollTrackChange = null, d.prototype.destroy.call(this);
                }, y.registerListeners = function () {
                  var i = this.hls;
                  i.on(j.Events.MEDIA_ATTACHED, this.onMediaAttached, this), i.on(j.Events.MEDIA_DETACHING, this.onMediaDetaching, this), i.on(j.Events.MANIFEST_LOADING, this.onManifestLoading, this), i.on(j.Events.MANIFEST_PARSED, this.onManifestParsed, this), i.on(j.Events.LEVEL_LOADING, this.onLevelLoading, this), i.on(j.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), i.on(j.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), i.on(j.Events.ERROR, this.onError, this);
                }, y.unregisterListeners = function () {
                  var i = this.hls;
                  i.off(j.Events.MEDIA_ATTACHED, this.onMediaAttached, this), i.off(j.Events.MEDIA_DETACHING, this.onMediaDetaching, this), i.off(j.Events.MANIFEST_LOADING, this.onManifestLoading, this), i.off(j.Events.MANIFEST_PARSED, this.onManifestParsed, this), i.off(j.Events.LEVEL_LOADING, this.onLevelLoading, this), i.off(j.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), i.off(j.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), i.off(j.Events.ERROR, this.onError, this);
                }, y.onMediaAttached = function (i, n) {
                  this.media = n.media, !!this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
                }, y.pollTrackChange = function (i) {
                  self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.trackChangeListener, i);
                }, y.onMediaDetaching = function () {
                  if (!!this.media) {
                    self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId);
                    var i = P(this.media.textTracks);
                    i.forEach(function (n) {
                      Object(x.clearCurrentCues)(n);
                    }), this.subtitleTrack = -1, this.media = null;
                  }
                }, y.onManifestLoading = function () {
                  this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.selectDefaultTrack = !0;
                }, y.onManifestParsed = function (i, n) {
                  this.tracks = n.subtitleTracks;
                }, y.onSubtitleTrackLoaded = function (i, n) {
                  var a = n.id,
                      v = n.details,
                      h = this.trackId,
                      c = this.tracksInGroup[h];

                  if (!c) {
                    this.warn("Invalid subtitle track id " + a);
                    return;
                  }

                  var p = c.details;
                  c.details = n.details, this.log("subtitle track " + a + " loaded [" + v.startSN + "-" + v.endSN + "]"), a === this.trackId && (this.retryCount = 0, this.playlistLoaded(a, n, p));
                }, y.onLevelLoading = function (i, n) {
                  this.switchLevel(n.level);
                }, y.onLevelSwitching = function (i, n) {
                  this.switchLevel(n.level);
                }, y.switchLevel = function (i) {
                  var n = this.hls.levels[i];

                  if (!!(n != null && n.textGroupIds)) {
                    var a = n.textGroupIds[n.urlId];

                    if (this.groupId !== a) {
                      var v = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0,
                          h = this.tracks.filter(function (C) {
                        return !a || C.groupId === a;
                      });
                      this.tracksInGroup = h;
                      var c = this.findTrackId(v == null ? void 0 : v.name) || this.findTrackId();
                      this.groupId = a;
                      var p = {
                        subtitleTracks: h
                      };
                      this.log("Updating subtitle tracks, " + h.length + ' track(s) found in "' + a + '" group-id'), this.hls.trigger(j.Events.SUBTITLE_TRACKS_UPDATED, p), c !== -1 && this.setSubtitleTrack(c, v);
                    }
                  }
                }, y.findTrackId = function (i) {
                  for (var n = this.tracksInGroup, a = 0; a < n.length; a++) {
                    var v = n[a];
                    if ((!this.selectDefaultTrack || v.default) && (!i || i === v.name)) return v.id;
                  }

                  return -1;
                }, y.onError = function (i, n) {
                  d.prototype.onError.call(this, i, n), !(n.fatal || !n.context) && n.context.type === H.PlaylistContextType.SUBTITLE_TRACK && n.context.id === this.trackId && n.context.groupId === this.groupId && this.retryLoadingOrFail(n);
                }, y.loadPlaylist = function (i) {
                  var n = this.tracksInGroup[this.trackId];

                  if (this.shouldLoadTrack(n)) {
                    var a = n.id,
                        v = n.groupId,
                        h = n.url;
                    if (i) try {
                      h = i.addDirectives(h);
                    } catch (c) {
                      this.warn("Could not construct new URL with HLS Delivery Directives: " + c);
                    }
                    this.log("Loading subtitle playlist for id " + a), this.hls.trigger(j.Events.SUBTITLE_TRACK_LOADING, {
                      url: h,
                      id: a,
                      groupId: v,
                      deliveryDirectives: i || null
                    });
                  }
                }, y.toggleTrackModes = function (i) {
                  var n = this,
                      a = this.media,
                      v = this.subtitleDisplay,
                      h = this.trackId;

                  if (!!a) {
                    var c = P(a.textTracks),
                        p = c.filter(function (g) {
                      return g.groupId === n.groupId;
                    });
                    if (i === -1) [].slice.call(c).forEach(function (g) {
                      g.mode = "disabled";
                    });else {
                      var C = p[h];
                      C && (C.mode = "disabled");
                    }
                    var _ = p[i];
                    _ && (_.mode = v ? "showing" : "hidden");
                  }
                }, y.setSubtitleTrack = function (i, n) {
                  var a,
                      v = this.tracksInGroup;

                  if (!this.media) {
                    this.queuedDefaultTrack = i;
                    return;
                  }

                  if (this.trackId !== i && this.toggleTrackModes(i), !(this.trackId === i && (i === -1 || (a = v[i]) !== null && a !== void 0 && a.details) || i < -1 || i >= v.length)) {
                    this.clearTimer();
                    var h = v[i];

                    if (this.log("Switching to subtitle track " + i), this.trackId = i, h) {
                      var c = h.id,
                          p = h.groupId,
                          C = p === void 0 ? "" : p,
                          _ = h.name,
                          g = h.type,
                          s = h.url;
                      this.hls.trigger(j.Events.SUBTITLE_TRACK_SWITCH, {
                        id: c,
                        groupId: C,
                        name: _,
                        type: g,
                        url: s
                      });
                      var o = this.switchParams(h.url, n == null ? void 0 : n.details);
                      this.loadPlaylist(o);
                    } else this.hls.trigger(j.Events.SUBTITLE_TRACK_SWITCH, {
                      id: i
                    });
                  }
                }, y.onTextTracksChanged = function () {
                  if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !(!this.media || !this.hls.config.renderTextTracksNatively)) {
                    for (var i = -1, n = P(this.media.textTracks), a = 0; a < n.length; a++) if (n[a].mode === "hidden") i = a;else if (n[a].mode === "showing") {
                      i = a;
                      break;
                    }

                    this.subtitleTrack !== i && (this.subtitleTrack = i);
                  }
                }, O(f, [{
                  key: "subtitleTracks",
                  get: function () {
                    return this.tracksInGroup;
                  }
                }, {
                  key: "subtitleTrack",
                  get: function () {
                    return this.trackId;
                  },
                  set: function (i) {
                    this.selectDefaultTrack = !1;
                    var n = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
                    this.setSubtitleTrack(i, n);
                  }
                }]), f;
              }(k.default);

              function P(d) {
                for (var f = [], y = 0; y < d.length; y++) {
                  var u = d[y];
                  u.kind === "subtitles" && u.label && f.push(d[y]);
                }

                return f;
              }

              K.default = L;
            },
            "./src/controller/timeline-controller.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "TimelineController", function () {
                return P;
              });

              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/events.ts"),
                  k = R("./src/utils/cea-608-parser.ts"),
                  H = R("./src/utils/output-filter.ts"),
                  w = R("./src/utils/webvtt-parser.ts"),
                  O = R("./src/utils/texttrack-utils.ts"),
                  D = R("./src/utils/imsc1-ttml-parser.ts"),
                  E = R("./src/types/loader.ts"),
                  L = R("./src/utils/logger.ts"),
                  P = function () {
                function u(n) {
                  if (this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.timescale = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = y(), this.captionsProperties = void 0, this.hls = n, this.config = n.config, this.Cues = n.config.cueHandler, this.captionsProperties = {
                    textTrack1: {
                      label: this.config.captionsTextTrack1Label,
                      languageCode: this.config.captionsTextTrack1LanguageCode
                    },
                    textTrack2: {
                      label: this.config.captionsTextTrack2Label,
                      languageCode: this.config.captionsTextTrack2LanguageCode
                    },
                    textTrack3: {
                      label: this.config.captionsTextTrack3Label,
                      languageCode: this.config.captionsTextTrack3LanguageCode
                    },
                    textTrack4: {
                      label: this.config.captionsTextTrack4Label,
                      languageCode: this.config.captionsTextTrack4LanguageCode
                    }
                  }, this.config.enableCEA708Captions) {
                    var a = new H.default(this, "textTrack1"),
                        v = new H.default(this, "textTrack2"),
                        h = new H.default(this, "textTrack3"),
                        c = new H.default(this, "textTrack4");
                    this.cea608Parser1 = new k.default(1, a, v), this.cea608Parser2 = new k.default(3, h, c);
                  }

                  n.on(x.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), n.on(x.Events.MEDIA_DETACHING, this.onMediaDetaching, this), n.on(x.Events.MANIFEST_LOADING, this.onManifestLoading, this), n.on(x.Events.MANIFEST_LOADED, this.onManifestLoaded, this), n.on(x.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), n.on(x.Events.FRAG_LOADING, this.onFragLoading, this), n.on(x.Events.FRAG_LOADED, this.onFragLoaded, this), n.on(x.Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), n.on(x.Events.FRAG_DECRYPTED, this.onFragDecrypted, this), n.on(x.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), n.on(x.Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), n.on(x.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                }

                var i = u.prototype;
                return i.destroy = function () {
                  var a = this.hls;
                  a.off(x.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), a.off(x.Events.MEDIA_DETACHING, this.onMediaDetaching, this), a.off(x.Events.MANIFEST_LOADING, this.onManifestLoading, this), a.off(x.Events.MANIFEST_LOADED, this.onManifestLoaded, this), a.off(x.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), a.off(x.Events.FRAG_LOADING, this.onFragLoading, this), a.off(x.Events.FRAG_LOADED, this.onFragLoaded, this), a.off(x.Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), a.off(x.Events.FRAG_DECRYPTED, this.onFragDecrypted, this), a.off(x.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), a.off(x.Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), a.off(x.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null;
                }, i.addCues = function (a, v, h, c, p) {
                  for (var C = !1, _ = p.length; _--;) {
                    var g = p[_],
                        s = f(g[0], g[1], v, h);
                    if (s >= 0 && (g[0] = Math.min(g[0], v), g[1] = Math.max(g[1], h), C = !0, s / (h - v) > .5)) return;
                  }

                  if (C || p.push([v, h]), this.config.renderTextTracksNatively) {
                    var o = this.captionsTracks[a];
                    this.Cues.newCue(o, v, h, c);
                  } else {
                    var b = this.Cues.newCue(null, v, h, c);
                    this.hls.trigger(x.Events.CUES_PARSED, {
                      type: "captions",
                      cues: b,
                      track: a
                    });
                  }
                }, i.onInitPtsFound = function (a, v) {
                  var h = this,
                      c = v.frag,
                      p = v.id,
                      C = v.initPTS,
                      _ = v.timescale,
                      g = this.unparsedVttFrags;
                  p === "main" && (this.initPTS[c.cc] = C, this.timescale[c.cc] = _), g.length && (this.unparsedVttFrags = [], g.forEach(function (s) {
                    h.onFragLoaded(x.Events.FRAG_LOADED, s);
                  }));
                }, i.getExistingTrack = function (a) {
                  var v = this.media;
                  if (v) for (var h = 0; h < v.textTracks.length; h++) {
                    var c = v.textTracks[h];
                    if (c[a]) return c;
                  }
                  return null;
                }, i.createCaptionsTrack = function (a) {
                  this.config.renderTextTracksNatively ? this.createNativeTrack(a) : this.createNonNativeTrack(a);
                }, i.createNativeTrack = function (a) {
                  if (!this.captionsTracks[a]) {
                    var v = this.captionsProperties,
                        h = this.captionsTracks,
                        c = this.media,
                        p = v[a],
                        C = p.label,
                        _ = p.languageCode,
                        g = this.getExistingTrack(a);
                    if (g) h[a] = g, Object(O.clearCurrentCues)(h[a]), Object(O.sendAddTrackEvent)(h[a], c);else {
                      var s = this.createTextTrack("captions", C, _);
                      s && (s[a] = !0, h[a] = s);
                    }
                  }
                }, i.createNonNativeTrack = function (a) {
                  if (!this.nonNativeCaptionsTracks[a]) {
                    var v = this.captionsProperties[a];

                    if (!!v) {
                      var h = v.label,
                          c = {
                        _id: a,
                        label: h,
                        kind: "captions",
                        default: v.media ? !!v.media.default : !1,
                        closedCaptions: v.media
                      };
                      this.nonNativeCaptionsTracks[a] = c, this.hls.trigger(x.Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
                        tracks: [c]
                      });
                    }
                  }
                }, i.createTextTrack = function (a, v, h) {
                  var c = this.media;
                  if (!!c) return c.addTextTrack(a, v, h);
                }, i.onMediaAttaching = function (a, v) {
                  this.media = v.media, this._cleanTracks();
                }, i.onMediaDetaching = function () {
                  var a = this.captionsTracks;
                  Object.keys(a).forEach(function (v) {
                    Object(O.clearCurrentCues)(a[v]), delete a[v];
                  }), this.nonNativeCaptionsTracks = {};
                }, i.onManifestLoading = function () {
                  this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = y(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = this.unparsedVttFrags || [], this.initPTS = [], this.timescale = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
                }, i._cleanTracks = function () {
                  var a = this.media;

                  if (!!a) {
                    var v = a.textTracks;
                    if (v) for (var h = 0; h < v.length; h++) Object(O.clearCurrentCues)(v[h]);
                  }
                }, i.onSubtitleTracksUpdated = function (a, v) {
                  var h = this;
                  this.textTracks = [];
                  var c = v.subtitleTracks || [],
                      p = c.some(function (s) {
                    return s.textCodec === D.IMSC1_CODEC;
                  });

                  if (this.config.enableWebVTT || p && this.config.enableIMSC1) {
                    var C = this.tracks && c && this.tracks.length === c.length;

                    if (this.tracks = c || [], this.config.renderTextTracksNatively) {
                      var _ = this.media ? this.media.textTracks : [];

                      this.tracks.forEach(function (s, o) {
                        var b;

                        if (o < _.length) {
                          for (var A = null, I = 0; I < _.length; I++) if (d(_[I], s)) {
                            A = _[I];
                            break;
                          }

                          A && (b = A);
                        }

                        b ? Object(O.clearCurrentCues)(b) : (b = h.createTextTrack("subtitles", s.name, s.lang), b && (b.mode = "disabled")), b && (b.groupId = s.groupId, h.textTracks.push(b));
                      });
                    } else if (!C && this.tracks && this.tracks.length) {
                      var g = this.tracks.map(function (s) {
                        return {
                          label: s.name,
                          kind: s.type.toLowerCase(),
                          default: s.default,
                          subtitleTrack: s
                        };
                      });
                      this.hls.trigger(x.Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
                        tracks: g
                      });
                    }
                  }
                }, i.onManifestLoaded = function (a, v) {
                  var h = this;
                  this.config.enableCEA708Captions && v.captions && v.captions.forEach(function (c) {
                    var p = /(?:CC|SERVICE)([1-4])/.exec(c.instreamId);

                    if (!!p) {
                      var C = "textTrack" + p[1],
                          _ = h.captionsProperties[C];
                      !_ || (_.label = c.name, c.lang && (_.languageCode = c.lang), _.media = c);
                    }
                  });
                }, i.onFragLoading = function (a, v) {
                  var h = this.cea608Parser1,
                      c = this.cea608Parser2,
                      p = this.lastSn,
                      C = this.lastPartIndex;

                  if (!(!this.enabled || !(h && c)) && v.frag.type === E.PlaylistLevelType.MAIN) {
                    var _,
                        g,
                        s = v.frag.sn,
                        o = (_ = v == null || (g = v.part) === null || g === void 0 ? void 0 : g.index) != null ? _ : -1;

                    s === p + 1 || s === p && o === C + 1 || (h.reset(), c.reset()), this.lastSn = s, this.lastPartIndex = o;
                  }
                }, i.onFragLoaded = function (a, v) {
                  var h = v.frag,
                      c = v.payload,
                      p = this.initPTS,
                      C = this.unparsedVttFrags;
                  if (h.type === E.PlaylistLevelType.SUBTITLE) if (c.byteLength) {
                    if (!Object(j.isFiniteNumber)(p[h.cc])) {
                      C.push(v), p.length && this.hls.trigger(x.Events.SUBTITLE_FRAG_PROCESSED, {
                        success: !1,
                        frag: h,
                        error: new Error("Missing initial subtitle PTS")
                      });
                      return;
                    }

                    var _ = h.decryptdata,
                        g = ("stats" in v);

                    if (_ == null || _.key == null || _.method !== "AES-128" || g) {
                      var s = this.tracks[h.level],
                          o = this.vttCCs;
                      o[h.cc] || (o[h.cc] = {
                        start: h.start,
                        prevCC: this.prevCC,
                        new: !0
                      }, this.prevCC = h.cc), s && s.textCodec === D.IMSC1_CODEC ? this._parseIMSC1(h, c) : this._parseVTTs(h, c, o);
                    }
                  } else this.hls.trigger(x.Events.SUBTITLE_FRAG_PROCESSED, {
                    success: !1,
                    frag: h,
                    error: new Error("Empty subtitle payload")
                  });
                }, i._parseIMSC1 = function (a, v) {
                  var h = this,
                      c = this.hls;
                  Object(D.parseIMSC1)(v, this.initPTS[a.cc], this.timescale[a.cc], function (p) {
                    h._appendCues(p, a.level), c.trigger(x.Events.SUBTITLE_FRAG_PROCESSED, {
                      success: !0,
                      frag: a
                    });
                  }, function (p) {
                    L.logger.log("Failed to parse IMSC1: " + p), c.trigger(x.Events.SUBTITLE_FRAG_PROCESSED, {
                      success: !1,
                      frag: a,
                      error: p
                    });
                  });
                }, i._parseVTTs = function (a, v, h) {
                  var c = this,
                      p = this.hls;
                  Object(w.parseWebVTT)(v, this.initPTS[a.cc], this.timescale[a.cc], h, a.cc, a.start, function (C) {
                    c._appendCues(C, a.level), p.trigger(x.Events.SUBTITLE_FRAG_PROCESSED, {
                      success: !0,
                      frag: a
                    });
                  }, function (C) {
                    c._fallbackToIMSC1(a, v), L.logger.log("Failed to parse VTT cue: " + C), p.trigger(x.Events.SUBTITLE_FRAG_PROCESSED, {
                      success: !1,
                      frag: a,
                      error: C
                    });
                  });
                }, i._fallbackToIMSC1 = function (a, v) {
                  var h = this,
                      c = this.tracks[a.level];
                  c.textCodec || Object(D.parseIMSC1)(v, this.initPTS[a.cc], this.timescale[a.cc], function () {
                    c.textCodec = D.IMSC1_CODEC, h._parseIMSC1(a, v);
                  }, function () {
                    c.textCodec = "wvtt";
                  });
                }, i._appendCues = function (a, v) {
                  var h = this.hls;

                  if (this.config.renderTextTracksNatively) {
                    var c = this.textTracks[v];
                    if (c.mode === "disabled") return;
                    a.forEach(function (_) {
                      return Object(O.addCueToTrack)(c, _);
                    });
                  } else {
                    var p = this.tracks[v],
                        C = p.default ? "default" : "subtitles" + v;
                    h.trigger(x.Events.CUES_PARSED, {
                      type: "subtitles",
                      cues: a,
                      track: C
                    });
                  }
                }, i.onFragDecrypted = function (a, v) {
                  var h = v.frag;

                  if (h.type === E.PlaylistLevelType.SUBTITLE) {
                    if (!Object(j.isFiniteNumber)(this.initPTS[h.cc])) {
                      this.unparsedVttFrags.push(v);
                      return;
                    }

                    this.onFragLoaded(x.Events.FRAG_LOADED, v);
                  }
                }, i.onSubtitleTracksCleared = function () {
                  this.tracks = [], this.captionsTracks = {};
                }, i.onFragParsingUserdata = function (a, v) {
                  var h = this.cea608Parser1,
                      c = this.cea608Parser2;
                  if (!(!this.enabled || !(h && c))) for (var p = 0; p < v.samples.length; p++) {
                    var C = v.samples[p].bytes;

                    if (C) {
                      var _ = this.extractCea608Data(C);

                      h.addData(v.samples[p].pts, _[0]), c.addData(v.samples[p].pts, _[1]);
                    }
                  }
                }, i.onBufferFlushing = function (a, v) {
                  var h = v.startOffset,
                      c = v.endOffset,
                      p = v.endOffsetSubtitles,
                      C = v.type,
                      _ = this.media;

                  if (!(!_ || _.currentTime < c)) {
                    if (!C || C === "video") {
                      var g = this.captionsTracks;
                      Object.keys(g).forEach(function (o) {
                        return Object(O.removeCuesInRange)(g[o], h, c);
                      });
                    }

                    if (this.config.renderTextTracksNatively && h === 0 && p !== void 0) {
                      var s = this.textTracks;
                      Object.keys(s).forEach(function (o) {
                        return Object(O.removeCuesInRange)(s[o], h, p);
                      });
                    }
                  }
                }, i.extractCea608Data = function (a) {
                  for (var v = a[0] & 31, h = 2, c = [[], []], p = 0; p < v; p++) {
                    var C = a[h++],
                        _ = 127 & a[h++],
                        g = 127 & a[h++],
                        s = (4 & C) != 0,
                        o = 3 & C;

                    _ === 0 && g === 0 || s && (o === 0 || o === 1) && (c[o].push(_), c[o].push(g));
                  }

                  return c;
                }, u;
              }();

              function d(u, i) {
                return u && u.label === i.name && !(u.textTrack1 || u.textTrack2);
              }

              function f(u, i, n, a) {
                return Math.min(i, a) - Math.max(u, n);
              }

              function y() {
                return {
                  ccOffset: 0,
                  presentationOffset: 0,
                  0: {
                    start: 0,
                    prevCC: -1,
                    new: !1
                  }
                };
              }
            },
            "./src/crypt/aes-crypto.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return j;
              });

              var j = function () {
                function x(H, w) {
                  this.subtle = void 0, this.aesIV = void 0, this.subtle = H, this.aesIV = w;
                }

                var k = x.prototype;
                return k.decrypt = function (w, O) {
                  return this.subtle.decrypt({
                    name: "AES-CBC",
                    iv: this.aesIV
                  }, O, w);
                }, x;
              }();
            },
            "./src/crypt/aes-decryptor.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "removePadding", function () {
                return x;
              }), R.d(K, "default", function () {
                return k;
              });
              var j = R("./src/utils/typed-array.ts");

              function x(H) {
                var w = H.byteLength,
                    O = w && new DataView(H.buffer).getUint8(w - 1);
                return O ? Object(j.sliceUint8)(H, 0, w - O) : H;
              }

              var k = function () {
                function H() {
                  this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
                }

                var w = H.prototype;
                return w.uint8ArrayToUint32Array_ = function (D) {
                  for (var E = new DataView(D), L = new Uint32Array(4), P = 0; P < 4; P++) L[P] = E.getUint32(P * 4);

                  return L;
                }, w.initTable = function () {
                  var D = this.sBox,
                      E = this.invSBox,
                      L = this.subMix,
                      P = L[0],
                      d = L[1],
                      f = L[2],
                      y = L[3],
                      u = this.invSubMix,
                      i = u[0],
                      n = u[1],
                      a = u[2],
                      v = u[3],
                      h = new Uint32Array(256),
                      c = 0,
                      p = 0,
                      C = 0;

                  for (C = 0; C < 256; C++) C < 128 ? h[C] = C << 1 : h[C] = C << 1 ^ 283;

                  for (C = 0; C < 256; C++) {
                    var _ = p ^ p << 1 ^ p << 2 ^ p << 3 ^ p << 4;

                    _ = _ >>> 8 ^ _ & 255 ^ 99, D[c] = _, E[_] = c;
                    var g = h[c],
                        s = h[g],
                        o = h[s],
                        b = h[_] * 257 ^ _ * 16843008;
                    P[c] = b << 24 | b >>> 8, d[c] = b << 16 | b >>> 16, f[c] = b << 8 | b >>> 24, y[c] = b, b = o * 16843009 ^ s * 65537 ^ g * 257 ^ c * 16843008, i[_] = b << 24 | b >>> 8, n[_] = b << 16 | b >>> 16, a[_] = b << 8 | b >>> 24, v[_] = b, c ? (c = g ^ h[h[h[o ^ g]]], p ^= h[h[p]]) : c = p = 1;
                  }
                }, w.expandKey = function (D) {
                  for (var E = this.uint8ArrayToUint32Array_(D), L = !0, P = 0; P < E.length && L;) L = E[P] === this.key[P], P++;

                  if (!L) {
                    this.key = E;
                    var d = this.keySize = E.length;
                    if (d !== 4 && d !== 6 && d !== 8) throw new Error("Invalid aes key size=" + d);
                    var f = this.ksRows = (d + 6 + 1) * 4,
                        y,
                        u,
                        i = this.keySchedule = new Uint32Array(f),
                        n = this.invKeySchedule = new Uint32Array(f),
                        a = this.sBox,
                        v = this.rcon,
                        h = this.invSubMix,
                        c = h[0],
                        p = h[1],
                        C = h[2],
                        _ = h[3],
                        g,
                        s;

                    for (y = 0; y < f; y++) {
                      if (y < d) {
                        g = i[y] = E[y];
                        continue;
                      }

                      s = g, y % d == 0 ? (s = s << 8 | s >>> 24, s = a[s >>> 24] << 24 | a[s >>> 16 & 255] << 16 | a[s >>> 8 & 255] << 8 | a[s & 255], s ^= v[y / d | 0] << 24) : d > 6 && y % d == 4 && (s = a[s >>> 24] << 24 | a[s >>> 16 & 255] << 16 | a[s >>> 8 & 255] << 8 | a[s & 255]), i[y] = g = (i[y - d] ^ s) >>> 0;
                    }

                    for (u = 0; u < f; u++) y = f - u, u & 3 ? s = i[y] : s = i[y - 4], u < 4 || y <= 4 ? n[u] = s : n[u] = c[a[s >>> 24]] ^ p[a[s >>> 16 & 255]] ^ C[a[s >>> 8 & 255]] ^ _[a[s & 255]], n[u] = n[u] >>> 0;
                  }
                }, w.networkToHostOrderSwap = function (D) {
                  return D << 24 | (D & 65280) << 8 | (D & 16711680) >> 8 | D >>> 24;
                }, w.decrypt = function (D, E, L) {
                  for (var P = this.keySize + 6, d = this.invKeySchedule, f = this.invSBox, y = this.invSubMix, u = y[0], i = y[1], n = y[2], a = y[3], v = this.uint8ArrayToUint32Array_(L), h = v[0], c = v[1], p = v[2], C = v[3], _ = new Int32Array(D), g = new Int32Array(_.length), s, o, b, A, I, M, F, B, U, W, G, V, Y, $, q = this.networkToHostOrderSwap; E < _.length;) {
                    for (U = q(_[E]), W = q(_[E + 1]), G = q(_[E + 2]), V = q(_[E + 3]), I = U ^ d[0], M = V ^ d[1], F = G ^ d[2], B = W ^ d[3], Y = 4, $ = 1; $ < P; $++) s = u[I >>> 24] ^ i[M >> 16 & 255] ^ n[F >> 8 & 255] ^ a[B & 255] ^ d[Y], o = u[M >>> 24] ^ i[F >> 16 & 255] ^ n[B >> 8 & 255] ^ a[I & 255] ^ d[Y + 1], b = u[F >>> 24] ^ i[B >> 16 & 255] ^ n[I >> 8 & 255] ^ a[M & 255] ^ d[Y + 2], A = u[B >>> 24] ^ i[I >> 16 & 255] ^ n[M >> 8 & 255] ^ a[F & 255] ^ d[Y + 3], I = s, M = o, F = b, B = A, Y = Y + 4;

                    s = f[I >>> 24] << 24 ^ f[M >> 16 & 255] << 16 ^ f[F >> 8 & 255] << 8 ^ f[B & 255] ^ d[Y], o = f[M >>> 24] << 24 ^ f[F >> 16 & 255] << 16 ^ f[B >> 8 & 255] << 8 ^ f[I & 255] ^ d[Y + 1], b = f[F >>> 24] << 24 ^ f[B >> 16 & 255] << 16 ^ f[I >> 8 & 255] << 8 ^ f[M & 255] ^ d[Y + 2], A = f[B >>> 24] << 24 ^ f[I >> 16 & 255] << 16 ^ f[M >> 8 & 255] << 8 ^ f[F & 255] ^ d[Y + 3], g[E] = q(s ^ h), g[E + 1] = q(A ^ c), g[E + 2] = q(b ^ p), g[E + 3] = q(o ^ C), h = U, c = W, p = G, C = V, E = E + 4;
                  }

                  return g.buffer;
                }, H;
              }();
            },
            "./src/crypt/decrypter.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return E;
              });

              var j = R("./src/crypt/aes-crypto.ts"),
                  x = R("./src/crypt/fast-aes-key.ts"),
                  k = R("./src/crypt/aes-decryptor.ts"),
                  H = R("./src/utils/logger.ts"),
                  w = R("./src/utils/mp4-tools.ts"),
                  O = R("./src/utils/typed-array.ts"),
                  D = 16,
                  E = function () {
                function L(d, f, y) {
                  var u = y === void 0 ? {} : y,
                      i = u.removePKCS7Padding,
                      n = i === void 0 ? !0 : i;
                  if (this.logEnabled = !0, this.observer = void 0, this.config = void 0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.observer = d, this.config = f, this.removePKCS7Padding = n, n) try {
                    var a = self.crypto;
                    a && (this.subtle = a.subtle || a.webkitSubtle);
                  } catch (v) {}
                  this.subtle === null && (this.config.enableSoftwareAES = !0);
                }

                var P = L.prototype;
                return P.destroy = function () {
                  this.observer = null;
                }, P.isSync = function () {
                  return this.config.enableSoftwareAES;
                }, P.flush = function () {
                  var f = this.currentResult;

                  if (!f) {
                    this.reset();
                    return;
                  }

                  var y = new Uint8Array(f);
                  return this.reset(), this.removePKCS7Padding ? Object(k.removePadding)(y) : y;
                }, P.reset = function () {
                  this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
                }, P.decrypt = function (f, y, u, i) {
                  if (this.config.enableSoftwareAES) {
                    this.softwareDecrypt(new Uint8Array(f), y, u);
                    var n = this.flush();
                    n && i(n.buffer);
                  } else this.webCryptoDecrypt(new Uint8Array(f), y, u).then(i);
                }, P.softwareDecrypt = function (f, y, u) {
                  var i = this.currentIV,
                      n = this.currentResult,
                      a = this.remainderData;
                  this.logOnce("JS AES decrypt"), a && (f = Object(w.appendUint8Array)(a, f), this.remainderData = null);
                  var v = this.getValidChunk(f);
                  if (!v.length) return null;
                  i && (u = i);
                  var h = this.softwareDecrypter;
                  h || (h = this.softwareDecrypter = new k.default()), h.expandKey(y);
                  var c = n;
                  return this.currentResult = h.decrypt(v.buffer, 0, u), this.currentIV = Object(O.sliceUint8)(v, -16).buffer, c || null;
                }, P.webCryptoDecrypt = function (f, y, u) {
                  var i = this,
                      n = this.subtle;
                  return (this.key !== y || !this.fastAesKey) && (this.key = y, this.fastAesKey = new x.default(n, y)), this.fastAesKey.expandKey().then(function (a) {
                    if (!n) return Promise.reject(new Error("web crypto not initialized"));
                    var v = new j.default(n, u);
                    return v.decrypt(f.buffer, a);
                  }).catch(function (a) {
                    return i.onWebCryptoError(a, f, y, u);
                  });
                }, P.onWebCryptoError = function (f, y, u, i) {
                  return H.logger.warn("[decrypter.ts]: WebCrypto Error, disable WebCrypto API:", f), this.config.enableSoftwareAES = !0, this.logEnabled = !0, this.softwareDecrypt(y, u, i);
                }, P.getValidChunk = function (f) {
                  var y = f,
                      u = f.length - f.length % D;
                  return u !== f.length && (y = Object(O.sliceUint8)(f, 0, u), this.remainderData = Object(O.sliceUint8)(f, u)), y;
                }, P.logOnce = function (f) {
                  !this.logEnabled || (H.logger.log("[decrypter.ts]: " + f), this.logEnabled = !1);
                }, L;
              }();
            },
            "./src/crypt/fast-aes-key.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return j;
              });

              var j = function () {
                function x(H, w) {
                  this.subtle = void 0, this.key = void 0, this.subtle = H, this.key = w;
                }

                var k = x.prototype;
                return k.expandKey = function () {
                  return this.subtle.importKey("raw", this.key, {
                    name: "AES-CBC"
                  }, !1, ["encrypt", "decrypt"]);
                }, x;
              }();
            },
            "./src/demux/aacdemuxer.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = R("./src/demux/base-audio-demuxer.ts"),
                  x = R("./src/demux/adts.ts"),
                  k = R("./src/utils/logger.ts"),
                  H = R("./src/demux/id3.ts");

              function w(E, L) {
                E.prototype = Object.create(L.prototype), E.prototype.constructor = E, O(E, L);
              }

              function O(E, L) {
                return O = Object.setPrototypeOf || function (d, f) {
                  return d.__proto__ = f, d;
                }, O(E, L);
              }

              var D = function (E) {
                w(L, E);

                function L(d, f) {
                  var y;
                  return y = E.call(this) || this, y.observer = void 0, y.config = void 0, y.observer = d, y.config = f, y;
                }

                var P = L.prototype;
                return P.resetInitSegment = function (f, y, u) {
                  E.prototype.resetInitSegment.call(this, f, y, u), this._audioTrack = {
                    container: "audio/adts",
                    type: "audio",
                    id: 2,
                    pid: -1,
                    sequenceNumber: 0,
                    isAAC: !0,
                    samples: [],
                    manifestCodec: f,
                    duration: u,
                    inputTimeScale: 9e4,
                    dropped: 0
                  };
                }, L.probe = function (f) {
                  if (!f) return !1;

                  for (var y = H.getID3Data(f, 0) || [], u = y.length, i = f.length; u < i; u++) if (x.probe(f, u)) return k.logger.log("ADTS sync word found !"), !0;

                  return !1;
                }, P.canParse = function (f, y) {
                  return x.canParse(f, y);
                }, P.appendFrame = function (f, y, u) {
                  x.initTrackConfig(f, this.observer, y, u, f.manifestCodec);
                  var i = x.appendFrame(f, y, u, this.initPTS, this.frameIndex);
                  if (i && i.missing === 0) return i;
                }, L;
              }(j.default);

              D.minProbeByteLength = 9, K.default = D;
            },
            "./src/demux/adts.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "getAudioConfig", function () {
                return H;
              }), R.d(K, "isHeaderPattern", function () {
                return w;
              }), R.d(K, "getHeaderLength", function () {
                return O;
              }), R.d(K, "getFullFrameLength", function () {
                return D;
              }), R.d(K, "canGetFrameLength", function () {
                return E;
              }), R.d(K, "isHeader", function () {
                return L;
              }), R.d(K, "canParse", function () {
                return P;
              }), R.d(K, "probe", function () {
                return d;
              }), R.d(K, "initTrackConfig", function () {
                return f;
              }), R.d(K, "getFrameDuration", function () {
                return y;
              }), R.d(K, "parseFrameHeader", function () {
                return u;
              }), R.d(K, "appendFrame", function () {
                return i;
              });
              var j = R("./src/utils/logger.ts"),
                  x = R("./src/errors.ts"),
                  k = R("./src/events.ts");

              function H(n, a, v, h) {
                var c,
                    p,
                    C,
                    _,
                    g = navigator.userAgent.toLowerCase(),
                    s = h,
                    o = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];

                c = ((a[v + 2] & 192) >>> 6) + 1;
                var b = (a[v + 2] & 60) >>> 2;

                if (b > o.length - 1) {
                  n.trigger(k.Events.ERROR, {
                    type: x.ErrorTypes.MEDIA_ERROR,
                    details: x.ErrorDetails.FRAG_PARSING_ERROR,
                    fatal: !0,
                    reason: "invalid ADTS sampling index:" + b
                  });
                  return;
                }

                return C = (a[v + 2] & 1) << 2, C |= (a[v + 3] & 192) >>> 6, j.logger.log("manifest codec:" + h + ", ADTS type:" + c + ", samplingIndex:" + b), /firefox/i.test(g) ? b >= 6 ? (c = 5, _ = new Array(4), p = b - 3) : (c = 2, _ = new Array(2), p = b) : g.indexOf("android") !== -1 ? (c = 2, _ = new Array(2), p = b) : (c = 5, _ = new Array(4), h && (h.indexOf("mp4a.40.29") !== -1 || h.indexOf("mp4a.40.5") !== -1) || !h && b >= 6 ? p = b - 3 : ((h && h.indexOf("mp4a.40.2") !== -1 && (b >= 6 && C === 1 || /vivaldi/i.test(g)) || !h && C === 1) && (c = 2, _ = new Array(2)), p = b)), _[0] = c << 3, _[0] |= (b & 14) >> 1, _[1] |= (b & 1) << 7, _[1] |= C << 3, c === 5 && (_[1] |= (p & 14) >> 1, _[2] = (p & 1) << 7, _[2] |= 2 << 2, _[3] = 0), {
                  config: _,
                  samplerate: o[b],
                  channelCount: C,
                  codec: "mp4a.40." + c,
                  manifestCodec: s
                };
              }

              function w(n, a) {
                return n[a] === 255 && (n[a + 1] & 246) == 240;
              }

              function O(n, a) {
                return n[a + 1] & 1 ? 7 : 9;
              }

              function D(n, a) {
                return (n[a + 3] & 3) << 11 | n[a + 4] << 3 | (n[a + 5] & 224) >>> 5;
              }

              function E(n, a) {
                return a + 5 < n.length;
              }

              function L(n, a) {
                return a + 1 < n.length && w(n, a);
              }

              function P(n, a) {
                return E(n, a) && w(n, a) && D(n, a) <= n.length - a;
              }

              function d(n, a) {
                if (L(n, a)) {
                  var v = O(n, a);
                  if (a + v >= n.length) return !1;
                  var h = D(n, a);
                  if (h <= v) return !1;
                  var c = a + h;
                  return c === n.length || L(n, c);
                }

                return !1;
              }

              function f(n, a, v, h, c) {
                if (!n.samplerate) {
                  var p = H(a, v, h, c);
                  if (!p) return;
                  n.config = p.config, n.samplerate = p.samplerate, n.channelCount = p.channelCount, n.codec = p.codec, n.manifestCodec = p.manifestCodec, j.logger.log("parsed codec:" + n.codec + ", rate:" + p.samplerate + ", channels:" + p.channelCount);
                }
              }

              function y(n) {
                return 1024 * 9e4 / n;
              }

              function u(n, a, v, h, c) {
                var p = O(n, a),
                    C = D(n, a);

                if (C -= p, C > 0) {
                  var _ = v + h * c;

                  return {
                    headerLength: p,
                    frameLength: C,
                    stamp: _
                  };
                }
              }

              function i(n, a, v, h, c) {
                var p = y(n.samplerate),
                    C = u(a, v, h, c, p);

                if (C) {
                  var _ = C.frameLength,
                      g = C.headerLength,
                      s = C.stamp,
                      o = g + _,
                      b = Math.max(0, v + o - a.length),
                      A;
                  b ? (A = new Uint8Array(o - g), A.set(a.subarray(v + g, a.length), 0)) : A = a.subarray(v + g, v + o);
                  var I = {
                    unit: A,
                    pts: s
                  };
                  return b || n.samples.push(I), {
                    sample: I,
                    length: o,
                    missing: b
                  };
                }
              }
            },
            "./src/demux/base-audio-demuxer.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "initPTSFn", function () {
                return D;
              });

              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/demux/id3.ts"),
                  k = R("./src/demux/dummy-demuxed-track.ts"),
                  H = R("./src/utils/mp4-tools.ts"),
                  w = R("./src/utils/typed-array.ts"),
                  O = function () {
                function E() {
                  this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.initPTS = null;
                }

                var L = E.prototype;
                return L.resetInitSegment = function (d, f, y) {
                  this._id3Track = {
                    type: "id3",
                    id: 3,
                    pid: -1,
                    inputTimeScale: 9e4,
                    sequenceNumber: 0,
                    samples: [],
                    dropped: 0
                  };
                }, L.resetTimeStamp = function () {}, L.resetContiguity = function () {}, L.canParse = function (d, f) {
                  return !1;
                }, L.appendFrame = function (d, f, y) {}, L.demux = function (d, f) {
                  this.cachedData && (d = Object(H.appendUint8Array)(this.cachedData, d), this.cachedData = null);
                  var y = x.getID3Data(d, 0),
                      u = y ? y.length : 0,
                      i,
                      n,
                      a = this._audioTrack,
                      v = this._id3Track,
                      h = y ? x.getTimeStamp(y) : void 0,
                      c = d.length;

                  for ((this.frameIndex === 0 || this.initPTS === null) && (this.initPTS = D(h, f)), y && y.length > 0 && v.samples.push({
                    pts: this.initPTS,
                    dts: this.initPTS,
                    data: y
                  }), n = this.initPTS; u < c;) {
                    if (this.canParse(d, u)) {
                      var p = this.appendFrame(a, d, u);
                      p ? (this.frameIndex++, n = p.sample.pts, u += p.length, i = u) : u = c;
                    } else x.canParse(d, u) ? (y = x.getID3Data(d, u), v.samples.push({
                      pts: n,
                      dts: n,
                      data: y
                    }), u += y.length, i = u) : u++;

                    if (u === c && i !== c) {
                      var C = Object(w.sliceUint8)(d, i);
                      this.cachedData ? this.cachedData = Object(H.appendUint8Array)(this.cachedData, C) : this.cachedData = C;
                    }
                  }

                  return {
                    audioTrack: a,
                    avcTrack: Object(k.dummyTrack)(),
                    id3Track: v,
                    textTrack: Object(k.dummyTrack)()
                  };
                }, L.demuxSampleAes = function (d, f, y) {
                  return Promise.reject(new Error("[" + this + "] This demuxer does not support Sample-AES decryption"));
                }, L.flush = function (d) {
                  var f = this.cachedData;
                  return f && (this.cachedData = null, this.demux(f, 0)), this.frameIndex = 0, {
                    audioTrack: this._audioTrack,
                    avcTrack: Object(k.dummyTrack)(),
                    id3Track: this._id3Track,
                    textTrack: Object(k.dummyTrack)()
                  };
                }, L.destroy = function () {}, E;
              }(),
                  D = function (L, P) {
                return Object(j.isFiniteNumber)(L) ? L * 90 : P * 9e4;
              };

              K.default = O;
            },
            "./src/demux/chunk-cache.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return j;
              });

              var j = function () {
                function k() {
                  this.chunks = [], this.dataLength = 0;
                }

                var H = k.prototype;
                return H.push = function (O) {
                  this.chunks.push(O), this.dataLength += O.length;
                }, H.flush = function () {
                  var O = this.chunks,
                      D = this.dataLength,
                      E;
                  if (O.length) O.length === 1 ? E = O[0] : E = x(O, D);else return new Uint8Array(0);
                  return this.reset(), E;
                }, H.reset = function () {
                  this.chunks.length = 0, this.dataLength = 0;
                }, k;
              }();

              function x(k, H) {
                for (var w = new Uint8Array(H), O = 0, D = 0; D < k.length; D++) {
                  var E = k[D];
                  w.set(E, O), O += E.length;
                }

                return w;
              }
            },
            "./src/demux/dummy-demuxed-track.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "dummyTrack", function () {
                return j;
              });

              function j() {
                return {
                  type: "",
                  id: -1,
                  pid: -1,
                  inputTimeScale: 9e4,
                  sequenceNumber: -1,
                  samples: [],
                  dropped: 0
                };
              }
            },
            "./src/demux/exp-golomb.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = R("./src/utils/logger.ts"),
                  x = function () {
                function k(w) {
                  this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = w, this.bytesAvailable = w.byteLength, this.word = 0, this.bitsAvailable = 0;
                }

                var H = k.prototype;
                return H.loadWord = function () {
                  var O = this.data,
                      D = this.bytesAvailable,
                      E = O.byteLength - D,
                      L = new Uint8Array(4),
                      P = Math.min(4, D);
                  if (P === 0) throw new Error("no bytes available");
                  L.set(O.subarray(E, E + P)), this.word = new DataView(L.buffer).getUint32(0), this.bitsAvailable = P * 8, this.bytesAvailable -= P;
                }, H.skipBits = function (O) {
                  var D;
                  this.bitsAvailable > O ? (this.word <<= O, this.bitsAvailable -= O) : (O -= this.bitsAvailable, D = O >> 3, O -= D >> 3, this.bytesAvailable -= D, this.loadWord(), this.word <<= O, this.bitsAvailable -= O);
                }, H.readBits = function (O) {
                  var D = Math.min(this.bitsAvailable, O),
                      E = this.word >>> 32 - D;
                  return O > 32 && j.logger.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= D, this.bitsAvailable > 0 ? this.word <<= D : this.bytesAvailable > 0 && this.loadWord(), D = O - D, D > 0 && this.bitsAvailable ? E << D | this.readBits(D) : E;
                }, H.skipLZ = function () {
                  var O;

                  for (O = 0; O < this.bitsAvailable; ++O) if ((this.word & 2147483648 >>> O) != 0) return this.word <<= O, this.bitsAvailable -= O, O;

                  return this.loadWord(), O + this.skipLZ();
                }, H.skipUEG = function () {
                  this.skipBits(1 + this.skipLZ());
                }, H.skipEG = function () {
                  this.skipBits(1 + this.skipLZ());
                }, H.readUEG = function () {
                  var O = this.skipLZ();
                  return this.readBits(O + 1) - 1;
                }, H.readEG = function () {
                  var O = this.readUEG();
                  return 1 & O ? 1 + O >>> 1 : -1 * (O >>> 1);
                }, H.readBoolean = function () {
                  return this.readBits(1) === 1;
                }, H.readUByte = function () {
                  return this.readBits(8);
                }, H.readUShort = function () {
                  return this.readBits(16);
                }, H.readUInt = function () {
                  return this.readBits(32);
                }, H.skipScalingList = function (O) {
                  for (var D = 8, E = 8, L, P = 0; P < O; P++) E !== 0 && (L = this.readEG(), E = (D + L + 256) % 256), D = E === 0 ? D : E;
                }, H.readSPS = function () {
                  var O = 0,
                      D = 0,
                      E = 0,
                      L = 0,
                      P,
                      d,
                      f,
                      y = this.readUByte.bind(this),
                      u = this.readBits.bind(this),
                      i = this.readUEG.bind(this),
                      n = this.readBoolean.bind(this),
                      a = this.skipBits.bind(this),
                      v = this.skipEG.bind(this),
                      h = this.skipUEG.bind(this),
                      c = this.skipScalingList.bind(this);
                  y();
                  var p = y();

                  if (u(5), a(3), y(), h(), p === 100 || p === 110 || p === 122 || p === 244 || p === 44 || p === 83 || p === 86 || p === 118 || p === 128) {
                    var C = i();
                    if (C === 3 && a(1), h(), h(), a(1), n()) for (d = C !== 3 ? 8 : 12, f = 0; f < d; f++) n() && (f < 6 ? c(16) : c(64));
                  }

                  h();

                  var _ = i();

                  if (_ === 0) i();else if (_ === 1) for (a(1), v(), v(), P = i(), f = 0; f < P; f++) v();
                  h(), a(1);
                  var g = i(),
                      s = i(),
                      o = u(1);
                  o === 0 && a(1), a(1), n() && (O = i(), D = i(), E = i(), L = i());
                  var b = [1, 1];

                  if (n() && n()) {
                    var A = y();

                    switch (A) {
                      case 1:
                        b = [1, 1];
                        break;

                      case 2:
                        b = [12, 11];
                        break;

                      case 3:
                        b = [10, 11];
                        break;

                      case 4:
                        b = [16, 11];
                        break;

                      case 5:
                        b = [40, 33];
                        break;

                      case 6:
                        b = [24, 11];
                        break;

                      case 7:
                        b = [20, 11];
                        break;

                      case 8:
                        b = [32, 11];
                        break;

                      case 9:
                        b = [80, 33];
                        break;

                      case 10:
                        b = [18, 11];
                        break;

                      case 11:
                        b = [15, 11];
                        break;

                      case 12:
                        b = [64, 33];
                        break;

                      case 13:
                        b = [160, 99];
                        break;

                      case 14:
                        b = [4, 3];
                        break;

                      case 15:
                        b = [3, 2];
                        break;

                      case 16:
                        b = [2, 1];
                        break;

                      case 255:
                        {
                          b = [y() << 8 | y(), y() << 8 | y()];
                          break;
                        }
                    }
                  }

                  return {
                    width: Math.ceil((g + 1) * 16 - O * 2 - D * 2),
                    height: (2 - o) * (s + 1) * 16 - (o ? 2 : 4) * (E + L),
                    pixelRatio: b
                  };
                }, H.readSliceType = function () {
                  return this.readUByte(), this.readUEG(), this.readUEG();
                }, k;
              }();

              K.default = x;
            },
            "./src/demux/id3.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "isHeader", function () {
                return j;
              }), R.d(K, "isFooter", function () {
                return x;
              }), R.d(K, "getID3Data", function () {
                return k;
              }), R.d(K, "canParse", function () {
                return w;
              }), R.d(K, "getTimeStamp", function () {
                return O;
              }), R.d(K, "isTimeStampFrame", function () {
                return D;
              }), R.d(K, "getID3Frames", function () {
                return L;
              }), R.d(K, "decodeFrame", function () {
                return P;
              }), R.d(K, "utf8ArrayToStr", function () {
                return i;
              }), R.d(K, "testables", function () {
                return n;
              });

              var j = function (c, p) {
                return p + 10 <= c.length && c[p] === 73 && c[p + 1] === 68 && c[p + 2] === 51 && c[p + 3] < 255 && c[p + 4] < 255 && c[p + 6] < 128 && c[p + 7] < 128 && c[p + 8] < 128 && c[p + 9] < 128;
              },
                  x = function (c, p) {
                return p + 10 <= c.length && c[p] === 51 && c[p + 1] === 68 && c[p + 2] === 73 && c[p + 3] < 255 && c[p + 4] < 255 && c[p + 6] < 128 && c[p + 7] < 128 && c[p + 8] < 128 && c[p + 9] < 128;
              },
                  k = function (c, p) {
                for (var C = p, _ = 0; j(c, p);) {
                  _ += 10;
                  var g = H(c, p + 6);
                  _ += g, x(c, p + 10) && (_ += 10), p += _;
                }

                if (_ > 0) return c.subarray(C, C + _);
              },
                  H = function (c, p) {
                var C = 0;
                return C = (c[p] & 127) << 21, C |= (c[p + 1] & 127) << 14, C |= (c[p + 2] & 127) << 7, C |= c[p + 3] & 127, C;
              },
                  w = function (c, p) {
                return j(c, p) && H(c, p + 6) + 10 <= c.length - p;
              },
                  O = function (c) {
                for (var p = L(c), C = 0; C < p.length; C++) {
                  var _ = p[C];
                  if (D(_)) return u(_);
                }
              },
                  D = function (c) {
                return c && c.key === "PRIV" && c.info === "com.apple.streaming.transportStreamTimestamp";
              },
                  E = function (c) {
                var p = String.fromCharCode(c[0], c[1], c[2], c[3]),
                    C = H(c, 4),
                    _ = 10;
                return {
                  type: p,
                  size: C,
                  data: c.subarray(_, _ + C)
                };
              },
                  L = function (c) {
                for (var p = 0, C = []; j(c, p);) {
                  var _ = H(c, p + 6);

                  p += 10;

                  for (var g = p + _; p + 8 < g;) {
                    var s = E(c.subarray(p)),
                        o = P(s);
                    o && C.push(o), p += s.size + 10;
                  }

                  x(c, p) && (p += 10);
                }

                return C;
              },
                  P = function (c) {
                return c.type === "PRIV" ? d(c) : c.type[0] === "W" ? y(c) : f(c);
              },
                  d = function (c) {
                if (!(c.size < 2)) {
                  var p = i(c.data, !0),
                      C = new Uint8Array(c.data.subarray(p.length + 1));
                  return {
                    key: c.type,
                    info: p,
                    data: C.buffer
                  };
                }
              },
                  f = function (c) {
                if (!(c.size < 2)) {
                  if (c.type === "TXXX") {
                    var p = 1,
                        C = i(c.data.subarray(p), !0);
                    p += C.length + 1;

                    var _ = i(c.data.subarray(p));

                    return {
                      key: c.type,
                      info: C,
                      data: _
                    };
                  }

                  var g = i(c.data.subarray(1));
                  return {
                    key: c.type,
                    data: g
                  };
                }
              },
                  y = function (c) {
                if (c.type === "WXXX") {
                  if (c.size < 2) return;
                  var p = 1,
                      C = i(c.data.subarray(p), !0);
                  p += C.length + 1;

                  var _ = i(c.data.subarray(p));

                  return {
                    key: c.type,
                    info: C,
                    data: _
                  };
                }

                var g = i(c.data);
                return {
                  key: c.type,
                  data: g
                };
              },
                  u = function (c) {
                if (c.data.byteLength === 8) {
                  var p = new Uint8Array(c.data),
                      C = p[3] & 1,
                      _ = (p[4] << 23) + (p[5] << 15) + (p[6] << 7) + p[7];

                  return _ /= 45, C && (_ += 4772185884e-2), Math.round(_);
                }
              },
                  i = function (c, p) {
                p === void 0 && (p = !1);
                var C = v();

                if (C) {
                  var _ = C.decode(c);

                  if (p) {
                    var g = _.indexOf("\0");

                    return g !== -1 ? _.substring(0, g) : _;
                  }

                  return _.replace(/\0/g, "");
                }

                for (var s = c.length, o, b, A, I = "", M = 0; M < s;) {
                  if (o = c[M++], o === 0 && p) return I;
                  if (o === 0 || o === 3) continue;

                  switch (o >> 4) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                      I += String.fromCharCode(o);
                      break;

                    case 12:
                    case 13:
                      b = c[M++], I += String.fromCharCode((o & 31) << 6 | b & 63);
                      break;

                    case 14:
                      b = c[M++], A = c[M++], I += String.fromCharCode((o & 15) << 12 | (b & 63) << 6 | (A & 63) << 0);
                      break;

                    default:
                  }
                }

                return I;
              },
                  n = {
                decodeTextFrame: f
              },
                  a;

              function v() {
                return !a && typeof self.TextDecoder != "undefined" && (a = new self.TextDecoder("utf-8")), a;
              }
            },
            "./src/demux/mp3demuxer.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = R("./src/demux/base-audio-demuxer.ts"),
                  x = R("./src/demux/id3.ts"),
                  k = R("./src/utils/logger.ts"),
                  H = R("./src/demux/mpegaudio.ts");

              function w(E, L) {
                E.prototype = Object.create(L.prototype), E.prototype.constructor = E, O(E, L);
              }

              function O(E, L) {
                return O = Object.setPrototypeOf || function (d, f) {
                  return d.__proto__ = f, d;
                }, O(E, L);
              }

              var D = function (E) {
                w(L, E);

                function L() {
                  return E.apply(this, arguments) || this;
                }

                var P = L.prototype;
                return P.resetInitSegment = function (f, y, u) {
                  E.prototype.resetInitSegment.call(this, f, y, u), this._audioTrack = {
                    container: "audio/mpeg",
                    type: "audio",
                    id: 2,
                    pid: -1,
                    sequenceNumber: 0,
                    isAAC: !1,
                    samples: [],
                    manifestCodec: f,
                    duration: u,
                    inputTimeScale: 9e4,
                    dropped: 0
                  };
                }, L.probe = function (f) {
                  if (!f) return !1;

                  for (var y = x.getID3Data(f, 0) || [], u = y.length, i = f.length; u < i; u++) if (H.probe(f, u)) return k.logger.log("MPEG Audio sync word found !"), !0;

                  return !1;
                }, P.canParse = function (f, y) {
                  return H.canParse(f, y);
                }, P.appendFrame = function (f, y, u) {
                  if (this.initPTS !== null) return H.appendFrame(f, y, u, this.initPTS, this.frameIndex);
                }, L;
              }(j.default);

              D.minProbeByteLength = 4, K.default = D;
            },
            "./src/demux/mp4demuxer.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = R("./src/utils/mp4-tools.ts"),
                  x = R("./src/demux/dummy-demuxed-track.ts"),
                  k = function () {
                function H(O, D) {
                  this.remainderData = null, this.config = void 0, this.config = D;
                }

                var w = H.prototype;
                return w.resetTimeStamp = function () {}, w.resetInitSegment = function () {}, w.resetContiguity = function () {}, H.probe = function (D) {
                  return Object(j.findBox)({
                    data: D,
                    start: 0,
                    end: Math.min(D.length, 16384)
                  }, ["moof"]).length > 0;
                }, w.demux = function (D) {
                  var E = D,
                      L = Object(x.dummyTrack)();

                  if (this.config.progressive) {
                    this.remainderData && (E = Object(j.appendUint8Array)(this.remainderData, D));
                    var P = Object(j.segmentValidRange)(E);
                    this.remainderData = P.remainder, L.samples = P.valid || new Uint8Array();
                  } else L.samples = E;

                  return {
                    audioTrack: Object(x.dummyTrack)(),
                    avcTrack: L,
                    id3Track: Object(x.dummyTrack)(),
                    textTrack: Object(x.dummyTrack)()
                  };
                }, w.flush = function () {
                  var D = Object(x.dummyTrack)();
                  return D.samples = this.remainderData || new Uint8Array(), this.remainderData = null, {
                    audioTrack: Object(x.dummyTrack)(),
                    avcTrack: D,
                    id3Track: Object(x.dummyTrack)(),
                    textTrack: Object(x.dummyTrack)()
                  };
                }, w.demuxSampleAes = function (D, E, L) {
                  return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
                }, w.destroy = function () {}, H;
              }();

              k.minProbeByteLength = 1024, K.default = k;
            },
            "./src/demux/mpegaudio.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "appendFrame", function () {
                return O;
              }), R.d(K, "parseHeader", function () {
                return D;
              }), R.d(K, "isHeaderPattern", function () {
                return E;
              }), R.d(K, "isHeader", function () {
                return L;
              }), R.d(K, "canParse", function () {
                return P;
              }), R.d(K, "probe", function () {
                return d;
              });
              var j = null,
                  x = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160],
                  k = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3],
                  H = [[0, 72, 144, 12], [0, 0, 0, 0], [0, 72, 144, 12], [0, 144, 144, 12]],
                  w = [0, 1, 1, 4];

              function O(f, y, u, i, n) {
                if (!(u + 24 > y.length)) {
                  var a = D(y, u);

                  if (a && u + a.frameLength <= y.length) {
                    var v = a.samplesPerFrame * 9e4 / a.sampleRate,
                        h = i + n * v,
                        c = {
                      unit: y.subarray(u, u + a.frameLength),
                      pts: h,
                      dts: h
                    };
                    return f.config = [], f.channelCount = a.channelCount, f.samplerate = a.sampleRate, f.samples.push(c), {
                      sample: c,
                      length: a.frameLength,
                      missing: 0
                    };
                  }
                }
              }

              function D(f, y) {
                var u = f[y + 1] >> 3 & 3,
                    i = f[y + 1] >> 1 & 3,
                    n = f[y + 2] >> 4 & 15,
                    a = f[y + 2] >> 2 & 3;

                if (u !== 1 && n !== 0 && n !== 15 && a !== 3) {
                  var v = f[y + 2] >> 1 & 1,
                      h = f[y + 3] >> 6,
                      c = u === 3 ? 3 - i : i === 3 ? 3 : 4,
                      p = x[c * 14 + n - 1] * 1e3,
                      C = u === 3 ? 0 : u === 2 ? 1 : 2,
                      _ = k[C * 3 + a],
                      g = h === 3 ? 1 : 2,
                      s = H[u][i],
                      o = w[i],
                      b = s * 8 * o,
                      A = Math.floor(s * p / _ + v) * o;

                  if (j === null) {
                    var I = navigator.userAgent || "",
                        M = I.match(/Chrome\/(\d+)/i);
                    j = M ? parseInt(M[1]) : 0;
                  }

                  var F = !!j && j <= 87;
                  return F && i === 2 && p >= 224e3 && h === 0 && (f[y + 3] = f[y + 3] | 128), {
                    sampleRate: _,
                    channelCount: g,
                    frameLength: A,
                    samplesPerFrame: b
                  };
                }
              }

              function E(f, y) {
                return f[y] === 255 && (f[y + 1] & 224) == 224 && (f[y + 1] & 6) != 0;
              }

              function L(f, y) {
                return y + 1 < f.length && E(f, y);
              }

              function P(f, y) {
                var u = 4;
                return E(f, y) && u <= f.length - y;
              }

              function d(f, y) {
                if (y + 1 < f.length && E(f, y)) {
                  var u = 4,
                      i = D(f, y),
                      n = u;
                  i != null && i.frameLength && (n = i.frameLength);
                  var a = y + n;
                  return a === f.length || L(f, a);
                }

                return !1;
              }
            },
            "./src/demux/sample-aes.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = R("./src/crypt/decrypter.ts"),
                  x = R("./src/demux/tsdemuxer.ts"),
                  k = function () {
                function H(O, D, E) {
                  this.keyData = void 0, this.decrypter = void 0, this.keyData = E, this.decrypter = new j.default(O, D, {
                    removePKCS7Padding: !1
                  });
                }

                var w = H.prototype;
                return w.decryptBuffer = function (D, E) {
                  this.decrypter.decrypt(D, this.keyData.key.buffer, this.keyData.iv.buffer, E);
                }, w.decryptAacSample = function (D, E, L, P) {
                  var d = D[E].unit,
                      f = d.subarray(16, d.length - d.length % 16),
                      y = f.buffer.slice(f.byteOffset, f.byteOffset + f.length),
                      u = this;
                  this.decryptBuffer(y, function (i) {
                    var n = new Uint8Array(i);
                    d.set(n, 16), P || u.decryptAacSamples(D, E + 1, L);
                  });
                }, w.decryptAacSamples = function (D, E, L) {
                  for (;; E++) {
                    if (E >= D.length) {
                      L();
                      return;
                    }

                    if (!(D[E].unit.length < 32)) {
                      var P = this.decrypter.isSync();
                      if (this.decryptAacSample(D, E, L, P), !P) return;
                    }
                  }
                }, w.getAvcEncryptedData = function (D) {
                  for (var E = Math.floor((D.length - 48) / 160) * 16 + 16, L = new Int8Array(E), P = 0, d = 32; d < D.length - 16; d += 160, P += 16) L.set(D.subarray(d, d + 16), P);

                  return L;
                }, w.getAvcDecryptedUnit = function (D, E) {
                  for (var L = new Uint8Array(E), P = 0, d = 32; d < D.length - 16; d += 160, P += 16) D.set(L.subarray(P, P + 16), d);

                  return D;
                }, w.decryptAvcSample = function (D, E, L, P, d, f) {
                  var y = Object(x.discardEPB)(d.data),
                      u = this.getAvcEncryptedData(y),
                      i = this;
                  this.decryptBuffer(u.buffer, function (n) {
                    d.data = i.getAvcDecryptedUnit(y, n), f || i.decryptAvcSamples(D, E, L + 1, P);
                  });
                }, w.decryptAvcSamples = function (D, E, L, P) {
                  if (D instanceof Uint8Array) throw new Error("Cannot decrypt samples of type Uint8Array");

                  for (;; E++, L = 0) {
                    if (E >= D.length) {
                      P();
                      return;
                    }

                    for (var d = D[E].units; !(L >= d.length); L++) {
                      var f = d[L];

                      if (!(f.data.length <= 48 || f.type !== 1 && f.type !== 5)) {
                        var y = this.decrypter.isSync();
                        if (this.decryptAvcSample(D, E, L, P, f, y), !y) return;
                      }
                    }
                  }
                }, H;
              }();

              K.default = k;
            },
            "./src/demux/transmuxer-interface.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return d;
              });

              var j = R("./node_modules/webworkify-webpack/index.js"),
                  x = R.n(j),
                  k = R("./src/events.ts"),
                  H = R("./src/demux/transmuxer.ts"),
                  w = R("./src/utils/logger.ts"),
                  O = R("./src/errors.ts"),
                  D = R("./src/utils/mediasource-helper.ts"),
                  E = R("./node_modules/eventemitter3/index.js"),
                  L = R.n(E),
                  P = Object(D.getMediaSource)() || {
                isTypeSupported: function () {
                  return !1;
                }
              },
                  d = function () {
                function f(u, i, n, a) {
                  var v = this;
                  this.hls = void 0, this.id = void 0, this.observer = void 0, this.frag = null, this.part = null, this.worker = void 0, this.onwmsg = void 0, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0, this.hls = u, this.id = i, this.onTransmuxComplete = n, this.onFlush = a;

                  var h = u.config,
                      c = function (s, o) {
                    o = o || {}, o.frag = v.frag, o.id = v.id, u.trigger(s, o);
                  };

                  this.observer = new E.EventEmitter(), this.observer.on(k.Events.FRAG_DECRYPTED, c), this.observer.on(k.Events.ERROR, c);
                  var p = {
                    mp4: P.isTypeSupported("video/mp4"),
                    mpeg: P.isTypeSupported("audio/mpeg"),
                    mp3: P.isTypeSupported('audio/mp4; codecs="mp3"')
                  },
                      C = navigator.vendor;

                  if (h.enableWorker && typeof Worker != "undefined") {
                    w.logger.log("demuxing in webworker");

                    var _;

                    try {
                      _ = this.worker = j("./src/demux/transmuxer-worker.ts"), this.onwmsg = this.onWorkerMessage.bind(this), _.addEventListener("message", this.onwmsg), _.onerror = function (g) {
                        u.trigger(k.Events.ERROR, {
                          type: O.ErrorTypes.OTHER_ERROR,
                          details: O.ErrorDetails.INTERNAL_EXCEPTION,
                          fatal: !0,
                          event: "demuxerWorker",
                          error: new Error(g.message + "  (" + g.filename + ":" + g.lineno + ")")
                        });
                      }, _.postMessage({
                        cmd: "init",
                        typeSupported: p,
                        vendor: C,
                        id: i,
                        config: JSON.stringify(h)
                      });
                    } catch (g) {
                      w.logger.warn("Error in worker:", g), w.logger.error("Error while initializing DemuxerWorker, fallback to inline"), _ && self.URL.revokeObjectURL(_.objectURL), this.transmuxer = new H.default(this.observer, p, h, C, i), this.worker = null;
                    }
                  } else this.transmuxer = new H.default(this.observer, p, h, C, i);
                }

                var y = f.prototype;
                return y.destroy = function () {
                  var i = this.worker;
                  if (i) i.removeEventListener("message", this.onwmsg), i.terminate(), this.worker = null;else {
                    var n = this.transmuxer;
                    n && (n.destroy(), this.transmuxer = null);
                  }
                  var a = this.observer;
                  a && a.removeAllListeners(), this.observer = null;
                }, y.push = function (i, n, a, v, h, c, p, C, _, g) {
                  var s,
                      o,
                      b = this;
                  _.transmuxing.start = self.performance.now();
                  var A = this.transmuxer,
                      I = this.worker,
                      M = c ? c.start : h.start,
                      F = h.decryptdata,
                      B = this.frag,
                      U = !(B && h.cc === B.cc),
                      W = !(B && _.level === B.level),
                      G = B ? _.sn - B.sn : -1,
                      V = this.part ? _.part - this.part.index : 1,
                      Y = !W && (G === 1 || G === 0 && V === 1),
                      $ = self.performance.now();
                  (W || G || h.stats.parsing.start === 0) && (h.stats.parsing.start = $), c && (V || !Y) && (c.stats.parsing.start = $);
                  var q = !(B && ((s = h.initSegment) === null || s === void 0 ? void 0 : s.url) === ((o = B.initSegment) === null || o === void 0 ? void 0 : o.url)),
                      Z = new H.TransmuxState(U, Y, C, W, M, q);

                  if (!Y || U || q) {
                    w.logger.log("[transmuxer-interface, " + h.type + "]: Starting new transmux session for sn: " + _.sn + " p: " + _.part + " level: " + _.level + " id: " + _.id + "\n        discontinuity: " + U + "\n        trackSwitch: " + W + "\n        contiguous: " + Y + "\n        accurateTimeOffset: " + C + "\n        timeOffset: " + M + "\n        initSegmentChange: " + q);
                    var te = new H.TransmuxConfig(a, v, n, p, g);
                    this.configureTransmuxer(te);
                  }

                  if (this.frag = h, this.part = c, I) I.postMessage({
                    cmd: "demux",
                    data: i,
                    decryptdata: F,
                    chunkMeta: _,
                    state: Z
                  }, i instanceof ArrayBuffer ? [i] : []);else if (A) {
                    var se = A.push(i, F, _, Z);
                    Object(H.isPromise)(se) ? se.then(function (ge) {
                      b.handleTransmuxComplete(ge);
                    }) : this.handleTransmuxComplete(se);
                  }
                }, y.flush = function (i) {
                  var n = this;
                  i.transmuxing.start = self.performance.now();
                  var a = this.transmuxer,
                      v = this.worker;
                  if (v) v.postMessage({
                    cmd: "flush",
                    chunkMeta: i
                  });else if (a) {
                    var h = a.flush(i);
                    Object(H.isPromise)(h) ? h.then(function (c) {
                      n.handleFlushResult(c, i);
                    }) : this.handleFlushResult(h, i);
                  }
                }, y.handleFlushResult = function (i, n) {
                  var a = this;
                  i.forEach(function (v) {
                    a.handleTransmuxComplete(v);
                  }), this.onFlush(n);
                }, y.onWorkerMessage = function (i) {
                  var n = i.data,
                      a = this.hls;

                  switch (n.event) {
                    case "init":
                      {
                        self.URL.revokeObjectURL(this.worker.objectURL);
                        break;
                      }

                    case "transmuxComplete":
                      {
                        this.handleTransmuxComplete(n.data);
                        break;
                      }

                    case "flush":
                      {
                        this.onFlush(n.data);
                        break;
                      }

                    default:
                      {
                        n.data = n.data || {}, n.data.frag = this.frag, n.data.id = this.id, a.trigger(n.event, n.data);
                        break;
                      }
                  }
                }, y.configureTransmuxer = function (i) {
                  var n = this.worker,
                      a = this.transmuxer;
                  n ? n.postMessage({
                    cmd: "configure",
                    config: i
                  }) : a && a.configure(i);
                }, y.handleTransmuxComplete = function (i) {
                  i.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(i);
                }, f;
              }();
            },
            "./src/demux/transmuxer-worker.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return O;
              });
              var j = R("./src/demux/transmuxer.ts"),
                  x = R("./src/events.ts"),
                  k = R("./src/utils/logger.ts"),
                  H = R("./node_modules/eventemitter3/index.js"),
                  w = R.n(H);

              function O(d) {
                var f = new H.EventEmitter(),
                    y = function (i, n) {
                  d.postMessage({
                    event: i,
                    data: n
                  });
                };

                f.on(x.Events.FRAG_DECRYPTED, y), f.on(x.Events.ERROR, y), d.addEventListener("message", function (u) {
                  var i = u.data;

                  switch (i.cmd) {
                    case "init":
                      {
                        var n = JSON.parse(i.config);
                        d.transmuxer = new j.default(f, i.typeSupported, n, i.vendor, i.id), Object(k.enableLogs)(n.debug), y("init", null);
                        break;
                      }

                    case "configure":
                      {
                        d.transmuxer.configure(i.config);
                        break;
                      }

                    case "demux":
                      {
                        var a = d.transmuxer.push(i.data, i.decryptdata, i.chunkMeta, i.state);
                        Object(j.isPromise)(a) ? a.then(function (c) {
                          D(d, c);
                        }) : D(d, a);
                        break;
                      }

                    case "flush":
                      {
                        var v = i.chunkMeta,
                            h = d.transmuxer.flush(v);
                        Object(j.isPromise)(h) ? h.then(function (c) {
                          L(d, c, v);
                        }) : L(d, h, v);
                        break;
                      }

                    default:
                      break;
                  }
                });
              }

              function D(d, f) {
                if (!P(f.remuxResult)) {
                  var y = [],
                      u = f.remuxResult,
                      i = u.audio,
                      n = u.video;
                  i && E(y, i), n && E(y, n), d.postMessage({
                    event: "transmuxComplete",
                    data: f
                  }, y);
                }
              }

              function E(d, f) {
                f.data1 && d.push(f.data1.buffer), f.data2 && d.push(f.data2.buffer);
              }

              function L(d, f, y) {
                f.forEach(function (u) {
                  D(d, u);
                }), d.postMessage({
                  event: "flush",
                  data: y
                });
              }

              function P(d) {
                return !d.audio && !d.video && !d.text && !d.id3 && !d.initSegment;
              }
            },
            "./src/demux/transmuxer.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return n;
              }), R.d(K, "isPromise", function () {
                return h;
              }), R.d(K, "TransmuxConfig", function () {
                return c;
              }), R.d(K, "TransmuxState", function () {
                return p;
              });
              var j = R("./src/events.ts"),
                  x = R("./src/errors.ts"),
                  k = R("./src/crypt/decrypter.ts"),
                  H = R("./src/demux/aacdemuxer.ts"),
                  w = R("./src/demux/mp4demuxer.ts"),
                  O = R("./src/demux/tsdemuxer.ts"),
                  D = R("./src/demux/mp3demuxer.ts"),
                  E = R("./src/remux/mp4-remuxer.ts"),
                  L = R("./src/remux/passthrough-remuxer.ts"),
                  P = R("./src/demux/chunk-cache.ts"),
                  d = R("./src/utils/mp4-tools.ts"),
                  f = R("./src/utils/logger.ts"),
                  y;

              try {
                y = self.performance.now.bind(self.performance);
              } catch (C) {
                f.logger.debug("Unable to use Performance API on this environment"), y = self.Date.now;
              }

              var u = [{
                demux: O.default,
                remux: E.default
              }, {
                demux: w.default,
                remux: L.default
              }, {
                demux: H.default,
                remux: E.default
              }, {
                demux: D.default,
                remux: E.default
              }],
                  i = 1024;
              u.forEach(function (C) {
                var _ = C.demux;
                i = Math.max(i, _.minProbeByteLength);
              });

              var n = function () {
                function C(g, s, o, b, A) {
                  this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.vendor = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.cache = new P.default(), this.observer = g, this.typeSupported = s, this.config = o, this.vendor = b, this.id = A;
                }

                var _ = C.prototype;
                return _.configure = function (s) {
                  this.transmuxConfig = s, this.decrypter && this.decrypter.reset();
                }, _.push = function (s, o, b, A) {
                  var I = this,
                      M = b.transmuxing;
                  M.executeStart = y();
                  var F = new Uint8Array(s),
                      B = this.cache,
                      U = this.config,
                      W = this.currentTransmuxState,
                      G = this.transmuxConfig;
                  A && (this.currentTransmuxState = A);
                  var V = a(F, o);

                  if (V && V.method === "AES-128") {
                    var Y = this.getDecrypter();

                    if (U.enableSoftwareAES) {
                      var $ = Y.softwareDecrypt(F, V.key.buffer, V.iv.buffer);
                      if (!$) return M.executeEnd = y(), v(b);
                      F = new Uint8Array($);
                    } else return this.decryptionPromise = Y.webCryptoDecrypt(F, V.key.buffer, V.iv.buffer).then(function (le) {
                      var ee = I.push(le, null, b);
                      return I.decryptionPromise = null, ee;
                    }), this.decryptionPromise;
                  }

                  var q = A || W,
                      Z = q.contiguous,
                      te = q.discontinuity,
                      se = q.trackSwitch,
                      ge = q.accurateTimeOffset,
                      he = q.timeOffset,
                      ye = q.initSegmentChange,
                      pe = G.audioCodec,
                      _e = G.videoCodec,
                      be = G.defaultInitPts,
                      Le = G.duration,
                      we = G.initSegmentData;

                  if ((te || se || ye) && this.resetInitSegment(we, pe, _e, Le), (te || ye) && this.resetInitialTimestamp(be), Z || this.resetContiguity(), this.needsProbing(F, te, se)) {
                    if (B.dataLength) {
                      var xe = B.flush();
                      F = Object(d.appendUint8Array)(xe, F);
                    }

                    this.configureTransmuxer(F, G);
                  }

                  var Ne = this.transmux(F, V, he, ge, b),
                      Me = this.currentTransmuxState;
                  return Me.contiguous = !0, Me.discontinuity = !1, Me.trackSwitch = !1, M.executeEnd = y(), Ne;
                }, _.flush = function (s) {
                  var o = this,
                      b = s.transmuxing;
                  b.executeStart = y();
                  var A = this.decrypter,
                      I = this.cache,
                      M = this.currentTransmuxState,
                      F = this.decryptionPromise;
                  if (F) return F.then(function () {
                    return o.flush(s);
                  });
                  var B = [],
                      U = M.timeOffset;

                  if (A) {
                    var W = A.flush();
                    W && B.push(this.push(W, null, s));
                  }

                  var G = I.dataLength;
                  I.reset();
                  var V = this.demuxer,
                      Y = this.remuxer;
                  if (!V || !Y) return G >= i && this.observer.emit(j.Events.ERROR, j.Events.ERROR, {
                    type: x.ErrorTypes.MEDIA_ERROR,
                    details: x.ErrorDetails.FRAG_PARSING_ERROR,
                    fatal: !0,
                    reason: "no demux matching with content found"
                  }), b.executeEnd = y(), [v(s)];
                  var $ = V.flush(U);
                  return h($) ? $.then(function (q) {
                    return o.flushRemux(B, q, s), B;
                  }) : (this.flushRemux(B, $, s), B);
                }, _.flushRemux = function (s, o, b) {
                  var A = o.audioTrack,
                      I = o.avcTrack,
                      M = o.id3Track,
                      F = o.textTrack,
                      B = this.currentTransmuxState,
                      U = B.accurateTimeOffset,
                      W = B.timeOffset;
                  f.logger.log("[transmuxer.ts]: Flushed fragment " + b.sn + (b.part > -1 ? " p: " + b.part : "") + " of level " + b.level);
                  var G = this.remuxer.remux(A, I, M, F, W, U, !0, this.id);
                  s.push({
                    remuxResult: G,
                    chunkMeta: b
                  }), b.transmuxing.executeEnd = y();
                }, _.resetInitialTimestamp = function (s) {
                  var o = this.demuxer,
                      b = this.remuxer;
                  !o || !b || (o.resetTimeStamp(s), b.resetTimeStamp(s));
                }, _.resetContiguity = function () {
                  var s = this.demuxer,
                      o = this.remuxer;
                  !s || !o || (s.resetContiguity(), o.resetNextTimestamp());
                }, _.resetInitSegment = function (s, o, b, A) {
                  var I = this.demuxer,
                      M = this.remuxer;
                  !I || !M || (I.resetInitSegment(o, b, A), M.resetInitSegment(s, o, b));
                }, _.destroy = function () {
                  this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
                }, _.transmux = function (s, o, b, A, I) {
                  var M;
                  return o && o.method === "SAMPLE-AES" ? M = this.transmuxSampleAes(s, o, b, A, I) : M = this.transmuxUnencrypted(s, b, A, I), M;
                }, _.transmuxUnencrypted = function (s, o, b, A) {
                  var I = this.demuxer.demux(s, o, !1, !this.config.progressive),
                      M = I.audioTrack,
                      F = I.avcTrack,
                      B = I.id3Track,
                      U = I.textTrack,
                      W = this.remuxer.remux(M, F, B, U, o, b, !1, this.id);
                  return {
                    remuxResult: W,
                    chunkMeta: A
                  };
                }, _.transmuxSampleAes = function (s, o, b, A, I) {
                  var M = this;
                  return this.demuxer.demuxSampleAes(s, o, b).then(function (F) {
                    var B = M.remuxer.remux(F.audioTrack, F.avcTrack, F.id3Track, F.textTrack, b, A, !1, M.id);
                    return {
                      remuxResult: B,
                      chunkMeta: I
                    };
                  });
                }, _.configureTransmuxer = function (s, o) {
                  for (var b = this.config, A = this.observer, I = this.typeSupported, M = this.vendor, F = o.audioCodec, B = o.defaultInitPts, U = o.duration, W = o.initSegmentData, G = o.videoCodec, V, Y = 0, $ = u.length; Y < $; Y++) if (u[Y].demux.probe(s)) {
                    V = u[Y];
                    break;
                  }

                  V || (f.logger.warn("Failed to find demuxer by probing frag, treating as mp4 passthrough"), V = {
                    demux: w.default,
                    remux: L.default
                  });
                  var q = this.demuxer,
                      Z = this.remuxer,
                      te = V.remux,
                      se = V.demux;
                  (!Z || !(Z instanceof te)) && (this.remuxer = new te(A, b, I, M)), (!q || !(q instanceof se)) && (this.demuxer = new se(A, b, I), this.probe = se.probe), this.resetInitSegment(W, F, G, U), this.resetInitialTimestamp(B);
                }, _.needsProbing = function (s, o, b) {
                  return !this.demuxer || !this.remuxer || o || b;
                }, _.getDecrypter = function () {
                  var s = this.decrypter;
                  return s || (s = this.decrypter = new k.default(this.observer, this.config)), s;
                }, C;
              }();

              function a(C, _) {
                var g = null;
                return C.byteLength > 0 && _ != null && _.key != null && _.iv !== null && _.method != null && (g = _), g;
              }

              var v = function (_) {
                return {
                  remuxResult: {},
                  chunkMeta: _
                };
              };

              function h(C) {
                return "then" in C && C.then instanceof Function;
              }

              var c = function (_, g, s, o, b) {
                this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = _, this.videoCodec = g, this.initSegmentData = s, this.duration = o, this.defaultInitPts = b;
              },
                  p = function (_, g, s, o, b, A) {
                this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = _, this.contiguous = g, this.accurateTimeOffset = s, this.trackSwitch = o, this.timeOffset = b, this.initSegmentChange = A;
              };
            },
            "./src/demux/tsdemuxer.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "discardEPB", function () {
                return v;
              });

              var j = R("./src/demux/adts.ts"),
                  x = R("./src/demux/mpegaudio.ts"),
                  k = R("./src/demux/exp-golomb.ts"),
                  H = R("./src/demux/id3.ts"),
                  w = R("./src/demux/sample-aes.ts"),
                  O = R("./src/events.ts"),
                  D = R("./src/utils/mp4-tools.ts"),
                  E = R("./src/utils/logger.ts"),
                  L = R("./src/errors.ts"),
                  P = {
                video: 1,
                audio: 2,
                id3: 3,
                text: 4
              },
                  d = function () {
                function h(p, C, _) {
                  this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._duration = 0, this.aacLastPTS = null, this._initPTS = null, this._initDTS = null, this._pmtId = -1, this._avcTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.avcSample = null, this.remainderData = null, this.observer = p, this.config = C, this.typeSupported = _;
                }

                h.probe = function (C) {
                  var _ = h.syncOffset(C);

                  return _ < 0 ? !1 : (_ && E.logger.warn("MPEG2-TS detected but first sync word found @ offset " + _ + ", junk ahead ?"), !0);
                }, h.syncOffset = function (C) {
                  for (var _ = Math.min(1e3, C.length - 3 * 188), g = 0; g < _;) {
                    if (C[g] === 71 && C[g + 188] === 71 && C[g + 2 * 188] === 71) return g;
                    g++;
                  }

                  return -1;
                }, h.createTrack = function (C, _) {
                  return {
                    container: C === "video" || C === "audio" ? "video/mp2t" : void 0,
                    type: C,
                    id: P[C],
                    pid: -1,
                    inputTimeScale: 9e4,
                    sequenceNumber: 0,
                    samples: [],
                    dropped: 0,
                    duration: C === "audio" ? _ : void 0
                  };
                };
                var c = h.prototype;
                return c.resetInitSegment = function (C, _, g) {
                  this.pmtParsed = !1, this._pmtId = -1, this._avcTrack = h.createTrack("video", g), this._audioTrack = h.createTrack("audio", g), this._id3Track = h.createTrack("id3", g), this._txtTrack = h.createTrack("text", g), this._audioTrack.isAAC = !0, this.aacOverFlow = null, this.aacLastPTS = null, this.avcSample = null, this.audioCodec = C, this.videoCodec = _, this._duration = g;
                }, c.resetTimeStamp = function () {}, c.resetContiguity = function () {
                  var C = this._audioTrack,
                      _ = this._avcTrack,
                      g = this._id3Track;
                  C && (C.pesData = null), _ && (_.pesData = null), g && (g.pesData = null), this.aacOverFlow = null, this.aacLastPTS = null;
                }, c.demux = function (C, _, g, s) {
                  g === void 0 && (g = !1), s === void 0 && (s = !1), g || (this.sampleAes = null);
                  var o,
                      b = this._avcTrack,
                      A = this._audioTrack,
                      I = this._id3Track,
                      M = b.pid,
                      F = b.pesData,
                      B = A.pid,
                      U = I.pid,
                      W = A.pesData,
                      G = I.pesData,
                      V = !1,
                      Y = this.pmtParsed,
                      $ = this._pmtId,
                      q = C.length;
                  if (this.remainderData && (C = Object(D.appendUint8Array)(this.remainderData, C), q = C.length, this.remainderData = null), q < 188 && !s) return this.remainderData = C, {
                    audioTrack: A,
                    avcTrack: b,
                    id3Track: I,
                    textTrack: this._txtTrack
                  };
                  var Z = Math.max(0, h.syncOffset(C));
                  q -= (q + Z) % 188, q < C.byteLength && !s && (this.remainderData = new Uint8Array(C.buffer, q, C.buffer.byteLength - q));

                  for (var te = 0, se = Z; se < q; se += 188) if (C[se] === 71) {
                    var ge = !!(C[se + 1] & 64),
                        he = ((C[se + 1] & 31) << 8) + C[se + 2],
                        ye = (C[se + 3] & 48) >> 4,
                        pe = void 0;

                    if (ye > 1) {
                      if (pe = se + 5 + C[se + 4], pe === se + 188) continue;
                    } else pe = se + 4;

                    switch (he) {
                      case M:
                        ge && (F && (o = i(F)) && this.parseAVCPES(o, !1), F = {
                          data: [],
                          size: 0
                        }), F && (F.data.push(C.subarray(pe, se + 188)), F.size += se + 188 - pe);
                        break;

                      case B:
                        ge && (W && (o = i(W)) && (A.isAAC ? this.parseAACPES(o) : this.parseMPEGPES(o)), W = {
                          data: [],
                          size: 0
                        }), W && (W.data.push(C.subarray(pe, se + 188)), W.size += se + 188 - pe);
                        break;

                      case U:
                        ge && (G && (o = i(G)) && this.parseID3PES(o), G = {
                          data: [],
                          size: 0
                        }), G && (G.data.push(C.subarray(pe, se + 188)), G.size += se + 188 - pe);
                        break;

                      case 0:
                        ge && (pe += C[pe] + 1), $ = this._pmtId = y(C, pe);
                        break;

                      case $:
                        {
                          ge && (pe += C[pe] + 1);

                          var _e = u(C, pe, this.typeSupported.mpeg === !0 || this.typeSupported.mp3 === !0, g);

                          M = _e.avc, M > 0 && (b.pid = M), B = _e.audio, B > 0 && (A.pid = B, A.isAAC = _e.isAAC), U = _e.id3, U > 0 && (I.pid = U), V && !Y && (E.logger.log("reparse from beginning"), V = !1, se = Z - 188), Y = this.pmtParsed = !0;
                          break;
                        }

                      case 17:
                      case 8191:
                        break;

                      default:
                        V = !0;
                        break;
                    }
                  } else te++;

                  te > 0 && this.observer.emit(O.Events.ERROR, O.Events.ERROR, {
                    type: L.ErrorTypes.MEDIA_ERROR,
                    details: L.ErrorDetails.FRAG_PARSING_ERROR,
                    fatal: !1,
                    reason: "Found " + te + " TS packet/s that do not start with 0x47"
                  }), b.pesData = F, A.pesData = W, I.pesData = G;
                  var be = {
                    audioTrack: A,
                    avcTrack: b,
                    id3Track: I,
                    textTrack: this._txtTrack
                  };
                  return s && this.extractRemainingSamples(be), be;
                }, c.flush = function () {
                  var C = this.remainderData;
                  this.remainderData = null;

                  var _;

                  return C ? _ = this.demux(C, -1, !1, !0) : _ = {
                    audioTrack: this._audioTrack,
                    avcTrack: this._avcTrack,
                    textTrack: this._txtTrack,
                    id3Track: this._id3Track
                  }, this.extractRemainingSamples(_), this.sampleAes ? this.decrypt(_, this.sampleAes) : _;
                }, c.extractRemainingSamples = function (C) {
                  var _ = C.audioTrack,
                      g = C.avcTrack,
                      s = C.id3Track,
                      o = g.pesData,
                      b = _.pesData,
                      A = s.pesData,
                      I;
                  o && (I = i(o)) ? (this.parseAVCPES(I, !0), g.pesData = null) : g.pesData = o, b && (I = i(b)) ? (_.isAAC ? this.parseAACPES(I) : this.parseMPEGPES(I), _.pesData = null) : (b != null && b.size && E.logger.log("last AAC PES packet truncated,might overlap between fragments"), _.pesData = b), A && (I = i(A)) ? (this.parseID3PES(I), s.pesData = null) : s.pesData = A;
                }, c.demuxSampleAes = function (C, _, g) {
                  var s = this.demux(C, g, !0, !this.config.progressive),
                      o = this.sampleAes = new w.default(this.observer, this.config, _);
                  return this.decrypt(s, o);
                }, c.decrypt = function (C, _) {
                  return new Promise(function (g) {
                    var s = C.audioTrack,
                        o = C.avcTrack;
                    s.samples && s.isAAC ? _.decryptAacSamples(s.samples, 0, function () {
                      o.samples ? _.decryptAvcSamples(o.samples, 0, 0, function () {
                        g(C);
                      }) : g(C);
                    }) : o.samples && _.decryptAvcSamples(o.samples, 0, 0, function () {
                      g(C);
                    });
                  });
                }, c.destroy = function () {
                  this._initPTS = this._initDTS = null, this._duration = 0;
                }, c.parseAVCPES = function (C, _) {
                  var g = this,
                      s = this._avcTrack,
                      o = this.parseAVCNALu(C.data),
                      b = !1,
                      A = this.avcSample,
                      I,
                      M = !1;
                  C.data = null, A && o.length && !s.audFound && (n(A, s), A = this.avcSample = f(!1, C.pts, C.dts, "")), o.forEach(function (F) {
                    switch (F.type) {
                      case 1:
                        {
                          I = !0, A || (A = g.avcSample = f(!0, C.pts, C.dts, "")), b && (A.debug += "NDR "), A.frame = !0;
                          var B = F.data;

                          if (M && B.length > 4) {
                            var U = new k.default(B).readSliceType();
                            (U === 2 || U === 4 || U === 7 || U === 9) && (A.key = !0);
                          }

                          break;
                        }

                      case 5:
                        I = !0, A || (A = g.avcSample = f(!0, C.pts, C.dts, "")), b && (A.debug += "IDR "), A.key = !0, A.frame = !0;
                        break;

                      case 6:
                        {
                          I = !0, b && A && (A.debug += "SEI ");
                          var W = new k.default(v(F.data));
                          W.readUByte();

                          for (var G = 0, V = 0, Y = !1, $ = 0; !Y && W.bytesAvailable > 1;) {
                            G = 0;

                            do $ = W.readUByte(), G += $; while ($ === 255);

                            V = 0;

                            do $ = W.readUByte(), V += $; while ($ === 255);

                            if (G === 4 && W.bytesAvailable !== 0) {
                              Y = !0;
                              var q = W.readUByte();

                              if (q === 181) {
                                var Z = W.readUShort();

                                if (Z === 49) {
                                  var te = W.readUInt();

                                  if (te === 1195456820) {
                                    var se = W.readUByte();

                                    if (se === 3) {
                                      for (var ge = W.readUByte(), he = W.readUByte(), ye = 31 & ge, pe = [ge, he], _e = 0; _e < ye; _e++) pe.push(W.readUByte()), pe.push(W.readUByte()), pe.push(W.readUByte());

                                      a(g._txtTrack.samples, {
                                        type: 3,
                                        pts: C.pts,
                                        bytes: pe
                                      });
                                    }
                                  }
                                }
                              }
                            } else if (G === 5 && W.bytesAvailable !== 0) {
                              if (Y = !0, V > 16) {
                                for (var be = [], Le = 0; Le < 16; Le++) be.push(W.readUByte().toString(16)), (Le === 3 || Le === 5 || Le === 7 || Le === 9) && be.push("-");

                                for (var we = V - 16, xe = new Uint8Array(we), Ne = 0; Ne < we; Ne++) xe[Ne] = W.readUByte();

                                a(g._txtTrack.samples, {
                                  pts: C.pts,
                                  payloadType: G,
                                  uuid: be.join(""),
                                  userData: Object(H.utf8ArrayToStr)(xe),
                                  userDataBytes: xe
                                });
                              }
                            } else if (V < W.bytesAvailable) for (var Me = 0; Me < V; Me++) W.readUByte();
                          }

                          break;
                        }

                      case 7:
                        if (I = !0, M = !0, b && A && (A.debug += "SPS "), !s.sps) {
                          var le = new k.default(F.data),
                              ee = le.readSPS();
                          s.width = ee.width, s.height = ee.height, s.pixelRatio = ee.pixelRatio, s.sps = [F.data], s.duration = g._duration;

                          for (var oe = F.data.subarray(1, 4), ue = "avc1.", re = 0; re < 3; re++) {
                            var ne = oe[re].toString(16);
                            ne.length < 2 && (ne = "0" + ne), ue += ne;
                          }

                          s.codec = ue;
                        }

                        break;

                      case 8:
                        I = !0, b && A && (A.debug += "PPS "), s.pps || (s.pps = [F.data]);
                        break;

                      case 9:
                        I = !1, s.audFound = !0, A && n(A, s), A = g.avcSample = f(!1, C.pts, C.dts, b ? "AUD " : "");
                        break;

                      case 12:
                        I = !1;
                        break;

                      default:
                        I = !1, A && (A.debug += "unknown NAL " + F.type + " ");
                        break;
                    }

                    if (A && I) {
                      var ce = A.units;
                      ce.push(F);
                    }
                  }), _ && A && (n(A, s), this.avcSample = null);
                }, c.getLastNalUnit = function () {
                  var C,
                      _ = this.avcSample,
                      g;

                  if (!_ || _.units.length === 0) {
                    var s = this._avcTrack.samples;
                    _ = s[s.length - 1];
                  }

                  if ((C = _) !== null && C !== void 0 && C.units) {
                    var o = _.units;
                    g = o[o.length - 1];
                  }

                  return g;
                }, c.parseAVCNALu = function (C) {
                  var _ = C.byteLength,
                      g = this._avcTrack,
                      s = g.naluState || 0,
                      o = s,
                      b = [],
                      A = 0,
                      I,
                      M,
                      F,
                      B = -1,
                      U = 0;

                  for (s === -1 && (B = 0, U = C[0] & 31, s = 0, A = 1); A < _;) {
                    if (I = C[A++], !s) {
                      s = I ? 0 : 1;
                      continue;
                    }

                    if (s === 1) {
                      s = I ? 0 : 2;
                      continue;
                    }

                    if (!I) s = 3;else if (I === 1) {
                      if (B >= 0) {
                        var W = {
                          data: C.subarray(B, A - s - 1),
                          type: U
                        };
                        b.push(W);
                      } else {
                        var G = this.getLastNalUnit();

                        if (G && (o && A <= 4 - o && G.state && (G.data = G.data.subarray(0, G.data.byteLength - o)), M = A - s - 1, M > 0)) {
                          var V = new Uint8Array(G.data.byteLength + M);
                          V.set(G.data, 0), V.set(C.subarray(0, M), G.data.byteLength), G.data = V, G.state = 0;
                        }
                      }

                      A < _ ? (F = C[A] & 31, B = A, U = F, s = 0) : s = -1;
                    } else s = 0;
                  }

                  if (B >= 0 && s >= 0) {
                    var Y = {
                      data: C.subarray(B, _),
                      type: U,
                      state: s
                    };
                    b.push(Y);
                  }

                  if (b.length === 0) {
                    var $ = this.getLastNalUnit();

                    if ($) {
                      var q = new Uint8Array($.data.byteLength + C.byteLength);
                      q.set($.data, 0), q.set(C, $.data.byteLength), $.data = q;
                    }
                  }

                  return g.naluState = s, b;
                }, c.parseAACPES = function (C) {
                  var _ = 0,
                      g = this._audioTrack,
                      s = this.aacOverFlow,
                      o = C.data;

                  if (s) {
                    this.aacOverFlow = null;
                    var b = s.sample.unit.byteLength,
                        A = Math.min(s.missing, b),
                        I = b - A;
                    s.sample.unit.set(o.subarray(0, A), I), g.samples.push(s.sample), _ = s.missing;
                  }

                  var M, F;

                  for (M = _, F = o.length; M < F - 1 && !j.isHeader(o, M); M++);

                  if (M !== _) {
                    var B, U;
                    if (M < F - 1 ? (B = "AAC PES did not start with ADTS header,offset:" + M, U = !1) : (B = "no ADTS header found in AAC PES", U = !0), E.logger.warn("parsing error:" + B), this.observer.emit(O.Events.ERROR, O.Events.ERROR, {
                      type: L.ErrorTypes.MEDIA_ERROR,
                      details: L.ErrorDetails.FRAG_PARSING_ERROR,
                      fatal: U,
                      reason: B
                    }), U) return;
                  }

                  j.initTrackConfig(g, this.observer, o, M, this.audioCodec);
                  var W;
                  if (C.pts !== void 0) W = C.pts;else if (s) {
                    var G = j.getFrameDuration(g.samplerate);
                    W = s.sample.pts + G;
                  } else {
                    E.logger.warn("[tsdemuxer]: AAC PES unknown PTS");
                    return;
                  }

                  for (var V = 0; M < F;) if (j.isHeader(o, M)) {
                    if (M + 5 < F) {
                      var Y = j.appendFrame(g, o, M, W, V);
                      if (Y) if (Y.missing) this.aacOverFlow = Y;else {
                        M += Y.length, V++;
                        continue;
                      }
                    }

                    break;
                  } else M++;
                }, c.parseMPEGPES = function (C) {
                  var _ = C.data,
                      g = _.length,
                      s = 0,
                      o = 0,
                      b = C.pts;

                  if (b === void 0) {
                    E.logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
                    return;
                  }

                  for (; o < g;) if (x.isHeader(_, o)) {
                    var A = x.appendFrame(this._audioTrack, _, o, b, s);
                    if (A) o += A.length, s++;else break;
                  } else o++;
                }, c.parseID3PES = function (C) {
                  if (C.pts === void 0) {
                    E.logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
                    return;
                  }

                  this._id3Track.samples.push(C);
                }, h;
              }();

              d.minProbeByteLength = 188;

              function f(h, c, p, C) {
                return {
                  key: h,
                  frame: !1,
                  pts: c,
                  dts: p,
                  units: [],
                  debug: C,
                  length: 0
                };
              }

              function y(h, c) {
                return (h[c + 10] & 31) << 8 | h[c + 11];
              }

              function u(h, c, p, C) {
                var _ = {
                  audio: -1,
                  avc: -1,
                  id3: -1,
                  isAAC: !0
                },
                    g = (h[c + 1] & 15) << 8 | h[c + 2],
                    s = c + 3 + g - 4,
                    o = (h[c + 10] & 15) << 8 | h[c + 11];

                for (c += 12 + o; c < s;) {
                  var b = (h[c + 1] & 31) << 8 | h[c + 2];

                  switch (h[c]) {
                    case 207:
                      if (!C) {
                        E.logger.log("ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream");
                        break;
                      }

                    case 15:
                      _.audio === -1 && (_.audio = b);
                      break;

                    case 21:
                      _.id3 === -1 && (_.id3 = b);
                      break;

                    case 219:
                      if (!C) {
                        E.logger.log("H.264 with AES-128-CBC slice encryption found in unencrypted stream");
                        break;
                      }

                    case 27:
                      _.avc === -1 && (_.avc = b);
                      break;

                    case 3:
                    case 4:
                      p ? _.audio === -1 && (_.audio = b, _.isAAC = !1) : E.logger.log("MPEG audio found, not supported in this browser");
                      break;

                    case 36:
                      E.logger.warn("Unsupported HEVC stream type found");
                      break;

                    default:
                      break;
                  }

                  c += ((h[c + 3] & 15) << 8 | h[c + 4]) + 5;
                }

                return _;
              }

              function i(h) {
                var c = 0,
                    p,
                    C,
                    _,
                    g,
                    s,
                    o = h.data;

                if (!h || h.size === 0) return null;

                for (; o[0].length < 19 && o.length > 1;) {
                  var b = new Uint8Array(o[0].length + o[1].length);
                  b.set(o[0]), b.set(o[1], o[0].length), o[0] = b, o.splice(1, 1);
                }

                p = o[0];
                var A = (p[0] << 16) + (p[1] << 8) + p[2];

                if (A === 1) {
                  if (C = (p[4] << 8) + p[5], C && C > h.size - 6) return null;
                  var I = p[7];
                  I & 192 && (g = (p[9] & 14) * 536870912 + (p[10] & 255) * 4194304 + (p[11] & 254) * 16384 + (p[12] & 255) * 128 + (p[13] & 254) / 2, I & 64 ? (s = (p[14] & 14) * 536870912 + (p[15] & 255) * 4194304 + (p[16] & 254) * 16384 + (p[17] & 255) * 128 + (p[18] & 254) / 2, g - s > 60 * 9e4 && (E.logger.warn(Math.round((g - s) / 9e4) + "s delta between PTS and DTS, align them"), g = s)) : s = g), _ = p[8];
                  var M = _ + 9;
                  if (h.size <= M) return null;
                  h.size -= M;

                  for (var F = new Uint8Array(h.size), B = 0, U = o.length; B < U; B++) {
                    p = o[B];
                    var W = p.byteLength;
                    if (M) if (M > W) {
                      M -= W;
                      continue;
                    } else p = p.subarray(M), W -= M, M = 0;
                    F.set(p, c), c += W;
                  }

                  return C && (C -= _ + 3), {
                    data: F,
                    pts: g,
                    dts: s,
                    len: C
                  };
                }

                return null;
              }

              function n(h, c) {
                if (h.units.length && h.frame) {
                  if (h.pts === void 0) {
                    var p = c.samples,
                        C = p.length;

                    if (C) {
                      var _ = p[C - 1];
                      h.pts = _.pts, h.dts = _.dts;
                    } else {
                      c.dropped++;
                      return;
                    }
                  }

                  c.samples.push(h);
                }

                h.debug.length && E.logger.log(h.pts + "/" + h.dts + ":" + h.debug);
              }

              function a(h, c) {
                var p = h.length;

                if (p > 0) {
                  if (c.pts >= h[p - 1].pts) h.push(c);else for (var C = p - 1; C >= 0; C--) if (c.pts < h[C].pts) {
                    h.splice(C, 0, c);
                    break;
                  }
                } else h.push(c);
              }

              function v(h) {
                for (var c = h.byteLength, p = [], C = 1; C < c - 2;) h[C] === 0 && h[C + 1] === 0 && h[C + 2] === 3 ? (p.push(C + 2), C += 2) : C++;

                if (p.length === 0) return h;

                var _ = c - p.length,
                    g = new Uint8Array(_),
                    s = 0;

                for (C = 0; C < _; s++, C++) s === p[0] && (s++, p.shift()), g[C] = h[s];

                return g;
              }

              K.default = d;
            },
            "./src/errors.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "ErrorTypes", function () {
                return j;
              }), R.d(K, "ErrorDetails", function () {
                return x;
              });
              var j;

              (function (k) {
                k.NETWORK_ERROR = "networkError", k.MEDIA_ERROR = "mediaError", k.KEY_SYSTEM_ERROR = "keySystemError", k.MUX_ERROR = "muxError", k.OTHER_ERROR = "otherError";
              })(j || (j = {}));

              var x;

              (function (k) {
                k.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", k.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", k.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", k.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", k.KEY_SYSTEM_NO_INIT_DATA = "keySystemNoInitData", k.MANIFEST_LOAD_ERROR = "manifestLoadError", k.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", k.MANIFEST_PARSING_ERROR = "manifestParsingError", k.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", k.LEVEL_EMPTY_ERROR = "levelEmptyError", k.LEVEL_LOAD_ERROR = "levelLoadError", k.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", k.LEVEL_SWITCH_ERROR = "levelSwitchError", k.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", k.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", k.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", k.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", k.FRAG_LOAD_ERROR = "fragLoadError", k.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", k.FRAG_DECRYPT_ERROR = "fragDecryptError", k.FRAG_PARSING_ERROR = "fragParsingError", k.REMUX_ALLOC_ERROR = "remuxAllocError", k.KEY_LOAD_ERROR = "keyLoadError", k.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", k.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", k.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", k.BUFFER_APPEND_ERROR = "bufferAppendError", k.BUFFER_APPENDING_ERROR = "bufferAppendingError", k.BUFFER_STALLED_ERROR = "bufferStalledError", k.BUFFER_FULL_ERROR = "bufferFullError", k.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", k.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", k.INTERNAL_EXCEPTION = "internalException", k.INTERNAL_ABORTED = "aborted", k.UNKNOWN = "unknown";
              })(x || (x = {}));
            },
            "./src/events.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "Events", function () {
                return j;
              });
              var j;

              (function (x) {
                x.MEDIA_ATTACHING = "hlsMediaAttaching", x.MEDIA_ATTACHED = "hlsMediaAttached", x.MEDIA_DETACHING = "hlsMediaDetaching", x.MEDIA_DETACHED = "hlsMediaDetached", x.BUFFER_RESET = "hlsBufferReset", x.BUFFER_CODECS = "hlsBufferCodecs", x.BUFFER_CREATED = "hlsBufferCreated", x.BUFFER_APPENDING = "hlsBufferAppending", x.BUFFER_APPENDED = "hlsBufferAppended", x.BUFFER_EOS = "hlsBufferEos", x.BUFFER_FLUSHING = "hlsBufferFlushing", x.BUFFER_FLUSHED = "hlsBufferFlushed", x.MANIFEST_LOADING = "hlsManifestLoading", x.MANIFEST_LOADED = "hlsManifestLoaded", x.MANIFEST_PARSED = "hlsManifestParsed", x.LEVEL_SWITCHING = "hlsLevelSwitching", x.LEVEL_SWITCHED = "hlsLevelSwitched", x.LEVEL_LOADING = "hlsLevelLoading", x.LEVEL_LOADED = "hlsLevelLoaded", x.LEVEL_UPDATED = "hlsLevelUpdated", x.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", x.LEVELS_UPDATED = "hlsLevelsUpdated", x.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", x.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", x.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", x.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", x.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", x.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", x.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", x.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", x.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", x.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", x.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", x.CUES_PARSED = "hlsCuesParsed", x.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", x.INIT_PTS_FOUND = "hlsInitPtsFound", x.FRAG_LOADING = "hlsFragLoading", x.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", x.FRAG_LOADED = "hlsFragLoaded", x.FRAG_DECRYPTED = "hlsFragDecrypted", x.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", x.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", x.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", x.FRAG_PARSED = "hlsFragParsed", x.FRAG_BUFFERED = "hlsFragBuffered", x.FRAG_CHANGED = "hlsFragChanged", x.FPS_DROP = "hlsFpsDrop", x.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", x.ERROR = "hlsError", x.DESTROYING = "hlsDestroying", x.KEY_LOADING = "hlsKeyLoading", x.KEY_LOADED = "hlsKeyLoaded", x.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", x.BACK_BUFFER_REACHED = "hlsBackBufferReached";
              })(j || (j = {}));
            },
            "./src/hls.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return h;
              });
              var j = R("./node_modules/url-toolkit/src/url-toolkit.js"),
                  x = R.n(j),
                  k = R("./src/loader/playlist-loader.ts"),
                  H = R("./src/loader/key-loader.ts"),
                  w = R("./src/controller/id3-track-controller.ts"),
                  O = R("./src/controller/latency-controller.ts"),
                  D = R("./src/controller/level-controller.ts"),
                  E = R("./src/controller/fragment-tracker.ts"),
                  L = R("./src/controller/stream-controller.ts"),
                  P = R("./src/is-supported.ts"),
                  d = R("./src/utils/logger.ts"),
                  f = R("./src/config.ts"),
                  y = R("./node_modules/eventemitter3/index.js"),
                  u = R.n(y),
                  i = R("./src/events.ts"),
                  n = R("./src/errors.ts");

              function a(c, p) {
                for (var C = 0; C < p.length; C++) {
                  var _ = p[C];
                  _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(c, _.key, _);
                }
              }

              function v(c, p, C) {
                return p && a(c.prototype, p), C && a(c, C), c;
              }

              var h = function () {
                c.isSupported = function () {
                  return Object(P.isSupported)();
                };

                function c(C) {
                  C === void 0 && (C = {}), this.config = void 0, this.userConfig = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this._emitter = new y.EventEmitter(), this._autoLevelCapping = void 0, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this.url = null;

                  var _ = this.config = Object(f.mergeConfig)(c.DefaultConfig, C);

                  this.userConfig = C, Object(d.enableLogs)(_.debug), this._autoLevelCapping = -1, _.progressive && Object(f.enableStreamingMode)(_);
                  var g = _.abrController,
                      s = _.bufferController,
                      o = _.capLevelController,
                      b = _.fpsController,
                      A = this.abrController = new g(this),
                      I = this.bufferController = new s(this),
                      M = this.capLevelController = new o(this),
                      F = new b(this),
                      B = new k.default(this),
                      U = new H.default(this),
                      W = new w.default(this),
                      G = this.levelController = new D.default(this),
                      V = new E.FragmentTracker(this),
                      Y = this.streamController = new L.default(this, V);
                  M.setStreamController(Y), F.setStreamController(Y);
                  var $ = [G, Y];
                  this.networkControllers = $;
                  var q = [B, U, A, I, M, F, W, V];
                  this.audioTrackController = this.createController(_.audioTrackController, null, $), this.createController(_.audioStreamController, V, $), this.subtitleTrackController = this.createController(_.subtitleTrackController, null, $), this.createController(_.subtitleStreamController, V, $), this.createController(_.timelineController, null, q), this.emeController = this.createController(_.emeController, null, q), this.cmcdController = this.createController(_.cmcdController, null, q), this.latencyController = this.createController(O.default, null, q), this.coreComponents = q;
                }

                var p = c.prototype;
                return p.createController = function (_, g, s) {
                  if (_) {
                    var o = g ? new _(this, g) : new _(this);
                    return s && s.push(o), o;
                  }

                  return null;
                }, p.on = function (_, g, s) {
                  s === void 0 && (s = this), this._emitter.on(_, g, s);
                }, p.once = function (_, g, s) {
                  s === void 0 && (s = this), this._emitter.once(_, g, s);
                }, p.removeAllListeners = function (_) {
                  this._emitter.removeAllListeners(_);
                }, p.off = function (_, g, s, o) {
                  s === void 0 && (s = this), this._emitter.off(_, g, s, o);
                }, p.listeners = function (_) {
                  return this._emitter.listeners(_);
                }, p.emit = function (_, g, s) {
                  return this._emitter.emit(_, g, s);
                }, p.trigger = function (_, g) {
                  if (this.config.debug) return this.emit(_, _, g);

                  try {
                    return this.emit(_, _, g);
                  } catch (s) {
                    d.logger.error("An internal error happened while handling event " + _ + '. Error message: "' + s.message + '". Here is a stacktrace:', s), this.trigger(i.Events.ERROR, {
                      type: n.ErrorTypes.OTHER_ERROR,
                      details: n.ErrorDetails.INTERNAL_EXCEPTION,
                      fatal: !1,
                      event: _,
                      error: s
                    });
                  }

                  return !1;
                }, p.listenerCount = function (_) {
                  return this._emitter.listenerCount(_);
                }, p.destroy = function () {
                  d.logger.log("destroy"), this.trigger(i.Events.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this.url = null, this.networkControllers.forEach(function (_) {
                    return _.destroy();
                  }), this.networkControllers.length = 0, this.coreComponents.forEach(function (_) {
                    return _.destroy();
                  }), this.coreComponents.length = 0;
                }, p.attachMedia = function (_) {
                  d.logger.log("attachMedia"), this._media = _, this.trigger(i.Events.MEDIA_ATTACHING, {
                    media: _
                  });
                }, p.detachMedia = function () {
                  d.logger.log("detachMedia"), this.trigger(i.Events.MEDIA_DETACHING, void 0), this._media = null;
                }, p.loadSource = function (_) {
                  this.stopLoad();
                  var g = this.media,
                      s = this.url,
                      o = this.url = j.buildAbsoluteURL(self.location.href, _, {
                    alwaysNormalize: !0
                  });
                  d.logger.log("loadSource:" + o), g && s && s !== o && this.bufferController.hasSourceTypes() && (this.detachMedia(), this.attachMedia(g)), this.trigger(i.Events.MANIFEST_LOADING, {
                    url: _
                  });
                }, p.startLoad = function (_) {
                  _ === void 0 && (_ = -1), d.logger.log("startLoad(" + _ + ")"), this.networkControllers.forEach(function (g) {
                    g.startLoad(_);
                  });
                }, p.stopLoad = function () {
                  d.logger.log("stopLoad"), this.networkControllers.forEach(function (_) {
                    _.stopLoad();
                  });
                }, p.swapAudioCodec = function () {
                  d.logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
                }, p.recoverMediaError = function () {
                  d.logger.log("recoverMediaError");
                  var _ = this._media;
                  this.detachMedia(), _ && this.attachMedia(_);
                }, p.removeLevel = function (_, g) {
                  g === void 0 && (g = 0), this.levelController.removeLevel(_, g);
                }, v(c, [{
                  key: "levels",
                  get: function () {
                    var _ = this.levelController.levels;
                    return _ || [];
                  }
                }, {
                  key: "currentLevel",
                  get: function () {
                    return this.streamController.currentLevel;
                  },
                  set: function (_) {
                    d.logger.log("set currentLevel:" + _), this.loadLevel = _, this.abrController.clearTimer(), this.streamController.immediateLevelSwitch();
                  }
                }, {
                  key: "nextLevel",
                  get: function () {
                    return this.streamController.nextLevel;
                  },
                  set: function (_) {
                    d.logger.log("set nextLevel:" + _), this.levelController.manualLevel = _, this.streamController.nextLevelSwitch();
                  }
                }, {
                  key: "loadLevel",
                  get: function () {
                    return this.levelController.level;
                  },
                  set: function (_) {
                    d.logger.log("set loadLevel:" + _), this.levelController.manualLevel = _;
                  }
                }, {
                  key: "nextLoadLevel",
                  get: function () {
                    return this.levelController.nextLoadLevel;
                  },
                  set: function (_) {
                    this.levelController.nextLoadLevel = _;
                  }
                }, {
                  key: "firstLevel",
                  get: function () {
                    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
                  },
                  set: function (_) {
                    d.logger.log("set firstLevel:" + _), this.levelController.firstLevel = _;
                  }
                }, {
                  key: "startLevel",
                  get: function () {
                    return this.levelController.startLevel;
                  },
                  set: function (_) {
                    d.logger.log("set startLevel:" + _), _ !== -1 && (_ = Math.max(_, this.minAutoLevel)), this.levelController.startLevel = _;
                  }
                }, {
                  key: "capLevelToPlayerSize",
                  get: function () {
                    return this.config.capLevelToPlayerSize;
                  },
                  set: function (_) {
                    var g = !!_;
                    g !== this.config.capLevelToPlayerSize && (g ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = g);
                  }
                }, {
                  key: "autoLevelCapping",
                  get: function () {
                    return this._autoLevelCapping;
                  },
                  set: function (_) {
                    this._autoLevelCapping !== _ && (d.logger.log("set autoLevelCapping:" + _), this._autoLevelCapping = _);
                  }
                }, {
                  key: "bandwidthEstimate",
                  get: function () {
                    var _ = this.abrController.bwEstimator;
                    return _ ? _.getEstimate() : NaN;
                  }
                }, {
                  key: "autoLevelEnabled",
                  get: function () {
                    return this.levelController.manualLevel === -1;
                  }
                }, {
                  key: "manualLevel",
                  get: function () {
                    return this.levelController.manualLevel;
                  }
                }, {
                  key: "minAutoLevel",
                  get: function () {
                    var _ = this.levels,
                        g = this.config.minAutoBitrate;
                    if (!_) return 0;

                    for (var s = _.length, o = 0; o < s; o++) if (_[o].maxBitrate > g) return o;

                    return 0;
                  }
                }, {
                  key: "maxAutoLevel",
                  get: function () {
                    var _ = this.levels,
                        g = this.autoLevelCapping,
                        s;
                    return g === -1 && _ && _.length ? s = _.length - 1 : s = g, s;
                  }
                }, {
                  key: "nextAutoLevel",
                  get: function () {
                    return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
                  },
                  set: function (_) {
                    this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, _);
                  }
                }, {
                  key: "audioTracks",
                  get: function () {
                    var _ = this.audioTrackController;
                    return _ ? _.audioTracks : [];
                  }
                }, {
                  key: "audioTrack",
                  get: function () {
                    var _ = this.audioTrackController;
                    return _ ? _.audioTrack : -1;
                  },
                  set: function (_) {
                    var g = this.audioTrackController;
                    g && (g.audioTrack = _);
                  }
                }, {
                  key: "subtitleTracks",
                  get: function () {
                    var _ = this.subtitleTrackController;
                    return _ ? _.subtitleTracks : [];
                  }
                }, {
                  key: "subtitleTrack",
                  get: function () {
                    var _ = this.subtitleTrackController;
                    return _ ? _.subtitleTrack : -1;
                  },
                  set: function (_) {
                    var g = this.subtitleTrackController;
                    g && (g.subtitleTrack = _);
                  }
                }, {
                  key: "media",
                  get: function () {
                    return this._media;
                  }
                }, {
                  key: "subtitleDisplay",
                  get: function () {
                    var _ = this.subtitleTrackController;
                    return _ ? _.subtitleDisplay : !1;
                  },
                  set: function (_) {
                    var g = this.subtitleTrackController;
                    g && (g.subtitleDisplay = _);
                  }
                }, {
                  key: "lowLatencyMode",
                  get: function () {
                    return this.config.lowLatencyMode;
                  },
                  set: function (_) {
                    this.config.lowLatencyMode = _;
                  }
                }, {
                  key: "liveSyncPosition",
                  get: function () {
                    return this.latencyController.liveSyncPosition;
                  }
                }, {
                  key: "latency",
                  get: function () {
                    return this.latencyController.latency;
                  }
                }, {
                  key: "maxLatency",
                  get: function () {
                    return this.latencyController.maxLatency;
                  }
                }, {
                  key: "targetLatency",
                  get: function () {
                    return this.latencyController.targetLatency;
                  }
                }, {
                  key: "drift",
                  get: function () {
                    return this.latencyController.drift;
                  }
                }, {
                  key: "forceStartLoad",
                  get: function () {
                    return this.streamController.forceStartLoad;
                  }
                }], [{
                  key: "version",
                  get: function () {
                    return "1.1.5";
                  }
                }, {
                  key: "Events",
                  get: function () {
                    return i.Events;
                  }
                }, {
                  key: "ErrorTypes",
                  get: function () {
                    return n.ErrorTypes;
                  }
                }, {
                  key: "ErrorDetails",
                  get: function () {
                    return n.ErrorDetails;
                  }
                }, {
                  key: "DefaultConfig",
                  get: function () {
                    return c.defaultConfig ? c.defaultConfig : f.hlsDefaultConfig;
                  },
                  set: function (_) {
                    c.defaultConfig = _;
                  }
                }]), c;
              }();

              h.defaultConfig = void 0;
            },
            "./src/is-supported.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "isSupported", function () {
                return k;
              }), R.d(K, "changeTypeSupported", function () {
                return H;
              });
              var j = R("./src/utils/mediasource-helper.ts");

              function x() {
                return self.SourceBuffer || self.WebKitSourceBuffer;
              }

              function k() {
                var w = Object(j.getMediaSource)();
                if (!w) return !1;
                var O = x(),
                    D = w && typeof w.isTypeSupported == "function" && w.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'),
                    E = !O || O.prototype && typeof O.prototype.appendBuffer == "function" && typeof O.prototype.remove == "function";
                return !!D && !!E;
              }

              function H() {
                var w,
                    O = x();
                return typeof (O == null || (w = O.prototype) === null || w === void 0 ? void 0 : w.changeType) == "function";
              }
            },
            "./src/loader/fragment-loader.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return d;
              }), R.d(K, "LoadError", function () {
                return y;
              });
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/errors.ts");

              function k(u, i) {
                u.prototype = Object.create(i.prototype), u.prototype.constructor = u, E(u, i);
              }

              function H(u) {
                var i = typeof Map == "function" ? new Map() : void 0;
                return H = function (a) {
                  if (a === null || !D(a)) return a;
                  if (typeof a != "function") throw new TypeError("Super expression must either be null or a function");

                  if (typeof i != "undefined") {
                    if (i.has(a)) return i.get(a);
                    i.set(a, v);
                  }

                  function v() {
                    return w(a, arguments, L(this).constructor);
                  }

                  return v.prototype = Object.create(a.prototype, {
                    constructor: {
                      value: v,
                      enumerable: !1,
                      writable: !0,
                      configurable: !0
                    }
                  }), E(v, a);
                }, H(u);
              }

              function w(u, i, n) {
                return O() ? w = Reflect.construct : w = function (v, h, c) {
                  var p = [null];
                  p.push.apply(p, h);

                  var C = Function.bind.apply(v, p),
                      _ = new C();

                  return c && E(_, c.prototype), _;
                }, w.apply(null, arguments);
              }

              function O() {
                if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
                if (typeof Proxy == "function") return !0;

                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (u) {
                  return !1;
                }
              }

              function D(u) {
                return Function.toString.call(u).indexOf("[native code]") !== -1;
              }

              function E(u, i) {
                return E = Object.setPrototypeOf || function (a, v) {
                  return a.__proto__ = v, a;
                }, E(u, i);
              }

              function L(u) {
                return L = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
                  return n.__proto__ || Object.getPrototypeOf(n);
                }, L(u);
              }

              var P = Math.pow(2, 17),
                  d = function () {
                function u(n) {
                  this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = n;
                }

                var i = u.prototype;
                return i.destroy = function () {
                  this.loader && (this.loader.destroy(), this.loader = null);
                }, i.abort = function () {
                  this.loader && this.loader.abort();
                }, i.load = function (a, v) {
                  var h = this,
                      c = a.url;
                  if (!c) return Promise.reject(new y({
                    type: x.ErrorTypes.NETWORK_ERROR,
                    details: x.ErrorDetails.FRAG_LOAD_ERROR,
                    fatal: !1,
                    frag: a,
                    networkDetails: null
                  }, "Fragment does not have a " + (c ? "part list" : "url")));
                  this.abort();
                  var p = this.config,
                      C = p.fLoader,
                      _ = p.loader;
                  return new Promise(function (g, s) {
                    h.loader && h.loader.destroy();
                    var o = h.loader = a.loader = C ? new C(p) : new _(p),
                        b = f(a),
                        A = {
                      timeout: p.fragLoadingTimeOut,
                      maxRetry: 0,
                      retryDelay: 0,
                      maxRetryDelay: p.fragLoadingMaxRetryTimeout,
                      highWaterMark: P
                    };
                    a.stats = o.stats, o.load(b, A, {
                      onSuccess: function (M, F, B, U) {
                        h.resetLoader(a, o), g({
                          frag: a,
                          part: null,
                          payload: M.data,
                          networkDetails: U
                        });
                      },
                      onError: function (M, F, B) {
                        h.resetLoader(a, o), s(new y({
                          type: x.ErrorTypes.NETWORK_ERROR,
                          details: x.ErrorDetails.FRAG_LOAD_ERROR,
                          fatal: !1,
                          frag: a,
                          response: M,
                          networkDetails: B
                        }));
                      },
                      onAbort: function (M, F, B) {
                        h.resetLoader(a, o), s(new y({
                          type: x.ErrorTypes.NETWORK_ERROR,
                          details: x.ErrorDetails.INTERNAL_ABORTED,
                          fatal: !1,
                          frag: a,
                          networkDetails: B
                        }));
                      },
                      onTimeout: function (M, F, B) {
                        h.resetLoader(a, o), s(new y({
                          type: x.ErrorTypes.NETWORK_ERROR,
                          details: x.ErrorDetails.FRAG_LOAD_TIMEOUT,
                          fatal: !1,
                          frag: a,
                          networkDetails: B
                        }));
                      },
                      onProgress: function (M, F, B, U) {
                        v && v({
                          frag: a,
                          part: null,
                          payload: B,
                          networkDetails: U
                        });
                      }
                    });
                  });
                }, i.loadPart = function (a, v, h) {
                  var c = this;
                  this.abort();
                  var p = this.config,
                      C = p.fLoader,
                      _ = p.loader;
                  return new Promise(function (g, s) {
                    c.loader && c.loader.destroy();
                    var o = c.loader = a.loader = C ? new C(p) : new _(p),
                        b = f(a, v),
                        A = {
                      timeout: p.fragLoadingTimeOut,
                      maxRetry: 0,
                      retryDelay: 0,
                      maxRetryDelay: p.fragLoadingMaxRetryTimeout,
                      highWaterMark: P
                    };
                    v.stats = o.stats, o.load(b, A, {
                      onSuccess: function (M, F, B, U) {
                        c.resetLoader(a, o), c.updateStatsFromPart(a, v);
                        var W = {
                          frag: a,
                          part: v,
                          payload: M.data,
                          networkDetails: U
                        };
                        h(W), g(W);
                      },
                      onError: function (M, F, B) {
                        c.resetLoader(a, o), s(new y({
                          type: x.ErrorTypes.NETWORK_ERROR,
                          details: x.ErrorDetails.FRAG_LOAD_ERROR,
                          fatal: !1,
                          frag: a,
                          part: v,
                          response: M,
                          networkDetails: B
                        }));
                      },
                      onAbort: function (M, F, B) {
                        a.stats.aborted = v.stats.aborted, c.resetLoader(a, o), s(new y({
                          type: x.ErrorTypes.NETWORK_ERROR,
                          details: x.ErrorDetails.INTERNAL_ABORTED,
                          fatal: !1,
                          frag: a,
                          part: v,
                          networkDetails: B
                        }));
                      },
                      onTimeout: function (M, F, B) {
                        c.resetLoader(a, o), s(new y({
                          type: x.ErrorTypes.NETWORK_ERROR,
                          details: x.ErrorDetails.FRAG_LOAD_TIMEOUT,
                          fatal: !1,
                          frag: a,
                          part: v,
                          networkDetails: B
                        }));
                      }
                    });
                  });
                }, i.updateStatsFromPart = function (a, v) {
                  var h = a.stats,
                      c = v.stats,
                      p = c.total;

                  if (h.loaded += c.loaded, p) {
                    var C = Math.round(a.duration / v.duration),
                        _ = Math.min(Math.round(h.loaded / p), C),
                        g = C - _,
                        s = g * Math.round(h.loaded / _);

                    h.total = h.loaded + s;
                  } else h.total = Math.max(h.loaded, h.total);

                  var o = h.loading,
                      b = c.loading;
                  o.start ? o.first += b.first - b.start : (o.start = b.start, o.first = b.first), o.end = b.end;
                }, i.resetLoader = function (a, v) {
                  a.loader = null, this.loader === v && (self.clearTimeout(this.partLoadTimeout), this.loader = null), v.destroy();
                }, u;
              }();

              function f(u, i) {
                i === void 0 && (i = null);
                var n = i || u,
                    a = {
                  frag: u,
                  part: i,
                  responseType: "arraybuffer",
                  url: n.url,
                  headers: {},
                  rangeStart: 0,
                  rangeEnd: 0
                },
                    v = n.byteRangeStartOffset,
                    h = n.byteRangeEndOffset;
                return Object(j.isFiniteNumber)(v) && Object(j.isFiniteNumber)(h) && (a.rangeStart = v, a.rangeEnd = h), a;
              }

              var y = function (u) {
                k(i, u);

                function i(n) {
                  for (var a, v = arguments.length, h = new Array(v > 1 ? v - 1 : 0), c = 1; c < v; c++) h[c - 1] = arguments[c];

                  return a = u.call.apply(u, [this].concat(h)) || this, a.data = void 0, a.data = n, a;
                }

                return i;
              }(H(Error));
            },
            "./src/loader/fragment.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "ElementaryStreamTypes", function () {
                return d;
              }), R.d(K, "BaseSegment", function () {
                return f;
              }), R.d(K, "Fragment", function () {
                return y;
              }), R.d(K, "Part", function () {
                return u;
              });
              var j = R("./src/polyfills/number.ts"),
                  x = R("./node_modules/url-toolkit/src/url-toolkit.js"),
                  k = R.n(x),
                  H = R("./src/utils/logger.ts"),
                  w = R("./src/loader/level-key.ts"),
                  O = R("./src/loader/load-stats.ts");

              function D(i, n) {
                i.prototype = Object.create(n.prototype), i.prototype.constructor = i, E(i, n);
              }

              function E(i, n) {
                return E = Object.setPrototypeOf || function (v, h) {
                  return v.__proto__ = h, v;
                }, E(i, n);
              }

              function L(i, n) {
                for (var a = 0; a < n.length; a++) {
                  var v = n[a];
                  v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(i, v.key, v);
                }
              }

              function P(i, n, a) {
                return n && L(i.prototype, n), a && L(i, a), i;
              }

              var d;

              (function (i) {
                i.AUDIO = "audio", i.VIDEO = "video", i.AUDIOVIDEO = "audiovideo";
              })(d || (d = {}));

              var f = function () {
                function i(a) {
                  var v;
                  this._byteRange = null, this._url = null, this.baseurl = void 0, this.relurl = void 0, this.elementaryStreams = (v = {}, v[d.AUDIO] = null, v[d.VIDEO] = null, v[d.AUDIOVIDEO] = null, v), this.baseurl = a;
                }

                var n = i.prototype;
                return n.setByteRange = function (v, h) {
                  var c = v.split("@", 2),
                      p = [];
                  c.length === 1 ? p[0] = h ? h.byteRangeEndOffset : 0 : p[0] = parseInt(c[1]), p[1] = parseInt(c[0]) + p[0], this._byteRange = p;
                }, P(i, [{
                  key: "byteRange",
                  get: function () {
                    return this._byteRange ? this._byteRange : [];
                  }
                }, {
                  key: "byteRangeStartOffset",
                  get: function () {
                    return this.byteRange[0];
                  }
                }, {
                  key: "byteRangeEndOffset",
                  get: function () {
                    return this.byteRange[1];
                  }
                }, {
                  key: "url",
                  get: function () {
                    return !this._url && this.baseurl && this.relurl && (this._url = Object(x.buildAbsoluteURL)(this.baseurl, this.relurl, {
                      alwaysNormalize: !0
                    })), this._url || "";
                  },
                  set: function (v) {
                    this._url = v;
                  }
                }]), i;
              }(),
                  y = function (i) {
                D(n, i);

                function n(v, h) {
                  var c;
                  return c = i.call(this, h) || this, c._decryptdata = null, c.rawProgramDateTime = null, c.programDateTime = null, c.tagList = [], c.duration = 0, c.sn = 0, c.levelkey = void 0, c.type = void 0, c.loader = null, c.level = -1, c.cc = 0, c.startPTS = void 0, c.endPTS = void 0, c.appendedPTS = void 0, c.startDTS = void 0, c.endDTS = void 0, c.start = 0, c.deltaPTS = void 0, c.maxStartPTS = void 0, c.minEndPTS = void 0, c.stats = new O.LoadStats(), c.urlId = 0, c.data = void 0, c.bitrateTest = !1, c.title = null, c.initSegment = null, c.type = v, c;
                }

                var a = n.prototype;
                return a.createInitializationVector = function (h) {
                  for (var c = new Uint8Array(16), p = 12; p < 16; p++) c[p] = h >> 8 * (15 - p) & 255;

                  return c;
                }, a.setDecryptDataFromLevelKey = function (h, c) {
                  var p = h;
                  return (h == null ? void 0 : h.method) === "AES-128" && h.uri && !h.iv && (p = w.LevelKey.fromURI(h.uri), p.method = h.method, p.iv = this.createInitializationVector(c), p.keyFormat = "identity"), p;
                }, a.setElementaryStreamInfo = function (h, c, p, C, _, g) {
                  g === void 0 && (g = !1);
                  var s = this.elementaryStreams,
                      o = s[h];

                  if (!o) {
                    s[h] = {
                      startPTS: c,
                      endPTS: p,
                      startDTS: C,
                      endDTS: _,
                      partial: g
                    };
                    return;
                  }

                  o.startPTS = Math.min(o.startPTS, c), o.endPTS = Math.max(o.endPTS, p), o.startDTS = Math.min(o.startDTS, C), o.endDTS = Math.max(o.endDTS, _);
                }, a.clearElementaryStreamInfo = function () {
                  var h = this.elementaryStreams;
                  h[d.AUDIO] = null, h[d.VIDEO] = null, h[d.AUDIOVIDEO] = null;
                }, P(n, [{
                  key: "decryptdata",
                  get: function () {
                    if (!this.levelkey && !this._decryptdata) return null;

                    if (!this._decryptdata && this.levelkey) {
                      var h = this.sn;
                      typeof h != "number" && (this.levelkey && this.levelkey.method === "AES-128" && !this.levelkey.iv && H.logger.warn('missing IV for initialization segment with method="' + this.levelkey.method + '" - compliance issue'), h = 0), this._decryptdata = this.setDecryptDataFromLevelKey(this.levelkey, h);
                    }

                    return this._decryptdata;
                  }
                }, {
                  key: "end",
                  get: function () {
                    return this.start + this.duration;
                  }
                }, {
                  key: "endProgramDateTime",
                  get: function () {
                    if (this.programDateTime === null || !Object(j.isFiniteNumber)(this.programDateTime)) return null;
                    var h = Object(j.isFiniteNumber)(this.duration) ? this.duration : 0;
                    return this.programDateTime + h * 1e3;
                  }
                }, {
                  key: "encrypted",
                  get: function () {
                    var h;
                    return !!((h = this.decryptdata) !== null && h !== void 0 && h.keyFormat && this.decryptdata.uri);
                  }
                }]), n;
              }(f),
                  u = function (i) {
                D(n, i);

                function n(a, v, h, c, p) {
                  var C;
                  C = i.call(this, h) || this, C.fragOffset = 0, C.duration = 0, C.gap = !1, C.independent = !1, C.relurl = void 0, C.fragment = void 0, C.index = void 0, C.stats = new O.LoadStats(), C.duration = a.decimalFloatingPoint("DURATION"), C.gap = a.bool("GAP"), C.independent = a.bool("INDEPENDENT"), C.relurl = a.enumeratedString("URI"), C.fragment = v, C.index = c;

                  var _ = a.enumeratedString("BYTERANGE");

                  return _ && C.setByteRange(_, p), p && (C.fragOffset = p.fragOffset + p.duration), C;
                }

                return P(n, [{
                  key: "start",
                  get: function () {
                    return this.fragment.start + this.fragOffset;
                  }
                }, {
                  key: "end",
                  get: function () {
                    return this.start + this.duration;
                  }
                }, {
                  key: "loaded",
                  get: function () {
                    var v = this.elementaryStreams;
                    return !!(v.audio || v.video || v.audiovideo);
                  }
                }]), n;
              }(f);
            },
            "./src/loader/key-loader.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return H;
              });

              var j = R("./src/events.ts"),
                  x = R("./src/errors.ts"),
                  k = R("./src/utils/logger.ts"),
                  H = function () {
                function w(D) {
                  this.hls = void 0, this.loaders = {}, this.decryptkey = null, this.decrypturl = null, this.hls = D, this._registerListeners();
                }

                var O = w.prototype;
                return O._registerListeners = function () {
                  this.hls.on(j.Events.KEY_LOADING, this.onKeyLoading, this);
                }, O._unregisterListeners = function () {
                  this.hls.off(j.Events.KEY_LOADING, this.onKeyLoading);
                }, O.destroy = function () {
                  this._unregisterListeners();

                  for (var E in this.loaders) {
                    var L = this.loaders[E];
                    L && L.destroy();
                  }

                  this.loaders = {};
                }, O.onKeyLoading = function (E, L) {
                  var P = L.frag,
                      d = P.type,
                      f = this.loaders[d];

                  if (!P.decryptdata) {
                    k.logger.warn("Missing decryption data on fragment in onKeyLoading");
                    return;
                  }

                  var y = P.decryptdata.uri;

                  if (y !== this.decrypturl || this.decryptkey === null) {
                    var u = this.hls.config;

                    if (f && (k.logger.warn("abort previous key loader for type:" + d), f.abort()), !y) {
                      k.logger.warn("key uri is falsy");
                      return;
                    }

                    var i = u.loader,
                        n = P.loader = this.loaders[d] = new i(u);
                    this.decrypturl = y, this.decryptkey = null;
                    var a = {
                      url: y,
                      frag: P,
                      responseType: "arraybuffer"
                    },
                        v = {
                      timeout: u.fragLoadingTimeOut,
                      maxRetry: 0,
                      retryDelay: u.fragLoadingRetryDelay,
                      maxRetryDelay: u.fragLoadingMaxRetryTimeout,
                      highWaterMark: 0
                    },
                        h = {
                      onSuccess: this.loadsuccess.bind(this),
                      onError: this.loaderror.bind(this),
                      onTimeout: this.loadtimeout.bind(this)
                    };
                    n.load(a, v, h);
                  } else this.decryptkey && (P.decryptdata.key = this.decryptkey, this.hls.trigger(j.Events.KEY_LOADED, {
                    frag: P
                  }));
                }, O.loadsuccess = function (E, L, P) {
                  var d = P.frag;

                  if (!d.decryptdata) {
                    k.logger.error("after key load, decryptdata unset");
                    return;
                  }

                  this.decryptkey = d.decryptdata.key = new Uint8Array(E.data), d.loader = null, delete this.loaders[d.type], this.hls.trigger(j.Events.KEY_LOADED, {
                    frag: d
                  });
                }, O.loaderror = function (E, L) {
                  var P = L.frag,
                      d = P.loader;
                  d && d.abort(), delete this.loaders[P.type], this.hls.trigger(j.Events.ERROR, {
                    type: x.ErrorTypes.NETWORK_ERROR,
                    details: x.ErrorDetails.KEY_LOAD_ERROR,
                    fatal: !1,
                    frag: P,
                    response: E
                  });
                }, O.loadtimeout = function (E, L) {
                  var P = L.frag,
                      d = P.loader;
                  d && d.abort(), delete this.loaders[P.type], this.hls.trigger(j.Events.ERROR, {
                    type: x.ErrorTypes.NETWORK_ERROR,
                    details: x.ErrorDetails.KEY_LOAD_TIMEOUT,
                    fatal: !1,
                    frag: P
                  });
                }, w;
              }();
            },
            "./src/loader/level-details.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "LevelDetails", function () {
                return w;
              });
              var j = R("./src/polyfills/number.ts");

              function x(O, D) {
                for (var E = 0; E < D.length; E++) {
                  var L = D[E];
                  L.enumerable = L.enumerable || !1, L.configurable = !0, "value" in L && (L.writable = !0), Object.defineProperty(O, L.key, L);
                }
              }

              function k(O, D, E) {
                return D && x(O.prototype, D), E && x(O, E), O;
              }

              var H = 10,
                  w = function () {
                function O(E) {
                  this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.live = !0, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.availabilityDelay = void 0, this.misses = 0, this.needSidxRanges = !1, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.fragments = [], this.url = E;
                }

                var D = O.prototype;
                return D.reloaded = function (L) {
                  if (!L) {
                    this.advanced = !0, this.updated = !0;
                    return;
                  }

                  var P = this.lastPartSn - L.lastPartSn,
                      d = this.lastPartIndex - L.lastPartIndex;
                  this.updated = this.endSN !== L.endSN || !!d || !!P, this.advanced = this.endSN > L.endSN || P > 0 || P === 0 && d > 0, this.updated || this.advanced ? this.misses = Math.floor(L.misses * .6) : this.misses = L.misses + 1, this.availabilityDelay = L.availabilityDelay;
                }, k(O, [{
                  key: "hasProgramDateTime",
                  get: function () {
                    return this.fragments.length ? Object(j.isFiniteNumber)(this.fragments[this.fragments.length - 1].programDateTime) : !1;
                  }
                }, {
                  key: "levelTargetDuration",
                  get: function () {
                    return this.averagetargetduration || this.targetduration || H;
                  }
                }, {
                  key: "drift",
                  get: function () {
                    var L = this.driftEndTime - this.driftStartTime;

                    if (L > 0) {
                      var P = this.driftEnd - this.driftStart;
                      return P * 1e3 / L;
                    }

                    return 1;
                  }
                }, {
                  key: "edge",
                  get: function () {
                    return this.partEnd || this.fragmentEnd;
                  }
                }, {
                  key: "partEnd",
                  get: function () {
                    var L;
                    return (L = this.partList) !== null && L !== void 0 && L.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
                  }
                }, {
                  key: "fragmentEnd",
                  get: function () {
                    var L;
                    return (L = this.fragments) !== null && L !== void 0 && L.length ? this.fragments[this.fragments.length - 1].end : 0;
                  }
                }, {
                  key: "age",
                  get: function () {
                    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
                  }
                }, {
                  key: "lastPartIndex",
                  get: function () {
                    var L;
                    return (L = this.partList) !== null && L !== void 0 && L.length ? this.partList[this.partList.length - 1].index : -1;
                  }
                }, {
                  key: "lastPartSn",
                  get: function () {
                    var L;
                    return (L = this.partList) !== null && L !== void 0 && L.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
                  }
                }]), O;
              }();
            },
            "./src/loader/level-key.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "LevelKey", function () {
                return w;
              });
              var j = R("./node_modules/url-toolkit/src/url-toolkit.js"),
                  x = R.n(j);

              function k(O, D) {
                for (var E = 0; E < D.length; E++) {
                  var L = D[E];
                  L.enumerable = L.enumerable || !1, L.configurable = !0, "value" in L && (L.writable = !0), Object.defineProperty(O, L.key, L);
                }
              }

              function H(O, D, E) {
                return D && k(O.prototype, D), E && k(O, E), O;
              }

              var w = function () {
                O.fromURL = function (E, L) {
                  return new O(E, L);
                }, O.fromURI = function (E) {
                  return new O(E);
                };

                function O(D, E) {
                  this._uri = null, this.method = null, this.keyFormat = null, this.keyFormatVersions = null, this.keyID = null, this.key = null, this.iv = null, E ? this._uri = Object(j.buildAbsoluteURL)(D, E, {
                    alwaysNormalize: !0
                  }) : this._uri = D;
                }

                return H(O, [{
                  key: "uri",
                  get: function () {
                    return this._uri;
                  }
                }]), O;
              }();
            },
            "./src/loader/load-stats.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "LoadStats", function () {
                return j;
              });

              var j = function () {
                this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
                  start: 0,
                  first: 0,
                  end: 0
                }, this.parsing = {
                  start: 0,
                  end: 0
                }, this.buffering = {
                  start: 0,
                  first: 0,
                  end: 0
                };
              };
            },
            "./src/loader/m3u8-parser.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return n;
              });
              var j = R("./src/polyfills/number.ts"),
                  x = R("./node_modules/url-toolkit/src/url-toolkit.js"),
                  k = R.n(x),
                  H = R("./src/loader/fragment.ts"),
                  w = R("./src/loader/level-details.ts"),
                  O = R("./src/loader/level-key.ts"),
                  D = R("./src/utils/attr-list.ts"),
                  E = R("./src/utils/logger.ts"),
                  L = R("./src/utils/codecs.ts"),
                  P = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-SESSION-DATA:([^\r\n]*)[\r\n]+/g,
                  d = /#EXT-X-MEDIA:(.*)/g,
                  f = new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source, /(?!#) *(\S[\S ]*)/.source, /#EXT-X-BYTERANGE:*(.+)/.source, /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source, /#.*/.source].join("|"), "g"),
                  y = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(PLAYLIST-TYPE):(.+)/.source, /#EXT-X-(MEDIA-SEQUENCE): *(\d+)/.source, /#EXT-X-(SKIP):(.+)/.source, /#EXT-X-(TARGETDURATION): *(\d+)/.source, /#EXT-X-(KEY):(.+)/.source, /#EXT-X-(START):(.+)/.source, /#EXT-X-(ENDLIST)/.source, /#EXT-X-(DISCONTINUITY-SEQ)UENCE: *(\d+)/.source, /#EXT-X-(DIS)CONTINUITY/.source, /#EXT-X-(VERSION):(\d+)/.source, /#EXT-X-(MAP):(.+)/.source, /#EXT-X-(SERVER-CONTROL):(.+)/.source, /#EXT-X-(PART-INF):(.+)/.source, /#EXT-X-(GAP)/.source, /#EXT-X-(BITRATE):\s*(\d+)/.source, /#EXT-X-(PART):(.+)/.source, /#EXT-X-(PRELOAD-HINT):(.+)/.source, /#EXT-X-(RENDITION-REPORT):(.+)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|")),
                  u = /\.(mp4|m4s|m4v|m4a)$/i;

              function i(p) {
                var C, _;

                return u.test((C = (_ = x.parseURL(p)) === null || _ === void 0 ? void 0 : _.path) != null ? C : "");
              }

              var n = function () {
                function p() {}

                return p.findGroup = function (_, g) {
                  for (var s = 0; s < _.length; s++) {
                    var o = _[s];
                    if (o.id === g) return o;
                  }
                }, p.convertAVC1ToAVCOTI = function (_) {
                  var g = _.split(".");

                  if (g.length > 2) {
                    var s = g.shift() + ".";
                    return s += parseInt(g.shift()).toString(16), s += ("000" + parseInt(g.shift()).toString(16)).substr(-4), s;
                  }

                  return _;
                }, p.resolve = function (_, g) {
                  return x.buildAbsoluteURL(g, _, {
                    alwaysNormalize: !0
                  });
                }, p.parseMasterPlaylist = function (_, g) {
                  var s = [],
                      o = {},
                      b = !1;
                  P.lastIndex = 0;

                  for (var A; (A = P.exec(_)) != null;) if (A[1]) {
                    var I = new D.AttrList(A[1]),
                        M = {
                      attrs: I,
                      bitrate: I.decimalInteger("AVERAGE-BANDWIDTH") || I.decimalInteger("BANDWIDTH"),
                      name: I.NAME,
                      url: p.resolve(A[2], g)
                    },
                        F = I.decimalResolution("RESOLUTION");
                    F && (M.width = F.width, M.height = F.height), a((I.CODECS || "").split(/[ ,]+/).filter(function (U) {
                      return U;
                    }), M), M.videoCodec && M.videoCodec.indexOf("avc1") !== -1 && (M.videoCodec = p.convertAVC1ToAVCOTI(M.videoCodec)), s.push(M);
                  } else if (A[3]) {
                    var B = new D.AttrList(A[3]);
                    B["DATA-ID"] && (b = !0, o[B["DATA-ID"]] = B);
                  }

                  return {
                    levels: s,
                    sessionData: b ? o : null
                  };
                }, p.parseMasterPlaylistMedia = function (_, g, s, o) {
                  o === void 0 && (o = []);
                  var b,
                      A = [],
                      I = 0;

                  for (d.lastIndex = 0; (b = d.exec(_)) !== null;) {
                    var M = new D.AttrList(b[1]);

                    if (M.TYPE === s) {
                      var F = {
                        attrs: M,
                        bitrate: 0,
                        id: I++,
                        groupId: M["GROUP-ID"],
                        instreamId: M["INSTREAM-ID"],
                        name: M.NAME || M.LANGUAGE || "",
                        type: s,
                        default: M.bool("DEFAULT"),
                        autoselect: M.bool("AUTOSELECT"),
                        forced: M.bool("FORCED"),
                        lang: M.LANGUAGE,
                        url: M.URI ? p.resolve(M.URI, g) : ""
                      };

                      if (o.length) {
                        var B = p.findGroup(o, F.groupId) || o[0];
                        v(F, B, "audioCodec"), v(F, B, "textCodec");
                      }

                      A.push(F);
                    }
                  }

                  return A;
                }, p.parseLevelPlaylist = function (_, g, s, o, b) {
                  var A = new w.LevelDetails(g),
                      I = A.fragments,
                      M = null,
                      F = 0,
                      B = 0,
                      U = 0,
                      W = 0,
                      G = null,
                      V = new H.Fragment(o, g),
                      Y,
                      $,
                      q,
                      Z = -1,
                      te = !1;

                  for (f.lastIndex = 0, A.m3u8 = _; (Y = f.exec(_)) !== null;) {
                    te && (te = !1, V = new H.Fragment(o, g), V.start = U, V.sn = F, V.cc = W, V.level = s, M && (V.initSegment = M, V.rawProgramDateTime = M.rawProgramDateTime));
                    var se = Y[1];

                    if (se) {
                      V.duration = parseFloat(se);
                      var ge = (" " + Y[2]).slice(1);
                      V.title = ge || null, V.tagList.push(ge ? ["INF", se, ge] : ["INF", se]);
                    } else if (Y[3]) Object(j.isFiniteNumber)(V.duration) && (V.start = U, q && (V.levelkey = q), V.sn = F, V.level = s, V.cc = W, V.urlId = b, I.push(V), V.relurl = (" " + Y[3]).slice(1), c(V, G), G = V, U += V.duration, F++, B = 0, te = !0);else if (Y[4]) {
                      var he = (" " + Y[4]).slice(1);
                      G ? V.setByteRange(he, G) : V.setByteRange(he);
                    } else if (Y[5]) V.rawProgramDateTime = (" " + Y[5]).slice(1), V.tagList.push(["PROGRAM-DATE-TIME", V.rawProgramDateTime]), Z === -1 && (Z = I.length);else {
                      if (Y = Y[0].match(y), !Y) {
                        E.logger.warn("No matches on slow regex match for level playlist!");
                        continue;
                      }

                      for ($ = 1; $ < Y.length && typeof Y[$] == "undefined"; $++);

                      var ye = (" " + Y[$]).slice(1),
                          pe = (" " + Y[$ + 1]).slice(1),
                          _e = Y[$ + 2] ? (" " + Y[$ + 2]).slice(1) : "";

                      switch (ye) {
                        case "PLAYLIST-TYPE":
                          A.type = pe.toUpperCase();
                          break;

                        case "MEDIA-SEQUENCE":
                          F = A.startSN = parseInt(pe);
                          break;

                        case "SKIP":
                          {
                            var be = new D.AttrList(pe),
                                Le = be.decimalInteger("SKIPPED-SEGMENTS");

                            if (Object(j.isFiniteNumber)(Le)) {
                              A.skippedSegments = Le;

                              for (var we = Le; we--;) I.unshift(null);

                              F += Le;
                            }

                            var xe = be.enumeratedString("RECENTLY-REMOVED-DATERANGES");
                            xe && (A.recentlyRemovedDateranges = xe.split("	"));
                            break;
                          }

                        case "TARGETDURATION":
                          A.targetduration = parseFloat(pe);
                          break;

                        case "VERSION":
                          A.version = parseInt(pe);
                          break;

                        case "EXTM3U":
                          break;

                        case "ENDLIST":
                          A.live = !1;
                          break;

                        case "#":
                          (pe || _e) && V.tagList.push(_e ? [pe, _e] : [pe]);
                          break;

                        case "DIS":
                          W++;

                        case "GAP":
                          V.tagList.push([ye]);
                          break;

                        case "BITRATE":
                          V.tagList.push([ye, pe]);
                          break;

                        case "DISCONTINUITY-SEQ":
                          W = parseInt(pe);
                          break;

                        case "KEY":
                          {
                            var Ne,
                                Me = new D.AttrList(pe),
                                le = Me.enumeratedString("METHOD"),
                                ee = Me.URI,
                                oe = Me.hexadecimalInteger("IV"),
                                ue = Me.enumeratedString("KEYFORMATVERSIONS"),
                                re = Me.enumeratedString("KEYID"),
                                ne = (Ne = Me.enumeratedString("KEYFORMAT")) != null ? Ne : "identity",
                                ce = ["com.apple.streamingkeydelivery", "com.microsoft.playready", "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", "com.widevine"];

                            if (ce.indexOf(ne) > -1) {
                              E.logger.warn("Keyformat " + ne + " is not supported from the manifest");
                              continue;
                            } else if (ne !== "identity") continue;

                            le && (q = O.LevelKey.fromURL(g, ee), ee && ["AES-128", "SAMPLE-AES", "SAMPLE-AES-CENC"].indexOf(le) >= 0 && (q.method = le, q.keyFormat = ne, re && (q.keyID = re), ue && (q.keyFormatVersions = ue), q.iv = oe));
                            break;
                          }

                        case "START":
                          {
                            var me = new D.AttrList(pe),
                                Ae = me.decimalFloatingPoint("TIME-OFFSET");
                            Object(j.isFiniteNumber)(Ae) && (A.startTimeOffset = Ae);
                            break;
                          }

                        case "MAP":
                          {
                            var Ce = new D.AttrList(pe);
                            V.relurl = Ce.URI, Ce.BYTERANGE && V.setByteRange(Ce.BYTERANGE), V.level = s, V.sn = "initSegment", q && (V.levelkey = q), V.initSegment = null, M = V, te = !0;
                            break;
                          }

                        case "SERVER-CONTROL":
                          {
                            var Ie = new D.AttrList(pe);
                            A.canBlockReload = Ie.bool("CAN-BLOCK-RELOAD"), A.canSkipUntil = Ie.optionalFloat("CAN-SKIP-UNTIL", 0), A.canSkipDateRanges = A.canSkipUntil > 0 && Ie.bool("CAN-SKIP-DATERANGES"), A.partHoldBack = Ie.optionalFloat("PART-HOLD-BACK", 0), A.holdBack = Ie.optionalFloat("HOLD-BACK", 0);
                            break;
                          }

                        case "PART-INF":
                          {
                            var ke = new D.AttrList(pe);
                            A.partTarget = ke.decimalFloatingPoint("PART-TARGET");
                            break;
                          }

                        case "PART":
                          {
                            var De = A.partList;
                            De || (De = A.partList = []);
                            var Re = B > 0 ? De[De.length - 1] : void 0,
                                Ue = B++,
                                Je = new H.Part(new D.AttrList(pe), V, g, Ue, Re);
                            De.push(Je), V.duration += Je.duration;
                            break;
                          }

                        case "PRELOAD-HINT":
                          {
                            var it = new D.AttrList(pe);
                            A.preloadHint = it;
                            break;
                          }

                        case "RENDITION-REPORT":
                          {
                            var Et = new D.AttrList(pe);
                            A.renditionReports = A.renditionReports || [], A.renditionReports.push(Et);
                            break;
                          }

                        default:
                          E.logger.warn("line parsed but not handled: " + Y);
                          break;
                      }
                    }
                  }

                  G && !G.relurl ? (I.pop(), U -= G.duration, A.partList && (A.fragmentHint = G)) : A.partList && (c(V, G), V.cc = W, A.fragmentHint = V);
                  var ze = I.length,
                      We = I[0],
                      st = I[ze - 1];

                  if (U += A.skippedSegments * A.targetduration, U > 0 && ze && st) {
                    A.averagetargetduration = U / ze;
                    var vt = st.sn;
                    A.endSN = vt !== "initSegment" ? vt : 0, We && (A.startCC = We.cc, We.initSegment || A.fragments.every(function (Pe) {
                      return Pe.relurl && i(Pe.relurl);
                    }) && (E.logger.warn("MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX"), V = new H.Fragment(o, g), V.relurl = st.relurl, V.level = s, V.sn = "initSegment", We.initSegment = V, A.needSidxRanges = !0));
                  } else A.endSN = 0, A.startCC = 0;

                  return A.fragmentHint && (U += A.fragmentHint.duration), A.totalduration = U, A.endCC = W, Z > 0 && h(I, Z), A;
                }, p;
              }();

              function a(p, C) {
                ["video", "audio", "text"].forEach(function (_) {
                  var g = p.filter(function (o) {
                    return Object(L.isCodecType)(o, _);
                  });

                  if (g.length) {
                    var s = g.filter(function (o) {
                      return o.lastIndexOf("avc1", 0) === 0 || o.lastIndexOf("mp4a", 0) === 0;
                    });
                    C[_ + "Codec"] = s.length > 0 ? s[0] : g[0], p = p.filter(function (o) {
                      return g.indexOf(o) === -1;
                    });
                  }
                }), C.unknownCodecs = p;
              }

              function v(p, C, _) {
                var g = C[_];
                g && (p[_] = g);
              }

              function h(p, C) {
                for (var _ = p[C], g = C; g--;) {
                  var s = p[g];
                  if (!s) return;
                  s.programDateTime = _.programDateTime - s.duration * 1e3, _ = s;
                }
              }

              function c(p, C) {
                p.rawProgramDateTime ? p.programDateTime = Date.parse(p.rawProgramDateTime) : C != null && C.programDateTime && (p.programDateTime = C.endProgramDateTime), Object(j.isFiniteNumber)(p.programDateTime) || (p.programDateTime = null, p.rawProgramDateTime = null);
              }
            },
            "./src/loader/playlist-loader.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/events.ts"),
                  k = R("./src/errors.ts"),
                  H = R("./src/utils/logger.ts"),
                  w = R("./src/utils/mp4-tools.ts"),
                  O = R("./src/loader/m3u8-parser.ts"),
                  D = R("./src/types/loader.ts"),
                  E = R("./src/utils/attr-list.ts");

              function L(f) {
                var y = f.type;

                switch (y) {
                  case D.PlaylistContextType.AUDIO_TRACK:
                    return D.PlaylistLevelType.AUDIO;

                  case D.PlaylistContextType.SUBTITLE_TRACK:
                    return D.PlaylistLevelType.SUBTITLE;

                  default:
                    return D.PlaylistLevelType.MAIN;
                }
              }

              function P(f, y) {
                var u = f.url;
                return (u === void 0 || u.indexOf("data:") === 0) && (u = y.url), u;
              }

              var d = function () {
                function f(u) {
                  this.hls = void 0, this.loaders = Object.create(null), this.hls = u, this.registerListeners();
                }

                var y = f.prototype;
                return y.registerListeners = function () {
                  var i = this.hls;
                  i.on(x.Events.MANIFEST_LOADING, this.onManifestLoading, this), i.on(x.Events.LEVEL_LOADING, this.onLevelLoading, this), i.on(x.Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), i.on(x.Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
                }, y.unregisterListeners = function () {
                  var i = this.hls;
                  i.off(x.Events.MANIFEST_LOADING, this.onManifestLoading, this), i.off(x.Events.LEVEL_LOADING, this.onLevelLoading, this), i.off(x.Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), i.off(x.Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
                }, y.createInternalLoader = function (i) {
                  var n = this.hls.config,
                      a = n.pLoader,
                      v = n.loader,
                      h = a || v,
                      c = new h(n);
                  return i.loader = c, this.loaders[i.type] = c, c;
                }, y.getInternalLoader = function (i) {
                  return this.loaders[i.type];
                }, y.resetInternalLoader = function (i) {
                  this.loaders[i] && delete this.loaders[i];
                }, y.destroyInternalLoaders = function () {
                  for (var i in this.loaders) {
                    var n = this.loaders[i];
                    n && n.destroy(), this.resetInternalLoader(i);
                  }
                }, y.destroy = function () {
                  this.unregisterListeners(), this.destroyInternalLoaders();
                }, y.onManifestLoading = function (i, n) {
                  var a = n.url;
                  this.load({
                    id: null,
                    groupId: null,
                    level: 0,
                    responseType: "text",
                    type: D.PlaylistContextType.MANIFEST,
                    url: a,
                    deliveryDirectives: null
                  });
                }, y.onLevelLoading = function (i, n) {
                  var a = n.id,
                      v = n.level,
                      h = n.url,
                      c = n.deliveryDirectives;
                  this.load({
                    id: a,
                    groupId: null,
                    level: v,
                    responseType: "text",
                    type: D.PlaylistContextType.LEVEL,
                    url: h,
                    deliveryDirectives: c
                  });
                }, y.onAudioTrackLoading = function (i, n) {
                  var a = n.id,
                      v = n.groupId,
                      h = n.url,
                      c = n.deliveryDirectives;
                  this.load({
                    id: a,
                    groupId: v,
                    level: null,
                    responseType: "text",
                    type: D.PlaylistContextType.AUDIO_TRACK,
                    url: h,
                    deliveryDirectives: c
                  });
                }, y.onSubtitleTrackLoading = function (i, n) {
                  var a = n.id,
                      v = n.groupId,
                      h = n.url,
                      c = n.deliveryDirectives;
                  this.load({
                    id: a,
                    groupId: v,
                    level: null,
                    responseType: "text",
                    type: D.PlaylistContextType.SUBTITLE_TRACK,
                    url: h,
                    deliveryDirectives: c
                  });
                }, y.load = function (i) {
                  var n,
                      a = this.hls.config,
                      v = this.getInternalLoader(i);

                  if (v) {
                    var h = v.context;

                    if (h && h.url === i.url) {
                      H.logger.trace("[playlist-loader]: playlist request ongoing");
                      return;
                    }

                    H.logger.log("[playlist-loader]: aborting previous loader for type: " + i.type), v.abort();
                  }

                  var c, p, C, _;

                  switch (i.type) {
                    case D.PlaylistContextType.MANIFEST:
                      c = a.manifestLoadingMaxRetry, p = a.manifestLoadingTimeOut, C = a.manifestLoadingRetryDelay, _ = a.manifestLoadingMaxRetryTimeout;
                      break;

                    case D.PlaylistContextType.LEVEL:
                    case D.PlaylistContextType.AUDIO_TRACK:
                    case D.PlaylistContextType.SUBTITLE_TRACK:
                      c = 0, p = a.levelLoadingTimeOut;
                      break;

                    default:
                      c = a.levelLoadingMaxRetry, p = a.levelLoadingTimeOut, C = a.levelLoadingRetryDelay, _ = a.levelLoadingMaxRetryTimeout;
                      break;
                  }

                  if (v = this.createInternalLoader(i), (n = i.deliveryDirectives) !== null && n !== void 0 && n.part) {
                    var g;

                    if (i.type === D.PlaylistContextType.LEVEL && i.level !== null ? g = this.hls.levels[i.level].details : i.type === D.PlaylistContextType.AUDIO_TRACK && i.id !== null ? g = this.hls.audioTracks[i.id].details : i.type === D.PlaylistContextType.SUBTITLE_TRACK && i.id !== null && (g = this.hls.subtitleTracks[i.id].details), g) {
                      var s = g.partTarget,
                          o = g.targetduration;
                      s && o && (p = Math.min(Math.max(s * 3, o * .8) * 1e3, p));
                    }
                  }

                  var b = {
                    timeout: p,
                    maxRetry: c,
                    retryDelay: C,
                    maxRetryDelay: _,
                    highWaterMark: 0
                  },
                      A = {
                    onSuccess: this.loadsuccess.bind(this),
                    onError: this.loaderror.bind(this),
                    onTimeout: this.loadtimeout.bind(this)
                  };
                  v.load(i, b, A);
                }, y.loadsuccess = function (i, n, a, v) {
                  if (v === void 0 && (v = null), a.isSidxRequest) {
                    this.handleSidxRequest(i, a), this.handlePlaylistLoaded(i, n, a, v);
                    return;
                  }

                  this.resetInternalLoader(a.type);
                  var h = i.data;

                  if (h.indexOf("#EXTM3U") !== 0) {
                    this.handleManifestParsingError(i, a, "no EXTM3U delimiter", v);
                    return;
                  }

                  n.parsing.start = performance.now(), h.indexOf("#EXTINF:") > 0 || h.indexOf("#EXT-X-TARGETDURATION:") > 0 ? this.handleTrackOrLevelPlaylist(i, n, a, v) : this.handleMasterPlaylist(i, n, a, v);
                }, y.loaderror = function (i, n, a) {
                  a === void 0 && (a = null), this.handleNetworkError(n, a, !1, i);
                }, y.loadtimeout = function (i, n, a) {
                  a === void 0 && (a = null), this.handleNetworkError(n, a, !0);
                }, y.handleMasterPlaylist = function (i, n, a, v) {
                  var h = this.hls,
                      c = i.data,
                      p = P(i, a),
                      C = O.default.parseMasterPlaylist(c, p),
                      _ = C.levels,
                      g = C.sessionData;

                  if (!_.length) {
                    this.handleManifestParsingError(i, a, "no level found in manifest", v);
                    return;
                  }

                  var s = _.map(function (F) {
                    return {
                      id: F.attrs.AUDIO,
                      audioCodec: F.audioCodec
                    };
                  }),
                      o = _.map(function (F) {
                    return {
                      id: F.attrs.SUBTITLES,
                      textCodec: F.textCodec
                    };
                  }),
                      b = O.default.parseMasterPlaylistMedia(c, p, "AUDIO", s),
                      A = O.default.parseMasterPlaylistMedia(c, p, "SUBTITLES", o),
                      I = O.default.parseMasterPlaylistMedia(c, p, "CLOSED-CAPTIONS");

                  if (b.length) {
                    var M = b.some(function (F) {
                      return !F.url;
                    });
                    !M && _[0].audioCodec && !_[0].attrs.AUDIO && (H.logger.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), b.unshift({
                      type: "main",
                      name: "main",
                      default: !1,
                      autoselect: !1,
                      forced: !1,
                      id: -1,
                      attrs: new E.AttrList({}),
                      bitrate: 0,
                      url: ""
                    }));
                  }

                  h.trigger(x.Events.MANIFEST_LOADED, {
                    levels: _,
                    audioTracks: b,
                    subtitles: A,
                    captions: I,
                    url: p,
                    stats: n,
                    networkDetails: v,
                    sessionData: g
                  });
                }, y.handleTrackOrLevelPlaylist = function (i, n, a, v) {
                  var h = this.hls,
                      c = a.id,
                      p = a.level,
                      C = a.type,
                      _ = P(i, a),
                      g = Object(j.isFiniteNumber)(c) ? c : 0,
                      s = Object(j.isFiniteNumber)(p) ? p : g,
                      o = L(a),
                      b = O.default.parseLevelPlaylist(i.data, _, s, o, g);

                  if (!b.fragments.length) {
                    h.trigger(x.Events.ERROR, {
                      type: k.ErrorTypes.NETWORK_ERROR,
                      details: k.ErrorDetails.LEVEL_EMPTY_ERROR,
                      fatal: !1,
                      url: _,
                      reason: "no fragments found in level",
                      level: typeof a.level == "number" ? a.level : void 0
                    });
                    return;
                  }

                  if (C === D.PlaylistContextType.MANIFEST) {
                    var A = {
                      attrs: new E.AttrList({}),
                      bitrate: 0,
                      details: b,
                      name: "",
                      url: _
                    };
                    h.trigger(x.Events.MANIFEST_LOADED, {
                      levels: [A],
                      audioTracks: [],
                      url: _,
                      stats: n,
                      networkDetails: v,
                      sessionData: null
                    });
                  }

                  if (n.parsing.end = performance.now(), b.needSidxRanges) {
                    var I,
                        M = (I = b.fragments[0].initSegment) === null || I === void 0 ? void 0 : I.url;
                    this.load({
                      url: M,
                      isSidxRequest: !0,
                      type: C,
                      level: p,
                      levelDetails: b,
                      id: c,
                      groupId: null,
                      rangeStart: 0,
                      rangeEnd: 2048,
                      responseType: "arraybuffer",
                      deliveryDirectives: null
                    });
                    return;
                  }

                  a.levelDetails = b, this.handlePlaylistLoaded(i, n, a, v);
                }, y.handleSidxRequest = function (i, n) {
                  var a = Object(w.parseSegmentIndex)(new Uint8Array(i.data));

                  if (!!a) {
                    var v = a.references,
                        h = n.levelDetails;
                    v.forEach(function (c, p) {
                      var C = c.info,
                          _ = h.fragments[p];
                      _.byteRange.length === 0 && _.setByteRange(String(1 + C.end - C.start) + "@" + String(C.start)), _.initSegment && _.initSegment.setByteRange(String(a.moovEndOffset) + "@0");
                    });
                  }
                }, y.handleManifestParsingError = function (i, n, a, v) {
                  this.hls.trigger(x.Events.ERROR, {
                    type: k.ErrorTypes.NETWORK_ERROR,
                    details: k.ErrorDetails.MANIFEST_PARSING_ERROR,
                    fatal: n.type === D.PlaylistContextType.MANIFEST,
                    url: i.url,
                    reason: a,
                    response: i,
                    context: n,
                    networkDetails: v
                  });
                }, y.handleNetworkError = function (i, n, a, v) {
                  a === void 0 && (a = !1), H.logger.warn("[playlist-loader]: A network " + (a ? "timeout" : "error") + " occurred while loading " + i.type + " level: " + i.level + " id: " + i.id + ' group-id: "' + i.groupId + '"');
                  var h = k.ErrorDetails.UNKNOWN,
                      c = !1,
                      p = this.getInternalLoader(i);

                  switch (i.type) {
                    case D.PlaylistContextType.MANIFEST:
                      h = a ? k.ErrorDetails.MANIFEST_LOAD_TIMEOUT : k.ErrorDetails.MANIFEST_LOAD_ERROR, c = !0;
                      break;

                    case D.PlaylistContextType.LEVEL:
                      h = a ? k.ErrorDetails.LEVEL_LOAD_TIMEOUT : k.ErrorDetails.LEVEL_LOAD_ERROR, c = !1;
                      break;

                    case D.PlaylistContextType.AUDIO_TRACK:
                      h = a ? k.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : k.ErrorDetails.AUDIO_TRACK_LOAD_ERROR, c = !1;
                      break;

                    case D.PlaylistContextType.SUBTITLE_TRACK:
                      h = a ? k.ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : k.ErrorDetails.SUBTITLE_LOAD_ERROR, c = !1;
                      break;
                  }

                  p && this.resetInternalLoader(i.type);
                  var C = {
                    type: k.ErrorTypes.NETWORK_ERROR,
                    details: h,
                    fatal: c,
                    url: i.url,
                    loader: p,
                    context: i,
                    networkDetails: n
                  };
                  v && (C.response = v), this.hls.trigger(x.Events.ERROR, C);
                }, y.handlePlaylistLoaded = function (i, n, a, v) {
                  var h = a.type,
                      c = a.level,
                      p = a.id,
                      C = a.groupId,
                      _ = a.loader,
                      g = a.levelDetails,
                      s = a.deliveryDirectives;

                  if (!(g != null && g.targetduration)) {
                    this.handleManifestParsingError(i, a, "invalid target duration", v);
                    return;
                  }

                  if (!!_) switch (g.live && (_.getCacheAge && (g.ageHeader = _.getCacheAge() || 0), (!_.getCacheAge || isNaN(g.ageHeader)) && (g.ageHeader = 0)), h) {
                    case D.PlaylistContextType.MANIFEST:
                    case D.PlaylistContextType.LEVEL:
                      this.hls.trigger(x.Events.LEVEL_LOADED, {
                        details: g,
                        level: c || 0,
                        id: p || 0,
                        stats: n,
                        networkDetails: v,
                        deliveryDirectives: s
                      });
                      break;

                    case D.PlaylistContextType.AUDIO_TRACK:
                      this.hls.trigger(x.Events.AUDIO_TRACK_LOADED, {
                        details: g,
                        id: p || 0,
                        groupId: C || "",
                        stats: n,
                        networkDetails: v,
                        deliveryDirectives: s
                      });
                      break;

                    case D.PlaylistContextType.SUBTITLE_TRACK:
                      this.hls.trigger(x.Events.SUBTITLE_TRACK_LOADED, {
                        details: g,
                        id: p || 0,
                        groupId: C || "",
                        stats: n,
                        networkDetails: v,
                        deliveryDirectives: s
                      });
                      break;
                  }
                }, f;
              }();

              K.default = d;
            },
            "./src/polyfills/number.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "isFiniteNumber", function () {
                return j;
              }), R.d(K, "MAX_SAFE_INTEGER", function () {
                return x;
              });

              var j = Number.isFinite || function (k) {
                return typeof k == "number" && isFinite(k);
              },
                  x = Number.MAX_SAFE_INTEGER || 9007199254740991;
            },
            "./src/remux/aac-helper.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = function () {
                function x() {}

                return x.getSilentFrame = function (H, w) {
                  switch (H) {
                    case "mp4a.40.2":
                      if (w === 1) return new Uint8Array([0, 200, 0, 128, 35, 128]);
                      if (w === 2) return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
                      if (w === 3) return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
                      if (w === 4) return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
                      if (w === 5) return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
                      if (w === 6) return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
                      break;

                    default:
                      if (w === 1) return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      if (w === 2) return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      if (w === 3) return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      break;
                  }
                }, x;
              }();

              K.default = j;
            },
            "./src/remux/mp4-generator.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = Math.pow(2, 32) - 1,
                  x = function () {
                function k() {}

                return k.init = function () {
                  k.types = {
                    avc1: [],
                    avcC: [],
                    btrt: [],
                    dinf: [],
                    dref: [],
                    esds: [],
                    ftyp: [],
                    hdlr: [],
                    mdat: [],
                    mdhd: [],
                    mdia: [],
                    mfhd: [],
                    minf: [],
                    moof: [],
                    moov: [],
                    mp4a: [],
                    ".mp3": [],
                    mvex: [],
                    mvhd: [],
                    pasp: [],
                    sdtp: [],
                    stbl: [],
                    stco: [],
                    stsc: [],
                    stsd: [],
                    stsz: [],
                    stts: [],
                    tfdt: [],
                    tfhd: [],
                    traf: [],
                    trak: [],
                    trun: [],
                    trex: [],
                    tkhd: [],
                    vmhd: [],
                    smhd: []
                  };
                  var w;

                  for (w in k.types) k.types.hasOwnProperty(w) && (k.types[w] = [w.charCodeAt(0), w.charCodeAt(1), w.charCodeAt(2), w.charCodeAt(3)]);

                  var O = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 118, 105, 100, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 86, 105, 100, 101, 111, 72, 97, 110, 100, 108, 101, 114, 0]),
                      D = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 115, 111, 117, 110, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 83, 111, 117, 110, 100, 72, 97, 110, 100, 108, 101, 114, 0]);
                  k.HDLR_TYPES = {
                    video: O,
                    audio: D
                  };
                  var E = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 12, 117, 114, 108, 32, 0, 0, 0, 1]),
                      L = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
                  k.STTS = k.STSC = k.STCO = L, k.STSZ = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), k.VMHD = new Uint8Array([0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0]), k.SMHD = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]), k.STSD = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1]);
                  var P = new Uint8Array([105, 115, 111, 109]),
                      d = new Uint8Array([97, 118, 99, 49]),
                      f = new Uint8Array([0, 0, 0, 1]);
                  k.FTYP = k.box(k.types.ftyp, P, f, P, d), k.DINF = k.box(k.types.dinf, k.box(k.types.dref, E));
                }, k.box = function (w) {
                  for (var O = 8, D = arguments.length, E = new Array(D > 1 ? D - 1 : 0), L = 1; L < D; L++) E[L - 1] = arguments[L];

                  for (var P = E.length, d = P; P--;) O += E[P].byteLength;

                  var f = new Uint8Array(O);

                  for (f[0] = O >> 24 & 255, f[1] = O >> 16 & 255, f[2] = O >> 8 & 255, f[3] = O & 255, f.set(w, 4), P = 0, O = 8; P < d; P++) f.set(E[P], O), O += E[P].byteLength;

                  return f;
                }, k.hdlr = function (w) {
                  return k.box(k.types.hdlr, k.HDLR_TYPES[w]);
                }, k.mdat = function (w) {
                  return k.box(k.types.mdat, w);
                }, k.mdhd = function (w, O) {
                  O *= w;
                  var D = Math.floor(O / (j + 1)),
                      E = Math.floor(O % (j + 1));
                  return k.box(k.types.mdhd, new Uint8Array([1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, w >> 24 & 255, w >> 16 & 255, w >> 8 & 255, w & 255, D >> 24, D >> 16 & 255, D >> 8 & 255, D & 255, E >> 24, E >> 16 & 255, E >> 8 & 255, E & 255, 85, 196, 0, 0]));
                }, k.mdia = function (w) {
                  return k.box(k.types.mdia, k.mdhd(w.timescale, w.duration), k.hdlr(w.type), k.minf(w));
                }, k.mfhd = function (w) {
                  return k.box(k.types.mfhd, new Uint8Array([0, 0, 0, 0, w >> 24, w >> 16 & 255, w >> 8 & 255, w & 255]));
                }, k.minf = function (w) {
                  return w.type === "audio" ? k.box(k.types.minf, k.box(k.types.smhd, k.SMHD), k.DINF, k.stbl(w)) : k.box(k.types.minf, k.box(k.types.vmhd, k.VMHD), k.DINF, k.stbl(w));
                }, k.moof = function (w, O, D) {
                  return k.box(k.types.moof, k.mfhd(w), k.traf(D, O));
                }, k.moov = function (w) {
                  for (var O = w.length, D = []; O--;) D[O] = k.trak(w[O]);

                  return k.box.apply(null, [k.types.moov, k.mvhd(w[0].timescale, w[0].duration)].concat(D).concat(k.mvex(w)));
                }, k.mvex = function (w) {
                  for (var O = w.length, D = []; O--;) D[O] = k.trex(w[O]);

                  return k.box.apply(null, [k.types.mvex].concat(D));
                }, k.mvhd = function (w, O) {
                  O *= w;
                  var D = Math.floor(O / (j + 1)),
                      E = Math.floor(O % (j + 1)),
                      L = new Uint8Array([1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, w >> 24 & 255, w >> 16 & 255, w >> 8 & 255, w & 255, D >> 24, D >> 16 & 255, D >> 8 & 255, D & 255, E >> 24, E >> 16 & 255, E >> 8 & 255, E & 255, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 255, 255, 255]);
                  return k.box(k.types.mvhd, L);
                }, k.sdtp = function (w) {
                  var O = w.samples || [],
                      D = new Uint8Array(4 + O.length),
                      E,
                      L;

                  for (E = 0; E < O.length; E++) L = O[E].flags, D[E + 4] = L.dependsOn << 4 | L.isDependedOn << 2 | L.hasRedundancy;

                  return k.box(k.types.sdtp, D);
                }, k.stbl = function (w) {
                  return k.box(k.types.stbl, k.stsd(w), k.box(k.types.stts, k.STTS), k.box(k.types.stsc, k.STSC), k.box(k.types.stsz, k.STSZ), k.box(k.types.stco, k.STCO));
                }, k.avc1 = function (w) {
                  var O = [],
                      D = [],
                      E,
                      L,
                      P;

                  for (E = 0; E < w.sps.length; E++) L = w.sps[E], P = L.byteLength, O.push(P >>> 8 & 255), O.push(P & 255), O = O.concat(Array.prototype.slice.call(L));

                  for (E = 0; E < w.pps.length; E++) L = w.pps[E], P = L.byteLength, D.push(P >>> 8 & 255), D.push(P & 255), D = D.concat(Array.prototype.slice.call(L));

                  var d = k.box(k.types.avcC, new Uint8Array([1, O[3], O[4], O[5], 252 | 3, 224 | w.sps.length].concat(O).concat([w.pps.length]).concat(D))),
                      f = w.width,
                      y = w.height,
                      u = w.pixelRatio[0],
                      i = w.pixelRatio[1];
                  return k.box(k.types.avc1, new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, f >> 8 & 255, f & 255, y >> 8 & 255, y & 255, 0, 72, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 1, 18, 100, 97, 105, 108, 121, 109, 111, 116, 105, 111, 110, 47, 104, 108, 115, 46, 106, 115, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 17, 17]), d, k.box(k.types.btrt, new Uint8Array([0, 28, 156, 128, 0, 45, 198, 192, 0, 45, 198, 192])), k.box(k.types.pasp, new Uint8Array([u >> 24, u >> 16 & 255, u >> 8 & 255, u & 255, i >> 24, i >> 16 & 255, i >> 8 & 255, i & 255])));
                }, k.esds = function (w) {
                  var O = w.config.length;
                  return new Uint8Array([0, 0, 0, 0, 3, 23 + O, 0, 1, 0, 4, 15 + O, 64, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5].concat([O]).concat(w.config).concat([6, 1, 2]));
                }, k.mp4a = function (w) {
                  var O = w.samplerate;
                  return k.box(k.types.mp4a, new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, w.channelCount, 0, 16, 0, 0, 0, 0, O >> 8 & 255, O & 255, 0, 0]), k.box(k.types.esds, k.esds(w)));
                }, k.mp3 = function (w) {
                  var O = w.samplerate;
                  return k.box(k.types[".mp3"], new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, w.channelCount, 0, 16, 0, 0, 0, 0, O >> 8 & 255, O & 255, 0, 0]));
                }, k.stsd = function (w) {
                  return w.type === "audio" ? !w.isAAC && w.codec === "mp3" ? k.box(k.types.stsd, k.STSD, k.mp3(w)) : k.box(k.types.stsd, k.STSD, k.mp4a(w)) : k.box(k.types.stsd, k.STSD, k.avc1(w));
                }, k.tkhd = function (w) {
                  var O = w.id,
                      D = w.duration * w.timescale,
                      E = w.width,
                      L = w.height,
                      P = Math.floor(D / (j + 1)),
                      d = Math.floor(D % (j + 1));
                  return k.box(k.types.tkhd, new Uint8Array([1, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, O >> 24 & 255, O >> 16 & 255, O >> 8 & 255, O & 255, 0, 0, 0, 0, P >> 24, P >> 16 & 255, P >> 8 & 255, P & 255, d >> 24, d >> 16 & 255, d >> 8 & 255, d & 255, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, E >> 8 & 255, E & 255, 0, 0, L >> 8 & 255, L & 255, 0, 0]));
                }, k.traf = function (w, O) {
                  var D = k.sdtp(w),
                      E = w.id,
                      L = Math.floor(O / (j + 1)),
                      P = Math.floor(O % (j + 1));
                  return k.box(k.types.traf, k.box(k.types.tfhd, new Uint8Array([0, 0, 0, 0, E >> 24, E >> 16 & 255, E >> 8 & 255, E & 255])), k.box(k.types.tfdt, new Uint8Array([1, 0, 0, 0, L >> 24, L >> 16 & 255, L >> 8 & 255, L & 255, P >> 24, P >> 16 & 255, P >> 8 & 255, P & 255])), k.trun(w, D.length + 16 + 20 + 8 + 16 + 8 + 8), D);
                }, k.trak = function (w) {
                  return w.duration = w.duration || 4294967295, k.box(k.types.trak, k.tkhd(w), k.mdia(w));
                }, k.trex = function (w) {
                  var O = w.id;
                  return k.box(k.types.trex, new Uint8Array([0, 0, 0, 0, O >> 24, O >> 16 & 255, O >> 8 & 255, O & 255, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1]));
                }, k.trun = function (w, O) {
                  var D = w.samples || [],
                      E = D.length,
                      L = 12 + 16 * E,
                      P = new Uint8Array(L),
                      d,
                      f,
                      y,
                      u,
                      i,
                      n;

                  for (O += 8 + L, P.set([0, 0, 15, 1, E >>> 24 & 255, E >>> 16 & 255, E >>> 8 & 255, E & 255, O >>> 24 & 255, O >>> 16 & 255, O >>> 8 & 255, O & 255], 0), d = 0; d < E; d++) f = D[d], y = f.duration, u = f.size, i = f.flags, n = f.cts, P.set([y >>> 24 & 255, y >>> 16 & 255, y >>> 8 & 255, y & 255, u >>> 24 & 255, u >>> 16 & 255, u >>> 8 & 255, u & 255, i.isLeading << 2 | i.dependsOn, i.isDependedOn << 6 | i.hasRedundancy << 4 | i.paddingValue << 1 | i.isNonSync, i.degradPrio & 240 << 8, i.degradPrio & 15, n >>> 24 & 255, n >>> 16 & 255, n >>> 8 & 255, n & 255], 12 + 16 * d);

                  return k.box(k.types.trun, P);
                }, k.initSegment = function (w) {
                  k.types || k.init();
                  var O = k.moov(w),
                      D = new Uint8Array(k.FTYP.byteLength + O.byteLength);
                  return D.set(k.FTYP), D.set(O, k.FTYP.byteLength), D;
                }, k;
              }();

              x.types = void 0, x.HDLR_TYPES = void 0, x.STTS = void 0, x.STSC = void 0, x.STCO = void 0, x.STSZ = void 0, x.VMHD = void 0, x.SMHD = void 0, x.STSD = void 0, x.FTYP = void 0, x.DINF = void 0, K.default = x;
            },
            "./src/remux/mp4-remuxer.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return n;
              }), R.d(K, "normalizePts", function () {
                return a;
              });
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/remux/aac-helper.ts"),
                  k = R("./src/remux/mp4-generator.ts"),
                  H = R("./src/events.ts"),
                  w = R("./src/errors.ts"),
                  O = R("./src/utils/logger.ts"),
                  D = R("./src/types/loader.ts"),
                  E = R("./src/utils/timescale-conversion.ts");

              function L() {
                return L = Object.assign || function (p) {
                  for (var C = 1; C < arguments.length; C++) {
                    var _ = arguments[C];

                    for (var g in _) Object.prototype.hasOwnProperty.call(_, g) && (p[g] = _[g]);
                  }

                  return p;
                }, L.apply(this, arguments);
              }

              var P = 10 * 1e3,
                  d = 1024,
                  f = 1152,
                  y = null,
                  u = null,
                  i = !1,
                  n = function () {
                function p(_, g, s, o) {
                  if (o === void 0 && (o = ""), this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = void 0, this._initDTS = void 0, this.nextAvcDts = null, this.nextAudioPts = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.observer = _, this.config = g, this.typeSupported = s, this.ISGenerated = !1, y === null) {
                    var b = navigator.userAgent || "",
                        A = b.match(/Chrome\/(\d+)/i);
                    y = A ? parseInt(A[1]) : 0;
                  }

                  if (u === null) {
                    var I = navigator.userAgent.match(/Safari\/(\d+)/i);
                    u = I ? parseInt(I[1]) : 0;
                  }

                  i = !!y && y < 75 || !!u && u < 600;
                }

                var C = p.prototype;
                return C.destroy = function () {}, C.resetTimeStamp = function (g) {
                  O.logger.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = g;
                }, C.resetNextTimestamp = function () {
                  O.logger.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
                }, C.resetInitSegment = function () {
                  O.logger.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1;
                }, C.getVideoStartPts = function (g) {
                  var s = !1,
                      o = g.reduce(function (b, A) {
                    var I = A.pts - b;
                    return I < -4294967296 ? (s = !0, a(b, A.pts)) : I > 0 ? b : A.pts;
                  }, g[0].pts);
                  return s && O.logger.debug("PTS rollover detected"), o;
                }, C.remux = function (g, s, o, b, A, I, M, F) {
                  var B,
                      U,
                      W,
                      G,
                      V,
                      Y,
                      $ = A,
                      q = A,
                      Z = g.pid > -1,
                      te = s.pid > -1,
                      se = s.samples.length,
                      ge = g.samples.length > 0,
                      he = se > 1,
                      ye = (!Z || ge) && (!te || he) || this.ISGenerated || M;

                  if (ye) {
                    this.ISGenerated || (W = this.generateIS(g, s, A));

                    var pe = this.isVideoContiguous,
                        _e = -1;

                    if (he && (_e = v(s.samples), !pe && this.config.forceKeyFrameOnDiscontinuity)) if (Y = !0, _e > 0) {
                      O.logger.warn("[mp4-remuxer]: Dropped " + _e + " out of " + se + " video samples due to a missing keyframe");
                      var be = this.getVideoStartPts(s.samples);
                      s.samples = s.samples.slice(_e), s.dropped += _e, q += (s.samples[0].pts - be) / (s.timescale || 9e4);
                    } else _e === -1 && (O.logger.warn("[mp4-remuxer]: No keyframe found out of " + se + " video samples"), Y = !1);

                    if (this.ISGenerated) {
                      if (ge && he) {
                        var Le = this.getVideoStartPts(s.samples),
                            we = a(g.samples[0].pts, Le) - Le,
                            xe = we / s.inputTimeScale;
                        $ += Math.max(0, xe), q += Math.max(0, -xe);
                      }

                      if (ge) {
                        if (g.samplerate || (O.logger.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), W = this.generateIS(g, s, A)), U = this.remuxAudio(g, $, this.isAudioContiguous, I, te || he || F === D.PlaylistLevelType.AUDIO ? q : void 0), he) {
                          var Ne = U ? U.endPTS - U.startPTS : 0;
                          s.inputTimeScale || (O.logger.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), W = this.generateIS(g, s, A)), B = this.remuxVideo(s, q, pe, Ne);
                        }
                      } else he && (B = this.remuxVideo(s, q, pe, 0));

                      B && (B.firstKeyFrame = _e, B.independent = _e !== -1);
                    }
                  }

                  return this.ISGenerated && (o.samples.length && (V = this.remuxID3(o, A)), b.samples.length && (G = this.remuxText(b, A))), {
                    audio: U,
                    video: B,
                    initSegment: W,
                    independent: Y,
                    text: G,
                    id3: V
                  };
                }, C.generateIS = function (g, s, o) {
                  var b = g.samples,
                      A = s.samples,
                      I = this.typeSupported,
                      M = {},
                      F = !Object(j.isFiniteNumber)(this._initPTS),
                      B = "audio/mp4",
                      U,
                      W,
                      G;

                  if (F && (U = W = 1 / 0), g.config && b.length && (g.timescale = g.samplerate, g.isAAC || (I.mpeg ? (B = "audio/mpeg", g.codec = "") : I.mp3 && (g.codec = "mp3")), M.audio = {
                    id: "audio",
                    container: B,
                    codec: g.codec,
                    initSegment: !g.isAAC && I.mpeg ? new Uint8Array(0) : k.default.initSegment([g]),
                    metadata: {
                      channelCount: g.channelCount
                    }
                  }, F && (G = g.inputTimeScale, U = W = b[0].pts - Math.round(G * o))), s.sps && s.pps && A.length && (s.timescale = s.inputTimeScale, M.video = {
                    id: "main",
                    container: "video/mp4",
                    codec: s.codec,
                    initSegment: k.default.initSegment([s]),
                    metadata: {
                      width: s.width,
                      height: s.height
                    }
                  }, F)) {
                    G = s.inputTimeScale;
                    var V = this.getVideoStartPts(A),
                        Y = Math.round(G * o);
                    W = Math.min(W, a(A[0].dts, V) - Y), U = Math.min(U, V - Y);
                  }

                  if (Object.keys(M).length) return this.ISGenerated = !0, F && (this._initPTS = U, this._initDTS = W), {
                    tracks: M,
                    initPTS: U,
                    timescale: G
                  };
                }, C.remuxVideo = function (g, s, o, b) {
                  var A = g.inputTimeScale,
                      I = g.samples,
                      M = [],
                      F = I.length,
                      B = this._initPTS,
                      U = this.nextAvcDts,
                      W = 8,
                      G,
                      V,
                      Y,
                      $ = Number.POSITIVE_INFINITY,
                      q = Number.NEGATIVE_INFINITY,
                      Z = 0,
                      te = !1;

                  if (!o || U === null) {
                    var se = s * A,
                        ge = I[0].pts - a(I[0].dts, I[0].pts);
                    U = se - ge;
                  }

                  for (var he = 0; he < F; he++) {
                    var ye = I[he];

                    if (ye.pts = a(ye.pts - B, U), ye.dts = a(ye.dts - B, U), ye.dts > ye.pts) {
                      var pe = 9e4 * .2;
                      Z = Math.max(Math.min(Z, ye.pts - ye.dts), -1 * pe);
                    }

                    ye.dts < I[he > 0 ? he - 1 : he].dts && (te = !0);
                  }

                  te && I.sort(function (Ze, jt) {
                    var pt = Ze.dts - jt.dts,
                        Dt = Ze.pts - jt.pts;
                    return pt || Dt;
                  }), V = I[0].dts, Y = I[I.length - 1].dts;

                  var _e = Math.round((Y - V) / (F - 1));

                  if (Z < 0) {
                    if (Z < _e * -2) {
                      O.logger.warn("PTS < DTS detected in video samples, offsetting DTS from PTS by " + Object(E.toMsFromMpegTsClock)(-_e, !0) + " ms");

                      for (var be = Z, Le = 0; Le < F; Le++) I[Le].dts = be = Math.max(be, I[Le].pts - _e), I[Le].pts = Math.max(be, I[Le].pts);
                    } else {
                      O.logger.warn("PTS < DTS detected in video samples, shifting DTS by " + Object(E.toMsFromMpegTsClock)(Z, !0) + " ms to overcome this issue");

                      for (var we = 0; we < F; we++) I[we].dts = I[we].dts + Z;
                    }

                    V = I[0].dts;
                  }

                  if (o) {
                    var xe = V - U,
                        Ne = xe > _e,
                        Me = xe < -1;

                    if (Ne || Me) {
                      Ne ? O.logger.warn("AVC: " + Object(E.toMsFromMpegTsClock)(xe, !0) + " ms (" + xe + "dts) hole between fragments detected, filling it") : O.logger.warn("AVC: " + Object(E.toMsFromMpegTsClock)(-xe, !0) + " ms (" + xe + "dts) overlapping between fragments detected"), V = U;
                      var le = I[0].pts - xe;
                      I[0].dts = V, I[0].pts = le, O.logger.log("Video: First PTS/DTS adjusted: " + Object(E.toMsFromMpegTsClock)(le, !0) + "/" + Object(E.toMsFromMpegTsClock)(V, !0) + ", delta: " + Object(E.toMsFromMpegTsClock)(xe, !0) + " ms");
                    }
                  }

                  i && (V = Math.max(0, V));

                  for (var ee = 0, oe = 0, ue = 0; ue < F; ue++) {
                    for (var re = I[ue], ne = re.units, ce = ne.length, me = 0, Ae = 0; Ae < ce; Ae++) me += ne[Ae].data.length;

                    oe += me, ee += ce, re.length = me, re.dts = Math.max(re.dts, V), re.pts = Math.max(re.pts, re.dts, 0), $ = Math.min(re.pts, $), q = Math.max(re.pts, q);
                  }

                  Y = I[F - 1].dts;
                  var Ce = oe + 4 * ee + 8,
                      Ie;

                  try {
                    Ie = new Uint8Array(Ce);
                  } catch (Ze) {
                    this.observer.emit(H.Events.ERROR, H.Events.ERROR, {
                      type: w.ErrorTypes.MUX_ERROR,
                      details: w.ErrorDetails.REMUX_ALLOC_ERROR,
                      fatal: !1,
                      bytes: Ce,
                      reason: "fail allocating video mdat " + Ce
                    });
                    return;
                  }

                  var ke = new DataView(Ie.buffer);
                  ke.setUint32(0, Ce), Ie.set(k.default.types.mdat, 4);

                  for (var De = 0; De < F; De++) {
                    for (var Re = I[De], Ue = Re.units, Je = 0, it = 0, Et = Ue.length; it < Et; it++) {
                      var ze = Ue[it],
                          We = ze.data,
                          st = ze.data.byteLength;
                      ke.setUint32(W, st), W += 4, Ie.set(We, W), W += st, Je += 4 + st;
                    }

                    if (De < F - 1) G = I[De + 1].dts - Re.dts;else {
                      var vt = this.config,
                          Pe = Re.dts - I[De > 0 ? De - 1 : De].dts;

                      if (vt.stretchShortVideoTrack && this.nextAudioPts !== null) {
                        var ut = Math.floor(vt.maxBufferHole * A),
                            Tt = (b ? $ + b * A : this.nextAudioPts) - Re.pts;
                        Tt > ut ? (G = Tt - Pe, G < 0 && (G = Pe), O.logger.log("[mp4-remuxer]: It is approximately " + Tt / 90 + " ms to the next segment; using duration " + G / 90 + " ms for the last video frame.")) : G = Pe;
                      } else G = Pe;
                    }
                    var ct = Math.round(Re.pts - Re.dts);
                    M.push(new h(Re.key, G, Je, ct));
                  }

                  if (M.length && y && y < 70) {
                    var et = M[0].flags;
                    et.dependsOn = 2, et.isNonSync = 0;
                  }

                  console.assert(G !== void 0, "mp4SampleDuration must be computed"), this.nextAvcDts = U = Y + G, this.isVideoContiguous = !0;

                  var _t = k.default.moof(g.sequenceNumber++, V, L({}, g, {
                    samples: M
                  })),
                      Qt = "video",
                      Jt = {
                    data1: _t,
                    data2: Ie,
                    startPTS: $ / A,
                    endPTS: (q + G) / A,
                    startDTS: V / A,
                    endDTS: U / A,
                    type: Qt,
                    hasAudio: !1,
                    hasVideo: !0,
                    nb: M.length,
                    dropped: g.dropped
                  };

                  return g.samples = [], g.dropped = 0, console.assert(Ie.length, "MDAT length must not be zero"), Jt;
                }, C.remuxAudio = function (g, s, o, b, A) {
                  var I = g.inputTimeScale,
                      M = g.samplerate ? g.samplerate : I,
                      F = I / M,
                      B = g.isAAC ? d : f,
                      U = B * F,
                      W = this._initPTS,
                      G = !g.isAAC && this.typeSupported.mpeg,
                      V = [],
                      Y = g.samples,
                      $ = G ? 0 : 8,
                      q = this.nextAudioPts || -1,
                      Z = s * I;

                  if (this.isAudioContiguous = o = o || Y.length && q > 0 && (b && Math.abs(Z - q) < 9e3 || Math.abs(a(Y[0].pts - W, Z) - q) < 20 * U), Y.forEach(function (We) {
                    We.pts = a(We.pts - W, Z);
                  }), !o || q < 0) {
                    if (Y = Y.filter(function (We) {
                      return We.pts >= 0;
                    }), !Y.length) return;
                    A === 0 ? q = 0 : b ? q = Math.max(0, Z) : q = Y[0].pts;
                  }

                  if (g.isAAC) for (var te = A !== void 0, se = this.config.maxAudioFramesDrift, ge = 0, he = q; ge < Y.length; ge++) {
                    var ye = Y[ge],
                        pe = ye.pts,
                        _e = pe - he,
                        be = Math.abs(1e3 * _e / I);

                    if (_e <= -se * U && te) ge === 0 && (O.logger.warn("Audio frame @ " + (pe / I).toFixed(3) + "s overlaps nextAudioPts by " + Math.round(1e3 * _e / I) + " ms."), this.nextAudioPts = q = he = pe);else if (_e >= se * U && be < P && te) {
                      var Le = Math.round(_e / U);
                      he = pe - Le * U, he < 0 && (Le--, he += U), ge === 0 && (this.nextAudioPts = q = he), O.logger.warn("[mp4-remuxer]: Injecting " + Le + " audio frame @ " + (he / I).toFixed(3) + "s due to " + Math.round(1e3 * _e / I) + " ms gap.");

                      for (var we = 0; we < Le; we++) {
                        var xe = Math.max(he, 0),
                            Ne = x.default.getSilentFrame(g.manifestCodec || g.codec, g.channelCount);
                        Ne || (O.logger.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), Ne = ye.unit.subarray()), Y.splice(ge, 0, {
                          unit: Ne,
                          pts: xe
                        }), he += U, ge++;
                      }
                    }
                    ye.pts = he, he += U;
                  }

                  for (var Me = null, le = null, ee, oe = 0, ue = Y.length; ue--;) oe += Y[ue].unit.byteLength;

                  for (var re = 0, ne = Y.length; re < ne; re++) {
                    var ce = Y[re],
                        me = ce.unit,
                        Ae = ce.pts;

                    if (le !== null) {
                      var Ce = V[re - 1];
                      Ce.duration = Math.round((Ae - le) / F);
                    } else if (o && g.isAAC && (Ae = q), Me = Ae, oe > 0) {
                      oe += $;

                      try {
                        ee = new Uint8Array(oe);
                      } catch (We) {
                        this.observer.emit(H.Events.ERROR, H.Events.ERROR, {
                          type: w.ErrorTypes.MUX_ERROR,
                          details: w.ErrorDetails.REMUX_ALLOC_ERROR,
                          fatal: !1,
                          bytes: oe,
                          reason: "fail allocating audio mdat " + oe
                        });
                        return;
                      }

                      if (!G) {
                        var Ie = new DataView(ee.buffer);
                        Ie.setUint32(0, oe), ee.set(k.default.types.mdat, 4);
                      }
                    } else return;

                    ee.set(me, $);
                    var ke = me.byteLength;
                    $ += ke, V.push(new h(!0, B, ke, 0)), le = Ae;
                  }

                  var De = V.length;

                  if (!!De) {
                    var Re = V[V.length - 1];
                    this.nextAudioPts = q = le + F * Re.duration;
                    var Ue = G ? new Uint8Array(0) : k.default.moof(g.sequenceNumber++, Me / F, L({}, g, {
                      samples: V
                    }));
                    g.samples = [];
                    var Je = Me / I,
                        it = q / I,
                        Et = "audio",
                        ze = {
                      data1: Ue,
                      data2: ee,
                      startPTS: Je,
                      endPTS: it,
                      startDTS: Je,
                      endDTS: it,
                      type: Et,
                      hasAudio: !0,
                      hasVideo: !1,
                      nb: De
                    };
                    return this.isAudioContiguous = !0, console.assert(ee.length, "MDAT length must not be zero"), ze;
                  }
                }, C.remuxEmptyAudio = function (g, s, o, b) {
                  var A = g.inputTimeScale,
                      I = g.samplerate ? g.samplerate : A,
                      M = A / I,
                      F = this.nextAudioPts,
                      B = (F !== null ? F : b.startDTS * A) + this._initDTS,
                      U = b.endDTS * A + this._initDTS,
                      W = M * d,
                      G = Math.ceil((U - B) / W),
                      V = x.default.getSilentFrame(g.manifestCodec || g.codec, g.channelCount);

                  if (O.logger.warn("[mp4-remuxer]: remux empty Audio"), !V) {
                    O.logger.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
                    return;
                  }

                  for (var Y = [], $ = 0; $ < G; $++) {
                    var q = B + $ * W;
                    Y.push({
                      unit: V,
                      pts: q,
                      dts: q
                    });
                  }

                  return g.samples = Y, this.remuxAudio(g, s, o, !1);
                }, C.remuxID3 = function (g, s) {
                  var o = g.samples.length;

                  if (!!o) {
                    for (var b = g.inputTimeScale, A = this._initPTS, I = this._initDTS, M = 0; M < o; M++) {
                      var F = g.samples[M];
                      F.pts = a(F.pts - A, s * b) / b, F.dts = a(F.dts - I, s * b) / b;
                    }

                    var B = g.samples;
                    return g.samples = [], {
                      samples: B
                    };
                  }
                }, C.remuxText = function (g, s) {
                  var o = g.samples.length;

                  if (!!o) {
                    for (var b = g.inputTimeScale, A = this._initPTS, I = 0; I < o; I++) {
                      var M = g.samples[I];
                      M.pts = a(M.pts - A, s * b) / b;
                    }

                    g.samples.sort(function (B, U) {
                      return B.pts - U.pts;
                    });
                    var F = g.samples;
                    return g.samples = [], {
                      samples: F
                    };
                  }
                }, p;
              }();

              function a(p, C) {
                var _;

                if (C === null) return p;

                for (C < p ? _ = -8589934592 : _ = 8589934592; Math.abs(p - C) > 4294967296;) p += _;

                return p;
              }

              function v(p) {
                for (var C = 0; C < p.length; C++) if (p[C].key) return C;

                return -1;
              }

              var h = function (C, _, g, s) {
                this.size = void 0, this.duration = void 0, this.cts = void 0, this.flags = void 0, this.duration = _, this.size = g, this.cts = s, this.flags = new c(C);
              },
                  c = function (C) {
                this.isLeading = 0, this.isDependedOn = 0, this.hasRedundancy = 0, this.degradPrio = 0, this.dependsOn = 1, this.isNonSync = 1, this.dependsOn = C ? 2 : 1, this.isNonSync = C ? 0 : 1;
              };
            },
            "./src/remux/passthrough-remuxer.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/utils/mp4-tools.ts"),
                  k = R("./src/loader/fragment.ts"),
                  H = R("./src/utils/logger.ts"),
                  w = function () {
                function E() {
                  this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = void 0, this.initTracks = void 0, this.lastEndDTS = null;
                }

                var L = E.prototype;
                return L.destroy = function () {}, L.resetTimeStamp = function (d) {
                  this.initPTS = d, this.lastEndDTS = null;
                }, L.resetNextTimestamp = function () {
                  this.lastEndDTS = null;
                }, L.resetInitSegment = function (d, f, y) {
                  this.audioCodec = f, this.videoCodec = y, this.generateInitSegment(d), this.emitInitSegment = !0;
                }, L.generateInitSegment = function (d) {
                  var f = this.audioCodec,
                      y = this.videoCodec;

                  if (!d || !d.byteLength) {
                    this.initTracks = void 0, this.initData = void 0;
                    return;
                  }

                  var u = this.initData = Object(x.parseInitSegment)(d);
                  f || (f = D(u.audio, k.ElementaryStreamTypes.AUDIO)), y || (y = D(u.video, k.ElementaryStreamTypes.VIDEO));
                  var i = {};
                  u.audio && u.video ? i.audiovideo = {
                    container: "video/mp4",
                    codec: f + "," + y,
                    initSegment: d,
                    id: "main"
                  } : u.audio ? i.audio = {
                    container: "audio/mp4",
                    codec: f,
                    initSegment: d,
                    id: "audio"
                  } : u.video ? i.video = {
                    container: "video/mp4",
                    codec: y,
                    initSegment: d,
                    id: "main"
                  } : H.logger.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = i;
                }, L.remux = function (d, f, y, u, i) {
                  var n = this.initPTS,
                      a = this.lastEndDTS,
                      v = {
                    audio: void 0,
                    video: void 0,
                    text: u,
                    id3: y,
                    initSegment: void 0
                  };
                  Object(j.isFiniteNumber)(a) || (a = this.lastEndDTS = i || 0);
                  var h = f.samples;
                  if (!h || !h.length) return v;
                  var c = {
                    initPTS: void 0,
                    timescale: 1
                  },
                      p = this.initData;
                  if ((!p || !p.length) && (this.generateInitSegment(h), p = this.initData), !p || !p.length) return H.logger.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), v;
                  this.emitInitSegment && (c.tracks = this.initTracks, this.emitInitSegment = !1), Object(j.isFiniteNumber)(n) || (this.initPTS = c.initPTS = n = O(p, h, a));
                  var C = Object(x.getDuration)(h, p),
                      _ = a,
                      g = C + _;
                  Object(x.offsetStartDTS)(p, h, n), C > 0 ? this.lastEndDTS = g : (H.logger.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
                  var s = !!p.audio,
                      o = !!p.video,
                      b = "";
                  s && (b += "audio"), o && (b += "video");
                  var A = {
                    data1: h,
                    startPTS: _,
                    startDTS: _,
                    endPTS: g,
                    endDTS: g,
                    type: b,
                    hasAudio: s,
                    hasVideo: o,
                    nb: 1,
                    dropped: 0
                  };
                  return v.audio = A.type === "audio" ? A : void 0, v.video = A.type !== "audio" ? A : void 0, v.text = u, v.id3 = y, v.initSegment = c, v;
                }, E;
              }(),
                  O = function (L, P, d) {
                return Object(x.getStartDTS)(L, P) - d;
              };

              function D(E, L) {
                var P = E == null ? void 0 : E.codec;
                return P && P.length > 4 ? P : P === "hvc1" ? "hvc1.1.c.L120.90" : P === "av01" ? "av01.0.04M.08" : P === "avc1" || L === k.ElementaryStreamTypes.VIDEO ? "avc1.42e01e" : "mp4a.40.5";
              }

              K.default = w;
            },
            "./src/task-loop.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return j;
              });

              var j = function () {
                function x() {
                  this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
                }

                var k = x.prototype;
                return k.destroy = function () {
                  this.onHandlerDestroying(), this.onHandlerDestroyed();
                }, k.onHandlerDestroying = function () {
                  this.clearNextTick(), this.clearInterval();
                }, k.onHandlerDestroyed = function () {}, k.hasInterval = function () {
                  return !!this._tickInterval;
                }, k.hasNextTick = function () {
                  return !!this._tickTimer;
                }, k.setInterval = function (w) {
                  return this._tickInterval ? !1 : (this._tickInterval = self.setInterval(this._boundTick, w), !0);
                }, k.clearInterval = function () {
                  return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
                }, k.clearNextTick = function () {
                  return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
                }, k.tick = function () {
                  this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
                }, k.tickImmediate = function () {
                  this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
                }, k.doTick = function () {}, x;
              }();
            },
            "./src/types/cmcd.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "CMCDVersion", function () {
                return j;
              }), R.d(K, "CMCDObjectType", function () {
                return x;
              }), R.d(K, "CMCDStreamingFormat", function () {
                return k;
              }), R.d(K, "CMCDStreamType", function () {
                return H;
              });
              var j = 1,
                  x;

              (function (w) {
                w.MANIFEST = "m", w.AUDIO = "a", w.VIDEO = "v", w.MUXED = "av", w.INIT = "i", w.CAPTION = "c", w.TIMED_TEXT = "tt", w.KEY = "k", w.OTHER = "o";
              })(x || (x = {}));

              var k;

              (function (w) {
                w.DASH = "d", w.HLS = "h", w.SMOOTH = "s", w.OTHER = "o";
              })(k || (k = {}));

              var H;

              (function (w) {
                w.VOD = "v", w.LIVE = "l";
              })(H || (H = {}));
            },
            "./src/types/level.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "HlsSkip", function () {
                return k;
              }), R.d(K, "getSkipValue", function () {
                return H;
              }), R.d(K, "HlsUrlParameters", function () {
                return w;
              }), R.d(K, "Level", function () {
                return O;
              });

              function j(D, E) {
                for (var L = 0; L < E.length; L++) {
                  var P = E[L];
                  P.enumerable = P.enumerable || !1, P.configurable = !0, "value" in P && (P.writable = !0), Object.defineProperty(D, P.key, P);
                }
              }

              function x(D, E, L) {
                return E && j(D.prototype, E), L && j(D, L), D;
              }

              var k;

              (function (D) {
                D.No = "", D.Yes = "YES", D.v2 = "v2";
              })(k || (k = {}));

              function H(D, E) {
                var L = D.canSkipUntil,
                    P = D.canSkipDateRanges,
                    d = D.endSN,
                    f = E !== void 0 ? E - d : 0;
                return L && f < L ? P ? k.v2 : k.Yes : k.No;
              }

              var w = function () {
                function D(L, P, d) {
                  this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = L, this.part = P, this.skip = d;
                }

                var E = D.prototype;
                return E.addDirectives = function (P) {
                  var d = new self.URL(P);
                  return this.msn !== void 0 && d.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && d.searchParams.set("_HLS_part", this.part.toString()), this.skip && d.searchParams.set("_HLS_skip", this.skip), d.toString();
                }, D;
              }(),
                  O = function () {
                function D(E) {
                  this.attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.videoCodec = void 0, this.width = void 0, this.unknownCodecs = void 0, this.audioGroupIds = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.textGroupIds = void 0, this.url = void 0, this._urlId = 0, this.url = [E.url], this.attrs = E.attrs, this.bitrate = E.bitrate, E.details && (this.details = E.details), this.id = E.id || 0, this.name = E.name, this.width = E.width || 0, this.height = E.height || 0, this.audioCodec = E.audioCodec, this.videoCodec = E.videoCodec, this.unknownCodecs = E.unknownCodecs, this.codecSet = [E.videoCodec, E.audioCodec].filter(function (L) {
                    return L;
                  }).join(",").replace(/\.[^.,]+/g, "");
                }

                return x(D, [{
                  key: "maxBitrate",
                  get: function () {
                    return Math.max(this.realBitrate, this.bitrate);
                  }
                }, {
                  key: "uri",
                  get: function () {
                    return this.url[this._urlId] || "";
                  }
                }, {
                  key: "urlId",
                  get: function () {
                    return this._urlId;
                  },
                  set: function (L) {
                    var P = L % this.url.length;
                    this._urlId !== P && (this.details = void 0, this._urlId = P);
                  }
                }]), D;
              }();
            },
            "./src/types/loader.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "PlaylistContextType", function () {
                return j;
              }), R.d(K, "PlaylistLevelType", function () {
                return x;
              });
              var j;

              (function (k) {
                k.MANIFEST = "manifest", k.LEVEL = "level", k.AUDIO_TRACK = "audioTrack", k.SUBTITLE_TRACK = "subtitleTrack";
              })(j || (j = {}));

              var x;

              (function (k) {
                k.MAIN = "main", k.AUDIO = "audio", k.SUBTITLE = "subtitle";
              })(x || (x = {}));
            },
            "./src/types/transmuxer.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "ChunkMetadata", function () {
                return j;
              });

              var j = function (H, w, O, D, E, L) {
                D === void 0 && (D = 0), E === void 0 && (E = -1), L === void 0 && (L = !1), this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = x(), this.buffering = {
                  audio: x(),
                  video: x(),
                  audiovideo: x()
                }, this.level = H, this.sn = w, this.id = O, this.size = D, this.part = E, this.partial = L;
              };

              function x() {
                return {
                  start: 0,
                  executeStart: 0,
                  executeEnd: 0,
                  end: 0
                };
              }
            },
            "./src/utils/attr-list.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "AttrList", function () {
                return k;
              });

              var j = /^(\d+)x(\d+)$/,
                  x = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g,
                  k = function () {
                function H(O) {
                  typeof O == "string" && (O = H.parseAttrList(O));

                  for (var D in O) O.hasOwnProperty(D) && (this[D] = O[D]);
                }

                var w = H.prototype;
                return w.decimalInteger = function (D) {
                  var E = parseInt(this[D], 10);
                  return E > Number.MAX_SAFE_INTEGER ? 1 / 0 : E;
                }, w.hexadecimalInteger = function (D) {
                  if (this[D]) {
                    var E = (this[D] || "0x").slice(2);
                    E = (E.length & 1 ? "0" : "") + E;

                    for (var L = new Uint8Array(E.length / 2), P = 0; P < E.length / 2; P++) L[P] = parseInt(E.slice(P * 2, P * 2 + 2), 16);

                    return L;
                  } else return null;
                }, w.hexadecimalIntegerAsNumber = function (D) {
                  var E = parseInt(this[D], 16);
                  return E > Number.MAX_SAFE_INTEGER ? 1 / 0 : E;
                }, w.decimalFloatingPoint = function (D) {
                  return parseFloat(this[D]);
                }, w.optionalFloat = function (D, E) {
                  var L = this[D];
                  return L ? parseFloat(L) : E;
                }, w.enumeratedString = function (D) {
                  return this[D];
                }, w.bool = function (D) {
                  return this[D] === "YES";
                }, w.decimalResolution = function (D) {
                  var E = j.exec(this[D]);
                  if (E !== null) return {
                    width: parseInt(E[1], 10),
                    height: parseInt(E[2], 10)
                  };
                }, H.parseAttrList = function (D) {
                  var E,
                      L = {},
                      P = '"';

                  for (x.lastIndex = 0; (E = x.exec(D)) !== null;) {
                    var d = E[2];
                    d.indexOf(P) === 0 && d.lastIndexOf(P) === d.length - 1 && (d = d.slice(1, -1)), L[E[1]] = d;
                  }

                  return L;
                }, H;
              }();
            },
            "./src/utils/binary-search.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = {
                search: function (k, H) {
                  for (var w = 0, O = k.length - 1, D = null, E = null; w <= O;) {
                    D = (w + O) / 2 | 0, E = k[D];
                    var L = H(E);
                    if (L > 0) w = D + 1;else if (L < 0) O = D - 1;else return E;
                  }

                  return null;
                }
              };
              K.default = j;
            },
            "./src/utils/buffer-helper.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "BufferHelper", function () {
                return k;
              });

              var j = R("./src/utils/logger.ts"),
                  x = {
                length: 0,
                start: function () {
                  return 0;
                },
                end: function () {
                  return 0;
                }
              },
                  k = function () {
                function H() {}

                return H.isBuffered = function (O, D) {
                  try {
                    if (O) {
                      for (var E = H.getBuffered(O), L = 0; L < E.length; L++) if (D >= E.start(L) && D <= E.end(L)) return !0;
                    }
                  } catch (P) {}

                  return !1;
                }, H.bufferInfo = function (O, D, E) {
                  try {
                    if (O) {
                      var L = H.getBuffered(O),
                          P = [],
                          d;

                      for (d = 0; d < L.length; d++) P.push({
                        start: L.start(d),
                        end: L.end(d)
                      });

                      return this.bufferedInfo(P, D, E);
                    }
                  } catch (f) {}

                  return {
                    len: 0,
                    start: D,
                    end: D,
                    nextStart: void 0
                  };
                }, H.bufferedInfo = function (O, D, E) {
                  D = Math.max(0, D), O.sort(function (c, p) {
                    var C = c.start - p.start;
                    return C || p.end - c.end;
                  });
                  var L = [];
                  if (E) for (var P = 0; P < O.length; P++) {
                    var d = L.length;

                    if (d) {
                      var f = L[d - 1].end;
                      O[P].start - f < E ? O[P].end > f && (L[d - 1].end = O[P].end) : L.push(O[P]);
                    } else L.push(O[P]);
                  } else L = O;

                  for (var y = 0, u, i = D, n = D, a = 0; a < L.length; a++) {
                    var v = L[a].start,
                        h = L[a].end;
                    if (D + E >= v && D < h) i = v, n = h, y = n - D;else if (D + E < v) {
                      u = v;
                      break;
                    }
                  }

                  return {
                    len: y,
                    start: i || 0,
                    end: n || 0,
                    nextStart: u
                  };
                }, H.getBuffered = function (O) {
                  try {
                    return O.buffered;
                  } catch (D) {
                    return j.logger.log("failed to get media.buffered", D), x;
                  }
                }, H;
              }();
            },
            "./src/utils/cea-608-parser.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "Row", function () {
                return n;
              }), R.d(K, "CaptionScreen", function () {
                return a;
              });

              var j = R("./src/utils/logger.ts"),
                  x = {
                42: 225,
                92: 233,
                94: 237,
                95: 243,
                96: 250,
                123: 231,
                124: 247,
                125: 209,
                126: 241,
                127: 9608,
                128: 174,
                129: 176,
                130: 189,
                131: 191,
                132: 8482,
                133: 162,
                134: 163,
                135: 9834,
                136: 224,
                137: 32,
                138: 232,
                139: 226,
                140: 234,
                141: 238,
                142: 244,
                143: 251,
                144: 193,
                145: 201,
                146: 211,
                147: 218,
                148: 220,
                149: 252,
                150: 8216,
                151: 161,
                152: 42,
                153: 8217,
                154: 9473,
                155: 169,
                156: 8480,
                157: 8226,
                158: 8220,
                159: 8221,
                160: 192,
                161: 194,
                162: 199,
                163: 200,
                164: 202,
                165: 203,
                166: 235,
                167: 206,
                168: 207,
                169: 239,
                170: 212,
                171: 217,
                172: 249,
                173: 219,
                174: 171,
                175: 187,
                176: 195,
                177: 227,
                178: 205,
                179: 204,
                180: 236,
                181: 210,
                182: 242,
                183: 213,
                184: 245,
                185: 123,
                186: 125,
                187: 92,
                188: 94,
                189: 95,
                190: 124,
                191: 8764,
                192: 196,
                193: 228,
                194: 214,
                195: 246,
                196: 223,
                197: 165,
                198: 164,
                199: 9475,
                200: 197,
                201: 229,
                202: 216,
                203: 248,
                204: 9487,
                205: 9491,
                206: 9495,
                207: 9499
              },
                  k = function (g) {
                var s = g;
                return x.hasOwnProperty(g) && (s = x[g]), String.fromCharCode(s);
              },
                  H = 15,
                  w = 100,
                  O = {
                17: 1,
                18: 3,
                21: 5,
                22: 7,
                23: 9,
                16: 11,
                19: 12,
                20: 14
              },
                  D = {
                17: 2,
                18: 4,
                21: 6,
                22: 8,
                23: 10,
                19: 13,
                20: 15
              },
                  E = {
                25: 1,
                26: 3,
                29: 5,
                30: 7,
                31: 9,
                24: 11,
                27: 12,
                28: 14
              },
                  L = {
                25: 2,
                26: 4,
                29: 6,
                30: 8,
                31: 10,
                27: 13,
                28: 15
              },
                  P = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"],
                  d;

              (function (_) {
                _[_.ERROR = 0] = "ERROR", _[_.TEXT = 1] = "TEXT", _[_.WARNING = 2] = "WARNING", _[_.INFO = 2] = "INFO", _[_.DEBUG = 3] = "DEBUG", _[_.DATA = 3] = "DATA";
              })(d || (d = {}));

              var f = function () {
                function _() {
                  this.time = null, this.verboseLevel = d.ERROR;
                }

                var g = _.prototype;
                return g.log = function (o, b) {
                  this.verboseLevel >= o && j.logger.log(this.time + " [" + o + "] " + b);
                }, _;
              }(),
                  y = function (g) {
                for (var s = [], o = 0; o < g.length; o++) s.push(g[o].toString(16));

                return s;
              },
                  u = function () {
                function _(s, o, b, A, I) {
                  this.foreground = void 0, this.underline = void 0, this.italics = void 0, this.background = void 0, this.flash = void 0, this.foreground = s || "white", this.underline = o || !1, this.italics = b || !1, this.background = A || "black", this.flash = I || !1;
                }

                var g = _.prototype;
                return g.reset = function () {
                  this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
                }, g.setStyles = function (o) {
                  for (var b = ["foreground", "underline", "italics", "background", "flash"], A = 0; A < b.length; A++) {
                    var I = b[A];
                    o.hasOwnProperty(I) && (this[I] = o[I]);
                  }
                }, g.isDefault = function () {
                  return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
                }, g.equals = function (o) {
                  return this.foreground === o.foreground && this.underline === o.underline && this.italics === o.italics && this.background === o.background && this.flash === o.flash;
                }, g.copy = function (o) {
                  this.foreground = o.foreground, this.underline = o.underline, this.italics = o.italics, this.background = o.background, this.flash = o.flash;
                }, g.toString = function () {
                  return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
                }, _;
              }(),
                  i = function () {
                function _(s, o, b, A, I, M) {
                  this.uchar = void 0, this.penState = void 0, this.uchar = s || " ", this.penState = new u(o, b, A, I, M);
                }

                var g = _.prototype;
                return g.reset = function () {
                  this.uchar = " ", this.penState.reset();
                }, g.setChar = function (o, b) {
                  this.uchar = o, this.penState.copy(b);
                }, g.setPenState = function (o) {
                  this.penState.copy(o);
                }, g.equals = function (o) {
                  return this.uchar === o.uchar && this.penState.equals(o.penState);
                }, g.copy = function (o) {
                  this.uchar = o.uchar, this.penState.copy(o.penState);
                }, g.isEmpty = function () {
                  return this.uchar === " " && this.penState.isDefault();
                }, _;
              }(),
                  n = function () {
                function _(s) {
                  this.chars = void 0, this.pos = void 0, this.currPenState = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chars = [];

                  for (var o = 0; o < w; o++) this.chars.push(new i());

                  this.logger = s, this.pos = 0, this.currPenState = new u();
                }

                var g = _.prototype;
                return g.equals = function (o) {
                  for (var b = !0, A = 0; A < w; A++) if (!this.chars[A].equals(o.chars[A])) {
                    b = !1;
                    break;
                  }

                  return b;
                }, g.copy = function (o) {
                  for (var b = 0; b < w; b++) this.chars[b].copy(o.chars[b]);
                }, g.isEmpty = function () {
                  for (var o = !0, b = 0; b < w; b++) if (!this.chars[b].isEmpty()) {
                    o = !1;
                    break;
                  }

                  return o;
                }, g.setCursor = function (o) {
                  this.pos !== o && (this.pos = o), this.pos < 0 ? (this.logger.log(d.DEBUG, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > w && (this.logger.log(d.DEBUG, "Too large cursor position " + this.pos), this.pos = w);
                }, g.moveCursor = function (o) {
                  var b = this.pos + o;
                  if (o > 1) for (var A = this.pos + 1; A < b + 1; A++) this.chars[A].setPenState(this.currPenState);
                  this.setCursor(b);
                }, g.backSpace = function () {
                  this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
                }, g.insertChar = function (o) {
                  o >= 144 && this.backSpace();
                  var b = k(o);

                  if (this.pos >= w) {
                    this.logger.log(d.ERROR, "Cannot insert " + o.toString(16) + " (" + b + ") at position " + this.pos + ". Skipping it!");
                    return;
                  }

                  this.chars[this.pos].setChar(b, this.currPenState), this.moveCursor(1);
                }, g.clearFromPos = function (o) {
                  var b;

                  for (b = o; b < w; b++) this.chars[b].reset();
                }, g.clear = function () {
                  this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
                }, g.clearToEndOfRow = function () {
                  this.clearFromPos(this.pos);
                }, g.getTextString = function () {
                  for (var o = [], b = !0, A = 0; A < w; A++) {
                    var I = this.chars[A].uchar;
                    I !== " " && (b = !1), o.push(I);
                  }

                  return b ? "" : o.join("");
                }, g.setPenStyles = function (o) {
                  this.currPenState.setStyles(o);
                  var b = this.chars[this.pos];
                  b.setPenState(this.currPenState);
                }, _;
              }(),
                  a = function () {
                function _(s) {
                  this.rows = void 0, this.currRow = void 0, this.nrRollUpRows = void 0, this.lastOutputScreen = void 0, this.logger = void 0, this.rows = [];

                  for (var o = 0; o < H; o++) this.rows.push(new n(s));

                  this.logger = s, this.currRow = H - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.reset();
                }

                var g = _.prototype;
                return g.reset = function () {
                  for (var o = 0; o < H; o++) this.rows[o].clear();

                  this.currRow = H - 1;
                }, g.equals = function (o) {
                  for (var b = !0, A = 0; A < H; A++) if (!this.rows[A].equals(o.rows[A])) {
                    b = !1;
                    break;
                  }

                  return b;
                }, g.copy = function (o) {
                  for (var b = 0; b < H; b++) this.rows[b].copy(o.rows[b]);
                }, g.isEmpty = function () {
                  for (var o = !0, b = 0; b < H; b++) if (!this.rows[b].isEmpty()) {
                    o = !1;
                    break;
                  }

                  return o;
                }, g.backSpace = function () {
                  var o = this.rows[this.currRow];
                  o.backSpace();
                }, g.clearToEndOfRow = function () {
                  var o = this.rows[this.currRow];
                  o.clearToEndOfRow();
                }, g.insertChar = function (o) {
                  var b = this.rows[this.currRow];
                  b.insertChar(o);
                }, g.setPen = function (o) {
                  var b = this.rows[this.currRow];
                  b.setPenStyles(o);
                }, g.moveCursor = function (o) {
                  var b = this.rows[this.currRow];
                  b.moveCursor(o);
                }, g.setCursor = function (o) {
                  this.logger.log(d.INFO, "setCursor: " + o);
                  var b = this.rows[this.currRow];
                  b.setCursor(o);
                }, g.setPAC = function (o) {
                  this.logger.log(d.INFO, "pacData = " + JSON.stringify(o));
                  var b = o.row - 1;

                  if (this.nrRollUpRows && b < this.nrRollUpRows - 1 && (b = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== b) {
                    for (var A = 0; A < H; A++) this.rows[A].clear();

                    var I = this.currRow + 1 - this.nrRollUpRows,
                        M = this.lastOutputScreen;

                    if (M) {
                      var F = M.rows[I].cueStartTime,
                          B = this.logger.time;
                      if (F && B !== null && F < B) for (var U = 0; U < this.nrRollUpRows; U++) this.rows[b - this.nrRollUpRows + U + 1].copy(M.rows[I + U]);
                    }
                  }

                  this.currRow = b;
                  var W = this.rows[this.currRow];

                  if (o.indent !== null) {
                    var G = o.indent,
                        V = Math.max(G - 1, 0);
                    W.setCursor(o.indent), o.color = W.chars[V].penState.foreground;
                  }

                  var Y = {
                    foreground: o.color,
                    underline: o.underline,
                    italics: o.italics,
                    background: "black",
                    flash: !1
                  };
                  this.setPen(Y);
                }, g.setBkgData = function (o) {
                  this.logger.log(d.INFO, "bkgData = " + JSON.stringify(o)), this.backSpace(), this.setPen(o), this.insertChar(32);
                }, g.setRollUpRows = function (o) {
                  this.nrRollUpRows = o;
                }, g.rollUp = function () {
                  if (this.nrRollUpRows === null) {
                    this.logger.log(d.DEBUG, "roll_up but nrRollUpRows not set yet");
                    return;
                  }

                  this.logger.log(d.TEXT, this.getDisplayText());
                  var o = this.currRow + 1 - this.nrRollUpRows,
                      b = this.rows.splice(o, 1)[0];
                  b.clear(), this.rows.splice(this.currRow, 0, b), this.logger.log(d.INFO, "Rolling up");
                }, g.getDisplayText = function (o) {
                  o = o || !1;

                  for (var b = [], A = "", I = -1, M = 0; M < H; M++) {
                    var F = this.rows[M].getTextString();
                    F && (I = M + 1, o ? b.push("Row " + I + ": '" + F + "'") : b.push(F.trim()));
                  }

                  return b.length > 0 && (o ? A = "[" + b.join(" | ") + "]" : A = b.join("\n")), A;
                }, g.getTextAndFormat = function () {
                  return this.rows;
                }, _;
              }(),
                  v = function () {
                function _(s, o, b) {
                  this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = s, this.outputFilter = o, this.mode = null, this.verbose = 0, this.displayedMemory = new a(b), this.nonDisplayedMemory = new a(b), this.lastOutputScreen = new a(b), this.currRollUpRow = this.displayedMemory.rows[H - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = b;
                }

                var g = _.prototype;
                return g.reset = function () {
                  this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[H - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
                }, g.getHandler = function () {
                  return this.outputFilter;
                }, g.setHandler = function (o) {
                  this.outputFilter = o;
                }, g.setPAC = function (o) {
                  this.writeScreen.setPAC(o);
                }, g.setBkgData = function (o) {
                  this.writeScreen.setBkgData(o);
                }, g.setMode = function (o) {
                  o !== this.mode && (this.mode = o, this.logger.log(d.INFO, "MODE=" + o), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = o);
                }, g.insertChars = function (o) {
                  for (var b = 0; b < o.length; b++) this.writeScreen.insertChar(o[b]);

                  var A = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
                  this.logger.log(d.INFO, A + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(d.TEXT, "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
                }, g.ccRCL = function () {
                  this.logger.log(d.INFO, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
                }, g.ccBS = function () {
                  this.logger.log(d.INFO, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
                }, g.ccAOF = function () {}, g.ccAON = function () {}, g.ccDER = function () {
                  this.logger.log(d.INFO, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
                }, g.ccRU = function (o) {
                  this.logger.log(d.INFO, "RU(" + o + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(o);
                }, g.ccFON = function () {
                  this.logger.log(d.INFO, "FON - Flash On"), this.writeScreen.setPen({
                    flash: !0
                  });
                }, g.ccRDC = function () {
                  this.logger.log(d.INFO, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
                }, g.ccTR = function () {
                  this.logger.log(d.INFO, "TR"), this.setMode("MODE_TEXT");
                }, g.ccRTD = function () {
                  this.logger.log(d.INFO, "RTD"), this.setMode("MODE_TEXT");
                }, g.ccEDM = function () {
                  this.logger.log(d.INFO, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
                }, g.ccCR = function () {
                  this.logger.log(d.INFO, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
                }, g.ccENM = function () {
                  this.logger.log(d.INFO, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
                }, g.ccEOC = function () {
                  if (this.logger.log(d.INFO, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
                    var o = this.displayedMemory;
                    this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = o, this.writeScreen = this.nonDisplayedMemory, this.logger.log(d.TEXT, "DISP: " + this.displayedMemory.getDisplayText());
                  }

                  this.outputDataUpdate(!0);
                }, g.ccTO = function (o) {
                  this.logger.log(d.INFO, "TO(" + o + ") - Tab Offset"), this.writeScreen.moveCursor(o);
                }, g.ccMIDROW = function (o) {
                  var b = {
                    flash: !1
                  };
                  if (b.underline = o % 2 == 1, b.italics = o >= 46, b.italics) b.foreground = "white";else {
                    var A = Math.floor(o / 2) - 16,
                        I = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
                    b.foreground = I[A];
                  }
                  this.logger.log(d.INFO, "MIDROW: " + JSON.stringify(b)), this.writeScreen.setPen(b);
                }, g.outputDataUpdate = function (o) {
                  o === void 0 && (o = !1);
                  var b = this.logger.time;
                  b !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = b : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, b, this.lastOutputScreen), o && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : b), this.lastOutputScreen.copy(this.displayedMemory));
                }, g.cueSplitAtTime = function (o) {
                  this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, o, this.displayedMemory), this.cueStartTime = o));
                }, _;
              }(),
                  h = function () {
                function _(s, o, b) {
                  this.channels = void 0, this.currentChannel = 0, this.cmdHistory = void 0, this.logger = void 0;
                  var A = new f();
                  this.channels = [null, new v(s, o, A), new v(s + 1, b, A)], this.cmdHistory = C(), this.logger = A;
                }

                var g = _.prototype;
                return g.getHandler = function (o) {
                  return this.channels[o].getHandler();
                }, g.setHandler = function (o, b) {
                  this.channels[o].setHandler(b);
                }, g.addData = function (o, b) {
                  var A,
                      I,
                      M,
                      F = !1;
                  this.logger.time = o;

                  for (var B = 0; B < b.length; B += 2) if (I = b[B] & 127, M = b[B + 1] & 127, !(I === 0 && M === 0)) {
                    if (this.logger.log(d.DATA, "[" + y([b[B], b[B + 1]]) + "] -> (" + y([I, M]) + ")"), A = this.parseCmd(I, M), A || (A = this.parseMidrow(I, M)), A || (A = this.parsePAC(I, M)), A || (A = this.parseBackgroundAttributes(I, M)), !A && (F = this.parseChars(I, M), F)) {
                      var U = this.currentChannel;

                      if (U && U > 0) {
                        var W = this.channels[U];
                        W.insertChars(F);
                      } else this.logger.log(d.WARNING, "No channel found yet. TEXT-MODE?");
                    }

                    !A && !F && this.logger.log(d.WARNING, "Couldn't parse cleaned data " + y([I, M]) + " orig: " + y([b[B], b[B + 1]]));
                  }
                }, g.parseCmd = function (o, b) {
                  var A = this.cmdHistory,
                      I = (o === 20 || o === 28 || o === 21 || o === 29) && b >= 32 && b <= 47,
                      M = (o === 23 || o === 31) && b >= 33 && b <= 35;
                  if (!(I || M)) return !1;
                  if (p(o, b, A)) return c(null, null, A), this.logger.log(d.DEBUG, "Repeated command (" + y([o, b]) + ") is dropped"), !0;
                  var F = o === 20 || o === 21 || o === 23 ? 1 : 2,
                      B = this.channels[F];
                  return o === 20 || o === 21 || o === 28 || o === 29 ? b === 32 ? B.ccRCL() : b === 33 ? B.ccBS() : b === 34 ? B.ccAOF() : b === 35 ? B.ccAON() : b === 36 ? B.ccDER() : b === 37 ? B.ccRU(2) : b === 38 ? B.ccRU(3) : b === 39 ? B.ccRU(4) : b === 40 ? B.ccFON() : b === 41 ? B.ccRDC() : b === 42 ? B.ccTR() : b === 43 ? B.ccRTD() : b === 44 ? B.ccEDM() : b === 45 ? B.ccCR() : b === 46 ? B.ccENM() : b === 47 && B.ccEOC() : B.ccTO(b - 32), c(o, b, A), this.currentChannel = F, !0;
                }, g.parseMidrow = function (o, b) {
                  var A = 0;

                  if ((o === 17 || o === 25) && b >= 32 && b <= 47) {
                    if (o === 17 ? A = 1 : A = 2, A !== this.currentChannel) return this.logger.log(d.ERROR, "Mismatch channel in midrow parsing"), !1;
                    var I = this.channels[A];
                    return I ? (I.ccMIDROW(b), this.logger.log(d.DEBUG, "MIDROW (" + y([o, b]) + ")"), !0) : !1;
                  }

                  return !1;
                }, g.parsePAC = function (o, b) {
                  var A,
                      I = this.cmdHistory,
                      M = (o >= 17 && o <= 23 || o >= 25 && o <= 31) && b >= 64 && b <= 127,
                      F = (o === 16 || o === 24) && b >= 64 && b <= 95;
                  if (!(M || F)) return !1;
                  if (p(o, b, I)) return c(null, null, I), !0;
                  var B = o <= 23 ? 1 : 2;
                  b >= 64 && b <= 95 ? A = B === 1 ? O[o] : E[o] : A = B === 1 ? D[o] : L[o];
                  var U = this.channels[B];
                  return U ? (U.setPAC(this.interpretPAC(A, b)), c(o, b, I), this.currentChannel = B, !0) : !1;
                }, g.interpretPAC = function (o, b) {
                  var A,
                      I = {
                    color: null,
                    italics: !1,
                    indent: null,
                    underline: !1,
                    row: o
                  };
                  return b > 95 ? A = b - 96 : A = b - 64, I.underline = (A & 1) == 1, A <= 13 ? I.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(A / 2)] : A <= 15 ? (I.italics = !0, I.color = "white") : I.indent = Math.floor((A - 16) / 2) * 4, I;
                }, g.parseChars = function (o, b) {
                  var A,
                      I = null,
                      M = null;

                  if (o >= 25 ? (A = 2, M = o - 8) : (A = 1, M = o), M >= 17 && M <= 19) {
                    var F;
                    M === 17 ? F = b + 80 : M === 18 ? F = b + 112 : F = b + 144, this.logger.log(d.INFO, "Special char '" + k(F) + "' in channel " + A), I = [F];
                  } else o >= 32 && o <= 127 && (I = b === 0 ? [o] : [o, b]);

                  if (I) {
                    var B = y(I);
                    this.logger.log(d.DEBUG, "Char codes =  " + B.join(",")), c(o, b, this.cmdHistory);
                  }

                  return I;
                }, g.parseBackgroundAttributes = function (o, b) {
                  var A = (o === 16 || o === 24) && b >= 32 && b <= 47,
                      I = (o === 23 || o === 31) && b >= 45 && b <= 47;
                  if (!(A || I)) return !1;
                  var M,
                      F = {};
                  o === 16 || o === 24 ? (M = Math.floor((b - 32) / 2), F.background = P[M], b % 2 == 1 && (F.background = F.background + "_semi")) : b === 45 ? F.background = "transparent" : (F.foreground = "black", b === 47 && (F.underline = !0));
                  var B = o <= 23 ? 1 : 2,
                      U = this.channels[B];
                  return U.setBkgData(F), c(o, b, this.cmdHistory), !0;
                }, g.reset = function () {
                  for (var o = 0; o < Object.keys(this.channels).length; o++) {
                    var b = this.channels[o];
                    b && b.reset();
                  }

                  this.cmdHistory = C();
                }, g.cueSplitAtTime = function (o) {
                  for (var b = 0; b < this.channels.length; b++) {
                    var A = this.channels[b];
                    A && A.cueSplitAtTime(o);
                  }
                }, _;
              }();

              function c(_, g, s) {
                s.a = _, s.b = g;
              }

              function p(_, g, s) {
                return s.a === _ && s.b === g;
              }

              function C() {
                return {
                  a: null,
                  b: null
                };
              }

              K.default = h;
            },
            "./src/utils/codecs.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "isCodecType", function () {
                return x;
              }), R.d(K, "isCodecSupportedInMp4", function () {
                return k;
              });
              var j = {
                audio: {
                  a3ds: !0,
                  "ac-3": !0,
                  "ac-4": !0,
                  alac: !0,
                  alaw: !0,
                  dra1: !0,
                  "dts+": !0,
                  "dts-": !0,
                  dtsc: !0,
                  dtse: !0,
                  dtsh: !0,
                  "ec-3": !0,
                  enca: !0,
                  g719: !0,
                  g726: !0,
                  m4ae: !0,
                  mha1: !0,
                  mha2: !0,
                  mhm1: !0,
                  mhm2: !0,
                  mlpa: !0,
                  mp4a: !0,
                  "raw ": !0,
                  Opus: !0,
                  samr: !0,
                  sawb: !0,
                  sawp: !0,
                  sevc: !0,
                  sqcp: !0,
                  ssmv: !0,
                  twos: !0,
                  ulaw: !0
                },
                video: {
                  avc1: !0,
                  avc2: !0,
                  avc3: !0,
                  avc4: !0,
                  avcp: !0,
                  av01: !0,
                  drac: !0,
                  dvav: !0,
                  dvhe: !0,
                  encv: !0,
                  hev1: !0,
                  hvc1: !0,
                  mjp2: !0,
                  mp4v: !0,
                  mvc1: !0,
                  mvc2: !0,
                  mvc3: !0,
                  mvc4: !0,
                  resv: !0,
                  rv60: !0,
                  s263: !0,
                  svc1: !0,
                  svc2: !0,
                  "vc-1": !0,
                  vp08: !0,
                  vp09: !0
                },
                text: {
                  stpp: !0,
                  wvtt: !0
                }
              };

              function x(H, w) {
                var O = j[w];
                return !!O && O[H.slice(0, 4)] === !0;
              }

              function k(H, w) {
                return MediaSource.isTypeSupported((w || "video") + '/mp4;codecs="' + H + '"');
              }
            },
            "./src/utils/cues.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = R("./src/utils/vttparser.ts"),
                  x = R("./src/utils/webvtt-parser.ts"),
                  k = R("./src/utils/texttrack-utils.ts"),
                  H = /\s/,
                  w = {
                newCue: function (D, E, L, P) {
                  for (var d = [], f, y, u, i, n, a = self.VTTCue || self.TextTrackCue, v = 0; v < P.rows.length; v++) if (f = P.rows[v], u = !0, i = 0, n = "", !f.isEmpty()) {
                    for (var h = 0; h < f.chars.length; h++) H.test(f.chars[h].uchar) && u ? i++ : (n += f.chars[h].uchar, u = !1);

                    f.cueStartTime = E, E === L && (L += 1e-4), i >= 16 ? i-- : i++;
                    var c = Object(j.fixLineBreaks)(n.trim()),
                        p = Object(x.generateCueId)(E, L, c);
                    (!D || !D.cues || !D.cues.getCueById(p)) && (y = new a(E, L, c), y.id = p, y.line = v + 1, y.align = "left", y.position = 10 + Math.min(80, Math.floor(i * 8 / 32) * 10), d.push(y));
                  }

                  return D && d.length && (d.sort(function (C, _) {
                    return C.line === "auto" || _.line === "auto" ? 0 : C.line > 8 && _.line > 8 ? _.line - C.line : C.line - _.line;
                  }), d.forEach(function (C) {
                    return Object(k.addCueToTrack)(D, C);
                  })), d;
                }
              };
              K.default = w;
            },
            "./src/utils/discontinuities.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "findFirstFragWithCC", function () {
                return H;
              }), R.d(K, "shouldAlignOnDiscontinuities", function () {
                return w;
              }), R.d(K, "findDiscontinuousReferenceFrag", function () {
                return O;
              }), R.d(K, "adjustSlidingStart", function () {
                return E;
              }), R.d(K, "alignStream", function () {
                return L;
              }), R.d(K, "alignPDT", function () {
                return d;
              }), R.d(K, "alignFragmentByPDTDelta", function () {
                return f;
              }), R.d(K, "alignMediaPlaylistByPDT", function () {
                return y;
              });
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/utils/logger.ts"),
                  k = R("./src/controller/level-helper.ts");

              function H(u, i) {
                for (var n = null, a = 0, v = u.length; a < v; a++) {
                  var h = u[a];

                  if (h && h.cc === i) {
                    n = h;
                    break;
                  }
                }

                return n;
              }

              function w(u, i, n) {
                return !!(i.details && (n.endCC > n.startCC || u && u.cc < n.startCC));
              }

              function O(u, i) {
                var n = u.fragments,
                    a = i.fragments;

                if (!a.length || !n.length) {
                  x.logger.log("No fragments to align");
                  return;
                }

                var v = H(n, a[0].cc);

                if (!v || v && !v.startPTS) {
                  x.logger.log("No frag in previous level to align on");
                  return;
                }

                return v;
              }

              function D(u, i) {
                if (u) {
                  var n = u.start + i;
                  u.start = u.startPTS = n, u.endPTS = n + u.duration;
                }
              }

              function E(u, i) {
                for (var n = i.fragments, a = 0, v = n.length; a < v; a++) D(n[a], u);

                i.fragmentHint && D(i.fragmentHint, u), i.alignedSliding = !0;
              }

              function L(u, i, n) {
                !i || (P(u, n, i), !n.alignedSliding && i.details && d(n, i.details), !n.alignedSliding && i.details && !n.skippedSegments && Object(k.adjustSliding)(i.details, n));
              }

              function P(u, i, n) {
                if (w(u, n, i)) {
                  var a = O(n.details, i);
                  a && Object(j.isFiniteNumber)(a.start) && (x.logger.log("Adjusting PTS using last level due to CC increase within current level " + i.url), E(a.start, i));
                }
              }

              function d(u, i) {
                if (!(!i.fragments.length || !u.hasProgramDateTime || !i.hasProgramDateTime)) {
                  var n = i.fragments[0].programDateTime,
                      a = u.fragments[0].programDateTime,
                      v = (a - n) / 1e3 + i.fragments[0].start;
                  v && Object(j.isFiniteNumber)(v) && (x.logger.log("Adjusting PTS using programDateTime delta " + (a - n) + "ms, sliding:" + v.toFixed(3) + " " + u.url + " "), E(v, u));
                }
              }

              function f(u, i) {
                var n = u.programDateTime;

                if (!!n) {
                  var a = (n - i) / 1e3;
                  u.start = u.startPTS = a, u.endPTS = a + u.duration;
                }
              }

              function y(u, i) {
                if (!(!i.fragments.length || !u.hasProgramDateTime || !i.hasProgramDateTime)) {
                  var n = i.fragments[0].programDateTime,
                      a = i.fragments[0].start,
                      v = n - a * 1e3;
                  u.fragments.forEach(function (h) {
                    f(h, v);
                  }), u.fragmentHint && f(u.fragmentHint, v), u.alignedSliding = !0;
                }
              }
            },
            "./src/utils/ewma-bandwidth-estimator.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = R("./src/utils/ewma.ts"),
                  x = function () {
                function k(w, O, D) {
                  this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultEstimate_ = D, this.minWeight_ = .001, this.minDelayMs_ = 50, this.slow_ = new j.default(w), this.fast_ = new j.default(O);
                }

                var H = k.prototype;
                return H.update = function (O, D) {
                  var E = this.slow_,
                      L = this.fast_;
                  this.slow_.halfLife !== O && (this.slow_ = new j.default(O, E.getEstimate(), E.getTotalWeight())), this.fast_.halfLife !== D && (this.fast_ = new j.default(D, L.getEstimate(), L.getTotalWeight()));
                }, H.sample = function (O, D) {
                  O = Math.max(O, this.minDelayMs_);
                  var E = 8 * D,
                      L = O / 1e3,
                      P = E / L;
                  this.fast_.sample(L, P), this.slow_.sample(L, P);
                }, H.canEstimate = function () {
                  var O = this.fast_;
                  return O && O.getTotalWeight() >= this.minWeight_;
                }, H.getEstimate = function () {
                  return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
                }, H.destroy = function () {}, k;
              }();

              K.default = x;
            },
            "./src/utils/ewma.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = function () {
                function x(H, w, O) {
                  w === void 0 && (w = 0), O === void 0 && (O = 0), this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = H, this.alpha_ = H ? Math.exp(Math.log(.5) / H) : 0, this.estimate_ = w, this.totalWeight_ = O;
                }

                var k = x.prototype;
                return k.sample = function (w, O) {
                  var D = Math.pow(this.alpha_, w);
                  this.estimate_ = O * (1 - D) + D * this.estimate_, this.totalWeight_ += w;
                }, k.getTotalWeight = function () {
                  return this.totalWeight_;
                }, k.getEstimate = function () {
                  if (this.alpha_) {
                    var w = 1 - Math.pow(this.alpha_, this.totalWeight_);
                    if (w) return this.estimate_ / w;
                  }

                  return this.estimate_;
                }, x;
              }();

              K.default = j;
            },
            "./src/utils/fetch-loader.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "fetchSupported", function () {
                return f;
              });
              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/loader/load-stats.ts"),
                  k = R("./src/demux/chunk-cache.ts");

              function H(a, v) {
                a.prototype = Object.create(v.prototype), a.prototype.constructor = a, L(a, v);
              }

              function w(a) {
                var v = typeof Map == "function" ? new Map() : void 0;
                return w = function (c) {
                  if (c === null || !E(c)) return c;
                  if (typeof c != "function") throw new TypeError("Super expression must either be null or a function");

                  if (typeof v != "undefined") {
                    if (v.has(c)) return v.get(c);
                    v.set(c, p);
                  }

                  function p() {
                    return O(c, arguments, P(this).constructor);
                  }

                  return p.prototype = Object.create(c.prototype, {
                    constructor: {
                      value: p,
                      enumerable: !1,
                      writable: !0,
                      configurable: !0
                    }
                  }), L(p, c);
                }, w(a);
              }

              function O(a, v, h) {
                return D() ? O = Reflect.construct : O = function (p, C, _) {
                  var g = [null];
                  g.push.apply(g, C);
                  var s = Function.bind.apply(p, g),
                      o = new s();
                  return _ && L(o, _.prototype), o;
                }, O.apply(null, arguments);
              }

              function D() {
                if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
                if (typeof Proxy == "function") return !0;

                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (a) {
                  return !1;
                }
              }

              function E(a) {
                return Function.toString.call(a).indexOf("[native code]") !== -1;
              }

              function L(a, v) {
                return L = Object.setPrototypeOf || function (c, p) {
                  return c.__proto__ = p, c;
                }, L(a, v);
              }

              function P(a) {
                return P = Object.setPrototypeOf ? Object.getPrototypeOf : function (h) {
                  return h.__proto__ || Object.getPrototypeOf(h);
                }, P(a);
              }

              function d() {
                return d = Object.assign || function (a) {
                  for (var v = 1; v < arguments.length; v++) {
                    var h = arguments[v];

                    for (var c in h) Object.prototype.hasOwnProperty.call(h, c) && (a[c] = h[c]);
                  }

                  return a;
                }, d.apply(this, arguments);
              }

              function f() {
                if (self.fetch && self.AbortController && self.ReadableStream && self.Request) try {
                  return new self.ReadableStream({}), !0;
                } catch (a) {}
                return !1;
              }

              var y = function () {
                function a(h) {
                  this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = void 0, this.response = void 0, this.controller = void 0, this.context = void 0, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = h.fetchSetup || i, this.controller = new self.AbortController(), this.stats = new x.LoadStats();
                }

                var v = a.prototype;
                return v.destroy = function () {
                  this.loader = this.callbacks = null, this.abortInternal();
                }, v.abortInternal = function () {
                  var c = this.response;
                  (!c || !c.ok) && (this.stats.aborted = !0, this.controller.abort());
                }, v.abort = function () {
                  var c;
                  this.abortInternal(), (c = this.callbacks) !== null && c !== void 0 && c.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
                }, v.load = function (c, p, C) {
                  var _ = this,
                      g = this.stats;

                  if (g.loading.start) throw new Error("Loader can only be used once.");
                  g.loading.start = self.performance.now();
                  var s = u(c, this.controller.signal),
                      o = C.onProgress,
                      b = c.responseType === "arraybuffer",
                      A = b ? "byteLength" : "length";
                  this.context = c, this.config = p, this.callbacks = C, this.request = this.fetchSetup(c, s), self.clearTimeout(this.requestTimeout), this.requestTimeout = self.setTimeout(function () {
                    _.abortInternal(), C.onTimeout(g, c, _.response);
                  }, p.timeout), self.fetch(this.request).then(function (I) {
                    if (_.response = _.loader = I, !I.ok) {
                      var M = I.status,
                          F = I.statusText;
                      throw new n(F || "fetch, bad network response", M, I);
                    }

                    return g.loading.first = Math.max(self.performance.now(), g.loading.start), g.total = parseInt(I.headers.get("Content-Length") || "0"), o && Object(j.isFiniteNumber)(p.highWaterMark) ? _.loadProgressively(I, g, c, p.highWaterMark, o) : b ? I.arrayBuffer() : I.text();
                  }).then(function (I) {
                    var M = _.response;
                    self.clearTimeout(_.requestTimeout), g.loading.end = Math.max(self.performance.now(), g.loading.first), g.loaded = g.total = I[A];
                    var F = {
                      url: M.url,
                      data: I
                    };
                    o && !Object(j.isFiniteNumber)(p.highWaterMark) && o(g, c, I, M), C.onSuccess(F, g, c, M);
                  }).catch(function (I) {
                    if (self.clearTimeout(_.requestTimeout), !g.aborted) {
                      var M = I.code || 0;
                      C.onError({
                        code: M,
                        text: I.message
                      }, c, I.details);
                    }
                  });
                }, v.getCacheAge = function () {
                  var c = null;

                  if (this.response) {
                    var p = this.response.headers.get("age");
                    c = p ? parseFloat(p) : null;
                  }

                  return c;
                }, v.loadProgressively = function (c, p, C, _, g) {
                  _ === void 0 && (_ = 0);

                  var s = new k.default(),
                      o = c.body.getReader(),
                      b = function A() {
                    return o.read().then(function (I) {
                      if (I.done) return s.dataLength && g(p, C, s.flush(), c), Promise.resolve(new ArrayBuffer(0));
                      var M = I.value,
                          F = M.length;
                      return p.loaded += F, F < _ || s.dataLength ? (s.push(M), s.dataLength >= _ && g(p, C, s.flush(), c)) : g(p, C, M, c), A();
                    }).catch(function () {
                      return Promise.reject();
                    });
                  };

                  return b();
                }, a;
              }();

              function u(a, v) {
                var h = {
                  method: "GET",
                  mode: "cors",
                  credentials: "same-origin",
                  signal: v,
                  headers: new self.Headers(d({}, a.headers))
                };
                return a.rangeEnd && h.headers.set("Range", "bytes=" + a.rangeStart + "-" + String(a.rangeEnd - 1)), h;
              }

              function i(a, v) {
                return new self.Request(a.url, v);
              }

              var n = function (a) {
                H(v, a);

                function v(h, c, p) {
                  var C;
                  return C = a.call(this, h) || this, C.code = void 0, C.details = void 0, C.code = c, C.details = p, C;
                }

                return v;
              }(w(Error));

              K.default = y;
            },
            "./src/utils/imsc1-ttml-parser.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "IMSC1_CODEC", function () {
                return E;
              }), R.d(K, "parseIMSC1", function () {
                return f;
              });
              var j = R("./src/utils/mp4-tools.ts"),
                  x = R("./src/utils/vttparser.ts"),
                  k = R("./src/utils/vttcue.ts"),
                  H = R("./src/demux/id3.ts"),
                  w = R("./src/utils/timescale-conversion.ts"),
                  O = R("./src/utils/webvtt-parser.ts");

              function D() {
                return D = Object.assign || function (_) {
                  for (var g = 1; g < arguments.length; g++) {
                    var s = arguments[g];

                    for (var o in s) Object.prototype.hasOwnProperty.call(s, o) && (_[o] = s[o]);
                  }

                  return _;
                }, D.apply(this, arguments);
              }

              var E = "stpp.ttml.im1t",
                  L = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/,
                  P = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/,
                  d = {
                left: "start",
                center: "center",
                right: "end",
                start: "start",
                end: "end"
              };

              function f(_, g, s, o, b) {
                var A = Object(j.findBox)(new Uint8Array(_), ["mdat"]);

                if (A.length === 0) {
                  b(new Error("Could not parse IMSC1 mdat"));
                  return;
                }

                var I = A[0],
                    M = Object(H.utf8ArrayToStr)(new Uint8Array(_, I.start, I.end - I.start)),
                    F = Object(w.toTimescaleFromScale)(g, 1, s);

                try {
                  o(y(M, F));
                } catch (B) {
                  b(B);
                }
              }

              function y(_, g) {
                var s = new DOMParser(),
                    o = s.parseFromString(_, "text/xml"),
                    b = o.getElementsByTagName("tt")[0];
                if (!b) throw new Error("Invalid ttml");
                var A = {
                  frameRate: 30,
                  subFrameRate: 1,
                  frameRateMultiplier: 0,
                  tickRate: 0
                },
                    I = Object.keys(A).reduce(function (W, G) {
                  return W[G] = b.getAttribute("ttp:" + G) || A[G], W;
                }, {}),
                    M = b.getAttribute("xml:space") !== "preserve",
                    F = i(u(b, "styling", "style")),
                    B = i(u(b, "layout", "region")),
                    U = u(b, "body", "[begin]");
                return [].map.call(U, function (W) {
                  var G = n(W, M);
                  if (!G || !W.hasAttribute("begin")) return null;
                  var V = c(W.getAttribute("begin"), I),
                      Y = c(W.getAttribute("dur"), I),
                      $ = c(W.getAttribute("end"), I);
                  if (V === null) throw h(W);

                  if ($ === null) {
                    if (Y === null) throw h(W);
                    $ = V + Y;
                  }

                  var q = new k.default(V - g, $ - g, G);
                  q.id = Object(O.generateCueId)(q.startTime, q.endTime, q.text);
                  var Z = B[W.getAttribute("region")],
                      te = F[W.getAttribute("style")];
                  q.position = 10, q.size = 80;
                  var se = a(Z, te),
                      ge = se.textAlign;

                  if (ge) {
                    var he = d[ge];
                    he && (q.lineAlign = he), q.align = ge;
                  }

                  return D(q, se), q;
                }).filter(function (W) {
                  return W !== null;
                });
              }

              function u(_, g, s) {
                var o = _.getElementsByTagName(g)[0];

                return o ? [].slice.call(o.querySelectorAll(s)) : [];
              }

              function i(_) {
                return _.reduce(function (g, s) {
                  var o = s.getAttribute("xml:id");
                  return o && (g[o] = s), g;
                }, {});
              }

              function n(_, g) {
                return [].slice.call(_.childNodes).reduce(function (s, o, b) {
                  var A;
                  return o.nodeName === "br" && b ? s + "\n" : (A = o.childNodes) !== null && A !== void 0 && A.length ? n(o, g) : g ? s + o.textContent.trim().replace(/\s+/g, " ") : s + o.textContent;
                }, "");
              }

              function a(_, g) {
                var s = "http://www.w3.org/ns/ttml#styling",
                    o = ["displayAlign", "textAlign", "color", "backgroundColor", "fontSize", "fontFamily"];
                return o.reduce(function (b, A) {
                  var I = v(g, s, A) || v(_, s, A);
                  return I && (b[A] = I), b;
                }, {});
              }

              function v(_, g, s) {
                return _.hasAttributeNS(g, s) ? _.getAttributeNS(g, s) : null;
              }

              function h(_) {
                return new Error("Could not parse ttml timestamp " + _);
              }

              function c(_, g) {
                if (!_) return null;
                var s = Object(x.parseTimeStamp)(_);
                return s === null && (L.test(_) ? s = p(_, g) : P.test(_) && (s = C(_, g))), s;
              }

              function p(_, g) {
                var s = L.exec(_),
                    o = (s[4] | 0) + (s[5] | 0) / g.subFrameRate;
                return (s[1] | 0) * 3600 + (s[2] | 0) * 60 + (s[3] | 0) + o / g.frameRate;
              }

              function C(_, g) {
                var s = P.exec(_),
                    o = Number(s[1]),
                    b = s[2];

                switch (b) {
                  case "h":
                    return o * 3600;

                  case "m":
                    return o * 60;

                  case "ms":
                    return o * 1e3;

                  case "f":
                    return o / g.frameRate;

                  case "t":
                    return o / g.tickRate;
                }

                return o;
              }
            },
            "./src/utils/logger.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "enableLogs", function () {
                return O;
              }), R.d(K, "logger", function () {
                return D;
              });

              var j = function () {},
                  x = {
                trace: j,
                debug: j,
                log: j,
                warn: j,
                info: j,
                error: j
              },
                  k = x;

              function H(E) {
                var L = self.console[E];
                return L ? L.bind(self.console, "[" + E + "] >") : j;
              }

              function w(E) {
                for (var L = arguments.length, P = new Array(L > 1 ? L - 1 : 0), d = 1; d < L; d++) P[d - 1] = arguments[d];

                P.forEach(function (f) {
                  k[f] = E[f] ? E[f].bind(E) : H(f);
                });
              }

              function O(E) {
                if (self.console && E === !0 || typeof E == "object") {
                  w(E, "debug", "log", "info", "warn", "error");

                  try {
                    k.log();
                  } catch (L) {
                    k = x;
                  }
                } else k = x;
              }

              var D = k;
            },
            "./src/utils/mediakeys-helper.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "KeySystems", function () {
                return j;
              }), R.d(K, "requestMediaKeySystemAccess", function () {
                return x;
              });
              var j;

              (function (k) {
                k.WIDEVINE = "com.widevine.alpha", k.PLAYREADY = "com.microsoft.playready";
              })(j || (j = {}));

              var x = function () {
                return typeof self != "undefined" && self.navigator && self.navigator.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
              }();
            },
            "./src/utils/mediasource-helper.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "getMediaSource", function () {
                return j;
              });

              function j() {
                return self.MediaSource || self.WebKitMediaSource;
              }
            },
            "./src/utils/mp4-tools.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "bin2str", function () {
                return w;
              }), R.d(K, "readUint16", function () {
                return O;
              }), R.d(K, "readUint32", function () {
                return D;
              }), R.d(K, "writeUint32", function () {
                return E;
              }), R.d(K, "findBox", function () {
                return L;
              }), R.d(K, "parseSegmentIndex", function () {
                return P;
              }), R.d(K, "parseInitSegment", function () {
                return d;
              }), R.d(K, "getStartDTS", function () {
                return f;
              }), R.d(K, "getDuration", function () {
                return y;
              }), R.d(K, "computeRawDurationFromSamples", function () {
                return u;
              }), R.d(K, "offsetStartDTS", function () {
                return i;
              }), R.d(K, "segmentValidRange", function () {
                return n;
              }), R.d(K, "appendUint8Array", function () {
                return a;
              });
              var j = R("./src/utils/typed-array.ts"),
                  x = R("./src/loader/fragment.ts"),
                  k = Math.pow(2, 32) - 1,
                  H = [].push;

              function w(v) {
                return String.fromCharCode.apply(null, v);
              }

              function O(v, h) {
                "data" in v && (h += v.start, v = v.data);
                var c = v[h] << 8 | v[h + 1];
                return c < 0 ? 65536 + c : c;
              }

              function D(v, h) {
                "data" in v && (h += v.start, v = v.data);
                var c = v[h] << 24 | v[h + 1] << 16 | v[h + 2] << 8 | v[h + 3];
                return c < 0 ? 4294967296 + c : c;
              }

              function E(v, h, c) {
                "data" in v && (h += v.start, v = v.data), v[h] = c >> 24, v[h + 1] = c >> 16 & 255, v[h + 2] = c >> 8 & 255, v[h + 3] = c & 255;
              }

              function L(v, h) {
                var c = [];
                if (!h.length) return c;

                var p, C, _;

                "data" in v ? (p = v.data, C = v.start, _ = v.end) : (p = v, C = 0, _ = p.byteLength);

                for (var g = C; g < _;) {
                  var s = D(p, g),
                      o = w(p.subarray(g + 4, g + 8)),
                      b = s > 1 ? g + s : _;
                  if (o === h[0]) if (h.length === 1) c.push({
                    data: p,
                    start: g + 8,
                    end: b
                  });else {
                    var A = L({
                      data: p,
                      start: g + 8,
                      end: b
                    }, h.slice(1));
                    A.length && H.apply(c, A);
                  }
                  g = b;
                }

                return c;
              }

              function P(v) {
                var h = L(v, ["moov"]),
                    c = h[0],
                    p = c ? c.end : null,
                    C = L(v, ["sidx"]);
                if (!C || !C[0]) return null;
                var _ = [],
                    g = C[0],
                    s = g.data[0],
                    o = s === 0 ? 8 : 16,
                    b = D(g, o);
                o += 4;
                var A = 0,
                    I = 0;
                s === 0 ? o += 8 : o += 16, o += 2;
                var M = g.end + I,
                    F = O(g, o);
                o += 2;

                for (var B = 0; B < F; B++) {
                  var U = o,
                      W = D(g, U);
                  U += 4;
                  var G = W & 2147483647,
                      V = (W & 2147483648) >>> 31;
                  if (V === 1) return console.warn("SIDX has hierarchical references (not supported)"), null;
                  var Y = D(g, U);
                  U += 4, _.push({
                    referenceSize: G,
                    subsegmentDuration: Y,
                    info: {
                      duration: Y / b,
                      start: M,
                      end: M + G - 1
                    }
                  }), M += G, U += 4, o = U;
                }

                return {
                  earliestPresentationTime: A,
                  timescale: b,
                  version: s,
                  referencesCount: F,
                  references: _,
                  moovEndOffset: p
                };
              }

              function d(v) {
                for (var h = [], c = L(v, ["moov", "trak"]), p = 0; p < c.length; p++) {
                  var C = c[p],
                      _ = L(C, ["tkhd"])[0];

                  if (_) {
                    var g = _.data[_.start],
                        s = g === 0 ? 12 : 20,
                        o = D(_, s),
                        b = L(C, ["mdia", "mdhd"])[0];

                    if (b) {
                      g = b.data[b.start], s = g === 0 ? 12 : 20;
                      var A = D(b, s),
                          I = L(C, ["mdia", "hdlr"])[0];

                      if (I) {
                        var M = w(I.data.subarray(I.start + 8, I.start + 12)),
                            F = {
                          soun: x.ElementaryStreamTypes.AUDIO,
                          vide: x.ElementaryStreamTypes.VIDEO
                        }[M];

                        if (F) {
                          var B = L(C, ["mdia", "minf", "stbl", "stsd"])[0],
                              U = void 0;
                          B && (U = w(B.data.subarray(B.start + 12, B.start + 16))), h[o] = {
                            timescale: A,
                            type: F
                          }, h[F] = {
                            timescale: A,
                            id: o,
                            codec: U
                          };
                        }
                      }
                    }
                  }
                }

                var W = L(v, ["moov", "mvex", "trex"]);
                return W.forEach(function (G) {
                  var V = D(G, 4),
                      Y = h[V];
                  Y && (Y.default = {
                    duration: D(G, 12),
                    flags: D(G, 20)
                  });
                }), h;
              }

              function f(v, h) {
                return L(h, ["moof", "traf"]).reduce(function (c, p) {
                  var C = L(p, ["tfdt"])[0],
                      _ = C.data[C.start],
                      g = L(p, ["tfhd"]).reduce(function (s, o) {
                    var b = D(o, 4),
                        A = v[b];

                    if (A) {
                      var I = D(C, 4);
                      _ === 1 && (I *= Math.pow(2, 32), I += D(C, 8));
                      var M = A.timescale || 9e4,
                          F = I / M;
                      if (isFinite(F) && (s === null || F < s)) return F;
                    }

                    return s;
                  }, null);
                  return g !== null && isFinite(g) && (c === null || g < c) ? g : c;
                }, null) || 0;
              }

              function y(v, h) {
                for (var c = 0, p = 0, C = 0, _ = L(v, ["moof", "traf"]), g = 0; g < _.length; g++) {
                  var s = _[g],
                      o = L(s, ["tfhd"])[0],
                      b = D(o, 4),
                      A = h[b];

                  if (!!A) {
                    var I = A.default,
                        M = D(o, 0) | (I == null ? void 0 : I.flags),
                        F = I == null ? void 0 : I.duration;
                    M & 8 && (M & 2 ? F = D(o, 12) : F = D(o, 8));

                    for (var B = A.timescale || 9e4, U = L(s, ["trun"]), W = 0; W < U.length; W++) {
                      if (c = u(U[W]), !c && F) {
                        var G = D(U[W], 4);
                        c = F * G;
                      }

                      A.type === x.ElementaryStreamTypes.VIDEO ? p += c / B : A.type === x.ElementaryStreamTypes.AUDIO && (C += c / B);
                    }
                  }
                }

                if (p === 0 && C === 0) {
                  var V = P(v);
                  if (V != null && V.references) return V.references.reduce(function (Y, $) {
                    return Y + $.info.duration || 0;
                  }, 0);
                }

                return p || C;
              }

              function u(v) {
                var h = D(v, 0),
                    c = 8;
                h & 1 && (c += 4), h & 4 && (c += 4);

                for (var p = 0, C = D(v, 4), _ = 0; _ < C; _++) {
                  if (h & 256) {
                    var g = D(v, c);
                    p += g, c += 4;
                  }

                  h & 512 && (c += 4), h & 1024 && (c += 4), h & 2048 && (c += 4);
                }

                return p;
              }

              function i(v, h, c) {
                L(h, ["moof", "traf"]).forEach(function (p) {
                  L(p, ["tfhd"]).forEach(function (C) {
                    var _ = D(C, 4),
                        g = v[_];

                    if (!!g) {
                      var s = g.timescale || 9e4;
                      L(p, ["tfdt"]).forEach(function (o) {
                        var b = o.data[o.start],
                            A = D(o, 4);
                        if (b === 0) E(o, 4, A - c * s);else {
                          A *= Math.pow(2, 32), A += D(o, 8), A -= c * s, A = Math.max(A, 0);
                          var I = Math.floor(A / (k + 1)),
                              M = Math.floor(A % (k + 1));
                          E(o, 4, I), E(o, 8, M);
                        }
                      });
                    }
                  });
                });
              }

              function n(v) {
                var h = {
                  valid: null,
                  remainder: null
                },
                    c = L(v, ["moof"]);

                if (c) {
                  if (c.length < 2) return h.remainder = v, h;
                } else return h;

                var p = c[c.length - 1];
                return h.valid = Object(j.sliceUint8)(v, 0, p.start - 8), h.remainder = Object(j.sliceUint8)(v, p.start - 8), h;
              }

              function a(v, h) {
                var c = new Uint8Array(v.length + h.length);
                return c.set(v), c.set(h, v.length), c;
              }
            },
            "./src/utils/output-filter.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "default", function () {
                return j;
              });

              var j = function () {
                function x(H, w) {
                  this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = H, this.trackName = w;
                }

                var k = x.prototype;
                return k.dispatchCue = function () {
                  this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
                }, k.newCue = function (w, O, D) {
                  (this.startTime === null || this.startTime > w) && (this.startTime = w), this.endTime = O, this.screen = D, this.timelineController.createCaptionsTrack(this.trackName);
                }, k.reset = function () {
                  this.cueRanges = [], this.startTime = null;
                }, x;
              }();
            },
            "./src/utils/texttrack-utils.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "sendAddTrackEvent", function () {
                return x;
              }), R.d(K, "addCueToTrack", function () {
                return k;
              }), R.d(K, "clearCurrentCues", function () {
                return H;
              }), R.d(K, "removeCuesInRange", function () {
                return w;
              }), R.d(K, "getCuesInRange", function () {
                return D;
              });
              var j = R("./src/utils/logger.ts");

              function x(E, L) {
                var P;

                try {
                  P = new Event("addtrack");
                } catch (d) {
                  P = document.createEvent("Event"), P.initEvent("addtrack", !1, !1);
                }

                P.track = E, L.dispatchEvent(P);
              }

              function k(E, L) {
                var P = E.mode;
                if (P === "disabled" && (E.mode = "hidden"), E.cues && !E.cues.getCueById(L.id)) try {
                  if (E.addCue(L), !E.cues.getCueById(L.id)) throw new Error("addCue is failed for: " + L);
                } catch (f) {
                  j.logger.debug("[texttrack-utils]: " + f);
                  var d = new self.TextTrackCue(L.startTime, L.endTime, L.text);
                  d.id = L.id, E.addCue(d);
                }
                P === "disabled" && (E.mode = P);
              }

              function H(E) {
                var L = E.mode;
                if (L === "disabled" && (E.mode = "hidden"), E.cues) for (var P = E.cues.length; P--;) E.removeCue(E.cues[P]);
                L === "disabled" && (E.mode = L);
              }

              function w(E, L, P) {
                var d = E.mode;
                if (d === "disabled" && (E.mode = "hidden"), E.cues && E.cues.length > 0) for (var f = D(E.cues, L, P), y = 0; y < f.length; y++) E.removeCue(f[y]);
                d === "disabled" && (E.mode = d);
              }

              function O(E, L) {
                if (L < E[0].startTime) return 0;
                var P = E.length - 1;
                if (L > E[P].endTime) return -1;

                for (var d = 0, f = P; d <= f;) {
                  var y = Math.floor((f + d) / 2);
                  if (L < E[y].startTime) f = y - 1;else if (L > E[y].startTime && d < P) d = y + 1;else return y;
                }

                return E[d].startTime - L < L - E[f].startTime ? d : f;
              }

              function D(E, L, P) {
                var d = [],
                    f = O(E, L);
                if (f > -1) for (var y = f, u = E.length; y < u; y++) {
                  var i = E[y];
                  if (i.startTime >= L && i.endTime <= P) d.push(i);else if (i.startTime > P) return d;
                }
                return d;
              }
            },
            "./src/utils/time-ranges.ts": function (ae, K, R) {
              "use strict";

              R.r(K);
              var j = {
                toString: function (k) {
                  for (var H = "", w = k.length, O = 0; O < w; O++) H += "[" + k.start(O).toFixed(3) + "," + k.end(O).toFixed(3) + "]";

                  return H;
                }
              };
              K.default = j;
            },
            "./src/utils/timescale-conversion.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "toTimescaleFromBase", function () {
                return x;
              }), R.d(K, "toTimescaleFromScale", function () {
                return k;
              }), R.d(K, "toMsFromMpegTsClock", function () {
                return H;
              }), R.d(K, "toMpegTsClockFromTimescale", function () {
                return w;
              });
              var j = 9e4;

              function x(O, D, E, L) {
                E === void 0 && (E = 1), L === void 0 && (L = !1);
                var P = O * D * E;
                return L ? Math.round(P) : P;
              }

              function k(O, D, E, L) {
                return E === void 0 && (E = 1), L === void 0 && (L = !1), x(O, D, 1 / E, L);
              }

              function H(O, D) {
                return D === void 0 && (D = !1), x(O, 1e3, 1 / j, D);
              }

              function w(O, D) {
                return D === void 0 && (D = 1), x(O, j, 1 / D);
              }
            },
            "./src/utils/typed-array.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "sliceUint8", function () {
                return j;
              });

              function j(x, k, H) {
                return Uint8Array.prototype.slice ? x.slice(k, H) : new Uint8Array(Array.prototype.slice.call(x, k, H));
              }
            },
            "./src/utils/vttcue.ts": function (ae, K, R) {
              "use strict";

              R.r(K), K.default = function () {
                if (typeof self != "undefined" && self.VTTCue) return self.VTTCue;
                var j = ["", "lr", "rl"],
                    x = ["start", "middle", "end", "left", "right"];

                function k(E, L) {
                  if (typeof L != "string" || !Array.isArray(E)) return !1;
                  var P = L.toLowerCase();
                  return ~E.indexOf(P) ? P : !1;
                }

                function H(E) {
                  return k(j, E);
                }

                function w(E) {
                  return k(x, E);
                }

                function O(E) {
                  for (var L = arguments.length, P = new Array(L > 1 ? L - 1 : 0), d = 1; d < L; d++) P[d - 1] = arguments[d];

                  for (var f = 1; f < arguments.length; f++) {
                    var y = arguments[f];

                    for (var u in y) E[u] = y[u];
                  }

                  return E;
                }

                function D(E, L, P) {
                  var d = this,
                      f = {
                    enumerable: !0
                  };
                  d.hasBeenReset = !1;
                  var y = "",
                      u = !1,
                      i = E,
                      n = L,
                      a = P,
                      v = null,
                      h = "",
                      c = !0,
                      p = "auto",
                      C = "start",
                      _ = 50,
                      g = "middle",
                      s = 50,
                      o = "middle";
                  Object.defineProperty(d, "id", O({}, f, {
                    get: function () {
                      return y;
                    },
                    set: function (A) {
                      y = "" + A;
                    }
                  })), Object.defineProperty(d, "pauseOnExit", O({}, f, {
                    get: function () {
                      return u;
                    },
                    set: function (A) {
                      u = !!A;
                    }
                  })), Object.defineProperty(d, "startTime", O({}, f, {
                    get: function () {
                      return i;
                    },
                    set: function (A) {
                      if (typeof A != "number") throw new TypeError("Start time must be set to a number.");
                      i = A, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "endTime", O({}, f, {
                    get: function () {
                      return n;
                    },
                    set: function (A) {
                      if (typeof A != "number") throw new TypeError("End time must be set to a number.");
                      n = A, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "text", O({}, f, {
                    get: function () {
                      return a;
                    },
                    set: function (A) {
                      a = "" + A, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "region", O({}, f, {
                    get: function () {
                      return v;
                    },
                    set: function (A) {
                      v = A, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "vertical", O({}, f, {
                    get: function () {
                      return h;
                    },
                    set: function (A) {
                      var I = H(A);
                      if (I === !1) throw new SyntaxError("An invalid or illegal string was specified.");
                      h = I, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "snapToLines", O({}, f, {
                    get: function () {
                      return c;
                    },
                    set: function (A) {
                      c = !!A, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "line", O({}, f, {
                    get: function () {
                      return p;
                    },
                    set: function (A) {
                      if (typeof A != "number" && A !== "auto") throw new SyntaxError("An invalid number or illegal string was specified.");
                      p = A, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "lineAlign", O({}, f, {
                    get: function () {
                      return C;
                    },
                    set: function (A) {
                      var I = w(A);
                      if (!I) throw new SyntaxError("An invalid or illegal string was specified.");
                      C = I, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "position", O({}, f, {
                    get: function () {
                      return _;
                    },
                    set: function (A) {
                      if (A < 0 || A > 100) throw new Error("Position must be between 0 and 100.");
                      _ = A, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "positionAlign", O({}, f, {
                    get: function () {
                      return g;
                    },
                    set: function (A) {
                      var I = w(A);
                      if (!I) throw new SyntaxError("An invalid or illegal string was specified.");
                      g = I, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "size", O({}, f, {
                    get: function () {
                      return s;
                    },
                    set: function (A) {
                      if (A < 0 || A > 100) throw new Error("Size must be between 0 and 100.");
                      s = A, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(d, "align", O({}, f, {
                    get: function () {
                      return o;
                    },
                    set: function (A) {
                      var I = w(A);
                      if (!I) throw new SyntaxError("An invalid or illegal string was specified.");
                      o = I, this.hasBeenReset = !0;
                    }
                  })), d.displayState = void 0;
                }

                return D.prototype.getCueAsHTML = function () {
                  var E = self.WebVTT;
                  return E.convertCueToDOMTree(self, this.text);
                }, D;
              }();
            },
            "./src/utils/vttparser.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "parseTimeStamp", function () {
                return k;
              }), R.d(K, "fixLineBreaks", function () {
                return L;
              }), R.d(K, "VTTParser", function () {
                return P;
              });

              var j = R("./src/utils/vttcue.ts"),
                  x = function () {
                function d() {}

                var f = d.prototype;
                return f.decode = function (u, i) {
                  if (!u) return "";
                  if (typeof u != "string") throw new Error("Error - expected string data.");
                  return decodeURIComponent(encodeURIComponent(u));
                }, d;
              }();

              function k(d) {
                function f(u, i, n, a) {
                  return (u | 0) * 3600 + (i | 0) * 60 + (n | 0) + parseFloat(a || 0);
                }

                var y = d.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
                return y ? parseFloat(y[2]) > 59 ? f(y[2], y[3], 0, y[4]) : f(y[1], y[2], y[3], y[4]) : null;
              }

              var H = function () {
                function d() {
                  this.values = Object.create(null);
                }

                var f = d.prototype;
                return f.set = function (u, i) {
                  !this.get(u) && i !== "" && (this.values[u] = i);
                }, f.get = function (u, i, n) {
                  return n ? this.has(u) ? this.values[u] : i[n] : this.has(u) ? this.values[u] : i;
                }, f.has = function (u) {
                  return u in this.values;
                }, f.alt = function (u, i, n) {
                  for (var a = 0; a < n.length; ++a) if (i === n[a]) {
                    this.set(u, i);
                    break;
                  }
                }, f.integer = function (u, i) {
                  /^-?\d+$/.test(i) && this.set(u, parseInt(i, 10));
                }, f.percent = function (u, i) {
                  if (/^([\d]{1,3})(\.[\d]*)?%$/.test(i)) {
                    var n = parseFloat(i);
                    if (n >= 0 && n <= 100) return this.set(u, n), !0;
                  }

                  return !1;
                }, d;
              }();

              function w(d, f, y, u) {
                var i = u ? d.split(u) : [d];

                for (var n in i) if (typeof i[n] == "string") {
                  var a = i[n].split(y);

                  if (a.length === 2) {
                    var v = a[0],
                        h = a[1];
                    f(v, h);
                  }
                }
              }

              var O = new j.default(0, 0, ""),
                  D = O.align === "middle" ? "middle" : "center";

              function E(d, f, y) {
                var u = d;

                function i() {
                  var v = k(d);
                  if (v === null) throw new Error("Malformed timestamp: " + u);
                  return d = d.replace(/^[^\sa-zA-Z-]+/, ""), v;
                }

                function n(v, h) {
                  var c = new H();
                  w(v, function (_, g) {
                    var s;

                    switch (_) {
                      case "region":
                        for (var o = y.length - 1; o >= 0; o--) if (y[o].id === g) {
                          c.set(_, y[o].region);
                          break;
                        }

                        break;

                      case "vertical":
                        c.alt(_, g, ["rl", "lr"]);
                        break;

                      case "line":
                        s = g.split(","), c.integer(_, s[0]), c.percent(_, s[0]) && c.set("snapToLines", !1), c.alt(_, s[0], ["auto"]), s.length === 2 && c.alt("lineAlign", s[1], ["start", D, "end"]);
                        break;

                      case "position":
                        s = g.split(","), c.percent(_, s[0]), s.length === 2 && c.alt("positionAlign", s[1], ["start", D, "end", "line-left", "line-right", "auto"]);
                        break;

                      case "size":
                        c.percent(_, g);
                        break;

                      case "align":
                        c.alt(_, g, ["start", D, "end", "left", "right"]);
                        break;
                    }
                  }, /:/, /\s/), h.region = c.get("region", null), h.vertical = c.get("vertical", "");
                  var p = c.get("line", "auto");
                  p === "auto" && O.line === -1 && (p = -1), h.line = p, h.lineAlign = c.get("lineAlign", "start"), h.snapToLines = c.get("snapToLines", !0), h.size = c.get("size", 100), h.align = c.get("align", D);
                  var C = c.get("position", "auto");
                  C === "auto" && O.position === 50 && (C = h.align === "start" || h.align === "left" ? 0 : h.align === "end" || h.align === "right" ? 100 : 50), h.position = C;
                }

                function a() {
                  d = d.replace(/^\s+/, "");
                }

                if (a(), f.startTime = i(), a(), d.substr(0, 3) !== "-->") throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + u);
                d = d.substr(3), a(), f.endTime = i(), a(), n(d, f);
              }

              function L(d) {
                return d.replace(/<br(?: \/)?>/gi, "\n");
              }

              var P = function () {
                function d() {
                  this.state = "INITIAL", this.buffer = "", this.decoder = new x(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
                }

                var f = d.prototype;
                return f.parse = function (u) {
                  var i = this;
                  u && (i.buffer += i.decoder.decode(u, {
                    stream: !0
                  }));

                  function n() {
                    var C = i.buffer,
                        _ = 0;

                    for (C = L(C); _ < C.length && C[_] !== "\r" && C[_] !== "\n";) ++_;

                    var g = C.substr(0, _);
                    return C[_] === "\r" && ++_, C[_] === "\n" && ++_, i.buffer = C.substr(_), g;
                  }

                  function a(C) {
                    w(C, function (_, g) {}, /:/);
                  }

                  try {
                    var v = "";

                    if (i.state === "INITIAL") {
                      if (!/\r\n|\n/.test(i.buffer)) return this;
                      v = n();
                      var h = v.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                      if (!h || !h[0]) throw new Error("Malformed WebVTT signature.");
                      i.state = "HEADER";
                    }

                    for (var c = !1; i.buffer;) {
                      if (!/\r\n|\n/.test(i.buffer)) return this;

                      switch (c ? c = !1 : v = n(), i.state) {
                        case "HEADER":
                          /:/.test(v) ? a(v) : v || (i.state = "ID");
                          continue;

                        case "NOTE":
                          v || (i.state = "ID");
                          continue;

                        case "ID":
                          if (/^NOTE($|[ \t])/.test(v)) {
                            i.state = "NOTE";
                            break;
                          }

                          if (!v) continue;

                          if (i.cue = new j.default(0, 0, ""), i.state = "CUE", v.indexOf("-->") === -1) {
                            i.cue.id = v;
                            continue;
                          }

                        case "CUE":
                          if (!i.cue) {
                            i.state = "BADCUE";
                            continue;
                          }

                          try {
                            E(v, i.cue, i.regionList);
                          } catch (C) {
                            i.cue = null, i.state = "BADCUE";
                            continue;
                          }

                          i.state = "CUETEXT";
                          continue;

                        case "CUETEXT":
                          {
                            var p = v.indexOf("-->") !== -1;

                            if (!v || p && (c = !0)) {
                              i.oncue && i.cue && i.oncue(i.cue), i.cue = null, i.state = "ID";
                              continue;
                            }

                            if (i.cue === null) continue;
                            i.cue.text && (i.cue.text += "\n"), i.cue.text += v;
                          }
                          continue;

                        case "BADCUE":
                          v || (i.state = "ID");
                      }
                    }
                  } catch (C) {
                    i.state === "CUETEXT" && i.cue && i.oncue && i.oncue(i.cue), i.cue = null, i.state = i.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
                  }

                  return this;
                }, f.flush = function () {
                  var u = this;

                  try {
                    if ((u.cue || u.state === "HEADER") && (u.buffer += "\n\n", u.parse()), u.state === "INITIAL" || u.state === "BADWEBVTT") throw new Error("Malformed WebVTT signature.");
                  } catch (i) {
                    u.onparsingerror && u.onparsingerror(i);
                  }

                  return u.onflush && u.onflush(), this;
                }, d;
              }();
            },
            "./src/utils/webvtt-parser.ts": function (ae, K, R) {
              "use strict";

              R.r(K), R.d(K, "generateCueId", function () {
                return P;
              }), R.d(K, "parseWebVTT", function () {
                return f;
              });

              var j = R("./src/polyfills/number.ts"),
                  x = R("./src/utils/vttparser.ts"),
                  k = R("./src/demux/id3.ts"),
                  H = R("./src/utils/timescale-conversion.ts"),
                  w = R("./src/remux/mp4-remuxer.ts"),
                  O = /\r\n|\n\r|\n|\r/g,
                  D = function (u, i, n) {
                return n === void 0 && (n = 0), u.substr(n, i.length) === i;
              },
                  E = function (u) {
                var i = parseInt(u.substr(-3)),
                    n = parseInt(u.substr(-6, 2)),
                    a = parseInt(u.substr(-9, 2)),
                    v = u.length > 9 ? parseInt(u.substr(0, u.indexOf(":"))) : 0;
                if (!Object(j.isFiniteNumber)(i) || !Object(j.isFiniteNumber)(n) || !Object(j.isFiniteNumber)(a) || !Object(j.isFiniteNumber)(v)) throw Error("Malformed X-TIMESTAMP-MAP: Local:" + u);
                return i += 1e3 * n, i += 60 * 1e3 * a, i += 60 * 60 * 1e3 * v, i;
              },
                  L = function (u) {
                for (var i = 5381, n = u.length; n;) i = i * 33 ^ u.charCodeAt(--n);

                return (i >>> 0).toString();
              };

              function P(y, u, i) {
                return L(y.toString()) + L(u.toString()) + L(i);
              }

              var d = function (u, i, n) {
                var a = u[i],
                    v = u[a.prevCC];

                if (!v || !v.new && a.new) {
                  u.ccOffset = u.presentationOffset = a.start, a.new = !1;
                  return;
                }

                for (; (h = v) !== null && h !== void 0 && h.new;) {
                  var h;
                  u.ccOffset += a.start - v.start, a.new = !1, a = v, v = u[a.prevCC];
                }

                u.presentationOffset = n;
              };

              function f(y, u, i, n, a, v, h, c) {
                var p = new x.VTTParser(),
                    C = Object(k.utf8ArrayToStr)(new Uint8Array(y)).trim().replace(O, "\n").split("\n"),
                    _ = [],
                    g = Object(H.toMpegTsClockFromTimescale)(u, i),
                    s = "00:00.000",
                    o = 0,
                    b = 0,
                    A,
                    I = !0,
                    M = !1;
                p.oncue = function (F) {
                  var B = n[a],
                      U = n.ccOffset,
                      W = (o - g) / 9e4;

                  if (B != null && B.new && (b !== void 0 ? U = n.ccOffset = B.start : d(n, a, W)), W && (U = W - n.presentationOffset), M) {
                    var G = F.endTime - F.startTime,
                        V = Object(w.normalizePts)((F.startTime + U - b) * 9e4, v * 9e4) / 9e4;
                    F.startTime = V, F.endTime = V + G;
                  }

                  var Y = F.text.trim();
                  F.text = decodeURIComponent(encodeURIComponent(Y)), F.id || (F.id = P(F.startTime, F.endTime, Y)), F.endTime > 0 && _.push(F);
                }, p.onparsingerror = function (F) {
                  A = F;
                }, p.onflush = function () {
                  if (A) {
                    c(A);
                    return;
                  }

                  h(_);
                }, C.forEach(function (F) {
                  if (I) if (D(F, "X-TIMESTAMP-MAP=")) {
                    I = !1, M = !0, F.substr(16).split(",").forEach(function (B) {
                      D(B, "LOCAL:") ? s = B.substr(6) : D(B, "MPEGTS:") && (o = parseInt(B.substr(7)));
                    });

                    try {
                      b = E(s) / 1e3;
                    } catch (B) {
                      M = !1, A = B;
                    }

                    return;
                  } else F === "" && (I = !1);
                  p.parse(F + "\n");
                }), p.flush();
              }
            },
            "./src/utils/xhr-loader.ts": function (ae, K, R) {
              "use strict";

              R.r(K);

              var j = R("./src/utils/logger.ts"),
                  x = R("./src/loader/load-stats.ts"),
                  k = /^age:\s*[\d.]+\s*$/m,
                  H = function () {
                function w(D) {
                  this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = void 0, this.loader = null, this.stats = void 0, this.xhrSetup = D ? D.xhrSetup : null, this.stats = new x.LoadStats(), this.retryDelay = 0;
                }

                var O = w.prototype;
                return O.destroy = function () {
                  this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null;
                }, O.abortInternal = function () {
                  var E = this.loader;
                  self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), E && (E.onreadystatechange = null, E.onprogress = null, E.readyState !== 4 && (this.stats.aborted = !0, E.abort()));
                }, O.abort = function () {
                  var E;
                  this.abortInternal(), (E = this.callbacks) !== null && E !== void 0 && E.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
                }, O.load = function (E, L, P) {
                  if (this.stats.loading.start) throw new Error("Loader can only be used once.");
                  this.stats.loading.start = self.performance.now(), this.context = E, this.config = L, this.callbacks = P, this.retryDelay = L.retryDelay, this.loadInternal();
                }, O.loadInternal = function () {
                  var E = this.config,
                      L = this.context;

                  if (!!E) {
                    var P = this.loader = new self.XMLHttpRequest(),
                        d = this.stats;
                    d.loading.first = 0, d.loaded = 0;
                    var f = this.xhrSetup;

                    try {
                      if (f) try {
                        f(P, L.url);
                      } catch (i) {
                        P.open("GET", L.url, !0), f(P, L.url);
                      }
                      P.readyState || P.open("GET", L.url, !0);
                      var y = this.context.headers;
                      if (y) for (var u in y) P.setRequestHeader(u, y[u]);
                    } catch (i) {
                      this.callbacks.onError({
                        code: P.status,
                        text: i.message
                      }, L, P);
                      return;
                    }

                    L.rangeEnd && P.setRequestHeader("Range", "bytes=" + L.rangeStart + "-" + (L.rangeEnd - 1)), P.onreadystatechange = this.readystatechange.bind(this), P.onprogress = this.loadprogress.bind(this), P.responseType = L.responseType, self.clearTimeout(this.requestTimeout), this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), E.timeout), P.send();
                  }
                }, O.readystatechange = function () {
                  var E = this.context,
                      L = this.loader,
                      P = this.stats;

                  if (!(!E || !L)) {
                    var d = L.readyState,
                        f = this.config;
                    if (!P.aborted && d >= 2) if (self.clearTimeout(this.requestTimeout), P.loading.first === 0 && (P.loading.first = Math.max(self.performance.now(), P.loading.start)), d === 4) {
                      L.onreadystatechange = null, L.onprogress = null;
                      var y = L.status;

                      if (y >= 200 && y < 300) {
                        P.loading.end = Math.max(self.performance.now(), P.loading.first);
                        var u, i;
                        if (E.responseType === "arraybuffer" ? (u = L.response, i = u.byteLength) : (u = L.responseText, i = u.length), P.loaded = P.total = i, !this.callbacks) return;
                        var n = this.callbacks.onProgress;
                        if (n && n(P, E, u, L), !this.callbacks) return;
                        var a = {
                          url: L.responseURL,
                          data: u
                        };
                        this.callbacks.onSuccess(a, P, E, L);
                      } else P.retry >= f.maxRetry || y >= 400 && y < 499 ? (j.logger.error(y + " while loading " + E.url), this.callbacks.onError({
                        code: y,
                        text: L.statusText
                      }, E, L)) : (j.logger.warn(y + " while loading " + E.url + ", retrying in " + this.retryDelay + "..."), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay), this.retryDelay = Math.min(2 * this.retryDelay, f.maxRetryDelay), P.retry++);
                    } else self.clearTimeout(this.requestTimeout), this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), f.timeout);
                  }
                }, O.loadtimeout = function () {
                  j.logger.warn("timeout while loading " + this.context.url);
                  var E = this.callbacks;
                  E && (this.abortInternal(), E.onTimeout(this.stats, this.context, this.loader));
                }, O.loadprogress = function (E) {
                  var L = this.stats;
                  L.loaded = E.loaded, E.lengthComputable && (L.total = E.total);
                }, O.getCacheAge = function () {
                  var E = null;

                  if (this.loader && k.test(this.loader.getAllResponseHeaders())) {
                    var L = this.loader.getResponseHeader("age");
                    E = L ? parseFloat(L) : null;
                  }

                  return E;
                }, w;
              }();

              K.default = H;
            }
          }).default;
        });
      },
      988: ve => {
        ve.exports = K;
        var ae = Object.prototype.toString;

        function K(R) {
          if (!R) return !1;
          var j = ae.call(R);
          return j === "[object Function]" || typeof R == "function" && j !== "[object RegExp]" || typeof window != "undefined" && (R === window.setTimeout || R === window.alert || R === window.confirm || R === window.prompt);
        }
      },
      642: (ve, ae) => {
        function K(w) {
          if (w && typeof w == "object") {
            var O = w.which || w.keyCode || w.charCode;
            O && (w = O);
          }

          if (typeof w == "number") return k[w];
          var D = String(w),
              E = R[D.toLowerCase()];
          if (E) return E;
          var E = j[D.toLowerCase()];
          if (E) return E;
          if (D.length === 1) return D.charCodeAt(0);
        }

        K.isEventKey = function (O, D) {
          if (O && typeof O == "object") {
            var E = O.which || O.keyCode || O.charCode;
            if (E == null) return !1;

            if (typeof D == "string") {
              var L = R[D.toLowerCase()];
              if (L) return L === E;
              var L = j[D.toLowerCase()];
              if (L) return L === E;
            } else if (typeof D == "number") return D === E;

            return !1;
          }
        }, ae = ve.exports = K;
        var R = ae.code = ae.codes = {
          backspace: 8,
          tab: 9,
          enter: 13,
          shift: 16,
          ctrl: 17,
          alt: 18,
          "pause/break": 19,
          "caps lock": 20,
          esc: 27,
          space: 32,
          "page up": 33,
          "page down": 34,
          end: 35,
          home: 36,
          left: 37,
          up: 38,
          right: 39,
          down: 40,
          insert: 45,
          delete: 46,
          command: 91,
          "left command": 91,
          "right command": 93,
          "numpad *": 106,
          "numpad +": 107,
          "numpad -": 109,
          "numpad .": 110,
          "numpad /": 111,
          "num lock": 144,
          "scroll lock": 145,
          "my computer": 182,
          "my calculator": 183,
          ";": 186,
          "=": 187,
          ",": 188,
          "-": 189,
          ".": 190,
          "/": 191,
          "`": 192,
          "[": 219,
          "\\": 220,
          "]": 221,
          "'": 222
        },
            j = ae.aliases = {
          windows: 91,
          "\u21E7": 16,
          "\u2325": 18,
          "\u2303": 17,
          "\u2318": 91,
          ctl: 17,
          control: 17,
          option: 18,
          pause: 19,
          break: 19,
          caps: 20,
          return: 13,
          escape: 27,
          spc: 32,
          spacebar: 32,
          pgup: 33,
          pgdn: 34,
          ins: 45,
          del: 46,
          cmd: 91
        };
        /*!
        * Programatically add the following
        */

        for (x = 97; x < 123; x++) R[String.fromCharCode(x)] = x - 32;

        for (var x = 48; x < 58; x++) R[x - 48] = x;

        for (x = 1; x < 13; x++) R["f" + x] = x + 111;

        for (x = 0; x < 10; x++) R["numpad " + x] = x + 96;

        var k = ae.names = ae.title = {};

        for (x in R) k[R[x]] = x;

        for (var H in j) R[H] = j[H];
      },
      54: ve => {
        ve.exports = ae;

        function ae(K, R) {
          var j,
              x = null;

          try {
            j = JSON.parse(K, R);
          } catch (k) {
            x = k;
          }

          return [x, j];
        }
      },
      207: (ve, ae, K) => {
        "use strict";
        /**
        * @license
        * Video.js 7.18.1 <http://videojs.com/>
        * Copyright Brightcove, Inc. <https://www.brightcove.com/>
        * Available under Apache License Version 2.0
        * <https://github.com/videojs/video.js/blob/main/LICENSE>
        *
        * Includes vtt.js <https://github.com/mozilla/vtt.js>
        * Available under Apache License Version 2.0
        * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
        */

        var R = K(697),
            j = K(675),
            x = K(723),
            k = K(642),
            H = K(477),
            w = K(743),
            O = K(54),
            D = K(424),
            E = K(497),
            L = K(811),
            P = K(324);

        function d(m) {
          return m && typeof m == "object" && "default" in m ? m : {
            default: m
          };
        }

        for (var f = d(R), y = d(j), u = d(x), i = d(k), n = d(H), a = d(w), v = d(O), h = d(D), c = d(E), p = d(L), C = d(P), _ = "7.18.1", g = {}, s = function (T, l) {
          return g[T] = g[T] || [], l && (g[T] = g[T].concat(l)), g[T];
        }, o = function (T, l) {
          s(T, l);
        }, b = function (T, l) {
          var r = s(T).indexOf(l);
          return r <= -1 ? !1 : (g[T] = g[T].slice(), g[T].splice(r, 1), !0);
        }, A = function (T, l) {
          s(T, [].concat(l).map(function (r) {
            var e = function t() {
              return b(T, t), r.apply(void 0, arguments);
            };

            return e;
          }));
        }, I = {
          prefixed: !0
        }, M = [["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"], ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"], ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror", "-moz-full-screen"], ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError", "-ms-fullscreen"]], F = M[0], B, U = 0; U < M.length; U++) if (M[U][1] in y.default) {
          B = M[U];
          break;
        }

        if (B) {
          for (var W = 0; W < B.length; W++) I[F[W]] = B[W];

          I.prefixed = B[0] !== F[0];
        }

        var G = [],
            V = function (T, l) {
          return function (r, e, t) {
            var S = l.levels[e],
                N = new RegExp("^(" + S + ")$");

            if (r !== "log" && t.unshift(r.toUpperCase() + ":"), t.unshift(T + ":"), G) {
              G.push([].concat(t));
              var z = G.length - 1e3;
              G.splice(0, z > 0 ? z : 0);
            }

            if (!!f.default.console) {
              var X = f.default.console[r];
              !X && r === "debug" && (X = f.default.console.info || f.default.console.log), !(!X || !S || !N.test(r)) && X[Array.isArray(t) ? "apply" : "call"](f.default.console, t);
            }
          };
        };

        function Y(m) {
          var T = "info",
              l,
              r = function () {
            for (var t = arguments.length, S = new Array(t), N = 0; N < t; N++) S[N] = arguments[N];

            l("log", T, S);
          };

          return l = V(m, r), r.createLogger = function (e) {
            return Y(m + ": " + e);
          }, r.levels = {
            all: "debug|log|warn|error",
            off: "",
            debug: "debug|log|warn|error",
            info: "log|warn|error",
            warn: "warn|error",
            error: "error",
            DEFAULT: T
          }, r.level = function (e) {
            if (typeof e == "string") {
              if (!r.levels.hasOwnProperty(e)) throw new Error('"' + e + '" in not a valid log level');
              T = e;
            }

            return T;
          }, r.history = function () {
            return G ? [].concat(G) : [];
          }, r.history.filter = function (e) {
            return (G || []).filter(function (t) {
              return new RegExp(".*" + e + ".*").test(t[0]);
            });
          }, r.history.clear = function () {
            G && (G.length = 0);
          }, r.history.disable = function () {
            G !== null && (G.length = 0, G = null);
          }, r.history.enable = function () {
            G === null && (G = []);
          }, r.error = function () {
            for (var e = arguments.length, t = new Array(e), S = 0; S < e; S++) t[S] = arguments[S];

            return l("error", T, t);
          }, r.warn = function () {
            for (var e = arguments.length, t = new Array(e), S = 0; S < e; S++) t[S] = arguments[S];

            return l("warn", T, t);
          }, r.debug = function () {
            for (var e = arguments.length, t = new Array(e), S = 0; S < e; S++) t[S] = arguments[S];

            return l("debug", T, t);
          }, r;
        }

        var $ = Y("VIDEOJS"),
            q = $.createLogger,
            Z = Object.prototype.toString,
            te = function (T) {
          return ye(T) ? Object.keys(T) : [];
        };

        function se(m, T) {
          te(m).forEach(function (l) {
            return T(m[l], l);
          });
        }

        function ge(m, T, l) {
          return l === void 0 && (l = 0), te(m).reduce(function (r, e) {
            return T(r, m[e], e);
          }, l);
        }

        function he(m) {
          for (var T = arguments.length, l = new Array(T > 1 ? T - 1 : 0), r = 1; r < T; r++) l[r - 1] = arguments[r];

          return Object.assign ? u.default.apply(void 0, [m].concat(l)) : (l.forEach(function (e) {
            !e || se(e, function (t, S) {
              m[S] = t;
            });
          }), m);
        }

        function ye(m) {
          return !!m && typeof m == "object";
        }

        function pe(m) {
          return ye(m) && Z.call(m) === "[object Object]" && m.constructor === Object;
        }

        function _e(m, T) {
          if (!m || !T) return "";

          if (typeof f.default.getComputedStyle == "function") {
            var l;

            try {
              l = f.default.getComputedStyle(m);
            } catch (r) {
              return "";
            }

            return l ? l.getPropertyValue(T) || l[T] : "";
          }

          return "";
        }

        var be = f.default.navigator && f.default.navigator.userAgent || "",
            Le = /AppleWebKit\/([\d.]+)/i.exec(be),
            we = Le ? parseFloat(Le.pop()) : null,
            xe = /iPod/i.test(be),
            Ne = function () {
          var m = be.match(/OS (\d+)_/i);
          return m && m[1] ? m[1] : null;
        }(),
            Me = /Android/i.test(be),
            le = function () {
          var m = be.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
          if (!m) return null;
          var T = m[1] && parseFloat(m[1]),
              l = m[2] && parseFloat(m[2]);
          return T && l ? parseFloat(m[1] + "." + m[2]) : T || null;
        }(),
            ee = Me && le < 5 && we < 537,
            oe = /Firefox/i.test(be),
            ue = /Edg/i.test(be),
            re = !ue && (/Chrome/i.test(be) || /CriOS/i.test(be)),
            ne = function () {
          var m = be.match(/(Chrome|CriOS)\/(\d+)/);
          return m && m[2] ? parseFloat(m[2]) : null;
        }(),
            ce = function () {
          var m = /MSIE\s(\d+)\.\d/.exec(be),
              T = m && parseFloat(m[1]);
          return !T && /Trident\/7.0/i.test(be) && /rv:11.0/.test(be) && (T = 11), T;
        }(),
            me = /Safari/i.test(be) && !re && !Me && !ue,
            Ae = /Windows/i.test(be),
            Ce = Boolean(ze() && ("ontouchstart" in f.default || f.default.navigator.maxTouchPoints || f.default.DocumentTouch && f.default.document instanceof f.default.DocumentTouch)),
            Ie = /iPad/i.test(be) || me && Ce && !/iPhone/i.test(be),
            ke = /iPhone/i.test(be) && !Ie,
            De = ke || Ie || xe,
            Re = (me || De) && !re,
            Ue = Object.freeze({
          __proto__: null,
          IS_IPOD: xe,
          IOS_VERSION: Ne,
          IS_ANDROID: Me,
          ANDROID_VERSION: le,
          IS_NATIVE_ANDROID: ee,
          IS_FIREFOX: oe,
          IS_EDGE: ue,
          IS_CHROME: re,
          CHROME_VERSION: ne,
          IE_VERSION: ce,
          IS_SAFARI: me,
          IS_WINDOWS: Ae,
          TOUCH_ENABLED: Ce,
          IS_IPAD: Ie,
          IS_IPHONE: ke,
          IS_IOS: De,
          IS_ANY_SAFARI: Re
        });

        function Je(m) {
          return typeof m == "string" && Boolean(m.trim());
        }

        function it(m) {
          if (m.indexOf(" ") >= 0) throw new Error("class has illegal whitespace characters");
        }

        function Et(m) {
          return new RegExp("(^|\\s)" + m + "($|\\s)");
        }

        function ze() {
          return y.default === f.default.document;
        }

        function We(m) {
          return ye(m) && m.nodeType === 1;
        }

        function st() {
          try {
            return f.default.parent !== f.default.self;
          } catch (m) {
            return !0;
          }
        }

        function vt(m) {
          return function (T, l) {
            if (!Je(T)) return y.default[m](null);
            Je(l) && (l = y.default.querySelector(l));
            var r = We(l) ? l : y.default;
            return r[m] && r[m](T);
          };
        }

        function Pe(m, T, l, r) {
          m === void 0 && (m = "div"), T === void 0 && (T = {}), l === void 0 && (l = {});
          var e = y.default.createElement(m);
          return Object.getOwnPropertyNames(T).forEach(function (t) {
            var S = T[t];
            t.indexOf("aria-") !== -1 || t === "role" || t === "type" ? ($.warn("Setting attributes in the second argument of createEl()\nhas been deprecated. Use the third argument instead.\n" + ("createEl(type, properties, attributes). Attempting to set " + t + " to " + S + ".")), e.setAttribute(t, S)) : t === "textContent" ? ut(e, S) : (e[t] !== S || t === "tabIndex") && (e[t] = S);
          }), Object.getOwnPropertyNames(l).forEach(function (t) {
            e.setAttribute(t, l[t]);
          }), r && _r(e, r), e;
        }

        function ut(m, T) {
          return typeof m.textContent == "undefined" ? m.innerText = T : m.textContent = T, m;
        }

        function Tt(m, T) {
          T.firstChild ? T.insertBefore(m, T.firstChild) : T.appendChild(m);
        }

        function ct(m, T) {
          return it(T), m.classList ? m.classList.contains(T) : Et(T).test(m.className);
        }

        function et(m, T) {
          return m.classList ? m.classList.add(T) : ct(m, T) || (m.className = (m.className + " " + T).trim()), m;
        }

        function _t(m, T) {
          return m ? (m.classList ? m.classList.remove(T) : (it(T), m.className = m.className.split(/\s+/).filter(function (l) {
            return l !== T;
          }).join(" ")), m) : ($.warn("removeClass was called with an element that doesn't exist"), null);
        }

        function Qt(m, T, l) {
          var r = ct(m, T);
          if (typeof l == "function" && (l = l(m, T)), typeof l != "boolean" && (l = !r), l !== r) return l ? et(m, T) : _t(m, T), m;
        }

        function Jt(m, T) {
          Object.getOwnPropertyNames(T).forEach(function (l) {
            var r = T[l];
            r === null || typeof r == "undefined" || r === !1 ? m.removeAttribute(l) : m.setAttribute(l, r === !0 ? "" : r);
          });
        }

        function Ze(m) {
          var T = {},
              l = ",autoplay,controls,playsinline,loop,muted,default,defaultMuted,";
          if (m && m.attributes && m.attributes.length > 0) for (var r = m.attributes, e = r.length - 1; e >= 0; e--) {
            var t = r[e].name,
                S = r[e].value;
            (typeof m[t] == "boolean" || l.indexOf("," + t + ",") !== -1) && (S = S !== null), T[t] = S;
          }
          return T;
        }

        function jt(m, T) {
          return m.getAttribute(T);
        }

        function pt(m, T, l) {
          m.setAttribute(T, l);
        }

        function Dt(m, T) {
          m.removeAttribute(T);
        }

        function gi() {
          y.default.body.focus(), y.default.onselectstart = function () {
            return !1;
          };
        }

        function mi() {
          y.default.onselectstart = function () {
            return !0;
          };
        }

        function Pt(m) {
          if (m && m.getBoundingClientRect && m.parentNode) {
            var T = m.getBoundingClientRect(),
                l = {};
            return ["bottom", "height", "left", "right", "top", "width"].forEach(function (r) {
              T[r] !== void 0 && (l[r] = T[r]);
            }), l.height || (l.height = parseFloat(_e(m, "height"))), l.width || (l.width = parseFloat(_e(m, "width"))), l;
          }
        }

        function Kt(m) {
          if (!m || m && !m.offsetParent) return {
            left: 0,
            top: 0,
            width: 0,
            height: 0
          };

          for (var T = m.offsetWidth, l = m.offsetHeight, r = 0, e = 0; m.offsetParent && m !== y.default[I.fullscreenElement];) r += m.offsetLeft, e += m.offsetTop, m = m.offsetParent;

          return {
            left: r,
            top: e,
            width: T,
            height: l
          };
        }

        function Zt(m, T) {
          var l = {
            x: 0,
            y: 0
          };
          if (De) for (var r = m; r && r.nodeName.toLowerCase() !== "html";) {
            var e = _e(r, "transform");

            if (/^matrix/.test(e)) {
              var t = e.slice(7, -1).split(/,\s/).map(Number);
              l.x += t[4], l.y += t[5];
            } else if (/^matrix3d/.test(e)) {
              var S = e.slice(9, -1).split(/,\s/).map(Number);
              l.x += S[12], l.y += S[13];
            }

            r = r.parentNode;
          }
          var N = {},
              z = Kt(T.target),
              X = Kt(m),
              J = X.width,
              ie = X.height,
              Q = T.offsetY - (X.top - z.top),
              de = T.offsetX - (X.left - z.left);
          return T.changedTouches && (de = T.changedTouches[0].pageX - X.left, Q = T.changedTouches[0].pageY + X.top, De && (de -= l.x, Q -= l.y)), N.y = 1 - Math.max(0, Math.min(1, Q / ie)), N.x = Math.max(0, Math.min(1, de / J)), N;
        }

        function yi(m) {
          return ye(m) && m.nodeType === 3;
        }

        function Tr(m) {
          for (; m.firstChild;) m.removeChild(m.firstChild);

          return m;
        }

        function Ei(m) {
          return typeof m == "function" && (m = m()), (Array.isArray(m) ? m : [m]).map(function (T) {
            if (typeof T == "function" && (T = T()), We(T) || yi(T)) return T;
            if (typeof T == "string" && /\S/.test(T)) return y.default.createTextNode(T);
          }).filter(function (T) {
            return T;
          });
        }

        function _r(m, T) {
          return Ei(T).forEach(function (l) {
            return m.appendChild(l);
          }), m;
        }

        function Ti(m, T) {
          return _r(Tr(m), T);
        }

        function Ht(m) {
          return m.button === void 0 && m.buttons === void 0 || m.button === 0 && m.buttons === void 0 || m.type === "mouseup" && m.button === 0 && m.buttons === 0 ? !0 : !(m.button !== 0 || m.buttons !== 1);
        }

        var gt = vt("querySelector"),
            _i = vt("querySelectorAll"),
            Si = Object.freeze({
          __proto__: null,
          isReal: ze,
          isEl: We,
          isInFrame: st,
          createEl: Pe,
          textContent: ut,
          prependTo: Tt,
          hasClass: ct,
          addClass: et,
          removeClass: _t,
          toggleClass: Qt,
          setAttributes: Jt,
          getAttributes: Ze,
          getAttribute: jt,
          setAttribute: pt,
          removeAttribute: Dt,
          blockTextSelection: gi,
          unblockTextSelection: mi,
          getBoundingClientRect: Pt,
          findPosition: Kt,
          getPointerPosition: Zt,
          isTextNode: yi,
          emptyEl: Tr,
          normalizeContent: Ei,
          appendContent: _r,
          insertContent: Ti,
          isSingleLeftClick: Ht,
          $: gt,
          $$: _i
        }),
            bi = !1,
            Sr,
            wn = function () {
          if (Sr.options.autoSetup !== !1) {
            var T = Array.prototype.slice.call(y.default.getElementsByTagName("video")),
                l = Array.prototype.slice.call(y.default.getElementsByTagName("audio")),
                r = Array.prototype.slice.call(y.default.getElementsByTagName("video-js")),
                e = T.concat(l, r);
            if (e && e.length > 0) for (var t = 0, S = e.length; t < S; t++) {
              var N = e[t];

              if (N && N.getAttribute) {
                if (N.player === void 0) {
                  var z = N.getAttribute("data-setup");
                  z !== null && Sr(N);
                }
              } else {
                br(1);
                break;
              }
            } else bi || br(1);
          }
        };

        function br(m, T) {
          !ze() || (T && (Sr = T), f.default.setTimeout(wn, m));
        }

        function Cr() {
          bi = !0, f.default.removeEventListener("load", Cr);
        }

        ze() && (y.default.readyState === "complete" ? Cr() : f.default.addEventListener("load", Cr));

        var Ci = function (T) {
          var l = y.default.createElement("style");
          return l.className = T, l;
        },
            Li = function (T, l) {
          T.styleSheet ? T.styleSheet.cssText = l : T.textContent = l;
        },
            Fn = 3,
            Bn = Fn;

        function mt() {
          return Bn++;
        }

        var Ai;
        f.default.WeakMap || (Ai = function () {
          function m() {
            this.vdata = "vdata" + Math.floor(f.default.performance && f.default.performance.now() || Date.now()), this.data = {};
          }

          var T = m.prototype;
          return T.set = function (r, e) {
            var t = r[this.vdata] || mt();
            return r[this.vdata] || (r[this.vdata] = t), this.data[t] = e, this;
          }, T.get = function (r) {
            var e = r[this.vdata];
            if (e) return this.data[e];
            $("We have no data for this element", r);
          }, T.has = function (r) {
            var e = r[this.vdata];
            return e in this.data;
          }, T.delete = function (r) {
            var e = r[this.vdata];
            e && (delete this.data[e], delete r[this.vdata]);
          }, m;
        }());
        var Xe = f.default.WeakMap ? new WeakMap() : new Ai();

        function Di(m, T) {
          if (!!Xe.has(m)) {
            var l = Xe.get(m);
            l.handlers[T].length === 0 && (delete l.handlers[T], m.removeEventListener ? m.removeEventListener(T, l.dispatcher, !1) : m.detachEvent && m.detachEvent("on" + T, l.dispatcher)), Object.getOwnPropertyNames(l.handlers).length <= 0 && (delete l.handlers, delete l.dispatcher, delete l.disabled), Object.getOwnPropertyNames(l).length === 0 && Xe.delete(m);
          }
        }

        function Lr(m, T, l, r) {
          l.forEach(function (e) {
            m(T, e, r);
          });
        }

        function qt(m) {
          if (m.fixed_) return m;

          function T() {
            return !0;
          }

          function l() {
            return !1;
          }

          if (!m || !m.isPropagationStopped || !m.isImmediatePropagationStopped) {
            var r = m || f.default.event;
            m = {};

            for (var e in r) e !== "layerX" && e !== "layerY" && e !== "keyLocation" && e !== "webkitMovementX" && e !== "webkitMovementY" && (e === "returnValue" && r.preventDefault || (m[e] = r[e]));

            if (m.target || (m.target = m.srcElement || y.default), m.relatedTarget || (m.relatedTarget = m.fromElement === m.target ? m.toElement : m.fromElement), m.preventDefault = function () {
              r.preventDefault && r.preventDefault(), m.returnValue = !1, r.returnValue = !1, m.defaultPrevented = !0;
            }, m.defaultPrevented = !1, m.stopPropagation = function () {
              r.stopPropagation && r.stopPropagation(), m.cancelBubble = !0, r.cancelBubble = !0, m.isPropagationStopped = T;
            }, m.isPropagationStopped = l, m.stopImmediatePropagation = function () {
              r.stopImmediatePropagation && r.stopImmediatePropagation(), m.isImmediatePropagationStopped = T, m.stopPropagation();
            }, m.isImmediatePropagationStopped = l, m.clientX !== null && m.clientX !== void 0) {
              var t = y.default.documentElement,
                  S = y.default.body;
              m.pageX = m.clientX + (t && t.scrollLeft || S && S.scrollLeft || 0) - (t && t.clientLeft || S && S.clientLeft || 0), m.pageY = m.clientY + (t && t.scrollTop || S && S.scrollTop || 0) - (t && t.clientTop || S && S.clientTop || 0);
            }

            m.which = m.charCode || m.keyCode, m.button !== null && m.button !== void 0 && (m.button = m.button & 1 ? 0 : m.button & 4 ? 1 : m.button & 2 ? 2 : 0);
          }

          return m.fixed_ = !0, m;
        }

        var er,
            Nn = function () {
          if (typeof er != "boolean") {
            er = !1;

            try {
              var T = Object.defineProperty({}, "passive", {
                get: function () {
                  er = !0;
                }
              });
              f.default.addEventListener("test", null, T), f.default.removeEventListener("test", null, T);
            } catch (l) {}
          }

          return er;
        },
            Un = ["touchstart", "touchmove"];

        function qe(m, T, l) {
          if (Array.isArray(T)) return Lr(qe, m, T, l);
          Xe.has(m) || Xe.set(m, {});
          var r = Xe.get(m);
          if (r.handlers || (r.handlers = {}), r.handlers[T] || (r.handlers[T] = []), l.guid || (l.guid = mt()), r.handlers[T].push(l), r.dispatcher || (r.disabled = !1, r.dispatcher = function (t, S) {
            if (!r.disabled) {
              t = qt(t);
              var N = r.handlers[t.type];
              if (N) for (var z = N.slice(0), X = 0, J = z.length; X < J && !t.isImmediatePropagationStopped(); X++) try {
                z[X].call(m, t, S);
              } catch (ie) {
                $.error(ie);
              }
            }
          }), r.handlers[T].length === 1) if (m.addEventListener) {
            var e = !1;
            Nn() && Un.indexOf(T) > -1 && (e = {
              passive: !0
            }), m.addEventListener(T, r.dispatcher, e);
          } else m.attachEvent && m.attachEvent("on" + T, r.dispatcher);
        }

        function Ve(m, T, l) {
          if (!!Xe.has(m)) {
            var r = Xe.get(m);

            if (!!r.handlers) {
              if (Array.isArray(T)) return Lr(Ve, m, T, l);

              var e = function (X, J) {
                r.handlers[J] = [], Di(X, J);
              };

              if (T === void 0) {
                for (var t in r.handlers) Object.prototype.hasOwnProperty.call(r.handlers || {}, t) && e(m, t);

                return;
              }

              var S = r.handlers[T];

              if (!!S) {
                if (!l) {
                  e(m, T);
                  return;
                }

                if (l.guid) for (var N = 0; N < S.length; N++) S[N].guid === l.guid && S.splice(N--, 1);
                Di(m, T);
              }
            }
          }
        }

        function Ot(m, T, l) {
          var r = Xe.has(m) ? Xe.get(m) : {},
              e = m.parentNode || m.ownerDocument;
          if (typeof T == "string" ? T = {
            type: T,
            target: m
          } : T.target || (T.target = m), T = qt(T), r.dispatcher && r.dispatcher.call(m, T, l), e && !T.isPropagationStopped() && T.bubbles === !0) Ot.call(null, e, T, l);else if (!e && !T.defaultPrevented && T.target && T.target[T.type]) {
            Xe.has(T.target) || Xe.set(T.target, {});
            var t = Xe.get(T.target);
            T.target[T.type] && (t.disabled = !0, typeof T.target[T.type] == "function" && T.target[T.type](), t.disabled = !1);
          }
          return !T.defaultPrevented;
        }

        function tr(m, T, l) {
          if (Array.isArray(T)) return Lr(tr, m, T, l);

          var r = function e() {
            Ve(m, T, e), l.apply(this, arguments);
          };

          r.guid = l.guid = l.guid || mt(), qe(m, T, r);
        }

        function Pi(m, T, l) {
          var r = function e() {
            Ve(m, T, e), l.apply(this, arguments);
          };

          r.guid = l.guid = l.guid || mt(), qe(m, T, r);
        }

        var jn = Object.freeze({
          __proto__: null,
          fixEvent: qt,
          on: qe,
          off: Ve,
          trigger: Ot,
          one: tr,
          any: Pi
        }),
            nt = 30,
            Fe = function (T, l, r) {
          l.guid || (l.guid = mt());
          var e = l.bind(T);
          return e.guid = r ? r + "_" + l.guid : l.guid, e;
        },
            dt = function (T, l) {
          var r = f.default.performance.now(),
              e = function () {
            var S = f.default.performance.now();
            S - r >= l && (T.apply(void 0, arguments), r = S);
          };

          return e;
        },
            Kn = function (T, l, r, e) {
          e === void 0 && (e = f.default);

          var t,
              S = function () {
            e.clearTimeout(t), t = null;
          },
              N = function () {
            var X = this,
                J = arguments,
                ie = function () {
              t = null, ie = null, r || T.apply(X, J);
            };

            !t && r && T.apply(X, J), e.clearTimeout(t), t = e.setTimeout(ie, l);
          };

          return N.cancel = S, N;
        },
            Ge = function () {};

        Ge.prototype.allowedEvents_ = {}, Ge.prototype.on = function (m, T) {
          var l = this.addEventListener;
          this.addEventListener = function () {}, qe(this, m, T), this.addEventListener = l;
        }, Ge.prototype.addEventListener = Ge.prototype.on, Ge.prototype.off = function (m, T) {
          Ve(this, m, T);
        }, Ge.prototype.removeEventListener = Ge.prototype.off, Ge.prototype.one = function (m, T) {
          var l = this.addEventListener;
          this.addEventListener = function () {}, tr(this, m, T), this.addEventListener = l;
        }, Ge.prototype.any = function (m, T) {
          var l = this.addEventListener;
          this.addEventListener = function () {}, Pi(this, m, T), this.addEventListener = l;
        }, Ge.prototype.trigger = function (m) {
          var T = m.type || m;
          typeof m == "string" && (m = {
            type: T
          }), m = qt(m), this.allowedEvents_[T] && this["on" + T] && this["on" + T](m), Ot(this, m);
        }, Ge.prototype.dispatchEvent = Ge.prototype.trigger;
        var Wt;

        Ge.prototype.queueTrigger = function (m) {
          var T = this;
          Wt || (Wt = new Map());
          var l = m.type || m,
              r = Wt.get(this);
          r || (r = new Map(), Wt.set(this, r));
          var e = r.get(l);
          r.delete(l), f.default.clearTimeout(e);
          var t = f.default.setTimeout(function () {
            r.size === 0 && (r = null, Wt.delete(T)), T.trigger(m);
          }, 0);
          r.set(l, t);
        };

        var rr = function (T) {
          return typeof T.name == "function" ? T.name() : typeof T.name == "string" ? T.name : T.name_ ? T.name_ : T.constructor && T.constructor.name ? T.constructor.name : typeof T;
        },
            ft = function (T) {
          return T instanceof Ge || !!T.eventBusEl_ && ["on", "one", "off", "trigger"].every(function (l) {
            return typeof T[l] == "function";
          });
        },
            Hn = function (T, l) {
          ft(T) ? l() : (T.eventedCallbacks || (T.eventedCallbacks = []), T.eventedCallbacks.push(l));
        },
            Ar = function (T) {
          return typeof T == "string" && /\S/.test(T) || Array.isArray(T) && !!T.length;
        },
            ir = function (T, l, r) {
          if (!T || !T.nodeName && !ft(T)) throw new Error("Invalid target for " + rr(l) + "#" + r + "; must be a DOM node or evented object.");
        },
            Oi = function (T, l, r) {
          if (!Ar(T)) throw new Error("Invalid event type for " + rr(l) + "#" + r + "; must be a non-empty string or array.");
        },
            Ii = function (T, l, r) {
          if (typeof T != "function") throw new Error("Invalid listener for " + rr(l) + "#" + r + "; must be a function.");
        },
            Dr = function (T, l, r) {
          var e = l.length < 3 || l[0] === T || l[0] === T.eventBusEl_,
              t,
              S,
              N;
          return e ? (t = T.eventBusEl_, l.length >= 3 && l.shift(), S = l[0], N = l[1]) : (t = l[0], S = l[1], N = l[2]), ir(t, T, r), Oi(S, T, r), Ii(N, T, r), N = Fe(T, N), {
            isTargetingSelf: e,
            target: t,
            type: S,
            listener: N
          };
        },
            St = function (T, l, r, e) {
          ir(T, T, l), T.nodeName ? jn[l](T, r, e) : T[l](r, e);
        },
            Wn = {
          on: function () {
            for (var T = this, l = arguments.length, r = new Array(l), e = 0; e < l; e++) r[e] = arguments[e];

            var t = Dr(this, r, "on"),
                S = t.isTargetingSelf,
                N = t.target,
                z = t.type,
                X = t.listener;

            if (St(N, "on", z, X), !S) {
              var J = function () {
                return T.off(N, z, X);
              };

              J.guid = X.guid;

              var ie = function () {
                return T.off("dispose", J);
              };

              ie.guid = X.guid, St(this, "on", "dispose", J), St(N, "on", "dispose", ie);
            }
          },
          one: function () {
            for (var T = this, l = arguments.length, r = new Array(l), e = 0; e < l; e++) r[e] = arguments[e];

            var t = Dr(this, r, "one"),
                S = t.isTargetingSelf,
                N = t.target,
                z = t.type,
                X = t.listener;
            if (S) St(N, "one", z, X);else {
              var J = function ie() {
                T.off(N, z, ie);

                for (var Q = arguments.length, de = new Array(Q), Te = 0; Te < Q; Te++) de[Te] = arguments[Te];

                X.apply(null, de);
              };

              J.guid = X.guid, St(N, "one", z, J);
            }
          },
          any: function () {
            for (var T = this, l = arguments.length, r = new Array(l), e = 0; e < l; e++) r[e] = arguments[e];

            var t = Dr(this, r, "any"),
                S = t.isTargetingSelf,
                N = t.target,
                z = t.type,
                X = t.listener;
            if (S) St(N, "any", z, X);else {
              var J = function ie() {
                T.off(N, z, ie);

                for (var Q = arguments.length, de = new Array(Q), Te = 0; Te < Q; Te++) de[Te] = arguments[Te];

                X.apply(null, de);
              };

              J.guid = X.guid, St(N, "any", z, J);
            }
          },
          off: function (T, l, r) {
            if (!T || Ar(T)) Ve(this.eventBusEl_, T, l);else {
              var e = T,
                  t = l;
              ir(e, this, "off"), Oi(t, this, "off"), Ii(r, this, "off"), r = Fe(this, r), this.off("dispose", r), e.nodeName ? (Ve(e, t, r), Ve(e, "dispose", r)) : ft(e) && (e.off(t, r), e.off("dispose", r));
            }
          },
          trigger: function (T, l) {
            ir(this.eventBusEl_, this, "trigger");
            var r = T && typeof T != "string" ? T.type : T;

            if (!Ar(r)) {
              var e = "Invalid event type for " + rr(this) + "#trigger; must be a non-empty string or object with a type key that has a non-empty value.";
              if (T) (this.log || $).error(e);else throw new Error(e);
            }

            return Ot(this.eventBusEl_, T, l);
          }
        };

        function Pr(m, T) {
          T === void 0 && (T = {});
          var l = T,
              r = l.eventBusKey;

          if (r) {
            if (!m[r].nodeName) throw new Error('The eventBusKey "' + r + '" does not refer to an element.');
            m.eventBusEl_ = m[r];
          } else m.eventBusEl_ = Pe("span", {
            className: "vjs-event-bus"
          });

          return he(m, Wn), m.eventedCallbacks && m.eventedCallbacks.forEach(function (e) {
            e();
          }), m.on("dispose", function () {
            m.off(), [m, m.el_, m.eventBusEl_].forEach(function (e) {
              e && Xe.has(e) && Xe.delete(e);
            }), f.default.setTimeout(function () {
              m.eventBusEl_ = null;
            }, 0);
          }), m;
        }

        var Gn = {
          state: {},
          setState: function (T) {
            var l = this;
            typeof T == "function" && (T = T());
            var r;
            return se(T, function (e, t) {
              l.state[t] !== e && (r = r || {}, r[t] = {
                from: l.state[t],
                to: e
              }), l.state[t] = e;
            }), r && ft(this) && this.trigger({
              changes: r,
              type: "statechanged"
            }), r;
          }
        };

        function Ri(m, T) {
          return he(m, Gn), m.state = he({}, m.state, T), typeof m.handleStateChanged == "function" && ft(m) && m.on("statechanged", m.handleStateChanged), m;
        }

        var nr = function (T) {
          return typeof T != "string" ? T : T.replace(/./, function (l) {
            return l.toLowerCase();
          });
        },
            Ke = function (T) {
          return typeof T != "string" ? T : T.replace(/./, function (l) {
            return l.toUpperCase();
          });
        },
            Vn = function (T, l) {
          return Ke(T) === Ke(l);
        };

        function je() {
          for (var m = {}, T = arguments.length, l = new Array(T), r = 0; r < T; r++) l[r] = arguments[r];

          return l.forEach(function (e) {
            !e || se(e, function (t, S) {
              if (!pe(t)) {
                m[S] = t;
                return;
              }

              pe(m[S]) || (m[S] = {}), m[S] = je(m[S], t);
            });
          }), m;
        }

        var zn = function () {
          function m() {
            this.map_ = {};
          }

          var T = m.prototype;
          return T.has = function (r) {
            return r in this.map_;
          }, T.delete = function (r) {
            var e = this.has(r);
            return delete this.map_[r], e;
          }, T.set = function (r, e) {
            return this.map_[r] = e, this;
          }, T.forEach = function (r, e) {
            for (var t in this.map_) r.call(e, this.map_[t], t, this);
          }, m;
        }(),
            Xn = f.default.Map ? f.default.Map : zn,
            Yn = function () {
          function m() {
            this.set_ = {};
          }

          var T = m.prototype;
          return T.has = function (r) {
            return r in this.set_;
          }, T.delete = function (r) {
            var e = this.has(r);
            return delete this.set_[r], e;
          }, T.add = function (r) {
            return this.set_[r] = 1, this;
          }, T.forEach = function (r, e) {
            for (var t in this.set_) r.call(e, t, t, this);
          }, m;
        }(),
            Or = f.default.Set ? f.default.Set : Yn,
            fe = function () {
          function m(l, r, e) {
            if (!l && this.play ? this.player_ = l = this : this.player_ = l, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = je({}, this.options_), r = this.options_ = je(this.options_, r), this.id_ = r.id || r.el && r.el.id, !this.id_) {
              var t = l && l.id && l.id() || "no_player";
              this.id_ = t + "_component_" + mt();
            }

            this.name_ = r.name || null, r.el ? this.el_ = r.el : r.createEl !== !1 && (this.el_ = this.createEl()), r.evented !== !1 && (Pr(this, {
              eventBusKey: this.el_ ? "el_" : null
            }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), Ri(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = new Or(), this.setIntervalIds_ = new Or(), this.rafIds_ = new Or(), this.namedRafs_ = new Xn(), this.clearingTimersOnDispose_ = !1, r.initChildren !== !1 && this.initChildren(), this.ready(e), r.reportTouchActivity !== !1 && this.enableTouchActivity();
          }

          var T = m.prototype;
          return T.dispose = function () {
            if (!this.isDisposed_) {
              if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
                type: "dispose",
                bubbles: !1
              }), this.isDisposed_ = !0, this.children_) for (var r = this.children_.length - 1; r >= 0; r--) this.children_[r].dispose && this.children_[r].dispose();
              this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && this.el_.parentNode.removeChild(this.el_), this.el_ = null), this.player_ = null;
            }
          }, T.isDisposed = function () {
            return Boolean(this.isDisposed_);
          }, T.player = function () {
            return this.player_;
          }, T.options = function (r) {
            return r ? (this.options_ = je(this.options_, r), this.options_) : this.options_;
          }, T.el = function () {
            return this.el_;
          }, T.createEl = function (r, e, t) {
            return Pe(r, e, t);
          }, T.localize = function (r, e, t) {
            t === void 0 && (t = r);
            var S = this.player_.language && this.player_.language(),
                N = this.player_.languages && this.player_.languages(),
                z = N && N[S],
                X = S && S.split("-")[0],
                J = N && N[X],
                ie = t;
            return z && z[r] ? ie = z[r] : J && J[r] && (ie = J[r]), e && (ie = ie.replace(/\{(\d+)\}/g, function (Q, de) {
              var Te = e[de - 1],
                  Oe = Te;
              return typeof Te == "undefined" && (Oe = Q), Oe;
            })), ie;
          }, T.handleLanguagechange = function () {}, T.contentEl = function () {
            return this.contentEl_ || this.el_;
          }, T.id = function () {
            return this.id_;
          }, T.name = function () {
            return this.name_;
          }, T.children = function () {
            return this.children_;
          }, T.getChildById = function (r) {
            return this.childIndex_[r];
          }, T.getChild = function (r) {
            if (!!r) return this.childNameIndex_[r];
          }, T.getDescendant = function () {
            for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++) e[t] = arguments[t];

            e = e.reduce(function (z, X) {
              return z.concat(X);
            }, []);

            for (var S = this, N = 0; N < e.length; N++) if (S = S.getChild(e[N]), !S || !S.getChild) return;

            return S;
          }, T.addChild = function (r, e, t) {
            e === void 0 && (e = {}), t === void 0 && (t = this.children_.length);
            var S, N;

            if (typeof r == "string") {
              N = Ke(r);
              var z = e.componentClass || N;
              e.name = N;
              var X = m.getComponent(z);
              if (!X) throw new Error("Component " + z + " does not exist");
              if (typeof X != "function") return null;
              S = new X(this.player_ || this, e);
            } else S = r;

            if (S.parentComponent_ && S.parentComponent_.removeChild(S), this.children_.splice(t, 0, S), S.parentComponent_ = this, typeof S.id == "function" && (this.childIndex_[S.id()] = S), N = N || S.name && Ke(S.name()), N && (this.childNameIndex_[N] = S, this.childNameIndex_[nr(N)] = S), typeof S.el == "function" && S.el()) {
              var J = null;
              this.children_[t + 1] && (this.children_[t + 1].el_ ? J = this.children_[t + 1].el_ : We(this.children_[t + 1]) && (J = this.children_[t + 1])), this.contentEl().insertBefore(S.el(), J);
            }

            return S;
          }, T.removeChild = function (r) {
            if (typeof r == "string" && (r = this.getChild(r)), !(!r || !this.children_)) {
              for (var e = !1, t = this.children_.length - 1; t >= 0; t--) if (this.children_[t] === r) {
                e = !0, this.children_.splice(t, 1);
                break;
              }

              if (!!e) {
                r.parentComponent_ = null, this.childIndex_[r.id()] = null, this.childNameIndex_[Ke(r.name())] = null, this.childNameIndex_[nr(r.name())] = null;
                var S = r.el();
                S && S.parentNode === this.contentEl() && this.contentEl().removeChild(r.el());
              }
            }
          }, T.initChildren = function () {
            var r = this,
                e = this.options_.children;

            if (e) {
              var t = this.options_,
                  S = function (J) {
                var ie = J.name,
                    Q = J.opts;

                if (t[ie] !== void 0 && (Q = t[ie]), Q !== !1) {
                  Q === !0 && (Q = {}), Q.playerOptions = r.options_.playerOptions;
                  var de = r.addChild(ie, Q);
                  de && (r[ie] = de);
                }
              },
                  N,
                  z = m.getComponent("Tech");

              Array.isArray(e) ? N = e : N = Object.keys(e), N.concat(Object.keys(this.options_).filter(function (X) {
                return !N.some(function (J) {
                  return typeof J == "string" ? X === J : X === J.name;
                });
              })).map(function (X) {
                var J, ie;
                return typeof X == "string" ? (J = X, ie = e[J] || r.options_[J] || {}) : (J = X.name, ie = X), {
                  name: J,
                  opts: ie
                };
              }).filter(function (X) {
                var J = m.getComponent(X.opts.componentClass || Ke(X.name));
                return J && !z.isTech(J);
              }).forEach(S);
            }
          }, T.buildCSSClass = function () {
            return "";
          }, T.ready = function (r, e) {
            if (e === void 0 && (e = !1), !!r) {
              if (!this.isReady_) {
                this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(r);
                return;
              }

              e ? r.call(this) : this.setTimeout(r, 1);
            }
          }, T.triggerReady = function () {
            this.isReady_ = !0, this.setTimeout(function () {
              var r = this.readyQueue_;
              this.readyQueue_ = [], r && r.length > 0 && r.forEach(function (e) {
                e.call(this);
              }, this), this.trigger("ready");
            }, 1);
          }, T.$ = function (r, e) {
            return gt(r, e || this.contentEl());
          }, T.$$ = function (r, e) {
            return _i(r, e || this.contentEl());
          }, T.hasClass = function (r) {
            return ct(this.el_, r);
          }, T.addClass = function (r) {
            et(this.el_, r);
          }, T.removeClass = function (r) {
            _t(this.el_, r);
          }, T.toggleClass = function (r, e) {
            Qt(this.el_, r, e);
          }, T.show = function () {
            this.removeClass("vjs-hidden");
          }, T.hide = function () {
            this.addClass("vjs-hidden");
          }, T.lockShowing = function () {
            this.addClass("vjs-lock-showing");
          }, T.unlockShowing = function () {
            this.removeClass("vjs-lock-showing");
          }, T.getAttribute = function (r) {
            return jt(this.el_, r);
          }, T.setAttribute = function (r, e) {
            pt(this.el_, r, e);
          }, T.removeAttribute = function (r) {
            Dt(this.el_, r);
          }, T.width = function (r, e) {
            return this.dimension("width", r, e);
          }, T.height = function (r, e) {
            return this.dimension("height", r, e);
          }, T.dimensions = function (r, e) {
            this.width(r, !0), this.height(e);
          }, T.dimension = function (r, e, t) {
            if (e !== void 0) {
              (e === null || e !== e) && (e = 0), ("" + e).indexOf("%") !== -1 || ("" + e).indexOf("px") !== -1 ? this.el_.style[r] = e : e === "auto" ? this.el_.style[r] = "" : this.el_.style[r] = e + "px", t || this.trigger("componentresize");
              return;
            }

            if (!this.el_) return 0;
            var S = this.el_.style[r],
                N = S.indexOf("px");
            return parseInt(N !== -1 ? S.slice(0, N) : this.el_["offset" + Ke(r)], 10);
          }, T.currentDimension = function (r) {
            var e = 0;
            if (r !== "width" && r !== "height") throw new Error("currentDimension only accepts width or height value");

            if (e = _e(this.el_, r), e = parseFloat(e), e === 0 || isNaN(e)) {
              var t = "offset" + Ke(r);
              e = this.el_[t];
            }

            return e;
          }, T.currentDimensions = function () {
            return {
              width: this.currentDimension("width"),
              height: this.currentDimension("height")
            };
          }, T.currentWidth = function () {
            return this.currentDimension("width");
          }, T.currentHeight = function () {
            return this.currentDimension("height");
          }, T.focus = function () {
            this.el_.focus();
          }, T.blur = function () {
            this.el_.blur();
          }, T.handleKeyDown = function (r) {
            this.player_ && (i.default.isEventKey(r, "Tab") || r.stopPropagation(), this.player_.handleKeyDown(r));
          }, T.handleKeyPress = function (r) {
            this.handleKeyDown(r);
          }, T.emitTapEvents = function () {
            var r = 0,
                e = null,
                t = 10,
                S = 200,
                N;
            this.on("touchstart", function (X) {
              X.touches.length === 1 && (e = {
                pageX: X.touches[0].pageX,
                pageY: X.touches[0].pageY
              }, r = f.default.performance.now(), N = !0);
            }), this.on("touchmove", function (X) {
              if (X.touches.length > 1) N = !1;else if (e) {
                var J = X.touches[0].pageX - e.pageX,
                    ie = X.touches[0].pageY - e.pageY,
                    Q = Math.sqrt(J * J + ie * ie);
                Q > t && (N = !1);
              }
            });

            var z = function () {
              N = !1;
            };

            this.on("touchleave", z), this.on("touchcancel", z), this.on("touchend", function (X) {
              if (e = null, N === !0) {
                var J = f.default.performance.now() - r;
                J < S && (X.preventDefault(), this.trigger("tap"));
              }
            });
          }, T.enableTouchActivity = function () {
            if (!(!this.player() || !this.player().reportUserActivity)) {
              var r = Fe(this.player(), this.player().reportUserActivity),
                  e;
              this.on("touchstart", function () {
                r(), this.clearInterval(e), e = this.setInterval(r, 250);
              });

              var t = function (N) {
                r(), this.clearInterval(e);
              };

              this.on("touchmove", r), this.on("touchend", t), this.on("touchcancel", t);
            }
          }, T.setTimeout = function (r, e) {
            var t = this,
                S;
            return r = Fe(this, r), this.clearTimersOnDispose_(), S = f.default.setTimeout(function () {
              t.setTimeoutIds_.has(S) && t.setTimeoutIds_.delete(S), r();
            }, e), this.setTimeoutIds_.add(S), S;
          }, T.clearTimeout = function (r) {
            return this.setTimeoutIds_.has(r) && (this.setTimeoutIds_.delete(r), f.default.clearTimeout(r)), r;
          }, T.setInterval = function (r, e) {
            r = Fe(this, r), this.clearTimersOnDispose_();
            var t = f.default.setInterval(r, e);
            return this.setIntervalIds_.add(t), t;
          }, T.clearInterval = function (r) {
            return this.setIntervalIds_.has(r) && (this.setIntervalIds_.delete(r), f.default.clearInterval(r)), r;
          }, T.requestAnimationFrame = function (r) {
            var e = this;
            if (!this.supportsRaf_) return this.setTimeout(r, 1e3 / 60);
            this.clearTimersOnDispose_();
            var t;
            return r = Fe(this, r), t = f.default.requestAnimationFrame(function () {
              e.rafIds_.has(t) && e.rafIds_.delete(t), r();
            }), this.rafIds_.add(t), t;
          }, T.requestNamedAnimationFrame = function (r, e) {
            var t = this;

            if (!this.namedRafs_.has(r)) {
              this.clearTimersOnDispose_(), e = Fe(this, e);
              var S = this.requestAnimationFrame(function () {
                e(), t.namedRafs_.has(r) && t.namedRafs_.delete(r);
              });
              return this.namedRafs_.set(r, S), r;
            }
          }, T.cancelNamedAnimationFrame = function (r) {
            !this.namedRafs_.has(r) || (this.cancelAnimationFrame(this.namedRafs_.get(r)), this.namedRafs_.delete(r));
          }, T.cancelAnimationFrame = function (r) {
            return this.supportsRaf_ ? (this.rafIds_.has(r) && (this.rafIds_.delete(r), f.default.cancelAnimationFrame(r)), r) : this.clearTimeout(r);
          }, T.clearTimersOnDispose_ = function () {
            var r = this;
            this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", function () {
              [["namedRafs_", "cancelNamedAnimationFrame"], ["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(function (e) {
                var t = e[0],
                    S = e[1];
                r[t].forEach(function (N, z) {
                  return r[S](z);
                });
              }), r.clearingTimersOnDispose_ = !1;
            }));
          }, m.registerComponent = function (r, e) {
            if (typeof r != "string" || !r) throw new Error('Illegal component name, "' + r + '"; must be a non-empty string.');
            var t = m.getComponent("Tech"),
                S = t && t.isTech(e),
                N = m === e || m.prototype.isPrototypeOf(e.prototype);

            if (S || !N) {
              var z;
              throw S ? z = "techs must be registered using Tech.registerTech()" : z = "must be a Component subclass", new Error('Illegal component, "' + r + '"; ' + z + ".");
            }

            r = Ke(r), m.components_ || (m.components_ = {});
            var X = m.getComponent("Player");

            if (r === "Player" && X && X.players) {
              var J = X.players,
                  ie = Object.keys(J);
              if (J && ie.length > 0 && ie.map(function (Q) {
                return J[Q];
              }).every(Boolean)) throw new Error("Can not register Player component after player has been created.");
            }

            return m.components_[r] = e, m.components_[nr(r)] = e, e;
          }, m.getComponent = function (r) {
            if (!(!r || !m.components_)) return m.components_[r];
          }, m;
        }();

        fe.prototype.supportsRaf_ = typeof f.default.requestAnimationFrame == "function" && typeof f.default.cancelAnimationFrame == "function", fe.registerComponent("Component", fe);

        function $n(m, T, l) {
          if (typeof T != "number" || T < 0 || T > l) throw new Error("Failed to execute '" + m + "' on 'TimeRanges': The index provided (" + T + ") is non-numeric or out of bounds (0-" + l + ").");
        }

        function Mi(m, T, l, r) {
          return $n(m, r, l.length - 1), l[r][T];
        }

        function Ir(m) {
          var T;
          return m === void 0 || m.length === 0 ? T = {
            length: 0,
            start: function () {
              throw new Error("This TimeRanges object is empty");
            },
            end: function () {
              throw new Error("This TimeRanges object is empty");
            }
          } : T = {
            length: m.length,
            start: Mi.bind(null, "start", 0, m),
            end: Mi.bind(null, "end", 1, m)
          }, f.default.Symbol && f.default.Symbol.iterator && (T[f.default.Symbol.iterator] = function () {
            return (m || []).values();
          }), T;
        }

        function bt(m, T) {
          return Array.isArray(m) ? Ir(m) : m === void 0 || T === void 0 ? Ir() : Ir([[m, T]]);
        }

        function xi(m, T) {
          var l = 0,
              r,
              e;
          if (!T) return 0;
          (!m || !m.length) && (m = bt(0, 0));

          for (var t = 0; t < m.length; t++) r = m.start(t), e = m.end(t), e > T && (e = T), l += e - r;

          return l / T;
        }

        function Ye(m) {
          if (m instanceof Ye) return m;
          typeof m == "number" ? this.code = m : typeof m == "string" ? this.message = m : ye(m) && (typeof m.code == "number" && (this.code = m.code), he(this, m)), this.message || (this.message = Ye.defaultMessages[this.code] || "");
        }

        Ye.prototype.code = 0, Ye.prototype.message = "", Ye.prototype.status = null, Ye.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"], Ye.defaultMessages = {
          1: "You aborted the media playback",
          2: "A network error caused the media download to fail part-way.",
          3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
          4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
          5: "The media is encrypted and we do not have the keys to decrypt it."
        };

        for (var It = 0; It < Ye.errorTypes.length; It++) Ye[Ye.errorTypes[It]] = It, Ye.prototype[Ye.errorTypes[It]] = It;

        function Gt(m) {
          return m != null && typeof m.then == "function";
        }

        function ot(m) {
          Gt(m) && m.then(null, function (T) {});
        }

        var Rr = function (T) {
          var l = ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce(function (r, e, t) {
            return T[e] && (r[e] = T[e]), r;
          }, {
            cues: T.cues && Array.prototype.map.call(T.cues, function (r) {
              return {
                startTime: r.startTime,
                endTime: r.endTime,
                text: r.text,
                id: r.id
              };
            })
          });
          return l;
        },
            Qn = function (T) {
          var l = T.$$("track"),
              r = Array.prototype.map.call(l, function (t) {
            return t.track;
          }),
              e = Array.prototype.map.call(l, function (t) {
            var S = Rr(t.track);
            return t.src && (S.src = t.src), S;
          });
          return e.concat(Array.prototype.filter.call(T.textTracks(), function (t) {
            return r.indexOf(t) === -1;
          }).map(Rr));
        },
            Jn = function (T, l) {
          return T.forEach(function (r) {
            var e = l.addRemoteTextTrack(r).track;
            !r.src && r.cues && r.cues.forEach(function (t) {
              return e.addCue(t);
            });
          }), l.textTracks();
        },
            ki = {
          textTracksToJson: Qn,
          jsonToTextTracks: Jn,
          trackToJson_: Rr
        },
            Mr = "vjs-modal-dialog",
            Rt = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.handleKeyDown_ = function (S) {
              return t.handleKeyDown(S);
            }, t.close_ = function (S) {
              return t.close(S);
            }, t.opened_ = t.hasBeenOpened_ = t.hasBeenFilled_ = !1, t.closeable(!t.options_.uncloseable), t.content(t.options_.content), t.contentEl_ = Pe("div", {
              className: Mr + "-content"
            }, {
              role: "document"
            }), t.descEl_ = Pe("p", {
              className: Mr + "-description vjs-control-text",
              id: t.el().getAttribute("aria-describedby")
            }), ut(t.descEl_, t.description()), t.el_.appendChild(t.descEl_), t.el_.appendChild(t.contentEl_), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: this.buildCSSClass(),
              tabIndex: -1
            }, {
              "aria-describedby": this.id() + "_description",
              "aria-hidden": "true",
              "aria-label": this.label(),
              role: "dialog"
            });
          }, l.dispose = function () {
            this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, m.prototype.dispose.call(this);
          }, l.buildCSSClass = function () {
            return Mr + " vjs-hidden " + m.prototype.buildCSSClass.call(this);
          }, l.label = function () {
            return this.localize(this.options_.label || "Modal Window");
          }, l.description = function () {
            var e = this.options_.description || this.localize("This is a modal window.");
            return this.closeable() && (e += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), e;
          }, l.open = function () {
            if (!this.opened_) {
              var e = this.player();
              this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !e.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && e.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = e.controls(), e.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
            }
          }, l.opened = function (e) {
            return typeof e == "boolean" && this[e ? "open" : "close"](), this.opened_;
          }, l.close = function () {
            if (!!this.opened_) {
              var e = this.player();
              this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && e.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && e.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger("modalclose"), this.conditionalBlur_(), this.options_.temporary && this.dispose();
            }
          }, l.closeable = function (e) {
            if (typeof e == "boolean") {
              var t = this.closeable_ = !!e,
                  S = this.getChild("closeButton");

              if (t && !S) {
                var N = this.contentEl_;
                this.contentEl_ = this.el_, S = this.addChild("closeButton", {
                  controlText: "Close Modal Dialog"
                }), this.contentEl_ = N, this.on(S, "close", this.close_);
              }

              !t && S && (this.off(S, "close", this.close_), this.removeChild(S), S.dispose());
            }

            return this.closeable_;
          }, l.fill = function () {
            this.fillWith(this.content());
          }, l.fillWith = function (e) {
            var t = this.contentEl(),
                S = t.parentNode,
                N = t.nextSibling;
            this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, S.removeChild(t), this.empty(), Ti(t, e), this.trigger("modalfill"), N ? S.insertBefore(t, N) : S.appendChild(t);
            var z = this.getChild("closeButton");
            z && S.appendChild(z.el_);
          }, l.empty = function () {
            this.trigger("beforemodalempty"), Tr(this.contentEl()), this.trigger("modalempty");
          }, l.content = function (e) {
            return typeof e != "undefined" && (this.content_ = e), this.content_;
          }, l.conditionalFocus_ = function () {
            var e = y.default.activeElement,
                t = this.player_.el_;
            this.previouslyActiveEl_ = null, (t.contains(e) || t === e) && (this.previouslyActiveEl_ = e, this.focus());
          }, l.conditionalBlur_ = function () {
            this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null);
          }, l.handleKeyDown = function (e) {
            if (e.stopPropagation(), i.default.isEventKey(e, "Escape") && this.closeable()) {
              e.preventDefault(), this.close();
              return;
            }

            if (!!i.default.isEventKey(e, "Tab")) {
              for (var t = this.focusableEls_(), S = this.el_.querySelector(":focus"), N, z = 0; z < t.length; z++) if (S === t[z]) {
                N = z;
                break;
              }

              y.default.activeElement === this.el_ && (N = 0), e.shiftKey && N === 0 ? (t[t.length - 1].focus(), e.preventDefault()) : !e.shiftKey && N === t.length - 1 && (t[0].focus(), e.preventDefault());
            }
          }, l.focusableEls_ = function () {
            var e = this.el_.querySelectorAll("*");
            return Array.prototype.filter.call(e, function (t) {
              return (t instanceof f.default.HTMLAnchorElement || t instanceof f.default.HTMLAreaElement) && t.hasAttribute("href") || (t instanceof f.default.HTMLInputElement || t instanceof f.default.HTMLSelectElement || t instanceof f.default.HTMLTextAreaElement || t instanceof f.default.HTMLButtonElement) && !t.hasAttribute("disabled") || t instanceof f.default.HTMLIFrameElement || t instanceof f.default.HTMLObjectElement || t instanceof f.default.HTMLEmbedElement || t.hasAttribute("tabindex") && t.getAttribute("tabindex") !== -1 || t.hasAttribute("contenteditable");
            });
          }, T;
        }(fe);

        Rt.prototype.options_ = {
          pauseOnOpen: !0,
          temporary: !0
        }, fe.registerComponent("ModalDialog", Rt);

        var Mt = function (m) {
          a.default(T, m);

          function T(r) {
            var e;
            r === void 0 && (r = []), e = m.call(this) || this, e.tracks_ = [], Object.defineProperty(n.default(e), "length", {
              get: function () {
                return this.tracks_.length;
              }
            });

            for (var t = 0; t < r.length; t++) e.addTrack(r[t]);

            return e;
          }

          var l = T.prototype;
          return l.addTrack = function (e) {
            var t = this,
                S = this.tracks_.length;
            "" + S in this || Object.defineProperty(this, S, {
              get: function () {
                return this.tracks_[S];
              }
            }), this.tracks_.indexOf(e) === -1 && (this.tracks_.push(e), this.trigger({
              track: e,
              type: "addtrack",
              target: this
            })), e.labelchange_ = function () {
              t.trigger({
                track: e,
                type: "labelchange",
                target: t
              });
            }, ft(e) && e.addEventListener("labelchange", e.labelchange_);
          }, l.removeTrack = function (e) {
            for (var t, S = 0, N = this.length; S < N; S++) if (this[S] === e) {
              t = this[S], t.off && t.off(), this.tracks_.splice(S, 1);
              break;
            }

            !t || this.trigger({
              track: t,
              type: "removetrack",
              target: this
            });
          }, l.getTrackById = function (e) {
            for (var t = null, S = 0, N = this.length; S < N; S++) {
              var z = this[S];

              if (z.id === e) {
                t = z;
                break;
              }
            }

            return t;
          }, T;
        }(Ge);

        Mt.prototype.allowedEvents_ = {
          change: "change",
          addtrack: "addtrack",
          removetrack: "removetrack",
          labelchange: "labelchange"
        };

        for (var Zn in Mt.prototype.allowedEvents_) Mt.prototype["on" + Zn] = null;

        var xr = function (T, l) {
          for (var r = 0; r < T.length; r++) !Object.keys(T[r]).length || l.id === T[r].id || (T[r].enabled = !1);
        },
            qn = function (m) {
          a.default(T, m);

          function T(r) {
            var e;
            r === void 0 && (r = []);

            for (var t = r.length - 1; t >= 0; t--) if (r[t].enabled) {
              xr(r, r[t]);
              break;
            }

            return e = m.call(this, r) || this, e.changing_ = !1, e;
          }

          var l = T.prototype;
          return l.addTrack = function (e) {
            var t = this;
            e.enabled && xr(this, e), m.prototype.addTrack.call(this, e), !!e.addEventListener && (e.enabledChange_ = function () {
              t.changing_ || (t.changing_ = !0, xr(t, e), t.changing_ = !1, t.trigger("change"));
            }, e.addEventListener("enabledchange", e.enabledChange_));
          }, l.removeTrack = function (e) {
            m.prototype.removeTrack.call(this, e), e.removeEventListener && e.enabledChange_ && (e.removeEventListener("enabledchange", e.enabledChange_), e.enabledChange_ = null);
          }, T;
        }(Mt),
            kr = function (T, l) {
          for (var r = 0; r < T.length; r++) !Object.keys(T[r]).length || l.id === T[r].id || (T[r].selected = !1);
        },
            ea = function (m) {
          a.default(T, m);

          function T(r) {
            var e;
            r === void 0 && (r = []);

            for (var t = r.length - 1; t >= 0; t--) if (r[t].selected) {
              kr(r, r[t]);
              break;
            }

            return e = m.call(this, r) || this, e.changing_ = !1, Object.defineProperty(n.default(e), "selectedIndex", {
              get: function () {
                for (var N = 0; N < this.length; N++) if (this[N].selected) return N;

                return -1;
              },
              set: function () {}
            }), e;
          }

          var l = T.prototype;
          return l.addTrack = function (e) {
            var t = this;
            e.selected && kr(this, e), m.prototype.addTrack.call(this, e), !!e.addEventListener && (e.selectedChange_ = function () {
              t.changing_ || (t.changing_ = !0, kr(t, e), t.changing_ = !1, t.trigger("change"));
            }, e.addEventListener("selectedchange", e.selectedChange_));
          }, l.removeTrack = function (e) {
            m.prototype.removeTrack.call(this, e), e.removeEventListener && e.selectedChange_ && (e.removeEventListener("selectedchange", e.selectedChange_), e.selectedChange_ = null);
          }, T;
        }(Mt),
            wi = function (m) {
          a.default(T, m);

          function T() {
            return m.apply(this, arguments) || this;
          }

          var l = T.prototype;
          return l.addTrack = function (e) {
            var t = this;
            m.prototype.addTrack.call(this, e), this.queueChange_ || (this.queueChange_ = function () {
              return t.queueTrigger("change");
            }), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = function () {
              return t.trigger("selectedlanguagechange");
            }), e.addEventListener("modechange", this.queueChange_);
            var S = ["metadata", "chapters"];
            S.indexOf(e.kind) === -1 && e.addEventListener("modechange", this.triggerSelectedlanguagechange_);
          }, l.removeTrack = function (e) {
            m.prototype.removeTrack.call(this, e), e.removeEventListener && (this.queueChange_ && e.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && e.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
          }, T;
        }(Mt),
            ta = function () {
          function m(l) {
            l === void 0 && (l = []), this.trackElements_ = [], Object.defineProperty(this, "length", {
              get: function () {
                return this.trackElements_.length;
              }
            });

            for (var r = 0, e = l.length; r < e; r++) this.addTrackElement_(l[r]);
          }

          var T = m.prototype;
          return T.addTrackElement_ = function (r) {
            var e = this.trackElements_.length;
            "" + e in this || Object.defineProperty(this, e, {
              get: function () {
                return this.trackElements_[e];
              }
            }), this.trackElements_.indexOf(r) === -1 && this.trackElements_.push(r);
          }, T.getTrackElementByTrack_ = function (r) {
            for (var e, t = 0, S = this.trackElements_.length; t < S; t++) if (r === this.trackElements_[t].track) {
              e = this.trackElements_[t];
              break;
            }

            return e;
          }, T.removeTrackElement_ = function (r) {
            for (var e = 0, t = this.trackElements_.length; e < t; e++) if (r === this.trackElements_[e]) {
              this.trackElements_[e].track && typeof this.trackElements_[e].track.off == "function" && this.trackElements_[e].track.off(), typeof this.trackElements_[e].off == "function" && this.trackElements_[e].off(), this.trackElements_.splice(e, 1);
              break;
            }
          }, m;
        }(),
            Fi = function () {
          function m(l) {
            m.prototype.setCues_.call(this, l), Object.defineProperty(this, "length", {
              get: function () {
                return this.length_;
              }
            });
          }

          var T = m.prototype;
          return T.setCues_ = function (r) {
            var e = this.length || 0,
                t = 0,
                S = r.length;
            this.cues_ = r, this.length_ = r.length;

            var N = function (X) {
              "" + X in this || Object.defineProperty(this, "" + X, {
                get: function () {
                  return this.cues_[X];
                }
              });
            };

            if (e < S) for (t = e; t < S; t++) N.call(this, t);
          }, T.getCueById = function (r) {
            for (var e = null, t = 0, S = this.length; t < S; t++) {
              var N = this[t];

              if (N.id === r) {
                e = N;
                break;
              }
            }

            return e;
          }, m;
        }(),
            ra = {
          alternative: "alternative",
          captions: "captions",
          main: "main",
          sign: "sign",
          subtitles: "subtitles",
          commentary: "commentary"
        },
            ia = {
          alternative: "alternative",
          descriptions: "descriptions",
          main: "main",
          "main-desc": "main-desc",
          translation: "translation",
          commentary: "commentary"
        },
            na = {
          subtitles: "subtitles",
          captions: "captions",
          descriptions: "descriptions",
          chapters: "chapters",
          metadata: "metadata"
        },
            Bi = {
          disabled: "disabled",
          hidden: "hidden",
          showing: "showing"
        },
            wr = function (m) {
          a.default(T, m);

          function T(l) {
            var r;
            l === void 0 && (l = {}), r = m.call(this) || this;

            var e = {
              id: l.id || "vjs_track_" + mt(),
              kind: l.kind || "",
              language: l.language || ""
            },
                t = l.label || "",
                S = function (X) {
              Object.defineProperty(n.default(r), X, {
                get: function () {
                  return e[X];
                },
                set: function () {}
              });
            };

            for (var N in e) S(N);

            return Object.defineProperty(n.default(r), "label", {
              get: function () {
                return t;
              },
              set: function (X) {
                X !== t && (t = X, this.trigger("labelchange"));
              }
            }), r;
          }

          return T;
        }(Ge),
            Fr = function (T) {
          var l = ["protocol", "hostname", "port", "pathname", "search", "hash", "host"],
              r = y.default.createElement("a");
          r.href = T;

          for (var e = {}, t = 0; t < l.length; t++) e[l[t]] = r[l[t]];

          return e.protocol === "http:" && (e.host = e.host.replace(/:80$/, "")), e.protocol === "https:" && (e.host = e.host.replace(/:443$/, "")), e.protocol || (e.protocol = f.default.location.protocol), e.host || (e.host = f.default.location.host), e;
        },
            Ni = function (T) {
          if (!T.match(/^https?:\/\//)) {
            var l = y.default.createElement("a");
            l.href = T, T = l.href;
          }

          return T;
        },
            Br = function (T) {
          if (typeof T == "string") {
            var l = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/,
                r = l.exec(T);
            if (r) return r.pop().toLowerCase();
          }

          return "";
        },
            ar = function (T, l) {
          l === void 0 && (l = f.default.location);
          var r = Fr(T),
              e = r.protocol === ":" ? l.protocol : r.protocol,
              t = e + r.host !== l.protocol + l.host;
          return t;
        },
            aa = Object.freeze({
          __proto__: null,
          parseUrl: Fr,
          getAbsoluteURL: Ni,
          getFileExtension: Br,
          isCrossOrigin: ar
        }),
            Ui = function (T, l) {
          var r = new f.default.WebVTT.Parser(f.default, f.default.vttjs, f.default.WebVTT.StringDecoder()),
              e = [];
          r.oncue = function (t) {
            l.addCue(t);
          }, r.onparsingerror = function (t) {
            e.push(t);
          }, r.onflush = function () {
            l.trigger({
              type: "loadeddata",
              target: l
            });
          }, r.parse(T), e.length > 0 && (f.default.console && f.default.console.groupCollapsed && f.default.console.groupCollapsed("Text Track parsing errors for " + l.src), e.forEach(function (t) {
            return $.error(t);
          }), f.default.console && f.default.console.groupEnd && f.default.console.groupEnd()), r.flush();
        },
            ji = function (T, l) {
          var r = {
            uri: T
          },
              e = ar(T);
          e && (r.cors = e);
          var t = l.tech_.crossOrigin() === "use-credentials";
          t && (r.withCredentials = t), h.default(r, Fe(this, function (S, N, z) {
            if (S) return $.error(S, N);
            l.loaded_ = !0, typeof f.default.WebVTT != "function" ? l.tech_ && l.tech_.any(["vttjsloaded", "vttjserror"], function (X) {
              if (X.type === "vttjserror") {
                $.error("vttjs failed to load, stopping trying to process " + l.src);
                return;
              }

              return Ui(z, l);
            }) : Ui(z, l);
          }));
        },
            Vt = function (m) {
          a.default(T, m);

          function T(r) {
            var e;
            if (r === void 0 && (r = {}), !r.tech) throw new Error("A tech was not provided.");
            var t = je(r, {
              kind: na[r.kind] || "subtitles",
              language: r.language || r.srclang || ""
            }),
                S = Bi[t.mode] || "disabled",
                N = t.default;
            (t.kind === "metadata" || t.kind === "chapters") && (S = "hidden"), e = m.call(this, t) || this, e.tech_ = t.tech, e.cues_ = [], e.activeCues_ = [], e.preload_ = e.tech_.preloadTextTracks !== !1;

            var z = new Fi(e.cues_),
                X = new Fi(e.activeCues_),
                J = !1,
                ie = Fe(n.default(e), function () {
              !this.tech_.isReady_ || this.tech_.isDisposed() || (this.activeCues = this.activeCues, J && (this.trigger("cuechange"), J = !1));
            }),
                Q = function () {
              e.tech_.off("timeupdate", ie);
            };

            return e.tech_.one("dispose", Q), S !== "disabled" && e.tech_.on("timeupdate", ie), Object.defineProperties(n.default(e), {
              default: {
                get: function () {
                  return N;
                },
                set: function () {}
              },
              mode: {
                get: function () {
                  return S;
                },
                set: function (Te) {
                  !Bi[Te] || S !== Te && (S = Te, !this.preload_ && S !== "disabled" && this.cues.length === 0 && ji(this.src, this), this.tech_.off("timeupdate", ie), S !== "disabled" && this.tech_.on("timeupdate", ie), this.trigger("modechange"));
                }
              },
              cues: {
                get: function () {
                  return this.loaded_ ? z : null;
                },
                set: function () {}
              },
              activeCues: {
                get: function () {
                  if (!this.loaded_) return null;
                  if (this.cues.length === 0) return X;

                  for (var Te = this.tech_.currentTime(), Oe = [], ht = 0, hi = this.cues.length; ht < hi; ht++) {
                    var yt = this.cues[ht];
                    (yt.startTime <= Te && yt.endTime >= Te || yt.startTime === yt.endTime && yt.startTime <= Te && yt.startTime + .5 >= Te) && Oe.push(yt);
                  }

                  if (J = !1, Oe.length !== this.activeCues_.length) J = !0;else for (var vi = 0; vi < Oe.length; vi++) this.activeCues_.indexOf(Oe[vi]) === -1 && (J = !0);
                  return this.activeCues_ = Oe, X.setCues_(this.activeCues_), X;
                },
                set: function () {}
              }
            }), t.src ? (e.src = t.src, e.preload_ || (e.loaded_ = !0), (e.preload_ || t.kind !== "subtitles" && t.kind !== "captions") && ji(e.src, n.default(e))) : e.loaded_ = !0, e;
          }

          var l = T.prototype;
          return l.addCue = function (e) {
            var t = e;

            if (f.default.vttjs && !(e instanceof f.default.vttjs.VTTCue)) {
              t = new f.default.vttjs.VTTCue(e.startTime, e.endTime, e.text);

              for (var S in e) S in t || (t[S] = e[S]);

              t.id = e.id, t.originalCue_ = e;
            }

            for (var N = this.tech_.textTracks(), z = 0; z < N.length; z++) N[z] !== this && N[z].removeCue(t);

            this.cues_.push(t), this.cues.setCues_(this.cues_);
          }, l.removeCue = function (e) {
            for (var t = this.cues_.length; t--;) {
              var S = this.cues_[t];

              if (S === e || S.originalCue_ && S.originalCue_ === e) {
                this.cues_.splice(t, 1), this.cues.setCues_(this.cues_);
                break;
              }
            }
          }, T;
        }(wr);

        Vt.prototype.allowedEvents_ = {
          cuechange: "cuechange"
        };

        var Ki = function (m) {
          a.default(T, m);

          function T(l) {
            var r;
            l === void 0 && (l = {});
            var e = je(l, {
              kind: ia[l.kind] || ""
            });
            r = m.call(this, e) || this;
            var t = !1;
            return Object.defineProperty(n.default(r), "enabled", {
              get: function () {
                return t;
              },
              set: function (N) {
                typeof N != "boolean" || N === t || (t = N, this.trigger("enabledchange"));
              }
            }), e.enabled && (r.enabled = e.enabled), r.loaded_ = !0, r;
          }

          return T;
        }(wr),
            Hi = function (m) {
          a.default(T, m);

          function T(l) {
            var r;
            l === void 0 && (l = {});
            var e = je(l, {
              kind: ra[l.kind] || ""
            });
            r = m.call(this, e) || this;
            var t = !1;
            return Object.defineProperty(n.default(r), "selected", {
              get: function () {
                return t;
              },
              set: function (N) {
                typeof N != "boolean" || N === t || (t = N, this.trigger("selectedchange"));
              }
            }), e.selected && (r.selected = e.selected), r;
          }

          return T;
        }(wr),
            Wi = 0,
            sa = 1,
            Gi = 2,
            oa = 3,
            xt = function (m) {
          a.default(T, m);

          function T(l) {
            var r;
            l === void 0 && (l = {}), r = m.call(this) || this;
            var e,
                t = new Vt(l);
            return r.kind = t.kind, r.src = t.src, r.srclang = t.language, r.label = t.label, r.default = t.default, Object.defineProperties(n.default(r), {
              readyState: {
                get: function () {
                  return e;
                }
              },
              track: {
                get: function () {
                  return t;
                }
              }
            }), e = Wi, t.addEventListener("loadeddata", function () {
              e = Gi, r.trigger({
                type: "load",
                target: n.default(r)
              });
            }), r;
          }

          return T;
        }(Ge);

        xt.prototype.allowedEvents_ = {
          load: "load"
        }, xt.NONE = Wi, xt.LOADING = sa, xt.LOADED = Gi, xt.ERROR = oa;
        var tt = {
          audio: {
            ListClass: qn,
            TrackClass: Ki,
            capitalName: "Audio"
          },
          video: {
            ListClass: ea,
            TrackClass: Hi,
            capitalName: "Video"
          },
          text: {
            ListClass: wi,
            TrackClass: Vt,
            capitalName: "Text"
          }
        };
        Object.keys(tt).forEach(function (m) {
          tt[m].getterName = m + "Tracks", tt[m].privateName = m + "Tracks_";
        });
        var kt = {
          remoteText: {
            ListClass: wi,
            TrackClass: Vt,
            capitalName: "RemoteText",
            getterName: "remoteTextTracks",
            privateName: "remoteTextTracks_"
          },
          remoteTextEl: {
            ListClass: ta,
            TrackClass: xt,
            capitalName: "RemoteTextTrackEls",
            getterName: "remoteTextTrackEls",
            privateName: "remoteTextTrackEls_"
          }
        },
            $e = u.default({}, tt, kt);
        kt.names = Object.keys(kt), tt.names = Object.keys(tt), $e.names = [].concat(kt.names).concat(tt.names);

        function la(m, T, l, r, e) {
          e === void 0 && (e = {});
          var t = m.textTracks();
          e.kind = T, l && (e.label = l), r && (e.language = r), e.tech = m;
          var S = new $e.text.TrackClass(e);
          return t.addTrack(S), S;
        }

        var Be = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return r === void 0 && (r = {}), e === void 0 && (e = function () {}), r.reportTouchActivity = !1, t = m.call(this, null, r, e) || this, t.onDurationChange_ = function (S) {
              return t.onDurationChange(S);
            }, t.trackProgress_ = function (S) {
              return t.trackProgress(S);
            }, t.trackCurrentTime_ = function (S) {
              return t.trackCurrentTime(S);
            }, t.stopTrackingCurrentTime_ = function (S) {
              return t.stopTrackingCurrentTime(S);
            }, t.disposeSourceHandler_ = function (S) {
              return t.disposeSourceHandler(S);
            }, t.hasStarted_ = !1, t.on("playing", function () {
              this.hasStarted_ = !0;
            }), t.on("loadstart", function () {
              this.hasStarted_ = !1;
            }), $e.names.forEach(function (S) {
              var N = $e[S];
              r && r[N.getterName] && (t[N.privateName] = r[N.getterName]);
            }), t.featuresProgressEvents || t.manualProgressOn(), t.featuresTimeupdateEvents || t.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach(function (S) {
              r["native" + S + "Tracks"] === !1 && (t["featuresNative" + S + "Tracks"] = !1);
            }), r.nativeCaptions === !1 || r.nativeTextTracks === !1 ? t.featuresNativeTextTracks = !1 : (r.nativeCaptions === !0 || r.nativeTextTracks === !0) && (t.featuresNativeTextTracks = !0), t.featuresNativeTextTracks || t.emulateTextTracks(), t.preloadTextTracks = r.preloadTextTracks !== !1, t.autoRemoteTextTracks_ = new $e.text.ListClass(), t.initTrackListeners(), r.nativeControlsForTouch || t.emitTapEvents(), t.constructor && (t.name_ = t.constructor.name || "Unknown Tech"), t;
          }

          var l = T.prototype;
          return l.triggerSourceset = function (e) {
            var t = this;
            this.isReady_ || this.one("ready", function () {
              return t.setTimeout(function () {
                return t.triggerSourceset(e);
              }, 1);
            }), this.trigger({
              src: e,
              type: "sourceset"
            });
          }, l.manualProgressOn = function () {
            this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
          }, l.manualProgressOff = function () {
            this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
          }, l.trackProgress = function (e) {
            this.stopTrackingProgress(), this.progressInterval = this.setInterval(Fe(this, function () {
              var t = this.bufferedPercent();
              this.bufferedPercent_ !== t && this.trigger("progress"), this.bufferedPercent_ = t, t === 1 && this.stopTrackingProgress();
            }), 500);
          }, l.onDurationChange = function (e) {
            this.duration_ = this.duration();
          }, l.buffered = function () {
            return bt(0, 0);
          }, l.bufferedPercent = function () {
            return xi(this.buffered(), this.duration_);
          }, l.stopTrackingProgress = function () {
            this.clearInterval(this.progressInterval);
          }, l.manualTimeUpdatesOn = function () {
            this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
          }, l.manualTimeUpdatesOff = function () {
            this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
          }, l.trackCurrentTime = function () {
            this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function () {
              this.trigger({
                type: "timeupdate",
                target: this,
                manuallyTriggered: !0
              });
            }, 250);
          }, l.stopTrackingCurrentTime = function () {
            this.clearInterval(this.currentTimeInterval), this.trigger({
              type: "timeupdate",
              target: this,
              manuallyTriggered: !0
            });
          }, l.dispose = function () {
            this.clearTracks(tt.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), m.prototype.dispose.call(this);
          }, l.clearTracks = function (e) {
            var t = this;
            e = [].concat(e), e.forEach(function (S) {
              for (var N = t[S + "Tracks"]() || [], z = N.length; z--;) {
                var X = N[z];
                S === "text" && t.removeRemoteTextTrack(X), N.removeTrack(X);
              }
            });
          }, l.cleanupAutoTextTracks = function () {
            for (var e = this.autoRemoteTextTracks_ || [], t = e.length; t--;) {
              var S = e[t];
              this.removeRemoteTextTrack(S);
            }
          }, l.reset = function () {}, l.crossOrigin = function () {}, l.setCrossOrigin = function () {}, l.error = function (e) {
            return e !== void 0 && (this.error_ = new Ye(e), this.trigger("error")), this.error_;
          }, l.played = function () {
            return this.hasStarted_ ? bt(0, 0) : bt();
          }, l.play = function () {}, l.setScrubbing = function () {}, l.scrubbing = function () {}, l.setCurrentTime = function () {
            this.manualTimeUpdates && this.trigger({
              type: "timeupdate",
              target: this,
              manuallyTriggered: !0
            });
          }, l.initTrackListeners = function () {
            var e = this;
            tt.names.forEach(function (t) {
              var S = tt[t],
                  N = function () {
                e.trigger(t + "trackchange");
              },
                  z = e[S.getterName]();

              z.addEventListener("removetrack", N), z.addEventListener("addtrack", N), e.on("dispose", function () {
                z.removeEventListener("removetrack", N), z.removeEventListener("addtrack", N);
              });
            });
          }, l.addWebVttScript_ = function () {
            var e = this;
            if (!f.default.WebVTT) if (y.default.body.contains(this.el())) {
              if (!this.options_["vtt.js"] && pe(c.default) && Object.keys(c.default).length > 0) {
                this.trigger("vttjsloaded");
                return;
              }

              var t = y.default.createElement("script");
              t.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", t.onload = function () {
                e.trigger("vttjsloaded");
              }, t.onerror = function () {
                e.trigger("vttjserror");
              }, this.on("dispose", function () {
                t.onload = null, t.onerror = null;
              }), f.default.WebVTT = !0, this.el().parentNode.appendChild(t);
            } else this.ready(this.addWebVttScript_);
          }, l.emulateTextTracks = function () {
            var e = this,
                t = this.textTracks(),
                S = this.remoteTextTracks(),
                N = function (Q) {
              return t.addTrack(Q.track);
            },
                z = function (Q) {
              return t.removeTrack(Q.track);
            };

            S.on("addtrack", N), S.on("removetrack", z), this.addWebVttScript_();

            var X = function () {
              return e.trigger("texttrackchange");
            },
                J = function () {
              X();

              for (var Q = 0; Q < t.length; Q++) {
                var de = t[Q];
                de.removeEventListener("cuechange", X), de.mode === "showing" && de.addEventListener("cuechange", X);
              }
            };

            J(), t.addEventListener("change", J), t.addEventListener("addtrack", J), t.addEventListener("removetrack", J), this.on("dispose", function () {
              S.off("addtrack", N), S.off("removetrack", z), t.removeEventListener("change", J), t.removeEventListener("addtrack", J), t.removeEventListener("removetrack", J);

              for (var ie = 0; ie < t.length; ie++) {
                var Q = t[ie];
                Q.removeEventListener("cuechange", X);
              }
            });
          }, l.addTextTrack = function (e, t, S) {
            if (!e) throw new Error("TextTrack kind is required but was not provided");
            return la(this, e, t, S);
          }, l.createRemoteTextTrack = function (e) {
            var t = je(e, {
              tech: this
            });
            return new kt.remoteTextEl.TrackClass(t);
          }, l.addRemoteTextTrack = function (e, t) {
            var S = this;
            e === void 0 && (e = {});
            var N = this.createRemoteTextTrack(e);
            return t !== !0 && t !== !1 && ($.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js'), t = !0), this.remoteTextTrackEls().addTrackElement_(N), this.remoteTextTracks().addTrack(N.track), t !== !0 && this.ready(function () {
              return S.autoRemoteTextTracks_.addTrack(N.track);
            }), N;
          }, l.removeRemoteTextTrack = function (e) {
            var t = this.remoteTextTrackEls().getTrackElementByTrack_(e);
            this.remoteTextTrackEls().removeTrackElement_(t), this.remoteTextTracks().removeTrack(e), this.autoRemoteTextTracks_.removeTrack(e);
          }, l.getVideoPlaybackQuality = function () {
            return {};
          }, l.requestPictureInPicture = function () {
            var e = this.options_.Promise || f.default.Promise;
            if (e) return e.reject();
          }, l.disablePictureInPicture = function () {
            return !0;
          }, l.setDisablePictureInPicture = function () {}, l.setPoster = function () {}, l.playsinline = function () {}, l.setPlaysinline = function () {}, l.overrideNativeAudioTracks = function () {}, l.overrideNativeVideoTracks = function () {}, l.canPlayType = function () {
            return "";
          }, T.canPlayType = function () {
            return "";
          }, T.canPlaySource = function (e, t) {
            return T.canPlayType(e.type);
          }, T.isTech = function (e) {
            return e.prototype instanceof T || e instanceof T || e === T;
          }, T.registerTech = function (e, t) {
            if (T.techs_ || (T.techs_ = {}), !T.isTech(t)) throw new Error("Tech " + e + " must be a Tech");
            if (!T.canPlayType) throw new Error("Techs must have a static canPlayType method on them");
            if (!T.canPlaySource) throw new Error("Techs must have a static canPlaySource method on them");
            return e = Ke(e), T.techs_[e] = t, T.techs_[nr(e)] = t, e !== "Tech" && T.defaultTechOrder_.push(e), t;
          }, T.getTech = function (e) {
            if (!!e) {
              if (T.techs_ && T.techs_[e]) return T.techs_[e];
              if (e = Ke(e), f.default && f.default.videojs && f.default.videojs[e]) return $.warn("The " + e + " tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)"), f.default.videojs[e];
            }
          }, T;
        }(fe);

        $e.names.forEach(function (m) {
          var T = $e[m];

          Be.prototype[T.getterName] = function () {
            return this[T.privateName] = this[T.privateName] || new T.ListClass(), this[T.privateName];
          };
        }), Be.prototype.featuresVolumeControl = !0, Be.prototype.featuresMuteControl = !0, Be.prototype.featuresFullscreenResize = !1, Be.prototype.featuresPlaybackRate = !1, Be.prototype.featuresProgressEvents = !1, Be.prototype.featuresSourceset = !1, Be.prototype.featuresTimeupdateEvents = !1, Be.prototype.featuresNativeTextTracks = !1, Be.withSourceHandlers = function (m) {
          m.registerSourceHandler = function (l, r) {
            var e = m.sourceHandlers;
            e || (e = m.sourceHandlers = []), r === void 0 && (r = e.length), e.splice(r, 0, l);
          }, m.canPlayType = function (l) {
            for (var r = m.sourceHandlers || [], e, t = 0; t < r.length; t++) if (e = r[t].canPlayType(l), e) return e;

            return "";
          }, m.selectSourceHandler = function (l, r) {
            for (var e = m.sourceHandlers || [], t, S = 0; S < e.length; S++) if (t = e[S].canHandleSource(l, r), t) return e[S];

            return null;
          }, m.canPlaySource = function (l, r) {
            var e = m.selectSourceHandler(l, r);
            return e ? e.canHandleSource(l, r) : "";
          };
          var T = ["seekable", "seeking", "duration"];
          T.forEach(function (l) {
            var r = this[l];
            typeof r == "function" && (this[l] = function () {
              return this.sourceHandler_ && this.sourceHandler_[l] ? this.sourceHandler_[l].apply(this.sourceHandler_, arguments) : r.apply(this, arguments);
            });
          }, m.prototype), m.prototype.setSource = function (l) {
            var r = m.selectSourceHandler(l, this.options_);
            r || (m.nativeSourceHandler ? r = m.nativeSourceHandler : $.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), r !== m.nativeSourceHandler && (this.currentSource_ = l), this.sourceHandler_ = r.handleSource(l, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
          }, m.prototype.disposeSourceHandler = function () {
            this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null);
          };
        }, fe.registerComponent("Tech", Be), Be.registerTech("Tech", Be), Be.defaultTechOrder_ = [];
        var Ct = {},
            Nr = {},
            sr = {};

        function ua(m, T) {
          Ct[m] = Ct[m] || [], Ct[m].push(T);
        }

        function ca(m, T, l) {
          m.setTimeout(function () {
            return Lt(T, Ct[T.type], l, m);
          }, 1);
        }

        function da(m, T) {
          m.forEach(function (l) {
            return l.setTech && l.setTech(T);
          });
        }

        function fa(m, T, l) {
          return m.reduceRight(Ur(l), T[l]());
        }

        function ha(m, T, l, r) {
          return T[l](m.reduce(Ur(l), r));
        }

        function Vi(m, T, l, r) {
          r === void 0 && (r = null);
          var e = "call" + Ke(l),
              t = m.reduce(Ur(e), r),
              S = t === sr,
              N = S ? null : T[l](t);
          return ga(m, l, N, S), N;
        }

        var va = {
          buffered: 1,
          currentTime: 1,
          duration: 1,
          muted: 1,
          played: 1,
          paused: 1,
          seekable: 1,
          volume: 1,
          ended: 1
        },
            pa = {
          setCurrentTime: 1,
          setMuted: 1,
          setVolume: 1
        },
            zi = {
          play: 1,
          pause: 1
        };

        function Ur(m) {
          return function (T, l) {
            return T === sr ? sr : l[m] ? l[m](T) : T;
          };
        }

        function ga(m, T, l, r) {
          for (var e = m.length - 1; e >= 0; e--) {
            var t = m[e];
            t[T] && t[T](r, l);
          }
        }

        function ma(m) {
          Nr[m.id()] = null;
        }

        function ya(m, T) {
          var l = Nr[m.id()],
              r = null;
          if (l == null) return r = T(m), Nr[m.id()] = [[T, r]], r;

          for (var e = 0; e < l.length; e++) {
            var t = l[e],
                S = t[0],
                N = t[1];
            S === T && (r = N);
          }

          return r === null && (r = T(m), l.push([T, r])), r;
        }

        function Lt(m, T, l, r, e, t) {
          m === void 0 && (m = {}), T === void 0 && (T = []), e === void 0 && (e = []), t === void 0 && (t = !1);
          var S = T,
              N = S[0],
              z = S.slice(1);
          if (typeof N == "string") Lt(m, Ct[N], l, r, e, t);else if (N) {
            var X = ya(r, N);
            if (!X.setSource) return e.push(X), Lt(m, z, l, r, e, t);
            X.setSource(he({}, m), function (J, ie) {
              if (J) return Lt(m, z, l, r, e, t);
              e.push(X), Lt(ie, m.type === ie.type ? z : Ct[ie.type], l, r, e, t);
            });
          } else z.length ? Lt(m, z, l, r, e, t) : t ? l(m, e) : Lt(m, Ct["*"], l, r, e, !0);
        }

        var Ea = {
          opus: "video/ogg",
          ogv: "video/ogg",
          mp4: "video/mp4",
          mov: "video/mp4",
          m4v: "video/mp4",
          mkv: "video/x-matroska",
          m4a: "audio/mp4",
          mp3: "audio/mpeg",
          aac: "audio/aac",
          caf: "audio/x-caf",
          flac: "audio/flac",
          oga: "audio/ogg",
          wav: "audio/wav",
          m3u8: "application/x-mpegURL",
          jpg: "image/jpeg",
          jpeg: "image/jpeg",
          gif: "image/gif",
          png: "image/png",
          svg: "image/svg+xml",
          webp: "image/webp"
        },
            or = function (T) {
          T === void 0 && (T = "");
          var l = Br(T),
              r = Ea[l.toLowerCase()];
          return r || "";
        },
            Ta = function (T, l) {
          if (!l) return "";
          if (T.cache_.source.src === l && T.cache_.source.type) return T.cache_.source.type;
          var r = T.cache_.sources.filter(function (N) {
            return N.src === l;
          });
          if (r.length) return r[0].type;

          for (var e = T.$$("source"), t = 0; t < e.length; t++) {
            var S = e[t];
            if (S.type && S.src && S.src === l) return S.type;
          }

          return or(l);
        },
            _a = function m(T) {
          if (Array.isArray(T)) {
            var l = [];
            T.forEach(function (r) {
              r = m(r), Array.isArray(r) ? l = l.concat(r) : ye(r) && l.push(r);
            }), T = l;
          } else typeof T == "string" && T.trim() ? T = [Xi({
            src: T
          })] : ye(T) && typeof T.src == "string" && T.src && T.src.trim() ? T = [Xi(T)] : T = [];

          return T;
        };

        function Xi(m) {
          if (!m.type) {
            var T = or(m.src);
            T && (m.type = T);
          }

          return m;
        }

        var Sa = function (m) {
          a.default(T, m);

          function T(l, r, e) {
            var t,
                S = je({
              createEl: !1
            }, r);
            if (t = m.call(this, l, S, e) || this, !r.playerOptions.sources || r.playerOptions.sources.length === 0) for (var N = 0, z = r.playerOptions.techOrder; N < z.length; N++) {
              var X = Ke(z[N]),
                  J = Be.getTech(X);

              if (X || (J = fe.getComponent(X)), J && J.isSupported()) {
                l.loadTech_(X);
                break;
              }
            } else l.src(r.playerOptions.sources);
            return t;
          }

          return T;
        }(fe);

        fe.registerComponent("MediaLoader", Sa);

        var lr = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.handleMouseOver_ = function (S) {
              return t.handleMouseOver(S);
            }, t.handleMouseOut_ = function (S) {
              return t.handleMouseOut(S);
            }, t.handleClick_ = function (S) {
              return t.handleClick(S);
            }, t.handleKeyDown_ = function (S) {
              return t.handleKeyDown(S);
            }, t.emitTapEvents(), t.enable(), t;
          }

          var l = T.prototype;
          return l.createEl = function (e, t, S) {
            e === void 0 && (e = "div"), t === void 0 && (t = {}), S === void 0 && (S = {}), t = he({
              className: this.buildCSSClass(),
              tabIndex: 0
            }, t), e === "button" && $.error("Creating a ClickableComponent with an HTML element of " + e + " is not supported; use a Button instead."), S = he({
              role: "button"
            }, S), this.tabIndex_ = t.tabIndex;
            var N = Pe(e, t, S);
            return N.appendChild(Pe("span", {
              className: "vjs-icon-placeholder"
            }, {
              "aria-hidden": !0
            })), this.createControlTextEl(N), N;
          }, l.dispose = function () {
            this.controlTextEl_ = null, m.prototype.dispose.call(this);
          }, l.createControlTextEl = function (e) {
            return this.controlTextEl_ = Pe("span", {
              className: "vjs-control-text"
            }, {
              "aria-live": "polite"
            }), e && e.appendChild(this.controlTextEl_), this.controlText(this.controlText_, e), this.controlTextEl_;
          }, l.controlText = function (e, t) {
            if (t === void 0 && (t = this.el()), e === void 0) return this.controlText_ || "Need Text";
            var S = this.localize(e);
            this.controlText_ = e, ut(this.controlTextEl_, S), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && t.setAttribute("title", S);
          }, l.buildCSSClass = function () {
            return "vjs-control vjs-button " + m.prototype.buildCSSClass.call(this);
          }, l.enable = function () {
            this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), typeof this.tabIndex_ != "undefined" && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
          }, l.disable = function () {
            this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), typeof this.tabIndex_ != "undefined" && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
          }, l.handleLanguagechange = function () {
            this.controlText(this.controlText_);
          }, l.handleClick = function (e) {
            this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
          }, l.handleKeyDown = function (e) {
            i.default.isEventKey(e, "Space") || i.default.isEventKey(e, "Enter") ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : m.prototype.handleKeyDown.call(this, e);
          }, T;
        }(fe);

        fe.registerComponent("ClickableComponent", lr);

        var ba = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.update(), t.update_ = function (S) {
              return t.update(S);
            }, r.on("posterchange", t.update_), t;
          }

          var l = T.prototype;
          return l.dispose = function () {
            this.player().off("posterchange", this.update_), m.prototype.dispose.call(this);
          }, l.createEl = function () {
            var e = Pe("div", {
              className: "vjs-poster",
              tabIndex: -1
            });
            return e;
          }, l.update = function (e) {
            var t = this.player().poster();
            this.setSrc(t), t ? this.show() : this.hide();
          }, l.setSrc = function (e) {
            var t = "";
            e && (t = 'url("' + e + '")'), this.el_.style.backgroundImage = t;
          }, l.handleClick = function (e) {
            if (!!this.player_.controls()) {
              var t = this.player_.usingPlugin("eme") && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
              this.player_.tech(!0) && !((ce || ue) && t) && this.player_.tech(!0).focus(), this.player_.paused() ? ot(this.player_.play()) : this.player_.pause();
            }
          }, T;
        }(lr);

        fe.registerComponent("PosterImage", ba);
        var rt = "#222",
            Yi = "#ccc",
            Ca = {
          monospace: "monospace",
          sansSerif: "sans-serif",
          serif: "serif",
          monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
          monospaceSerif: '"Courier New", monospace',
          proportionalSansSerif: "sans-serif",
          proportionalSerif: "serif",
          casual: '"Comic Sans MS", Impact, fantasy',
          script: '"Monotype Corsiva", cursive',
          smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
        };

        function jr(m, T) {
          var l;
          if (m.length === 4) l = m[1] + m[1] + m[2] + m[2] + m[3] + m[3];else if (m.length === 7) l = m.slice(1);else throw new Error("Invalid color code provided, " + m + "; must be formatted as e.g. #f0e or #f604e2.");
          return "rgba(" + parseInt(l.slice(0, 2), 16) + "," + parseInt(l.slice(2, 4), 16) + "," + parseInt(l.slice(4, 6), 16) + "," + T + ")";
        }

        function Kr(m, T, l) {
          try {
            m.style[T] = l;
          } catch (r) {
            return;
          }
        }

        var La = function (m) {
          a.default(T, m);

          function T(r, e, t) {
            var S;
            S = m.call(this, r, e, t) || this;

            var N = function (X) {
              return S.updateDisplay(X);
            };

            return r.on("loadstart", function (z) {
              return S.toggleDisplay(z);
            }), r.on("texttrackchange", N), r.on("loadedmetadata", function (z) {
              return S.preselectTrack(z);
            }), r.ready(Fe(n.default(S), function () {
              if (r.tech_ && r.tech_.featuresNativeTextTracks) {
                this.hide();
                return;
              }

              r.on("fullscreenchange", N), r.on("playerresize", N), f.default.addEventListener("orientationchange", N), r.on("dispose", function () {
                return f.default.removeEventListener("orientationchange", N);
              });

              for (var z = this.options_.playerOptions.tracks || [], X = 0; X < z.length; X++) this.player_.addRemoteTextTrack(z[X], !0);

              this.preselectTrack();
            })), S;
          }

          var l = T.prototype;
          return l.preselectTrack = function () {
            for (var e = {
              captions: 1,
              subtitles: 1
            }, t = this.player_.textTracks(), S = this.player_.cache_.selectedLanguage, N, z, X, J = 0; J < t.length; J++) {
              var ie = t[J];
              S && S.enabled && S.language && S.language === ie.language && ie.kind in e ? ie.kind === S.kind ? X = ie : X || (X = ie) : S && !S.enabled ? (X = null, N = null, z = null) : ie.default && (ie.kind === "descriptions" && !N ? N = ie : ie.kind in e && !z && (z = ie));
            }

            X ? X.mode = "showing" : z ? z.mode = "showing" : N && (N.mode = "showing");
          }, l.toggleDisplay = function () {
            this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
          }, l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: "vjs-text-track-display"
            }, {
              translate: "yes",
              "aria-live": "off",
              "aria-atomic": "true"
            });
          }, l.clearDisplay = function () {
            typeof f.default.WebVTT == "function" && f.default.WebVTT.processCues(f.default, [], this.el_);
          }, l.updateDisplay = function () {
            var e = this.player_.textTracks(),
                t = this.options_.allowMultipleShowingTracks;

            if (this.clearDisplay(), t) {
              for (var S = [], N = 0; N < e.length; ++N) {
                var z = e[N];
                z.mode === "showing" && S.push(z);
              }

              this.updateForTrack(S);
              return;
            }

            for (var X = null, J = null, ie = e.length; ie--;) {
              var Q = e[ie];
              Q.mode === "showing" && (Q.kind === "descriptions" ? X = Q : J = Q);
            }

            J ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(J)) : X && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(X));
          }, l.updateDisplayState = function (e) {
            for (var t = this.player_.textTrackSettings.getValues(), S = e.activeCues, N = S.length; N--;) {
              var z = S[N];

              if (!!z) {
                var X = z.displayState;

                if (t.color && (X.firstChild.style.color = t.color), t.textOpacity && Kr(X.firstChild, "color", jr(t.color || "#fff", t.textOpacity)), t.backgroundColor && (X.firstChild.style.backgroundColor = t.backgroundColor), t.backgroundOpacity && Kr(X.firstChild, "backgroundColor", jr(t.backgroundColor || "#000", t.backgroundOpacity)), t.windowColor && (t.windowOpacity ? Kr(X, "backgroundColor", jr(t.windowColor, t.windowOpacity)) : X.style.backgroundColor = t.windowColor), t.edgeStyle && (t.edgeStyle === "dropshadow" ? X.firstChild.style.textShadow = "2px 2px 3px " + rt + ", 2px 2px 4px " + rt + ", 2px 2px 5px " + rt : t.edgeStyle === "raised" ? X.firstChild.style.textShadow = "1px 1px " + rt + ", 2px 2px " + rt + ", 3px 3px " + rt : t.edgeStyle === "depressed" ? X.firstChild.style.textShadow = "1px 1px " + Yi + ", 0 1px " + Yi + ", -1px -1px " + rt + ", 0 -1px " + rt : t.edgeStyle === "uniform" && (X.firstChild.style.textShadow = "0 0 4px " + rt + ", 0 0 4px " + rt + ", 0 0 4px " + rt + ", 0 0 4px " + rt)), t.fontPercent && t.fontPercent !== 1) {
                  var J = f.default.parseFloat(X.style.fontSize);
                  X.style.fontSize = J * t.fontPercent + "px", X.style.height = "auto", X.style.top = "auto";
                }

                t.fontFamily && t.fontFamily !== "default" && (t.fontFamily === "small-caps" ? X.firstChild.style.fontVariant = "small-caps" : X.firstChild.style.fontFamily = Ca[t.fontFamily]);
              }
            }
          }, l.updateForTrack = function (e) {
            if (Array.isArray(e) || (e = [e]), !(typeof f.default.WebVTT != "function" || e.every(function (de) {
              return !de.activeCues;
            }))) {
              for (var t = [], S = 0; S < e.length; ++S) for (var N = e[S], z = 0; z < N.activeCues.length; ++z) t.push(N.activeCues[z]);

              f.default.WebVTT.processCues(f.default, t, this.el_);

              for (var X = 0; X < e.length; ++X) {
                for (var J = e[X], ie = 0; ie < J.activeCues.length; ++ie) {
                  var Q = J.activeCues[ie].displayState;
                  et(Q, "vjs-text-track-cue"), et(Q, "vjs-text-track-cue-" + (J.language ? J.language : X)), J.language && pt(Q, "lang", J.language);
                }

                this.player_.textTrackSettings && this.updateDisplayState(J);
              }
            }
          }, T;
        }(fe);

        fe.registerComponent("TextTrackDisplay", La);

        var Aa = function (m) {
          a.default(T, m);

          function T() {
            return m.apply(this, arguments) || this;
          }

          var l = T.prototype;
          return l.createEl = function () {
            var e = this.player_.isAudio(),
                t = this.localize(e ? "Audio Player" : "Video Player"),
                S = Pe("span", {
              className: "vjs-control-text",
              textContent: this.localize("{1} is loading.", [t])
            }),
                N = m.prototype.createEl.call(this, "div", {
              className: "vjs-loading-spinner",
              dir: "ltr"
            });
            return N.appendChild(S), N;
          }, T;
        }(fe);

        fe.registerComponent("LoadingSpinner", Aa);

        var at = function (m) {
          a.default(T, m);

          function T() {
            return m.apply(this, arguments) || this;
          }

          var l = T.prototype;
          return l.createEl = function (e, t, S) {
            t === void 0 && (t = {}), S === void 0 && (S = {}), e = "button", t = he({
              className: this.buildCSSClass()
            }, t), S = he({
              type: "button"
            }, S);
            var N = Pe(e, t, S);
            return N.appendChild(Pe("span", {
              className: "vjs-icon-placeholder"
            }, {
              "aria-hidden": !0
            })), this.createControlTextEl(N), N;
          }, l.addChild = function (e, t) {
            t === void 0 && (t = {});
            var S = this.constructor.name;
            return $.warn("Adding an actionable (user controllable) child to a Button (" + S + ") is not supported; use a ClickableComponent instead."), fe.prototype.addChild.call(this, e, t);
          }, l.enable = function () {
            m.prototype.enable.call(this), this.el_.removeAttribute("disabled");
          }, l.disable = function () {
            m.prototype.disable.call(this), this.el_.setAttribute("disabled", "disabled");
          }, l.handleKeyDown = function (e) {
            if (i.default.isEventKey(e, "Space") || i.default.isEventKey(e, "Enter")) {
              e.stopPropagation();
              return;
            }

            m.prototype.handleKeyDown.call(this, e);
          }, T;
        }(lr);

        fe.registerComponent("Button", at);

        var $i = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.mouseused_ = !1, t.on("mousedown", function (S) {
              return t.handleMouseDown(S);
            }), t;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-big-play-button";
          }, l.handleClick = function (e) {
            var t = this.player_.play();

            if (this.mouseused_ && e.clientX && e.clientY) {
              var S = this.player_.usingPlugin("eme") && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
              ot(t), this.player_.tech(!0) && !((ce || ue) && S) && this.player_.tech(!0).focus();
              return;
            }

            var N = this.player_.getChild("controlBar"),
                z = N && N.getChild("playToggle");

            if (!z) {
              this.player_.tech(!0).focus();
              return;
            }

            var X = function () {
              return z.focus();
            };

            Gt(t) ? t.then(X, function () {}) : this.setTimeout(X, 1);
          }, l.handleKeyDown = function (e) {
            this.mouseused_ = !1, m.prototype.handleKeyDown.call(this, e);
          }, l.handleMouseDown = function (e) {
            this.mouseused_ = !0;
          }, T;
        }(at);

        $i.prototype.controlText_ = "Play Video", fe.registerComponent("BigPlayButton", $i);

        var Da = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.controlText(e && e.controlText || t.localize("Close")), t;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-close-button " + m.prototype.buildCSSClass.call(this);
          }, l.handleClick = function (e) {
            this.trigger({
              type: "close",
              bubbles: !1
            });
          }, l.handleKeyDown = function (e) {
            i.default.isEventKey(e, "Esc") ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : m.prototype.handleKeyDown.call(this, e);
          }, T;
        }(at);

        fe.registerComponent("CloseButton", Da);

        var Qi = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return e === void 0 && (e = {}), t = m.call(this, r, e) || this, e.replay = e.replay === void 0 || e.replay, t.on(r, "play", function (S) {
              return t.handlePlay(S);
            }), t.on(r, "pause", function (S) {
              return t.handlePause(S);
            }), e.replay && t.on(r, "ended", function (S) {
              return t.handleEnded(S);
            }), t;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-play-control " + m.prototype.buildCSSClass.call(this);
          }, l.handleClick = function (e) {
            this.player_.paused() ? ot(this.player_.play()) : this.player_.pause();
          }, l.handleSeeked = function (e) {
            this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(e) : this.handlePlay(e);
          }, l.handlePlay = function (e) {
            this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.controlText("Pause");
          }, l.handlePause = function (e) {
            this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.controlText("Play");
          }, l.handleEnded = function (e) {
            var t = this;
            this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.controlText("Replay"), this.one(this.player_, "seeked", function (S) {
              return t.handleSeeked(S);
            });
          }, T;
        }(at);

        Qi.prototype.controlText_ = "Play", fe.registerComponent("PlayToggle", Qi);

        var Ji = function (T, l) {
          T = T < 0 ? 0 : T;
          var r = Math.floor(T % 60),
              e = Math.floor(T / 60 % 60),
              t = Math.floor(T / 3600),
              S = Math.floor(l / 60 % 60),
              N = Math.floor(l / 3600);
          return (isNaN(T) || T === 1 / 0) && (t = e = r = "-"), t = t > 0 || N > 0 ? t + ":" : "", e = ((t || S >= 10) && e < 10 ? "0" + e : e) + ":", r = r < 10 ? "0" + r : r, t + e + r;
        },
            Hr = Ji;

        function Pa(m) {
          Hr = m;
        }

        function Oa() {
          Hr = Ji;
        }

        function wt(m, T) {
          return T === void 0 && (T = m), Hr(m, T);
        }

        var Ft = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.on(r, ["timeupdate", "ended"], function (S) {
              return t.updateContent(S);
            }), t.updateTextNode_(), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            var e = this.buildCSSClass(),
                t = m.prototype.createEl.call(this, "div", {
              className: e + " vjs-time-control vjs-control"
            }),
                S = Pe("span", {
              className: "vjs-control-text",
              textContent: this.localize(this.labelText_) + "\xA0"
            }, {
              role: "presentation"
            });
            return t.appendChild(S), this.contentEl_ = Pe("span", {
              className: e + "-display"
            }, {
              "aria-live": "off",
              role: "presentation"
            }), t.appendChild(this.contentEl_), t;
          }, l.dispose = function () {
            this.contentEl_ = null, this.textNode_ = null, m.prototype.dispose.call(this);
          }, l.updateTextNode_ = function (e) {
            var t = this;
            e === void 0 && (e = 0), e = wt(e), this.formattedTime_ !== e && (this.formattedTime_ = e, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", function () {
              if (!!t.contentEl_) {
                var S = t.textNode_;
                S && t.contentEl_.firstChild !== S && (S = null, $.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), t.textNode_ = y.default.createTextNode(t.formattedTime_), !!t.textNode_ && (S ? t.contentEl_.replaceChild(t.textNode_, S) : t.contentEl_.appendChild(t.textNode_));
              }
            }));
          }, l.updateContent = function (e) {}, T;
        }(fe);

        Ft.prototype.labelText_ = "Time", Ft.prototype.controlText_ = "Time", fe.registerComponent("TimeDisplay", Ft);

        var Wr = function (m) {
          a.default(T, m);

          function T() {
            return m.apply(this, arguments) || this;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-current-time";
          }, l.updateContent = function (e) {
            var t;
            this.player_.ended() ? t = this.player_.duration() : t = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(t);
          }, T;
        }(Ft);

        Wr.prototype.labelText_ = "Current Time", Wr.prototype.controlText_ = "Current Time", fe.registerComponent("CurrentTimeDisplay", Wr);

        var Gr = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            t = m.call(this, r, e) || this;

            var S = function (z) {
              return t.updateContent(z);
            };

            return t.on(r, "durationchange", S), t.on(r, "loadstart", S), t.on(r, "loadedmetadata", S), t;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-duration";
          }, l.updateContent = function (e) {
            var t = this.player_.duration();
            this.updateTextNode_(t);
          }, T;
        }(Ft);

        Gr.prototype.labelText_ = "Duration", Gr.prototype.controlText_ = "Duration", fe.registerComponent("DurationDisplay", Gr);

        var Ia = function (m) {
          a.default(T, m);

          function T() {
            return m.apply(this, arguments) || this;
          }

          var l = T.prototype;
          return l.createEl = function () {
            var e = m.prototype.createEl.call(this, "div", {
              className: "vjs-time-control vjs-time-divider"
            }, {
              "aria-hidden": !0
            }),
                t = m.prototype.createEl.call(this, "div"),
                S = m.prototype.createEl.call(this, "span", {
              textContent: "/"
            });
            return t.appendChild(S), e.appendChild(t), e;
          }, T;
        }(fe);

        fe.registerComponent("TimeDivider", Ia);

        var Vr = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.on(r, "durationchange", function (S) {
              return t.updateContent(S);
            }), t;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-remaining-time";
          }, l.createEl = function () {
            var e = m.prototype.createEl.call(this);
            return this.options_.displayNegative !== !1 && e.insertBefore(Pe("span", {}, {
              "aria-hidden": !0
            }, "-"), this.contentEl_), e;
          }, l.updateContent = function (e) {
            if (typeof this.player_.duration() == "number") {
              var t;
              this.player_.ended() ? t = 0 : this.player_.remainingTimeDisplay ? t = this.player_.remainingTimeDisplay() : t = this.player_.remainingTime(), this.updateTextNode_(t);
            }
          }, T;
        }(Ft);

        Vr.prototype.labelText_ = "Remaining Time", Vr.prototype.controlText_ = "Remaining Time", fe.registerComponent("RemainingTimeDisplay", Vr);

        var Ra = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.updateShowing(), t.on(t.player(), "durationchange", function (S) {
              return t.updateShowing(S);
            }), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            var e = m.prototype.createEl.call(this, "div", {
              className: "vjs-live-control vjs-control"
            });
            return this.contentEl_ = Pe("div", {
              className: "vjs-live-display"
            }, {
              "aria-live": "off"
            }), this.contentEl_.appendChild(Pe("span", {
              className: "vjs-control-text",
              textContent: this.localize("Stream Type") + "\xA0"
            })), this.contentEl_.appendChild(y.default.createTextNode(this.localize("LIVE"))), e.appendChild(this.contentEl_), e;
          }, l.dispose = function () {
            this.contentEl_ = null, m.prototype.dispose.call(this);
          }, l.updateShowing = function (e) {
            this.player().duration() === 1 / 0 ? this.show() : this.hide();
          }, T;
        }(fe);

        fe.registerComponent("LiveDisplay", Ra);

        var Zi = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.updateLiveEdgeStatus(), t.player_.liveTracker && (t.updateLiveEdgeStatusHandler_ = function (S) {
              return t.updateLiveEdgeStatus(S);
            }, t.on(t.player_.liveTracker, "liveedgechange", t.updateLiveEdgeStatusHandler_)), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            var e = m.prototype.createEl.call(this, "button", {
              className: "vjs-seek-to-live-control vjs-control"
            });
            return this.textEl_ = Pe("span", {
              className: "vjs-seek-to-live-text",
              textContent: this.localize("LIVE")
            }, {
              "aria-hidden": "true"
            }), e.appendChild(this.textEl_), e;
          }, l.updateLiveEdgeStatus = function () {
            !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
          }, l.handleClick = function () {
            this.player_.liveTracker.seekToLiveEdge();
          }, l.dispose = function () {
            this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, m.prototype.dispose.call(this);
          }, T;
        }(at);

        Zi.prototype.controlText_ = "Seek to live, currently playing live", fe.registerComponent("SeekToLive", Zi);

        var ur = function (T, l, r) {
          return T = Number(T), Math.min(r, Math.max(l, isNaN(T) ? l : T));
        },
            zr = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.handleMouseDown_ = function (S) {
              return t.handleMouseDown(S);
            }, t.handleMouseUp_ = function (S) {
              return t.handleMouseUp(S);
            }, t.handleKeyDown_ = function (S) {
              return t.handleKeyDown(S);
            }, t.handleClick_ = function (S) {
              return t.handleClick(S);
            }, t.handleMouseMove_ = function (S) {
              return t.handleMouseMove(S);
            }, t.update_ = function (S) {
              return t.update(S);
            }, t.bar = t.getChild(t.options_.barName), t.vertical(!!t.options_.vertical), t.enable(), t;
          }

          var l = T.prototype;
          return l.enabled = function () {
            return this.enabled_;
          }, l.enable = function () {
            this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
          }, l.disable = function () {
            if (!!this.enabled()) {
              var e = this.bar.el_.ownerDocument;
              this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(e, "mousemove", this.handleMouseMove_), this.off(e, "mouseup", this.handleMouseUp_), this.off(e, "touchmove", this.handleMouseMove_), this.off(e, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
            }
          }, l.createEl = function (e, t, S) {
            return t === void 0 && (t = {}), S === void 0 && (S = {}), t.className = t.className + " vjs-slider", t = he({
              tabIndex: 0
            }, t), S = he({
              role: "slider",
              "aria-valuenow": 0,
              "aria-valuemin": 0,
              "aria-valuemax": 100,
              tabIndex: 0
            }, S), m.prototype.createEl.call(this, e, t, S);
          }, l.handleMouseDown = function (e) {
            var t = this.bar.el_.ownerDocument;
            e.type === "mousedown" && e.preventDefault(), e.type === "touchstart" && !re && e.preventDefault(), gi(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(t, "mousemove", this.handleMouseMove_), this.on(t, "mouseup", this.handleMouseUp_), this.on(t, "touchmove", this.handleMouseMove_), this.on(t, "touchend", this.handleMouseUp_), this.handleMouseMove(e, !0);
          }, l.handleMouseMove = function (e) {}, l.handleMouseUp = function () {
            var e = this.bar.el_.ownerDocument;
            mi(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(e, "mousemove", this.handleMouseMove_), this.off(e, "mouseup", this.handleMouseUp_), this.off(e, "touchmove", this.handleMouseMove_), this.off(e, "touchend", this.handleMouseUp_), this.update();
          }, l.update = function () {
            var e = this;

            if (!(!this.el_ || !this.bar)) {
              var t = this.getProgress();
              return t === this.progress_ || (this.progress_ = t, this.requestNamedAnimationFrame("Slider#update", function () {
                var S = e.vertical() ? "height" : "width";
                e.bar.el().style[S] = (t * 100).toFixed(2) + "%";
              })), t;
            }
          }, l.getProgress = function () {
            return Number(ur(this.getPercent(), 0, 1).toFixed(4));
          }, l.calculateDistance = function (e) {
            var t = Zt(this.el_, e);
            return this.vertical() ? t.y : t.x;
          }, l.handleKeyDown = function (e) {
            i.default.isEventKey(e, "Left") || i.default.isEventKey(e, "Down") ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : i.default.isEventKey(e, "Right") || i.default.isEventKey(e, "Up") ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : m.prototype.handleKeyDown.call(this, e);
          }, l.handleClick = function (e) {
            e.stopPropagation(), e.preventDefault();
          }, l.vertical = function (e) {
            if (e === void 0) return this.vertical_ || !1;
            this.vertical_ = !!e, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
          }, T;
        }(fe);

        fe.registerComponent("Slider", zr);

        var Xr = function (T, l) {
          return ur(T / l * 100, 0, 100).toFixed(2) + "%";
        },
            Ma = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.partEls_ = [], t.on(r, "progress", function (S) {
              return t.update(S);
            }), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            var e = m.prototype.createEl.call(this, "div", {
              className: "vjs-load-progress"
            }),
                t = Pe("span", {
              className: "vjs-control-text"
            }),
                S = Pe("span", {
              textContent: this.localize("Loaded")
            }),
                N = y.default.createTextNode(": ");
            return this.percentageEl_ = Pe("span", {
              className: "vjs-control-text-loaded-percentage",
              textContent: "0%"
            }), e.appendChild(t), t.appendChild(S), t.appendChild(N), t.appendChild(this.percentageEl_), e;
          }, l.dispose = function () {
            this.partEls_ = null, this.percentageEl_ = null, m.prototype.dispose.call(this);
          }, l.update = function (e) {
            var t = this;
            this.requestNamedAnimationFrame("LoadProgressBar#update", function () {
              var S = t.player_.liveTracker,
                  N = t.player_.buffered(),
                  z = S && S.isLive() ? S.seekableEnd() : t.player_.duration(),
                  X = t.player_.bufferedEnd(),
                  J = t.partEls_,
                  ie = Xr(X, z);
              t.percent_ !== ie && (t.el_.style.width = ie, ut(t.percentageEl_, ie), t.percent_ = ie);

              for (var Q = 0; Q < N.length; Q++) {
                var de = N.start(Q),
                    Te = N.end(Q),
                    Oe = J[Q];
                Oe || (Oe = t.el_.appendChild(Pe()), J[Q] = Oe), !(Oe.dataset.start === de && Oe.dataset.end === Te) && (Oe.dataset.start = de, Oe.dataset.end = Te, Oe.style.left = Xr(de, X), Oe.style.width = Xr(Te - de, X));
              }

              for (var ht = J.length; ht > N.length; ht--) t.el_.removeChild(J[ht - 1]);

              J.length = N.length;
            });
          }, T;
        }(fe);

        fe.registerComponent("LoadProgressBar", Ma);

        var xa = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.update = dt(Fe(n.default(t), t.update), nt), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: "vjs-time-tooltip"
            }, {
              "aria-hidden": "true"
            });
          }, l.update = function (e, t, S) {
            var N = Kt(this.el_),
                z = Pt(this.player_.el()),
                X = e.width * t;

            if (!(!z || !N)) {
              var J = e.left - z.left + X,
                  ie = e.width - X + (z.right - e.right),
                  Q = N.width / 2;
              J < Q ? Q += Q - J : ie < Q && (Q = ie), Q < 0 ? Q = 0 : Q > N.width && (Q = N.width), Q = Math.round(Q), this.el_.style.right = "-" + Q + "px", this.write(S);
            }
          }, l.write = function (e) {
            ut(this.el_, e);
          }, l.updateTime = function (e, t, S, N) {
            var z = this;
            this.requestNamedAnimationFrame("TimeTooltip#updateTime", function () {
              var X,
                  J = z.player_.duration();

              if (z.player_.liveTracker && z.player_.liveTracker.isLive()) {
                var ie = z.player_.liveTracker.liveWindow(),
                    Q = ie - t * ie;
                X = (Q < 1 ? "" : "-") + wt(Q, ie);
              } else X = wt(S, J);

              z.update(e, t, X), N && N();
            });
          }, T;
        }(fe);

        fe.registerComponent("TimeTooltip", xa);

        var Yr = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.update = dt(Fe(n.default(t), t.update), nt), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: "vjs-play-progress vjs-slider-bar"
            }, {
              "aria-hidden": "true"
            });
          }, l.update = function (e, t) {
            var S = this.getChild("timeTooltip");

            if (!!S) {
              var N = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
              S.updateTime(e, t, N);
            }
          }, T;
        }(fe);

        Yr.prototype.options_ = {
          children: []
        }, !De && !Me && Yr.prototype.options_.children.push("timeTooltip"), fe.registerComponent("PlayProgressBar", Yr);

        var qi = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.update = dt(Fe(n.default(t), t.update), nt), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: "vjs-mouse-display"
            });
          }, l.update = function (e, t) {
            var S = this,
                N = t * this.player_.duration();
            this.getChild("timeTooltip").updateTime(e, t, N, function () {
              S.el_.style.left = e.width * t + "px";
            });
          }, T;
        }(fe);

        qi.prototype.options_ = {
          children: ["timeTooltip"]
        }, fe.registerComponent("MouseTimeDisplay", qi);

        var cr = 5,
            en = 12,
            $r = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.setEventHandlers_(), t;
          }

          var l = T.prototype;
          return l.setEventHandlers_ = function () {
            var e = this;
            this.update_ = Fe(this, this.update), this.update = dt(this.update_, nt), this.on(this.player_, ["ended", "durationchange", "timeupdate"], this.update), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = function (t) {
              return e.enableInterval_(t);
            }, this.disableIntervalHandler_ = function (t) {
              return e.disableInterval_(t);
            }, this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in y.default && "visibilityState" in y.default && this.on(y.default, "visibilitychange", this.toggleVisibility_);
          }, l.toggleVisibility_ = function (e) {
            y.default.visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(e)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
          }, l.enableInterval_ = function () {
            this.updateInterval || (this.updateInterval = this.setInterval(this.update, nt));
          }, l.disableInterval_ = function (e) {
            this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== "ended" || !this.updateInterval || (this.clearInterval(this.updateInterval), this.updateInterval = null);
          }, l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: "vjs-progress-holder"
            }, {
              "aria-label": this.localize("Progress Bar")
            });
          }, l.update = function (e) {
            var t = this;

            if (y.default.visibilityState !== "hidden") {
              var S = m.prototype.update.call(this);
              return this.requestNamedAnimationFrame("SeekBar#update", function () {
                var N = t.player_.ended() ? t.player_.duration() : t.getCurrentTime_(),
                    z = t.player_.liveTracker,
                    X = t.player_.duration();
                z && z.isLive() && (X = t.player_.liveTracker.liveCurrentTime()), t.percent_ !== S && (t.el_.setAttribute("aria-valuenow", (S * 100).toFixed(2)), t.percent_ = S), (t.currentTime_ !== N || t.duration_ !== X) && (t.el_.setAttribute("aria-valuetext", t.localize("progress bar timing: currentTime={1} duration={2}", [wt(N, X), wt(X, X)], "{1} of {2}")), t.currentTime_ = N, t.duration_ = X), t.bar && t.bar.update(Pt(t.el()), t.getProgress());
              }), S;
            }
          }, l.userSeek_ = function (e) {
            this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
          }, l.getCurrentTime_ = function () {
            return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
          }, l.getPercent = function () {
            var e = this.getCurrentTime_(),
                t,
                S = this.player_.liveTracker;
            return S && S.isLive() ? (t = (e - S.seekableStart()) / S.liveWindow(), S.atLiveEdge() && (t = 1)) : t = e / this.player_.duration(), t;
          }, l.handleMouseDown = function (e) {
            !Ht(e) || (e.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.player_.pause(), m.prototype.handleMouseDown.call(this, e));
          }, l.handleMouseMove = function (e, t) {
            if (t === void 0 && (t = !1), !!Ht(e)) {
              !t && !this.player_.scrubbing() && this.player_.scrubbing(!0);
              var S,
                  N = this.calculateDistance(e),
                  z = this.player_.liveTracker;
              if (!z || !z.isLive()) S = N * this.player_.duration(), S === this.player_.duration() && (S = S - .1);else {
                if (N >= .99) {
                  z.seekToLiveEdge();
                  return;
                }

                var X = z.seekableStart(),
                    J = z.liveCurrentTime();
                if (S = X + N * z.liveWindow(), S >= J && (S = J), S <= X && (S = X + .1), S === 1 / 0) return;
              }
              this.userSeek_(S);
            }
          }, l.enable = function () {
            m.prototype.enable.call(this);
            var e = this.getChild("mouseTimeDisplay");
            !e || e.show();
          }, l.disable = function () {
            m.prototype.disable.call(this);
            var e = this.getChild("mouseTimeDisplay");
            !e || e.hide();
          }, l.handleMouseUp = function (e) {
            m.prototype.handleMouseUp.call(this, e), e && e.stopPropagation(), this.player_.scrubbing(!1), this.player_.trigger({
              type: "timeupdate",
              target: this,
              manuallyTriggered: !0
            }), this.videoWasPlaying ? ot(this.player_.play()) : this.update_();
          }, l.stepForward = function () {
            this.userSeek_(this.player_.currentTime() + cr);
          }, l.stepBack = function () {
            this.userSeek_(this.player_.currentTime() - cr);
          }, l.handleAction = function (e) {
            this.player_.paused() ? this.player_.play() : this.player_.pause();
          }, l.handleKeyDown = function (e) {
            var t = this.player_.liveTracker;
            if (i.default.isEventKey(e, "Space") || i.default.isEventKey(e, "Enter")) e.preventDefault(), e.stopPropagation(), this.handleAction(e);else if (i.default.isEventKey(e, "Home")) e.preventDefault(), e.stopPropagation(), this.userSeek_(0);else if (i.default.isEventKey(e, "End")) e.preventDefault(), e.stopPropagation(), t && t.isLive() ? this.userSeek_(t.liveCurrentTime()) : this.userSeek_(this.player_.duration());else if (/^[0-9]$/.test(i.default(e))) {
              e.preventDefault(), e.stopPropagation();
              var S = (i.default.codes[i.default(e)] - i.default.codes["0"]) * 10 / 100;
              t && t.isLive() ? this.userSeek_(t.seekableStart() + t.liveWindow() * S) : this.userSeek_(this.player_.duration() * S);
            } else i.default.isEventKey(e, "PgDn") ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() - cr * en)) : i.default.isEventKey(e, "PgUp") ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() + cr * en)) : m.prototype.handleKeyDown.call(this, e);
          }, l.dispose = function () {
            this.disableInterval_(), this.off(this.player_, ["ended", "durationchange", "timeupdate"], this.update), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in y.default && "visibilityState" in y.default && this.off(y.default, "visibilitychange", this.toggleVisibility_), m.prototype.dispose.call(this);
          }, T;
        }(zr);

        $r.prototype.options_ = {
          children: ["loadProgressBar", "playProgressBar"],
          barName: "playProgressBar"
        }, !De && !Me && $r.prototype.options_.children.splice(1, 0, "mouseTimeDisplay"), fe.registerComponent("SeekBar", $r);

        var tn = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.handleMouseMove = dt(Fe(n.default(t), t.handleMouseMove), nt), t.throttledHandleMouseSeek = dt(Fe(n.default(t), t.handleMouseSeek), nt), t.handleMouseUpHandler_ = function (S) {
              return t.handleMouseUp(S);
            }, t.handleMouseDownHandler_ = function (S) {
              return t.handleMouseDown(S);
            }, t.enable(), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: "vjs-progress-control vjs-control"
            });
          }, l.handleMouseMove = function (e) {
            var t = this.getChild("seekBar");

            if (!!t) {
              var S = t.getChild("playProgressBar"),
                  N = t.getChild("mouseTimeDisplay");

              if (!(!S && !N)) {
                var z = t.el(),
                    X = Kt(z),
                    J = Zt(z, e).x;
                J = ur(J, 0, 1), N && N.update(X, J), S && S.update(X, t.getProgress());
              }
            }
          }, l.handleMouseSeek = function (e) {
            var t = this.getChild("seekBar");
            t && t.handleMouseMove(e);
          }, l.enabled = function () {
            return this.enabled_;
          }, l.disable = function () {
            if (this.children().forEach(function (t) {
              return t.disable && t.disable();
            }), !!this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, "mousemove", this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
              var e = this.getChild("seekBar");
              this.player_.scrubbing(!1), e.videoWasPlaying && ot(this.player_.play());
            }
          }, l.enable = function () {
            this.children().forEach(function (e) {
              return e.enable && e.enable();
            }), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, "mousemove", this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
          }, l.removeListenersAddedOnMousedownAndTouchstart = function () {
            var e = this.el_.ownerDocument;
            this.off(e, "mousemove", this.throttledHandleMouseSeek), this.off(e, "touchmove", this.throttledHandleMouseSeek), this.off(e, "mouseup", this.handleMouseUpHandler_), this.off(e, "touchend", this.handleMouseUpHandler_);
          }, l.handleMouseDown = function (e) {
            var t = this.el_.ownerDocument,
                S = this.getChild("seekBar");
            S && S.handleMouseDown(e), this.on(t, "mousemove", this.throttledHandleMouseSeek), this.on(t, "touchmove", this.throttledHandleMouseSeek), this.on(t, "mouseup", this.handleMouseUpHandler_), this.on(t, "touchend", this.handleMouseUpHandler_);
          }, l.handleMouseUp = function (e) {
            var t = this.getChild("seekBar");
            t && t.handleMouseUp(e), this.removeListenersAddedOnMousedownAndTouchstart();
          }, T;
        }(fe);

        tn.prototype.options_ = {
          children: ["seekBar"]
        }, fe.registerComponent("ProgressControl", tn);

        var rn = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.on(r, ["enterpictureinpicture", "leavepictureinpicture"], function (S) {
              return t.handlePictureInPictureChange(S);
            }), t.on(r, ["disablepictureinpicturechanged", "loadedmetadata"], function (S) {
              return t.handlePictureInPictureEnabledChange(S);
            }), t.disable(), t;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-picture-in-picture-control " + m.prototype.buildCSSClass.call(this);
          }, l.handlePictureInPictureEnabledChange = function () {
            y.default.pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 ? this.enable() : this.disable();
          }, l.handlePictureInPictureChange = function (e) {
            this.player_.isInPictureInPicture() ? this.controlText("Exit Picture-in-Picture") : this.controlText("Picture-in-Picture"), this.handlePictureInPictureEnabledChange();
          }, l.handleClick = function (e) {
            this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
          }, T;
        }(at);

        rn.prototype.controlText_ = "Picture-in-Picture", fe.registerComponent("PictureInPictureToggle", rn);

        var nn = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.on(r, "fullscreenchange", function (S) {
              return t.handleFullscreenChange(S);
            }), y.default[r.fsApi_.fullscreenEnabled] === !1 && t.disable(), t;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-fullscreen-control " + m.prototype.buildCSSClass.call(this);
          }, l.handleFullscreenChange = function (e) {
            this.player_.isFullscreen() ? this.controlText("Non-Fullscreen") : this.controlText("Fullscreen");
          }, l.handleClick = function (e) {
            this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
          }, T;
        }(at);

        nn.prototype.controlText_ = "Fullscreen", fe.registerComponent("FullscreenToggle", nn);

        var ka = function (T, l) {
          l.tech_ && !l.tech_.featuresVolumeControl && T.addClass("vjs-hidden"), T.on(l, "loadstart", function () {
            l.tech_.featuresVolumeControl ? T.removeClass("vjs-hidden") : T.addClass("vjs-hidden");
          });
        },
            wa = function (m) {
          a.default(T, m);

          function T() {
            return m.apply(this, arguments) || this;
          }

          var l = T.prototype;
          return l.createEl = function () {
            var e = m.prototype.createEl.call(this, "div", {
              className: "vjs-volume-level"
            });
            return e.appendChild(m.prototype.createEl.call(this, "span", {
              className: "vjs-control-text"
            })), e;
          }, T;
        }(fe);

        fe.registerComponent("VolumeLevel", wa);

        var Fa = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.update = dt(Fe(n.default(t), t.update), nt), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: "vjs-volume-tooltip"
            }, {
              "aria-hidden": "true"
            });
          }, l.update = function (e, t, S, N) {
            if (!S) {
              var z = Pt(this.el_),
                  X = Pt(this.player_.el()),
                  J = e.width * t;
              if (!X || !z) return;
              var ie = e.left - X.left + J,
                  Q = e.width - J + (X.right - e.right),
                  de = z.width / 2;
              ie < de ? de += de - ie : Q < de && (de = Q), de < 0 ? de = 0 : de > z.width && (de = z.width), this.el_.style.right = "-" + de + "px";
            }

            this.write(N + "%");
          }, l.write = function (e) {
            ut(this.el_, e);
          }, l.updateVolume = function (e, t, S, N, z) {
            var X = this;
            this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", function () {
              X.update(e, t, S, N.toFixed(0)), z && z();
            });
          }, T;
        }(fe);

        fe.registerComponent("VolumeLevelTooltip", Fa);

        var an = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.update = dt(Fe(n.default(t), t.update), nt), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: "vjs-mouse-display"
            });
          }, l.update = function (e, t, S) {
            var N = this,
                z = 100 * t;
            this.getChild("volumeLevelTooltip").updateVolume(e, t, S, z, function () {
              S ? N.el_.style.bottom = e.height * t + "px" : N.el_.style.left = e.width * t + "px";
            });
          }, T;
        }(fe);

        an.prototype.options_ = {
          children: ["volumeLevelTooltip"]
        }, fe.registerComponent("MouseVolumeLevelDisplay", an);

        var dr = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.on("slideractive", function (S) {
              return t.updateLastVolume_(S);
            }), t.on(r, "volumechange", function (S) {
              return t.updateARIAAttributes(S);
            }), r.ready(function () {
              return t.updateARIAAttributes();
            }), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: "vjs-volume-bar vjs-slider-bar"
            }, {
              "aria-label": this.localize("Volume Level"),
              "aria-live": "polite"
            });
          }, l.handleMouseDown = function (e) {
            !Ht(e) || m.prototype.handleMouseDown.call(this, e);
          }, l.handleMouseMove = function (e) {
            var t = this.getChild("mouseVolumeLevelDisplay");

            if (t) {
              var S = this.el(),
                  N = Pt(S),
                  z = this.vertical(),
                  X = Zt(S, e);
              X = z ? X.y : X.x, X = ur(X, 0, 1), t.update(N, X, z);
            }

            !Ht(e) || (this.checkMuted(), this.player_.volume(this.calculateDistance(e)));
          }, l.checkMuted = function () {
            this.player_.muted() && this.player_.muted(!1);
          }, l.getPercent = function () {
            return this.player_.muted() ? 0 : this.player_.volume();
          }, l.stepForward = function () {
            this.checkMuted(), this.player_.volume(this.player_.volume() + .1);
          }, l.stepBack = function () {
            this.checkMuted(), this.player_.volume(this.player_.volume() - .1);
          }, l.updateARIAAttributes = function (e) {
            var t = this.player_.muted() ? 0 : this.volumeAsPercentage_();
            this.el_.setAttribute("aria-valuenow", t), this.el_.setAttribute("aria-valuetext", t + "%");
          }, l.volumeAsPercentage_ = function () {
            return Math.round(this.player_.volume() * 100);
          }, l.updateLastVolume_ = function () {
            var e = this,
                t = this.player_.volume();
            this.one("sliderinactive", function () {
              e.player_.volume() === 0 && e.player_.lastVolume_(t);
            });
          }, T;
        }(zr);

        dr.prototype.options_ = {
          children: ["volumeLevel"],
          barName: "volumeLevel"
        }, !De && !Me && dr.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay"), dr.prototype.playerEvent = "volumechange", fe.registerComponent("VolumeBar", dr);

        var sn = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return e === void 0 && (e = {}), e.vertical = e.vertical || !1, (typeof e.volumeBar == "undefined" || pe(e.volumeBar)) && (e.volumeBar = e.volumeBar || {}, e.volumeBar.vertical = e.vertical), t = m.call(this, r, e) || this, ka(n.default(t), r), t.throttledHandleMouseMove = dt(Fe(n.default(t), t.handleMouseMove), nt), t.handleMouseUpHandler_ = function (S) {
              return t.handleMouseUp(S);
            }, t.on("mousedown", function (S) {
              return t.handleMouseDown(S);
            }), t.on("touchstart", function (S) {
              return t.handleMouseDown(S);
            }), t.on("mousemove", function (S) {
              return t.handleMouseMove(S);
            }), t.on(t.volumeBar, ["focus", "slideractive"], function () {
              t.volumeBar.addClass("vjs-slider-active"), t.addClass("vjs-slider-active"), t.trigger("slideractive");
            }), t.on(t.volumeBar, ["blur", "sliderinactive"], function () {
              t.volumeBar.removeClass("vjs-slider-active"), t.removeClass("vjs-slider-active"), t.trigger("sliderinactive");
            }), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            var e = "vjs-volume-horizontal";
            return this.options_.vertical && (e = "vjs-volume-vertical"), m.prototype.createEl.call(this, "div", {
              className: "vjs-volume-control vjs-control " + e
            });
          }, l.handleMouseDown = function (e) {
            var t = this.el_.ownerDocument;
            this.on(t, "mousemove", this.throttledHandleMouseMove), this.on(t, "touchmove", this.throttledHandleMouseMove), this.on(t, "mouseup", this.handleMouseUpHandler_), this.on(t, "touchend", this.handleMouseUpHandler_);
          }, l.handleMouseUp = function (e) {
            var t = this.el_.ownerDocument;
            this.off(t, "mousemove", this.throttledHandleMouseMove), this.off(t, "touchmove", this.throttledHandleMouseMove), this.off(t, "mouseup", this.handleMouseUpHandler_), this.off(t, "touchend", this.handleMouseUpHandler_);
          }, l.handleMouseMove = function (e) {
            this.volumeBar.handleMouseMove(e);
          }, T;
        }(fe);

        sn.prototype.options_ = {
          children: ["volumeBar"]
        }, fe.registerComponent("VolumeControl", sn);

        var Ba = function (T, l) {
          l.tech_ && !l.tech_.featuresMuteControl && T.addClass("vjs-hidden"), T.on(l, "loadstart", function () {
            l.tech_.featuresMuteControl ? T.removeClass("vjs-hidden") : T.addClass("vjs-hidden");
          });
        },
            on = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, Ba(n.default(t), r), t.on(r, ["loadstart", "volumechange"], function (S) {
              return t.update(S);
            }), t;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-mute-control " + m.prototype.buildCSSClass.call(this);
          }, l.handleClick = function (e) {
            var t = this.player_.volume(),
                S = this.player_.lastVolume_();

            if (t === 0) {
              var N = S < .1 ? .1 : S;
              this.player_.volume(N), this.player_.muted(!1);
            } else this.player_.muted(!this.player_.muted());
          }, l.update = function (e) {
            this.updateIcon_(), this.updateControlText_();
          }, l.updateIcon_ = function () {
            var e = this.player_.volume(),
                t = 3;
            De && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), e === 0 || this.player_.muted() ? t = 0 : e < .33 ? t = 1 : e < .67 && (t = 2);

            for (var S = 0; S < 4; S++) _t(this.el_, "vjs-vol-" + S);

            et(this.el_, "vjs-vol-" + t);
          }, l.updateControlText_ = function () {
            var e = this.player_.muted() || this.player_.volume() === 0,
                t = e ? "Unmute" : "Mute";
            this.controlText() !== t && this.controlText(t);
          }, T;
        }(at);

        on.prototype.controlText_ = "Mute", fe.registerComponent("MuteToggle", on);

        var ln = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return e === void 0 && (e = {}), typeof e.inline != "undefined" ? e.inline = e.inline : e.inline = !0, (typeof e.volumeControl == "undefined" || pe(e.volumeControl)) && (e.volumeControl = e.volumeControl || {}, e.volumeControl.vertical = !e.inline), t = m.call(this, r, e) || this, t.handleKeyPressHandler_ = function (S) {
              return t.handleKeyPress(S);
            }, t.on(r, ["loadstart"], function (S) {
              return t.volumePanelState_(S);
            }), t.on(t.muteToggle, "keyup", function (S) {
              return t.handleKeyPress(S);
            }), t.on(t.volumeControl, "keyup", function (S) {
              return t.handleVolumeControlKeyUp(S);
            }), t.on("keydown", function (S) {
              return t.handleKeyPress(S);
            }), t.on("mouseover", function (S) {
              return t.handleMouseOver(S);
            }), t.on("mouseout", function (S) {
              return t.handleMouseOut(S);
            }), t.on(t.volumeControl, ["slideractive"], t.sliderActive_), t.on(t.volumeControl, ["sliderinactive"], t.sliderInactive_), t;
          }

          var l = T.prototype;
          return l.sliderActive_ = function () {
            this.addClass("vjs-slider-active");
          }, l.sliderInactive_ = function () {
            this.removeClass("vjs-slider-active");
          }, l.volumePanelState_ = function () {
            this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
          }, l.createEl = function () {
            var e = "vjs-volume-panel-horizontal";
            return this.options_.inline || (e = "vjs-volume-panel-vertical"), m.prototype.createEl.call(this, "div", {
              className: "vjs-volume-panel vjs-control " + e
            });
          }, l.dispose = function () {
            this.handleMouseOut(), m.prototype.dispose.call(this);
          }, l.handleVolumeControlKeyUp = function (e) {
            i.default.isEventKey(e, "Esc") && this.muteToggle.focus();
          }, l.handleMouseOver = function (e) {
            this.addClass("vjs-hover"), qe(y.default, "keyup", this.handleKeyPressHandler_);
          }, l.handleMouseOut = function (e) {
            this.removeClass("vjs-hover"), Ve(y.default, "keyup", this.handleKeyPressHandler_);
          }, l.handleKeyPress = function (e) {
            i.default.isEventKey(e, "Esc") && this.handleMouseOut();
          }, T;
        }(fe);

        ln.prototype.options_ = {
          children: ["muteToggle", "volumeControl"]
        }, fe.registerComponent("VolumePanel", ln);

        var un = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, e && (t.menuButton_ = e.menuButton), t.focusedChild_ = -1, t.on("keydown", function (S) {
              return t.handleKeyDown(S);
            }), t.boundHandleBlur_ = function (S) {
              return t.handleBlur(S);
            }, t.boundHandleTapClick_ = function (S) {
              return t.handleTapClick(S);
            }, t;
          }

          var l = T.prototype;
          return l.addEventListenerForItem = function (e) {
            e instanceof fe && (this.on(e, "blur", this.boundHandleBlur_), this.on(e, ["tap", "click"], this.boundHandleTapClick_));
          }, l.removeEventListenerForItem = function (e) {
            e instanceof fe && (this.off(e, "blur", this.boundHandleBlur_), this.off(e, ["tap", "click"], this.boundHandleTapClick_));
          }, l.removeChild = function (e) {
            typeof e == "string" && (e = this.getChild(e)), this.removeEventListenerForItem(e), m.prototype.removeChild.call(this, e);
          }, l.addItem = function (e) {
            var t = this.addChild(e);
            t && this.addEventListenerForItem(t);
          }, l.createEl = function () {
            var e = this.options_.contentElType || "ul";
            this.contentEl_ = Pe(e, {
              className: "vjs-menu-content"
            }), this.contentEl_.setAttribute("role", "menu");
            var t = m.prototype.createEl.call(this, "div", {
              append: this.contentEl_,
              className: "vjs-menu"
            });
            return t.appendChild(this.contentEl_), qe(t, "click", function (S) {
              S.preventDefault(), S.stopImmediatePropagation();
            }), t;
          }, l.dispose = function () {
            this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, m.prototype.dispose.call(this);
          }, l.handleBlur = function (e) {
            var t = e.relatedTarget || y.default.activeElement;

            if (!this.children().some(function (N) {
              return N.el() === t;
            })) {
              var S = this.menuButton_;
              S && S.buttonPressed_ && t !== S.el().firstChild && S.unpressButton();
            }
          }, l.handleTapClick = function (e) {
            if (this.menuButton_) {
              this.menuButton_.unpressButton();
              var t = this.children();
              if (!Array.isArray(t)) return;
              var S = t.filter(function (N) {
                return N.el() === e.target;
              })[0];
              if (!S) return;
              S.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
            }
          }, l.handleKeyDown = function (e) {
            i.default.isEventKey(e, "Left") || i.default.isEventKey(e, "Down") ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : (i.default.isEventKey(e, "Right") || i.default.isEventKey(e, "Up")) && (e.preventDefault(), e.stopPropagation(), this.stepBack());
          }, l.stepForward = function () {
            var e = 0;
            this.focusedChild_ !== void 0 && (e = this.focusedChild_ + 1), this.focus(e);
          }, l.stepBack = function () {
            var e = 0;
            this.focusedChild_ !== void 0 && (e = this.focusedChild_ - 1), this.focus(e);
          }, l.focus = function (e) {
            e === void 0 && (e = 0);
            var t = this.children().slice(),
                S = t.length && t[0].hasClass("vjs-menu-title");
            S && t.shift(), t.length > 0 && (e < 0 ? e = 0 : e >= t.length && (e = t.length - 1), this.focusedChild_ = e, t[e].el_.focus());
          }, T;
        }(fe);

        fe.registerComponent("Menu", un);

        var Qr = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            e === void 0 && (e = {}), t = m.call(this, r, e) || this, t.menuButton_ = new at(r, e), t.menuButton_.controlText(t.controlText_), t.menuButton_.el_.setAttribute("aria-haspopup", "true");
            var S = at.prototype.buildCSSClass();
            t.menuButton_.el_.className = t.buildCSSClass() + " " + S, t.menuButton_.removeClass("vjs-control"), t.addChild(t.menuButton_), t.update(), t.enabled_ = !0;

            var N = function (X) {
              return t.handleClick(X);
            };

            return t.handleMenuKeyUp_ = function (z) {
              return t.handleMenuKeyUp(z);
            }, t.on(t.menuButton_, "tap", N), t.on(t.menuButton_, "click", N), t.on(t.menuButton_, "keydown", function (z) {
              return t.handleKeyDown(z);
            }), t.on(t.menuButton_, "mouseenter", function () {
              t.addClass("vjs-hover"), t.menu.show(), qe(y.default, "keyup", t.handleMenuKeyUp_);
            }), t.on("mouseleave", function (z) {
              return t.handleMouseLeave(z);
            }), t.on("keydown", function (z) {
              return t.handleSubmenuKeyDown(z);
            }), t;
          }

          var l = T.prototype;
          return l.update = function () {
            var e = this.createMenu();
            this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = e, this.addChild(e), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? this.hide() : this.show();
          }, l.createMenu = function () {
            var e = new un(this.player_, {
              menuButton: this
            });

            if (this.hideThreshold_ = 0, this.options_.title) {
              var t = Pe("li", {
                className: "vjs-menu-title",
                textContent: Ke(this.options_.title),
                tabIndex: -1
              }),
                  S = new fe(this.player_, {
                el: t
              });
              e.addItem(S);
            }

            if (this.items = this.createItems(), this.items) for (var N = 0; N < this.items.length; N++) e.addItem(this.items[N]);
            return e;
          }, l.createItems = function () {}, l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: this.buildWrapperCSSClass()
            }, {});
          }, l.buildWrapperCSSClass = function () {
            var e = "vjs-menu-button";
            this.options_.inline === !0 ? e += "-inline" : e += "-popup";
            var t = at.prototype.buildCSSClass();
            return "vjs-menu-button " + e + " " + t + " " + m.prototype.buildCSSClass.call(this);
          }, l.buildCSSClass = function () {
            var e = "vjs-menu-button";
            return this.options_.inline === !0 ? e += "-inline" : e += "-popup", "vjs-menu-button " + e + " " + m.prototype.buildCSSClass.call(this);
          }, l.controlText = function (e, t) {
            return t === void 0 && (t = this.menuButton_.el()), this.menuButton_.controlText(e, t);
          }, l.dispose = function () {
            this.handleMouseLeave(), m.prototype.dispose.call(this);
          }, l.handleClick = function (e) {
            this.buttonPressed_ ? this.unpressButton() : this.pressButton();
          }, l.handleMouseLeave = function (e) {
            this.removeClass("vjs-hover"), Ve(y.default, "keyup", this.handleMenuKeyUp_);
          }, l.focus = function () {
            this.menuButton_.focus();
          }, l.blur = function () {
            this.menuButton_.blur();
          }, l.handleKeyDown = function (e) {
            i.default.isEventKey(e, "Esc") || i.default.isEventKey(e, "Tab") ? (this.buttonPressed_ && this.unpressButton(), i.default.isEventKey(e, "Tab") || (e.preventDefault(), this.menuButton_.focus())) : (i.default.isEventKey(e, "Up") || i.default.isEventKey(e, "Down")) && (this.buttonPressed_ || (e.preventDefault(), this.pressButton()));
          }, l.handleMenuKeyUp = function (e) {
            (i.default.isEventKey(e, "Esc") || i.default.isEventKey(e, "Tab")) && this.removeClass("vjs-hover");
          }, l.handleSubmenuKeyPress = function (e) {
            this.handleSubmenuKeyDown(e);
          }, l.handleSubmenuKeyDown = function (e) {
            (i.default.isEventKey(e, "Esc") || i.default.isEventKey(e, "Tab")) && (this.buttonPressed_ && this.unpressButton(), i.default.isEventKey(e, "Tab") || (e.preventDefault(), this.menuButton_.focus()));
          }, l.pressButton = function () {
            if (this.enabled_) {
              if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), De && st()) return;
              this.menu.focus();
            }
          }, l.unpressButton = function () {
            this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
          }, l.disable = function () {
            this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
          }, l.enable = function () {
            this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
          }, T;
        }(fe);

        fe.registerComponent("MenuButton", Qr);

        var Jr = function (m) {
          a.default(T, m);

          function T(l, r) {
            var e,
                t = r.tracks;
            if (e = m.call(this, l, r) || this, e.items.length <= 1 && e.hide(), !t) return n.default(e);
            var S = Fe(n.default(e), e.update);
            return t.addEventListener("removetrack", S), t.addEventListener("addtrack", S), t.addEventListener("labelchange", S), e.player_.on("ready", S), e.player_.on("dispose", function () {
              t.removeEventListener("removetrack", S), t.removeEventListener("addtrack", S), t.removeEventListener("labelchange", S);
            }), e;
          }

          return T;
        }(Qr);

        fe.registerComponent("TrackButton", Jr);

        var Na = ["Tab", "Esc", "Up", "Down", "Right", "Left"],
            zt = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.selectable = e.selectable, t.isSelected_ = e.selected || !1, t.multiSelectable = e.multiSelectable, t.selected(t.isSelected_), t.selectable ? t.multiSelectable ? t.el_.setAttribute("role", "menuitemcheckbox") : t.el_.setAttribute("role", "menuitemradio") : t.el_.setAttribute("role", "menuitem"), t;
          }

          var l = T.prototype;
          return l.createEl = function (e, t, S) {
            this.nonIconControl = !0;
            var N = m.prototype.createEl.call(this, "li", he({
              className: "vjs-menu-item",
              tabIndex: -1
            }, t), S);
            return N.replaceChild(Pe("span", {
              className: "vjs-menu-item-text",
              textContent: this.localize(this.options_.label)
            }), N.querySelector(".vjs-icon-placeholder")), N;
          }, l.handleKeyDown = function (e) {
            Na.some(function (t) {
              return i.default.isEventKey(e, t);
            }) || m.prototype.handleKeyDown.call(this, e);
          }, l.handleClick = function (e) {
            this.selected(!0);
          }, l.selected = function (e) {
            this.selectable && (e ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
          }, T;
        }(lr);

        fe.registerComponent("MenuItem", zt);

        var Xt = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t,
                S = e.track,
                N = r.textTracks();
            e.label = S.label || S.language || "Unknown", e.selected = S.mode === "showing", t = m.call(this, r, e) || this, t.track = S, t.kinds = (e.kinds || [e.kind || t.track.kind]).filter(Boolean);

            var z = function () {
              for (var Q = arguments.length, de = new Array(Q), Te = 0; Te < Q; Te++) de[Te] = arguments[Te];

              t.handleTracksChange.apply(n.default(t), de);
            },
                X = function () {
              for (var Q = arguments.length, de = new Array(Q), Te = 0; Te < Q; Te++) de[Te] = arguments[Te];

              t.handleSelectedLanguageChange.apply(n.default(t), de);
            };

            if (r.on(["loadstart", "texttrackchange"], z), N.addEventListener("change", z), N.addEventListener("selectedlanguagechange", X), t.on("dispose", function () {
              r.off(["loadstart", "texttrackchange"], z), N.removeEventListener("change", z), N.removeEventListener("selectedlanguagechange", X);
            }), N.onchange === void 0) {
              var J;
              t.on(["tap", "click"], function () {
                if (typeof f.default.Event != "object") try {
                  J = new f.default.Event("change");
                } catch (ie) {}
                J || (J = y.default.createEvent("Event"), J.initEvent("change", !0, !0)), N.dispatchEvent(J);
              });
            }

            return t.handleTracksChange(), t;
          }

          var l = T.prototype;
          return l.handleClick = function (e) {
            var t = this.track,
                S = this.player_.textTracks();
            if (m.prototype.handleClick.call(this, e), !!S) for (var N = 0; N < S.length; N++) {
              var z = S[N];
              this.kinds.indexOf(z.kind) !== -1 && (z === t ? z.mode !== "showing" && (z.mode = "showing") : z.mode !== "disabled" && (z.mode = "disabled"));
            }
          }, l.handleTracksChange = function (e) {
            var t = this.track.mode === "showing";
            t !== this.isSelected_ && this.selected(t);
          }, l.handleSelectedLanguageChange = function (e) {
            if (this.track.mode === "showing") {
              var t = this.player_.cache_.selectedLanguage;
              if (t && t.enabled && t.language === this.track.language && t.kind !== this.track.kind) return;
              this.player_.cache_.selectedLanguage = {
                enabled: !0,
                language: this.track.language,
                kind: this.track.kind
              };
            }
          }, l.dispose = function () {
            this.track = null, m.prototype.dispose.call(this);
          }, T;
        }(zt);

        fe.registerComponent("TextTrackMenuItem", Xt);

        var cn = function (m) {
          a.default(T, m);

          function T(r, e) {
            return e.track = {
              player: r,
              kind: e.kind,
              kinds: e.kinds,
              default: !1,
              mode: "disabled"
            }, e.kinds || (e.kinds = [e.kind]), e.label ? e.track.label = e.label : e.track.label = e.kinds.join(" and ") + " off", e.selectable = !0, e.multiSelectable = !1, m.call(this, r, e) || this;
          }

          var l = T.prototype;
          return l.handleTracksChange = function (e) {
            for (var t = this.player().textTracks(), S = !0, N = 0, z = t.length; N < z; N++) {
              var X = t[N];

              if (this.options_.kinds.indexOf(X.kind) > -1 && X.mode === "showing") {
                S = !1;
                break;
              }
            }

            S !== this.isSelected_ && this.selected(S);
          }, l.handleSelectedLanguageChange = function (e) {
            for (var t = this.player().textTracks(), S = !0, N = 0, z = t.length; N < z; N++) {
              var X = t[N];

              if (["captions", "descriptions", "subtitles"].indexOf(X.kind) > -1 && X.mode === "showing") {
                S = !1;
                break;
              }
            }

            S && (this.player_.cache_.selectedLanguage = {
              enabled: !1
            });
          }, T;
        }(Xt);

        fe.registerComponent("OffTextTrackMenuItem", cn);

        var Bt = function (m) {
          a.default(T, m);

          function T(r, e) {
            return e === void 0 && (e = {}), e.tracks = r.textTracks(), m.call(this, r, e) || this;
          }

          var l = T.prototype;
          return l.createItems = function (e, t) {
            e === void 0 && (e = []), t === void 0 && (t = Xt);
            var S;
            this.label_ && (S = this.label_ + " off"), e.push(new cn(this.player_, {
              kinds: this.kinds_,
              kind: this.kind_,
              label: S
            })), this.hideThreshold_ += 1;
            var N = this.player_.textTracks();
            Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);

            for (var z = 0; z < N.length; z++) {
              var X = N[z];

              if (this.kinds_.indexOf(X.kind) > -1) {
                var J = new t(this.player_, {
                  track: X,
                  kinds: this.kinds_,
                  kind: this.kind_,
                  selectable: !0,
                  multiSelectable: !1
                });
                J.addClass("vjs-" + X.kind + "-menu-item"), e.push(J);
              }
            }

            return e;
          }, T;
        }(Jr);

        fe.registerComponent("TextTrackButton", Bt);

        var dn = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t,
                S = e.track,
                N = e.cue,
                z = r.currentTime();
            return e.selectable = !0, e.multiSelectable = !1, e.label = N.text, e.selected = N.startTime <= z && z < N.endTime, t = m.call(this, r, e) || this, t.track = S, t.cue = N, S.addEventListener("cuechange", Fe(n.default(t), t.update)), t;
          }

          var l = T.prototype;
          return l.handleClick = function (e) {
            m.prototype.handleClick.call(this), this.player_.currentTime(this.cue.startTime), this.update(this.cue.startTime);
          }, l.update = function (e) {
            var t = this.cue,
                S = this.player_.currentTime();
            this.selected(t.startTime <= S && S < t.endTime);
          }, T;
        }(zt);

        fe.registerComponent("ChaptersTrackMenuItem", dn);

        var Zr = function (m) {
          a.default(T, m);

          function T(r, e, t) {
            return m.call(this, r, e, t) || this;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-chapters-button " + m.prototype.buildCSSClass.call(this);
          }, l.buildWrapperCSSClass = function () {
            return "vjs-chapters-button " + m.prototype.buildWrapperCSSClass.call(this);
          }, l.update = function (e) {
            (!this.track_ || e && (e.type === "addtrack" || e.type === "removetrack")) && this.setTrack(this.findChaptersTrack()), m.prototype.update.call(this);
          }, l.setTrack = function (e) {
            if (this.track_ !== e) {
              if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
                var t = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
                t && t.removeEventListener("load", this.updateHandler_), this.track_ = null;
              }

              if (this.track_ = e, this.track_) {
                this.track_.mode = "hidden";
                var S = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
                S && S.addEventListener("load", this.updateHandler_);
              }
            }
          }, l.findChaptersTrack = function () {
            for (var e = this.player_.textTracks() || [], t = e.length - 1; t >= 0; t--) {
              var S = e[t];
              if (S.kind === this.kind_) return S;
            }
          }, l.getMenuCaption = function () {
            return this.track_ && this.track_.label ? this.track_.label : this.localize(Ke(this.kind_));
          }, l.createMenu = function () {
            return this.options_.title = this.getMenuCaption(), m.prototype.createMenu.call(this);
          }, l.createItems = function () {
            var e = [];
            if (!this.track_) return e;
            var t = this.track_.cues;
            if (!t) return e;

            for (var S = 0, N = t.length; S < N; S++) {
              var z = t[S],
                  X = new dn(this.player_, {
                track: this.track_,
                cue: z
              });
              e.push(X);
            }

            return e;
          }, T;
        }(Bt);

        Zr.prototype.kind_ = "chapters", Zr.prototype.controlText_ = "Chapters", fe.registerComponent("ChaptersButton", Zr);

        var qr = function (m) {
          a.default(T, m);

          function T(r, e, t) {
            var S;
            S = m.call(this, r, e, t) || this;
            var N = r.textTracks(),
                z = Fe(n.default(S), S.handleTracksChange);
            return N.addEventListener("change", z), S.on("dispose", function () {
              N.removeEventListener("change", z);
            }), S;
          }

          var l = T.prototype;
          return l.handleTracksChange = function (e) {
            for (var t = this.player().textTracks(), S = !1, N = 0, z = t.length; N < z; N++) {
              var X = t[N];

              if (X.kind !== this.kind_ && X.mode === "showing") {
                S = !0;
                break;
              }
            }

            S ? this.disable() : this.enable();
          }, l.buildCSSClass = function () {
            return "vjs-descriptions-button " + m.prototype.buildCSSClass.call(this);
          }, l.buildWrapperCSSClass = function () {
            return "vjs-descriptions-button " + m.prototype.buildWrapperCSSClass.call(this);
          }, T;
        }(Bt);

        qr.prototype.kind_ = "descriptions", qr.prototype.controlText_ = "Descriptions", fe.registerComponent("DescriptionsButton", qr);

        var ei = function (m) {
          a.default(T, m);

          function T(r, e, t) {
            return m.call(this, r, e, t) || this;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-subtitles-button " + m.prototype.buildCSSClass.call(this);
          }, l.buildWrapperCSSClass = function () {
            return "vjs-subtitles-button " + m.prototype.buildWrapperCSSClass.call(this);
          }, T;
        }(Bt);

        ei.prototype.kind_ = "subtitles", ei.prototype.controlText_ = "Subtitles", fe.registerComponent("SubtitlesButton", ei);

        var ti = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return e.track = {
              player: r,
              kind: e.kind,
              label: e.kind + " settings",
              selectable: !1,
              default: !1,
              mode: "disabled"
            }, e.selectable = !1, e.name = "CaptionSettingsMenuItem", t = m.call(this, r, e) || this, t.addClass("vjs-texttrack-settings"), t.controlText(", opens " + e.kind + " settings dialog"), t;
          }

          var l = T.prototype;
          return l.handleClick = function (e) {
            this.player().getChild("textTrackSettings").open();
          }, T;
        }(Xt);

        fe.registerComponent("CaptionSettingsMenuItem", ti);

        var ri = function (m) {
          a.default(T, m);

          function T(r, e, t) {
            return m.call(this, r, e, t) || this;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-captions-button " + m.prototype.buildCSSClass.call(this);
          }, l.buildWrapperCSSClass = function () {
            return "vjs-captions-button " + m.prototype.buildWrapperCSSClass.call(this);
          }, l.createItems = function () {
            var e = [];
            return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new ti(this.player_, {
              kind: this.kind_
            })), this.hideThreshold_ += 1), m.prototype.createItems.call(this, e);
          }, T;
        }(Bt);

        ri.prototype.kind_ = "captions", ri.prototype.controlText_ = "Captions", fe.registerComponent("CaptionsButton", ri);

        var fn = function (m) {
          a.default(T, m);

          function T() {
            return m.apply(this, arguments) || this;
          }

          var l = T.prototype;
          return l.createEl = function (e, t, S) {
            var N = m.prototype.createEl.call(this, e, t, S),
                z = N.querySelector(".vjs-menu-item-text");
            return this.options_.track.kind === "captions" && (z.appendChild(Pe("span", {
              className: "vjs-icon-placeholder"
            }, {
              "aria-hidden": !0
            })), z.appendChild(Pe("span", {
              className: "vjs-control-text",
              textContent: " " + this.localize("Captions")
            }))), N;
          }, T;
        }(Xt);

        fe.registerComponent("SubsCapsMenuItem", fn);

        var ii = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return e === void 0 && (e = {}), t = m.call(this, r, e) || this, t.label_ = "subtitles", ["en", "en-us", "en-ca", "fr-ca"].indexOf(t.player_.language_) > -1 && (t.label_ = "captions"), t.menuButton_.controlText(Ke(t.label_)), t;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-subs-caps-button " + m.prototype.buildCSSClass.call(this);
          }, l.buildWrapperCSSClass = function () {
            return "vjs-subs-caps-button " + m.prototype.buildWrapperCSSClass.call(this);
          }, l.createItems = function () {
            var e = [];
            return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new ti(this.player_, {
              kind: this.label_
            })), this.hideThreshold_ += 1), e = m.prototype.createItems.call(this, e, fn), e;
          }, T;
        }(Bt);

        ii.prototype.kinds_ = ["captions", "subtitles"], ii.prototype.controlText_ = "Subtitles", fe.registerComponent("SubsCapsButton", ii);

        var hn = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t,
                S = e.track,
                N = r.audioTracks();
            e.label = S.label || S.language || "Unknown", e.selected = S.enabled, t = m.call(this, r, e) || this, t.track = S, t.addClass("vjs-" + S.kind + "-menu-item");

            var z = function () {
              for (var J = arguments.length, ie = new Array(J), Q = 0; Q < J; Q++) ie[Q] = arguments[Q];

              t.handleTracksChange.apply(n.default(t), ie);
            };

            return N.addEventListener("change", z), t.on("dispose", function () {
              N.removeEventListener("change", z);
            }), t;
          }

          var l = T.prototype;
          return l.createEl = function (e, t, S) {
            var N = m.prototype.createEl.call(this, e, t, S),
                z = N.querySelector(".vjs-menu-item-text");
            return this.options_.track.kind === "main-desc" && (z.appendChild(Pe("span", {
              className: "vjs-icon-placeholder"
            }, {
              "aria-hidden": !0
            })), z.appendChild(Pe("span", {
              className: "vjs-control-text",
              textContent: " " + this.localize("Descriptions")
            }))), N;
          }, l.handleClick = function (e) {
            if (m.prototype.handleClick.call(this, e), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks) for (var t = this.player_.audioTracks(), S = 0; S < t.length; S++) {
              var N = t[S];
              N !== this.track && (N.enabled = N === this.track);
            }
          }, l.handleTracksChange = function (e) {
            this.selected(this.track.enabled);
          }, T;
        }(zt);

        fe.registerComponent("AudioTrackMenuItem", hn);

        var vn = function (m) {
          a.default(T, m);

          function T(r, e) {
            return e === void 0 && (e = {}), e.tracks = r.audioTracks(), m.call(this, r, e) || this;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-audio-button " + m.prototype.buildCSSClass.call(this);
          }, l.buildWrapperCSSClass = function () {
            return "vjs-audio-button " + m.prototype.buildWrapperCSSClass.call(this);
          }, l.createItems = function (e) {
            e === void 0 && (e = []), this.hideThreshold_ = 1;

            for (var t = this.player_.audioTracks(), S = 0; S < t.length; S++) {
              var N = t[S];
              e.push(new hn(this.player_, {
                track: N,
                selectable: !0,
                multiSelectable: !1
              }));
            }

            return e;
          }, T;
        }(Jr);

        vn.prototype.controlText_ = "Audio Track", fe.registerComponent("AudioTrackButton", vn);

        var ni = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t,
                S = e.rate,
                N = parseFloat(S, 10);
            return e.label = S, e.selected = N === r.playbackRate(), e.selectable = !0, e.multiSelectable = !1, t = m.call(this, r, e) || this, t.label = S, t.rate = N, t.on(r, "ratechange", function (z) {
              return t.update(z);
            }), t;
          }

          var l = T.prototype;
          return l.handleClick = function (e) {
            m.prototype.handleClick.call(this), this.player().playbackRate(this.rate);
          }, l.update = function (e) {
            this.selected(this.player().playbackRate() === this.rate);
          }, T;
        }(zt);

        ni.prototype.contentElType = "button", fe.registerComponent("PlaybackRateMenuItem", ni);

        var pn = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.menuButton_.el_.setAttribute("aria-describedby", t.labelElId_), t.updateVisibility(), t.updateLabel(), t.on(r, "loadstart", function (S) {
              return t.updateVisibility(S);
            }), t.on(r, "ratechange", function (S) {
              return t.updateLabel(S);
            }), t.on(r, "playbackrateschange", function (S) {
              return t.handlePlaybackRateschange(S);
            }), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            var e = m.prototype.createEl.call(this);
            return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = Pe("div", {
              className: "vjs-playback-rate-value",
              id: this.labelElId_,
              textContent: "1x"
            }), e.appendChild(this.labelEl_), e;
          }, l.dispose = function () {
            this.labelEl_ = null, m.prototype.dispose.call(this);
          }, l.buildCSSClass = function () {
            return "vjs-playback-rate " + m.prototype.buildCSSClass.call(this);
          }, l.buildWrapperCSSClass = function () {
            return "vjs-playback-rate " + m.prototype.buildWrapperCSSClass.call(this);
          }, l.createItems = function () {
            for (var e = this.playbackRates(), t = [], S = e.length - 1; S >= 0; S--) t.push(new ni(this.player(), {
              rate: e[S] + "x"
            }));

            return t;
          }, l.updateARIAAttributes = function () {
            this.el().setAttribute("aria-valuenow", this.player().playbackRate());
          }, l.handleClick = function (e) {
            var t = this.player().playbackRate(),
                S = this.playbackRates(),
                N = S.indexOf(t),
                z = (N + 1) % S.length;
            this.player().playbackRate(S[z]);
          }, l.handlePlaybackRateschange = function (e) {
            this.update();
          }, l.playbackRates = function () {
            var e = this.player();
            return e.playbackRates && e.playbackRates() || [];
          }, l.playbackRateSupported = function () {
            return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
          }, l.updateVisibility = function (e) {
            this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
          }, l.updateLabel = function (e) {
            this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
          }, T;
        }(Qr);

        pn.prototype.controlText_ = "Playback Rate", fe.registerComponent("PlaybackRateMenuButton", pn);

        var gn = function (m) {
          a.default(T, m);

          function T() {
            return m.apply(this, arguments) || this;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-spacer " + m.prototype.buildCSSClass.call(this);
          }, l.createEl = function (e, t, S) {
            return e === void 0 && (e = "div"), t === void 0 && (t = {}), S === void 0 && (S = {}), t.className || (t.className = this.buildCSSClass()), m.prototype.createEl.call(this, e, t, S);
          }, T;
        }(fe);

        fe.registerComponent("Spacer", gn);

        var Ua = function (m) {
          a.default(T, m);

          function T() {
            return m.apply(this, arguments) || this;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-custom-control-spacer " + m.prototype.buildCSSClass.call(this);
          }, l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: this.buildCSSClass(),
              textContent: "\xA0"
            });
          }, T;
        }(gn);

        fe.registerComponent("CustomControlSpacer", Ua);

        var fr = function (m) {
          a.default(T, m);

          function T() {
            return m.apply(this, arguments) || this;
          }

          var l = T.prototype;
          return l.createEl = function () {
            return m.prototype.createEl.call(this, "div", {
              className: "vjs-control-bar",
              dir: "ltr"
            });
          }, T;
        }(fe);

        fr.prototype.options_ = {
          children: ["playToggle", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "fullscreenToggle"]
        }, "exitPictureInPicture" in y.default && fr.prototype.options_.children.splice(fr.prototype.options_.children.length - 1, 0, "pictureInPictureToggle"), fe.registerComponent("ControlBar", fr);

        var mn = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return t = m.call(this, r, e) || this, t.on(r, "error", function (S) {
              return t.open(S);
            }), t;
          }

          var l = T.prototype;
          return l.buildCSSClass = function () {
            return "vjs-error-display " + m.prototype.buildCSSClass.call(this);
          }, l.content = function () {
            var e = this.player().error();
            return e ? this.localize(e.message) : "";
          }, T;
        }(Rt);

        mn.prototype.options_ = u.default({}, Rt.prototype.options_, {
          pauseOnOpen: !1,
          fillAlways: !0,
          temporary: !1,
          uncloseable: !0
        }), fe.registerComponent("ErrorDisplay", mn);
        var ai = "vjs-text-track-settings",
            yn = ["#000", "Black"],
            En = ["#00F", "Blue"],
            Tn = ["#0FF", "Cyan"],
            _n = ["#0F0", "Green"],
            Sn = ["#F0F", "Magenta"],
            bn = ["#F00", "Red"],
            Cn = ["#FFF", "White"],
            Ln = ["#FF0", "Yellow"],
            si = ["1", "Opaque"],
            oi = ["0.5", "Semi-Transparent"],
            An = ["0", "Transparent"],
            At = {
          backgroundColor: {
            selector: ".vjs-bg-color > select",
            id: "captions-background-color-%s",
            label: "Color",
            options: [yn, Cn, bn, _n, En, Ln, Sn, Tn]
          },
          backgroundOpacity: {
            selector: ".vjs-bg-opacity > select",
            id: "captions-background-opacity-%s",
            label: "Transparency",
            options: [si, oi, An]
          },
          color: {
            selector: ".vjs-fg-color > select",
            id: "captions-foreground-color-%s",
            label: "Color",
            options: [Cn, yn, bn, _n, En, Ln, Sn, Tn]
          },
          edgeStyle: {
            selector: ".vjs-edge-style > select",
            id: "%s",
            label: "Text Edge Style",
            options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Dropshadow"]]
          },
          fontFamily: {
            selector: ".vjs-font-family > select",
            id: "captions-font-family-%s",
            label: "Font Family",
            options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
          },
          fontPercent: {
            selector: ".vjs-font-percent > select",
            id: "captions-font-size-%s",
            label: "Font Size",
            options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
            default: 2,
            parser: function (T) {
              return T === "1.00" ? null : Number(T);
            }
          },
          textOpacity: {
            selector: ".vjs-text-opacity > select",
            id: "captions-foreground-opacity-%s",
            label: "Transparency",
            options: [si, oi]
          },
          windowColor: {
            selector: ".vjs-window-color > select",
            id: "captions-window-color-%s",
            label: "Color"
          },
          windowOpacity: {
            selector: ".vjs-window-opacity > select",
            id: "captions-window-opacity-%s",
            label: "Transparency",
            options: [An, oi, si]
          }
        };
        At.windowColor.options = At.backgroundColor.options;

        function Dn(m, T) {
          if (T && (m = T(m)), m && m !== "none") return m;
        }

        function ja(m, T) {
          var l = m.options[m.options.selectedIndex].value;
          return Dn(l, T);
        }

        function Ka(m, T, l) {
          if (!!T) {
            for (var r = 0; r < m.options.length; r++) if (Dn(m.options[r].value, l) === T) {
              m.selectedIndex = r;
              break;
            }
          }
        }

        var Ha = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            return e.temporary = !1, t = m.call(this, r, e) || this, t.updateDisplay = t.updateDisplay.bind(n.default(t)), t.fill(), t.hasBeenOpened_ = t.hasBeenFilled_ = !0, t.endDialog = Pe("p", {
              className: "vjs-control-text",
              textContent: t.localize("End of dialog window.")
            }), t.el().appendChild(t.endDialog), t.setDefaults(), e.persistTextTrackSettings === void 0 && (t.options_.persistTextTrackSettings = t.options_.playerOptions.persistTextTrackSettings), t.on(t.$(".vjs-done-button"), "click", function () {
              t.saveSettings(), t.close();
            }), t.on(t.$(".vjs-default-button"), "click", function () {
              t.setDefaults(), t.updateDisplay();
            }), se(At, function (S) {
              t.on(t.$(S.selector), "change", t.updateDisplay);
            }), t.options_.persistTextTrackSettings && t.restoreSettings(), t;
          }

          var l = T.prototype;
          return l.dispose = function () {
            this.endDialog = null, m.prototype.dispose.call(this);
          }, l.createElSelect_ = function (e, t, S) {
            var N = this;
            t === void 0 && (t = ""), S === void 0 && (S = "label");
            var z = At[e],
                X = z.id.replace("%s", this.id_),
                J = [t, X].join(" ").trim();
            return ["<" + S + ' id="' + X + '" class="' + (S === "label" ? "vjs-label" : "") + '">', this.localize(z.label), "</" + S + ">", '<select aria-labelledby="' + J + '">'].concat(z.options.map(function (ie) {
              var Q = X + "-" + ie[1].replace(/\W+/g, "");
              return ['<option id="' + Q + '" value="' + ie[0] + '" ', 'aria-labelledby="' + J + " " + Q + '">', N.localize(ie[1]), "</option>"].join("");
            })).concat("</select>").join("");
          }, l.createElFgColor_ = function () {
            var e = "captions-text-legend-" + this.id_;
            return ['<fieldset class="vjs-fg-color vjs-track-setting">', '<legend id="' + e + '">', this.localize("Text"), "</legend>", this.createElSelect_("color", e), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_("textOpacity", e), "</span>", "</fieldset>"].join("");
          }, l.createElBgColor_ = function () {
            var e = "captions-background-" + this.id_;
            return ['<fieldset class="vjs-bg-color vjs-track-setting">', '<legend id="' + e + '">', this.localize("Background"), "</legend>", this.createElSelect_("backgroundColor", e), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_("backgroundOpacity", e), "</span>", "</fieldset>"].join("");
          }, l.createElWinColor_ = function () {
            var e = "captions-window-" + this.id_;
            return ['<fieldset class="vjs-window-color vjs-track-setting">', '<legend id="' + e + '">', this.localize("Window"), "</legend>", this.createElSelect_("windowColor", e), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_("windowOpacity", e), "</span>", "</fieldset>"].join("");
          }, l.createElColors_ = function () {
            return Pe("div", {
              className: "vjs-track-settings-colors",
              innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join("")
            });
          }, l.createElFont_ = function () {
            return Pe("div", {
              className: "vjs-track-settings-font",
              innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_("fontPercent", "", "legend"), "</fieldset>", '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_("edgeStyle", "", "legend"), "</fieldset>", '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_("fontFamily", "", "legend"), "</fieldset>"].join("")
            });
          }, l.createElControls_ = function () {
            var e = this.localize("restore all settings to the default values");
            return Pe("div", {
              className: "vjs-track-settings-controls",
              innerHTML: ['<button type="button" class="vjs-default-button" title="' + e + '">', this.localize("Reset"), '<span class="vjs-control-text"> ' + e + "</span>", "</button>", '<button type="button" class="vjs-done-button">' + this.localize("Done") + "</button>"].join("")
            });
          }, l.content = function () {
            return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
          }, l.label = function () {
            return this.localize("Caption Settings Dialog");
          }, l.description = function () {
            return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
          }, l.buildCSSClass = function () {
            return m.prototype.buildCSSClass.call(this) + " vjs-text-track-settings";
          }, l.getValues = function () {
            var e = this;
            return ge(At, function (t, S, N) {
              var z = ja(e.$(S.selector), S.parser);
              return z !== void 0 && (t[N] = z), t;
            }, {});
          }, l.setValues = function (e) {
            var t = this;
            se(At, function (S, N) {
              Ka(t.$(S.selector), e[N], S.parser);
            });
          }, l.setDefaults = function () {
            var e = this;
            se(At, function (t) {
              var S = t.hasOwnProperty("default") ? t.default : 0;
              e.$(t.selector).selectedIndex = S;
            });
          }, l.restoreSettings = function () {
            var e;

            try {
              e = JSON.parse(f.default.localStorage.getItem(ai));
            } catch (t) {
              $.warn(t);
            }

            e && this.setValues(e);
          }, l.saveSettings = function () {
            if (!!this.options_.persistTextTrackSettings) {
              var e = this.getValues();

              try {
                Object.keys(e).length ? f.default.localStorage.setItem(ai, JSON.stringify(e)) : f.default.localStorage.removeItem(ai);
              } catch (t) {
                $.warn(t);
              }
            }
          }, l.updateDisplay = function () {
            var e = this.player_.getChild("textTrackDisplay");
            e && e.updateDisplay();
          }, l.conditionalBlur_ = function () {
            this.previouslyActiveEl_ = null;
            var e = this.player_.controlBar,
                t = e && e.subsCapsButton,
                S = e && e.captionsButton;
            t ? t.focus() : S && S.focus();
          }, T;
        }(Rt);

        fe.registerComponent("TextTrackSettings", Ha);

        var Wa = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t,
                S = e.ResizeObserver || f.default.ResizeObserver;
            e.ResizeObserver === null && (S = !1);
            var N = je({
              createEl: !S,
              reportTouchActivity: !1
            }, e);
            return t = m.call(this, r, N) || this, t.ResizeObserver = e.ResizeObserver || f.default.ResizeObserver, t.loadListener_ = null, t.resizeObserver_ = null, t.debouncedHandler_ = Kn(function () {
              t.resizeHandler();
            }, 100, !1, n.default(t)), S ? (t.resizeObserver_ = new t.ResizeObserver(t.debouncedHandler_), t.resizeObserver_.observe(r.el())) : (t.loadListener_ = function () {
              if (!(!t.el_ || !t.el_.contentWindow)) {
                var z = t.debouncedHandler_,
                    X = t.unloadListener_ = function () {
                  Ve(this, "resize", z), Ve(this, "unload", X), X = null;
                };

                qe(t.el_.contentWindow, "unload", X), qe(t.el_.contentWindow, "resize", z);
              }
            }, t.one("load", t.loadListener_)), t;
          }

          var l = T.prototype;
          return l.createEl = function () {
            return m.prototype.createEl.call(this, "iframe", {
              className: "vjs-resize-manager",
              tabIndex: -1
            }, {
              "aria-hidden": "true"
            });
          }, l.resizeHandler = function () {
            !this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
          }, l.dispose = function () {
            this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, m.prototype.dispose.call(this);
          }, T;
        }(fe);

        fe.registerComponent("ResizeManager", Wa);

        var Ga = {
          trackingThreshold: 20,
          liveTolerance: 15
        },
            Va = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t,
                S = je(Ga, e, {
              createEl: !1
            });
            return t = m.call(this, r, S) || this, t.handleVisibilityChange_ = function (N) {
              return t.handleVisibilityChange(N);
            }, t.trackLiveHandler_ = function () {
              return t.trackLive_();
            }, t.handlePlay_ = function (N) {
              return t.handlePlay(N);
            }, t.handleFirstTimeupdate_ = function (N) {
              return t.handleFirstTimeupdate(N);
            }, t.handleSeeked_ = function (N) {
              return t.handleSeeked(N);
            }, t.seekToLiveEdge_ = function (N) {
              return t.seekToLiveEdge(N);
            }, t.reset_(), t.on(t.player_, "durationchange", function (N) {
              return t.handleDurationchange(N);
            }), t.on(t.player_, "canplay", function () {
              return t.toggleTracking();
            }), ce && "hidden" in y.default && "visibilityState" in y.default && t.on(y.default, "visibilitychange", t.handleVisibilityChange_), t;
          }

          var l = T.prototype;
          return l.handleVisibilityChange = function () {
            this.player_.duration() === 1 / 0 && (y.default.hidden ? this.stopTracking() : this.startTracking());
          }, l.trackLive_ = function () {
            var e = this.player_.seekable();

            if (!(!e || !e.length)) {
              var t = Number(f.default.performance.now().toFixed(4)),
                  S = this.lastTime_ === -1 ? 0 : (t - this.lastTime_) / 1e3;
              this.lastTime_ = t, this.pastSeekEnd_ = this.pastSeekEnd() + S;
              var N = this.liveCurrentTime(),
                  z = this.player_.currentTime(),
                  X = this.player_.paused() || this.seekedBehindLive_ || Math.abs(N - z) > this.options_.liveTolerance;
              (!this.timeupdateSeen_ || N === 1 / 0) && (X = !1), X !== this.behindLiveEdge_ && (this.behindLiveEdge_ = X, this.trigger("liveedgechange"));
            }
          }, l.handleDurationchange = function () {
            this.toggleTracking();
          }, l.toggleTracking = function () {
            this.player_.duration() === 1 / 0 && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
          }, l.startTracking = function () {
            this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, nt), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
          }, l.handleFirstTimeupdate = function () {
            this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
          }, l.handleSeeked = function () {
            var e = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
            this.seekedBehindLive_ = this.nextSeekedFromUser_ && e > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
          }, l.handlePlay = function () {
            this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
          }, l.reset_ = function () {
            this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
          }, l.nextSeekedFromUser = function () {
            this.nextSeekedFromUser_ = !0;
          }, l.stopTracking = function () {
            !this.isTracking() || (this.reset_(), this.trigger("liveedgechange"));
          }, l.seekableEnd = function () {
            for (var e = this.player_.seekable(), t = [], S = e ? e.length : 0; S--;) t.push(e.end(S));

            return t.length ? t.sort()[t.length - 1] : 1 / 0;
          }, l.seekableStart = function () {
            for (var e = this.player_.seekable(), t = [], S = e ? e.length : 0; S--;) t.push(e.start(S));

            return t.length ? t.sort()[0] : 0;
          }, l.liveWindow = function () {
            var e = this.liveCurrentTime();
            return e === 1 / 0 ? 0 : e - this.seekableStart();
          }, l.isLive = function () {
            return this.isTracking();
          }, l.atLiveEdge = function () {
            return !this.behindLiveEdge();
          }, l.liveCurrentTime = function () {
            return this.pastSeekEnd() + this.seekableEnd();
          }, l.pastSeekEnd = function () {
            var e = this.seekableEnd();
            return this.lastSeekEnd_ !== -1 && e !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = e, this.pastSeekEnd_;
          }, l.behindLiveEdge = function () {
            return this.behindLiveEdge_;
          }, l.isTracking = function () {
            return typeof this.trackingInterval_ == "number";
          }, l.seekToLiveEdge = function () {
            this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
          }, l.dispose = function () {
            this.off(y.default, "visibilitychange", this.handleVisibilityChange_), this.stopTracking(), m.prototype.dispose.call(this);
          }, T;
        }(fe);

        fe.registerComponent("LiveTracker", Va);

        var li = function (T) {
          var l = T.el();
          if (l.hasAttribute("src")) return T.triggerSourceset(l.src), !0;
          var r = T.$$("source"),
              e = [],
              t = "";
          if (!r.length) return !1;

          for (var S = 0; S < r.length; S++) {
            var N = r[S].src;
            N && e.indexOf(N) === -1 && e.push(N);
          }

          return e.length ? (e.length === 1 && (t = e[0]), T.triggerSourceset(t), !0) : !1;
        },
            za = Object.defineProperty({}, "innerHTML", {
          get: function () {
            return this.cloneNode(!0).innerHTML;
          },
          set: function (T) {
            var l = y.default.createElement(this.nodeName.toLowerCase());
            l.innerHTML = T;

            for (var r = y.default.createDocumentFragment(); l.childNodes.length;) r.appendChild(l.childNodes[0]);

            return this.innerText = "", f.default.Element.prototype.appendChild.call(this, r), this.innerHTML;
          }
        }),
            Pn = function (T, l) {
          for (var r = {}, e = 0; e < T.length && (r = Object.getOwnPropertyDescriptor(T[e], l), !(r && r.set && r.get)); e++);

          return r.enumerable = !0, r.configurable = !0, r;
        },
            Xa = function (T) {
          return Pn([T.el(), f.default.HTMLMediaElement.prototype, f.default.Element.prototype, za], "innerHTML");
        },
            On = function (T) {
          var l = T.el();

          if (!l.resetSourceWatch_) {
            var r = {},
                e = Xa(T),
                t = function (N) {
              return function () {
                for (var z = arguments.length, X = new Array(z), J = 0; J < z; J++) X[J] = arguments[J];

                var ie = N.apply(l, X);
                return li(T), ie;
              };
            };

            ["append", "appendChild", "insertAdjacentHTML"].forEach(function (S) {
              !l[S] || (r[S] = l[S], l[S] = t(r[S]));
            }), Object.defineProperty(l, "innerHTML", je(e, {
              set: t(e.set)
            })), l.resetSourceWatch_ = function () {
              l.resetSourceWatch_ = null, Object.keys(r).forEach(function (S) {
                l[S] = r[S];
              }), Object.defineProperty(l, "innerHTML", e);
            }, T.one("sourceset", l.resetSourceWatch_);
          }
        },
            Ya = Object.defineProperty({}, "src", {
          get: function () {
            return this.hasAttribute("src") ? Ni(f.default.Element.prototype.getAttribute.call(this, "src")) : "";
          },
          set: function (T) {
            return f.default.Element.prototype.setAttribute.call(this, "src", T), T;
          }
        }),
            $a = function (T) {
          return Pn([T.el(), f.default.HTMLMediaElement.prototype, Ya], "src");
        },
            Qa = function (T) {
          if (!!T.featuresSourceset) {
            var l = T.el();

            if (!l.resetSourceset_) {
              var r = $a(T),
                  e = l.setAttribute,
                  t = l.load;
              Object.defineProperty(l, "src", je(r, {
                set: function (N) {
                  var z = r.set.call(l, N);
                  return T.triggerSourceset(l.src), z;
                }
              })), l.setAttribute = function (S, N) {
                var z = e.call(l, S, N);
                return /src/i.test(S) && T.triggerSourceset(l.src), z;
              }, l.load = function () {
                var S = t.call(l);
                return li(T) || (T.triggerSourceset(""), On(T)), S;
              }, l.currentSrc ? T.triggerSourceset(l.currentSrc) : li(T) || On(T), l.resetSourceset_ = function () {
                l.resetSourceset_ = null, l.load = t, l.setAttribute = e, Object.defineProperty(l, "src", r), l.resetSourceWatch_ && l.resetSourceWatch_();
              };
            }
          }
        },
            ui = function (T, l, r, e) {
          e === void 0 && (e = !0);

          var t = function (z) {
            return Object.defineProperty(T, l, {
              value: z,
              enumerable: !0,
              writable: !0
            });
          },
              S = {
            configurable: !0,
            enumerable: !0,
            get: function () {
              var z = r();
              return t(z), z;
            }
          };

          return e && (S.set = t), Object.defineProperty(T, l, S);
        },
            Ee = function (m) {
          a.default(T, m);

          function T(r, e) {
            var t;
            t = m.call(this, r, e) || this;
            var S = r.source,
                N = !1;

            if (S && (t.el_.currentSrc !== S.src || r.tag && r.tag.initNetworkState_ === 3) ? t.setSource(S) : t.handleLateInit_(t.el_), r.enableSourceset && t.setupSourcesetHandling_(), t.isScrubbing_ = !1, t.el_.hasChildNodes()) {
              for (var z = t.el_.childNodes, X = z.length, J = []; X--;) {
                var ie = z[X],
                    Q = ie.nodeName.toLowerCase();
                Q === "track" && (t.featuresNativeTextTracks ? (t.remoteTextTrackEls().addTrackElement_(ie), t.remoteTextTracks().addTrack(ie.track), t.textTracks().addTrack(ie.track), !N && !t.el_.hasAttribute("crossorigin") && ar(ie.src) && (N = !0)) : J.push(ie));
              }

              for (var de = 0; de < J.length; de++) t.el_.removeChild(J[de]);
            }

            return t.proxyNativeTracks_(), t.featuresNativeTextTracks && N && $.warn("Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.\nThis may prevent text tracks from loading."), t.restoreMetadataTracksInIOSNativePlayer_(), (Ce || ke || ee) && r.nativeControlsForTouch === !0 && t.setControls(!0), t.proxyWebkitFullscreen_(), t.triggerReady(), t;
          }

          var l = T.prototype;
          return l.dispose = function () {
            this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), T.disposeMediaElement(this.el_), this.options_ = null, m.prototype.dispose.call(this);
          }, l.setupSourcesetHandling_ = function () {
            Qa(this);
          }, l.restoreMetadataTracksInIOSNativePlayer_ = function () {
            var e = this.textTracks(),
                t,
                S = function () {
              t = [];

              for (var X = 0; X < e.length; X++) {
                var J = e[X];
                J.kind === "metadata" && t.push({
                  track: J,
                  storedMode: J.mode
                });
              }
            };

            S(), e.addEventListener("change", S), this.on("dispose", function () {
              return e.removeEventListener("change", S);
            });

            var N = function z() {
              for (var X = 0; X < t.length; X++) {
                var J = t[X];
                J.track.mode === "disabled" && J.track.mode !== J.storedMode && (J.track.mode = J.storedMode);
              }

              e.removeEventListener("change", z);
            };

            this.on("webkitbeginfullscreen", function () {
              e.removeEventListener("change", S), e.removeEventListener("change", N), e.addEventListener("change", N);
            }), this.on("webkitendfullscreen", function () {
              e.removeEventListener("change", S), e.addEventListener("change", S), e.removeEventListener("change", N);
            });
          }, l.overrideNative_ = function (e, t) {
            var S = this;

            if (t === this["featuresNative" + e + "Tracks"]) {
              var N = e.toLowerCase();
              this[N + "TracksListeners_"] && Object.keys(this[N + "TracksListeners_"]).forEach(function (z) {
                var X = S.el()[N + "Tracks"];
                X.removeEventListener(z, S[N + "TracksListeners_"][z]);
              }), this["featuresNative" + e + "Tracks"] = !t, this[N + "TracksListeners_"] = null, this.proxyNativeTracksForType_(N);
            }
          }, l.overrideNativeAudioTracks = function (e) {
            this.overrideNative_("Audio", e);
          }, l.overrideNativeVideoTracks = function (e) {
            this.overrideNative_("Video", e);
          }, l.proxyNativeTracksForType_ = function (e) {
            var t = this,
                S = tt[e],
                N = this.el()[S.getterName],
                z = this[S.getterName]();

            if (!(!this["featuresNative" + S.capitalName + "Tracks"] || !N || !N.addEventListener)) {
              var X = {
                change: function (Q) {
                  var de = {
                    type: "change",
                    target: z,
                    currentTarget: z,
                    srcElement: z
                  };
                  z.trigger(de), e === "text" && t[kt.remoteText.getterName]().trigger(de);
                },
                addtrack: function (Q) {
                  z.addTrack(Q.track);
                },
                removetrack: function (Q) {
                  z.removeTrack(Q.track);
                }
              },
                  J = function () {
                for (var Q = [], de = 0; de < z.length; de++) {
                  for (var Te = !1, Oe = 0; Oe < N.length; Oe++) if (N[Oe] === z[de]) {
                    Te = !0;
                    break;
                  }

                  Te || Q.push(z[de]);
                }

                for (; Q.length;) z.removeTrack(Q.shift());
              };

              this[S.getterName + "Listeners_"] = X, Object.keys(X).forEach(function (ie) {
                var Q = X[ie];
                N.addEventListener(ie, Q), t.on("dispose", function (de) {
                  return N.removeEventListener(ie, Q);
                });
              }), this.on("loadstart", J), this.on("dispose", function (ie) {
                return t.off("loadstart", J);
              });
            }
          }, l.proxyNativeTracks_ = function () {
            var e = this;
            tt.names.forEach(function (t) {
              e.proxyNativeTracksForType_(t);
            });
          }, l.createEl = function () {
            var e = this.options_.tag;

            if (!e || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
              if (e) {
                var t = e.cloneNode(!0);
                e.parentNode && e.parentNode.insertBefore(t, e), T.disposeMediaElement(e), e = t;
              } else {
                e = y.default.createElement("video");
                var S = this.options_.tag && Ze(this.options_.tag),
                    N = je({}, S);
                (!Ce || this.options_.nativeControlsForTouch !== !0) && delete N.controls, Jt(e, he(N, {
                  id: this.options_.techId,
                  class: "vjs-tech"
                }));
              }

              e.playerId = this.options_.playerId;
            }

            typeof this.options_.preload != "undefined" && pt(e, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (e.disablePictureInPicture = this.options_.disablePictureInPicture);

            for (var z = ["loop", "muted", "playsinline", "autoplay"], X = 0; X < z.length; X++) {
              var J = z[X],
                  ie = this.options_[J];
              typeof ie != "undefined" && (ie ? pt(e, J, J) : Dt(e, J), e[J] = ie);
            }

            return e;
          }, l.handleLateInit_ = function (e) {
            if (!(e.networkState === 0 || e.networkState === 3)) {
              if (e.readyState === 0) {
                var t = !1,
                    S = function () {
                  t = !0;
                };

                this.on("loadstart", S);

                var N = function () {
                  t || this.trigger("loadstart");
                };

                this.on("loadedmetadata", N), this.ready(function () {
                  this.off("loadstart", S), this.off("loadedmetadata", N), t || this.trigger("loadstart");
                });
                return;
              }

              var z = ["loadstart"];
              z.push("loadedmetadata"), e.readyState >= 2 && z.push("loadeddata"), e.readyState >= 3 && z.push("canplay"), e.readyState >= 4 && z.push("canplaythrough"), this.ready(function () {
                z.forEach(function (X) {
                  this.trigger(X);
                }, this);
              });
            }
          }, l.setScrubbing = function (e) {
            this.isScrubbing_ = e;
          }, l.scrubbing = function () {
            return this.isScrubbing_;
          }, l.setCurrentTime = function (e) {
            try {
              this.isScrubbing_ && this.el_.fastSeek && Re ? this.el_.fastSeek(e) : this.el_.currentTime = e;
            } catch (t) {
              $(t, "Video is not ready. (Video.js)");
            }
          }, l.duration = function () {
            var e = this;

            if (this.el_.duration === 1 / 0 && Me && re && this.el_.currentTime === 0) {
              var t = function S() {
                e.el_.currentTime > 0 && (e.el_.duration === 1 / 0 && e.trigger("durationchange"), e.off("timeupdate", S));
              };

              return this.on("timeupdate", t), NaN;
            }

            return this.el_.duration || NaN;
          }, l.width = function () {
            return this.el_.offsetWidth;
          }, l.height = function () {
            return this.el_.offsetHeight;
          }, l.proxyWebkitFullscreen_ = function () {
            var e = this;

            if ("webkitDisplayingFullscreen" in this.el_) {
              var t = function () {
                this.trigger("fullscreenchange", {
                  isFullscreen: !1
                }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
              },
                  S = function () {
                "webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", t), this.trigger("fullscreenchange", {
                  isFullscreen: !0,
                  nativeIOSFullscreen: !0
                }));
              };

              this.on("webkitbeginfullscreen", S), this.on("dispose", function () {
                e.off("webkitbeginfullscreen", S), e.off("webkitendfullscreen", t);
              });
            }
          }, l.supportsFullScreen = function () {
            if (typeof this.el_.webkitEnterFullScreen == "function") {
              var e = f.default.navigator && f.default.navigator.userAgent || "";
              if (/Android/.test(e) || !/Chrome|Mac OS X 10.5/.test(e)) return !0;
            }

            return !1;
          }, l.enterFullScreen = function () {
            var e = this.el_;
            if (e.paused && e.networkState <= e.HAVE_METADATA) ot(this.el_.play()), this.setTimeout(function () {
              e.pause();

              try {
                e.webkitEnterFullScreen();
              } catch (t) {
                this.trigger("fullscreenerror", t);
              }
            }, 0);else try {
              e.webkitEnterFullScreen();
            } catch (t) {
              this.trigger("fullscreenerror", t);
            }
          }, l.exitFullScreen = function () {
            if (!this.el_.webkitDisplayingFullscreen) {
              this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
              return;
            }

            this.el_.webkitExitFullScreen();
          }, l.requestPictureInPicture = function () {
            return this.el_.requestPictureInPicture();
          }, l.src = function (e) {
            if (e === void 0) return this.el_.src;
            this.setSrc(e);
          }, l.reset = function () {
            T.resetMediaElement(this.el_);
          }, l.currentSrc = function () {
            return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
          }, l.setControls = function (e) {
            this.el_.controls = !!e;
          }, l.addTextTrack = function (e, t, S) {
            return this.featuresNativeTextTracks ? this.el_.addTextTrack(e, t, S) : m.prototype.addTextTrack.call(this, e, t, S);
          }, l.createRemoteTextTrack = function (e) {
            if (!this.featuresNativeTextTracks) return m.prototype.createRemoteTextTrack.call(this, e);
            var t = y.default.createElement("track");
            return e.kind && (t.kind = e.kind), e.label && (t.label = e.label), (e.language || e.srclang) && (t.srclang = e.language || e.srclang), e.default && (t.default = e.default), e.id && (t.id = e.id), e.src && (t.src = e.src), t;
          }, l.addRemoteTextTrack = function (e, t) {
            var S = m.prototype.addRemoteTextTrack.call(this, e, t);
            return this.featuresNativeTextTracks && this.el().appendChild(S), S;
          }, l.removeRemoteTextTrack = function (e) {
            if (m.prototype.removeRemoteTextTrack.call(this, e), this.featuresNativeTextTracks) for (var t = this.$$("track"), S = t.length; S--;) (e === t[S] || e === t[S].track) && this.el().removeChild(t[S]);
          }, l.getVideoPlaybackQuality = function () {
            if (typeof this.el().getVideoPlaybackQuality == "function") return this.el().getVideoPlaybackQuality();
            var e = {};
            return typeof this.el().webkitDroppedFrameCount != "undefined" && typeof this.el().webkitDecodedFrameCount != "undefined" && (e.droppedVideoFrames = this.el().webkitDroppedFrameCount, e.totalVideoFrames = this.el().webkitDecodedFrameCount), f.default.performance && typeof f.default.performance.now == "function" ? e.creationTime = f.default.performance.now() : f.default.performance && f.default.performance.timing && typeof f.default.performance.timing.navigationStart == "number" && (e.creationTime = f.default.Date.now() - f.default.performance.timing.navigationStart), e;
          }, T;
        }(Be);

        ui(Ee, "TEST_VID", function () {
          if (!!ze()) {
            var m = y.default.createElement("video"),
                T = y.default.createElement("track");
            return T.kind = "captions", T.srclang = "en", T.label = "English", m.appendChild(T), m;
          }
        }), Ee.isSupported = function () {
          try {
            Ee.TEST_VID.volume = .5;
          } catch (m) {
            return !1;
          }

          return !!(Ee.TEST_VID && Ee.TEST_VID.canPlayType);
        }, Ee.canPlayType = function (m) {
          return Ee.TEST_VID.canPlayType(m);
        }, Ee.canPlaySource = function (m, T) {
          return Ee.canPlayType(m.type);
        }, Ee.canControlVolume = function () {
          try {
            var m = Ee.TEST_VID.volume;
            Ee.TEST_VID.volume = m / 2 + .1;
            var T = m !== Ee.TEST_VID.volume;
            return T && De ? (f.default.setTimeout(function () {
              Ee && Ee.prototype && (Ee.prototype.featuresVolumeControl = m !== Ee.TEST_VID.volume);
            }), !1) : T;
          } catch (l) {
            return !1;
          }
        }, Ee.canMuteVolume = function () {
          try {
            var m = Ee.TEST_VID.muted;
            return Ee.TEST_VID.muted = !m, Ee.TEST_VID.muted ? pt(Ee.TEST_VID, "muted", "muted") : Dt(Ee.TEST_VID, "muted", "muted"), m !== Ee.TEST_VID.muted;
          } catch (T) {
            return !1;
          }
        }, Ee.canControlPlaybackRate = function () {
          if (Me && re && ne < 58) return !1;

          try {
            var m = Ee.TEST_VID.playbackRate;
            return Ee.TEST_VID.playbackRate = m / 2 + .1, m !== Ee.TEST_VID.playbackRate;
          } catch (T) {
            return !1;
          }
        }, Ee.canOverrideAttributes = function () {
          try {
            var m = function () {};

            Object.defineProperty(y.default.createElement("video"), "src", {
              get: m,
              set: m
            }), Object.defineProperty(y.default.createElement("audio"), "src", {
              get: m,
              set: m
            }), Object.defineProperty(y.default.createElement("video"), "innerHTML", {
              get: m,
              set: m
            }), Object.defineProperty(y.default.createElement("audio"), "innerHTML", {
              get: m,
              set: m
            });
          } catch (T) {
            return !1;
          }

          return !0;
        }, Ee.supportsNativeTextTracks = function () {
          return Re || De && re;
        }, Ee.supportsNativeVideoTracks = function () {
          return !!(Ee.TEST_VID && Ee.TEST_VID.videoTracks);
        }, Ee.supportsNativeAudioTracks = function () {
          return !!(Ee.TEST_VID && Ee.TEST_VID.audioTracks);
        }, Ee.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"], [["featuresMuteControl", "canMuteVolume"], ["featuresPlaybackRate", "canControlPlaybackRate"], ["featuresSourceset", "canOverrideAttributes"], ["featuresNativeTextTracks", "supportsNativeTextTracks"], ["featuresNativeVideoTracks", "supportsNativeVideoTracks"], ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]].forEach(function (m) {
          var T = m[0],
              l = m[1];
          ui(Ee.prototype, T, function () {
            return Ee[l]();
          }, !0);
        }), Ee.prototype.featuresVolumeControl = Ee.canControlVolume(), Ee.prototype.movingMediaElementInDOM = !De, Ee.prototype.featuresFullscreenResize = !0, Ee.prototype.featuresProgressEvents = !0, Ee.prototype.featuresTimeupdateEvents = !0;
        var hr;
        Ee.patchCanPlayType = function () {
          le >= 4 && !oe && !re && (hr = Ee.TEST_VID && Ee.TEST_VID.constructor.prototype.canPlayType, Ee.TEST_VID.constructor.prototype.canPlayType = function (m) {
            var T = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
            return m && T.test(m) ? "maybe" : hr.call(this, m);
          });
        }, Ee.unpatchCanPlayType = function () {
          var m = Ee.TEST_VID.constructor.prototype.canPlayType;
          return hr && (Ee.TEST_VID.constructor.prototype.canPlayType = hr), m;
        }, Ee.patchCanPlayType(), Ee.disposeMediaElement = function (m) {
          if (!!m) {
            for (m.parentNode && m.parentNode.removeChild(m); m.hasChildNodes();) m.removeChild(m.firstChild);

            m.removeAttribute("src"), typeof m.load == "function" && function () {
              try {
                m.load();
              } catch (T) {}
            }();
          }
        }, Ee.resetMediaElement = function (m) {
          if (!!m) {
            for (var T = m.querySelectorAll("source"), l = T.length; l--;) m.removeChild(T[l]);

            m.removeAttribute("src"), typeof m.load == "function" && function () {
              try {
                m.load();
              } catch (r) {}
            }();
          }
        }, ["muted", "defaultMuted", "autoplay", "controls", "loop", "playsinline"].forEach(function (m) {
          Ee.prototype[m] = function () {
            return this.el_[m] || this.el_.hasAttribute(m);
          };
        }), ["muted", "defaultMuted", "autoplay", "loop", "playsinline"].forEach(function (m) {
          Ee.prototype["set" + Ke(m)] = function (T) {
            this.el_[m] = T, T ? this.el_.setAttribute(m, m) : this.el_.removeAttribute(m);
          };
        }), ["paused", "currentTime", "buffered", "volume", "poster", "preload", "error", "seeking", "seekable", "ended", "playbackRate", "defaultPlaybackRate", "disablePictureInPicture", "played", "networkState", "readyState", "videoWidth", "videoHeight", "crossOrigin"].forEach(function (m) {
          Ee.prototype[m] = function () {
            return this.el_[m];
          };
        }), ["volume", "src", "poster", "preload", "playbackRate", "defaultPlaybackRate", "disablePictureInPicture", "crossOrigin"].forEach(function (m) {
          Ee.prototype["set" + Ke(m)] = function (T) {
            this.el_[m] = T;
          };
        }), ["pause", "load", "play"].forEach(function (m) {
          Ee.prototype[m] = function () {
            return this.el_[m]();
          };
        }), Be.withSourceHandlers(Ee), Ee.nativeSourceHandler = {}, Ee.nativeSourceHandler.canPlayType = function (m) {
          try {
            return Ee.TEST_VID.canPlayType(m);
          } catch (T) {
            return "";
          }
        }, Ee.nativeSourceHandler.canHandleSource = function (m, T) {
          if (m.type) return Ee.nativeSourceHandler.canPlayType(m.type);

          if (m.src) {
            var l = Br(m.src);
            return Ee.nativeSourceHandler.canPlayType("video/" + l);
          }

          return "";
        }, Ee.nativeSourceHandler.handleSource = function (m, T, l) {
          T.setSrc(m.src);
        }, Ee.nativeSourceHandler.dispose = function () {}, Ee.registerSourceHandler(Ee.nativeSourceHandler), Be.registerTech("Html5", Ee);
        var In = ["progress", "abort", "suspend", "emptied", "stalled", "loadedmetadata", "loadeddata", "timeupdate", "resize", "volumechange", "texttrackchange"],
            ci = {
          canplay: "CanPlay",
          canplaythrough: "CanPlayThrough",
          playing: "Playing",
          seeked: "Seeked"
        },
            di = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"],
            vr = {};
        di.forEach(function (m) {
          var T = m.charAt(0) === "x" ? "x-" + m.substring(1) : m;
          vr[m] = "vjs-layout-" + T;
        });

        var Ja = {
          tiny: 210,
          xsmall: 320,
          small: 425,
          medium: 768,
          large: 1440,
          xlarge: 2560,
          huge: 1 / 0
        },
            He = function (m) {
          a.default(T, m);

          function T(r, e, t) {
            var S;
            if (r.id = r.id || e.id || "vjs_video_" + mt(), e = he(T.getTagSettings(r), e), e.initChildren = !1, e.createEl = !1, e.evented = !1, e.reportTouchActivity = !1, !e.language) if (typeof r.closest == "function") {
              var N = r.closest("[lang]");
              N && N.getAttribute && (e.language = N.getAttribute("lang"));
            } else for (var z = r; z && z.nodeType === 1;) {
              if (Ze(z).hasOwnProperty("lang")) {
                e.language = z.getAttribute("lang");
                break;
              }

              z = z.parentNode;
            }
            if (S = m.call(this, null, e, t) || this, S.boundDocumentFullscreenChange_ = function (Q) {
              return S.documentFullscreenChange_(Q);
            }, S.boundFullWindowOnEscKey_ = function (Q) {
              return S.fullWindowOnEscKey(Q);
            }, S.boundUpdateStyleEl_ = function (Q) {
              return S.updateStyleEl_(Q);
            }, S.boundApplyInitTime_ = function (Q) {
              return S.applyInitTime_(Q);
            }, S.boundUpdateCurrentBreakpoint_ = function (Q) {
              return S.updateCurrentBreakpoint_(Q);
            }, S.boundHandleTechClick_ = function (Q) {
              return S.handleTechClick_(Q);
            }, S.boundHandleTechDoubleClick_ = function (Q) {
              return S.handleTechDoubleClick_(Q);
            }, S.boundHandleTechTouchStart_ = function (Q) {
              return S.handleTechTouchStart_(Q);
            }, S.boundHandleTechTouchMove_ = function (Q) {
              return S.handleTechTouchMove_(Q);
            }, S.boundHandleTechTouchEnd_ = function (Q) {
              return S.handleTechTouchEnd_(Q);
            }, S.boundHandleTechTap_ = function (Q) {
              return S.handleTechTap_(Q);
            }, S.isFullscreen_ = !1, S.log = q(S.id_), S.fsApi_ = I, S.isPosterFromTech_ = !1, S.queuedCallbacks_ = [], S.isReady_ = !1, S.hasStarted_ = !1, S.userActive_ = !1, S.debugEnabled_ = !1, !S.options_ || !S.options_.techOrder || !S.options_.techOrder.length) throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");

            if (S.tag = r, S.tagAttributes = r && Ze(r), S.language(S.options_.language), e.languages) {
              var X = {};
              Object.getOwnPropertyNames(e.languages).forEach(function (Q) {
                X[Q.toLowerCase()] = e.languages[Q];
              }), S.languages_ = X;
            } else S.languages_ = T.prototype.options_.languages;

            S.resetCache_(), S.poster_ = e.poster || "", S.controls_ = !!e.controls, r.controls = !1, r.removeAttribute("controls"), S.changingSrc_ = !1, S.playCallbacks_ = [], S.playTerminatedQueue_ = [], r.hasAttribute("autoplay") ? S.autoplay(!0) : S.autoplay(S.options_.autoplay), e.plugins && Object.keys(e.plugins).forEach(function (Q) {
              if (typeof S[Q] != "function") throw new Error('plugin "' + Q + '" does not exist');
            }), S.scrubbing_ = !1, S.el_ = S.createEl(), Pr(n.default(S), {
              eventBusKey: "el_"
            }), S.fsApi_.requestFullscreen && (qe(y.default, S.fsApi_.fullscreenchange, S.boundDocumentFullscreenChange_), S.on(S.fsApi_.fullscreenchange, S.boundDocumentFullscreenChange_)), S.fluid_ && S.on(["playerreset", "resize"], S.boundUpdateStyleEl_);
            var J = je(S.options_);
            e.plugins && Object.keys(e.plugins).forEach(function (Q) {
              S[Q](e.plugins[Q]);
            }), e.debug && S.debug(!0), S.options_.playerOptions = J, S.middleware_ = [], S.playbackRates(e.playbackRates), S.initChildren(), S.isAudio(r.nodeName.toLowerCase() === "audio"), S.controls() ? S.addClass("vjs-controls-enabled") : S.addClass("vjs-controls-disabled"), S.el_.setAttribute("role", "region"), S.isAudio() ? S.el_.setAttribute("aria-label", S.localize("Audio Player")) : S.el_.setAttribute("aria-label", S.localize("Video Player")), S.isAudio() && S.addClass("vjs-audio"), S.flexNotSupported_() && S.addClass("vjs-no-flex"), Ce && S.addClass("vjs-touch-enabled"), De || S.addClass("vjs-workinghover"), T.players[S.id_] = n.default(S);

            var ie = _.split(".")[0];

            return S.addClass("vjs-v" + ie), S.userActive(!0), S.reportUserActivity(), S.one("play", function (Q) {
              return S.listenForUserActivity_(Q);
            }), S.on("stageclick", function (Q) {
              return S.handleStageClick_(Q);
            }), S.on("keydown", function (Q) {
              return S.handleKeyDown(Q);
            }), S.on("languagechange", function (Q) {
              return S.handleLanguagechange(Q);
            }), S.breakpoints(S.options_.breakpoints), S.responsive(S.options_.responsive), S;
          }

          var l = T.prototype;
          return l.dispose = function () {
            var e = this;
            this.trigger("dispose"), this.off("dispose"), Ve(y.default, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), Ve(y.default, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), T.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null), ma(this), $e.names.forEach(function (t) {
              var S = $e[t],
                  N = e[S.getterName]();
              N && N.off && N.off();
            }), m.prototype.dispose.call(this);
          }, l.createEl = function () {
            var e = this.tag,
                t,
                S = this.playerElIngest_ = e.parentNode && e.parentNode.hasAttribute && e.parentNode.hasAttribute("data-vjs-player"),
                N = this.tag.tagName.toLowerCase() === "video-js";
            S ? t = this.el_ = e.parentNode : N || (t = this.el_ = m.prototype.createEl.call(this, "div"));
            var z = Ze(e);

            if (N) {
              for (t = this.el_ = e, e = this.tag = y.default.createElement("video"); t.children.length;) e.appendChild(t.firstChild);

              ct(t, "video-js") || et(t, "video-js"), t.appendChild(e), S = this.playerElIngest_ = t, Object.keys(t).forEach(function (Te) {
                try {
                  e[Te] = t[Te];
                } catch (Oe) {}
              });
            }

            if (e.setAttribute("tabindex", "-1"), z.tabindex = "-1", (ce || re && Ae) && (e.setAttribute("role", "application"), z.role = "application"), e.removeAttribute("width"), e.removeAttribute("height"), "width" in z && delete z.width, "height" in z && delete z.height, Object.getOwnPropertyNames(z).forEach(function (Te) {
              N && Te === "class" || t.setAttribute(Te, z[Te]), N && e.setAttribute(Te, z[Te]);
            }), e.playerId = e.id, e.id += "_html5_api", e.className = "vjs-tech", e.player = t.player = this, this.addClass("vjs-paused"), f.default.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
              this.styleEl_ = Ci("vjs-styles-dimensions");
              var X = gt(".vjs-styles-defaults"),
                  J = gt("head");
              J.insertBefore(this.styleEl_, X ? X.nextSibling : J.firstChild);
            }

            this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);

            for (var ie = e.getElementsByTagName("a"), Q = 0; Q < ie.length; Q++) {
              var de = ie.item(Q);
              et(de, "vjs-hidden"), de.setAttribute("hidden", "hidden");
            }

            return e.initNetworkState_ = e.networkState, e.parentNode && !S && e.parentNode.insertBefore(t, e), Tt(e, t), this.children_.unshift(e), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = t, t;
          }, l.crossOrigin = function (e) {
            if (!e) return this.techGet_("crossOrigin");

            if (e !== "anonymous" && e !== "use-credentials") {
              $.warn('crossOrigin must be "anonymous" or "use-credentials", given "' + e + '"');
              return;
            }

            this.techCall_("setCrossOrigin", e);
          }, l.width = function (e) {
            return this.dimension("width", e);
          }, l.height = function (e) {
            return this.dimension("height", e);
          }, l.dimension = function (e, t) {
            var S = e + "_";
            if (t === void 0) return this[S] || 0;

            if (t === "" || t === "auto") {
              this[S] = void 0, this.updateStyleEl_();
              return;
            }

            var N = parseFloat(t);

            if (isNaN(N)) {
              $.error('Improper value "' + t + '" supplied for for ' + e);
              return;
            }

            this[S] = N, this.updateStyleEl_();
          }, l.fluid = function (e) {
            var t = this;
            if (e === void 0) return !!this.fluid_;
            this.fluid_ = !!e, ft(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), e ? (this.addClass("vjs-fluid"), this.fill(!1), Hn(this, function () {
              t.on(["playerreset", "resize"], t.boundUpdateStyleEl_);
            })) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
          }, l.fill = function (e) {
            if (e === void 0) return !!this.fill_;
            this.fill_ = !!e, e ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
          }, l.aspectRatio = function (e) {
            if (e === void 0) return this.aspectRatio_;
            if (!/^\d+\:\d+$/.test(e)) throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
            this.aspectRatio_ = e, this.fluid(!0), this.updateStyleEl_();
          }, l.updateStyleEl_ = function () {
            if (f.default.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
              var e = typeof this.width_ == "number" ? this.width_ : this.options_.width,
                  t = typeof this.height_ == "number" ? this.height_ : this.options_.height,
                  S = this.tech_ && this.tech_.el();
              S && (e >= 0 && (S.width = e), t >= 0 && (S.height = t));
              return;
            }

            var N, z, X, J;
            this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? X = this.aspectRatio_ : this.videoWidth() > 0 ? X = this.videoWidth() + ":" + this.videoHeight() : X = "16:9";
            var ie = X.split(":"),
                Q = ie[1] / ie[0];
            this.width_ !== void 0 ? N = this.width_ : this.height_ !== void 0 ? N = this.height_ / Q : N = this.videoWidth() || 300, this.height_ !== void 0 ? z = this.height_ : z = N * Q, /^[^a-zA-Z]/.test(this.id()) ? J = "dimensions-" + this.id() : J = this.id() + "-dimensions", this.addClass(J), Li(this.styleEl_, "\n      ." + J + " {\n        width: " + N + "px;\n        height: " + z + "px;\n      }\n\n      ." + J + ".vjs-fluid {\n        padding-top: " + Q * 100 + "%;\n      }\n    ");
          }, l.loadTech_ = function (e, t) {
            var S = this;
            this.tech_ && this.unloadTech_();
            var N = Ke(e),
                z = e.charAt(0).toLowerCase() + e.slice(1);
            N !== "Html5" && this.tag && (Be.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = N, this.isReady_ = !1;
            var X = this.autoplay();
            (typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (X = !1);
            var J = {
              source: t,
              autoplay: X,
              nativeControlsForTouch: this.options_.nativeControlsForTouch,
              playerId: this.id(),
              techId: this.id() + "_" + z + "_api",
              playsinline: this.options_.playsinline,
              preload: this.options_.preload,
              loop: this.options_.loop,
              disablePictureInPicture: this.options_.disablePictureInPicture,
              muted: this.options_.muted,
              poster: this.poster(),
              language: this.language(),
              playerElIngest: this.playerElIngest_ || !1,
              "vtt.js": this.options_["vtt.js"],
              canOverridePoster: !!this.options_.techCanOverridePoster,
              enableSourceset: this.options_.enableSourceset,
              Promise: this.options_.Promise
            };
            $e.names.forEach(function (Q) {
              var de = $e[Q];
              J[de.getterName] = S[de.privateName];
            }), he(J, this.options_[N]), he(J, this.options_[z]), he(J, this.options_[e.toLowerCase()]), this.tag && (J.tag = this.tag), t && t.src === this.cache_.src && this.cache_.currentTime > 0 && (J.startTime = this.cache_.currentTime);
            var ie = Be.getTech(e);
            if (!ie) throw new Error("No Tech named '" + N + "' exists! '" + N + "' should be registered using videojs.registerTech()'");
            this.tech_ = new ie(J), this.tech_.ready(Fe(this, this.handleTechReady_), !0), ki.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), In.forEach(function (Q) {
              S.on(S.tech_, Q, function (de) {
                return S["handleTech" + Ke(Q) + "_"](de);
              });
            }), Object.keys(ci).forEach(function (Q) {
              S.on(S.tech_, Q, function (de) {
                if (S.tech_.playbackRate() === 0 && S.tech_.seeking()) {
                  S.queuedCallbacks_.push({
                    callback: S["handleTech" + ci[Q] + "_"].bind(S),
                    event: de
                  });
                  return;
                }

                S["handleTech" + ci[Q] + "_"](de);
              });
            }), this.on(this.tech_, "loadstart", function (Q) {
              return S.handleTechLoadStart_(Q);
            }), this.on(this.tech_, "sourceset", function (Q) {
              return S.handleTechSourceset_(Q);
            }), this.on(this.tech_, "waiting", function (Q) {
              return S.handleTechWaiting_(Q);
            }), this.on(this.tech_, "ended", function (Q) {
              return S.handleTechEnded_(Q);
            }), this.on(this.tech_, "seeking", function (Q) {
              return S.handleTechSeeking_(Q);
            }), this.on(this.tech_, "play", function (Q) {
              return S.handleTechPlay_(Q);
            }), this.on(this.tech_, "firstplay", function (Q) {
              return S.handleTechFirstPlay_(Q);
            }), this.on(this.tech_, "pause", function (Q) {
              return S.handleTechPause_(Q);
            }), this.on(this.tech_, "durationchange", function (Q) {
              return S.handleTechDurationChange_(Q);
            }), this.on(this.tech_, "fullscreenchange", function (Q, de) {
              return S.handleTechFullscreenChange_(Q, de);
            }), this.on(this.tech_, "fullscreenerror", function (Q, de) {
              return S.handleTechFullscreenError_(Q, de);
            }), this.on(this.tech_, "enterpictureinpicture", function (Q) {
              return S.handleTechEnterPictureInPicture_(Q);
            }), this.on(this.tech_, "leavepictureinpicture", function (Q) {
              return S.handleTechLeavePictureInPicture_(Q);
            }), this.on(this.tech_, "error", function (Q) {
              return S.handleTechError_(Q);
            }), this.on(this.tech_, "posterchange", function (Q) {
              return S.handleTechPosterChange_(Q);
            }), this.on(this.tech_, "textdata", function (Q) {
              return S.handleTechTextData_(Q);
            }), this.on(this.tech_, "ratechange", function (Q) {
              return S.handleTechRateChange_(Q);
            }), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (N !== "Html5" || !this.tag) && Tt(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null);
          }, l.unloadTech_ = function () {
            var e = this;
            $e.names.forEach(function (t) {
              var S = $e[t];
              e[S.privateName] = e[S.getterName]();
            }), this.textTracksJson_ = ki.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
          }, l.tech = function (e) {
            return e === void 0 && $.warn("Using the tech directly can be dangerous. I hope you know what you're doing.\nSee https://github.com/videojs/video.js/issues/2617 for more info.\n"), this.tech_;
          }, l.addTechControlsListeners_ = function () {
            this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
          }, l.removeTechControlsListeners_ = function () {
            this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
          }, l.handleTechReady_ = function () {
            this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
          }, l.handleTechLoadStart_ = function () {
            this.removeClass("vjs-ended"), this.removeClass("vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : (this.trigger("loadstart"), this.trigger("firstplay")), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
          }, l.manualAutoplay_ = function (e) {
            var t = this;

            if (!(!this.tech_ || typeof e != "string")) {
              var S = function () {
                var X = t.muted();
                t.muted(!0);

                var J = function () {
                  t.muted(X);
                };

                t.playTerminatedQueue_.push(J);
                var ie = t.play();
                if (!!Gt(ie)) return ie.catch(function (Q) {
                  throw J(), new Error("Rejection at manualAutoplay. Restoring muted value. " + (Q || ""));
                });
              },
                  N;

              if (e === "any" && !this.muted() ? (N = this.play(), Gt(N) && (N = N.catch(S))) : e === "muted" && !this.muted() ? N = S() : N = this.play(), !!Gt(N)) return N.then(function () {
                t.trigger({
                  type: "autoplay-success",
                  autoplay: e
                });
              }).catch(function () {
                t.trigger({
                  type: "autoplay-failure",
                  autoplay: e
                });
              });
            }
          }, l.updateSourceCaches_ = function (e) {
            e === void 0 && (e = "");
            var t = e,
                S = "";
            typeof t != "string" && (t = e.src, S = e.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], t && !S && (S = Ta(this, t)), this.cache_.source = je({}, e, {
              src: t,
              type: S
            });

            for (var N = this.cache_.sources.filter(function (de) {
              return de.src && de.src === t;
            }), z = [], X = this.$$("source"), J = [], ie = 0; ie < X.length; ie++) {
              var Q = Ze(X[ie]);
              z.push(Q), Q.src && Q.src === t && J.push(Q.src);
            }

            J.length && !N.length ? this.cache_.sources = z : N.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = t;
          }, l.handleTechSourceset_ = function (e) {
            var t = this;

            if (!this.changingSrc_) {
              var S = function (J) {
                return t.updateSourceCaches_(J);
              },
                  N = this.currentSource().src,
                  z = e.src;

              N && !/^blob:/.test(N) && /^blob:/.test(z) && (!this.lastSource_ || this.lastSource_.tech !== z && this.lastSource_.player !== N) && (S = function () {}), S(z), e.src || this.tech_.any(["sourceset", "loadstart"], function (X) {
                if (X.type !== "sourceset") {
                  var J = t.techGet("currentSrc");
                  t.lastSource_.tech = J, t.updateSourceCaches_(J);
                }
              });
            }

            this.lastSource_ = {
              player: this.currentSource().src,
              tech: e.src
            }, this.trigger({
              src: e.src,
              type: "sourceset"
            });
          }, l.hasStarted = function (e) {
            if (e === void 0) return this.hasStarted_;
            e !== this.hasStarted_ && (this.hasStarted_ = e, this.hasStarted_ ? (this.addClass("vjs-has-started"), this.trigger("firstplay")) : this.removeClass("vjs-has-started"));
          }, l.handleTechPlay_ = function () {
            this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
          }, l.handleTechRateChange_ = function () {
            this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach(function (e) {
              return e.callback(e.event);
            }), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
          }, l.handleTechWaiting_ = function () {
            var e = this;
            this.addClass("vjs-waiting"), this.trigger("waiting");

            var t = this.currentTime(),
                S = function N() {
              t !== e.currentTime() && (e.removeClass("vjs-waiting"), e.off("timeupdate", N));
            };

            this.on("timeupdate", S);
          }, l.handleTechCanPlay_ = function () {
            this.removeClass("vjs-waiting"), this.trigger("canplay");
          }, l.handleTechCanPlayThrough_ = function () {
            this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
          }, l.handleTechPlaying_ = function () {
            this.removeClass("vjs-waiting"), this.trigger("playing");
          }, l.handleTechSeeking_ = function () {
            this.addClass("vjs-seeking"), this.trigger("seeking");
          }, l.handleTechSeeked_ = function () {
            this.removeClass("vjs-seeking"), this.removeClass("vjs-ended"), this.trigger("seeked");
          }, l.handleTechFirstPlay_ = function () {
            this.options_.starttime && ($.warn("Passing the `starttime` option to the player will be deprecated in 6.0"), this.currentTime(this.options_.starttime)), this.addClass("vjs-has-started"), this.trigger("firstplay");
          }, l.handleTechPause_ = function () {
            this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
          }, l.handleTechEnded_ = function () {
            this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
          }, l.handleTechDurationChange_ = function () {
            this.duration(this.techGet_("duration"));
          }, l.handleTechClick_ = function (e) {
            !this.controls_ || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, e) : this.paused() ? ot(this.play()) : this.pause());
          }, l.handleTechDoubleClick_ = function (e) {
            if (!!this.controls_) {
              var t = Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), function (S) {
                return S.contains(e.target);
              });
              t || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, e) : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen());
            }
          }, l.handleTechTap_ = function () {
            this.userActive(!this.userActive());
          }, l.handleTechTouchStart_ = function () {
            this.userWasActive = this.userActive();
          }, l.handleTechTouchMove_ = function () {
            this.userWasActive && this.reportUserActivity();
          }, l.handleTechTouchEnd_ = function (e) {
            e.cancelable && e.preventDefault();
          }, l.handleStageClick_ = function () {
            this.reportUserActivity();
          }, l.toggleFullscreenClass_ = function () {
            this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
          }, l.documentFullscreenChange_ = function (e) {
            var t = e.target.player;

            if (!(t && t !== this)) {
              var S = this.el(),
                  N = y.default[this.fsApi_.fullscreenElement] === S;
              !N && S.matches ? N = S.matches(":" + this.fsApi_.fullscreen) : !N && S.msMatchesSelector && (N = S.msMatchesSelector(":" + this.fsApi_.fullscreen)), this.isFullscreen(N);
            }
          }, l.handleTechFullscreenChange_ = function (e, t) {
            var S = this;
            t && (t.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", function () {
              S.removeClass("vjs-ios-native-fs");
            })), this.isFullscreen(t.isFullscreen));
          }, l.handleTechFullscreenError_ = function (e, t) {
            this.trigger("fullscreenerror", t);
          }, l.togglePictureInPictureClass_ = function () {
            this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
          }, l.handleTechEnterPictureInPicture_ = function (e) {
            this.isInPictureInPicture(!0);
          }, l.handleTechLeavePictureInPicture_ = function (e) {
            this.isInPictureInPicture(!1);
          }, l.handleTechError_ = function () {
            var e = this.tech_.error();
            this.error(e);
          }, l.handleTechTextData_ = function () {
            var e = null;
            arguments.length > 1 && (e = arguments[1]), this.trigger("textdata", e);
          }, l.getCache = function () {
            return this.cache_;
          }, l.resetCache_ = function () {
            this.cache_ = {
              currentTime: 0,
              initTime: 0,
              inactivityTimeout: this.options_.inactivityTimeout,
              duration: NaN,
              lastVolume: 1,
              lastPlaybackRate: this.defaultPlaybackRate(),
              media: null,
              src: "",
              source: {},
              sources: [],
              playbackRates: [],
              volume: 1
            };
          }, l.techCall_ = function (e, t) {
            this.ready(function () {
              if (e in pa) return ha(this.middleware_, this.tech_, e, t);
              if (e in zi) return Vi(this.middleware_, this.tech_, e, t);

              try {
                this.tech_ && this.tech_[e](t);
              } catch (S) {
                throw $(S), S;
              }
            }, !0);
          }, l.techGet_ = function (e) {
            if (!(!this.tech_ || !this.tech_.isReady_)) {
              if (e in va) return fa(this.middleware_, this.tech_, e);
              if (e in zi) return Vi(this.middleware_, this.tech_, e);

              try {
                return this.tech_[e]();
              } catch (t) {
                throw this.tech_[e] === void 0 ? ($("Video.js: " + e + " method not defined for " + this.techName_ + " playback technology.", t), t) : t.name === "TypeError" ? ($("Video.js: " + e + " unavailable on " + this.techName_ + " playback technology element.", t), this.tech_.isReady_ = !1, t) : ($(t), t);
              }
            }
          }, l.play = function () {
            var e = this,
                t = this.options_.Promise || f.default.Promise;
            return t ? new t(function (S) {
              e.play_(S);
            }) : this.play_();
          }, l.play_ = function (e) {
            var t = this;
            e === void 0 && (e = ot), this.playCallbacks_.push(e);
            var S = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));

            if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !S) {
              this.waitToPlay_ = function (z) {
                t.play_();
              }, this.one(["ready", "loadstart"], this.waitToPlay_), !S && (Re || De) && this.load();
              return;
            }

            var N = this.techGet_("play");
            N === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(N);
          }, l.runPlayTerminatedQueue_ = function () {
            var e = this.playTerminatedQueue_.slice(0);
            this.playTerminatedQueue_ = [], e.forEach(function (t) {
              t();
            });
          }, l.runPlayCallbacks_ = function (e) {
            var t = this.playCallbacks_.slice(0);
            this.playCallbacks_ = [], this.playTerminatedQueue_ = [], t.forEach(function (S) {
              S(e);
            });
          }, l.pause = function () {
            this.techCall_("pause");
          }, l.paused = function () {
            return this.techGet_("paused") !== !1;
          }, l.played = function () {
            return this.techGet_("played") || bt(0, 0);
          }, l.scrubbing = function (e) {
            if (typeof e == "undefined") return this.scrubbing_;
            this.scrubbing_ = !!e, this.techCall_("setScrubbing", this.scrubbing_), e ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
          }, l.currentTime = function (e) {
            if (typeof e != "undefined") {
              if (e < 0 && (e = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
                this.cache_.initTime = e, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
                return;
              }

              this.techCall_("setCurrentTime", e), this.cache_.initTime = 0;
              return;
            }

            return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
          }, l.applyInitTime_ = function () {
            this.currentTime(this.cache_.initTime);
          }, l.duration = function (e) {
            if (e === void 0) return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
            e = parseFloat(e), e < 0 && (e = 1 / 0), e !== this.cache_.duration && (this.cache_.duration = e, e === 1 / 0 ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(e) || this.trigger("durationchange"));
          }, l.remainingTime = function () {
            return this.duration() - this.currentTime();
          }, l.remainingTimeDisplay = function () {
            return Math.floor(this.duration()) - Math.floor(this.currentTime());
          }, l.buffered = function () {
            var e = this.techGet_("buffered");
            return (!e || !e.length) && (e = bt(0, 0)), e;
          }, l.bufferedPercent = function () {
            return xi(this.buffered(), this.duration());
          }, l.bufferedEnd = function () {
            var e = this.buffered(),
                t = this.duration(),
                S = e.end(e.length - 1);
            return S > t && (S = t), S;
          }, l.volume = function (e) {
            var t;

            if (e !== void 0) {
              t = Math.max(0, Math.min(1, parseFloat(e))), this.cache_.volume = t, this.techCall_("setVolume", t), t > 0 && this.lastVolume_(t);
              return;
            }

            return t = parseFloat(this.techGet_("volume")), isNaN(t) ? 1 : t;
          }, l.muted = function (e) {
            if (e !== void 0) {
              this.techCall_("setMuted", e);
              return;
            }

            return this.techGet_("muted") || !1;
          }, l.defaultMuted = function (e) {
            return e !== void 0 ? this.techCall_("setDefaultMuted", e) : this.techGet_("defaultMuted") || !1;
          }, l.lastVolume_ = function (e) {
            if (e !== void 0 && e !== 0) {
              this.cache_.lastVolume = e;
              return;
            }

            return this.cache_.lastVolume;
          }, l.supportsFullScreen = function () {
            return this.techGet_("supportsFullScreen") || !1;
          }, l.isFullscreen = function (e) {
            if (e !== void 0) {
              var t = this.isFullscreen_;
              this.isFullscreen_ = Boolean(e), this.isFullscreen_ !== t && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
              return;
            }

            return this.isFullscreen_;
          }, l.requestFullscreen = function (e) {
            var t = this.options_.Promise || f.default.Promise;

            if (t) {
              var S = this;
              return new t(function (N, z) {
                function X() {
                  S.off("fullscreenerror", ie), S.off("fullscreenchange", J);
                }

                function J() {
                  X(), N();
                }

                function ie(de, Te) {
                  X(), z(Te);
                }

                S.one("fullscreenchange", J), S.one("fullscreenerror", ie);
                var Q = S.requestFullscreenHelper_(e);
                Q && (Q.then(X, X), Q.then(N, z));
              });
            }

            return this.requestFullscreenHelper_();
          }, l.requestFullscreenHelper_ = function (e) {
            var t = this,
                S;

            if (this.fsApi_.prefixed || (S = this.options_.fullscreen && this.options_.fullscreen.options || {}, e !== void 0 && (S = e)), this.fsApi_.requestFullscreen) {
              var N = this.el_[this.fsApi_.requestFullscreen](S);
              return N && N.then(function () {
                return t.isFullscreen(!0);
              }, function () {
                return t.isFullscreen(!1);
              }), N;
            } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
          }, l.exitFullscreen = function () {
            var e = this.options_.Promise || f.default.Promise;

            if (e) {
              var t = this;
              return new e(function (S, N) {
                function z() {
                  t.off("fullscreenerror", J), t.off("fullscreenchange", X);
                }

                function X() {
                  z(), S();
                }

                function J(Q, de) {
                  z(), N(de);
                }

                t.one("fullscreenchange", X), t.one("fullscreenerror", J);
                var ie = t.exitFullscreenHelper_();
                ie && (ie.then(z, z), ie.then(S, N));
              });
            }

            return this.exitFullscreenHelper_();
          }, l.exitFullscreenHelper_ = function () {
            var e = this;

            if (this.fsApi_.requestFullscreen) {
              var t = y.default[this.fsApi_.exitFullscreen]();
              return t && ot(t.then(function () {
                return e.isFullscreen(!1);
              })), t;
            } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
          }, l.enterFullWindow = function () {
            this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = y.default.documentElement.style.overflow, qe(y.default, "keydown", this.boundFullWindowOnEscKey_), y.default.documentElement.style.overflow = "hidden", et(y.default.body, "vjs-full-window"), this.trigger("enterFullWindow");
          }, l.fullWindowOnEscKey = function (e) {
            i.default.isEventKey(e, "Esc") && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
          }, l.exitFullWindow = function () {
            this.isFullscreen(!1), this.isFullWindow = !1, Ve(y.default, "keydown", this.boundFullWindowOnEscKey_), y.default.documentElement.style.overflow = this.docOrigOverflow, _t(y.default.body, "vjs-full-window"), this.trigger("exitFullWindow");
          }, l.disablePictureInPicture = function (e) {
            if (e === void 0) return this.techGet_("disablePictureInPicture");
            this.techCall_("setDisablePictureInPicture", e), this.options_.disablePictureInPicture = e, this.trigger("disablepictureinpicturechanged");
          }, l.isInPictureInPicture = function (e) {
            if (e !== void 0) {
              this.isInPictureInPicture_ = !!e, this.togglePictureInPictureClass_();
              return;
            }

            return !!this.isInPictureInPicture_;
          }, l.requestPictureInPicture = function () {
            if ("pictureInPictureEnabled" in y.default && this.disablePictureInPicture() === !1) return this.techGet_("requestPictureInPicture");
          }, l.exitPictureInPicture = function () {
            if ("pictureInPictureEnabled" in y.default) return y.default.exitPictureInPicture();
          }, l.handleKeyDown = function (e) {
            var t = this.options_.userActions;

            if (!(!t || !t.hotkeys)) {
              var S = function (z) {
                var X = z.tagName.toLowerCase();
                if (z.isContentEditable) return !0;
                var J = ["button", "checkbox", "hidden", "radio", "reset", "submit"];
                if (X === "input") return J.indexOf(z.type) === -1;
                var ie = ["textarea"];
                return ie.indexOf(X) !== -1;
              };

              S(this.el_.ownerDocument.activeElement) || (typeof t.hotkeys == "function" ? t.hotkeys.call(this, e) : this.handleHotkeys(e));
            }
          }, l.handleHotkeys = function (e) {
            var t = this.options_.userActions ? this.options_.userActions.hotkeys : {},
                S = t.fullscreenKey,
                N = S === void 0 ? function (Oe) {
              return i.default.isEventKey(Oe, "f");
            } : S,
                z = t.muteKey,
                X = z === void 0 ? function (Oe) {
              return i.default.isEventKey(Oe, "m");
            } : z,
                J = t.playPauseKey,
                ie = J === void 0 ? function (Oe) {
              return i.default.isEventKey(Oe, "k") || i.default.isEventKey(Oe, "Space");
            } : J;

            if (N.call(this, e)) {
              e.preventDefault(), e.stopPropagation();
              var Q = fe.getComponent("FullscreenToggle");
              y.default[this.fsApi_.fullscreenEnabled] !== !1 && Q.prototype.handleClick.call(this, e);
            } else if (X.call(this, e)) {
              e.preventDefault(), e.stopPropagation();
              var de = fe.getComponent("MuteToggle");
              de.prototype.handleClick.call(this, e);
            } else if (ie.call(this, e)) {
              e.preventDefault(), e.stopPropagation();
              var Te = fe.getComponent("PlayToggle");
              Te.prototype.handleClick.call(this, e);
            }
          }, l.canPlayType = function (e) {
            for (var t, S = 0, N = this.options_.techOrder; S < N.length; S++) {
              var z = N[S],
                  X = Be.getTech(z);

              if (X || (X = fe.getComponent(z)), !X) {
                $.error('The "' + z + '" tech is undefined. Skipped browser support check for that tech.');
                continue;
              }

              if (X.isSupported() && (t = X.canPlayType(e), t)) return t;
            }

            return "";
          }, l.selectSource = function (e) {
            var t = this,
                S = this.options_.techOrder.map(function (ie) {
              return [ie, Be.getTech(ie)];
            }).filter(function (ie) {
              var Q = ie[0],
                  de = ie[1];
              return de ? de.isSupported() : ($.error('The "' + Q + '" tech is undefined. Skipped browser support check for that tech.'), !1);
            }),
                N = function (Q, de, Te) {
              var Oe;
              return Q.some(function (ht) {
                return de.some(function (hi) {
                  if (Oe = Te(ht, hi), Oe) return !0;
                });
              }), Oe;
            },
                z,
                X = function (Q) {
              return function (de, Te) {
                return Q(Te, de);
              };
            },
                J = function (Q, de) {
              var Te = Q[0],
                  Oe = Q[1];
              if (Oe.canPlaySource(de, t.options_[Te.toLowerCase()])) return {
                source: de,
                tech: Te
              };
            };

            return this.options_.sourceOrder ? z = N(e, S, X(J)) : z = N(S, e, J), z || !1;
          }, l.handleSrc_ = function (e, t) {
            var S = this;
            if (typeof e == "undefined") return this.cache_.src || "";
            this.resetRetryOnError_ && this.resetRetryOnError_();

            var N = _a(e);

            if (!N.length) {
              this.setTimeout(function () {
                this.error({
                  code: 4,
                  message: this.localize(this.options_.notSupportedMessage)
                });
              }, 0);
              return;
            }

            if (this.changingSrc_ = !0, t || (this.cache_.sources = N), this.updateSourceCaches_(N[0]), ca(this, N[0], function (J, ie) {
              S.middleware_ = ie, t || (S.cache_.sources = N), S.updateSourceCaches_(J);
              var Q = S.src_(J);

              if (Q) {
                if (N.length > 1) return S.handleSrc_(N.slice(1));
                S.changingSrc_ = !1, S.setTimeout(function () {
                  this.error({
                    code: 4,
                    message: this.localize(this.options_.notSupportedMessage)
                  });
                }, 0), S.triggerReady();
                return;
              }

              da(ie, S.tech_);
            }), this.options_.retryOnError && N.length > 1) {
              var z = function () {
                S.error(null), S.handleSrc_(N.slice(1), !0);
              },
                  X = function () {
                S.off("error", z);
              };

              this.one("error", z), this.one("playing", X), this.resetRetryOnError_ = function () {
                S.off("error", z), S.off("playing", X);
              };
            }
          }, l.src = function (e) {
            return this.handleSrc_(e, !1);
          }, l.src_ = function (e) {
            var t = this,
                S = this.selectSource([e]);
            return S ? Vn(S.tech, this.techName_) ? (this.ready(function () {
              this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", e) : this.techCall_("src", e.src), this.changingSrc_ = !1;
            }, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(S.tech, S.source), this.tech_.ready(function () {
              t.changingSrc_ = !1;
            }), !1) : !0;
          }, l.load = function () {
            this.techCall_("load");
          }, l.reset = function () {
            var e = this,
                t = this.options_.Promise || f.default.Promise;
            if (this.paused() || !t) this.doReset_();else {
              var S = this.play();
              ot(S.then(function () {
                return e.doReset_();
              }));
            }
          }, l.doReset_ = function () {
            this.tech_ && this.tech_.clearTracks("text"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), ft(this) && this.trigger("playerreset");
          }, l.resetControlBarUI_ = function () {
            this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
          }, l.resetProgressBar_ = function () {
            this.currentTime(0);
            var e = this.controlBar,
                t = e.durationDisplay,
                S = e.remainingTimeDisplay;
            t && t.updateContent(), S && S.updateContent();
          }, l.resetPlaybackRate_ = function () {
            this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
          }, l.resetVolumeBar_ = function () {
            this.volume(1), this.trigger("volumechange");
          }, l.currentSources = function () {
            var e = this.currentSource(),
                t = [];
            return Object.keys(e).length !== 0 && t.push(e), this.cache_.sources || t;
          }, l.currentSource = function () {
            return this.cache_.source || {};
          }, l.currentSrc = function () {
            return this.currentSource() && this.currentSource().src || "";
          }, l.currentType = function () {
            return this.currentSource() && this.currentSource().type || "";
          }, l.preload = function (e) {
            if (e !== void 0) {
              this.techCall_("setPreload", e), this.options_.preload = e;
              return;
            }

            return this.techGet_("preload");
          }, l.autoplay = function (e) {
            if (e === void 0) return this.options_.autoplay || !1;
            var t;
            typeof e == "string" && /(any|play|muted)/.test(e) || e === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = e, this.manualAutoplay_(typeof e == "string" ? e : "play"), t = !1) : e ? this.options_.autoplay = !0 : this.options_.autoplay = !1, t = typeof t == "undefined" ? this.options_.autoplay : t, this.tech_ && this.techCall_("setAutoplay", t);
          }, l.playsinline = function (e) {
            return e !== void 0 ? (this.techCall_("setPlaysinline", e), this.options_.playsinline = e, this) : this.techGet_("playsinline");
          }, l.loop = function (e) {
            if (e !== void 0) {
              this.techCall_("setLoop", e), this.options_.loop = e;
              return;
            }

            return this.techGet_("loop");
          }, l.poster = function (e) {
            if (e === void 0) return this.poster_;
            e || (e = ""), e !== this.poster_ && (this.poster_ = e, this.techCall_("setPoster", e), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
          }, l.handleTechPosterChange_ = function () {
            if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
              var e = this.tech_.poster() || "";
              e !== this.poster_ && (this.poster_ = e, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
            }
          }, l.controls = function (e) {
            if (e === void 0) return !!this.controls_;
            e = !!e, this.controls_ !== e && (this.controls_ = e, this.usingNativeControls() && this.techCall_("setControls", e), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
          }, l.usingNativeControls = function (e) {
            if (e === void 0) return !!this.usingNativeControls_;
            e = !!e, this.usingNativeControls_ !== e && (this.usingNativeControls_ = e, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
          }, l.error = function (e) {
            var t = this;
            if (e === void 0) return this.error_ || null;

            if (s("beforeerror").forEach(function (N) {
              var z = N(t, e);

              if (!(ye(z) && !Array.isArray(z) || typeof z == "string" || typeof z == "number" || z === null)) {
                t.log.error("please return a value that MediaError expects in beforeerror hooks");
                return;
              }

              e = z;
            }), this.options_.suppressNotSupportedError && e && e.code === 4) {
              var S = function () {
                this.error(e);
              };

              this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], S), this.one("loadstart", function () {
                this.off(["click", "touchstart"], S);
              });
              return;
            }

            if (e === null) {
              this.error_ = e, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
              return;
            }

            this.error_ = new Ye(e), this.addClass("vjs-error"), $.error("(CODE:" + this.error_.code + " " + Ye.errorTypes[this.error_.code] + ")", this.error_.message, this.error_), this.trigger("error"), s("error").forEach(function (N) {
              return N(t, t.error_);
            });
          }, l.reportUserActivity = function (e) {
            this.userActivity_ = !0;
          }, l.userActive = function (e) {
            if (e === void 0) return this.userActive_;

            if (e = !!e, e !== this.userActive_) {
              if (this.userActive_ = e, this.userActive_) {
                this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
                return;
              }

              this.tech_ && this.tech_.one("mousemove", function (t) {
                t.stopPropagation(), t.preventDefault();
              }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
            }
          }, l.listenForUserActivity_ = function () {
            var e,
                t,
                S,
                N = Fe(this, this.reportUserActivity),
                z = function (Te) {
              (Te.screenX !== t || Te.screenY !== S) && (t = Te.screenX, S = Te.screenY, N());
            },
                X = function () {
              N(), this.clearInterval(e), e = this.setInterval(N, 250);
            },
                J = function (Te) {
              N(), this.clearInterval(e);
            };

            this.on("mousedown", X), this.on("mousemove", z), this.on("mouseup", J), this.on("mouseleave", J);
            var ie = this.getChild("controlBar");
            ie && !De && !Me && (ie.on("mouseenter", function (de) {
              this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
            }), ie.on("mouseleave", function (de) {
              this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
            })), this.on("keydown", N), this.on("keyup", N);
            var Q;
            this.setInterval(function () {
              if (!!this.userActivity_) {
                this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(Q);
                var de = this.options_.inactivityTimeout;
                de <= 0 || (Q = this.setTimeout(function () {
                  this.userActivity_ || this.userActive(!1);
                }, de));
              }
            }, 250);
          }, l.playbackRate = function (e) {
            if (e !== void 0) {
              this.techCall_("setPlaybackRate", e);
              return;
            }

            return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
          }, l.defaultPlaybackRate = function (e) {
            return e !== void 0 ? this.techCall_("setDefaultPlaybackRate", e) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1;
          }, l.isAudio = function (e) {
            if (e !== void 0) {
              this.isAudio_ = !!e;
              return;
            }

            return !!this.isAudio_;
          }, l.addTextTrack = function (e, t, S) {
            if (this.tech_) return this.tech_.addTextTrack(e, t, S);
          }, l.addRemoteTextTrack = function (e, t) {
            if (this.tech_) return this.tech_.addRemoteTextTrack(e, t);
          }, l.removeRemoteTextTrack = function (e) {
            e === void 0 && (e = {});
            var t = e,
                S = t.track;
            if (S || (S = e), this.tech_) return this.tech_.removeRemoteTextTrack(S);
          }, l.getVideoPlaybackQuality = function () {
            return this.techGet_("getVideoPlaybackQuality");
          }, l.videoWidth = function () {
            return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
          }, l.videoHeight = function () {
            return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
          }, l.language = function (e) {
            if (e === void 0) return this.language_;
            this.language_ !== String(e).toLowerCase() && (this.language_ = String(e).toLowerCase(), ft(this) && this.trigger("languagechange"));
          }, l.languages = function () {
            return je(T.prototype.options_.languages, this.languages_);
          }, l.toJSON = function () {
            var e = je(this.options_),
                t = e.tracks;
            e.tracks = [];

            for (var S = 0; S < t.length; S++) {
              var N = t[S];
              N = je(N), N.player = void 0, e.tracks[S] = N;
            }

            return e;
          }, l.createModal = function (e, t) {
            var S = this;
            t = t || {}, t.content = e || "";
            var N = new Rt(this, t);
            return this.addChild(N), N.on("dispose", function () {
              S.removeChild(N);
            }), N.open(), N;
          }, l.updateCurrentBreakpoint_ = function () {
            if (!!this.responsive()) for (var e = this.currentBreakpoint(), t = this.currentWidth(), S = 0; S < di.length; S++) {
              var N = di[S],
                  z = this.breakpoints_[N];

              if (t <= z) {
                if (e === N) return;
                e && this.removeClass(vr[e]), this.addClass(vr[N]), this.breakpoint_ = N;
                break;
              }
            }
          }, l.removeCurrentBreakpoint_ = function () {
            var e = this.currentBreakpointClass();
            this.breakpoint_ = "", e && this.removeClass(e);
          }, l.breakpoints = function (e) {
            return e === void 0 ? he(this.breakpoints_) : (this.breakpoint_ = "", this.breakpoints_ = he({}, Ja, e), this.updateCurrentBreakpoint_(), he(this.breakpoints_));
          }, l.responsive = function (e) {
            if (e === void 0) return this.responsive_;
            e = Boolean(e);
            var t = this.responsive_;
            if (e !== t) return this.responsive_ = e, e ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), e;
          }, l.currentBreakpoint = function () {
            return this.breakpoint_;
          }, l.currentBreakpointClass = function () {
            return vr[this.breakpoint_] || "";
          }, l.loadMedia = function (e, t) {
            var S = this;

            if (!(!e || typeof e != "object")) {
              this.reset(), this.cache_.media = je(e);
              var N = this.cache_.media,
                  z = N.artwork,
                  X = N.poster,
                  J = N.src,
                  ie = N.textTracks;
              !z && X && (this.cache_.media.artwork = [{
                src: X,
                type: or(X)
              }]), J && this.src(J), X && this.poster(X), Array.isArray(ie) && ie.forEach(function (Q) {
                return S.addRemoteTextTrack(Q, !1);
              }), this.ready(t);
            }
          }, l.getMedia = function () {
            if (!this.cache_.media) {
              var e = this.poster(),
                  t = this.currentSources(),
                  S = Array.prototype.map.call(this.remoteTextTracks(), function (z) {
                return {
                  kind: z.kind,
                  label: z.label,
                  language: z.language,
                  src: z.src
                };
              }),
                  N = {
                src: t,
                textTracks: S
              };
              return e && (N.poster = e, N.artwork = [{
                src: N.poster,
                type: or(N.poster)
              }]), N;
            }

            return je(this.cache_.media);
          }, T.getTagSettings = function (e) {
            var t = {
              sources: [],
              tracks: []
            },
                S = Ze(e),
                N = S["data-setup"];

            if (ct(e, "vjs-fill") && (S.fill = !0), ct(e, "vjs-fluid") && (S.fluid = !0), N !== null) {
              var z = v.default(N || "{}"),
                  X = z[0],
                  J = z[1];
              X && $.error(X), he(S, J);
            }

            if (he(t, S), e.hasChildNodes()) for (var ie = e.childNodes, Q = 0, de = ie.length; Q < de; Q++) {
              var Te = ie[Q],
                  Oe = Te.nodeName.toLowerCase();
              Oe === "source" ? t.sources.push(Ze(Te)) : Oe === "track" && t.tracks.push(Ze(Te));
            }
            return t;
          }, l.flexNotSupported_ = function () {
            var e = y.default.createElement("i");
            return !("flexBasis" in e.style || "webkitFlexBasis" in e.style || "mozFlexBasis" in e.style || "msFlexBasis" in e.style || "msFlexOrder" in e.style);
          }, l.debug = function (e) {
            if (e === void 0) return this.debugEnabled_;
            e ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
          }, l.playbackRates = function (e) {
            if (e === void 0) return this.cache_.playbackRates;
            !Array.isArray(e) || !e.every(function (t) {
              return typeof t == "number";
            }) || (this.cache_.playbackRates = e, this.trigger("playbackrateschange"));
          }, T;
        }(fe);

        $e.names.forEach(function (m) {
          var T = $e[m];

          He.prototype[T.getterName] = function () {
            return this.tech_ ? this.tech_[T.getterName]() : (this[T.privateName] = this[T.privateName] || new T.ListClass(), this[T.privateName]);
          };
        }), He.prototype.crossorigin = He.prototype.crossOrigin, He.players = {};
        var Yt = f.default.navigator;
        He.prototype.options_ = {
          techOrder: Be.defaultTechOrder_,
          html5: {},
          inactivityTimeout: 2e3,
          playbackRates: [],
          liveui: !1,
          children: ["mediaLoader", "posterImage", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
          language: Yt && (Yt.languages && Yt.languages[0] || Yt.userLanguage || Yt.language) || "en",
          languages: {},
          notSupportedMessage: "No compatible source was found for this media.",
          normalizeAutoplay: !1,
          fullscreen: {
            options: {
              navigationUI: "hide"
            }
          },
          breakpoints: {},
          responsive: !1
        }, ["ended", "seeking", "seekable", "networkState", "readyState"].forEach(function (m) {
          He.prototype[m] = function () {
            return this.techGet_(m);
          };
        }), In.forEach(function (m) {
          He.prototype["handleTech" + Ke(m) + "_"] = function () {
            return this.trigger(m);
          };
        }), fe.registerComponent("Player", He);

        var pr = "plugin",
            Nt = "activePlugins_",
            Ut = {},
            gr = function (T) {
          return Ut.hasOwnProperty(T);
        },
            mr = function (T) {
          return gr(T) ? Ut[T] : void 0;
        },
            Rn = function (T, l) {
          T[Nt] = T[Nt] || {}, T[Nt][l] = !0;
        },
            yr = function (T, l, r) {
          var e = (r ? "before" : "") + "pluginsetup";
          T.trigger(e, l), T.trigger(e + ":" + l.name, l);
        },
            Za = function (T, l) {
          var r = function () {
            yr(this, {
              name: T,
              plugin: l,
              instance: null
            }, !0);
            var t = l.apply(this, arguments);
            return Rn(this, T), yr(this, {
              name: T,
              plugin: l,
              instance: t
            }), t;
          };

          return Object.keys(l).forEach(function (e) {
            r[e] = l[e];
          }), r;
        },
            Mn = function (T, l) {
          return l.prototype.name = T, function () {
            yr(this, {
              name: T,
              plugin: l,
              instance: null
            }, !0);

            for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++) e[t] = arguments[t];

            var S = p.default(l, [this].concat(e));
            return this[T] = function () {
              return S;
            }, yr(this, S.getEventHash()), S;
          };
        },
            lt = function () {
          function m(l) {
            if (this.constructor === m) throw new Error("Plugin must be sub-classed; not directly instantiated.");
            this.player = l, this.log || (this.log = this.player.log.createLogger(this.name)), Pr(this), delete this.trigger, Ri(this, this.constructor.defaultState), Rn(l, this.name), this.dispose = this.dispose.bind(this), l.on("dispose", this.dispose);
          }

          var T = m.prototype;
          return T.version = function () {
            return this.constructor.VERSION;
          }, T.getEventHash = function (r) {
            return r === void 0 && (r = {}), r.name = this.name, r.plugin = this.constructor, r.instance = this, r;
          }, T.trigger = function (r, e) {
            return e === void 0 && (e = {}), Ot(this.eventBusEl_, r, this.getEventHash(e));
          }, T.handleStateChanged = function (r) {}, T.dispose = function () {
            var r = this.name,
                e = this.player;
            this.trigger("dispose"), this.off(), e.off("dispose", this.dispose), e[Nt][r] = !1, this.player = this.state = null, e[r] = Mn(r, Ut[r]);
          }, m.isBasic = function (r) {
            var e = typeof r == "string" ? mr(r) : r;
            return typeof e == "function" && !m.prototype.isPrototypeOf(e.prototype);
          }, m.registerPlugin = function (r, e) {
            if (typeof r != "string") throw new Error('Illegal plugin name, "' + r + '", must be a string, was ' + typeof r + ".");
            if (gr(r)) $.warn('A plugin named "' + r + '" already exists. You may want to avoid re-registering plugins!');else if (He.prototype.hasOwnProperty(r)) throw new Error('Illegal plugin name, "' + r + '", cannot share a name with an existing player method!');
            if (typeof e != "function") throw new Error('Illegal plugin for "' + r + '", must be a function, was ' + typeof e + ".");
            return Ut[r] = e, r !== pr && (m.isBasic(e) ? He.prototype[r] = Za(r, e) : He.prototype[r] = Mn(r, e)), e;
          }, m.deregisterPlugin = function (r) {
            if (r === pr) throw new Error("Cannot de-register base plugin.");
            gr(r) && (delete Ut[r], delete He.prototype[r]);
          }, m.getPlugins = function (r) {
            r === void 0 && (r = Object.keys(Ut));
            var e;
            return r.forEach(function (t) {
              var S = mr(t);
              S && (e = e || {}, e[t] = S);
            }), e;
          }, m.getPluginVersion = function (r) {
            var e = mr(r);
            return e && e.VERSION || "";
          }, m;
        }();

        lt.getPlugin = mr, lt.BASE_PLUGIN_NAME = pr, lt.registerPlugin(pr, lt), He.prototype.usingPlugin = function (m) {
          return !!this[Nt] && this[Nt][m] === !0;
        }, He.prototype.hasPlugin = function (m) {
          return !!gr(m);
        };

        var qa = function (T, l) {
          l === void 0 && (l = {});

          var r = function () {
            T.apply(this, arguments);
          },
              e = {};

          typeof l == "object" ? (l.constructor !== Object.prototype.constructor && (r = l.constructor), e = l) : typeof l == "function" && (r = l), C.default(r, T), T && (r.super_ = T);

          for (var t in e) e.hasOwnProperty(t) && (r.prototype[t] = e[t]);

          return r;
        },
            xn = function (T) {
          return T.indexOf("#") === 0 ? T.slice(1) : T;
        };

        function Se(m, T, l) {
          var r = Se.getPlayer(m);
          if (r) return T && $.warn('Player "' + m + '" is already initialised. Options will not be applied.'), l && r.ready(l), r;
          var e = typeof m == "string" ? gt("#" + xn(m)) : m;
          if (!We(e)) throw new TypeError("The element or ID supplied is not valid. (videojs)");
          (!e.ownerDocument.defaultView || !e.ownerDocument.body.contains(e)) && $.warn("The element supplied is not included in the DOM"), T = T || {}, s("beforesetup").forEach(function (S) {
            var N = S(e, je(T));

            if (!ye(N) || Array.isArray(N)) {
              $.error("please return an object in beforesetup hooks");
              return;
            }

            T = je(T, N);
          });
          var t = fe.getComponent("Player");
          return r = new t(e, T, l), s("setup").forEach(function (S) {
            return S(r);
          }), r;
        }

        if (Se.hooks_ = g, Se.hooks = s, Se.hook = o, Se.hookOnce = A, Se.removeHook = b, f.default.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && ze()) {
          var Er = gt(".vjs-styles-defaults");

          if (!Er) {
            Er = Ci("vjs-styles-defaults");
            var fi = gt("head");
            fi && fi.insertBefore(Er, fi.firstChild), Li(Er, "\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid {\n        padding-top: 56.25%\n      }\n    ");
          }
        }

        br(1, Se), Se.VERSION = _, Se.options = He.prototype.options_, Se.getPlayers = function () {
          return He.players;
        }, Se.getPlayer = function (m) {
          var T = He.players,
              l;

          if (typeof m == "string") {
            var r = xn(m),
                e = T[r];
            if (e) return e;
            l = gt("#" + r);
          } else l = m;

          if (We(l)) {
            var t = l,
                S = t.player,
                N = t.playerId;
            if (S || T[N]) return S || T[N];
          }
        }, Se.getAllPlayers = function () {
          return Object.keys(He.players).map(function (m) {
            return He.players[m];
          }).filter(Boolean);
        }, Se.players = He.players, Se.getComponent = fe.getComponent, Se.registerComponent = function (m, T) {
          Be.isTech(T) && $.warn("The " + m + " tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)"), fe.registerComponent.call(fe, m, T);
        }, Se.getTech = Be.getTech, Se.registerTech = Be.registerTech, Se.use = ua, Object.defineProperty(Se, "middleware", {
          value: {},
          writeable: !1,
          enumerable: !0
        }), Object.defineProperty(Se.middleware, "TERMINATOR", {
          value: sr,
          writeable: !1,
          enumerable: !0
        }), Se.browser = Ue, Se.TOUCH_ENABLED = Ce, Se.extend = qa, Se.mergeOptions = je, Se.bind = Fe, Se.registerPlugin = lt.registerPlugin, Se.deregisterPlugin = lt.deregisterPlugin, Se.plugin = function (m, T) {
          return $.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), lt.registerPlugin(m, T);
        }, Se.getPlugins = lt.getPlugins, Se.getPlugin = lt.getPlugin, Se.getPluginVersion = lt.getPluginVersion, Se.addLanguage = function (m, T) {
          var l;
          return m = ("" + m).toLowerCase(), Se.options.languages = je(Se.options.languages, (l = {}, l[m] = T, l)), Se.options.languages[m];
        }, Se.log = $, Se.createLogger = q, Se.createTimeRange = Se.createTimeRanges = bt, Se.formatTime = wt, Se.setFormatTime = Pa, Se.resetFormatTime = Oa, Se.parseUrl = Fr, Se.isCrossOrigin = ar, Se.EventTarget = Ge, Se.on = qe, Se.one = tr, Se.off = Ve, Se.trigger = Ot, Se.xhr = h.default, Se.TextTrack = Vt, Se.AudioTrack = Ki, Se.VideoTrack = Hi, ["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach(function (m) {
          Se[m] = function () {
            return $.warn("videojs." + m + "() is deprecated; use videojs.dom." + m + "() instead"), Si[m].apply(null, arguments);
          };
        }), Se.computedStyle = _e, Se.dom = Si, Se.url = aa, Se.defineLazyProperty = ui, Se.addLanguage("en", {
          "Non-Fullscreen": "Exit Fullscreen"
        }), ve.exports = Se;
      },
      288: (ve, ae, K) => {
        /**
        * videojs-mux
        * @version 4.2.0
        * @copyright 2021 Mux, Inc.
        * @license
        */
        (function () {
          var R = !1;

          (function (j, x) {
            if (!0) ve.exports = x(K(207));else var k, H;
          })(typeof self != "undefined" ? self : this, function (j) {
            return function (x) {
              function k(w) {
                if (H[w]) return H[w].exports;
                var O = H[w] = {
                  i: w,
                  l: !1,
                  exports: {}
                };
                return x[w].call(O.exports, O, O.exports, k), O.l = !0, O.exports;
              }

              var H = {};
              return k.m = x, k.c = H, k.d = function (w, O, D) {
                k.o(w, O) || Object.defineProperty(w, O, {
                  configurable: !1,
                  enumerable: !0,
                  get: D
                });
              }, k.n = function (w) {
                var O = w && w.__esModule ? function () {
                  return w.default;
                } : function () {
                  return w;
                };
                return k.d(O, "a", O), O;
              }, k.o = function (w, O) {
                return Object.prototype.hasOwnProperty.call(w, O);
              }, k.p = "", k(k.s = 2);
            }([function (x, k, H) {
              (function () {
                (function (w, O) {
                  x.exports = O();
                })(0, function () {
                  return function (w) {
                    function O(E) {
                      if (D[E]) return D[E].exports;
                      var L = D[E] = {
                        i: E,
                        l: !1,
                        exports: {}
                      };
                      return w[E].call(L.exports, L, L.exports, O), L.l = !0, L.exports;
                    }

                    var D = {};
                    return O.m = w, O.c = D, O.d = function (E, L, P) {
                      O.o(E, L) || Object.defineProperty(E, L, {
                        configurable: !1,
                        enumerable: !0,
                        get: P
                      });
                    }, O.n = function (E) {
                      var L = E && E.__esModule ? function () {
                        return E.default;
                      } : function () {
                        return E;
                      };
                      return O.d(L, "a", L), L;
                    }, O.o = function (E, L) {
                      return Object.prototype.hasOwnProperty.call(E, L);
                    }, O.p = "", O(O.s = 16);
                  }([function (w, O, D) {
                    (function (E) {
                      var L;
                      L = typeof window != "undefined" ? window : E !== void 0 ? E : typeof self != "undefined" ? self : {}, w.exports = L;
                    }).call(O, D(6));
                  }, function (w, O) {
                    function D(Z, te, se) {
                      switch (se.length) {
                        case 0:
                          return Z.call(te);

                        case 1:
                          return Z.call(te, se[0]);

                        case 2:
                          return Z.call(te, se[0], se[1]);

                        case 3:
                          return Z.call(te, se[0], se[1], se[2]);
                      }

                      return Z.apply(te, se);
                    }

                    function E(Z, te) {
                      for (var se = -1, ge = Array(Z); ++se < Z;) ge[se] = te(se);

                      return ge;
                    }

                    function L(Z, te) {
                      var se = $(Z) || v(Z) ? E(Z.length, String) : [],
                          ge = se.length,
                          he = !!ge;

                      for (var ye in Z) !te && !B.call(Z, ye) || he && (ye == "length" || u(ye, ge)) || se.push(ye);

                      return se;
                    }

                    function P(Z, te, se) {
                      var ge = Z[te];
                      B.call(Z, te) && a(ge, se) && (se !== void 0 || te in Z) || (Z[te] = se);
                    }

                    function d(Z) {
                      if (!n(Z)) return G(Z);
                      var te = [];

                      for (var se in Object(Z)) B.call(Z, se) && se != "constructor" && te.push(se);

                      return te;
                    }

                    function f(Z, te) {
                      return te = V(te === void 0 ? Z.length - 1 : te, 0), function () {
                        for (var se = arguments, ge = -1, he = V(se.length - te, 0), ye = Array(he); ++ge < he;) ye[ge] = se[te + ge];

                        ge = -1;

                        for (var pe = Array(te + 1); ++ge < te;) pe[ge] = se[ge];

                        return pe[te] = ye, D(Z, this, pe);
                      };
                    }

                    function y(Z, te, se, ge) {
                      se || (se = {});

                      for (var he = -1, ye = te.length; ++he < ye;) {
                        var pe = te[he],
                            _e = ge ? ge(se[pe], Z[pe], pe, se, Z) : void 0;

                        P(se, pe, _e === void 0 ? Z[pe] : _e);
                      }

                      return se;
                    }

                    function u(Z, te) {
                      return !!(te = te == null ? o : te) && (typeof Z == "number" || M.test(Z)) && Z > -1 && Z % 1 == 0 && Z < te;
                    }

                    function i(Z, te, se) {
                      if (!_(se)) return !1;
                      var ge = typeof te;
                      return !!(ge == "number" ? h(se) && u(te, se.length) : ge == "string" && te in se) && a(se[te], Z);
                    }

                    function n(Z) {
                      var te = Z && Z.constructor;
                      return Z === (typeof te == "function" && te.prototype || F);
                    }

                    function a(Z, te) {
                      return Z === te || Z !== Z && te !== te;
                    }

                    function v(Z) {
                      return c(Z) && B.call(Z, "callee") && (!W.call(Z, "callee") || U.call(Z) == b);
                    }

                    function h(Z) {
                      return Z != null && C(Z.length) && !p(Z);
                    }

                    function c(Z) {
                      return g(Z) && h(Z);
                    }

                    function p(Z) {
                      var te = _(Z) ? U.call(Z) : "";
                      return te == A || te == I;
                    }

                    function C(Z) {
                      return typeof Z == "number" && Z > -1 && Z % 1 == 0 && Z <= o;
                    }

                    function _(Z) {
                      var te = typeof Z;
                      return !!Z && (te == "object" || te == "function");
                    }

                    function g(Z) {
                      return !!Z && typeof Z == "object";
                    }

                    function s(Z) {
                      return h(Z) ? L(Z) : d(Z);
                    }

                    var o = 9007199254740991,
                        b = "[object Arguments]",
                        A = "[object Function]",
                        I = "[object GeneratorFunction]",
                        M = /^(?:0|[1-9]\d*)$/,
                        F = Object.prototype,
                        B = F.hasOwnProperty,
                        U = F.toString,
                        W = F.propertyIsEnumerable,
                        G = function (Z, te) {
                      return function (se) {
                        return Z(te(se));
                      };
                    }(Object.keys, Object),
                        V = Math.max,
                        Y = !W.call({
                      valueOf: 1
                    }, "valueOf"),
                        $ = Array.isArray,
                        q = function (Z) {
                      return f(function (te, se) {
                        var ge = -1,
                            he = se.length,
                            ye = he > 1 ? se[he - 1] : void 0,
                            pe = he > 2 ? se[2] : void 0;

                        for (ye = Z.length > 3 && typeof ye == "function" ? (he--, ye) : void 0, pe && i(se[0], se[1], pe) && (ye = he < 3 ? void 0 : ye, he = 1), te = Object(te); ++ge < he;) {
                          var _e = se[ge];
                          _e && Z(te, _e);
                        }

                        return te;
                      });
                    }(function (Z, te) {
                      if (Y || n(te) || h(te)) return void y(te, s(te), Z);

                      for (var se in te) B.call(te, se) && P(Z, se, te[se]);
                    });

                    w.exports = q;
                  }, function (w, O, D) {
                    "use strict";

                    function E(L, P, d) {
                      d = d === void 0 ? 1 : d, L[P] = L[P] || 0, L[P] += d;
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = E;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = D(0),
                        L = function (d) {
                      return d && d.__esModule ? d : {
                        default: d
                      };
                    }(E),
                        P = {};

                    P.now = function () {
                      var d = L.default.performance,
                          f = d && d.timing;
                      return f && typeof f.navigationStart == "number" && typeof d.now == "function" ? f.navigationStart + d.now() : Date.now();
                    }, O.default = P;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = D(18),
                        L = function (d) {
                      return d && d.__esModule ? d : {
                        default: d
                      };
                    }(E),
                        P = L.default.methodFactory;

                    L.default.methodFactory = function (d, f, y) {
                      var u = P(d, f, y);
                      return function () {
                        for (var i = ["[mux]"], n = 0; n < arguments.length; n++) i.push(arguments[n]);

                        u.apply(void 0, i);
                      };
                    }, L.default.setLevel(L.default.getLevel()), O.default = L.default;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = function (d) {
                      return P(d)[0];
                    },
                        L = function (d) {
                      return P(d)[1];
                    },
                        P = function (d) {
                      if (typeof d != "string" || d === "") return ["localhost"];
                      var f = /^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/,
                          y = d.match(f) || [],
                          u = y[4],
                          i = void 0;
                      return u && (i = (u.match(/[^\.]+\.[^\.]+$/) || [])[0]), [u, i];
                    };

                    O.extractHostnameAndDomain = P, O.extractHostname = E, O.extractDomain = L;
                  }, function (w, O) {
                    var D;

                    D = function () {
                      return this;
                    }();

                    try {
                      D = D || Function("return this")() || (0, eval)("this");
                    } catch (E) {
                      typeof window == "object" && (D = window);
                    }

                    w.exports = D;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = function () {
                      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (P) {
                        var d = 16 * Math.random() | 0;
                        return (P === "x" ? d : 3 & d | 8).toString(16);
                      });
                    },
                        L = function () {
                      return ("000000" + (Math.random() * Math.pow(36, 6) << 0).toString(36)).slice(-6);
                    };

                    O.generateUUID = E, O.generateShortID = L;
                  }, function (w, O, D) {
                    "use strict";

                    function E(P) {
                      P = P || "";
                      var d = {};
                      return P.trim().split(/[\r\n]+/).forEach(function (f) {
                        if (f) {
                          var y = f.split(": "),
                              u = y.shift();
                          u && L.indexOf(u.toLowerCase()) >= 0 && (d[u] = y.join(": "));
                        }
                      }), d;
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = E;
                    var L = ["x-cdn", "content-type"];
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.findMediaElement = O.getMuxPlayerId = void 0;

                    var E = D(7),
                        L = function (d) {
                      return d && d.nodeName !== void 0 ? (d.muxId || (d.muxId = d.id || (0, E.generateShortID)()), d.muxId) : d;
                    },
                        P = function (d) {
                      var f = void 0;
                      return d && d.nodeName !== void 0 ? (f = d, d = L(f)) : f = document.querySelector(d), [f, d, f && f.nodeName ? f.nodeName.toLowerCase() : ""];
                    };

                    O.getMuxPlayerId = L, O.findMediaElement = P;
                  }, function (w, O, D) {
                    "use strict";

                    function E() {
                      return (P.default.doNotTrack || P.default.navigator && (P.default.navigator.doNotTrack || P.default.navigator.msDoNotTrack)) === "1";
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = E;

                    var L = D(0),
                        P = function (d) {
                      return d && d.__esModule ? d : {
                        default: d
                      };
                    }(L);
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = D(0),
                        L = function (d) {
                      return d && d.__esModule ? d : {
                        default: d
                      };
                    }(E),
                        P = {};

                    P.exists = function () {
                      var d = L.default.performance;
                      return (d && d.timing) !== void 0;
                    }, P.domContentLoadedEventEnd = function () {
                      var d = L.default.performance,
                          f = d && d.timing;
                      return f && f.domContentLoadedEventEnd;
                    }, P.navigationStart = function () {
                      var d = L.default.performance,
                          f = d && d.timing;
                      return f && f.navigationStart;
                    }, O.default = P;
                  }, function (w, O, D) {
                    "use strict";

                    var E = D(42),
                        L = D(43),
                        P = D(14);
                    w.exports = {
                      formats: P,
                      parse: L,
                      stringify: E
                    };
                  }, function (w, O, D) {
                    "use strict";

                    var E = Object.prototype.hasOwnProperty,
                        L = function () {
                      for (var d = [], f = 0; f < 256; ++f) d.push("%" + ((f < 16 ? "0" : "") + f.toString(16)).toUpperCase());

                      return d;
                    }(),
                        P = function (d) {
                      for (var f; d.length;) {
                        var y = d.pop();

                        if (f = y.obj[y.prop], Array.isArray(f)) {
                          for (var u = [], i = 0; i < f.length; ++i) f[i] !== void 0 && u.push(f[i]);

                          y.obj[y.prop] = u;
                        }
                      }

                      return f;
                    };

                    O.arrayToObject = function (d, f) {
                      for (var y = f && f.plainObjects ? Object.create(null) : {}, u = 0; u < d.length; ++u) d[u] !== void 0 && (y[u] = d[u]);

                      return y;
                    }, O.merge = function (d, f, y) {
                      if (!f) return d;

                      if (typeof f != "object") {
                        if (Array.isArray(d)) d.push(f);else {
                          if (typeof d != "object") return [d, f];
                          (y.plainObjects || y.allowPrototypes || !E.call(Object.prototype, f)) && (d[f] = !0);
                        }
                        return d;
                      }

                      if (typeof d != "object") return [d].concat(f);
                      var u = d;
                      return Array.isArray(d) && !Array.isArray(f) && (u = O.arrayToObject(d, y)), Array.isArray(d) && Array.isArray(f) ? (f.forEach(function (i, n) {
                        E.call(d, n) ? d[n] && typeof d[n] == "object" ? d[n] = O.merge(d[n], i, y) : d.push(i) : d[n] = i;
                      }), d) : Object.keys(f).reduce(function (i, n) {
                        var a = f[n];
                        return E.call(i, n) ? i[n] = O.merge(i[n], a, y) : i[n] = a, i;
                      }, u);
                    }, O.assign = function (d, f) {
                      return Object.keys(f).reduce(function (y, u) {
                        return y[u] = f[u], y;
                      }, d);
                    }, O.decode = function (d) {
                      try {
                        return decodeURIComponent(d.replace(/\+/g, " "));
                      } catch (f) {
                        return d;
                      }
                    }, O.encode = function (d) {
                      if (d.length === 0) return d;

                      for (var f = typeof d == "string" ? d : String(d), y = "", u = 0; u < f.length; ++u) {
                        var i = f.charCodeAt(u);
                        i === 45 || i === 46 || i === 95 || i === 126 || i >= 48 && i <= 57 || i >= 65 && i <= 90 || i >= 97 && i <= 122 ? y += f.charAt(u) : i < 128 ? y += L[i] : i < 2048 ? y += L[192 | i >> 6] + L[128 | 63 & i] : i < 55296 || i >= 57344 ? y += L[224 | i >> 12] + L[128 | i >> 6 & 63] + L[128 | 63 & i] : (u += 1, i = 65536 + ((1023 & i) << 10 | 1023 & f.charCodeAt(u)), y += L[240 | i >> 18] + L[128 | i >> 12 & 63] + L[128 | i >> 6 & 63] + L[128 | 63 & i]);
                      }

                      return y;
                    }, O.compact = function (d) {
                      for (var f = [{
                        obj: {
                          o: d
                        },
                        prop: "o"
                      }], y = [], u = 0; u < f.length; ++u) for (var i = f[u], n = i.obj[i.prop], a = Object.keys(n), v = 0; v < a.length; ++v) {
                        var h = a[v],
                            c = n[h];
                        typeof c == "object" && c !== null && y.indexOf(c) === -1 && (f.push({
                          obj: n,
                          prop: h
                        }), y.push(c));
                      }

                      return P(f);
                    }, O.isRegExp = function (d) {
                      return Object.prototype.toString.call(d) === "[object RegExp]";
                    }, O.isBuffer = function (d) {
                      return d != null && !!(d.constructor && d.constructor.isBuffer && d.constructor.isBuffer(d));
                    };
                  }, function (w, O, D) {
                    "use strict";

                    var E = String.prototype.replace,
                        L = /%20/g;
                    w.exports = {
                      default: "RFC3986",
                      formatters: {
                        RFC1738: function (P) {
                          return E.call(P, L, "+");
                        },
                        RFC3986: function (P) {
                          return P;
                        }
                      },
                      RFC1738: "RFC1738",
                      RFC3986: "RFC3986"
                    };
                  }, function (w, O, D) {
                    "use strict";

                    function E(h) {
                      return h && h.__esModule ? h : {
                        default: h
                      };
                    }

                    function L(h) {
                      var c = {};

                      for (var p in h) h.hasOwnProperty(p) && (c[h[p]] = p);

                      return c;
                    }

                    function P(h) {
                      var c = {},
                          p = {};
                      return Object.keys(h).forEach(function (C) {
                        var _ = !1;

                        if (h.hasOwnProperty(C) && h[C] !== void 0) {
                          var g = C.split("_"),
                              s = g[0],
                              o = n[s];
                          o || (f.default.info("Data key word `" + g[0] + "` not expected in " + C), o = s + "_"), g.splice(1).forEach(function (b) {
                            b === "url" && (_ = !0), v[b] ? o += v[b] : Number(b) && Math.floor(Number(b)) === Number(b) ? o += b : (f.default.info("Data key word `" + b + "` not expected in " + C), o += "_" + b + "_");
                          }), _ ? p[o] = h[C] : c[o] = h[C];
                        }
                      }), (0, u.default)(c, p);
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = P;
                    var d = D(4),
                        f = E(d),
                        y = D(1),
                        u = E(y),
                        i = {
                      a: "env",
                      b: "beacon",
                      c: "custom",
                      d: "ad",
                      e: "event",
                      f: "experiment",
                      m: "mux",
                      n: "response",
                      p: "player",
                      q: "request",
                      r: "retry",
                      s: "session",
                      t: "timestamp",
                      u: "viewer",
                      v: "video",
                      w: "page",
                      x: "view",
                      y: "sub"
                    },
                        n = L(i),
                        a = {
                      ad: "ad",
                      ag: "aggregate",
                      ap: "api",
                      al: "application",
                      ar: "architecture",
                      as: "asset",
                      au: "autoplay",
                      av: "average",
                      bi: "bitrate",
                      br: "break",
                      bw: "browser",
                      by: "bytes",
                      ca: "cached",
                      cb: "cancel",
                      cd: "code",
                      cg: "category",
                      ch: "changed",
                      cn: "config",
                      co: "count",
                      ce: "counter",
                      cp: "complete",
                      cr: "creative",
                      ct: "content",
                      cu: "current",
                      cx: "connection",
                      dg: "downscaling",
                      dm: "domain",
                      dn: "cdn",
                      do: "downscale",
                      du: "duration",
                      dv: "device",
                      ec: "encoding",
                      en: "end",
                      eg: "engine",
                      em: "embed",
                      er: "error",
                      es: "errorcode",
                      et: "errortext",
                      ee: "event",
                      ev: "events",
                      ex: "expires",
                      fi: "first",
                      fm: "family",
                      ft: "format",
                      fq: "frequency",
                      fr: "frame",
                      fs: "fullscreen",
                      he: "headers",
                      ho: "host",
                      hn: "hostname",
                      ht: "height",
                      id: "id",
                      ii: "init",
                      in: "instance",
                      ip: "ip",
                      is: "is",
                      ke: "key",
                      la: "language",
                      lb: "labeled",
                      le: "level",
                      li: "live",
                      ld: "loaded",
                      lo: "load",
                      ls: "lists",
                      lt: "latency",
                      ma: "max",
                      md: "media",
                      me: "message",
                      mi: "mime",
                      ml: "midroll",
                      mm: "min",
                      mn: "manufacturer",
                      mo: "model",
                      mx: "mux",
                      nm: "name",
                      no: "number",
                      on: "on",
                      os: "os",
                      pa: "paused",
                      pb: "playback",
                      pd: "producer",
                      pe: "percentage",
                      pf: "played",
                      pg: "program",
                      ph: "playhead",
                      pi: "plugin",
                      pl: "preroll",
                      pn: "playing",
                      po: "poster",
                      pr: "preload",
                      ps: "position",
                      py: "property",
                      ra: "rate",
                      rd: "requested",
                      re: "rebuffer",
                      rf: "rendition",
                      rm: "remote",
                      ro: "ratio",
                      rp: "response",
                      rq: "request",
                      rs: "requests",
                      sa: "sample",
                      se: "session",
                      sk: "seek",
                      sm: "stream",
                      so: "source",
                      sq: "sequence",
                      sr: "series",
                      st: "start",
                      su: "startup",
                      sv: "server",
                      sw: "software",
                      ta: "tag",
                      tc: "tech",
                      te: "text",
                      th: "throughput",
                      ti: "time",
                      tl: "total",
                      to: "to",
                      tt: "title",
                      ty: "type",
                      ug: "upscaling",
                      up: "upscale",
                      ur: "url",
                      us: "user",
                      va: "variant",
                      vd: "viewed",
                      vi: "video",
                      ve: "version",
                      vw: "view",
                      vr: "viewer",
                      wd: "width",
                      wa: "watch",
                      wt: "waiting"
                    },
                        v = L(a);
                  }, function (w, O, D) {
                    "use strict";

                    w.exports = D(17).default;
                  }, function (w, O, D) {
                    "use strict";

                    function E(b) {
                      return b && b.__esModule ? b : {
                        default: b
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var L = function () {
                      function b(A, I) {
                        var M = [],
                            F = !0,
                            B = !1,
                            U = void 0;

                        try {
                          for (var W, G = A[Symbol.iterator](); !(F = (W = G.next()).done) && (M.push(W.value), !I || M.length !== I); F = !0);
                        } catch (V) {
                          B = !0, U = V;
                        } finally {
                          try {
                            !F && G.return && G.return();
                          } finally {
                            if (B) throw U;
                          }
                        }

                        return M;
                      }

                      return function (A, I) {
                        if (Array.isArray(A)) return A;
                        if (Symbol.iterator in Object(A)) return b(A, I);
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                      };
                    }(),
                        P = D(0),
                        d = E(P),
                        f = D(9),
                        y = D(4),
                        u = E(y),
                        i = D(10),
                        n = E(i),
                        a = D(3),
                        v = E(a),
                        h = D(19),
                        c = E(h),
                        p = D(50),
                        C = E(p),
                        _ = D(51),
                        g = E(_),
                        s = {},
                        o = function b(A) {
                      var I = arguments;
                      typeof A == "string" ? b.hasOwnProperty(A) ? d.default.setTimeout(function () {
                        I = Array.prototype.splice.call(I, 1), b[A].apply(null, I);
                      }, 0) : u.default.warn("`" + A + "` is an unknown task") : typeof A == "function" ? d.default.setTimeout(function () {
                        A(b);
                      }, 0) : u.default.warn("`" + A + "` is invalid.");
                    };

                    o.loaded = v.default.now(), o.NAME = "mux-embed", o.VERSION = "4.2.0", o.API_VERSION = "2.1", o.PLAYER_TRACKED = !1, o.monitor = function (b, A) {
                      return (0, C.default)(o, b, A);
                    }, o.destroyMonitor = function (b) {
                      var A = (0, f.findMediaElement)(b),
                          I = L(A, 1),
                          M = I[0];
                      M && M.mux && typeof M.mux.destroy == "function" ? M.mux.destroy() : u.default.error("A video element monitor for `" + b + "` has not been initialized via `mux.monitor`.");
                    }, o.addHLSJS = function (b, A) {
                      var I = (0, f.getMuxPlayerId)(b);
                      s[I] ? s[I].addHLSJS(A) : u.default.error("A monitor for `" + I + "` has not been initialized.");
                    }, o.addDashJS = function (b, A) {
                      var I = (0, f.getMuxPlayerId)(b);
                      s[I] ? s[I].addDashJS(A) : u.default.error("A monitor for `" + I + "` has not been initialized.");
                    }, o.removeHLSJS = function (b) {
                      var A = (0, f.getMuxPlayerId)(b);
                      s[A] ? s[A].removeHLSJS() : u.default.error("A monitor for `" + A + "` has not been initialized.");
                    }, o.removeDashJS = function (b) {
                      var A = (0, f.getMuxPlayerId)(b);
                      s[A] ? s[A].removeDashJS() : u.default.error("A monitor for `" + A + "` has not been initialized.");
                    }, o.init = function (b, A) {
                      (0, n.default)() && A && A.respectDoNotTrack && u.default.info("The browser's Do Not Track flag is enabled - Mux beaconing is disabled.");
                      var I = (0, f.getMuxPlayerId)(b);
                      s[I] = new c.default(o, I, A);
                    }, o.emit = function (b, A, I) {
                      var M = (0, f.getMuxPlayerId)(b);
                      s[M] ? (s[M].emit(A, I), A === "destroy" && delete s[M]) : u.default.error("A monitor for `" + M + "` has not been initialized.");
                    }, d.default !== void 0 && typeof d.default.addEventListener == "function" && d.default.addEventListener("unload", function () {
                      o.WINDOW_UNLOADING = !0;
                    }, !1), o.checkDoNotTrack = n.default, o.log = u.default, o.utils = g.default, O.default = o;
                  }, function (w, O, D) {
                    var E, L;

                    (function (P, d) {
                      "use strict";

                      E = d, (L = typeof E == "function" ? E.call(O, D, O, w) : E) !== void 0 && (w.exports = L);
                    })(0, function () {
                      "use strict";

                      function P(g, s) {
                        var o = g[s];
                        if (typeof o.bind == "function") return o.bind(g);

                        try {
                          return Function.prototype.bind.call(o, g);
                        } catch (b) {
                          return function () {
                            return Function.prototype.apply.apply(o, [g, arguments]);
                          };
                        }
                      }

                      function d() {
                        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
                      }

                      function f(g) {
                        return g === "debug" && (g = "log"), typeof console !== v && (g === "trace" && h ? d : console[g] !== void 0 ? P(console, g) : console.log !== void 0 ? P(console, "log") : a);
                      }

                      function y(g, s) {
                        for (var o = 0; o < c.length; o++) {
                          var b = c[o];
                          this[b] = o < g ? a : this.methodFactory(b, g, s);
                        }

                        this.log = this.debug;
                      }

                      function u(g, s, o) {
                        return function () {
                          typeof console !== v && (y.call(this, s, o), this[g].apply(this, arguments));
                        };
                      }

                      function i(g, s, o) {
                        return f(g) || u.apply(this, arguments);
                      }

                      function n(g, s, o) {
                        function b(U) {
                          var W = (c[U] || "silent").toUpperCase();

                          if (typeof window !== v && F) {
                            try {
                              return void (window.localStorage[F] = W);
                            } catch (G) {}

                            try {
                              window.document.cookie = encodeURIComponent(F) + "=" + W + ";";
                            } catch (G) {}
                          }
                        }

                        function A() {
                          var U;

                          if (typeof window !== v && F) {
                            try {
                              U = window.localStorage[F];
                            } catch (V) {}

                            if (typeof U === v) try {
                              var W = window.document.cookie,
                                  G = W.indexOf(encodeURIComponent(F) + "=");
                              G !== -1 && (U = /^([^;]+)/.exec(W.slice(G))[1]);
                            } catch (V) {}
                            return M.levels[U] === void 0 && (U = void 0), U;
                          }
                        }

                        var I,
                            M = this,
                            F = "loglevel";
                        typeof g == "string" ? F += ":" + g : typeof g == "symbol" && (F = void 0), M.name = g, M.levels = {
                          TRACE: 0,
                          DEBUG: 1,
                          INFO: 2,
                          WARN: 3,
                          ERROR: 4,
                          SILENT: 5
                        }, M.methodFactory = o || i, M.getLevel = function () {
                          return I;
                        }, M.setLevel = function (U, W) {
                          if (typeof U == "string" && M.levels[U.toUpperCase()] !== void 0 && (U = M.levels[U.toUpperCase()]), !(typeof U == "number" && U >= 0 && U <= M.levels.SILENT)) throw "log.setLevel() called with invalid level: " + U;
                          if (I = U, W !== !1 && b(U), y.call(M, U, g), typeof console === v && U < M.levels.SILENT) return "No console available for logging";
                        }, M.setDefaultLevel = function (U) {
                          A() || M.setLevel(U, !1);
                        }, M.enableAll = function (U) {
                          M.setLevel(M.levels.TRACE, U);
                        }, M.disableAll = function (U) {
                          M.setLevel(M.levels.SILENT, U);
                        };
                        var B = A();
                        B == null && (B = s == null ? "WARN" : s), M.setLevel(B, !1);
                      }

                      var a = function () {},
                          v = "undefined",
                          h = typeof window !== v && typeof window.navigator !== v && /Trident\/|MSIE /.test(window.navigator.userAgent),
                          c = ["trace", "debug", "info", "warn", "error"],
                          p = new n(),
                          C = {};

                      p.getLogger = function (g) {
                        if (typeof g != "symbol" && typeof g != "string" || g === "") throw new TypeError("You must supply a name when creating a logger.");
                        var s = C[g];
                        return s || (s = C[g] = new n(g, p.getLevel(), p.methodFactory)), s;
                      };

                      var _ = typeof window !== v ? window.log : void 0;

                      return p.noConflict = function () {
                        return typeof window !== v && window.log === p && (window.log = _), p;
                      }, p.getLoggers = function () {
                        return C;
                      }, p.default = p, p;
                    });
                  }, function (w, O, D) {
                    "use strict";

                    function E(re) {
                      return re && re.__esModule ? re : {
                        default: re
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var L = function () {
                      function re(ne, ce) {
                        var me = [],
                            Ae = !0,
                            Ce = !1,
                            Ie = void 0;

                        try {
                          for (var ke, De = ne[Symbol.iterator](); !(Ae = (ke = De.next()).done) && (me.push(ke.value), !ce || me.length !== ce); Ae = !0);
                        } catch (Re) {
                          Ce = !0, Ie = Re;
                        } finally {
                          try {
                            !Ae && De.return && De.return();
                          } finally {
                            if (Ce) throw Ie;
                          }
                        }

                        return me;
                      }

                      return function (ne, ce) {
                        if (Array.isArray(ne)) return ne;
                        if (Symbol.iterator in Object(ne)) return re(ne, ce);
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                      };
                    }(),
                        P = D(4),
                        d = E(P),
                        f = D(1),
                        y = E(f),
                        u = D(7),
                        i = D(5),
                        n = D(0),
                        a = E(n),
                        v = D(11),
                        h = E(v),
                        c = D(2),
                        p = E(c),
                        C = D(20),
                        _ = E(C),
                        g = D(25),
                        s = D(26),
                        o = D(27),
                        b = E(o),
                        A = D(28),
                        I = E(A),
                        M = D(29),
                        F = E(M),
                        B = D(30),
                        U = E(B),
                        W = D(31),
                        G = E(W),
                        V = D(32),
                        Y = E(V),
                        $ = D(33),
                        q = E($),
                        Z = D(34),
                        te = E(Z),
                        se = D(35),
                        ge = E(se),
                        he = D(36),
                        ye = E(he),
                        pe = D(37),
                        _e = E(pe),
                        be = D(38),
                        Le = E(be),
                        we = D(39),
                        xe = E(we),
                        Ne = D(40),
                        Me = E(Ne),
                        le = D(49),
                        ee = E(le),
                        oe = ["viewstart", "ended", "loadstart", "pause", "play", "playing", "ratechange", "waiting", "adplay", "adpause", "adended", "aderror", "adplaying", "adrequest", "adresponse", "adbreakstart", "adbreakend", "adfirstquartile", "admidpoint", "adthirdquartile", "rebufferstart", "rebufferend", "seeked", "error", "hb", "requestcompleted", "requestfailed", "requestcanceled", "renditionchange"],
                        ue = function (re, ne, ce) {
                      var me = this;
                      this.DOM_CONTENT_LOADED_EVENT_END = h.default.domContentLoadedEventEnd(), this.NAVIGATION_START = h.default.navigationStart();
                      var Ae = {
                        debug: !1,
                        minimumRebufferDuration: 250,
                        sustainedRebufferThreshold: 1e3,
                        playbackHeartbeatTime: 25,
                        beaconDomain: "litix.io",
                        sampleRate: 1,
                        disableCookies: !1,
                        respectDoNotTrack: !1,
                        disableRebufferTracking: !1,
                        errorTranslator: function (Re) {
                          return Re;
                        }
                      };
                      this.mux = re, this.id = ne, ce = (0, y.default)(Ae, ce), ce.data = ce.data || {}, ce.data.property_key && (ce.data.env_key = ce.data.property_key, delete ce.data.property_key), d.default.setLevel(ce.debug ? "debug" : "warn"), this.getPlayheadTime = ce.getPlayheadTime, this.getStateData = ce.getStateData || function () {}, this.getAdData = ce.getAdData || function () {}, this.minimumRebufferDuration = ce.minimumRebufferDuration, this.sustainedRebufferThreshold = ce.sustainedRebufferThreshold, this.playbackHeartbeatTime = ce.playbackHeartbeatTime, this.disableRebufferTracking = ce.disableRebufferTracking, this.disableRebufferTracking && this.mux.log.warn("Disabling rebuffer tracking. This should only be used in specific circumstances as a last resort when your player is known to unreliably track rebuffering."), this.errorTranslator = ce.errorTranslator, this.playbackEventDispatcher = new Me.default(re, ce.data.env_key, ce), this.data = {
                        player_instance_id: (0, u.generateUUID)(),
                        mux_sample_rate: ce.sampleRate,
                        beacon_domain: ce.beaconDomain
                      }, this.data.view_sequence_number = 1, this.data.player_sequence_number = 1, this.oldEmit = this.emit, this.emit = function (Re, Ue) {
                        Ue = (0, y.default)({
                          viewer_time: this.mux.utils.now()
                        }, Ue), this.oldEmit(Re, Ue);
                      };

                      var Ce = function () {
                        this.data.view_start === void 0 && (this.data.view_start = this.mux.utils.now(), this.emit("viewstart"));
                      }.bind(this);

                      this.on("viewinit", function (Re, Ue) {
                        this._resetVideoData(), this._resetViewData(), this._resetErrorData(), this._updateStateData(), (0, y.default)(this.data, Ue), this._initializeViewData(), this.one("play", Ce), this.one("adbreakstart", Ce);
                      });

                      var Ie = function (Re) {
                        this.emit("viewend"), this.send("viewend"), this.emit("viewinit", Re);
                      }.bind(this);

                      this.on("videochange", function (Re, Ue) {
                        Ie(Ue);
                      }), this.on("programchange", function (Re, Ue) {
                        this.data.player_is_paused && this.mux.log.warn("The `programchange` event is intended to be used when the content changes mid playback without the video source changing, however the video is not currently playing. If the video source is changing please use the videochange event otherwise you will lose startup time information."), Ie((0, y.default)(Ue, {
                          view_program_changed: !0
                        })), Ce(), this.emit("play"), this.emit("playing");
                      }), this.on("destroy", this.destroy);
                      var ke = this.destroy.bind(this);
                      a.default !== void 0 && typeof a.default.addEventListener == "function" && a.default.addEventListener("unload", ke, !1), this.on("destroy", function () {
                        a.default !== void 0 && typeof a.default.removeEventListener == "function" && a.default.removeEventListener("unload", ke);
                      }), this.on("playerready", function (Re, Ue) {
                        (0, y.default)(this.data, Ue);
                      }), oe.forEach(function (Re) {
                        me.on(Re, function (Ue, Je) {
                          Re.indexOf("ad") !== 0 && this._updateStateData(), (0, y.default)(this.data, Je), this._sanitizeData();
                        }), me.on("after" + Re, function () {
                          (Re !== "error" || this.viewErrored) && this.send(Re);
                        });
                      }), this.on("viewend", function (Re, Ue) {
                        (0, y.default)(me.data, Ue);
                      });

                      var De = function (Re) {
                        var Ue = this.mux.utils.now();
                        this.data.player_init_time && (this.data.player_startup_time = Ue - this.data.player_init_time), !this.mux.PLAYER_TRACKED && this.NAVIGATION_START && (this.mux.PLAYER_TRACKED = !0, (this.data.player_init_time || this.DOM_CONTENT_LOADED_EVENT_END) && (this.data.page_load_time = Math.min(this.data.player_init_time || 1 / 0, this.DOM_CONTENT_LOADED_EVENT_END || 1 / 0) - this.NAVIGATION_START)), this.send("playerready"), delete this.data.player_startup_time, delete this.data.page_load_time;
                      };

                      this.one("playerready", De), F.default.apply(this), xe.default.apply(this), ye.default.apply(this), Y.default.apply(this), I.default.apply(this), ge.default.apply(this), U.default.apply(this), G.default.apply(this), _e.default.apply(this), q.default.apply(this), te.default.apply(this), Le.default.apply(this), ee.default.apply(this), ce.hlsjs && this.addHLSJS(ce), ce.dashjs && this.addDashJS(ce), this.emit("viewinit", ce.data);
                    };

                    (0, y.default)(ue.prototype, b.default.prototype), (0, y.default)(ue.prototype, Y.default.prototype), (0, y.default)(ue.prototype, ye.default.prototype), (0, y.default)(ue.prototype, I.default.prototype), (0, y.default)(ue.prototype, U.default.prototype), (0, y.default)(ue.prototype, G.default.prototype), (0, y.default)(ue.prototype, _e.default.prototype), (0, y.default)(ue.prototype, q.default.prototype), (0, y.default)(ue.prototype, te.default.prototype), ue.prototype.destroy = function () {
                      this._destroyed || (this._destroyed = !0, this.data.view_start !== void 0 && (this.emit("viewend"), this.send("viewend")), this.playbackEventDispatcher.destroy(), this.removeHLSJS(), this.removeDashJS(), a.default.clearTimeout(this._heartBeatTimeout));
                    }, ue.prototype.send = function (re) {
                      var ne = (0, y.default)({}, this.data);

                      if (ne.player_error_code === 1 && (delete ne.player_error_code, delete ne.player_error_message), ne.player_source_duration === 1 / 0 || ne.video_source_duration === 1 / 0 ? ne.video_source_is_live = !0 : (ne.player_source_duration > 0 || ne.video_source_duration > 0) && (ne.video_source_is_live = !1), ne.video_source_url = ne.video_source_url || ne.player_source_url, ne.video_source_url) {
                        var ce = (0, i.extractHostnameAndDomain)(ne.video_source_url),
                            me = L(ce, 2),
                            Ae = me[0],
                            Ce = me[1];
                        ne.video_source_domain = Ce, ne.video_source_hostname = Ae;
                      }

                      delete ne.ad_request_id, this.playbackEventDispatcher.send(re, ne), this.data.view_sequence_number++, this.data.player_sequence_number++, this._restartHeartBeat();
                    }, ue.prototype._updateStateData = function () {
                      (0, y.default)(this.data, this.getStateData()), this.getPlayheadTime && (this.data.player_playhead_time = this.getPlayheadTime()), this._sanitizeData();
                    }, ue.prototype._sanitizeData = function () {
                      var re = this;
                      ["player_width", "player_height", "video_source_width", "video_source_height", "player_playhead_time", "video_source_bitrate"].forEach(function (ne) {
                        var ce = parseInt(re.data[ne], 10);
                        re.data[ne] = isNaN(ce) ? void 0 : ce;
                      }), ["player_source_url", "video_source_url"].forEach(function (ne) {
                        if (re.data[ne]) {
                          var ce = re.data[ne].toLowerCase();
                          ce.indexOf("data:") !== 0 && ce.indexOf("blob:") !== 0 || (re.data[ne] = "MSE style URL");
                        }
                      });
                    }, ue.prototype._resetVideoData = function (re, ne) {
                      var ce = this;
                      Object.keys(this.data).forEach(function (me) {
                        me.indexOf("video_") === 0 && delete ce.data[me];
                      });
                    }, ue.prototype._resetViewData = function () {
                      var re = this;
                      Object.keys(this.data).forEach(function (ne) {
                        ne.indexOf("view_") === 0 && delete re.data[ne];
                      }), this.data.view_sequence_number = 1;
                    }, ue.prototype._resetErrorData = function (re, ne) {
                      delete this.data.player_error_code, delete this.data.player_error_message;
                    }, ue.prototype._initializeViewData = function () {
                      var re = this,
                          ne = this.data.view_id = (0, u.generateUUID)();
                      this.data.video_id || (this.data.video_id = (0, _.default)(this.data.player_source_url));

                      var ce = function () {
                        ne === re.data.view_id && (0, p.default)(re.data, "player_view_count", 1);
                      };

                      this.data.player_is_paused ? this.one("play", ce) : ce();
                    }, ue.prototype._restartHeartBeat = function () {
                      var re = this;
                      a.default.clearTimeout(this._heartBeatTimeout), this.viewErrored || (this._heartBeatTimeout = a.default.setTimeout(function () {
                        re.data.player_is_paused || re.emit("hb");
                      }, 1e4));
                    }, ue.prototype.addHLSJS = function (re) {
                      return re.hlsjs ? this.hlsjs ? void this.mux.log.warn("An instance of HLS.js is already being monitored for this player.") : (this.hlsjs = re.hlsjs, void (0, g.monitorHlsJs)(this.mux, this.id, re.hlsjs, {}, re.Hls || a.default.Hls)) : void this.mux.log.warn("You must pass a valid hlsjs instance in order to track it.");
                    }, ue.prototype.removeHLSJS = function () {
                      this.hlsjs && ((0, g.stopMonitoringHlsJs)(this.hlsjs), this.hlsjs = void 0);
                    }, ue.prototype.addDashJS = function (re) {
                      return re.dashjs ? this.dashjs ? void this.mux.log.warn("An instance of Dash.js is already being monitored for this player.") : (this.dashjs = re.dashjs, void (0, s.monitorDashJS)(this.mux, this.id, re.dashjs)) : void this.mux.log.warn("You must pass a valid dashjs instance in order to track it.");
                    }, ue.prototype.removeDashJS = function () {
                      this.dashjs && ((0, s.stopMonitoringDashJS)(this.dashjs), this.dashjs = void 0);
                    }, O.default = ue;
                  }, function (w, O, D) {
                    "use strict";

                    function E(u) {
                      return u && u.__esModule ? u : {
                        default: u
                      };
                    }

                    function L(u) {
                      var i = d.default.createElement("a");
                      i.href = u;
                      var n = i.pathname.replace(/\.[^\/.]+$/, "");
                      return y.default.encode(i.host + n).split("=")[0];
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = L;
                    var P = D(21),
                        d = E(P),
                        f = D(23),
                        y = E(f);
                  }, function (w, O, D) {
                    (function (E) {
                      var L,
                          P = E !== void 0 ? E : typeof window != "undefined" ? window : {},
                          d = D(22);
                      typeof document != "undefined" ? L = document : (L = P["__GLOBAL_DOCUMENT_CACHE@4"]) || (L = P["__GLOBAL_DOCUMENT_CACHE@4"] = d), w.exports = L;
                    }).call(O, D(6));
                  }, function (w, O) {}, function (w, O, D) {
                    (function (E, L) {
                      var P;

                      (function (d) {
                        var f = (typeof E == "object" && E && E.exports, function (h) {
                          this.message = h;
                        });
                        f.prototype = new Error(), f.prototype.name = "InvalidCharacterError";

                        var y = function (h) {
                          throw new f(h);
                        },
                            u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
                            i = /[\t\n\f\r ]/g,
                            n = function (h) {
                          h = String(h).replace(i, "");
                          var c = h.length;
                          c % 4 == 0 && (h = h.replace(/==?$/, ""), c = h.length), (c % 4 == 1 || /[^+a-zA-Z0-9\/]/.test(h)) && y("Invalid character: the string to be decoded is not correctly encoded.");

                          for (var p, C, _ = 0, g = "", s = -1; ++s < c;) C = u.indexOf(h.charAt(s)), p = _ % 4 ? 64 * p + C : C, _++ % 4 && (g += String.fromCharCode(255 & p >> (-2 * _ & 6)));

                          return g;
                        },
                            a = function (h) {
                          h = String(h), /[^\0-\xFF]/.test(h) && y("The string to be encoded contains characters outside of the Latin1 range.");

                          for (var c, p, C, _, g = h.length % 3, s = "", o = -1, b = h.length - g; ++o < b;) c = h.charCodeAt(o) << 16, p = h.charCodeAt(++o) << 8, C = h.charCodeAt(++o), _ = c + p + C, s += u.charAt(_ >> 18 & 63) + u.charAt(_ >> 12 & 63) + u.charAt(_ >> 6 & 63) + u.charAt(63 & _);

                          return g == 2 ? (c = h.charCodeAt(o) << 8, p = h.charCodeAt(++o), _ = c + p, s += u.charAt(_ >> 10) + u.charAt(_ >> 4 & 63) + u.charAt(_ << 2 & 63) + "=") : g == 1 && (_ = h.charCodeAt(o), s += u.charAt(_ >> 2) + u.charAt(_ << 4 & 63) + "=="), s;
                        },
                            v = {
                          encode: a,
                          decode: n,
                          version: "0.1.0"
                        };

                        (P = function () {
                          return v;
                        }.call(O, D, O, E)) !== void 0 && (E.exports = P);
                      })();
                    }).call(O, D(24)(w), D(6));
                  }, function (w, O) {
                    w.exports = function (D) {
                      return D.webpackPolyfill || (D.deprecate = function () {}, D.paths = [], D.children || (D.children = []), Object.defineProperty(D, "loaded", {
                        enumerable: !0,
                        get: function () {
                          return D.l;
                        }
                      }), Object.defineProperty(D, "id", {
                        enumerable: !0,
                        get: function () {
                          return D.i;
                        }
                      }), D.webpackPolyfill = 1), D;
                    };
                  }, function (w, O, D) {
                    "use strict";

                    function E(v) {
                      return v && v.__esModule ? v : {
                        default: v
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.stopMonitoringHlsJs = O.monitorHlsJs = void 0;

                    var L = D(8),
                        P = E(L),
                        d = D(11),
                        f = E(d),
                        y = D(5),
                        u = function (v) {
                      if (!v) return {};

                      var h = f.default.navigationStart(),
                          c = v.loading,
                          p = c ? c.start : v.trequest,
                          C = c ? c.first : v.tfirst,
                          _ = c ? c.end : v.tload;

                      return {
                        bytesLoaded: v.total,
                        requestStart: Math.round(h + p),
                        responseStart: Math.round(h + C),
                        responseEnd: Math.round(h + _)
                      };
                    },
                        i = function (v) {
                      if (v && typeof v.getAllResponseHeaders == "function") return (0, P.default)(v.getAllResponseHeaders());
                    },
                        n = function (v, h, c) {
                      var p = (arguments.length > 3 && arguments[3] !== void 0 && arguments[3], arguments[4]),
                          C = v.log;
                      if (!f.default.exists()) return void C.warn("performance timing not supported. Not tracking HLS.js.");

                      var _ = function (F, B) {
                        return v.emit(h, F, B);
                      },
                          g = function (F, B) {
                        var U = B.levels,
                            W = B.audioTracks,
                            G = B.url,
                            V = B.stats,
                            Y = B.networkDetails,
                            $ = {},
                            q = {};
                        U.forEach(function (ye, pe) {
                          $[pe] = {
                            width: ye.width,
                            height: ye.height,
                            bitrate: ye.bitrate,
                            attrs: ye.attrs
                          };
                        }), W.forEach(function (ye, pe) {
                          q[pe] = {
                            name: ye.name,
                            language: ye.lang,
                            bitrate: ye.bitrate
                          };
                        });
                        var Z = u(V),
                            te = Z.bytesLoaded,
                            se = Z.requestStart,
                            ge = Z.responseStart,
                            he = Z.responseEnd;

                        _("requestcompleted", {
                          request_event_type: F,
                          request_bytes_loaded: te,
                          request_start: se,
                          request_response_start: ge,
                          request_response_end: he,
                          request_type: "manifest",
                          request_hostname: (0, y.extractHostname)(G),
                          request_response_headers: i(Y),
                          request_rendition_lists: {
                            media: $,
                            audio: q,
                            video: {}
                          }
                        });
                      };

                      c.on(p.Events.MANIFEST_LOADED, g);

                      var s = function (F, B) {
                        var U = B.details,
                            W = B.level,
                            G = B.networkDetails,
                            V = B.stats,
                            Y = u(V),
                            $ = Y.bytesLoaded,
                            q = Y.requestStart,
                            Z = Y.responseStart,
                            te = Y.responseEnd;

                        _("requestcompleted", {
                          request_event_type: F,
                          request_bytes_loaded: $,
                          request_start: q,
                          request_response_start: Z,
                          request_response_end: te,
                          request_current_level: W,
                          request_type: "manifest",
                          request_hostname: (0, y.extractHostname)(U.url),
                          request_response_headers: i(G)
                        });
                      };

                      c.on(p.Events.LEVEL_LOADED, s);

                      var o = function (F, B) {
                        var U = B.details,
                            W = B.networkDetails,
                            G = B.stats,
                            V = u(G),
                            Y = V.bytesLoaded,
                            $ = V.requestStart,
                            q = V.responseStart,
                            Z = V.responseEnd;

                        _("requestcompleted", {
                          request_event_type: F,
                          request_bytes_loaded: Y,
                          request_start: $,
                          request_response_start: q,
                          request_response_end: Z,
                          request_type: "manifest",
                          request_hostname: (0, y.extractHostname)(U.url),
                          request_response_headers: i(W)
                        });
                      };

                      c.on(p.Events.AUDIO_TRACK_LOADED, o);

                      var b = function (F, B) {
                        var U = B.stats,
                            W = B.networkDetails,
                            G = B.frag,
                            V = u(U),
                            Y = V.bytesLoaded,
                            $ = V.requestStart,
                            q = V.responseStart,
                            Z = V.responseEnd,
                            te = {
                          request_event_type: F,
                          request_bytes_loaded: Y,
                          request_start: $,
                          request_response_start: q,
                          request_response_end: Z,
                          request_hostname: W ? (0, y.extractHostname)(W.responseURL) : void 0,
                          request_response_headers: i(W),
                          request_media_duration: G.duration
                        };
                        G.type === "main" ? (te.request_type = "media", te.request_current_level = G.level, te.request_video_width = (c.levels[G.level] || {}).width, te.request_video_height = (c.levels[G.level] || {}).height) : te.request_type = G.type, _("requestcompleted", te);
                      };

                      c.on(p.Events.FRAG_LOADED, b);

                      var A = function (F, B) {
                        var U = B.details,
                            W = B.response,
                            G = B.context,
                            V = B.frag;

                        if (U === p.ErrorDetails.MANIFEST_LOAD_ERROR || U === p.ErrorDetails.MANIFEST_LOAD_TIMEOUT || U === p.ErrorDetails.FRAG_LOAD_ERROR || U === p.ErrorDetails.FRAG_LOAD_TIMEOUT || U === p.ErrorDetails.LEVEL_LOAD_ERROR || U === p.ErrorDetails.LEVEL_LOAD_TIMEOUT) {
                          var Y = V && V.url || G && G.url || "";

                          _("requestfailed", {
                            request_error: U,
                            request_url: Y,
                            request_hostname: (0, y.extractHostname)(Y),
                            request_type: U === p.ErrorDetails.FRAG_LOAD_ERROR || U === p.ErrorDetails.FRAG_LOAD_TIMEOUT ? "media" : "manifest",
                            request_error_code: W && W.code,
                            request_error_text: W && W.text
                          });
                        }
                      };

                      c.on(p.Events.ERROR, A);

                      var I = function (F, B) {
                        var U = B.frag,
                            W = U && U._url || "";

                        _("requestcanceled", {
                          request_cancel: F,
                          request_url: W,
                          request_type: "media",
                          request_hostname: (0, y.extractHostname)(W)
                        });
                      };

                      c.on(p.Events.FRAG_LOAD_EMERGENCY_ABORTED, I);

                      var M = function (F, B) {
                        var U = B.level,
                            W = c.levels.find(function (V) {
                          return V.level === U;
                        });

                        if (W && W.attrs && W.attrs.BANDWIDTH) {
                          var G = W.attrs.BANDWIDTH;
                          G ? _("renditionchange", {
                            video_source_bitrate: G,
                            video_source_width: W.width,
                            video_source_height: W.height
                          }) : C.warn("missing BANDWIDTH from HLS manifest parsed by HLS.js");
                        }
                      };

                      c.on(p.Events.LEVEL_SWITCHED, M), c._stopMuxMonitor = function () {
                        c.off(p.Events.MANIFEST_LOADED, g), c.off(p.Events.LEVEL_LOADED, s), c.off(p.Events.AUDIO_TRACK_LOADED, o), c.off(p.Events.FRAG_LOADED, b), c.off(p.Events.ERROR, A), c.off(p.Events.FRAG_LOAD_EMERGENCY_ABORTED, I), c.off(p.Events.LEVEL_SWITCHED, M), c.off(p.Events.DESTROYING, c._stopMuxMonitor), delete c._stopMuxMonitor;
                      }, c.on(p.Events.DESTROYING, c._stopMuxMonitor);
                    },
                        a = function (v) {
                      v && typeof v._stopMuxMonitor == "function" && v._stopMuxMonitor();
                    };

                    O.monitorHlsJs = n, O.stopMonitoringHlsJs = a;
                  }, function (w, O, D) {
                    "use strict";

                    function E(v) {
                      return v && v.__esModule ? v : {
                        default: v
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.stopMonitoringDashJS = O.monitorDashJS = void 0;

                    var L = D(0),
                        P = E(L),
                        d = D(8),
                        f = E(d),
                        y = D(5),
                        u = function (v, h) {
                      if (!v || typeof v.getRequests != "function") return {};
                      var c = v.getRequests({
                        state: "executed"
                      });
                      if (c.length === 0) return {};
                      var p = c[c.length - 1],
                          C = (0, y.extractHostname)(p.url),
                          _ = p.bytesLoaded,
                          g = new Date(p.requestStartDate).getTime(),
                          s = new Date(p.firstByteDate).getTime(),
                          o = new Date(p.requestEndDate).getTime(),
                          b = isNaN(p.duration) ? 0 : p.duration,
                          A = typeof h.getMetricsFor == "function" ? h.getMetricsFor(p.mediaType).HttpList : h.getDashMetrics().getHttpRequests(p.mediaType),
                          I = void 0;
                      return A.length > 0 && (I = (0, f.default)(A[A.length - 1]._responseHeaders || "")), {
                        requestStart: g,
                        requestResponseStart: s,
                        requestResponseEnd: o,
                        requestBytesLoaded: _,
                        requestResponseHeaders: I,
                        requestMediaDuration: b,
                        requestHostname: C
                      };
                    },
                        i = function (v, h) {
                      var c = h.getQualityFor(v),
                          p = h.getCurrentTrackFor(v),
                          C = p.bitrateList;
                      return C ? {
                        currentLevel: c,
                        renditionWidth: C[c].width || null,
                        renditionHeight: C[c].height || null,
                        renditionBitrate: C[c].bandwidth
                      } : {};
                    },
                        n = function (v, h, c) {
                      var p = (arguments.length > 3 && arguments[3] !== void 0 && arguments[3], v.log);
                      if (!c || !c.on) return void p.warn("Invalid dash.js player reference. Monitoring blocked.");

                      var C = function (F, B) {
                        return v.emit(h, F, B);
                      },
                          _ = function (F) {
                        var B = F.type,
                            U = F.data,
                            W = U || {},
                            G = W.url;
                        C("requestcompleted", {
                          request_event_type: B,
                          request_start: 0,
                          request_response_start: 0,
                          request_response_end: 0,
                          request_bytes_loaded: -1,
                          request_type: "manifest",
                          request_hostname: (0, y.extractHostname)(G)
                        });
                      };

                      c.on("manifestLoaded", _);

                      var g = {},
                          s = function (F) {
                        var B = F.type,
                            U = F.fragmentModel,
                            W = F.chunk,
                            G = W || {},
                            V = G.mediaInfo,
                            Y = V || {},
                            $ = Y.type,
                            q = Y.bitrateList;
                        q = q || [];
                        var Z = {};
                        q.forEach(function (be, Le) {
                          Z[Le] = {}, Z[Le].width = be.width, Z[Le].height = be.height, Z[Le].bitrate = be.bandwidth, Z[Le].attrs = {};
                        }), $ === "video" ? g.video = Z : $ === "audio" ? g.audio = Z : g.media = Z;
                        var te = u(U, c),
                            se = te.requestStart,
                            ge = te.requestResponseStart,
                            he = te.requestResponseEnd,
                            ye = te.requestResponseHeaders,
                            pe = te.requestMediaDuration,
                            _e = te.requestHostname;
                        C("requestcompleted", {
                          request_event_type: B,
                          request_start: se,
                          request_response_start: ge,
                          request_response_end: he,
                          request_bytes_loaded: -1,
                          request_type: $ + "_init",
                          request_response_headers: ye,
                          request_hostname: _e,
                          request_media_duration: pe,
                          request_rendition_lists: g
                        });
                      };

                      c.on("initFragmentLoaded", s);

                      var o = function (F) {
                        var B = F.type,
                            U = F.fragmentModel,
                            W = F.chunk,
                            G = W || {},
                            V = G.mediaInfo,
                            Y = G.start,
                            $ = V || {},
                            q = $.type,
                            Z = u(U, c),
                            te = Z.requestStart,
                            se = Z.requestResponseStart,
                            ge = Z.requestResponseEnd,
                            he = Z.requestBytesLoaded,
                            ye = Z.requestResponseHeaders,
                            pe = Z.requestMediaDuration,
                            _e = Z.requestHostname,
                            be = i(q, c),
                            Le = be.currentLevel,
                            we = be.renditionWidth,
                            xe = be.renditionHeight,
                            Ne = be.renditionBitrate;
                        C("requestcompleted", {
                          request_event_type: B,
                          request_start: te,
                          request_response_start: se,
                          request_response_end: ge,
                          request_bytes_loaded: he,
                          request_type: q,
                          request_response_headers: ye,
                          request_hostname: _e,
                          request_media_start_time: Y,
                          request_media_duration: pe,
                          request_current_level: Le,
                          request_labeled_bitrate: Ne,
                          request_video_width: we,
                          request_video_height: xe
                        });
                      };

                      c.on("mediaFragmentLoaded", o);

                      var b = {
                        video: void 0,
                        audio: void 0,
                        totalBitrate: void 0
                      },
                          A = function () {
                        if (b.video && typeof b.video.bitrate == "number") {
                          if (!b.video.width || !b.video.height) return void p.warn("have bitrate info for video but missing width/height");
                          var F = b.video.bitrate;
                          return b.audio && typeof b.audio.bitrate == "number" && (F += b.audio.bitrate), F !== b.totalBitrate ? (b.totalBitrate = F, {
                            video_source_bitrate: F,
                            video_source_height: b.video.height,
                            video_source_width: b.video.width
                          }) : void 0;
                        }
                      },
                          I = function (F, B, U) {
                        if (typeof F.newQuality != "number") return void p.warn("missing evt.newQuality in qualityChangeRendered event", F);
                        var W = F.mediaType;

                        if (W === "audio" || W === "video") {
                          var G = c.getBitrateInfoListFor(W).find(function (Y) {
                            return Y.qualityIndex === F.newQuality;
                          });
                          if (!G || typeof G.bitrate != "number") return void p.warn("missing bitrate info for " + W);
                          b[W] = G;
                          var V = A();
                          V && C("renditionchange", V);
                        }
                      };

                      c.on("qualityChangeRendered", I);

                      var M = function (F) {
                        var B = F.error,
                            U = F.event;
                        U = U || {};
                        var W = U.request || {},
                            G = P.default.event && P.default.event.currentTarget || {};
                        C("requestfailed", {
                          request_error: B + "_" + U.id + "_" + W.type,
                          request_url: U.url,
                          request_hostname: (0, y.extractHostname)(U.url),
                          request_type: W.mediaType,
                          request_error_code: G.status,
                          request_error_type: G.statusText
                        });
                      };

                      c.on("error", M), c._stopMuxMonitor = function () {
                        c.off("manifestLoaded", _), c.off("initFragmentLoaded", s), c.off("mediaFragmentLoaded", o), c.off("qualityChangeRendered", I), c.off("error", M), delete c._stopMuxMonitor;
                      };
                    },
                        a = function (v) {
                      v && typeof v._stopMuxMonitor == "function" && v._stopMuxMonitor();
                    };

                    O.monitorDashJS = n, O.stopMonitoringDashJS = a;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = function () {},
                        L = 0;

                    E.prototype.on = function (P, d, f) {
                      return d._eventEmitterGuid = d._eventEmitterGuid || ++L, this._listeners = this._listeners || {}, this._listeners[P] = this._listeners[P] || [], f && (d = d.bind(f)), this._listeners[P].push(d), d;
                    }, E.prototype.off = function (P, d) {
                      var f = this._listeners && this._listeners[P];
                      f && f.forEach(function (y, u) {
                        y._eventEmitterGuid === d._eventEmitterGuid && f.splice(u, 1);
                      });
                    }, E.prototype.one = function (P, d, f) {
                      var y = this;
                      d._eventEmitterGuid = d._eventEmitterGuid || ++L;

                      var u = function i() {
                        y.off(P, i), d.apply(f || this, arguments);
                      };

                      u._eventEmitterGuid = d._eventEmitterGuid, this.on(P, u);
                    }, E.prototype.emit = function (P, d) {
                      var f = this;

                      if (this._listeners) {
                        d = d || {};

                        var y = this._listeners["before*"] || [],
                            u = this._listeners[P] || [],
                            i = this._listeners["after" + P] || [],
                            n = function (a, v) {
                          a = a.slice(), a.forEach(function (h) {
                            h.call(f, {
                              type: P
                            }, v);
                          });
                        };

                        n(y, d), n(u, d), n(i, d);
                      }
                    }, O.default = E;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = D(0),
                        L = function (d) {
                      return d && d.__esModule ? d : {
                        default: d
                      };
                    }(E),
                        P = function () {
                      this._playbackHeartbeatInterval = null, this._playheadShouldBeProgressing = !1, this.on("playing", function () {
                        this._playheadShouldBeProgressing = !0;
                      }), this.on("play", this._startPlaybackHeartbeatInterval), this.on("playing", this._startPlaybackHeartbeatInterval), this.on("adbreakstart", this._startPlaybackHeartbeatInterval), this.on("adplay", this._startPlaybackHeartbeatInterval), this.on("adplaying", this._startPlaybackHeartbeatInterval), this.on("seeking", this._startPlaybackHeartbeatInterval), this.on("devicewake", this._startPlaybackHeartbeatInterval), this.on("viewstart", this._startPlaybackHeartbeatInterval), this.on("pause", this._stopPlaybackHeartbeatInterval), this.on("ended", this._stopPlaybackHeartbeatInterval), this.on("viewend", this._stopPlaybackHeartbeatInterval), this.on("error", this._stopPlaybackHeartbeatInterval), this.on("aderror", this._stopPlaybackHeartbeatInterval), this.on("adpause", this._stopPlaybackHeartbeatInterval), this.on("adended", this._stopPlaybackHeartbeatInterval), this.on("adbreakend", this._stopPlaybackHeartbeatInterval), this.on("seeked", function () {
                        this.data.player_is_paused ? this._stopPlaybackHeartbeatInterval() : this._startPlaybackHeartbeatInterval();
                      }), this.on("timeupdate", function () {
                        this._playbackHeartbeatInterval !== null && this.emit("playbackheartbeat");
                      }), this.on("devicesleep", function (d, f) {
                        this._playbackHeartbeatInterval !== null && (L.default.clearInterval(this._playbackHeartbeatInterval), this.emit("playbackheartbeatend", {
                          viewer_time: f.viewer_time
                        }), this._playbackHeartbeatInterval = null);
                      });
                    };

                    P.prototype._startPlaybackHeartbeatInterval = function () {
                      var d = this;
                      this._playbackHeartbeatInterval === null && (this.emit("playbackheartbeat"), this._playbackHeartbeatInterval = L.default.setInterval(function () {
                        d.emit("playbackheartbeat");
                      }, this.playbackHeartbeatTime));
                    }, P.prototype._stopPlaybackHeartbeatInterval = function () {
                      this._playheadShouldBeProgressing = !1, this._playbackHeartbeatInterval !== null && (L.default.clearInterval(this._playbackHeartbeatInterval), this.emit("playbackheartbeatend"), this._playbackHeartbeatInterval = null);
                    }, O.default = P;
                  }, function (w, O, D) {
                    "use strict";

                    function E() {
                      var L = this;
                      this.on("viewinit", function () {
                        L.viewErrored = !1;
                      }), this.on("error", function () {
                        try {
                          var P = L.errorTranslator({
                            player_error_code: L.data.player_error_code,
                            player_error_message: L.data.player_error_message
                          });
                          P ? (L.data.player_error_code = P.player_error_code, L.data.player_error_message = P.player_error_message, L.viewErrored = !0) : (delete L.data.player_error_code, delete L.data.player_error_message);
                        } catch (d) {
                          L.mux.log.warn("Exception in error translator callback.", d), L.viewErrored = !0;
                        }
                      });
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = E;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = D(2),
                        L = function (d) {
                      return d && d.__esModule ? d : {
                        default: d
                      };
                    }(E),
                        P = function () {
                      this._watchTimeTrackerLastCheckedTime = null, this.on("playbackheartbeat", this._updateWatchTime), this.on("playbackheartbeatend", this._clearWatchTimeState);
                    };

                    P.prototype._updateWatchTime = function (d, f) {
                      var y = f.viewer_time;
                      this._watchTimeTrackerLastCheckedTime === null && (this._watchTimeTrackerLastCheckedTime = y), (0, L.default)(this.data, "view_watch_time", y - this._watchTimeTrackerLastCheckedTime), this._watchTimeTrackerLastCheckedTime = y;
                    }, P.prototype._clearWatchTimeState = function (d, f) {
                      this._updateWatchTime(d, f), this._watchTimeTrackerLastCheckedTime = null;
                    }, O.default = P;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = D(2),
                        L = function (d) {
                      return d && d.__esModule ? d : {
                        default: d
                      };
                    }(E),
                        P = function () {
                      this._playbackTimeTrackerLastPlayheadPosition = -1, this.on("playbackheartbeat", this._updatePlaybackTime), this.on("playbackheartbeatend", this._clearPlaybackTimeState), this.on("seeking", this._clearPlaybackTimeState);
                    };

                    P.prototype._updatePlaybackTime = function () {
                      var d = this.data.player_playhead_time;

                      if (this._playbackTimeTrackerLastPlayheadPosition >= 0 && d > this._playbackTimeTrackerLastPlayheadPosition) {
                        var f = d - this._playbackTimeTrackerLastPlayheadPosition;
                        f <= 1e3 && (0, L.default)(this.data, "view_content_playback_time", f);
                      }

                      this._playbackTimeTrackerLastPlayheadPosition = d;
                    }, P.prototype._clearPlaybackTimeState = function () {
                      this._updatePlaybackTime(), this._playbackTimeTrackerLastPlayheadPosition = -1;
                    }, O.default = P;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = function () {
                      this.on("playbackheartbeat", this._updatePlayheadTime), this.on("playbackheartbeatend", this._updatePlayheadTime), this.on("timeupdate", this._updatePlayheadTime), this.on("destroy", function () {
                        this.off("timeupdate", this._updatePlayheadTime);
                      });
                    };

                    E.prototype._updateMaxPlayheadPosition = function () {
                      this.data.view_max_playhead_position = this.data.view_max_playhead_position === void 0 ? this.data.player_playhead_time : Math.max(this.data.view_max_playhead_position, this.data.player_playhead_time);
                    }, E.prototype._updatePlayheadTime = function (L, P) {
                      if (P.player_playhead_time) this.data.player_playhead_time = P.player_playhead_time, this._updateMaxPlayheadPosition();else if (this.getPlayheadTime) {
                        var d = this.getPlayheadTime();
                        d !== void 0 && (this.data.player_playhead_time = d, this._updateMaxPlayheadPosition());
                      }
                    }, O.default = E;
                  }, function (w, O, D) {
                    "use strict";

                    function E(u) {
                      return u && u.__esModule ? u : {
                        default: u
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var L = D(3),
                        P = E(L),
                        d = D(2),
                        f = E(d),
                        y = function () {
                      this._lastCheckedTime = null, this._lastPlayheadTime = null, this._lastPlayheadTimeUpdatedTime = null, this.on("playbackheartbeat", this._checkIfRebuffering), this.on("playbackheartbeatend", this._cleanupRebufferTracker), this.on("seeking", function () {
                        this._cleanupRebufferTracker(null, {
                          viewer_time: P.default.now()
                        });
                      });
                    };

                    y.prototype._checkIfRebuffering = function (u, i) {
                      if (!this.disableRebufferTracking) {
                        if (this.isSeeking || this.isAdBreak || !this._playheadShouldBeProgressing) return void this._cleanupRebufferTracker(u, i);
                        if (this._lastCheckedTime === null) return this._prepareRebufferTrackerState(i.viewer_time), void this._updateRebufferMetrics();
                        if (this._lastPlayheadTime !== this.data.player_playhead_time) return void this._cleanupRebufferTracker(u, i, !0);
                        var n = i.viewer_time - this._lastPlayheadTimeUpdatedTime;
                        n >= this.sustainedRebufferThreshold && (this._rebuffering ? this._updateRebufferMetrics(i.viewer_time - this._lastCheckedTime) : (this._rebuffering = !0, (0, f.default)(this.data, "view_rebuffer_count", 1), this._updateRebufferMetrics(n), this.emit("rebufferstart"))), this._lastCheckedTime = i.viewer_time;
                      }
                    }, y.prototype._clearRebufferTrackerState = function () {
                      this._lastCheckedTime = null, this._lastPlayheadTime = null, this._lastPlayheadTimeUpdatedTime = null;
                    }, y.prototype._prepareRebufferTrackerState = function (u) {
                      this._lastCheckedTime = u, this._lastPlayheadTime = this.data.player_playhead_time, this._lastPlayheadTimeUpdatedTime = u;
                    }, y.prototype._cleanupRebufferTracker = function (u, i) {
                      var n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];

                      if (!this.disableRebufferTracking) {
                        if (this._rebuffering) this._rebuffering = !1, this._updateRebufferMetrics(i.viewer_time - this._lastCheckedTime), this.emit("rebufferend", {
                          viewer_time: i.viewer_time
                        });else {
                          if (this._lastCheckedTime === null) return void this._updateRebufferMetrics();
                          var a = this.data.player_playhead_time - this._lastPlayheadTime,
                              v = i.viewer_time - this._lastPlayheadTimeUpdatedTime;
                          a > 0 && v - a > this.minimumRebufferDuration ? ((0, f.default)(this.data, "view_rebuffer_count", 1), this._updateRebufferMetrics(v - a), this.emit("rebufferstart", {
                            viewer_time: this._lastPlayheadTimeUpdatedTime
                          }), this.emit("rebufferend", {
                            viewer_time: this._lastPlayheadTimeUpdatedTime + v - a
                          })) : this._updateRebufferMetrics();
                        }
                        n ? this._prepareRebufferTrackerState(i.viewer_time) : this._clearRebufferTrackerState();
                      }
                    }, y.prototype._updateRebufferMetrics = function (u) {
                      u > 0 && (0, f.default)(this.data, "view_rebuffer_duration", u), this.data.view_watch_time >= 0 && this.data.view_rebuffer_count > 0 && (this.data.view_rebuffer_frequency = this.data.view_rebuffer_count / this.data.view_watch_time, this.data.view_rebuffer_percentage = this.data.view_rebuffer_duration / this.data.view_watch_time);
                    }, O.default = y;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = D(3),
                        L = function (d) {
                      return d && d.__esModule ? d : {
                        default: d
                      };
                    }(E),
                        P = function () {
                      this.on("viewinit", function () {
                        var d = this.data,
                            f = d.view_id;

                        if (!d.view_program_changed) {
                          var y = function (u, i) {
                            var n = i.viewer_time;
                            u.type === "playing" && this.data.view_time_to_first_frame === void 0 ? this.calculateTimeToFirstFrame(n || L.default.now(), f) : u.type !== "adplaying" || this.data.view_time_to_first_frame !== void 0 && !this.inPrerollPosition() || this.calculateTimeToFirstFrame(n || L.default.now(), f);
                          };

                          this.one("playing", y), this.one("adplaying", y), this.one("viewend", function () {
                            this.off("playing", y), this.off("adplaying", y);
                          });
                        }
                      });
                    };

                    P.prototype.calculateTimeToFirstFrame = function (d, f) {
                      f === this.data.view_id && (this._updateWatchTime(null, {
                        viewer_time: d
                      }), this.data.view_time_to_first_frame = this.data.view_watch_time, (this.data.player_autoplay_on || this.data.video_is_autoplay) && this.NAVIGATION_START && (this.data.view_aggregate_startup_time = this.data.view_start + this.data.view_watch_time - this.NAVIGATION_START));
                    }, O.default = P;
                  }, function (w, O, D) {
                    "use strict";

                    function E() {
                      var d = this;
                      this.on("viewinit", function () {
                        this._lastPlayheadPosition = -1;
                      });
                      var f = ["pause", "rebufferstart", "seeking", "error", "adbreakstart", "hb"],
                          y = ["playing", "hb"];
                      f.forEach(function (u) {
                        d.on(u, function () {
                          if (this._lastPlayheadPosition >= 0 && this.data.player_playhead_time >= 0 && this._lastPlayerWidth >= 0 && this._lastSourceWidth > 0 && this._lastPlayerHeight >= 0 && this._lastSourceHeight > 0) {
                            var i = this.data.player_playhead_time - this._lastPlayheadPosition;
                            if (i < 0) return void (this._lastPlayheadPosition = -1);
                            var n = Math.min(this._lastPlayerWidth / this._lastSourceWidth, this._lastPlayerHeight / this._lastSourceHeight),
                                a = Math.max(0, n - 1),
                                v = Math.max(0, 1 - n);
                            this.data.view_max_upscale_percentage = Math.max(this.data.view_max_upscale_percentage || 0, a), this.data.view_max_downscale_percentage = Math.max(this.data.view_max_downscale_percentage || 0, v), (0, P.default)(this.data, "view_total_content_playback_time", i), (0, P.default)(this.data, "view_total_upscaling", a * i), (0, P.default)(this.data, "view_total_downscaling", v * i);
                          }

                          this._lastPlayheadPosition = -1;
                        });
                      }), y.forEach(function (u) {
                        d.on(u, function () {
                          this._lastPlayheadPosition = this.data.player_playhead_time, this._lastPlayerWidth = this.data.player_width, this._lastPlayerHeight = this.data.player_height, this._lastSourceWidth = this.data.video_source_width, this._lastSourceHeight = this.data.video_source_height;
                        });
                      });
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = E;

                    var L = D(2),
                        P = function (d) {
                      return d && d.__esModule ? d : {
                        default: d
                      };
                    }(L);
                  }, function (w, O, D) {
                    "use strict";

                    function E(n) {
                      return n && n.__esModule ? n : {
                        default: n
                      };
                    }

                    function L() {
                      this.isSeeking = !1, this.on("seeking", function (n, a) {
                        (0, i.default)(this.data, a), this._lastSeekingTime = d.default.now(), this.isSeeking === !1 && (this.isSeeking = !0, this.send("seeking"));
                      }), this.on("seeked", function () {
                        this.isSeeking = !1;
                        var n = this._lastSeekingTime || d.default.now(),
                            a = d.default.now() - n;
                        (0, y.default)(this.data, "view_seek_count", 1), (0, y.default)(this.data, "view_seek_duration", a);
                        var v = this.data.view_max_seek_time || 0;
                        this.data.view_max_seek_time = Math.max(v, a);
                      }), this.on("viewend", function () {
                        this.isSeeking = !1;
                      });
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = L;
                    var P = D(3),
                        d = E(P),
                        f = D(2),
                        y = E(f),
                        u = D(1),
                        i = E(u);
                  }, function (w, O, D) {
                    "use strict";

                    function E(v) {
                      return v && v.__esModule ? v : {
                        default: v
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var L = function () {
                      function v(h, c) {
                        var p = [],
                            C = !0,
                            _ = !1,
                            g = void 0;

                        try {
                          for (var s, o = h[Symbol.iterator](); !(C = (s = o.next()).done) && (p.push(s.value), !c || p.length !== c); C = !0);
                        } catch (b) {
                          _ = !0, g = b;
                        } finally {
                          try {
                            !C && o.return && o.return();
                          } finally {
                            if (_) throw g;
                          }
                        }

                        return p;
                      }

                      return function (h, c) {
                        if (Array.isArray(h)) return h;
                        if (Symbol.iterator in Object(h)) return v(h, c);
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                      };
                    }(),
                        P = D(2),
                        d = E(P),
                        f = D(5),
                        y = D(1),
                        u = E(y),
                        i = function (v, h) {
                      v.push(h), v.sort(function (c, p) {
                        return c.viewer_time - p.viewer_time;
                      });
                    },
                        n = ["adbreakstart", "adrequest", "adresponse", "adplay", "adplaying", "adpause", "adended", "adbreakend", "aderror"],
                        a = function () {
                      var v = this;
                      this.on("viewinit", function () {
                        this.isAdBreak = !1, this._currentAdRequestNumber = 0, this._currentAdResponseNumber = 0, this._adRequests = [], this._adResponses = [], this._adHasPlayed = !1, this._wouldBeNewAdPlay = !0, this._prerollPlayTime = void 0;
                      }), n.forEach(function (c) {
                        return v.on(c, v._updateAdData);
                      });

                      var h = function () {
                        v.isAdBreak = !1;
                      };

                      this.on("adbreakstart", function () {
                        this.isAdBreak = !0;
                      }), this.on("play", h), this.on("playing", h), this.on("viewend", h), this.on("adrequest", function (c, p) {
                        p = (0, u.default)({
                          ad_request_id: "generatedAdRequestId" + this._currentAdRequestNumber++
                        }, p), i(this._adRequests, p), (0, d.default)(this.data, "view_ad_request_count"), this.inPrerollPosition() && (this.data.view_preroll_requested = !0, this._adHasPlayed || (0, d.default)(this.data, "view_preroll_request_count"));
                      }), this.on("adresponse", function (c, p) {
                        p = (0, u.default)({
                          ad_request_id: "generatedAdRequestId" + this._currentAdResponseNumber++
                        }, p), i(this._adResponses, p);
                        var C = this.findAdRequest(p.ad_request_id);
                        C && (0, d.default)(this.data, "view_ad_request_time", Math.max(0, p.viewer_time - C.viewer_time));
                      }), this.on("adplay", function (c, p) {
                        this._adHasPlayed = !0, this._wouldBeNewAdPlay && (this._wouldBeNewAdPlay = !1, (0, d.default)(this.data, "view_ad_played_count")), this.inPrerollPosition() && !this.data.view_preroll_played && (this.data.view_preroll_played = !0, this._adRequests.length > 0 && (this.data.view_preroll_request_time = Math.max(0, p.viewer_time - this._adRequests[0].viewer_time)), this.data.view_start && (this.data.view_startup_preroll_request_time = Math.max(0, p.viewer_time - this.data.view_start)), this._prerollPlayTime = p.viewer_time);
                      }), this.on("adplaying", function (c, p) {
                        this.inPrerollPosition() && this.data.view_preroll_load_time === void 0 && this._prerollPlayTime !== void 0 && (this.data.view_preroll_load_time = p.viewer_time - this._prerollPlayTime, this.data.view_startup_preroll_load_time = p.viewer_time - this._prerollPlayTime);
                      }), this.on("adended", function () {
                        this._wouldBeNewAdPlay = !0;
                      }), this.on("aderror", function () {
                        this._wouldBeNewAdPlay = !0;
                      });
                    };

                    a.prototype.inPrerollPosition = function () {
                      return this.data.view_content_playback_time === void 0 || this.data.view_content_playback_time <= 1e3;
                    }, a.prototype.findAdRequest = function (v) {
                      for (var h = 0; h < this._adRequests.length; h++) if (this._adRequests[h].ad_request_id === v) return this._adRequests[h];
                    }, a.prototype._updateAdData = function (v, h) {
                      if (this.inPrerollPosition()) {
                        if (!this.data.view_preroll_ad_tag_hostname && h.ad_tag_url) {
                          var c = (0, f.extractHostnameAndDomain)(h.ad_tag_url),
                              p = L(c, 2),
                              C = p[0],
                              _ = p[1];
                          this.data.view_preroll_ad_tag_domain = _, this.data.view_preroll_ad_tag_hostname = C;
                        }

                        if (!this.data.view_preroll_ad_asset_hostname && h.ad_asset_url) {
                          var g = (0, f.extractHostnameAndDomain)(h.ad_asset_url),
                              s = L(g, 2),
                              o = s[0],
                              b = s[1];
                          this.data.view_preroll_ad_asset_domain = b, this.data.view_preroll_ad_asset_hostname = o;
                        }
                      }
                    }, O.default = a;
                  }, function (w, O, D) {
                    "use strict";

                    function E(u) {
                      return u && u.__esModule ? u : {
                        default: u
                      };
                    }

                    function L() {
                      var u = this,
                          i = void 0,
                          n = void 0,
                          a = function () {
                        u.disableRebufferTracking || ((0, y.default)(u.data, "view_waiting_rebuffer_count", 1), i = d.default.now(), n = window.setInterval(function () {
                          if (i) {
                            var C = d.default.now();
                            (0, y.default)(u.data, "view_waiting_rebuffer_duration", C - i), i = C;
                          }
                        }, 250));
                      },
                          v = function () {
                        u.disableRebufferTracking || i && ((0, y.default)(u.data, "view_waiting_rebuffer_duration", d.default.now() - i), i = !1, window.clearInterval(n));
                      },
                          h = !1,
                          c = function () {
                        h = !0;
                      },
                          p = function () {
                        h = !1, v();
                      };

                      this.on("waiting", function () {
                        h && a();
                      }), this.on("playing", function () {
                        v(), c();
                      }), this.on("pause", p), this.on("seeking", p);
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = L;
                    var P = D(3),
                        d = E(P),
                        f = D(2),
                        y = E(f);
                  }, function (w, O, D) {
                    "use strict";

                    function E(n) {
                      return n && n.__esModule ? n : {
                        default: n
                      };
                    }

                    function L() {
                      var n = this;
                      this.one("playbackheartbeat", u), this.on("playbackheartbeatend", function () {
                        n.off("before*", i), n.one("playbackheartbeat", u);
                      });
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = L;

                    var P = D(1),
                        d = E(P),
                        f = D(3),
                        y = E(f),
                        u = function () {
                      this.lastWallClockTime = y.default.now(), this.on("before*", i);
                    },
                        i = function (n) {
                      var a = y.default.now(),
                          v = this.lastWallClockTime;
                      this.lastWallClockTime = a, a - v > 3e4 && (this.emit("devicesleep", {
                        viewer_time: v
                      }), (0, d.default)(this.data, {
                        viewer_time: v
                      }), this.send("devicesleep"), this.emit("devicewake", {
                        viewer_time: a
                      }), (0, d.default)(this.data, {
                        viewer_time: a
                      }), this.send("devicewake"));
                    };
                  }, function (w, O, D) {
                    "use strict";

                    function E(B) {
                      return B && B.__esModule ? B : {
                        default: B
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var L = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (B) {
                      return typeof B;
                    } : function (B) {
                      return B && typeof Symbol == "function" && B.constructor === Symbol && B !== Symbol.prototype ? "symbol" : typeof B;
                    },
                        P = D(0),
                        d = E(P),
                        f = D(41),
                        y = D(4),
                        u = E(y),
                        i = D(45),
                        n = E(i),
                        a = D(10),
                        v = E(a),
                        h = D(46),
                        c = E(h),
                        p = D(15),
                        C = E(p),
                        _ = D(47),
                        g = E(_),
                        s = D(1),
                        o = E(s),
                        b = ["env_key", "view_id", "view_sequence_number", "player_sequence_number", "beacon_domain", "player_playhead_time", "viewer_time", "mux_api_version", "event", "video_id", "player_instance_id"],
                        A = ["viewstart", "error", "ended", "viewend"],
                        I = function (B, U) {
                      var W = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                      this.mux = B, this.envKey = U, this.eventQueue = new g.default((0, n.default)(U, W.beaconDomain)), this.previousBeaconData = null, this.lastEventTime = null, this.sampleRate = W.sampleRate, this.disableCookies = W.disableCookies, this.respectDoNotTrack = W.respectDoNotTrack;
                      var G = W.platform || {};
                      this.pageLevelData = {
                        mux_api_version: this.mux.API_VERSION,
                        mux_embed: this.mux.NAME,
                        mux_embed_version: this.mux.VERSION,
                        viewer_application_name: G.name,
                        viewer_application_version: G.version,
                        viewer_application_engine: G.layout,
                        viewer_device_name: G.product,
                        viewer_device_category: "",
                        viewer_device_manufacturer: G.manufacturer,
                        viewer_os_family: G.os && G.os.family,
                        viewer_os_architecture: G.os && G.os.architecture,
                        viewer_os_version: G.os && G.os.version
                      };
                      var V = (0, c.default)();
                      V && (this.pageLevelData = (0, o.default)(this.pageLevelData, {
                        viewer_connection_type: V
                      })), d.default !== void 0 && d.default.location && d.default.location.href && (this.pageLevelData.page_url = d.default.location.href), this.viewerData = this.disableCookies ? {} : (0, f.getAndUpdateViewerData)();
                    };

                    I.prototype.send = function (B, U) {
                      if (B) {
                        if (this.respectDoNotTrack && (0, v.default)()) return u.default.info("Not sending `" + B + "` because Do Not Track is enabled");
                        if (!U || (U === void 0 ? "undefined" : L(U)) !== "object") return u.default.error("A data object was expected in send() but was not provided");
                        var W = this.disableCookies ? {} : (0, f.getAndUpdateSessionData)(),
                            G = {};
                        (0, o.default)(G, this.pageLevelData), (0, o.default)(G, U), (0, o.default)(G, W), (0, o.default)(G, this.viewerData), G.event = B, G.env_key = this.envKey, G.user_id && (G.viewer_user_id = G.user_id, delete G.user_id);

                        var V = G.mux_sample_number >= this.sampleRate,
                            Y = this._deduplicateBeaconData(B, G),
                            $ = (0, C.default)(Y);

                        if (this.lastEventTime = this.mux.utils.now(), V) return u.default.info("Not sending event due to sample rate restriction", B, G, $);
                        if (!this.envKey) return u.default.info("Not sending event due to missing environment key", B, G, $);

                        if (!this.rateLimited) {
                          if (u.default.info("Sending event", B, G, $), this.rateLimited = !this.eventQueue.queueEvent(B, $), this.mux.WINDOW_UNLOADING && B === "viewend") this.eventQueue.destroy(!0);else if (A.indexOf(B) >= 0 && this.eventQueue.flushEvents(), this.rateLimited) return G.event = "eventrateexceeded", $ = (0, C.default)(G), this.eventQueue.queueEvent(G.event, $), u.default.error("Beaconing disabled due to rate limit.");
                        }
                      }
                    }, I.prototype.destroy = function () {
                      this.eventQueue.destroy(!1);
                    };

                    var M = function (B, U, W, G) {
                      return !(!B || U.indexOf("request_") !== 0 || U !== "request_response_headers" && (W === void 0 ? "undefined" : L(W)) === "object" && (G === void 0 ? "undefined" : L(G)) === "object" && Object.keys(W || {}).length === Object.keys(G || {}).length);
                    },
                        F = function (B, U) {
                      return B === "renditionchange" && U.indexOf("video_source_") === 0;
                    };

                    I.prototype._deduplicateBeaconData = function (B, U) {
                      var W = this,
                          G = {},
                          V = U.view_id;
                      if (!V || B === "viewstart" || B === "viewend" || !this.previousBeaconData || this.mux.utils.now() - this.lastEventTime >= 6e5) G = (0, o.default)({}, U), V && (this.previousBeaconData = G), V && B === "viewend" && (this.previousBeaconData = null);else {
                        var Y = B.indexOf("request") === 0;
                        Object.keys(U).forEach(function ($) {
                          var q = U[$];
                          (q !== W.previousBeaconData[$] || b.indexOf($) > -1 || M(Y, $, q, W.previousBeaconData[$]) || F(B, $)) && (G[$] = q, W.previousBeaconData[$] = q);
                        });
                      }
                      return G;
                    }, O.default = I;
                  }, function (w, O, D) {
                    "use strict";

                    function E(c) {
                      return c && c.__esModule ? c : {
                        default: c
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.getAndUpdateSessionData = O.getAndUpdateViewerData = void 0;

                    var L = D(12),
                        P = E(L),
                        d = D(44),
                        f = E(d),
                        y = D(7),
                        u = D(3),
                        i = E(u),
                        n = function () {
                      var c = void 0;

                      try {
                        c = P.default.parse(f.default.get("muxData") || "");
                      } catch (p) {
                        c = {};
                      }

                      return c;
                    },
                        a = function (c) {
                      try {
                        f.default.set("muxData", P.default.stringify(c), {
                          expires: 7300
                        });
                      } catch (p) {}
                    },
                        v = function () {
                      var c = n();
                      return c.mux_viewer_id = c.mux_viewer_id || (0, y.generateUUID)(), c.msn = c.msn || Math.random(), a(c), {
                        mux_viewer_id: c.mux_viewer_id,
                        mux_sample_number: c.msn
                      };
                    },
                        h = function () {
                      var c = n(),
                          p = i.default.now();
                      return c.session_start && (c.sst = c.session_start, delete c.session_start), c.session_id && (c.sid = c.session_id, delete c.session_id), c.session_expires && (c.sex = c.session_expires, delete c.session_expires), (!c.sex || c.sex < p) && (c.sid = (0, y.generateUUID)(), c.sst = p), c.sex = p + 15e5, a(c), {
                        session_id: c.sid,
                        session_start: c.sst,
                        session_expires: c.sex
                      };
                    };

                    O.getAndUpdateViewerData = v, O.getAndUpdateSessionData = h;
                  }, function (w, O, D) {
                    "use strict";

                    var E = D(13),
                        L = D(14),
                        P = {
                      brackets: function (u) {
                        return u + "[]";
                      },
                      indices: function (u, i) {
                        return u + "[" + i + "]";
                      },
                      repeat: function (u) {
                        return u;
                      }
                    },
                        d = Date.prototype.toISOString,
                        f = {
                      delimiter: "&",
                      encode: !0,
                      encoder: E.encode,
                      encodeValuesOnly: !1,
                      serializeDate: function (u) {
                        return d.call(u);
                      },
                      skipNulls: !1,
                      strictNullHandling: !1
                    },
                        y = function u(i, n, a, v, h, c, p, C, _, g, s, o) {
                      var b = i;
                      if (typeof p == "function") b = p(n, b);else if (b instanceof Date) b = g(b);else if (b === null) {
                        if (v) return c && !o ? c(n, f.encoder) : n;
                        b = "";
                      }
                      if (typeof b == "string" || typeof b == "number" || typeof b == "boolean" || E.isBuffer(b)) return c ? [s(o ? n : c(n, f.encoder)) + "=" + s(c(b, f.encoder))] : [s(n) + "=" + s(String(b))];
                      var A = [];
                      if (b === void 0) return A;
                      var I;
                      if (Array.isArray(p)) I = p;else {
                        var M = Object.keys(b);
                        I = C ? M.sort(C) : M;
                      }

                      for (var F = 0; F < I.length; ++F) {
                        var B = I[F];
                        h && b[B] === null || (A = Array.isArray(b) ? A.concat(u(b[B], a(n, B), a, v, h, c, p, C, _, g, s, o)) : A.concat(u(b[B], n + (_ ? "." + B : "[" + B + "]"), a, v, h, c, p, C, _, g, s, o)));
                      }

                      return A;
                    };

                    w.exports = function (u, i) {
                      var n = u,
                          a = i ? E.assign({}, i) : {};
                      if (a.encoder !== null && a.encoder !== void 0 && typeof a.encoder != "function") throw new TypeError("Encoder has to be a function.");

                      var v = a.delimiter === void 0 ? f.delimiter : a.delimiter,
                          h = typeof a.strictNullHandling == "boolean" ? a.strictNullHandling : f.strictNullHandling,
                          c = typeof a.skipNulls == "boolean" ? a.skipNulls : f.skipNulls,
                          p = typeof a.encode == "boolean" ? a.encode : f.encode,
                          C = typeof a.encoder == "function" ? a.encoder : f.encoder,
                          _ = typeof a.sort == "function" ? a.sort : null,
                          g = a.allowDots !== void 0 && a.allowDots,
                          s = typeof a.serializeDate == "function" ? a.serializeDate : f.serializeDate,
                          o = typeof a.encodeValuesOnly == "boolean" ? a.encodeValuesOnly : f.encodeValuesOnly;

                      if (a.format === void 0) a.format = L.default;else if (!Object.prototype.hasOwnProperty.call(L.formatters, a.format)) throw new TypeError("Unknown format option provided.");
                      var b,
                          A,
                          I = L.formatters[a.format];
                      typeof a.filter == "function" ? (A = a.filter, n = A("", n)) : Array.isArray(a.filter) && (A = a.filter, b = A);
                      var M = [];
                      if (typeof n != "object" || n === null) return "";
                      var F;
                      F = a.arrayFormat in P ? a.arrayFormat : "indices" in a ? a.indices ? "indices" : "repeat" : "indices";
                      var B = P[F];
                      b || (b = Object.keys(n)), _ && b.sort(_);

                      for (var U = 0; U < b.length; ++U) {
                        var W = b[U];
                        c && n[W] === null || (M = M.concat(y(n[W], W, B, h, c, p ? C : null, A, _, g, s, I, o)));
                      }

                      var G = M.join(v),
                          V = a.addQueryPrefix === !0 ? "?" : "";
                      return G.length > 0 ? V + G : "";
                    };
                  }, function (w, O, D) {
                    "use strict";

                    var E = D(13),
                        L = Object.prototype.hasOwnProperty,
                        P = {
                      allowDots: !1,
                      allowPrototypes: !1,
                      arrayLimit: 20,
                      decoder: E.decode,
                      delimiter: "&",
                      depth: 5,
                      parameterLimit: 1e3,
                      plainObjects: !1,
                      strictNullHandling: !1
                    },
                        d = function (u, i) {
                      for (var n = {}, a = i.ignoreQueryPrefix ? u.replace(/^\?/, "") : u, v = i.parameterLimit === 1 / 0 ? void 0 : i.parameterLimit, h = a.split(i.delimiter, v), c = 0; c < h.length; ++c) {
                        var p,
                            C,
                            _ = h[c],
                            g = _.indexOf("]="),
                            s = g === -1 ? _.indexOf("=") : g + 1;

                        s === -1 ? (p = i.decoder(_, P.decoder), C = i.strictNullHandling ? null : "") : (p = i.decoder(_.slice(0, s), P.decoder), C = i.decoder(_.slice(s + 1), P.decoder)), L.call(n, p) ? n[p] = [].concat(n[p]).concat(C) : n[p] = C;
                      }

                      return n;
                    },
                        f = function (u, i, n) {
                      for (var a = i, v = u.length - 1; v >= 0; --v) {
                        var h,
                            c = u[v];
                        if (c === "[]") h = [], h = h.concat(a);else {
                          h = n.plainObjects ? Object.create(null) : {};
                          var p = c.charAt(0) === "[" && c.charAt(c.length - 1) === "]" ? c.slice(1, -1) : c,
                              C = parseInt(p, 10);
                          !isNaN(C) && c !== p && String(C) === p && C >= 0 && n.parseArrays && C <= n.arrayLimit ? (h = [], h[C] = a) : h[p] = a;
                        }
                        a = h;
                      }

                      return a;
                    },
                        y = function (u, i, n) {
                      if (u) {
                        var a = n.allowDots ? u.replace(/\.([^.[]+)/g, "[$1]") : u,
                            v = /(\[[^[\]]*])/,
                            h = /(\[[^[\]]*])/g,
                            c = v.exec(a),
                            p = c ? a.slice(0, c.index) : a,
                            C = [];

                        if (p) {
                          if (!n.plainObjects && L.call(Object.prototype, p) && !n.allowPrototypes) return;
                          C.push(p);
                        }

                        for (var _ = 0; (c = h.exec(a)) !== null && _ < n.depth;) {
                          if (_ += 1, !n.plainObjects && L.call(Object.prototype, c[1].slice(1, -1)) && !n.allowPrototypes) return;
                          C.push(c[1]);
                        }

                        return c && C.push("[" + a.slice(c.index) + "]"), f(C, i, n);
                      }
                    };

                    w.exports = function (u, i) {
                      var n = i ? E.assign({}, i) : {};
                      if (n.decoder !== null && n.decoder !== void 0 && typeof n.decoder != "function") throw new TypeError("Decoder has to be a function.");
                      if (n.ignoreQueryPrefix = n.ignoreQueryPrefix === !0, n.delimiter = typeof n.delimiter == "string" || E.isRegExp(n.delimiter) ? n.delimiter : P.delimiter, n.depth = typeof n.depth == "number" ? n.depth : P.depth, n.arrayLimit = typeof n.arrayLimit == "number" ? n.arrayLimit : P.arrayLimit, n.parseArrays = n.parseArrays !== !1, n.decoder = typeof n.decoder == "function" ? n.decoder : P.decoder, n.allowDots = typeof n.allowDots == "boolean" ? n.allowDots : P.allowDots, n.plainObjects = typeof n.plainObjects == "boolean" ? n.plainObjects : P.plainObjects, n.allowPrototypes = typeof n.allowPrototypes == "boolean" ? n.allowPrototypes : P.allowPrototypes, n.parameterLimit = typeof n.parameterLimit == "number" ? n.parameterLimit : P.parameterLimit, n.strictNullHandling = typeof n.strictNullHandling == "boolean" ? n.strictNullHandling : P.strictNullHandling, u === "" || u === null || u === void 0) return n.plainObjects ? Object.create(null) : {};

                      for (var a = typeof u == "string" ? d(u, n) : u, v = n.plainObjects ? Object.create(null) : {}, h = Object.keys(a), c = 0; c < h.length; ++c) {
                        var p = h[c],
                            C = y(p, a[p], n);
                        v = E.merge(v, C, n);
                      }

                      return E.compact(v);
                    };
                  }, function (w, O, D) {
                    "use strict";

                    var E,
                        L,
                        P = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (d) {
                      return typeof d;
                    } : function (d) {
                      return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
                    };

                    (function (d) {
                      var f = !1;

                      if (E = d, (L = typeof E == "function" ? E.call(O, D, O, w) : E) !== void 0 && (w.exports = L), f = !0, P(O) === "object" && (w.exports = d(), f = !0), !f) {
                        var y = window.Cookies,
                            u = window.Cookies = d();

                        u.noConflict = function () {
                          return window.Cookies = y, u;
                        };
                      }
                    })(function () {
                      function d(y) {
                        function u(i, n, a) {
                          var v;

                          if (typeof document != "undefined") {
                            if (arguments.length > 1) {
                              if (a = f({
                                path: "/"
                              }, u.defaults, a), typeof a.expires == "number") {
                                var h = new Date();
                                h.setMilliseconds(h.getMilliseconds() + 864e5 * a.expires), a.expires = h;
                              }

                              try {
                                v = JSON.stringify(n), /^[\{\[]/.test(v) && (n = v);
                              } catch (o) {}

                              return n = y.write ? y.write(n, i) : encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), i = encodeURIComponent(String(i)), i = i.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), i = i.replace(/[\(\)]/g, escape), document.cookie = [i, "=", n, a.expires ? "; expires=" + a.expires.toUTCString() : "", a.path ? "; path=" + a.path : "", a.domain ? "; domain=" + a.domain : "", a.secure ? "; secure" : ""].join("");
                            }

                            i || (v = {});

                            for (var c = document.cookie ? document.cookie.split("; ") : [], p = /(%[0-9A-Z]{2})+/g, C = 0; C < c.length; C++) {
                              var _ = c[C].split("="),
                                  g = _.slice(1).join("=");

                              g.charAt(0) === '"' && (g = g.slice(1, -1));

                              try {
                                var s = _[0].replace(p, decodeURIComponent);

                                if (g = y.read ? y.read(g, s) : y(g, s) || g.replace(p, decodeURIComponent), this.json) try {
                                  g = JSON.parse(g);
                                } catch (o) {}

                                if (i === s) {
                                  v = g;
                                  break;
                                }

                                i || (v[s] = g);
                              } catch (o) {}
                            }

                            return v;
                          }
                        }

                        return u.set = u, u.get = function (i) {
                          return u.call(u, i);
                        }, u.getJSON = function () {
                          return u.apply({
                            json: !0
                          }, [].slice.call(arguments));
                        }, u.defaults = {}, u.remove = function (i, n) {
                          u(i, "", f(n, {
                            expires: -1
                          }));
                        }, u.withConverter = d, u;
                      }

                      var f = function () {
                        for (var y = 0, u = {}; y < arguments.length; y++) {
                          var i = arguments[y];

                          for (var n in i) u[n] = i[n];
                        }

                        return u;
                      };

                      return d(function () {});
                    });
                  }, function (w, O, D) {
                    "use strict";

                    function E(L, P) {
                      return L = L || "", P = P || "litix.io", L.match(/^[a-z0-9]+$/) ? "https://" + L + "." + P : "https://img.litix.io/a.gif";
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = E;
                  }, function (w, O, D) {
                    "use strict";

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var E = D(0),
                        L = function (f) {
                      return f && f.__esModule ? f : {
                        default: f
                      };
                    }(E),
                        P = function () {
                      var f = void 0;

                      switch (d()) {
                        case "cellular":
                          f = "cellular";
                          break;

                        case "ethernet":
                          f = "wired";
                          break;

                        case "wifi":
                          f = "wifi";
                          break;

                        case void 0:
                          break;

                        default:
                          f = "other";
                      }

                      return f;
                    },
                        d = function () {
                      var f = L.default.navigator,
                          y = f && (f.connection || f.mozConnection || f.webkitConnection);
                      return y && y.type;
                    };

                    O.default = P;
                  }, function (w, O, D) {
                    "use strict";

                    function E(C) {
                      return C && C.__esModule ? C : {
                        default: C
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var L = D(0),
                        P = E(L),
                        d = D(4),
                        f = E(d),
                        y = D(48),
                        u = E(y),
                        i = D(1),
                        n = E(i),
                        a = D(15),
                        v = E(a),
                        h = !!P.default.XMLHttpRequest && "withCredentials" in new P.default.XMLHttpRequest(),
                        c = {
                      maxBeaconSize: 300,
                      maxQueueLength: 3600,
                      baseTimeBetweenBeacons: 5e3
                    },
                        p = function (C, _) {
                      this._beaconUrl = C || "https://img.litix.io", this._eventQueue = [], this._postInFlight = !1, this._failureCount = 0, this._sendTimeout = !1, this._options = (0, n.default)({}, c, _);
                    };

                    p.prototype.queueEvent = function (C, _) {
                      var g = (0, n.default)({}, _);
                      return h ? (this._eventQueue.length <= this._options.maxQueueLength || C === "eventrateexceeded") && (this._eventQueue.push(g), this._sendTimeout || this._startBeaconSending(), this._eventQueue.length <= this._options.maxQueueLength) : (u.default.send(this._beaconUrl, g), !0);
                    }, p.prototype.flushEvents = function () {
                      h && (this._eventQueue.length && this._sendBeaconQueue(), this._startBeaconSending());
                    }, p.prototype.destroy = function () {
                      var C = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
                      this.destroyed = !0, C ? this._clearBeaconQueue() : this.flushEvents(), P.default.clearTimeout(this._sendTimeout);
                    }, p.prototype._clearBeaconQueue = function () {
                      var C = P.default.navigator,
                          _ = this._eventQueue.length > this._options.maxBeaconSize ? this._eventQueue.length - this._options.maxBeaconSize : 0,
                          g = this._eventQueue.slice(_);

                      if (_ > 0 && (0, n.default)(g[g.length - 1], (0, v.default)({
                        mux_view_message: "event queue truncated"
                      })), C.sendBeacon) C.sendBeacon(this._beaconUrl, JSON.stringify({
                        events: g
                      }));else if (P.default.XMLHttpRequest) {
                        var s = new P.default.XMLHttpRequest();
                        s.open("POST", this._beaconUrl), s.setRequestHeader("Content-Type", "application/json"), s.send(JSON.stringify({
                          events: g
                        }));
                      } else u.default.send(this._beaconUrl, g[g.length - 1]);
                    }, p.prototype._sendBeaconQueue = function () {
                      var C = this;

                      if (P.default.XMLHttpRequest && !this._postInFlight) {
                        var _ = new P.default.XMLHttpRequest(),
                            g = this._eventQueue.slice(0, this._options.maxBeaconSize);

                        this._eventQueue = this._eventQueue.slice(this._options.maxBeaconSize), this._postInFlight = !0, _.onreadystatechange = function () {
                          _.readyState === 4 && (_.status !== 200 ? (C._eventQueue = g.concat(C._eventQueue), C._failureCount += 1, f.default.info("Error sending beacon: " + _.status), f.default.info(_.responseText)) : C._failureCount = 0, C._postInFlight = !1);
                        }, _.open("POST", this._beaconUrl), _.setRequestHeader("Content-Type", "application/json"), _.send(JSON.stringify({
                          events: g
                        }));
                      }
                    }, p.prototype._getNextBeaconTime = function () {
                      if (!this._failureCount) return this._options.baseTimeBetweenBeacons;
                      var C = Math.pow(2, this._failureCount - 1);
                      return (1 + (C *= Math.random())) * this._options.baseTimeBetweenBeacons;
                    }, p.prototype._startBeaconSending = function () {
                      var C = this;
                      P.default.clearTimeout(this._sendTimeout), this.destroyed || (this._sendTimeout = P.default.setTimeout(function () {
                        C._eventQueue.length && C._sendBeaconQueue(), C._startBeaconSending();
                      }, this._getNextBeaconTime()));
                    }, O.default = p;
                  }, function (w, O, D) {
                    "use strict";

                    function E(u) {
                      return u && u.__esModule ? u : {
                        default: u
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });
                    var L = D(12),
                        P = E(L),
                        d = D(0),
                        f = E(d),
                        y = {};
                    y.send = function (u, i) {
                      function n() {
                        a.src = h + (v ? "&rc=" + v : "");
                      }

                      var a = new Image(),
                          v = 0,
                          h = u + "?" + P.default.stringify(i);
                      return a.addEventListener("error", function () {
                        v > 3 || f.default.setTimeout(function () {
                          v++, n();
                        }, 5e3 * v);
                      }), n(), a;
                    }, O.default = y;
                  }, function (w, O, D) {
                    "use strict";

                    function E() {
                      function L(h, c) {
                        var p = c.request_start,
                            C = c.request_response_start,
                            _ = c.request_response_end,
                            g = c.request_bytes_loaded;
                        i++;
                        var s = void 0,
                            o = void 0;

                        if (C ? (s = C - p, o = _ - C) : o = _ - p, o > 0 && g > 0) {
                          var b = g / o * 8e3;
                          n++, y += g, u += o, this.data.view_min_request_throughput = Math.min(this.data.view_min_request_throughput || 1 / 0, b), this.data.view_average_request_throughput = y / u * 8e3, this.data.view_request_count = i, s > 0 && (f += s, this.data.view_max_request_latency = Math.max(this.data.view_max_request_latency || 0, s), this.data.view_average_request_latency = f / n);
                        }
                      }

                      function P(h, c) {
                        i++, a++, this.data.view_request_count = i, this.data.view_request_failed_count = a;
                      }

                      function d(h, c) {
                        i++, v++, this.data.view_request_count = i, this.data.view_request_canceled_count = v;
                      }

                      var f = 0,
                          y = 0,
                          u = 0,
                          i = 0,
                          n = 0,
                          a = 0,
                          v = 0;
                      this.on("requestcompleted", L), this.on("requestfailed", P), this.on("requestcanceled", d);
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = E;
                  }, function (w, O, D) {
                    "use strict";

                    function E(n, a, v) {
                      var h = (0, y.findMediaElement)(a),
                          c = P(h, 3),
                          p = c[0],
                          C = c[1],
                          _ = c[2],
                          g = n.log,
                          s = n.utils.getComputedStyle,
                          o = n.utils.secondsToMs,
                          b = {
                        automaticErrorTracking: !0
                      };
                      if (!p) return g.error("No element was found with the `" + C + "` query selector.");
                      if (_ !== "video" && _ !== "audio") return g.error("The element of `" + C + "` was not a media element.");
                      v = (0, f.default)(b, v), v.data = (0, f.default)({
                        player_software: "HTML5 Video Element",
                        player_software_version: "No Versions",
                        player_mux_plugin_name: "VideoElementMonitor",
                        player_mux_plugin_version: "4.2.0"
                      }, v.data), v.getPlayheadTime = function () {
                        return o(p.currentTime);
                      }, v.getStateData = function () {
                        var I = this.hlsjs && this.hlsjs.url,
                            M = this.dashjs && L(this.dashjs.getSource === "function") && this.dashjs.getSource();
                        return {
                          player_is_paused: p.paused,
                          player_playhead_time: o(p.currentTime),
                          player_width: parseInt(s(p, "width")),
                          player_height: parseInt(s(p, "height")),
                          player_autoplay_on: p.autoplay,
                          player_preload_on: p.preload,
                          video_poster_url: p.poster,
                          video_source_url: I || M || p.currentSrc,
                          video_source_duration: o(p.duration),
                          video_source_height: p.videoHeight,
                          video_source_width: p.videoWidth
                        };
                      }, p.mux = p.mux || {}, p.mux.deleted = !1, p.mux.emit = function (I, M) {
                        n.emit(C, I, M);
                      };

                      var A = function () {
                        g.error("The monitor for this video element has already been destroyed.");
                      };

                      p.mux.destroy = function () {
                        Object.keys(p.mux.listeners).forEach(function (I) {
                          p.removeEventListener(I, p.mux.listeners[I], !1);
                        }), delete p.mux.listeners, p.mux.destroy = A, p.mux.swapElement = A, p.mux.emit = A, p.mux.addHLSJS = A, p.mux.addDashJS = A, p.mux.removeHLSJS = A, p.mux.removeDashJS = A, p.mux.deleted = !0, n.emit(C, "destroy");
                      }, p.mux.swapElement = function (I) {
                        var M = (0, y.findMediaElement)(I),
                            F = P(M, 3),
                            B = F[0],
                            U = F[1],
                            W = F[2];
                        return B ? W !== "video" && W !== "audio" ? n.log.error("The element of `" + U + "` was not a media element.") : (B.muxId = p.muxId, delete p.muxId, B.mux = B.mux || {}, B.mux.listeners = (0, f.default)({}, p.mux.listeners), delete p.mux.listeners, Object.keys(B.mux.listeners).forEach(function (G) {
                          p.removeEventListener(G, B.mux.listeners[G], !1), B.addEventListener(G, B.mux.listeners[G], !1);
                        }), B.mux.swapElement = p.mux.swapElement, B.mux.destroy = p.mux.destroy, delete p.mux, void (p = B)) : n.log.error("No element was found with the `" + U + "` query selector.");
                      }, p.mux.addHLSJS = function (I) {
                        n.addHLSJS(C, I);
                      }, p.mux.addDashJS = function (I) {
                        n.addDashJS(C, I);
                      }, p.mux.removeHLSJS = function () {
                        n.removeHLSJS(C);
                      }, p.mux.removeDashJS = function () {
                        n.removeDashJS(C);
                      }, n.init(C, v), n.emit(C, "playerready"), p.paused || (n.emit(C, "play"), p.readyState > 2 && n.emit(C, "playing")), p.mux.listeners = {}, u.forEach(function (I) {
                        (I !== "error" || v.automaticErrorTracking) && (p.mux.listeners[I] = function () {
                          var M = {};
                          I === "error" && (M.player_error_code = p.error && p.error.code, M.player_error_message = p.error && i[p.error.code]), n.emit(C, I, M);
                        }, p.addEventListener(I, p.mux.listeners[I], !1));
                      });
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var L = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (n) {
                      return typeof n;
                    } : function (n) {
                      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
                    },
                        P = function () {
                      function n(a, v) {
                        var h = [],
                            c = !0,
                            p = !1,
                            C = void 0;

                        try {
                          for (var _, g = a[Symbol.iterator](); !(c = (_ = g.next()).done) && (h.push(_.value), !v || h.length !== v); c = !0);
                        } catch (s) {
                          p = !0, C = s;
                        } finally {
                          try {
                            !c && g.return && g.return();
                          } finally {
                            if (p) throw C;
                          }
                        }

                        return h;
                      }

                      return function (a, v) {
                        if (Array.isArray(a)) return a;
                        if (Symbol.iterator in Object(a)) return n(a, v);
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                      };
                    }();

                    O.default = E;

                    var d = D(1),
                        f = function (n) {
                      return n && n.__esModule ? n : {
                        default: n
                      };
                    }(d),
                        y = D(9),
                        u = ["loadstart", "pause", "play", "playing", "seeking", "seeked", "timeupdate", "ratechange", "stalled", "waiting", "error", "ended"],
                        i = {
                      1: "MEDIA_ERR_ABORTED",
                      2: "MEDIA_ERR_NETWORK",
                      3: "MEDIA_ERR_DECODE",
                      4: "MEDIA_ERR_SRC_NOT_SUPPORTED"
                    };
                  }, function (w, O, D) {
                    "use strict";

                    function E(s) {
                      return s && s.__esModule ? s : {
                        default: s
                      };
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    });

                    var L = D(52),
                        P = E(L),
                        d = D(2),
                        f = E(d),
                        y = D(53),
                        u = E(y),
                        i = D(54),
                        n = E(i),
                        a = D(1),
                        v = E(a),
                        h = D(8),
                        c = E(h),
                        p = D(5),
                        C = D(3),
                        _ = E(C),
                        g = {};

                    g.safeCall = P.default, g.safeIncrement = f.default, g.getComputedStyle = u.default, g.secondsToMs = n.default, g.assign = v.default, g.headersStringToObject = c.default, g.extractHostnameAndDomain = p.extractHostnameAndDomain, g.extractHostname = p.extractHostname, g.now = _.default.now, O.default = g;
                  }, function (w, O, D) {
                    "use strict";

                    function E(d, f, y, u) {
                      var i = u;
                      if (d && typeof d[f] == "function") try {
                        i = d[f].apply(d, y);
                      } catch (n) {
                        P.default.info("safeCall error", n);
                      }
                      return i;
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = E;

                    var L = D(4),
                        P = function (d) {
                      return d && d.__esModule ? d : {
                        default: d
                      };
                    }(L);
                  }, function (w, O, D) {
                    "use strict";

                    function E(f, y) {
                      if (f && y && P.default && typeof P.default.getComputedStyle == "function") {
                        var u = void 0;
                        return d && d.has(f) && (u = d.get(f)), u || (u = P.default.getComputedStyle(f, null), d && d.set(f, u)), u.getPropertyValue(y);
                      }
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = E;

                    var L = D(0),
                        P = function (f) {
                      return f && f.__esModule ? f : {
                        default: f
                      };
                    }(L),
                        d = void 0;

                    P.default && P.default.WeakMap && (d = new WeakMap());
                  }, function (w, O, D) {
                    "use strict";

                    function E(L) {
                      return Math.floor(1e3 * L);
                    }

                    Object.defineProperty(O, "__esModule", {
                      value: !0
                    }), O.default = E;
                  }]);
                });
              })();
            }, function (x, k, H) {
              "use strict";

              function w(L, P) {
                var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [],
                    f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [],
                    y = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function () {
                  return {};
                },
                    u = !1;
                L.on("adstart", function () {
                  u = !0;
                }), L.on("adend", function () {
                  u = !1;
                }), L.on("adserror", function () {
                  u = !1;
                });

                var i = function () {
                  var n = E(P.currentTime()),
                      a = function h() {
                    var c = D.default.utils.now(),
                        p = E(P.currentTime());

                    if (u) {
                      if (p > n) {
                        var C = y();
                        C.viewer_time = c - Math.max(0, p - n), P.off("timeupdate", h), L.mux.emit("adplaying", C);
                      }
                    } else P.off("timeupdate", h);
                  };

                  P.on("timeupdate", a);

                  var v = function h() {
                    P.off("timeupdate", a), d.forEach(function (c) {
                      P.off(c, h);
                    });
                  };

                  d.forEach(function (h) {
                    P.on(h, v);
                  });
                };

                f.forEach(function (n) {
                  P.on(n, i);
                });
              }

              Object.defineProperty(k, "__esModule", {
                value: !0
              }), k.default = w;

              var O = H(0),
                  D = function (L) {
                return L && L.__esModule ? L : {
                  default: L
                };
              }(O),
                  E = D.default.utils.secondsToMs;
            }, function (x, k, H) {
              "use strict";

              function w(I) {
                return I && I.__esModule ? I : {
                  default: I
                };
              }

              function O(I) {
                if (E.default.IS_IE8) return !1;
                var M = this,
                    F = M.id();
                I = g({
                  automaticErrorTracking: !0
                }, I), I.data = g({
                  player_software_name: "Video.js",
                  player_software_version: E.default.VERSION || "< 4.11",
                  player_mux_plugin_name: "videojs-mux",
                  player_mux_plugin_version: "4.2.0"
                }, I.data), I.getPlayheadTime = function () {
                  return b(M.currentTime());
                }, I.getStateData = function () {
                  var V = s(M, "videoHeight"),
                      Y = s(M, "videoWidth");

                  if (Y === void 0 || V === void 0) {
                    var $ = M.el().firstChild;
                    $ && $.nodeName.toUpperCase() === "VIDEO" && (V = $.videoHeight, Y = $.videoWidth);
                  }

                  return {
                    player_is_paused: s(M, "paused"),
                    player_is_fullscreen: s(M, "isFullscreen"),
                    player_autoplay_on: !!s(M, "autoplay"),
                    player_preload_on: s(M, "preload"),
                    player_width: o(M.el(), "width"),
                    player_height: o(M.el(), "height"),
                    player_language_code: s(M, "language"),
                    video_poster_url: s(M, "poster"),
                    video_source_url: s(M, "currentSrc"),
                    video_source_mime_type: s(M, "currentType") && s(M, "currentType").toLowerCase(),
                    video_source_duration: b(s(M, "duration") || 0),
                    video_source_height: V,
                    video_source_width: Y
                  };
                }, M.mux = function () {
                  _.error("[videojs-mux] The plugin was initialized more than once.");
                }, M.mux.emit = function (V, Y) {
                  P.default.emit(F, V, Y);
                }, M.mux.addHLSJS = function (V) {
                  P.default.addHLSJS(F, V);
                }, M.mux.log = _, M.mux.utils = P.default.utils, P.default.init(F, I);

                var B = !1,
                    U = function () {
                  B || M.mux.emit("playerready"), B = !0;
                };

                M.ready(function () {
                  M.addClass("vjs-mux"), f.default.setTimeout(U, 0);
                });
                var W = !1;
                M.one("play", U), A.forEach(function (V) {
                  (V !== "error" || I.automaticErrorTracking) && M.on(V, function () {
                    if (!W) {
                      var Y = {};

                      if (V === "error") {
                        var $ = s(M, "error");
                        Y.player_error_code = $ && $.code, Y.player_error_message = $ && $.message;
                      }

                      M.mux.emit(V, Y);
                    }
                  });
                });
                var G = !1;
                M.on("play", function () {
                  G = !0;
                }), M.on("pause", function () {
                  G = !1;
                }), M.on("adstart", function () {
                  W = !0, G && M.mux.emit("pause"), M.mux.emit("adbreakstart");
                }), M.on("adend", function () {
                  M.mux.emit("adbreakend"), W = !1, s(M, "paused") || (M.mux.emit("play"), G = !0, M.onceux && M.mux.emit("playing"));
                }), M.ima && (0, u.default)(M), M.onceux && (0, c.default)(M), M.ima3 && typeof M.ima3.ready == "function" && (0, n.default)(M), M.FreeWheelPlugin && M.FreeWheelPlugin.VERSION && (0, v.default)(M), M.on("dispose", function () {
                  M.mux.emit("destroy");
                });
              }

              var D = H(3),
                  E = w(D),
                  L = H(0),
                  P = w(L),
                  d = H(4),
                  f = w(d),
                  y = H(6),
                  u = w(y),
                  i = H(7),
                  n = w(i),
                  a = H(8),
                  v = w(a),
                  h = H(9),
                  c = w(h),
                  p = H(10),
                  C = w(p),
                  _ = P.default.log,
                  g = P.default.utils.assign,
                  s = P.default.utils.safeCall,
                  o = P.default.utils.getComputedStyle,
                  b = P.default.utils.secondsToMs,
                  A = ["loadstart", "pause", "play", "playing", "seeking", "seeked", "timeupdate", "ratechange", "stalled", "waiting", "error", "ended"];
              (E.default.registerPlugin || E.default.plugin || function () {
                P.default.log.error("No valid method to register videojs plugin available.");
              })("mux", O), (0, C.default)(E.default);
            }, function (x, k) {
              x.exports = j;
            }, function (x, k, H) {
              (function (w) {
                var O;
                O = typeof window != "undefined" ? window : w !== void 0 ? w : typeof self != "undefined" ? self : {}, x.exports = O;
              }).call(k, H(5));
            }, function (x, k) {
              var H;

              H = function () {
                return this;
              }();

              try {
                H = H || Function("return this")() || (0, eval)("this");
              } catch (w) {
                typeof window == "object" && (H = window);
              }

              x.exports = H;
            }, function (x, k, H) {
              "use strict";

              function w(O) {
                var D = function (n) {
                  n = n || {};
                  var a = typeof n.getAdData == "function" ? n.getAdData() : {},
                      v = typeof n.getAd == "function" ? n.getAd() : {},
                      h = typeof v.getMediaUrl == "function" ? v.getMediaUrl() : a.mediaUrl,
                      c = O.ima.settings || {},
                      p = {};
                  return h && (p.ad_asset_url = h), c.adTagUrl && (p.ad_tag_url = c.adTagUrl), p;
                },
                    E = void 0,
                    L = void 0,
                    P = void 0,
                    d = void 0,
                    f = void 0,
                    y = void 0;

                try {
                  var u = window.google.ima.AdEvent.Type;
                  E = u.LOADED, L = u.STARTED, P = u.COMPLETE, d = u.PAUSED, f = u.RESUMED, y = u.SKIPPED;
                } catch (n) {
                  E = "loaded", L = "start", P = "complete", d = "pause", f = "resume", y = "skip";
                }

                var i = 0;
                O.mux.triggerAdRequest = function () {
                  i++, O.mux.emit("adrequest", D());
                }, O.on("adsready", function () {
                  var n = O.ima.addEventListener || function () {};

                  n(E, function (a) {
                    var v = D(a);
                    i > 0 && (i--, O.mux.emit("adresponse", v)), O.mux.emit("adplay", v);
                  }), n(L, function (a) {
                    var v = D(a);
                    O.mux.emit("adplaying", v);
                  }), n(f, function (a) {
                    var v = D(a);
                    O.mux.emit("adplay", v), O.mux.emit("adplaying", v);
                  }), n(d, function (a) {
                    var v = D(a);
                    O.mux.emit("adpause", v);
                  }), n(P, function (a) {
                    var v = D(a);
                    O.mux.emit("adended", v);
                  }), n(y, function (a) {
                    var v = D(a);
                    O.mux.emit("adended", v);
                  }), O.on("adserror", function () {
                    i > 0 && (i--, O.mux.emit("adresponse")), O.mux.emit("aderror");
                  });
                });
              }

              Object.defineProperty(k, "__esModule", {
                value: !0
              }), k.default = w;
            }, function (x, k, H) {
              "use strict";

              function w(L) {
                if (typeof L != "string") return !1;
                var P = L.split(".").map(function (y) {
                  return parseInt(y);
                }),
                    d = P[0],
                    f = P[1];
                return d > 2 || d === 2 && f >= 3;
              }

              function O(L) {
                var P = function () {
                  var y = L.ima3.currentAd,
                      u = L.ima3.settings,
                      i = {};
                  return y && (i.ad_asset_url = y.mediaUrl), u && (i.ad_tag_url = u.serverUrl), i;
                };

                if (w(L.ima3.version)) {
                  var d = 0,
                      f = function () {
                    d > 0 && (d--, L.mux.emit("adresponse", P()));
                  };

                  L.on("ads-request", function () {
                    d++, L.mux.emit("adrequest", P());
                  }), L.on("ads-load", function () {
                    f(), L.mux.emit("adplay", P());
                  }), L.on("adserror", function () {
                    f(), L.mux.emit("aderror");
                  }), L.on("ads-play", function () {
                    L.mux.emit("adplay", P());
                  }), L.on("ads-pause", function () {
                    L.mux.emit("adpause", P());
                  }), L.on("ads-ad-ended", function () {
                    L.mux.emit("adended", P());
                  });
                }

                L.ima3.ready(function () {
                  if (L.ima3.adPlayer) {
                    w(L.ima3.version) || (L.ima3.adPlayer.on("play", function () {
                      L.mux.emit("adplay");
                    }), L.ima3.adPlayer.on("pause", function () {
                      L.mux.emit("adpause");
                    }), L.ima3.adPlayer.on("ended", function () {
                      L.mux.emit("adended");
                    }));
                    var y = ["pause", "ended", "adserror"],
                        u = ["play"];
                    (0, E.default)(L, L.ima3.adPlayer, y, u, P);
                  } else L.mux.log("Legacy IMA3 plugin found, ad events may not track correctly."), L.on("ads-ad-started", function () {
                    L.mux.emit("adplaying", P());
                  }), L.on("ads-play", function () {
                    L.mux.emit("adplaying", P());
                  });
                });
              }

              Object.defineProperty(k, "__esModule", {
                value: !0
              }), k.brightcoveImaAdsEventsSupported = w, k.default = O;

              var D = H(1),
                  E = function (L) {
                return L && L.__esModule ? L : {
                  default: L
                };
              }(D);
            }, function (x, k, H) {
              "use strict";

              function w(O) {
                var D = function (E) {
                  var L = O.FreeWheelPlugin,
                      P = {};

                  switch (E) {
                    case "adplay":
                    case "adplaying":
                    case "adpause":
                      P.ad_asset_url = O.currentSrc();
                  }

                  return L && (P.ad_tag_url = L.tech.toLowerCase() === "html5" ? L.settings.Html5.serverUrl : L.settings.Flash.serverUrl), P;
                };

                O.on("ads-request", function () {
                  O.mux.emit("adrequest", D("adrequest"));
                }), O.on("ads-load", function () {
                  O.mux.emit("adresponse", D("adresponse"));
                }), O.on("adserror", function () {
                  O.mux.emit("aderror");
                }), O.on("ads-ad-started", function () {
                  O.mux.emit("adplay", D("adplay")), O.mux.emit("adplaying", D("adplaying"));
                }), O.on("ads-play", function () {
                  O.mux.emit("adplay", D("adplay")), O.mux.emit("adplaying", D("adplaying"));
                }), O.on("ads-pause", function () {
                  O.mux.emit("adpause", D("adpause"));
                }), O.on("ads-ad-ended", function () {
                  O.mux.emit("adended", D("adended"));
                }), O.on("adend", function () {
                  O.mux.emit("play");
                });
              }

              Object.defineProperty(k, "__esModule", {
                value: !0
              }), k.default = w;
            }, function (x, k, H) {
              "use strict";

              function w(E) {
                var L = ["onceux-linearad-pause", "onceux-linearad-skipped", "onceux-linearad-complete", "adserror"],
                    P = ["adstart", "onceux-linearad-resume"];
                (0, D.default)(E, E, L, P), E.on("adstart", function () {
                  E.mux.emit("adplay");
                }), E.on("onceux-linearad-start", function (d) {
                  d.linearAd && d.linearAd.index > 0 && (E.mux.emit("adplay"), E.mux.emit("adplaying"));
                }), E.on("onceux-linearad-resume", function () {
                  E.mux.emit("adplay");
                }), E.on("onceux-linearad-pause", function () {
                  E.mux.emit("adpause");
                }), E.on("onceux-linearad-complete", function () {
                  E.mux.emit("adended");
                }), E.on("onceux-linearad-skipped", function () {
                  E.mux.emit("adended");
                });
              }

              Object.defineProperty(k, "__esModule", {
                value: !0
              }), k.default = w;

              var O = H(1),
                  D = function (E) {
                return E && E.__esModule ? E : {
                  default: E
                };
              }(O);
            }, function (x, k, H) {
              "use strict";

              function w(d) {
                if (!P && typeof d.getTech == "function") {
                  for (var f = d.getTech("Html5") || {}, y = f.sourceHandlers, u = 0; u < y.length; u++) (function (i) {
                    var n = y[i],
                        a = n.handleSource;

                    n.handleSource = function (v, h) {
                      var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
                          p = a(v, h, c);
                      if (p && typeof p.xhr == "function") try {
                        var C = d.VERSION.split("."),
                            _ = O(C, 2),
                            g = _[0],
                            s = _[1];

                        g = parseInt(g), s = parseInt(s);
                        var o = g >= 7 && s >= 4 ? p.player().id() : p.player_.el_.parentNode.id;
                        (0, E.default)(d(o), p.xhr), (0, L.trackRenditionChanges)(d(o));
                      } catch (b) {}
                      return p;
                    };
                  })(u);

                  P = !0;
                }
              }

              Object.defineProperty(k, "__esModule", {
                value: !0
              });

              var O = function () {
                function d(f, y) {
                  var u = [],
                      i = !0,
                      n = !1,
                      a = void 0;

                  try {
                    for (var v, h = f[Symbol.iterator](); !(i = (v = h.next()).done) && (u.push(v.value), !y || u.length !== y); i = !0);
                  } catch (c) {
                    n = !0, a = c;
                  } finally {
                    try {
                      !i && h.return && h.return();
                    } finally {
                      if (n) throw a;
                    }
                  }

                  return u;
                }

                return function (f, y) {
                  if (Array.isArray(f)) return f;
                  if (Symbol.iterator in Object(f)) return d(f, y);
                  throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
              }();

              k.default = w;

              var D = H(11),
                  E = function (d) {
                return d && d.__esModule ? d : {
                  default: d
                };
              }(D),
                  L = H(13),
                  P = !1;
            }, function (x, k, H) {
              "use strict";

              function w(d) {
                return d && d.__esModule ? d : {
                  default: d
                };
              }

              function O(d, f) {
                var y = function (i, n, a) {
                  var v = (0, E.default)(d, i, n);
                  return function () {
                    try {
                      v();
                    } catch (h) {}

                    try {
                      a();
                    } catch (h) {}
                  };
                },
                    u = function (i) {
                  return function (n) {
                    var a = P.default.utils.now();

                    try {
                      i(n);
                    } catch (v) {}

                    try {
                      n.onreadystatechange = y(n, a, n.onreadystatechange || function () {});
                    } catch (v) {}
                  };
                };

                f.beforeRequest = function (i) {
                  return function (n) {
                    var a = i(n);
                    return a.beforeSend = u(a.beforeSend || function () {}), a;
                  };
                }(f.beforeRequest || function (i) {
                  return i;
                });
              }

              Object.defineProperty(k, "__esModule", {
                value: !0
              }), k.default = O;
              var D = H(12),
                  E = w(D),
                  L = H(0),
                  P = w(L);
            }, function (x, k, H) {
              "use strict";

              function w(L, P, d) {
                var f = L.mux.utils.extractHostnameAndDomain,
                    y = L.mux.utils.headersStringToObject,
                    u = function (n) {
                  var a = n["content-type"];
                  return a ? a.match(/^audio\/mpegurl/i) ? "manifest" : a.match(/^audio.*/i) ? "audio" : a.match(/^video.*/) ? "video" : a.match(/^application\/x-mpegurl/i) || a.match(/^application\/vnd.apple.mpegurl/i) || a.match(/^application\/dash+xml/i) ? "manifest" : "unknown" : "unknown";
                },
                    i = 0;

                return function () {
                  var n = P.readyState;

                  if (n >= 2) {
                    if (i = i || E.default.utils.now(), n !== 4) return;

                    if (P.status >= 200 && P.status < 300) {
                      var a = E.default.utils.now(),
                          v = P.responseType === "arraybuffer" ? P.response.byteLength : P.responseText.length,
                          h = f(P.responseURL),
                          c = O(h, 1),
                          p = c[0],
                          C = y(P.getAllResponseHeaders ? P.getAllResponseHeaders() : ""),
                          _ = u(C),
                          g = {
                        request_start: d,
                        request_response_start: i,
                        request_response_end: a,
                        request_bytes_loaded: v,
                        request_hostname: p,
                        request_response_headers: C,
                        request_type: _
                      };

                      L.mux.emit("requestcompleted", g);
                    } else L.mux.emit("requestfailed");
                  }
                };
              }

              Object.defineProperty(k, "__esModule", {
                value: !0
              });

              var O = function () {
                function L(P, d) {
                  var f = [],
                      y = !0,
                      u = !1,
                      i = void 0;

                  try {
                    for (var n, a = P[Symbol.iterator](); !(y = (n = a.next()).done) && (f.push(n.value), !d || f.length !== d); y = !0);
                  } catch (v) {
                    u = !0, i = v;
                  } finally {
                    try {
                      !y && a.return && a.return();
                    } finally {
                      if (u) throw i;
                    }
                  }

                  return f;
                }

                return function (P, d) {
                  if (Array.isArray(P)) return P;
                  if (Symbol.iterator in Object(P)) return L(P, d);
                  throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
              }();

              k.default = w;

              var D = H(0),
                  E = function (L) {
                return L && L.__esModule ? L : {
                  default: L
                };
              }(D);
            }, function (x, k, H) {
              "use strict";

              Object.defineProperty(k, "__esModule", {
                value: !0
              });

              var w = function (D) {
                for (var E = D.textTracks(), L = void 0, P = 0; P < E.length; P++) E[P].label === "segment-metadata" && (L = E[P]);

                return L;
              },
                  O = function (D) {
                var E = w(D),
                    L = void 0;
                E && E.on && E.on("cuechange", function () {
                  try {
                    var P = D.tech({
                      IWillNotUseThisInPlugins: !0
                    }),
                        d = P.vhs || P.hls,
                        f = d.playlists.media().attributes.BANDWIDTH;
                    L !== f && D.mux.emit("renditionchange", {
                      video_source_bitrate: f
                    }), L = f;
                  } catch (y) {
                    D.mux && D.mux.log && D.mux.log.warn && D.mux.log.warn("Cannot retrieve BANDWIDTH information from player: " + y);
                  }
                });
              };

              k.getSegmentMetadataTrack = w, k.trackRenditionChanges = O;
            }]);
          });
        })();
      },
      497: (ve, ae, K) => {
        var R = K(697),
            j = ve.exports = {
          WebVTT: K(13),
          VTTCue: K(190),
          VTTRegion: K(146)
        };
        R.vttjs = j, R.WebVTT = j.WebVTT;
        var x = j.VTTCue,
            k = j.VTTRegion,
            H = R.VTTCue,
            w = R.VTTRegion;
        j.shim = function () {
          R.VTTCue = x, R.VTTRegion = k;
        }, j.restore = function () {
          R.VTTCue = H, R.VTTRegion = w;
        }, R.VTTCue || j.shim();
      },
      13: (ve, ae, K) => {
        var R = K(675),
            j = Object.create || function () {
          function s() {}

          return function (o) {
            if (arguments.length !== 1) throw new Error("Object.create shim only accepts one parameter.");
            return s.prototype = o, new s();
          };
        }();

        function x(s, o) {
          this.name = "ParsingError", this.code = s.code, this.message = o || s.message;
        }

        x.prototype = j(Error.prototype), x.prototype.constructor = x, x.Errors = {
          BadSignature: {
            code: 0,
            message: "Malformed WebVTT signature."
          },
          BadTimeStamp: {
            code: 1,
            message: "Malformed time stamp."
          }
        };

        function k(s) {
          function o(A, I, M, F) {
            return (A | 0) * 3600 + (I | 0) * 60 + (M | 0) + (F | 0) / 1e3;
          }

          var b = s.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
          return b ? b[3] ? o(b[1], b[2], b[3].replace(":", ""), b[4]) : b[1] > 59 ? o(b[1], b[2], 0, b[4]) : o(0, b[1], b[2], b[4]) : null;
        }

        function H() {
          this.values = j(null);
        }

        H.prototype = {
          set: function (s, o) {
            !this.get(s) && o !== "" && (this.values[s] = o);
          },
          get: function (s, o, b) {
            return b ? this.has(s) ? this.values[s] : o[b] : this.has(s) ? this.values[s] : o;
          },
          has: function (s) {
            return s in this.values;
          },
          alt: function (s, o, b) {
            for (var A = 0; A < b.length; ++A) if (o === b[A]) {
              this.set(s, o);
              break;
            }
          },
          integer: function (s, o) {
            /^-?\d+$/.test(o) && this.set(s, parseInt(o, 10));
          },
          percent: function (s, o) {
            var b;
            return (b = o.match(/^([\d]{1,3})(\.[\d]*)?%$/)) && (o = parseFloat(o), o >= 0 && o <= 100) ? (this.set(s, o), !0) : !1;
          }
        };

        function w(s, o, b, A) {
          var I = A ? s.split(A) : [s];

          for (var M in I) if (typeof I[M] == "string") {
            var F = I[M].split(b);

            if (F.length === 2) {
              var B = F[0],
                  U = F[1];
              o(B, U);
            }
          }
        }

        function O(s, o, b) {
          var A = s;

          function I() {
            var B = k(s);
            if (B === null) throw new x(x.Errors.BadTimeStamp, "Malformed timestamp: " + A);
            return s = s.replace(/^[^\sa-zA-Z-]+/, ""), B;
          }

          function M(B, U) {
            var W = new H();
            w(B, function (G, V) {
              switch (G) {
                case "region":
                  for (var Y = b.length - 1; Y >= 0; Y--) if (b[Y].id === V) {
                    W.set(G, b[Y].region);
                    break;
                  }

                  break;

                case "vertical":
                  W.alt(G, V, ["rl", "lr"]);
                  break;

                case "line":
                  var $ = V.split(","),
                      q = $[0];
                  W.integer(G, q), W.percent(G, q) && W.set("snapToLines", !1), W.alt(G, q, ["auto"]), $.length === 2 && W.alt("lineAlign", $[1], ["start", "center", "end"]);
                  break;

                case "position":
                  $ = V.split(","), W.percent(G, $[0]), $.length === 2 && W.alt("positionAlign", $[1], ["start", "center", "end"]);
                  break;

                case "size":
                  W.percent(G, V);
                  break;

                case "align":
                  W.alt(G, V, ["start", "center", "end", "left", "right"]);
                  break;
              }
            }, /:/, /\s/), U.region = W.get("region", null), U.vertical = W.get("vertical", "");

            try {
              U.line = W.get("line", "auto");
            } catch (G) {}

            U.lineAlign = W.get("lineAlign", "start"), U.snapToLines = W.get("snapToLines", !0), U.size = W.get("size", 100);

            try {
              U.align = W.get("align", "center");
            } catch (G) {
              U.align = W.get("align", "middle");
            }

            try {
              U.position = W.get("position", "auto");
            } catch (G) {
              U.position = W.get("position", {
                start: 0,
                left: 0,
                center: 50,
                middle: 50,
                end: 100,
                right: 100
              }, U.align);
            }

            U.positionAlign = W.get("positionAlign", {
              start: "start",
              left: "start",
              center: "center",
              middle: "center",
              end: "end",
              right: "end"
            }, U.align);
          }

          function F() {
            s = s.replace(/^\s+/, "");
          }

          if (F(), o.startTime = I(), F(), s.substr(0, 3) !== "-->") throw new x(x.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '-->'): " + A);
          s = s.substr(3), F(), o.endTime = I(), F(), M(s, o);
        }

        var D = R.createElement && R.createElement("textarea"),
            E = {
          c: "span",
          i: "i",
          b: "b",
          u: "u",
          ruby: "ruby",
          rt: "rt",
          v: "span",
          lang: "span"
        },
            L = {
          white: "rgba(255,255,255,1)",
          lime: "rgba(0,255,0,1)",
          cyan: "rgba(0,255,255,1)",
          red: "rgba(255,0,0,1)",
          yellow: "rgba(255,255,0,1)",
          magenta: "rgba(255,0,255,1)",
          blue: "rgba(0,0,255,1)",
          black: "rgba(0,0,0,1)"
        },
            P = {
          v: "title",
          lang: "lang"
        },
            d = {
          rt: "ruby"
        };

        function f(s, o) {
          function b() {
            if (!o) return null;

            function q(te) {
              return o = o.substr(te.length), te;
            }

            var Z = o.match(/^([^<]*)(<[^>]*>?)?/);
            return q(Z[1] ? Z[1] : Z[2]);
          }

          function A(q) {
            return D.innerHTML = q, q = D.textContent, D.textContent = "", q;
          }

          function I(q, Z) {
            return !d[Z.localName] || d[Z.localName] === q.localName;
          }

          function M(q, Z) {
            var te = E[q];
            if (!te) return null;
            var se = s.document.createElement(te),
                ge = P[q];
            return ge && Z && (se[ge] = Z.trim()), se;
          }

          for (var F = s.document.createElement("div"), B = F, U, W = []; (U = b()) !== null;) {
            if (U[0] === "<") {
              if (U[1] === "/") {
                W.length && W[W.length - 1] === U.substr(2).replace(">", "") && (W.pop(), B = B.parentNode);
                continue;
              }

              var G = k(U.substr(1, U.length - 2)),
                  V;

              if (G) {
                V = s.document.createProcessingInstruction("timestamp", G), B.appendChild(V);
                continue;
              }

              var Y = U.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
              if (!Y || (V = M(Y[1], Y[3]), !V) || !I(B, V)) continue;

              if (Y[2]) {
                var $ = Y[2].split(".");
                $.forEach(function (q) {
                  var Z = /^bg_/.test(q),
                      te = Z ? q.slice(3) : q;

                  if (L.hasOwnProperty(te)) {
                    var se = Z ? "background-color" : "color",
                        ge = L[te];
                    V.style[se] = ge;
                  }
                }), V.className = $.join(" ");
              }

              W.push(Y[1]), B.appendChild(V), B = V;
              continue;
            }

            B.appendChild(s.document.createTextNode(A(U)));
          }

          return F;
        }

        var y = [[1470, 1470], [1472, 1472], [1475, 1475], [1478, 1478], [1488, 1514], [1520, 1524], [1544, 1544], [1547, 1547], [1549, 1549], [1563, 1563], [1566, 1610], [1645, 1647], [1649, 1749], [1765, 1766], [1774, 1775], [1786, 1805], [1807, 1808], [1810, 1839], [1869, 1957], [1969, 1969], [1984, 2026], [2036, 2037], [2042, 2042], [2048, 2069], [2074, 2074], [2084, 2084], [2088, 2088], [2096, 2110], [2112, 2136], [2142, 2142], [2208, 2208], [2210, 2220], [8207, 8207], [64285, 64285], [64287, 64296], [64298, 64310], [64312, 64316], [64318, 64318], [64320, 64321], [64323, 64324], [64326, 64449], [64467, 64829], [64848, 64911], [64914, 64967], [65008, 65020], [65136, 65140], [65142, 65276], [67584, 67589], [67592, 67592], [67594, 67637], [67639, 67640], [67644, 67644], [67647, 67669], [67671, 67679], [67840, 67867], [67872, 67897], [67903, 67903], [67968, 68023], [68030, 68031], [68096, 68096], [68112, 68115], [68117, 68119], [68121, 68147], [68160, 68167], [68176, 68184], [68192, 68223], [68352, 68405], [68416, 68437], [68440, 68466], [68472, 68479], [68608, 68680], [126464, 126467], [126469, 126495], [126497, 126498], [126500, 126500], [126503, 126503], [126505, 126514], [126516, 126519], [126521, 126521], [126523, 126523], [126530, 126530], [126535, 126535], [126537, 126537], [126539, 126539], [126541, 126543], [126545, 126546], [126548, 126548], [126551, 126551], [126553, 126553], [126555, 126555], [126557, 126557], [126559, 126559], [126561, 126562], [126564, 126564], [126567, 126570], [126572, 126578], [126580, 126583], [126585, 126588], [126590, 126590], [126592, 126601], [126603, 126619], [126625, 126627], [126629, 126633], [126635, 126651], [1114109, 1114109]];

        function u(s) {
          for (var o = 0; o < y.length; o++) {
            var b = y[o];
            if (s >= b[0] && s <= b[1]) return !0;
          }

          return !1;
        }

        function i(s) {
          var o = [],
              b = "",
              A;
          if (!s || !s.childNodes) return "ltr";

          function I(B, U) {
            for (var W = U.childNodes.length - 1; W >= 0; W--) B.push(U.childNodes[W]);
          }

          function M(B) {
            if (!B || !B.length) return null;
            var U = B.pop(),
                W = U.textContent || U.innerText;

            if (W) {
              var G = W.match(/^.*(\n|\r)/);
              return G ? (B.length = 0, G[0]) : W;
            }

            if (U.tagName === "ruby") return M(B);
            if (U.childNodes) return I(B, U), M(B);
          }

          for (I(o, s); b = M(o);) for (var F = 0; F < b.length; F++) if (A = b.charCodeAt(F), u(A)) return "rtl";

          return "ltr";
        }

        function n(s) {
          if (typeof s.line == "number" && (s.snapToLines || s.line >= 0 && s.line <= 100)) return s.line;
          if (!s.track || !s.track.textTrackList || !s.track.textTrackList.mediaElement) return -1;

          for (var o = s.track, b = o.textTrackList, A = 0, I = 0; I < b.length && b[I] !== o; I++) b[I].mode === "showing" && A++;

          return ++A * -1;
        }

        function a() {}

        a.prototype.applyStyles = function (s, o) {
          o = o || this.div;

          for (var b in s) s.hasOwnProperty(b) && (o.style[b] = s[b]);
        }, a.prototype.formatStyle = function (s, o) {
          return s === 0 ? 0 : s + o;
        };

        function v(s, o, b) {
          a.call(this), this.cue = o, this.cueDiv = f(s, o.text);
          var A = {
            color: "rgba(255, 255, 255, 1)",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            position: "relative",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            display: "inline",
            writingMode: o.vertical === "" ? "horizontal-tb" : o.vertical === "lr" ? "vertical-lr" : "vertical-rl",
            unicodeBidi: "plaintext"
          };
          this.applyStyles(A, this.cueDiv), this.div = s.document.createElement("div"), A = {
            direction: i(this.cueDiv),
            writingMode: o.vertical === "" ? "horizontal-tb" : o.vertical === "lr" ? "vertical-lr" : "vertical-rl",
            unicodeBidi: "plaintext",
            textAlign: o.align === "middle" ? "center" : o.align,
            font: b.font,
            whiteSpace: "pre-line",
            position: "absolute"
          }, this.applyStyles(A), this.div.appendChild(this.cueDiv);
          var I = 0;

          switch (o.positionAlign) {
            case "start":
              I = o.position;
              break;

            case "center":
              I = o.position - o.size / 2;
              break;

            case "end":
              I = o.position - o.size;
              break;
          }

          o.vertical === "" ? this.applyStyles({
            left: this.formatStyle(I, "%"),
            width: this.formatStyle(o.size, "%")
          }) : this.applyStyles({
            top: this.formatStyle(I, "%"),
            height: this.formatStyle(o.size, "%")
          }), this.move = function (M) {
            this.applyStyles({
              top: this.formatStyle(M.top, "px"),
              bottom: this.formatStyle(M.bottom, "px"),
              left: this.formatStyle(M.left, "px"),
              right: this.formatStyle(M.right, "px"),
              height: this.formatStyle(M.height, "px"),
              width: this.formatStyle(M.width, "px")
            });
          };
        }

        v.prototype = j(a.prototype), v.prototype.constructor = v;

        function h(s) {
          var o, b, A, I;

          if (s.div) {
            b = s.div.offsetHeight, A = s.div.offsetWidth, I = s.div.offsetTop;
            var M = (M = s.div.childNodes) && (M = M[0]) && M.getClientRects && M.getClientRects();
            s = s.div.getBoundingClientRect(), o = M ? Math.max(M[0] && M[0].height || 0, s.height / M.length) : 0;
          }

          this.left = s.left, this.right = s.right, this.top = s.top || I, this.height = s.height || b, this.bottom = s.bottom || I + (s.height || b), this.width = s.width || A, this.lineHeight = o !== void 0 ? o : s.lineHeight;
        }

        h.prototype.move = function (s, o) {
          switch (o = o !== void 0 ? o : this.lineHeight, s) {
            case "+x":
              this.left += o, this.right += o;
              break;

            case "-x":
              this.left -= o, this.right -= o;
              break;

            case "+y":
              this.top += o, this.bottom += o;
              break;

            case "-y":
              this.top -= o, this.bottom -= o;
              break;
          }
        }, h.prototype.overlaps = function (s) {
          return this.left < s.right && this.right > s.left && this.top < s.bottom && this.bottom > s.top;
        }, h.prototype.overlapsAny = function (s) {
          for (var o = 0; o < s.length; o++) if (this.overlaps(s[o])) return !0;

          return !1;
        }, h.prototype.within = function (s) {
          return this.top >= s.top && this.bottom <= s.bottom && this.left >= s.left && this.right <= s.right;
        }, h.prototype.overlapsOppositeAxis = function (s, o) {
          switch (o) {
            case "+x":
              return this.left < s.left;

            case "-x":
              return this.right > s.right;

            case "+y":
              return this.top < s.top;

            case "-y":
              return this.bottom > s.bottom;
          }
        }, h.prototype.intersectPercentage = function (s) {
          var o = Math.max(0, Math.min(this.right, s.right) - Math.max(this.left, s.left)),
              b = Math.max(0, Math.min(this.bottom, s.bottom) - Math.max(this.top, s.top)),
              A = o * b;
          return A / (this.height * this.width);
        }, h.prototype.toCSSCompatValues = function (s) {
          return {
            top: this.top - s.top,
            bottom: s.bottom - this.bottom,
            left: this.left - s.left,
            right: s.right - this.right,
            height: this.height,
            width: this.width
          };
        }, h.getSimpleBoxPosition = function (s) {
          var o = s.div ? s.div.offsetHeight : s.tagName ? s.offsetHeight : 0,
              b = s.div ? s.div.offsetWidth : s.tagName ? s.offsetWidth : 0,
              A = s.div ? s.div.offsetTop : s.tagName ? s.offsetTop : 0;
          s = s.div ? s.div.getBoundingClientRect() : s.tagName ? s.getBoundingClientRect() : s;
          var I = {
            left: s.left,
            right: s.right,
            top: s.top || A,
            height: s.height || o,
            bottom: s.bottom || A + (s.height || o),
            width: s.width || b
          };
          return I;
        };

        function c(s, o, b, A) {
          function I(te, se) {
            for (var ge, he = new h(te), ye = 1, pe = 0; pe < se.length; pe++) {
              for (; te.overlapsOppositeAxis(b, se[pe]) || te.within(b) && te.overlapsAny(A);) te.move(se[pe]);

              if (te.within(b)) return te;

              var _e = te.intersectPercentage(b);

              ye > _e && (ge = new h(te), ye = _e), te = new h(he);
            }

            return ge || he;
          }

          var M = new h(o),
              F = o.cue,
              B = n(F),
              U = [];

          if (F.snapToLines) {
            var W;

            switch (F.vertical) {
              case "":
                U = ["+y", "-y"], W = "height";
                break;

              case "rl":
                U = ["+x", "-x"], W = "width";
                break;

              case "lr":
                U = ["-x", "+x"], W = "width";
                break;
            }

            var G = M.lineHeight,
                V = G * Math.round(B),
                Y = b[W] + G,
                $ = U[0];
            Math.abs(V) > Y && (V = V < 0 ? -1 : 1, V *= Math.ceil(Y / G) * G), B < 0 && (V += F.vertical === "" ? b.height : b.width, U = U.reverse()), M.move($, V);
          } else {
            var q = M.lineHeight / b.height * 100;

            switch (F.lineAlign) {
              case "center":
                B -= q / 2;
                break;

              case "end":
                B -= q;
                break;
            }

            switch (F.vertical) {
              case "":
                o.applyStyles({
                  top: o.formatStyle(B, "%")
                });
                break;

              case "rl":
                o.applyStyles({
                  left: o.formatStyle(B, "%")
                });
                break;

              case "lr":
                o.applyStyles({
                  right: o.formatStyle(B, "%")
                });
                break;
            }

            U = ["+y", "-x", "+x", "-y"], M = new h(o);
          }

          var Z = I(M, U);
          o.move(Z.toCSSCompatValues(b));
        }

        function p() {}

        p.StringDecoder = function () {
          return {
            decode: function (s) {
              if (!s) return "";
              if (typeof s != "string") throw new Error("Error - expected string data.");
              return decodeURIComponent(encodeURIComponent(s));
            }
          };
        }, p.convertCueToDOMTree = function (s, o) {
          return !s || !o ? null : f(s, o);
        };
        var C = .05,
            _ = "sans-serif",
            g = "1.5%";
        p.processCues = function (s, o, b) {
          if (!s || !o || !b) return null;

          for (; b.firstChild;) b.removeChild(b.firstChild);

          var A = s.document.createElement("div");
          A.style.position = "absolute", A.style.left = "0", A.style.right = "0", A.style.top = "0", A.style.bottom = "0", A.style.margin = g, b.appendChild(A);

          function I(G) {
            for (var V = 0; V < G.length; V++) if (G[V].hasBeenReset || !G[V].displayState) return !0;

            return !1;
          }

          if (!I(o)) {
            for (var M = 0; M < o.length; M++) A.appendChild(o[M].displayState);

            return;
          }

          var F = [],
              B = h.getSimpleBoxPosition(A),
              U = Math.round(B.height * C * 100) / 100,
              W = {
            font: U + "px " + _
          };

          (function () {
            for (var G, V, Y = 0; Y < o.length; Y++) V = o[Y], G = new v(s, V, W), A.appendChild(G.div), c(s, G, B, F), V.displayState = G.div, F.push(h.getSimpleBoxPosition(G));
          })();
        }, p.Parser = function (s, o, b) {
          b || (b = o, o = {}), o || (o = {}), this.window = s, this.vttjs = o, this.state = "INITIAL", this.buffer = "", this.decoder = b || new TextDecoder("utf8"), this.regionList = [];
        }, p.Parser.prototype = {
          reportOrThrowError: function (s) {
            if (s instanceof x) this.onparsingerror && this.onparsingerror(s);else throw s;
          },
          parse: function (s) {
            var o = this;
            s && (o.buffer += o.decoder.decode(s, {
              stream: !0
            }));

            function b() {
              for (var G = o.buffer, V = 0; V < G.length && G[V] !== "\r" && G[V] !== "\n";) ++V;

              var Y = G.substr(0, V);
              return G[V] === "\r" && ++V, G[V] === "\n" && ++V, o.buffer = G.substr(V), Y;
            }

            function A(G) {
              var V = new H();

              if (w(G, function ($, q) {
                switch ($) {
                  case "id":
                    V.set($, q);
                    break;

                  case "width":
                    V.percent($, q);
                    break;

                  case "lines":
                    V.integer($, q);
                    break;

                  case "regionanchor":
                  case "viewportanchor":
                    var Z = q.split(",");
                    if (Z.length !== 2) break;
                    var te = new H();
                    if (te.percent("x", Z[0]), te.percent("y", Z[1]), !te.has("x") || !te.has("y")) break;
                    V.set($ + "X", te.get("x")), V.set($ + "Y", te.get("y"));
                    break;

                  case "scroll":
                    V.alt($, q, ["up"]);
                    break;
                }
              }, /=/, /\s/), V.has("id")) {
                var Y = new (o.vttjs.VTTRegion || o.window.VTTRegion)();
                Y.width = V.get("width", 100), Y.lines = V.get("lines", 3), Y.regionAnchorX = V.get("regionanchorX", 0), Y.regionAnchorY = V.get("regionanchorY", 100), Y.viewportAnchorX = V.get("viewportanchorX", 0), Y.viewportAnchorY = V.get("viewportanchorY", 100), Y.scroll = V.get("scroll", ""), o.onregion && o.onregion(Y), o.regionList.push({
                  id: V.get("id"),
                  region: Y
                });
              }
            }

            function I(G) {
              var V = new H();
              w(G, function (Y, $) {
                switch (Y) {
                  case "MPEGT":
                    V.integer(Y + "S", $);
                    break;

                  case "LOCA":
                    V.set(Y + "L", k($));
                    break;
                }
              }, /[^\d]:/, /,/), o.ontimestampmap && o.ontimestampmap({
                MPEGTS: V.get("MPEGTS"),
                LOCAL: V.get("LOCAL")
              });
            }

            function M(G) {
              G.match(/X-TIMESTAMP-MAP/) ? w(G, function (V, Y) {
                switch (V) {
                  case "X-TIMESTAMP-MAP":
                    I(Y);
                    break;
                }
              }, /=/) : w(G, function (V, Y) {
                switch (V) {
                  case "Region":
                    A(Y);
                    break;
                }
              }, /:/);
            }

            try {
              var F;

              if (o.state === "INITIAL") {
                if (!/\r\n|\n/.test(o.buffer)) return this;
                F = b();
                var B = F.match(/^WEBVTT([ \t].*)?$/);
                if (!B || !B[0]) throw new x(x.Errors.BadSignature);
                o.state = "HEADER";
              }

              for (var U = !1; o.buffer;) {
                if (!/\r\n|\n/.test(o.buffer)) return this;

                switch (U ? U = !1 : F = b(), o.state) {
                  case "HEADER":
                    /:/.test(F) ? M(F) : F || (o.state = "ID");
                    continue;

                  case "NOTE":
                    F || (o.state = "ID");
                    continue;

                  case "ID":
                    if (/^NOTE($|[ \t])/.test(F)) {
                      o.state = "NOTE";
                      break;
                    }

                    if (!F) continue;
                    o.cue = new (o.vttjs.VTTCue || o.window.VTTCue)(0, 0, "");

                    try {
                      o.cue.align = "center";
                    } catch (G) {
                      o.cue.align = "middle";
                    }

                    if (o.state = "CUE", F.indexOf("-->") === -1) {
                      o.cue.id = F;
                      continue;
                    }

                  case "CUE":
                    try {
                      O(F, o.cue, o.regionList);
                    } catch (G) {
                      o.reportOrThrowError(G), o.cue = null, o.state = "BADCUE";
                      continue;
                    }

                    o.state = "CUETEXT";
                    continue;

                  case "CUETEXT":
                    var W = F.indexOf("-->") !== -1;

                    if (!F || W && (U = !0)) {
                      o.oncue && o.oncue(o.cue), o.cue = null, o.state = "ID";
                      continue;
                    }

                    o.cue.text && (o.cue.text += "\n"), o.cue.text += F.replace(/\u2028/g, "\n").replace(/u2029/g, "\n");
                    continue;

                  case "BADCUE":
                    F || (o.state = "ID");
                    continue;
                }
              }
            } catch (G) {
              o.reportOrThrowError(G), o.state === "CUETEXT" && o.cue && o.oncue && o.oncue(o.cue), o.cue = null, o.state = o.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
            }

            return this;
          },
          flush: function () {
            var s = this;

            try {
              if (s.buffer += s.decoder.decode(), (s.cue || s.state === "HEADER") && (s.buffer += "\n\n", s.parse()), s.state === "INITIAL") throw new x(x.Errors.BadSignature);
            } catch (o) {
              s.reportOrThrowError(o);
            }

            return s.onflush && s.onflush(), this;
          }
        }, ve.exports = p;
      },
      190: ve => {
        var ae = "auto",
            K = {
          "": 1,
          lr: 1,
          rl: 1
        },
            R = {
          start: 1,
          center: 1,
          end: 1,
          left: 1,
          right: 1,
          auto: 1,
          "line-left": 1,
          "line-right": 1
        };

        function j(H) {
          if (typeof H != "string") return !1;
          var w = K[H.toLowerCase()];
          return w ? H.toLowerCase() : !1;
        }

        function x(H) {
          if (typeof H != "string") return !1;
          var w = R[H.toLowerCase()];
          return w ? H.toLowerCase() : !1;
        }

        function k(H, w, O) {
          this.hasBeenReset = !1;
          var D = "",
              E = !1,
              L = H,
              P = w,
              d = O,
              f = null,
              y = "",
              u = !0,
              i = "auto",
              n = "start",
              a = "auto",
              v = "auto",
              h = 100,
              c = "center";
          Object.defineProperties(this, {
            id: {
              enumerable: !0,
              get: function () {
                return D;
              },
              set: function (p) {
                D = "" + p;
              }
            },
            pauseOnExit: {
              enumerable: !0,
              get: function () {
                return E;
              },
              set: function (p) {
                E = !!p;
              }
            },
            startTime: {
              enumerable: !0,
              get: function () {
                return L;
              },
              set: function (p) {
                if (typeof p != "number") throw new TypeError("Start time must be set to a number.");
                L = p, this.hasBeenReset = !0;
              }
            },
            endTime: {
              enumerable: !0,
              get: function () {
                return P;
              },
              set: function (p) {
                if (typeof p != "number") throw new TypeError("End time must be set to a number.");
                P = p, this.hasBeenReset = !0;
              }
            },
            text: {
              enumerable: !0,
              get: function () {
                return d;
              },
              set: function (p) {
                d = "" + p, this.hasBeenReset = !0;
              }
            },
            region: {
              enumerable: !0,
              get: function () {
                return f;
              },
              set: function (p) {
                f = p, this.hasBeenReset = !0;
              }
            },
            vertical: {
              enumerable: !0,
              get: function () {
                return y;
              },
              set: function (p) {
                var C = j(p);
                if (C === !1) throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
                y = C, this.hasBeenReset = !0;
              }
            },
            snapToLines: {
              enumerable: !0,
              get: function () {
                return u;
              },
              set: function (p) {
                u = !!p, this.hasBeenReset = !0;
              }
            },
            line: {
              enumerable: !0,
              get: function () {
                return i;
              },
              set: function (p) {
                if (typeof p != "number" && p !== ae) throw new SyntaxError("Line: an invalid number or illegal string was specified.");
                i = p, this.hasBeenReset = !0;
              }
            },
            lineAlign: {
              enumerable: !0,
              get: function () {
                return n;
              },
              set: function (p) {
                var C = x(p);
                C ? (n = C, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
              }
            },
            position: {
              enumerable: !0,
              get: function () {
                return a;
              },
              set: function (p) {
                if (p < 0 || p > 100) throw new Error("Position must be between 0 and 100.");
                a = p, this.hasBeenReset = !0;
              }
            },
            positionAlign: {
              enumerable: !0,
              get: function () {
                return v;
              },
              set: function (p) {
                var C = x(p);
                C ? (v = C, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
              }
            },
            size: {
              enumerable: !0,
              get: function () {
                return h;
              },
              set: function (p) {
                if (p < 0 || p > 100) throw new Error("Size must be between 0 and 100.");
                h = p, this.hasBeenReset = !0;
              }
            },
            align: {
              enumerable: !0,
              get: function () {
                return c;
              },
              set: function (p) {
                var C = x(p);
                if (!C) throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
                c = C, this.hasBeenReset = !0;
              }
            }
          }), this.displayState = void 0;
        }

        k.prototype.getCueAsHTML = function () {
          return WebVTT.convertCueToDOMTree(window, this.text);
        }, ve.exports = k;
      },
      146: ve => {
        var ae = {
          "": !0,
          up: !0
        };

        function K(x) {
          if (typeof x != "string") return !1;
          var k = ae[x.toLowerCase()];
          return k ? x.toLowerCase() : !1;
        }

        function R(x) {
          return typeof x == "number" && x >= 0 && x <= 100;
        }

        function j() {
          var x = 100,
              k = 3,
              H = 0,
              w = 100,
              O = 0,
              D = 100,
              E = "";
          Object.defineProperties(this, {
            width: {
              enumerable: !0,
              get: function () {
                return x;
              },
              set: function (L) {
                if (!R(L)) throw new Error("Width must be between 0 and 100.");
                x = L;
              }
            },
            lines: {
              enumerable: !0,
              get: function () {
                return k;
              },
              set: function (L) {
                if (typeof L != "number") throw new TypeError("Lines must be set to a number.");
                k = L;
              }
            },
            regionAnchorY: {
              enumerable: !0,
              get: function () {
                return w;
              },
              set: function (L) {
                if (!R(L)) throw new Error("RegionAnchorX must be between 0 and 100.");
                w = L;
              }
            },
            regionAnchorX: {
              enumerable: !0,
              get: function () {
                return H;
              },
              set: function (L) {
                if (!R(L)) throw new Error("RegionAnchorY must be between 0 and 100.");
                H = L;
              }
            },
            viewportAnchorY: {
              enumerable: !0,
              get: function () {
                return D;
              },
              set: function (L) {
                if (!R(L)) throw new Error("ViewportAnchorY must be between 0 and 100.");
                D = L;
              }
            },
            viewportAnchorX: {
              enumerable: !0,
              get: function () {
                return O;
              },
              set: function (L) {
                if (!R(L)) throw new Error("ViewportAnchorX must be between 0 and 100.");
                O = L;
              }
            },
            scroll: {
              enumerable: !0,
              get: function () {
                return E;
              },
              set: function (L) {
                var P = K(L);
                P === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : E = P;
              }
            }
          });
        }

        ve.exports = j;
      },
      18: (ve, ae, K) => {
        ve.exports = K(393).default;
      },
      393: (ve, ae, K) => {
        "use strict";

        K.d(ae, {
          default: () => Me
        });
        var R = K(207),
            j = K.n(R),
            x = K(675),
            k = K.n(x);
        /*! @name videojs-contrib-quality-levels @version 2.1.0 @license Apache-2.0 */

        function H(le, ee) {
          le.prototype = Object.create(ee.prototype), le.prototype.constructor = le, le.__proto__ = ee;
        }

        function w(le) {
          if (le === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return le;
        }

        var O = function le(ee) {
          var oe = this;

          if (j().browser.IS_IE8) {
            oe = k().createElement("custom");

            for (var ue in le.prototype) ue !== "constructor" && (oe[ue] = le.prototype[ue]);
          }

          return oe.id = ee.id, oe.label = oe.id, oe.width = ee.width, oe.height = ee.height, oe.bitrate = ee.bandwidth, oe.enabled_ = ee.enabled, Object.defineProperty(oe, "enabled", {
            get: function () {
              return oe.enabled_();
            },
            set: function (ne) {
              oe.enabled_(ne);
            }
          }), oe;
        },
            D = function (le) {
          H(ee, le);

          function ee() {
            var ue;
            ue = le.call(this) || this;
            var re = w(w(ue));

            if (j().browser.IS_IE8) {
              re = k().createElement("custom");

              for (var ne in ee.prototype) ne !== "constructor" && (re[ne] = ee.prototype[ne]);
            }

            return re.levels_ = [], re.selectedIndex_ = -1, Object.defineProperty(re, "selectedIndex", {
              get: function () {
                return re.selectedIndex_;
              }
            }), Object.defineProperty(re, "length", {
              get: function () {
                return re.levels_.length;
              }
            }), re || w(ue);
          }

          var oe = ee.prototype;
          return oe.addQualityLevel = function (re) {
            var ne = this.getQualityLevelById(re.id);
            if (ne) return ne;
            var ce = this.levels_.length;
            return ne = new O(re), "" + ce in this || Object.defineProperty(this, ce, {
              get: function () {
                return this.levels_[ce];
              }
            }), this.levels_.push(ne), this.trigger({
              qualityLevel: ne,
              type: "addqualitylevel"
            }), ne;
          }, oe.removeQualityLevel = function (re) {
            for (var ne = null, ce = 0, me = this.length; ce < me; ce++) if (this[ce] === re) {
              ne = this.levels_.splice(ce, 1)[0], this.selectedIndex_ === ce ? this.selectedIndex_ = -1 : this.selectedIndex_ > ce && this.selectedIndex_--;
              break;
            }

            return ne && this.trigger({
              qualityLevel: re,
              type: "removequalitylevel"
            }), ne;
          }, oe.getQualityLevelById = function (re) {
            for (var ne = 0, ce = this.length; ne < ce; ne++) {
              var me = this[ne];
              if (me.id === re) return me;
            }

            return null;
          }, oe.dispose = function () {
            this.selectedIndex_ = -1, this.levels_.length = 0;
          }, ee;
        }(j().EventTarget);

        D.prototype.allowedEvents_ = {
          change: "change",
          addqualitylevel: "addqualitylevel",
          removequalitylevel: "removequalitylevel"
        };

        for (var E in D.prototype.allowedEvents_) D.prototype["on" + E] = null;

        var L = "2.1.0",
            P = j().registerPlugin || j().plugin,
            d = function (ee, oe) {
          var ue = ee.qualityLevels,
              re = new D(),
              ne = function ce() {
            re.dispose(), ee.qualityLevels = ue, ee.off("dispose", ce);
          };

          return ee.on("dispose", ne), ee.qualityLevels = function () {
            return re;
          }, ee.qualityLevels.VERSION = L, re;
        },
            f = function (ee) {
          return d(this, j().mergeOptions({}, ee));
        };

        P("qualityLevels", f), f.VERSION = L;
        const y = null;
        var u = "1.1.6";

        function i(le, ee) {
          le.prototype = Object.create(ee.prototype), le.prototype.constructor = le, le.__proto__ = ee;
        }

        function n(le) {
          if (le === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return le;
        }

        var a = j().getComponent("MenuItem"),
            v = j().getComponent("Component"),
            h = function (le) {
          i(ee, le);

          function ee(ue, re) {
            return re.selectable = !0, re.multiSelectable = !1, le.call(this, ue, re) || this;
          }

          var oe = ee.prototype;
          return oe.handleClick = function () {
            var re = this.options_;
            console.log("Changing quality to:", re.label), le.prototype.handleClick.call(this);

            for (var ne = this.player().qualityLevels(), ce = 0; ce < ne.length; ce++) re.index == ne.length || re.index == ce ? ne[ce].enabled = !0 : ne[ce].enabled = !1;
          }, oe.update = function () {
            var re = this.player().qualityLevels().selectedIndex;
            this.selected(this.options_.index == re);
          }, ee;
        }(a);

        v.registerComponent("SourceMenuItem", h);

        var c = j().getComponent("MenuButton"),
            p = function (le) {
          i(ee, le);

          function ee(ue, re) {
            var ne;
            ne = le.call(this, ue, re) || this, c.apply(n(ne), arguments);
            var ce = ne.player().qualityLevels();

            if (re && re.default) {
              if (re.default == "low") for (var me = 0; me < ce.length; me++) ce[me].enabled = me == 0;else if (re.default = "high") for (var me = 0; me < ce.length; me++) ce[me].enabled = me == ce.length - 1;
            }

            return ne.player().qualityLevels().on(["change", "addqualitylevel"], j().bind(n(ne), ne.update)), ne;
          }

          var oe = ee.prototype;
          return oe.createEl = function () {
            return j().dom.createEl("div", {
              className: "vjs-http-source-selector vjs-menu-button vjs-menu-button-popup vjs-control vjs-button"
            });
          }, oe.buildCSSClass = function () {
            return c.prototype.buildCSSClass.call(this) + " vjs-icon-cog";
          }, oe.update = function () {
            return c.prototype.update.call(this);
          }, oe.createItems = function () {
            for (var re = [], ne = this.player().qualityLevels(), ce = [], me = 0; me < ne.length; me++) {
              var Ae = ne.length - (me + 1),
                  Ce = Ae === ne.selectedIndex,
                  Ie = "" + Ae,
                  ke = Ae;
              ne[Ae].height ? (Ie = ne[Ae].height + "p", ke = parseInt(ne[Ae].height, 10)) : ne[Ae].bitrate && (Ie = Math.floor(ne[Ae].bitrate / 1e3) + " kbps", ke = parseInt(ne[Ae].bitrate, 10)), !(ce.indexOf(Ie) >= 0) && (ce.push(Ie), re.push(new h(this.player_, {
                label: Ie,
                index: Ae,
                selected: Ce,
                sortVal: ke
              })));
            }

            return ne.length > 1 && re.push(new h(this.player_, {
              label: "Auto",
              index: ne.length,
              selected: !1,
              sortVal: 99999
            })), re.sort(function (De, Re) {
              return De.options_.sortVal < Re.options_.sortVal ? 1 : De.options_.sortVal > Re.options_.sortVal ? -1 : 0;
            }), re;
          }, ee;
        }(c),
            C = {},
            _ = j().registerPlugin || j().plugin,
            g = function (ee, oe) {
          if (ee.addClass("vjs-http-source-selector"), console.log("videojs-http-source-selector initialized!"), console.log("player.techName_:" + ee.techName_), ee.techName_ != "Html5") return !1;
          ee.on(["loadedmetadata"], function (ue) {
            var re = ee.qualityLevels();
            if (j().log("loadmetadata event"), ee.videojs_http_source_selector_initialized == "undefined" || ee.videojs_http_source_selector_initialized == !0) console.log("player.videojs_http_source_selector_initialized == true");else {
              console.log("player.videojs_http_source_selector_initialized == false"), ee.videojs_http_source_selector_initialized = !0;
              var ne = ee.controlBar,
                  ce = ne.getChild("fullscreenToggle").el();
              ne.el().insertBefore(ne.addChild("SourceMenuButton").el(), ce);
            }
          });
        },
            s = function (ee) {
          var oe = this;
          this.ready(function () {
            g(oe, j().mergeOptions(C, ee));
          }), j().registerComponent("SourceMenuButton", p), j().registerComponent("SourceMenuItem", h);
        };

        _("httpSourceSelector", s), s.VERSION = u;
        const o = null;

        var b = K(199),
            A = K.n(b),
            I = Object.defineProperty,
            M = Object.getOwnPropertySymbols,
            F = Object.prototype.hasOwnProperty,
            B = Object.prototype.propertyIsEnumerable,
            U = (le, ee, oe) => ee in le ? I(le, ee, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: oe
        }) : le[ee] = oe,
            W = (le, ee) => {
          for (var oe in ee || (ee = {})) F.call(ee, oe) && U(le, oe, ee[oe]);

          if (M) for (var oe of M(ee)) B.call(ee, oe) && U(le, oe, ee[oe]);
          return le;
        },
            G = (le, ee, oe) => (U(le, typeof ee != "symbol" ? ee + "" : ee, oe), oe);

        class V {
          constructor(ee, oe) {
            let ue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            const re = j().getTech("Tech").prototype.error;
            this.source = ee, this.tech = oe, this.player = j().getPlayer(this.tech.options().playerId), this._html5TechError = this.tech.error, this.tech.error = re, this.el = oe.el(), this.hls = new (A())(W({
              backBufferLength: 30,
              liveDurationInfinity: !0
            }, ue.hls)), this.tech.hlsjs = this.hls, this.player.qualityLevels && this.setupQualityLevels(), this.setupEventHandlers(), this.setupHls(), this.mediaElErrorHandler_ = () => this.tech.error(this.el.error);
          }

          dispose() {
            this.el.removeEventListener("error", this.mediaElErrorHandler_), this.tech.error = this._html5TechError, this.hls.destroy(), delete this.tech.hlsjs;
          }

          setupEventHandlers() {
            const ee = {
              MEDIA_ERR_CUSTOM: 0,
              MEDIA_ERR_ABORTED: 1,
              MEDIA_ERR_NETWORK: 2,
              MEDIA_ERR_DECODE: 3,
              MEDIA_ERR_SRC_NOT_SUPPORTED: 4,
              MEDIA_ERR_ENCRYPTED: 5
            },
                  oe = {
              [A().ErrorTypes.NETWORK_ERROR]: ee.MEDIA_ERR_NETWORK,
              [A().ErrorTypes.MEDIA_ERROR]: ee.MEDIA_ERR_DECODE,
              [A().ErrorTypes.MUX_ERROR]: ee.MEDIA_ERR_DECODE,
              [A().ErrorTypes.KEY_SYSTEM_ERROR]: ee.MEDIA_ERR_ENCRYPTED,
              DEFAULT: ee.MEDIA_ERR_CUSTOM
            };
            Object.values(A().Events).forEach(ue => {
              if (ue === A().Events.ERROR) {
                this.hls.on(ue, (re, ne) => {
                  var ce;
                  const me = ne.type,
                        Ae = ne.fatal;
                  if (!Ae) return;
                  const Ce = (ce = oe[me]) != null ? ce : oe.DEFAULT;
                  this.tech.error({
                    code: Ce,
                    hlsError: ne
                  });
                });
                return;
              }

              this.hls.on(ue, (re, ne) => {
                this.tech.trigger(ue, ne);
              });
            }), this.el.addEventListener("error", this.mediaElErrorHandler_);
          }

          setupHls() {
            A().isSupported() ? (this.hls.attachMedia(this.el), this.hls.loadSource(this.source.src)) : this.el.canPlayType("application/vnd.apple.mpegurl") ? this.el.src = this.source.src : console.log("[videojs-mux-kit] Error: browser does not support MSE nor Hls natively");
          }

          setupQualityLevels() {
            const ee = this.player.qualityLevels();
            let oe;

            const ue = () => {
              let me;

              for (me = oe.length - 1; me > 0 && !oe[me]; me--);

              return me;
            },
                  re = () => ue() === this.hls.levels.length - 1,
                  ne = (me, Ae) => {
              const Ce = ue();
              re() ? this.hls.autoLevelCapping = -1 : this.hls.autoLevelCapping = Ce, !!Ae && this.hls.currentLevel !== me && (this.hls.currentLevel = me, ce());
            },
                  ce = (me, Ae) => {
              let Ce = this.hls.currentLevel;
              ee.selectedIndex_ = Ce, ee.trigger({
                type: "change",
                selectedIndex: Ce
              });
            };

            this.tech.on(A().Events.MANIFEST_LOADED, (me, Ae) => {
              if (oe = new Array(this.hls.levels.length).fill(!0), this.hls.autoLevelCapping !== -1) for (let Ce = this.hls.maxAutoLevel; Ce < this.hls.levels.length; Ce++) oe[Ce] = !1;
              this.hls.levels.forEach((Ce, Ie) => {
                ee.addQualityLevel({
                  id: Ie,
                  width: Ce.width,
                  height: Ce.height,
                  bitrate: Ce.bitrate,
                  enabled: ke => {
                    oe[Ie] = ke, ne(Ie, ke);
                  }
                });
              }), ee.selectedIndex_ = this.hls.currentLevel, ee.trigger({
                type: "change",
                selectedIndex: this.hls.currentLevel
              });
            }), this.tech.on(A().Events.LEVEL_SWITCHED, ce);
          }

        }

        G(V, "hlsTypeRE", /^application\/(x-mpegURL|vnd\.apple\.mpegURL)$/i), G(V, "hlsExtRE", /\.m3u8/i);
        const Y = {
          canHandleSource(le) {
            return le.skipHlsJs ? "" : V.hlsTypeRE.test(le.type) ? "probably" : V.hlsExtRE.test(le.src) ? "maybe" : "";
          },

          handleSource(le, ee) {
            let oe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return new V(le, ee, oe);
          },

          canPlayType(le) {
            return V.hlsTypeRE.test(le) ? "probably" : "";
          }

        };
        j().getTech("Html5").registerSourceHandler(Y, 0);
        const $ = null,
              q = {
          i8: "0.11.1"
        };
        var Z = K(288);

        function te(le) {
          var ee, oe;

          if ((oe = (ee = le.tech_) == null ? void 0 : ee.sourceHandler_) == null ? void 0 : oe.hls) {
            const ue = le.tech_.sourceHandler_.hls;
            le.mux.addHLSJS({
              hlsjs: ue,
              Hls: A()
            });
          }
        }

        function se(le, ee) {
          var oe, ue, re, ne, ce;

          if ((oe = le == null ? void 0 : le.dataset) == null ? void 0 : oe.setup) {
            let me = le.dataset.setup;
            me = JSON.parse(me), me && ((re = (ue = me == null ? void 0 : me.plugins) == null ? void 0 : ue.mux) == null ? void 0 : re.data) && (me = ge(me), me = JSON.stringify(me), le.dataset.setup = me);
          }

          return ((ce = (ne = ee == null ? void 0 : ee.plugins) == null ? void 0 : ne.mux) == null ? void 0 : ce.data) && (ee = ge(ee)), ee;
        }

        function ge(le) {
          var ee;
          return le.plugins.mux.data.player_software_name = "vjs-mux-kit-" + ((ee = j()) == null ? void 0 : ee.VERSION.split(".")[0]) + (typeof A() == "function" ? "-hlsjs" : "-vhs"), le.plugins.mux.data.player_software_version = q.i8, le;
        }

        function he(le) {
          var ee, oe;
          (oe = (ee = le.tech_) == null ? void 0 : ee.sourceHandler_) == null || oe.hls.on(A().Events.MANIFEST_LOADED, function (ue, re) {
            if (re.subtitles) {
              let ne;

              for (ne = 0; ne < re.subtitles.length; ne++) le.addRemoteTextTrack({
                kind: re.subtitles[ne].type,
                label: re.subtitles[ne].name,
                srclang: re.subtitles[ne].lang,
                default: re.subtitles[ne].default
              }, !1);
            }
          }), le.remoteTextTracks().addEventListener("change", ue => {
            let re = le.remoteTextTracks(),
                ne,
                ce = !1;

            for (ne = 0; ne < re.length; ne++) re[ne].mode === "showing" && (le.tech_.sourceHandler_.hls.subtitleTrack = ne, ce = !0);

            ce !== !0 && (le.tech_.sourceHandler_.hls.subtitleTrack = -1);
          });
        }

        const ye = {},
              pe = {},
              _e = j().registerPlugin || j().plugin,
              be = (le, ee) => {
          le.addClass("vjs-vtt-thumbnails"), le.vttThumbnails = new we(le, ee);
        },
              Le = function (le) {
          this.ready(() => {
            be(this, j().mergeOptions(ye, le));
          });
        };

        class we {
          constructor(ee, oe) {
            return this.player = ee, this.options = oe, this.listenForDurationChange(), this.initializeThumbnails(), this.registeredEvents = {}, this;
          }

          src(ee) {
            this.resetPlugin(), this.options.src = ee, this.initializeThumbnails();
          }

          detach() {
            this.resetPlugin();
          }

          resetPlugin() {
            this.thumbnailHolder && this.thumbnailHolder.parentNode.removeChild(this.thumbnailHolder), this.progressBar && (this.progressBar.removeEventListener("mouseenter", this.registeredEvents.progressBarMouseEnter), this.progressBar.removeEventListener("mouseleave", this.registeredEvents.progressBarMouseLeave), this.progressBar.removeEventListener("mousemove", this.registeredEvents.progressBarMouseMove)), delete this.registeredEvents.progressBarMouseEnter, delete this.registeredEvents.progressBarMouseLeave, delete this.registeredEvents.progressBarMouseMove, delete this.progressBar, delete this.vttData, delete this.thumbnailHolder, delete this.lastStyle;
          }

          listenForDurationChange() {
            this.player.on("durationchange", () => {});
          }

          initializeThumbnails() {
            if (!this.options.src) return;
            const ee = this.getBaseUrl(),
                  oe = this.getFullyQualifiedUrl(this.options.src, ee);
            this.getVttFile(oe).then(ue => {
              this.vttData = this.processVtt(ue), this.setupThumbnailElement();
            });
          }

          getBaseUrl() {
            return [window.location.protocol, "//", window.location.hostname, window.location.port ? ":" + window.location.port : "", window.location.pathname].join("").split(/([^\/]*)$/gi).shift();
          }

          getVttFile(ee) {
            return new Promise((oe, ue) => {
              const re = new XMLHttpRequest();
              re.data = {
                resolve: oe
              }, re.addEventListener("load", this.vttFileLoaded), re.open("GET", ee), re.overrideMimeType("text/plain; charset=utf-8"), re.send();
            });
          }

          vttFileLoaded() {
            this.data.resolve(this.responseText);
          }

          setupThumbnailElement(ee) {
            let oe = null;
            this.options.showTimestamp || (oe = this.player.$(".vjs-mouse-display"));
            const ue = document.createElement("div");
            ue.setAttribute("class", "vjs-vtt-thumbnail-display"), this.progressBar = this.player.$(".vjs-progress-control"), this.progressBar.appendChild(ue), this.thumbnailHolder = ue, oe && !this.options.showTimestamp && oe.classList.add("vjs-hidden"), this.registeredEvents.progressBarMouseEnter = () => this.onBarMouseenter(), this.registeredEvents.progressBarMouseLeave = () => this.onBarMouseleave(), this.progressBar.addEventListener("mouseenter", this.registeredEvents.progressBarMouseEnter), this.progressBar.addEventListener("mouseleave", this.registeredEvents.progressBarMouseLeave);
          }

          onBarMouseenter() {
            this.mouseMoveCallback = ee => {
              this.onBarMousemove(ee);
            }, this.registeredEvents.progressBarMouseMove = this.mouseMoveCallback, this.progressBar.addEventListener("mousemove", this.registeredEvents.progressBarMouseMove), this.showThumbnailHolder();
          }

          onBarMouseleave() {
            this.registeredEvents.progressBarMouseMove && this.progressBar.removeEventListener("mousemove", this.registeredEvents.progressBarMouseMove), this.hideThumbnailHolder();
          }

          getXCoord(ee, oe) {
            const ue = ee.getBoundingClientRect(),
                  re = document.documentElement;
            return oe - (ue.left + (window.pageXOffset || re.scrollLeft || 0));
          }

          onBarMousemove(ee) {
            this.updateThumbnailStyle(j().dom.getPointerPosition(this.progressBar, ee).x, this.progressBar.offsetWidth);
          }

          getStyleForTime(ee) {
            for (let oe = 0; oe < this.vttData.length; ++oe) {
              const ue = this.vttData[oe];

              if (ee >= ue.start && ee < ue.end) {
                if (ue.css.url && !pe[ue.css.url]) {
                  const re = new Image();
                  re.src = ue.css.url, pe[ue.css.url] = re;
                }

                return ue.css;
              }
            }
          }

          showThumbnailHolder() {
            this.thumbnailHolder.style.opacity = "1";
          }

          hideThumbnailHolder() {
            this.thumbnailHolder.style.opacity = "0";
          }

          updateThumbnailStyle(ee, oe) {
            const ue = this.player.duration(),
                  re = ee * ue,
                  ne = this.getStyleForTime(re);
            if (!ne) return this.hideThumbnailHolder();
            const ce = ee * oe,
                  me = parseInt(ne.width, 10),
                  Ae = me >> 1,
                  Ce = oe - (ce + Ae),
                  Ie = ce - Ae;

            if (Ie > 0 && Ce > 0 ? this.thumbnailHolder.style.transform = "translateX(" + (ce - Ae) + "px)" : Ie <= 0 ? this.thumbnailHolder.style.transform = "translateX(" + 0 + "px)" : Ce <= 0 && (this.thumbnailHolder.style.transform = "translateX(" + (oe - me) + "px)"), !(this.lastStyle && this.lastStyle === ne)) {
              this.lastStyle = ne;

              for (const ke in ne) ne.hasOwnProperty(ke) && (this.thumbnailHolder.style[ke] = ne[ke]);
            }
          }

          processVtt(ee) {
            const oe = [];
            return ee.split(/[\r\n][\r\n]/i).forEach(re => {
              if (re.match(/([0-9]{2}:)?([0-9]{2}:)?[0-9]{2}(.[0-9]{3})?( ?--> ?)([0-9]{2}:)?([0-9]{2}:)?[0-9]{2}(.[0-9]{3})?[\r\n]{1}.*/gi)) {
                const ne = re.split(/[\r\n]/i),
                      me = ne[0].split(/ ?--> ?/i),
                      Ae = me[0],
                      Ce = me[1],
                      Ie = ne[1],
                      ke = this.getVttCss(Ie);
                oe.push({
                  start: this.getSecondsFromTimestamp(Ae),
                  end: this.getSecondsFromTimestamp(Ce),
                  css: ke
                });
              }
            }), oe;
          }

          getFullyQualifiedUrl(ee, oe) {
            return ee.indexOf("//") >= 0 ? ee : oe.indexOf("//") === 0 ? [oe.replace(/\/$/gi, ""), this.trim(ee, "/")].join("/") : oe.indexOf("//") > 0 ? [this.trim(oe, "/"), this.trim(ee, "/")].join("/") : ee;
          }

          getPropsFromDef(ee) {
            const oe = ee.split(/#xywh=/i),
                  ue = oe[0],
                  ne = oe[1].match(/[0-9]+/gi);
            return {
              x: ne[0],
              y: ne[1],
              w: ne[2],
              h: ne[3],
              image: ue
            };
          }

          getVttCss(ee) {
            const oe = {};
            let ue;
            if (this.options.src.indexOf("//") >= 0 ? ue = this.options.src.split(/([^\/]*)$/gi).shift() : ue = this.getBaseUrl() + this.options.src.split(/([^\/]*)$/gi).shift(), ee = this.getFullyQualifiedUrl(ee, ue), !ee.match(/#xywh=/i)) return oe.background = 'url("' + ee + '")', oe;
            const re = this.getPropsFromDef(ee);
            return oe.background = 'url("' + re.image + '") no-repeat -' + re.x + "px -" + re.y + "px", oe.width = re.w + "px", oe.height = re.h + "px", oe.url = re.image, oe;
          }

          deconstructTimestamp(ee) {
            const oe = ee.split("."),
                  re = oe[0].split(":");
            return {
              milliseconds: parseInt(oe[1], 10) || 0,
              seconds: parseInt(re.pop(), 10) || 0,
              minutes: parseInt(re.pop(), 10) || 0,
              hours: parseInt(re.pop(), 10) || 0
            };
          }

          getSecondsFromTimestamp(ee) {
            const oe = this.deconstructTimestamp(ee);
            return parseInt(oe.hours * (60 * 60) + oe.minutes * 60 + oe.seconds + oe.milliseconds / 1e3, 10);
          }

          trim(ee, oe) {
            let ue = [" ", "\n", "\r", "	", "\f", "\v", "\xA0", "\u2000", "\u2001", "\u2002", "\u2003", "\u2004", "\u2005", "\u2006", "\u2007", "\u2008", "\u2009", "\u200A", "\u200B", "\u2028", "\u2029", "\u3000"].join(""),
                re = 0,
                ne = 0;

            for (ee += "", oe && (ue = (oe + "").replace(/([[\]().?/*{}+$^:])/g, "$1")), re = ee.length, ne = 0; ne < re; ne++) if (ue.indexOf(ee.charAt(ne)) === -1) {
              ee = ee.substring(ne);
              break;
            }

            for (re = ee.length, ne = re - 1; ne >= 0; ne--) if (ue.indexOf(ee.charAt(ne)) === -1) {
              ee = ee.substring(0, ne + 1);
              break;
            }

            return ue.indexOf(ee.charAt(0)) === -1 ? ee : "";
          }

        }

        _e("vttThumbnails", Le);

        const xe = null;

        function Ne(le) {
          le.timelineHoverPreviews = function (ee) {
            let oe = (ee == null ? void 0 : ee.enabled) || !1,
                ue = (ee == null ? void 0 : ee.src) || null;

            if (!oe && typeof le.vttThumbnails.detach == "function") {
              le.vttThumbnails.detach(), le.options().timelineHoverPreviewsUrl = null;
              return;
            } else if (typeof le.vttThumbnails == "function" && ue !== null) {
              le.vttThumbnails({
                src: ue
              }), le.options().timelineHoverPreviewsUrl = ue;
              return;
            } else if (typeof le.vttThumbnails.src == "function" && ue !== null) {
              le.vttThumbnails.src(ue), le.options().timelineHoverPreviewsUrl = ue;
              return;
            }
          };
        }

        j().hook("beforesetup", function (le, ee) {
          return ee = se(le, ee), ee;
        }), j().hook("setup", function (le) {
          Ne(le), le.options().timelineHoverPreviewsUrl && le.timelineHoverPreviews({
            enabled: !0,
            src: le.options().timelineHoverPreviewsUrl
          });
        }), j().use("video/mux", le => ({
          setSource(_ref, oe) {
            let ee = _ref.src;

            if (le.options().timelineHoverPreviews) {
              let re = "https://image.mux.com/".concat(ee.split("?", 1)[0], "/storyboard.vtt");
              le.timelineHoverPreviews({
                enabled: !0,
                src: re
              });
            }

            oe(null, {
              src: "https://stream.mux.com/".concat(ee),
              type: "application/x-mpegurl"
            }), le.mux && le.mux.addHLSJS && te(le), typeof he != "undefined" && he(le);
          }

        }));
        const Me = j();
      },
      893: () => {}
    },
        $t = {};

    function Qe(ve) {
      var ae = $t[ve];
      if (ae !== void 0) return ae.exports;
      var K = $t[ve] = {
        exports: {}
      };
      return pi[ve].call(K.exports, K, K.exports, Qe), K.exports;
    }

    (() => {
      Qe.n = ve => {
        var ae = ve && ve.__esModule ? () => ve.default : () => ve;
        return Qe.d(ae, {
          a: ae
        }), ae;
      };
    })(), (() => {
      Qe.d = (ve, ae) => {
        for (var K in ae) Qe.o(ae, K) && !Qe.o(ve, K) && Object.defineProperty(ve, K, {
          enumerable: !0,
          get: ae[K]
        });
      };
    })(), (() => {
      Qe.g = function () {
        if (typeof globalThis == "object") return globalThis;

        try {
          return this || new Function("return this")();
        } catch (ve) {
          if (typeof window == "object") return window;
        }
      }();
    })(), (() => {
      Qe.o = (ve, ae) => Object.prototype.hasOwnProperty.call(ve, ae);
    })();
    var kn = Qe(18);
    return kn;
  })();
});